// @ts-nocheck

/* Generated on 2026-09-24T15:17:27.217Z — bundle: rcprofi */

import { Schema } from 'effect';
import { DateSerializableFromString } from '@vs-shop/schemas/datetime/DateSerializableFromString'; // <runtime>
import { DateTimeSerializableFromString } from '@vs-shop/schemas/DateTimeSerializableFromString'; // <runtime>

/* AccountResetPasswordsyliusshopresetpasswordupdatejsonMergePatch */

export const AccountResetPasswordsyliusshopresetpasswordupdatejsonMergePatch =
  Schema.StructWithRest(
    Schema.Struct({
      newPassword: Schema.String.check(
        Schema.isMinLength(4).annotate({ expected: 'a value with a length of at least 4' })
      ).check(
        Schema.isMaxLength(254).annotate({ expected: 'a value with a length of at most 254' })
      ),
      confirmNewPassword: Schema.String.check(
        Schema.isMinLength(4).annotate({ expected: 'a value with a length of at least 4' })
      ).check(
        Schema.isMaxLength(254).annotate({ expected: 'a value with a length of at most 254' })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({ identifier: 'AccountResetPasswordsyliusshopresetpasswordupdatejsonMergePatch' });
export type AccountResetPasswordsyliusshopresetpasswordupdatejsonMergePatch = Schema.Schema.Type<
  typeof AccountResetPasswordsyliusshopresetpasswordupdatejsonMergePatch
>;
export type AccountResetPasswordsyliusshopresetpasswordupdatejsonMergePatchEncoded =
  Schema.Codec.Encoded<typeof AccountResetPasswordsyliusshopresetpasswordupdatejsonMergePatch>;

/* AccountResetPasswordRequestResetPasswordTokensyliusshopresetpasswordcreate */

export const AccountResetPasswordRequestResetPasswordTokensyliusshopresetpasswordcreate =
  Schema.StructWithRest(
    Schema.Struct({
      localeCode: Schema.String,
      email: Schema.String.annotate({ format: 'email' }),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier: 'AccountResetPasswordRequestResetPasswordTokensyliusshopresetpasswordcreate',
  });
export type AccountResetPasswordRequestResetPasswordTokensyliusshopresetpasswordcreate =
  Schema.Schema.Type<
    typeof AccountResetPasswordRequestResetPasswordTokensyliusshopresetpasswordcreate
  >;
export type AccountResetPasswordRequestResetPasswordTokensyliusshopresetpasswordcreateEncoded =
  Schema.Codec.Encoded<
    typeof AccountResetPasswordRequestResetPasswordTokensyliusshopresetpasswordcreate
  >;

/* AccountResetPasswordRequestResetPasswordTokenjsonldsyliusshopresetpasswordcreate */

export const AccountResetPasswordRequestResetPasswordTokenjsonldsyliusshopresetpasswordcreate =
  Schema.StructWithRest(
    Schema.Struct({
      localeCode: Schema.String,
      email: Schema.String.annotate({ format: 'email' }),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier: 'AccountResetPasswordRequestResetPasswordTokenjsonldsyliusshopresetpasswordcreate',
  });
export type AccountResetPasswordRequestResetPasswordTokenjsonldsyliusshopresetpasswordcreate =
  Schema.Schema.Type<
    typeof AccountResetPasswordRequestResetPasswordTokenjsonldsyliusshopresetpasswordcreate
  >;
export type AccountResetPasswordRequestResetPasswordTokenjsonldsyliusshopresetpasswordcreateEncoded =
  Schema.Codec.Encoded<
    typeof AccountResetPasswordRequestResetPasswordTokenjsonldsyliusshopresetpasswordcreate
  >;

/* ShippingDiscountRuleHint */

export const ShippingDiscountRuleHint = Schema.StructWithRest(
  Schema.Struct({
    itemThresholdTotal: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    missingItemTotal: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    percentageDiscountAmount: Schema.Number.check(
      Schema.isFinite().annotate({ expected: 'a finite number' })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingDiscountRuleHint' });
export type ShippingDiscountRuleHint = Schema.Schema.Type<typeof ShippingDiscountRuleHint>;
export type ShippingDiscountRuleHintEncoded = Schema.Codec.Encoded<typeof ShippingDiscountRuleHint>;

/* BankAccountCZ */

export const BankAccountCZ = Schema.StructWithRest(
  Schema.Struct({
    prefix: Schema.Union([Schema.String, Schema.Null]),
    main: Schema.String,
    bankCode: Schema.String,
    prefixFull: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    mainFull: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    accountNumber: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'BankAccountCZ' });
export type BankAccountCZ = Schema.Schema.Type<typeof BankAccountCZ>;
export type BankAccountCZEncoded = Schema.Codec.Encoded<typeof BankAccountCZ>;

/* Iban */

export const Iban = Schema.StructWithRest(
  Schema.Struct({ value: Schema.optionalKey(Schema.String.annotate({ readOnly: true })) }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Iban' });
export type Iban = Schema.Schema.Type<typeof Iban>;
export type IbanEncoded = Schema.Codec.Encoded<typeof Iban>;

/* ShopBillingData */

export const ShopBillingData = Schema.StructWithRest(
  Schema.Struct({
    vatNumber: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    company: Schema.Union([Schema.String, Schema.Null]),
    taxId: Schema.Union([Schema.String, Schema.Null]),
    countryCode: Schema.Union([Schema.String, Schema.Null]),
    street: Schema.Union([Schema.String, Schema.Null]),
    city: Schema.Union([Schema.String, Schema.Null]),
    postcode: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShopBillingData' });
export type ShopBillingData = Schema.Schema.Type<typeof ShopBillingData>;
export type ShopBillingDataEncoded = Schema.Codec.Encoded<typeof ShopBillingData>;

/* CategoryImage */

export const CategoryImage = Schema.StructWithRest(
  Schema.Struct({
    owner: Schema.String.annotate({ format: 'iri-reference' }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.Union([Schema.String, Schema.Null]),
    file: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'binary' }),
    path: Schema.String,
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CategoryImage' });
export type CategoryImage = Schema.Schema.Type<typeof CategoryImage>;
export type CategoryImageEncoded = Schema.Codec.Encoded<typeof CategoryImage>;

/* ProductVideo */

export const ProductVideo = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.String.annotate({ format: 'uuid' }),
    product: Schema.String.annotate({ format: 'iri-reference' }),
    type: Schema.Literal('youtube').annotate({ default: 'youtube' }),
    path: Schema.String.annotate({ default: '' }),
    position: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductVideo' });
export type ProductVideo = Schema.Schema.Type<typeof ProductVideo>;
export type ProductVideoEncoded = Schema.Codec.Encoded<typeof ProductVideo>;

/* BigInteger */

export const BigInteger = Schema.StructWithRest(
  Schema.Struct({
    bitLength: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          "Returns the number of bits in the minimal two's-complement representation of this BigInteger, excluding a sign bit.",
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    lowestSetBit: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns the index of the rightmost (lowest-order) one bit in this BigInteger.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    even: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Returns whether this number is even.',
        readOnly: true,
      })
    ),
    odd: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Returns whether this number is odd.',
        readOnly: true,
      })
    ),
    sign: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    zero: Schema.optionalKey(
      Schema.Boolean.annotate({ description: 'Checks if this number equals zero.', readOnly: true })
    ),
    negative: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Checks if this number is strictly negative.',
        readOnly: true,
      })
    ),
    negativeOrZero: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Checks if this number is negative or zero.',
        readOnly: true,
      })
    ),
    positive: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Checks if this number is strictly positive.',
        readOnly: true,
      })
    ),
    positiveOrZero: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Checks if this number is positive or zero.',
        readOnly: true,
      })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'BigInteger' });
export type BigInteger = Schema.Schema.Type<typeof BigInteger>;
export type BigIntegerEncoded = Schema.Codec.Encoded<typeof BigInteger>;

/* CurrencyType */

export const CurrencyType = Schema.StructWithRest(
  Schema.Struct({ name: Schema.optionalKey(Schema.String.annotate({ readOnly: true })) }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CurrencyType' });
export type CurrencyType = Schema.Schema.Type<typeof CurrencyType>;
export type CurrencyTypeEncoded = Schema.Codec.Encoded<typeof CurrencyType>;

/* Context */

export const Context = Schema.StructWithRest(
  Schema.Struct({
    step: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns the step used by this context.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    fixedScale: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Returns whether this context uses a fixed scale and step.',
        readOnly: true,
      })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Context' });
export type Context = Schema.Schema.Type<typeof Context>;
export type ContextEncoded = Schema.Codec.Encoded<typeof Context>;

/* TimeZoneOffset */

export const TimeZoneOffset = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.String.annotate({
        description: 'The string representation of this time-zone offset.',
        readOnly: true,
      })
    ),
    totalSeconds: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Private constructor. Use a factory method to obtain an instance.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TimeZoneOffset' });
export type TimeZoneOffset = Schema.Schema.Type<typeof TimeZoneOffset>;
export type TimeZoneOffsetEncoded = Schema.Codec.Encoded<typeof TimeZoneOffset>;

/* TimeZone */

export const TimeZone = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.String.annotate({ description: 'Returns the unique time-zone ID.', readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TimeZone' });
export type TimeZone = Schema.Schema.Type<typeof TimeZone>;
export type TimeZoneEncoded = Schema.Codec.Encoded<typeof TimeZone>;

/* Instant */

export const Instant = Schema.StructWithRest(
  Schema.Struct({
    epochSecond: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Private constructor. Use of() to obtain an Instant.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    nano: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Private constructor. Use of() to obtain an Instant.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    future: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Returns whether this instant is in the future, according to the given clock.',
        readOnly: true,
      })
    ),
    past: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Returns whether this instant is in the past, according to the given clock.',
        readOnly: true,
      })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Instant' });
export type Instant = Schema.Schema.Type<typeof Instant>;
export type InstantEncoded = Schema.Codec.Encoded<typeof Instant>;

/* LocalTime */

export const LocalTime = Schema.StructWithRest(
  Schema.Struct({
    hour: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Private constructor. Use of() to obtain an instance.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    minute: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Private constructor. Use of() to obtain an instance.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    second: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Private constructor. Use of() to obtain an instance.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    nano: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Private constructor. Use of() to obtain an instance.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'LocalTime' });
export type LocalTime = Schema.Schema.Type<typeof LocalTime>;
export type LocalTimeEncoded = Schema.Codec.Encoded<typeof LocalTime>;

/* EligiblePromotion */

export const EligiblePromotion = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.annotate({ description: 'The promotion code.' }),
    name: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'The promotion name.',
    }),
    label: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'The promotion label.',
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'EligiblePromotion' });
export type EligiblePromotion = Schema.Schema.Type<typeof EligiblePromotion>;
export type EligiblePromotionEncoded = Schema.Codec.Encoded<typeof EligiblePromotion>;

/* Collection */

export const Collection = Schema.StructWithRest(
  Schema.Struct({
    empty: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Checks whether the collection is empty (contains no elements).',
        readOnly: true,
      })
    ),
    keys: Schema.optionalKey(
      Schema.Union([
        Schema.Array(Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' }))),
        Schema.Array(Schema.String),
      ]).annotate({ description: 'Gets all keys/indices of the collection.', readOnly: true })
    ),
    values: Schema.optionalKey(
      Schema.Array(Schema.Union([Schema.String, Schema.Null])).annotate({
        description: 'Gets all values of the collection.',
        readOnly: true,
      })
    ),
    iterator: Schema.optionalKey(Schema.Json.annotate({ expected: 'JSON value', readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Collection' });
export type Collection = Schema.Schema.Type<typeof Collection>;
export type CollectionEncoded = Schema.Codec.Encoded<typeof Collection>;

/* ProductTranslation */

export const ProductTranslation = Schema.StructWithRest(
  Schema.Struct({
    state: Schema.Literals([
      'draft',
      'needs_link_review',
      'needs_correction',
      'seo_reviewed_ok',
      'reviewed_ok',
      'imported_ok',
      'final_ok',
    ]).annotate({ default: 'needs_correction' }),
    translationOrigins: Schema.Union([Schema.Record(Schema.String, Schema.String), Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'SEO meta title, max 1000 chars',
    }),
    subtitle: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'Product subtitle shown under the name, max 1000 chars',
    }),
    shortDescription: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    name: Schema.String,
    slug: Schema.String,
    description: Schema.Union([Schema.String, Schema.Null]),
    metaKeywords: Schema.Union([Schema.String, Schema.Null]),
    metaDescription: Schema.Union([Schema.String, Schema.Null]),
    locale: Schema.String,
    translatable: Schema.String.annotate({ format: 'iri-reference' }),
    stateValue: Schema.String.annotate({
      description:
        "Get state as string for Symfony Workflow\nThis method is used by the workflow's MethodMarkingStore",
    }),
    columnsForAutomaticTranslation: Schema.optionalKey(
      Schema.Array(Schema.Union([Schema.String, Schema.Null])).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductTranslation' });
export type ProductTranslation = Schema.Schema.Type<typeof ProductTranslation>;
export type ProductTranslationEncoded = Schema.Codec.Encoded<typeof ProductTranslation>;

/* Author */

export const Author = Schema.StructWithRest(
  Schema.Struct({
    favourite: Schema.Boolean.annotate({ default: false }),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
    currentLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    fallbackLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    name: Schema.String,
    image: Schema.Union([Schema.String, Schema.Null]),
    imageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    description: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    translation: Schema.Array(
      Schema.suspend((): Schema.Codec<TranslationInterface> => TranslationInterface)
    ),
    slug: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    metaDescription: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Author' });
export type Author = Schema.Schema.Type<typeof Author>;
export type AuthorEncoded = Schema.Codec.Encoded<typeof Author>;

/* FeedCategory */

export const FeedCategory = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(Schema.String.annotate({ readOnly: true, format: 'uuid' })),
    taxon: Schema.String.annotate({ format: 'iri-reference' }),
    feedCode: Schema.Literals([
      'google_product_category',
      'google_product_type',
      'heureka_category_text',
      'zbozi_category_id',
    ]),
    channel: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'iri-reference' }),
    text: Schema.String,
    textNotNull: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'FeedCategory' });
export type FeedCategory = Schema.Schema.Type<typeof FeedCategory>;
export type FeedCategoryEncoded = Schema.Codec.Encoded<typeof FeedCategory>;

/* TaxonImagejsonldsyliusshoptaxonshowdetail */

export const TaxonImagejsonldsyliusshoptaxonshowdetail = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TaxonImagejsonldsyliusshoptaxonshowdetail' });
export type TaxonImagejsonldsyliusshoptaxonshowdetail = Schema.Schema.Type<
  typeof TaxonImagejsonldsyliusshoptaxonshowdetail
>;
export type TaxonImagejsonldsyliusshoptaxonshowdetailEncoded = Schema.Codec.Encoded<
  typeof TaxonImagejsonldsyliusshoptaxonshowdetail
>;

/* ProductAttributejsonldsyliusshoptaxonshowdetail */

export const ProductAttributejsonldsyliusshoptaxonshowdetail = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    unit: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'Unit of the attribute values (e.g. "mm", "g"), shown next to the value',
    }),
    filterUrlMode: Schema.Literals(['path', 'fragment', 'hide']).annotate({
      description: 'How the attribute filter is represented in the storefront URL',
    }),
    filterState: Schema.Literals(['open', 'close']).annotate({
      description: 'Whether the filter is rendered expanded or collapsed by default',
    }),
    numberOfShow: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({
      description: 'How many filter values are shown before the "show more" expander; null = all',
    }),
    attributeValues: Schema.Array(
      Schema.Union(
        [
          Schema.String,
          Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
          Schema.Boolean,
          Schema.StructWithRest(
            Schema.Struct({
              label: Schema.optionalKey(Schema.String),
              value: Schema.optionalKey(Schema.String),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      )
    ).annotate({
      description:
        'The values this attribute takes here, i.e. the choices its filter should offer. Scalar attributes yield bare values; `select` attributes yield `{label, value}` pairs.',
    }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    type: Schema.String.annotate({ default: 'text' }),
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    name: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAttributejsonldsyliusshoptaxonshowdetail' });
export type ProductAttributejsonldsyliusshoptaxonshowdetail = Schema.Schema.Type<
  typeof ProductAttributejsonldsyliusshoptaxonshowdetail
>;
export type ProductAttributejsonldsyliusshoptaxonshowdetailEncoded = Schema.Codec.Encoded<
  typeof ProductAttributejsonldsyliusshoptaxonshowdetail
>;

/* TaxonImagejsonldsyliusshoptaxonindex */

export const TaxonImagejsonldsyliusshoptaxonindex = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TaxonImagejsonldsyliusshoptaxonindex' });
export type TaxonImagejsonldsyliusshoptaxonindex = Schema.Schema.Type<
  typeof TaxonImagejsonldsyliusshoptaxonindex
>;
export type TaxonImagejsonldsyliusshoptaxonindexEncoded = Schema.Codec.Encoded<
  typeof TaxonImagejsonldsyliusshoptaxonindex
>;

/* Authorjsonldsyliusshoparticleindexfavourite */

export const Authorjsonldsyliusshoparticleindexfavourite = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    name: Schema.String,
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Authorjsonldsyliusshoparticleindexfavourite' });
export type Authorjsonldsyliusshoparticleindexfavourite = Schema.Schema.Type<
  typeof Authorjsonldsyliusshoparticleindexfavourite
>;
export type AuthorjsonldsyliusshoparticleindexfavouriteEncoded = Schema.Codec.Encoded<
  typeof Authorjsonldsyliusshoparticleindexfavourite
>;

/* BrandImagejsonldsyliusshopbrandindex */

export const BrandImagejsonldsyliusshopbrandindex = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'BrandImagejsonldsyliusshopbrandindex' });
export type BrandImagejsonldsyliusshopbrandindex = Schema.Schema.Type<
  typeof BrandImagejsonldsyliusshopbrandindex
>;
export type BrandImagejsonldsyliusshopbrandindexEncoded = Schema.Codec.Encoded<
  typeof BrandImagejsonldsyliusshopbrandindex
>;

/* TaxonImagesyliusshoptaxonshowdetail */

export const TaxonImagesyliusshoptaxonshowdetail = Schema.StructWithRest(
  Schema.Struct({
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TaxonImagesyliusshoptaxonshowdetail' });
export type TaxonImagesyliusshoptaxonshowdetail = Schema.Schema.Type<
  typeof TaxonImagesyliusshoptaxonshowdetail
>;
export type TaxonImagesyliusshoptaxonshowdetailEncoded = Schema.Codec.Encoded<
  typeof TaxonImagesyliusshoptaxonshowdetail
>;

/* ProductAttributesyliusshoptaxonshowdetail */

export const ProductAttributesyliusshoptaxonshowdetail = Schema.StructWithRest(
  Schema.Struct({
    unit: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'Unit of the attribute values (e.g. "mm", "g"), shown next to the value',
    }),
    filterUrlMode: Schema.Literals(['path', 'fragment', 'hide']).annotate({
      description: 'How the attribute filter is represented in the storefront URL',
    }),
    filterState: Schema.Literals(['open', 'close']).annotate({
      description: 'Whether the filter is rendered expanded or collapsed by default',
    }),
    numberOfShow: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({
      description: 'How many filter values are shown before the "show more" expander; null = all',
    }),
    attributeValues: Schema.Array(
      Schema.Union(
        [
          Schema.String,
          Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
          Schema.Boolean,
          Schema.StructWithRest(
            Schema.Struct({
              label: Schema.optionalKey(Schema.String),
              value: Schema.optionalKey(Schema.String),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      )
    ).annotate({
      description:
        'The values this attribute takes here, i.e. the choices its filter should offer. Scalar attributes yield bare values; `select` attributes yield `{label, value}` pairs.',
    }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    type: Schema.String.annotate({ default: 'text' }),
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    name: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAttributesyliusshoptaxonshowdetail' });
export type ProductAttributesyliusshoptaxonshowdetail = Schema.Schema.Type<
  typeof ProductAttributesyliusshoptaxonshowdetail
>;
export type ProductAttributesyliusshoptaxonshowdetailEncoded = Schema.Codec.Encoded<
  typeof ProductAttributesyliusshoptaxonshowdetail
>;

/* TaxonImagesyliusshoptaxonindex */

export const TaxonImagesyliusshoptaxonindex = Schema.StructWithRest(
  Schema.Struct({
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TaxonImagesyliusshoptaxonindex' });
export type TaxonImagesyliusshoptaxonindex = Schema.Schema.Type<
  typeof TaxonImagesyliusshoptaxonindex
>;
export type TaxonImagesyliusshoptaxonindexEncoded = Schema.Codec.Encoded<
  typeof TaxonImagesyliusshoptaxonindex
>;

/* Authorsyliusshoparticleindexfavourite */

export const Authorsyliusshoparticleindexfavourite = Schema.StructWithRest(
  Schema.Struct({
    name: Schema.String,
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Authorsyliusshoparticleindexfavourite' });
export type Authorsyliusshoparticleindexfavourite = Schema.Schema.Type<
  typeof Authorsyliusshoparticleindexfavourite
>;
export type AuthorsyliusshoparticleindexfavouriteEncoded = Schema.Codec.Encoded<
  typeof Authorsyliusshoparticleindexfavourite
>;

/* BrandImagesyliusshopbrandindex */

export const BrandImagesyliusshopbrandindex = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'BrandImagesyliusshopbrandindex' });
export type BrandImagesyliusshopbrandindex = Schema.Schema.Type<
  typeof BrandImagesyliusshopbrandindex
>;
export type BrandImagesyliusshopbrandindexEncoded = Schema.Codec.Encoded<
  typeof BrandImagesyliusshopbrandindex
>;

/* TaxonImage */

export const TaxonImage = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.Union([Schema.String, Schema.Null]),
    file: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'binary' }),
    path: Schema.String,
    owner: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TaxonImage' });
export type TaxonImage = Schema.Schema.Type<typeof TaxonImage>;
export type TaxonImageEncoded = Schema.Codec.Encoded<typeof TaxonImage>;

/* TaxonTranslation */

export const TaxonTranslation = Schema.StructWithRest(
  Schema.Struct({
    translationOrigins: Schema.Union([Schema.Record(Schema.String, Schema.String), Schema.Null]),
    metaDescription: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    nameInTaxonList: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    name: Schema.String,
    slug: Schema.String,
    description: Schema.Union([Schema.String, Schema.Null]),
    locale: Schema.String,
    translatable: Schema.String.annotate({ format: 'iri-reference' }),
    columnsForAutomaticTranslation: Schema.optionalKey(
      Schema.Array(Schema.Union([Schema.String, Schema.Null])).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TaxonTranslation' });
export type TaxonTranslation = Schema.Schema.Type<typeof TaxonTranslation>;
export type TaxonTranslationEncoded = Schema.Codec.Encoded<typeof TaxonTranslation>;

/* PaymentMethodImage */

export const PaymentMethodImage = Schema.StructWithRest(
  Schema.Struct({
    owner: Schema.String.annotate({ format: 'iri-reference' }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.Union([Schema.String, Schema.Null]),
    file: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'binary' }),
    path: Schema.String,
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PaymentMethodImage' });
export type PaymentMethodImage = Schema.Schema.Type<typeof PaymentMethodImage>;
export type PaymentMethodImageEncoded = Schema.Codec.Encoded<typeof PaymentMethodImage>;

/* ShippingPricing */

export const ShippingPricing = Schema.StructWithRest(
  Schema.Struct({
    pohodaSyncId: Schema.String.annotate({ default: '' }),
    id: Schema.optionalKey(
      Schema.Union([Schema.String.annotate({ format: 'uuid' }), Schema.String]).annotate({
        readOnly: true,
      })
    ),
    channel: Schema.String.annotate({ format: 'iri-reference' }),
    shippingMethod: Schema.String.annotate({ format: 'iri-reference' }),
    paymentMethod: Schema.String.annotate({ format: 'iri-reference' }),
    price: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    taxCategory: Schema.optionalKey(
      Schema.Union([
        Schema.suspend((): Schema.Codec<TaxCategory> => TaxCategory),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingPricing' });
export type ShippingPricing = Schema.Schema.Type<typeof ShippingPricing>;
export type ShippingPricingEncoded = Schema.Codec.Encoded<typeof ShippingPricing>;

/* OriginalPricing */

export const OriginalPricing = Schema.StructWithRest(
  Schema.Struct({
    taxRate: Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
    quantity: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    unitPriceWithTaxBeforeDiscount: Schema.Number.check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    unitPriceWithoutTaxBeforeDiscount: Schema.Number.check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    unitTaxBeforeDiscount: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    source: Schema.String,
    sourceId: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    schemaVersion: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'OriginalPricing' });
export type OriginalPricing = Schema.Schema.Type<typeof OriginalPricing>;
export type OriginalPricingEncoded = Schema.Codec.Encoded<typeof OriginalPricing>;

/* FeedShippingMethod */

export const FeedShippingMethod = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Union([Schema.String.annotate({ format: 'uuid' }), Schema.String]).annotate({
        readOnly: true,
      })
    ),
    shippingMethod: Schema.String.annotate({ format: 'iri-reference' }),
    feedType: Schema.Literals([
      'analytical_report',
      'baselinker',
      'emag',
      'facebook',
      'google_merchants',
      'heureka_availability',
      'heureka',
      'luigis_box_articles',
      'luigis_box_brands',
      'luigis_box_categories',
      'luigis_box',
      'zbozi',
      'sitemaps_glossary_terms',
      'sitemaps_faq_questions',
      'sitemaps_faq_topics',
      'sitemaps_brands',
      'sitemaps_articles_author',
      'sitemaps_articles_category',
      'sitemaps_articles',
      'sitemaps_pages',
      'sitemaps_categories',
      'sitemaps_products_available',
      'sitemaps_products_unavailable',
    ]).annotate({ default: '' }),
    shippingId: Schema.String.annotate({ default: '' }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'FeedShippingMethod' });
export type FeedShippingMethod = Schema.Schema.Type<typeof FeedShippingMethod>;
export type FeedShippingMethodEncoded = Schema.Codec.Encoded<typeof FeedShippingMethod>;

/* ShippingMethodImage */

export const ShippingMethodImage = Schema.StructWithRest(
  Schema.Struct({
    owner: Schema.String.annotate({ format: 'iri-reference' }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.Union([Schema.String, Schema.Null]),
    file: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'binary' }),
    path: Schema.String,
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingMethodImage' });
export type ShippingMethodImage = Schema.Schema.Type<typeof ShippingMethodImage>;
export type ShippingMethodImageEncoded = Schema.Codec.Encoded<typeof ShippingMethodImage>;

/* FavouriteListProductVariant */

export const FavouriteListProductVariant = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(Schema.String.annotate({ readOnly: true, format: 'uuid' })),
    favouriteList: Schema.String.annotate({ format: 'iri-reference' }),
    productVariant: Schema.String.annotate({ format: 'iri-reference' }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'FavouriteListProductVariant' });
export type FavouriteListProductVariant = Schema.Schema.Type<typeof FavouriteListProductVariant>;
export type FavouriteListProductVariantEncoded = Schema.Codec.Encoded<
  typeof FavouriteListProductVariant
>;

/* CustomerGroup */

export const CustomerGroup = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.String,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CustomerGroup' });
export type CustomerGroup = Schema.Schema.Type<typeof CustomerGroup>;
export type CustomerGroupEncoded = Schema.Codec.Encoded<typeof CustomerGroup>;

/* Addresssyliusadminaddressshow */

export const Addresssyliusadminaddressshow = Schema.StructWithRest(
  Schema.Struct({
    vatNumber: Schema.Union([Schema.String, Schema.Null]),
    businessId: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'IČO or similar ID for other countries',
    }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    firstName: Schema.String,
    lastName: Schema.String,
    phoneNumber: Schema.Union([Schema.String, Schema.Null]),
    company: Schema.Union([Schema.String, Schema.Null]),
    countryCode: Schema.String,
    provinceCode: Schema.Union([Schema.String, Schema.Null]),
    provinceName: Schema.Union([Schema.String, Schema.Null]),
    street: Schema.String,
    city: Schema.String,
    postcode: Schema.String,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Addresssyliusadminaddressshow' });
export type Addresssyliusadminaddressshow = Schema.Schema.Type<
  typeof Addresssyliusadminaddressshow
>;
export type AddresssyliusadminaddressshowEncoded = Schema.Codec.Encoded<
  typeof Addresssyliusadminaddressshow
>;

/* Addresssyliusadminaddressupdate */

export const Addresssyliusadminaddressupdate = Schema.StructWithRest(
  Schema.Struct({
    vatNumber: Schema.Union([Schema.String, Schema.Null]),
    businessId: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'IČO or similar ID for other countries',
    }),
    firstName: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    lastName: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    phoneNumber: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    company: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    countryCode: Schema.String,
    provinceCode: Schema.Union([Schema.String, Schema.Null]),
    provinceName: Schema.Union([Schema.String, Schema.Null]),
    street: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    city: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    postcode: Schema.String.check(
      Schema.isMinLength(1).annotate({ expected: 'a value with a length of at least 1' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Addresssyliusadminaddressupdate' });
export type Addresssyliusadminaddressupdate = Schema.Schema.Type<
  typeof Addresssyliusadminaddressupdate
>;
export type AddresssyliusadminaddressupdateEncoded = Schema.Codec.Encoded<
  typeof Addresssyliusadminaddressupdate
>;

/* Addresssyliusadminorderindex */

export const Addresssyliusadminorderindex = Schema.StructWithRest(
  Schema.Struct({
    vatNumber: Schema.Union([Schema.String, Schema.Null]),
    businessId: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'IČO or similar ID for other countries',
    }),
    firstName: Schema.String,
    lastName: Schema.String,
    phoneNumber: Schema.Union([Schema.String, Schema.Null]),
    company: Schema.Union([Schema.String, Schema.Null]),
    countryCode: Schema.String,
    provinceName: Schema.Union([Schema.String, Schema.Null]),
    street: Schema.String,
    city: Schema.String,
    postcode: Schema.String,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Addresssyliusadminorderindex' });
export type Addresssyliusadminorderindex = Schema.Schema.Type<typeof Addresssyliusadminorderindex>;
export type AddresssyliusadminorderindexEncoded = Schema.Codec.Encoded<
  typeof Addresssyliusadminorderindex
>;

/* Addresssyliusadminordershow */

export const Addresssyliusadminordershow = Schema.StructWithRest(
  Schema.Struct({
    vatNumber: Schema.Union([Schema.String, Schema.Null]),
    businessId: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'IČO or similar ID for other countries',
    }),
    firstName: Schema.String,
    lastName: Schema.String,
    phoneNumber: Schema.Union([Schema.String, Schema.Null]),
    company: Schema.Union([Schema.String, Schema.Null]),
    countryCode: Schema.String,
    provinceName: Schema.Union([Schema.String, Schema.Null]),
    street: Schema.String,
    city: Schema.String,
    postcode: Schema.String,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Addresssyliusadminordershow' });
export type Addresssyliusadminordershow = Schema.Schema.Type<typeof Addresssyliusadminordershow>;
export type AddresssyliusadminordershowEncoded = Schema.Codec.Encoded<
  typeof Addresssyliusadminordershow
>;

/* Addresssyliusshopaddresscreate */

export const Addresssyliusshopaddresscreate = Schema.StructWithRest(
  Schema.Struct({
    vatNumber: Schema.Union([Schema.String, Schema.Null]),
    businessId: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'IČO or similar ID for other countries',
    }),
    firstName: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    lastName: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    phoneNumber: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    company: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    countryCode: Schema.String,
    provinceCode: Schema.Union([Schema.String, Schema.Null]),
    provinceName: Schema.Union([Schema.String, Schema.Null]),
    street: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    city: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    postcode: Schema.String.check(
      Schema.isMinLength(1).annotate({ expected: 'a value with a length of at least 1' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Addresssyliusshopaddresscreate' });
export type Addresssyliusshopaddresscreate = Schema.Schema.Type<
  typeof Addresssyliusshopaddresscreate
>;
export type AddresssyliusshopaddresscreateEncoded = Schema.Codec.Encoded<
  typeof Addresssyliusshopaddresscreate
>;

/* Addresssyliusshopaddressindex */

export const Addresssyliusshopaddressindex = Schema.StructWithRest(
  Schema.Struct({
    vatNumber: Schema.Union([Schema.String, Schema.Null]),
    businessId: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'IČO or similar ID for other countries',
    }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    firstName: Schema.String,
    lastName: Schema.String,
    phoneNumber: Schema.Union([Schema.String, Schema.Null]),
    company: Schema.Union([Schema.String, Schema.Null]),
    countryCode: Schema.String,
    provinceCode: Schema.Union([Schema.String, Schema.Null]),
    provinceName: Schema.Union([Schema.String, Schema.Null]),
    street: Schema.String,
    city: Schema.String,
    postcode: Schema.String,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Addresssyliusshopaddressindex' });
export type Addresssyliusshopaddressindex = Schema.Schema.Type<
  typeof Addresssyliusshopaddressindex
>;
export type AddresssyliusshopaddressindexEncoded = Schema.Codec.Encoded<
  typeof Addresssyliusshopaddressindex
>;

/* Addresssyliusshopaddressshow */

export const Addresssyliusshopaddressshow = Schema.StructWithRest(
  Schema.Struct({
    vatNumber: Schema.Union([Schema.String, Schema.Null]),
    businessId: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'IČO or similar ID for other countries',
    }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    firstName: Schema.String,
    lastName: Schema.String,
    phoneNumber: Schema.Union([Schema.String, Schema.Null]),
    company: Schema.Union([Schema.String, Schema.Null]),
    countryCode: Schema.String,
    provinceCode: Schema.Union([Schema.String, Schema.Null]),
    provinceName: Schema.Union([Schema.String, Schema.Null]),
    street: Schema.String,
    city: Schema.String,
    postcode: Schema.String,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Addresssyliusshopaddressshow' });
export type Addresssyliusshopaddressshow = Schema.Schema.Type<typeof Addresssyliusshopaddressshow>;
export type AddresssyliusshopaddressshowEncoded = Schema.Codec.Encoded<
  typeof Addresssyliusshopaddressshow
>;

/* Addresssyliusshopaddressupdate */

export const Addresssyliusshopaddressupdate = Schema.StructWithRest(
  Schema.Struct({
    vatNumber: Schema.Union([Schema.String, Schema.Null]),
    businessId: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'IČO or similar ID for other countries',
    }),
    firstName: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    lastName: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    phoneNumber: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    company: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    countryCode: Schema.String,
    provinceCode: Schema.Union([Schema.String, Schema.Null]),
    provinceName: Schema.Union([Schema.String, Schema.Null]),
    street: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    city: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    postcode: Schema.String.check(
      Schema.isMinLength(1).annotate({ expected: 'a value with a length of at least 1' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Addresssyliusshopaddressupdate' });
export type Addresssyliusshopaddressupdate = Schema.Schema.Type<
  typeof Addresssyliusshopaddressupdate
>;
export type AddresssyliusshopaddressupdateEncoded = Schema.Codec.Encoded<
  typeof Addresssyliusshopaddressupdate
>;

/* Addresssyliusshopcartupdate */

export const Addresssyliusshopcartupdate = Schema.StructWithRest(
  Schema.Struct({
    vatNumber: Schema.Union([Schema.String, Schema.Null]),
    businessId: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'IČO or similar ID for other countries',
    }),
    firstName: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    lastName: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    phoneNumber: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    company: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    countryCode: Schema.String,
    provinceCode: Schema.Union([Schema.String, Schema.Null]),
    provinceName: Schema.Union([Schema.String, Schema.Null]),
    street: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    city: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    postcode: Schema.String.check(
      Schema.isMinLength(1).annotate({ expected: 'a value with a length of at least 1' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Addresssyliusshopcartupdate' });
export type Addresssyliusshopcartupdate = Schema.Schema.Type<typeof Addresssyliusshopcartupdate>;
export type AddresssyliusshopcartupdateEncoded = Schema.Codec.Encoded<
  typeof Addresssyliusshopcartupdate
>;

/* Addresssyliusshopcustomerme */

export const Addresssyliusshopcustomerme = Schema.StructWithRest(
  Schema.Struct({
    vatNumber: Schema.Union([Schema.String, Schema.Null]),
    businessId: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'IČO or similar ID for other countries',
    }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    firstName: Schema.String,
    lastName: Schema.String,
    phoneNumber: Schema.Union([Schema.String, Schema.Null]),
    company: Schema.Union([Schema.String, Schema.Null]),
    countryCode: Schema.String,
    provinceCode: Schema.Union([Schema.String, Schema.Null]),
    provinceName: Schema.Union([Schema.String, Schema.Null]),
    street: Schema.String,
    city: Schema.String,
    postcode: Schema.String,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Addresssyliusshopcustomerme' });
export type Addresssyliusshopcustomerme = Schema.Schema.Type<typeof Addresssyliusshopcustomerme>;
export type AddresssyliusshopcustomermeEncoded = Schema.Codec.Encoded<
  typeof Addresssyliusshopcustomerme
>;

/* Addresssyliusshoporderaccountshow */

export const Addresssyliusshoporderaccountshow = Schema.StructWithRest(
  Schema.Struct({
    vatNumber: Schema.Union([Schema.String, Schema.Null]),
    businessId: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'IČO or similar ID for other countries',
    }),
    firstName: Schema.String,
    lastName: Schema.String,
    phoneNumber: Schema.Union([Schema.String, Schema.Null]),
    company: Schema.Union([Schema.String, Schema.Null]),
    countryCode: Schema.String,
    provinceCode: Schema.Union([Schema.String, Schema.Null]),
    provinceName: Schema.Union([Schema.String, Schema.Null]),
    street: Schema.String,
    city: Schema.String,
    postcode: Schema.String,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Addresssyliusshoporderaccountshow' });
export type Addresssyliusshoporderaccountshow = Schema.Schema.Type<
  typeof Addresssyliusshoporderaccountshow
>;
export type AddresssyliusshoporderaccountshowEncoded = Schema.Codec.Encoded<
  typeof Addresssyliusshoporderaccountshow
>;

/* Addresssyliusshopstoreindex */

export const Addresssyliusshopstoreindex = Schema.StructWithRest(
  Schema.Struct({
    countryCode: Schema.String,
    street: Schema.String,
    city: Schema.String,
    postcode: Schema.String,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Addresssyliusshopstoreindex' });
export type Addresssyliusshopstoreindex = Schema.Schema.Type<typeof Addresssyliusshopstoreindex>;
export type AddresssyliusshopstoreindexEncoded = Schema.Codec.Encoded<
  typeof Addresssyliusshopstoreindex
>;

/* ShippingDiscountRuleHintjsonld */

export const ShippingDiscountRuleHintjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    itemThresholdTotal: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    missingItemTotal: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    percentageDiscountAmount: Schema.Number.check(
      Schema.isFinite().annotate({ expected: 'a finite number' })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingDiscountRuleHintjsonld' });
export type ShippingDiscountRuleHintjsonld = Schema.Schema.Type<
  typeof ShippingDiscountRuleHintjsonld
>;
export type ShippingDiscountRuleHintjsonldEncoded = Schema.Codec.Encoded<
  typeof ShippingDiscountRuleHintjsonld
>;

/* BankAccountCZjsonld */

export const BankAccountCZjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    prefix: Schema.Union([Schema.String, Schema.Null]),
    main: Schema.String,
    bankCode: Schema.String,
    prefixFull: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    mainFull: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    accountNumber: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'BankAccountCZjsonld' });
export type BankAccountCZjsonld = Schema.Schema.Type<typeof BankAccountCZjsonld>;
export type BankAccountCZjsonldEncoded = Schema.Codec.Encoded<typeof BankAccountCZjsonld>;

/* Ibanjsonld */

export const Ibanjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    value: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Ibanjsonld' });
export type Ibanjsonld = Schema.Schema.Type<typeof Ibanjsonld>;
export type IbanjsonldEncoded = Schema.Codec.Encoded<typeof Ibanjsonld>;

/* ShopBillingDatajsonld */

export const ShopBillingDatajsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    vatNumber: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    company: Schema.Union([Schema.String, Schema.Null]),
    taxId: Schema.Union([Schema.String, Schema.Null]),
    countryCode: Schema.Union([Schema.String, Schema.Null]),
    street: Schema.Union([Schema.String, Schema.Null]),
    city: Schema.Union([Schema.String, Schema.Null]),
    postcode: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShopBillingDatajsonld' });
export type ShopBillingDatajsonld = Schema.Schema.Type<typeof ShopBillingDatajsonld>;
export type ShopBillingDatajsonldEncoded = Schema.Codec.Encoded<typeof ShopBillingDatajsonld>;

/* CategoryImagejsonld */

export const CategoryImagejsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    owner: Schema.String.annotate({ format: 'iri-reference' }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.Union([Schema.String, Schema.Null]),
    file: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'binary' }),
    path: Schema.String,
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CategoryImagejsonld' });
export type CategoryImagejsonld = Schema.Schema.Type<typeof CategoryImagejsonld>;
export type CategoryImagejsonldEncoded = Schema.Codec.Encoded<typeof CategoryImagejsonld>;

/* ProductVideojsonld */

export const ProductVideojsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.String.annotate({ format: 'uuid' }),
    product: Schema.String.annotate({ format: 'iri-reference' }),
    type: Schema.Literal('youtube').annotate({ default: 'youtube' }),
    path: Schema.String.annotate({ default: '' }),
    position: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductVideojsonld' });
export type ProductVideojsonld = Schema.Schema.Type<typeof ProductVideojsonld>;
export type ProductVideojsonldEncoded = Schema.Codec.Encoded<typeof ProductVideojsonld>;

/* BigIntegerjsonld */

export const BigIntegerjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    bitLength: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          "Returns the number of bits in the minimal two's-complement representation of this BigInteger, excluding a sign bit.",
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    lowestSetBit: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns the index of the rightmost (lowest-order) one bit in this BigInteger.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    even: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Returns whether this number is even.',
        readOnly: true,
      })
    ),
    odd: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Returns whether this number is odd.',
        readOnly: true,
      })
    ),
    sign: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    zero: Schema.optionalKey(
      Schema.Boolean.annotate({ description: 'Checks if this number equals zero.', readOnly: true })
    ),
    negative: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Checks if this number is strictly negative.',
        readOnly: true,
      })
    ),
    negativeOrZero: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Checks if this number is negative or zero.',
        readOnly: true,
      })
    ),
    positive: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Checks if this number is strictly positive.',
        readOnly: true,
      })
    ),
    positiveOrZero: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Checks if this number is positive or zero.',
        readOnly: true,
      })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'BigIntegerjsonld' });
export type BigIntegerjsonld = Schema.Schema.Type<typeof BigIntegerjsonld>;
export type BigIntegerjsonldEncoded = Schema.Codec.Encoded<typeof BigIntegerjsonld>;

/* CurrencyTypejsonld */

export const CurrencyTypejsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    name: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CurrencyTypejsonld' });
export type CurrencyTypejsonld = Schema.Schema.Type<typeof CurrencyTypejsonld>;
export type CurrencyTypejsonldEncoded = Schema.Codec.Encoded<typeof CurrencyTypejsonld>;

/* Contextjsonld */

export const Contextjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    step: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns the step used by this context.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    fixedScale: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Returns whether this context uses a fixed scale and step.',
        readOnly: true,
      })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Contextjsonld' });
export type Contextjsonld = Schema.Schema.Type<typeof Contextjsonld>;
export type ContextjsonldEncoded = Schema.Codec.Encoded<typeof Contextjsonld>;

/* TimeZoneOffsetjsonld */

export const TimeZoneOffsetjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.String.annotate({
        description: 'The string representation of this time-zone offset.',
        readOnly: true,
      })
    ),
    totalSeconds: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Private constructor. Use a factory method to obtain an instance.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TimeZoneOffsetjsonld' });
export type TimeZoneOffsetjsonld = Schema.Schema.Type<typeof TimeZoneOffsetjsonld>;
export type TimeZoneOffsetjsonldEncoded = Schema.Codec.Encoded<typeof TimeZoneOffsetjsonld>;

/* TimeZonejsonld */

export const TimeZonejsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.String.annotate({ description: 'Returns the unique time-zone ID.', readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TimeZonejsonld' });
export type TimeZonejsonld = Schema.Schema.Type<typeof TimeZonejsonld>;
export type TimeZonejsonldEncoded = Schema.Codec.Encoded<typeof TimeZonejsonld>;

/* Instantjsonld */

export const Instantjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    epochSecond: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Private constructor. Use of() to obtain an Instant.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    nano: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Private constructor. Use of() to obtain an Instant.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    future: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Returns whether this instant is in the future, according to the given clock.',
        readOnly: true,
      })
    ),
    past: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Returns whether this instant is in the past, according to the given clock.',
        readOnly: true,
      })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Instantjsonld' });
export type Instantjsonld = Schema.Schema.Type<typeof Instantjsonld>;
export type InstantjsonldEncoded = Schema.Codec.Encoded<typeof Instantjsonld>;

/* LocalTimejsonld */

export const LocalTimejsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    hour: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Private constructor. Use of() to obtain an instance.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    minute: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Private constructor. Use of() to obtain an instance.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    second: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Private constructor. Use of() to obtain an instance.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    nano: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Private constructor. Use of() to obtain an instance.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'LocalTimejsonld' });
export type LocalTimejsonld = Schema.Schema.Type<typeof LocalTimejsonld>;
export type LocalTimejsonldEncoded = Schema.Codec.Encoded<typeof LocalTimejsonld>;

/* EligiblePromotionjsonld */

export const EligiblePromotionjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String.annotate({ description: 'The promotion code.' }),
    name: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'The promotion name.',
    }),
    label: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'The promotion label.',
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'EligiblePromotionjsonld' });
export type EligiblePromotionjsonld = Schema.Schema.Type<typeof EligiblePromotionjsonld>;
export type EligiblePromotionjsonldEncoded = Schema.Codec.Encoded<typeof EligiblePromotionjsonld>;

/* Collectionjsonld */

export const Collectionjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    empty: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Checks whether the collection is empty (contains no elements).',
        readOnly: true,
      })
    ),
    keys: Schema.optionalKey(
      Schema.Union([
        Schema.Array(Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' }))),
        Schema.Array(Schema.String),
      ]).annotate({ description: 'Gets all keys/indices of the collection.', readOnly: true })
    ),
    values: Schema.optionalKey(
      Schema.Array(Schema.Union([Schema.String, Schema.Null])).annotate({
        description: 'Gets all values of the collection.',
        readOnly: true,
      })
    ),
    iterator: Schema.optionalKey(Schema.Json.annotate({ expected: 'JSON value', readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Collectionjsonld' });
export type Collectionjsonld = Schema.Schema.Type<typeof Collectionjsonld>;
export type CollectionjsonldEncoded = Schema.Codec.Encoded<typeof Collectionjsonld>;

/* ProductTranslationjsonld */

export const ProductTranslationjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    state: Schema.Literals([
      'draft',
      'needs_link_review',
      'needs_correction',
      'seo_reviewed_ok',
      'reviewed_ok',
      'imported_ok',
      'final_ok',
    ]).annotate({ default: 'needs_correction' }),
    translationOrigins: Schema.Union([Schema.Record(Schema.String, Schema.String), Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'SEO meta title, max 1000 chars',
    }),
    subtitle: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'Product subtitle shown under the name, max 1000 chars',
    }),
    shortDescription: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    name: Schema.String,
    slug: Schema.String,
    description: Schema.Union([Schema.String, Schema.Null]),
    metaKeywords: Schema.Union([Schema.String, Schema.Null]),
    metaDescription: Schema.Union([Schema.String, Schema.Null]),
    locale: Schema.String,
    translatable: Schema.String.annotate({ format: 'iri-reference' }),
    stateValue: Schema.String.annotate({
      description:
        "Get state as string for Symfony Workflow\nThis method is used by the workflow's MethodMarkingStore",
    }),
    columnsForAutomaticTranslation: Schema.optionalKey(
      Schema.Array(Schema.Union([Schema.String, Schema.Null])).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductTranslationjsonld' });
export type ProductTranslationjsonld = Schema.Schema.Type<typeof ProductTranslationjsonld>;
export type ProductTranslationjsonldEncoded = Schema.Codec.Encoded<typeof ProductTranslationjsonld>;

/* Authorjsonld */

export const Authorjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    favourite: Schema.Boolean.annotate({ default: false }),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
    currentLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    fallbackLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    name: Schema.String,
    image: Schema.Union([Schema.String, Schema.Null]),
    imageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    description: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    translation: Schema.Array(
      Schema.suspend((): Schema.Codec<TranslationInterfacejsonld> => TranslationInterfacejsonld)
    ),
    slug: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    metaDescription: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Authorjsonld' });
export type Authorjsonld = Schema.Schema.Type<typeof Authorjsonld>;
export type AuthorjsonldEncoded = Schema.Codec.Encoded<typeof Authorjsonld>;

/* FeedCategoryjsonld */

export const FeedCategoryjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(Schema.String.annotate({ readOnly: true, format: 'uuid' })),
    taxon: Schema.String.annotate({ format: 'iri-reference' }),
    feedCode: Schema.Literals([
      'google_product_category',
      'google_product_type',
      'heureka_category_text',
      'zbozi_category_id',
    ]),
    channel: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'iri-reference' }),
    text: Schema.String,
    textNotNull: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'FeedCategoryjsonld' });
export type FeedCategoryjsonld = Schema.Schema.Type<typeof FeedCategoryjsonld>;
export type FeedCategoryjsonldEncoded = Schema.Codec.Encoded<typeof FeedCategoryjsonld>;

/* TaxonImagejsonld */

export const TaxonImagejsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.Union([Schema.String, Schema.Null]),
    file: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'binary' }),
    path: Schema.String,
    owner: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TaxonImagejsonld' });
export type TaxonImagejsonld = Schema.Schema.Type<typeof TaxonImagejsonld>;
export type TaxonImagejsonldEncoded = Schema.Codec.Encoded<typeof TaxonImagejsonld>;

/* TaxonTranslationjsonld */

export const TaxonTranslationjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    translationOrigins: Schema.Union([Schema.Record(Schema.String, Schema.String), Schema.Null]),
    metaDescription: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    nameInTaxonList: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    name: Schema.String,
    slug: Schema.String,
    description: Schema.Union([Schema.String, Schema.Null]),
    locale: Schema.String,
    translatable: Schema.String.annotate({ format: 'iri-reference' }),
    columnsForAutomaticTranslation: Schema.optionalKey(
      Schema.Array(Schema.Union([Schema.String, Schema.Null])).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TaxonTranslationjsonld' });
export type TaxonTranslationjsonld = Schema.Schema.Type<typeof TaxonTranslationjsonld>;
export type TaxonTranslationjsonldEncoded = Schema.Codec.Encoded<typeof TaxonTranslationjsonld>;

/* PaymentMethodImagejsonld */

export const PaymentMethodImagejsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    owner: Schema.String.annotate({ format: 'iri-reference' }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.Union([Schema.String, Schema.Null]),
    file: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'binary' }),
    path: Schema.String,
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PaymentMethodImagejsonld' });
export type PaymentMethodImagejsonld = Schema.Schema.Type<typeof PaymentMethodImagejsonld>;
export type PaymentMethodImagejsonldEncoded = Schema.Codec.Encoded<typeof PaymentMethodImagejsonld>;

/* ShippingPricingjsonld */

export const ShippingPricingjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    pohodaSyncId: Schema.String.annotate({ default: '' }),
    id: Schema.optionalKey(
      Schema.Union([Schema.String.annotate({ format: 'uuid' }), Schema.String]).annotate({
        readOnly: true,
      })
    ),
    channel: Schema.String.annotate({ format: 'iri-reference' }),
    shippingMethod: Schema.String.annotate({ format: 'iri-reference' }),
    paymentMethod: Schema.String.annotate({ format: 'iri-reference' }),
    price: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    taxCategory: Schema.optionalKey(
      Schema.Union([
        Schema.suspend((): Schema.Codec<TaxCategoryjsonld> => TaxCategoryjsonld),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingPricingjsonld' });
export type ShippingPricingjsonld = Schema.Schema.Type<typeof ShippingPricingjsonld>;
export type ShippingPricingjsonldEncoded = Schema.Codec.Encoded<typeof ShippingPricingjsonld>;

/* OriginalPricingjsonld */

export const OriginalPricingjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    taxRate: Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
    quantity: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    unitPriceWithTaxBeforeDiscount: Schema.Number.check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    unitPriceWithoutTaxBeforeDiscount: Schema.Number.check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    unitTaxBeforeDiscount: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    source: Schema.String,
    sourceId: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    schemaVersion: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'OriginalPricingjsonld' });
export type OriginalPricingjsonld = Schema.Schema.Type<typeof OriginalPricingjsonld>;
export type OriginalPricingjsonldEncoded = Schema.Codec.Encoded<typeof OriginalPricingjsonld>;

/* FeedShippingMethodjsonld */

export const FeedShippingMethodjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Union([Schema.String.annotate({ format: 'uuid' }), Schema.String]).annotate({
        readOnly: true,
      })
    ),
    shippingMethod: Schema.String.annotate({ format: 'iri-reference' }),
    feedType: Schema.Literals([
      'analytical_report',
      'baselinker',
      'emag',
      'facebook',
      'google_merchants',
      'heureka_availability',
      'heureka',
      'luigis_box_articles',
      'luigis_box_brands',
      'luigis_box_categories',
      'luigis_box',
      'zbozi',
      'sitemaps_glossary_terms',
      'sitemaps_faq_questions',
      'sitemaps_faq_topics',
      'sitemaps_brands',
      'sitemaps_articles_author',
      'sitemaps_articles_category',
      'sitemaps_articles',
      'sitemaps_pages',
      'sitemaps_categories',
      'sitemaps_products_available',
      'sitemaps_products_unavailable',
    ]).annotate({ default: '' }),
    shippingId: Schema.String.annotate({ default: '' }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'FeedShippingMethodjsonld' });
export type FeedShippingMethodjsonld = Schema.Schema.Type<typeof FeedShippingMethodjsonld>;
export type FeedShippingMethodjsonldEncoded = Schema.Codec.Encoded<typeof FeedShippingMethodjsonld>;

/* ShippingMethodImagejsonld */

export const ShippingMethodImagejsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    owner: Schema.String.annotate({ format: 'iri-reference' }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.Union([Schema.String, Schema.Null]),
    file: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'binary' }),
    path: Schema.String,
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingMethodImagejsonld' });
export type ShippingMethodImagejsonld = Schema.Schema.Type<typeof ShippingMethodImagejsonld>;
export type ShippingMethodImagejsonldEncoded = Schema.Codec.Encoded<
  typeof ShippingMethodImagejsonld
>;

/* FavouriteListProductVariantjsonld */

export const FavouriteListProductVariantjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(Schema.String.annotate({ readOnly: true, format: 'uuid' })),
    favouriteList: Schema.String.annotate({ format: 'iri-reference' }),
    productVariant: Schema.String.annotate({ format: 'iri-reference' }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'FavouriteListProductVariantjsonld' });
export type FavouriteListProductVariantjsonld = Schema.Schema.Type<
  typeof FavouriteListProductVariantjsonld
>;
export type FavouriteListProductVariantjsonldEncoded = Schema.Codec.Encoded<
  typeof FavouriteListProductVariantjsonld
>;

/* CustomerGroupjsonld */

export const CustomerGroupjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.String,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CustomerGroupjsonld' });
export type CustomerGroupjsonld = Schema.Schema.Type<typeof CustomerGroupjsonld>;
export type CustomerGroupjsonldEncoded = Schema.Codec.Encoded<typeof CustomerGroupjsonld>;

/* Addressjsonldsyliusadminaddressshow */

export const Addressjsonldsyliusadminaddressshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    vatNumber: Schema.Union([Schema.String, Schema.Null]),
    businessId: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'IČO or similar ID for other countries',
    }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    firstName: Schema.String,
    lastName: Schema.String,
    phoneNumber: Schema.Union([Schema.String, Schema.Null]),
    company: Schema.Union([Schema.String, Schema.Null]),
    countryCode: Schema.String,
    provinceCode: Schema.Union([Schema.String, Schema.Null]),
    provinceName: Schema.Union([Schema.String, Schema.Null]),
    street: Schema.String,
    city: Schema.String,
    postcode: Schema.String,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Addressjsonldsyliusadminaddressshow' });
export type Addressjsonldsyliusadminaddressshow = Schema.Schema.Type<
  typeof Addressjsonldsyliusadminaddressshow
>;
export type AddressjsonldsyliusadminaddressshowEncoded = Schema.Codec.Encoded<
  typeof Addressjsonldsyliusadminaddressshow
>;

/* Addressjsonldsyliusadminaddressupdate */

export const Addressjsonldsyliusadminaddressupdate = Schema.StructWithRest(
  Schema.Struct({
    vatNumber: Schema.Union([Schema.String, Schema.Null]),
    businessId: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'IČO or similar ID for other countries',
    }),
    firstName: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    lastName: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    phoneNumber: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    company: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    countryCode: Schema.String,
    provinceCode: Schema.Union([Schema.String, Schema.Null]),
    provinceName: Schema.Union([Schema.String, Schema.Null]),
    street: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    city: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    postcode: Schema.String.check(
      Schema.isMinLength(1).annotate({ expected: 'a value with a length of at least 1' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Addressjsonldsyliusadminaddressupdate' });
export type Addressjsonldsyliusadminaddressupdate = Schema.Schema.Type<
  typeof Addressjsonldsyliusadminaddressupdate
>;
export type AddressjsonldsyliusadminaddressupdateEncoded = Schema.Codec.Encoded<
  typeof Addressjsonldsyliusadminaddressupdate
>;

/* Addressjsonldsyliusadminorderindex */

export const Addressjsonldsyliusadminorderindex = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    vatNumber: Schema.Union([Schema.String, Schema.Null]),
    businessId: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'IČO or similar ID for other countries',
    }),
    firstName: Schema.String,
    lastName: Schema.String,
    phoneNumber: Schema.Union([Schema.String, Schema.Null]),
    company: Schema.Union([Schema.String, Schema.Null]),
    countryCode: Schema.String,
    provinceName: Schema.Union([Schema.String, Schema.Null]),
    street: Schema.String,
    city: Schema.String,
    postcode: Schema.String,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Addressjsonldsyliusadminorderindex' });
export type Addressjsonldsyliusadminorderindex = Schema.Schema.Type<
  typeof Addressjsonldsyliusadminorderindex
>;
export type AddressjsonldsyliusadminorderindexEncoded = Schema.Codec.Encoded<
  typeof Addressjsonldsyliusadminorderindex
>;

/* Addressjsonldsyliusadminordershow */

export const Addressjsonldsyliusadminordershow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    vatNumber: Schema.Union([Schema.String, Schema.Null]),
    businessId: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'IČO or similar ID for other countries',
    }),
    firstName: Schema.String,
    lastName: Schema.String,
    phoneNumber: Schema.Union([Schema.String, Schema.Null]),
    company: Schema.Union([Schema.String, Schema.Null]),
    countryCode: Schema.String,
    provinceName: Schema.Union([Schema.String, Schema.Null]),
    street: Schema.String,
    city: Schema.String,
    postcode: Schema.String,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Addressjsonldsyliusadminordershow' });
export type Addressjsonldsyliusadminordershow = Schema.Schema.Type<
  typeof Addressjsonldsyliusadminordershow
>;
export type AddressjsonldsyliusadminordershowEncoded = Schema.Codec.Encoded<
  typeof Addressjsonldsyliusadminordershow
>;

/* Addressjsonldsyliusshopaddresscreate */

export const Addressjsonldsyliusshopaddresscreate = Schema.StructWithRest(
  Schema.Struct({
    vatNumber: Schema.Union([Schema.String, Schema.Null]),
    businessId: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'IČO or similar ID for other countries',
    }),
    firstName: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    lastName: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    phoneNumber: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    company: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    countryCode: Schema.String,
    provinceCode: Schema.Union([Schema.String, Schema.Null]),
    provinceName: Schema.Union([Schema.String, Schema.Null]),
    street: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    city: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    postcode: Schema.String.check(
      Schema.isMinLength(1).annotate({ expected: 'a value with a length of at least 1' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Addressjsonldsyliusshopaddresscreate' });
export type Addressjsonldsyliusshopaddresscreate = Schema.Schema.Type<
  typeof Addressjsonldsyliusshopaddresscreate
>;
export type AddressjsonldsyliusshopaddresscreateEncoded = Schema.Codec.Encoded<
  typeof Addressjsonldsyliusshopaddresscreate
>;

/* Addressjsonldsyliusshopaddressindex */

export const Addressjsonldsyliusshopaddressindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    vatNumber: Schema.Union([Schema.String, Schema.Null]),
    businessId: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'IČO or similar ID for other countries',
    }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    firstName: Schema.String,
    lastName: Schema.String,
    phoneNumber: Schema.Union([Schema.String, Schema.Null]),
    company: Schema.Union([Schema.String, Schema.Null]),
    countryCode: Schema.String,
    provinceCode: Schema.Union([Schema.String, Schema.Null]),
    provinceName: Schema.Union([Schema.String, Schema.Null]),
    street: Schema.String,
    city: Schema.String,
    postcode: Schema.String,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Addressjsonldsyliusshopaddressindex' });
export type Addressjsonldsyliusshopaddressindex = Schema.Schema.Type<
  typeof Addressjsonldsyliusshopaddressindex
>;
export type AddressjsonldsyliusshopaddressindexEncoded = Schema.Codec.Encoded<
  typeof Addressjsonldsyliusshopaddressindex
>;

/* Addressjsonldsyliusshopaddressshow */

export const Addressjsonldsyliusshopaddressshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    vatNumber: Schema.Union([Schema.String, Schema.Null]),
    businessId: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'IČO or similar ID for other countries',
    }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    firstName: Schema.String,
    lastName: Schema.String,
    phoneNumber: Schema.Union([Schema.String, Schema.Null]),
    company: Schema.Union([Schema.String, Schema.Null]),
    countryCode: Schema.String,
    provinceCode: Schema.Union([Schema.String, Schema.Null]),
    provinceName: Schema.Union([Schema.String, Schema.Null]),
    street: Schema.String,
    city: Schema.String,
    postcode: Schema.String,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Addressjsonldsyliusshopaddressshow' });
export type Addressjsonldsyliusshopaddressshow = Schema.Schema.Type<
  typeof Addressjsonldsyliusshopaddressshow
>;
export type AddressjsonldsyliusshopaddressshowEncoded = Schema.Codec.Encoded<
  typeof Addressjsonldsyliusshopaddressshow
>;

/* Addressjsonldsyliusshopaddressupdate */

export const Addressjsonldsyliusshopaddressupdate = Schema.StructWithRest(
  Schema.Struct({
    vatNumber: Schema.Union([Schema.String, Schema.Null]),
    businessId: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'IČO or similar ID for other countries',
    }),
    firstName: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    lastName: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    phoneNumber: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    company: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    countryCode: Schema.String,
    provinceCode: Schema.Union([Schema.String, Schema.Null]),
    provinceName: Schema.Union([Schema.String, Schema.Null]),
    street: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    city: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    postcode: Schema.String.check(
      Schema.isMinLength(1).annotate({ expected: 'a value with a length of at least 1' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Addressjsonldsyliusshopaddressupdate' });
export type Addressjsonldsyliusshopaddressupdate = Schema.Schema.Type<
  typeof Addressjsonldsyliusshopaddressupdate
>;
export type AddressjsonldsyliusshopaddressupdateEncoded = Schema.Codec.Encoded<
  typeof Addressjsonldsyliusshopaddressupdate
>;

/* Addressjsonldsyliusshopcartupdate */

export const Addressjsonldsyliusshopcartupdate = Schema.StructWithRest(
  Schema.Struct({
    vatNumber: Schema.Union([Schema.String, Schema.Null]),
    businessId: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'IČO or similar ID for other countries',
    }),
    firstName: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    lastName: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    phoneNumber: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    company: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    countryCode: Schema.String,
    provinceCode: Schema.Union([Schema.String, Schema.Null]),
    provinceName: Schema.Union([Schema.String, Schema.Null]),
    street: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    city: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    postcode: Schema.String.check(
      Schema.isMinLength(1).annotate({ expected: 'a value with a length of at least 1' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Addressjsonldsyliusshopcartupdate' });
export type Addressjsonldsyliusshopcartupdate = Schema.Schema.Type<
  typeof Addressjsonldsyliusshopcartupdate
>;
export type AddressjsonldsyliusshopcartupdateEncoded = Schema.Codec.Encoded<
  typeof Addressjsonldsyliusshopcartupdate
>;

/* Addressjsonldsyliusshopcustomerme */

export const Addressjsonldsyliusshopcustomerme = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    vatNumber: Schema.Union([Schema.String, Schema.Null]),
    businessId: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'IČO or similar ID for other countries',
    }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    firstName: Schema.String,
    lastName: Schema.String,
    phoneNumber: Schema.Union([Schema.String, Schema.Null]),
    company: Schema.Union([Schema.String, Schema.Null]),
    countryCode: Schema.String,
    provinceCode: Schema.Union([Schema.String, Schema.Null]),
    provinceName: Schema.Union([Schema.String, Schema.Null]),
    street: Schema.String,
    city: Schema.String,
    postcode: Schema.String,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Addressjsonldsyliusshopcustomerme' });
export type Addressjsonldsyliusshopcustomerme = Schema.Schema.Type<
  typeof Addressjsonldsyliusshopcustomerme
>;
export type AddressjsonldsyliusshopcustomermeEncoded = Schema.Codec.Encoded<
  typeof Addressjsonldsyliusshopcustomerme
>;

/* Addressjsonldsyliusshoporderaccountshow */

export const Addressjsonldsyliusshoporderaccountshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    vatNumber: Schema.Union([Schema.String, Schema.Null]),
    businessId: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'IČO or similar ID for other countries',
    }),
    firstName: Schema.String,
    lastName: Schema.String,
    phoneNumber: Schema.Union([Schema.String, Schema.Null]),
    company: Schema.Union([Schema.String, Schema.Null]),
    countryCode: Schema.String,
    provinceCode: Schema.Union([Schema.String, Schema.Null]),
    provinceName: Schema.Union([Schema.String, Schema.Null]),
    street: Schema.String,
    city: Schema.String,
    postcode: Schema.String,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Addressjsonldsyliusshoporderaccountshow' });
export type Addressjsonldsyliusshoporderaccountshow = Schema.Schema.Type<
  typeof Addressjsonldsyliusshoporderaccountshow
>;
export type AddressjsonldsyliusshoporderaccountshowEncoded = Schema.Codec.Encoded<
  typeof Addressjsonldsyliusshoporderaccountshow
>;

/* Addressjsonldsyliusshopstoreindex */

export const Addressjsonldsyliusshopstoreindex = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    countryCode: Schema.String,
    street: Schema.String,
    city: Schema.String,
    postcode: Schema.String,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Addressjsonldsyliusshopstoreindex' });
export type Addressjsonldsyliusshopstoreindex = Schema.Schema.Type<
  typeof Addressjsonldsyliusshopstoreindex
>;
export type AddressjsonldsyliusshopstoreindexEncoded = Schema.Codec.Encoded<
  typeof Addressjsonldsyliusshopstoreindex
>;

/* Adjustmentsyliusadminadjustmentshow */

export const Adjustmentsyliusadminadjustmentshow = Schema.StructWithRest(
  Schema.Struct({
    shipment: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    order: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    orderItem: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    orderItemUnit: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    type: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    label: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    amount: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    neutral: Schema.optionalKey(Schema.Boolean.annotate({ default: false, readOnly: true })),
    locked: Schema.optionalKey(Schema.Boolean.annotate({ default: false, readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Adjustmentsyliusadminadjustmentshow' });
export type Adjustmentsyliusadminadjustmentshow = Schema.Schema.Type<
  typeof Adjustmentsyliusadminadjustmentshow
>;
export type AdjustmentsyliusadminadjustmentshowEncoded = Schema.Codec.Encoded<
  typeof Adjustmentsyliusadminadjustmentshow
>;

/* Adjustmentsyliusadminorderitemindex */

export const Adjustmentsyliusadminorderitemindex = Schema.StructWithRest(
  Schema.Struct({
    type: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    amount: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    neutral: Schema.optionalKey(Schema.Boolean.annotate({ default: false, readOnly: true })),
    locked: Schema.optionalKey(Schema.Boolean.annotate({ default: false, readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Adjustmentsyliusadminorderitemindex' });
export type Adjustmentsyliusadminorderitemindex = Schema.Schema.Type<
  typeof Adjustmentsyliusadminorderitemindex
>;
export type AdjustmentsyliusadminorderitemindexEncoded = Schema.Codec.Encoded<
  typeof Adjustmentsyliusadminorderitemindex
>;

/* Adjustmentsyliusadminorderitemunitindex */

export const Adjustmentsyliusadminorderitemunitindex = Schema.StructWithRest(
  Schema.Struct({
    type: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    amount: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    neutral: Schema.optionalKey(Schema.Boolean.annotate({ default: false, readOnly: true })),
    locked: Schema.optionalKey(Schema.Boolean.annotate({ default: false, readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Adjustmentsyliusadminorderitemunitindex' });
export type Adjustmentsyliusadminorderitemunitindex = Schema.Schema.Type<
  typeof Adjustmentsyliusadminorderitemunitindex
>;
export type AdjustmentsyliusadminorderitemunitindexEncoded = Schema.Codec.Encoded<
  typeof Adjustmentsyliusadminorderitemunitindex
>;

/* Adjustmentsyliusadminshipmentindex */

export const Adjustmentsyliusadminshipmentindex = Schema.StructWithRest(
  Schema.Struct({
    type: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    amount: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    neutral: Schema.optionalKey(Schema.Boolean.annotate({ default: false, readOnly: true })),
    locked: Schema.optionalKey(Schema.Boolean.annotate({ default: false, readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Adjustmentsyliusadminshipmentindex' });
export type Adjustmentsyliusadminshipmentindex = Schema.Schema.Type<
  typeof Adjustmentsyliusadminshipmentindex
>;
export type AdjustmentsyliusadminshipmentindexEncoded = Schema.Codec.Encoded<
  typeof Adjustmentsyliusadminshipmentindex
>;

/* Adjustmentsyliusshopcartshow */

export const Adjustmentsyliusshopcartshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    label: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    amount: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    neutral: Schema.optionalKey(Schema.Boolean.annotate({ default: false, readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Adjustmentsyliusshopcartshow' });
export type Adjustmentsyliusshopcartshow = Schema.Schema.Type<typeof Adjustmentsyliusshopcartshow>;
export type AdjustmentsyliusshopcartshowEncoded = Schema.Codec.Encoded<
  typeof Adjustmentsyliusshopcartshow
>;

/* Adjustmentjsonldsyliusadminadjustmentshow */

export const Adjustmentjsonldsyliusadminadjustmentshow = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    shipment: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    order: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    orderItem: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    orderItemUnit: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    type: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    label: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    amount: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    neutral: Schema.optionalKey(Schema.Boolean.annotate({ default: false, readOnly: true })),
    locked: Schema.optionalKey(Schema.Boolean.annotate({ default: false, readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Adjustmentjsonldsyliusadminadjustmentshow' });
export type Adjustmentjsonldsyliusadminadjustmentshow = Schema.Schema.Type<
  typeof Adjustmentjsonldsyliusadminadjustmentshow
>;
export type AdjustmentjsonldsyliusadminadjustmentshowEncoded = Schema.Codec.Encoded<
  typeof Adjustmentjsonldsyliusadminadjustmentshow
>;

/* Adjustmentjsonldsyliusadminorderitemindex */

export const Adjustmentjsonldsyliusadminorderitemindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    type: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    amount: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    neutral: Schema.optionalKey(Schema.Boolean.annotate({ default: false, readOnly: true })),
    locked: Schema.optionalKey(Schema.Boolean.annotate({ default: false, readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Adjustmentjsonldsyliusadminorderitemindex' });
export type Adjustmentjsonldsyliusadminorderitemindex = Schema.Schema.Type<
  typeof Adjustmentjsonldsyliusadminorderitemindex
>;
export type AdjustmentjsonldsyliusadminorderitemindexEncoded = Schema.Codec.Encoded<
  typeof Adjustmentjsonldsyliusadminorderitemindex
>;

/* Adjustmentjsonldsyliusadminorderitemunitindex */

export const Adjustmentjsonldsyliusadminorderitemunitindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    type: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    amount: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    neutral: Schema.optionalKey(Schema.Boolean.annotate({ default: false, readOnly: true })),
    locked: Schema.optionalKey(Schema.Boolean.annotate({ default: false, readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Adjustmentjsonldsyliusadminorderitemunitindex' });
export type Adjustmentjsonldsyliusadminorderitemunitindex = Schema.Schema.Type<
  typeof Adjustmentjsonldsyliusadminorderitemunitindex
>;
export type AdjustmentjsonldsyliusadminorderitemunitindexEncoded = Schema.Codec.Encoded<
  typeof Adjustmentjsonldsyliusadminorderitemunitindex
>;

/* Adjustmentjsonldsyliusadminshipmentindex */

export const Adjustmentjsonldsyliusadminshipmentindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    type: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    amount: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    neutral: Schema.optionalKey(Schema.Boolean.annotate({ default: false, readOnly: true })),
    locked: Schema.optionalKey(Schema.Boolean.annotate({ default: false, readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Adjustmentjsonldsyliusadminshipmentindex' });
export type Adjustmentjsonldsyliusadminshipmentindex = Schema.Schema.Type<
  typeof Adjustmentjsonldsyliusadminshipmentindex
>;
export type AdjustmentjsonldsyliusadminshipmentindexEncoded = Schema.Codec.Encoded<
  typeof Adjustmentjsonldsyliusadminshipmentindex
>;

/* Adjustmentjsonldsyliusshopcartshow */

export const Adjustmentjsonldsyliusshopcartshow = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    label: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    amount: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    neutral: Schema.optionalKey(Schema.Boolean.annotate({ default: false, readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Adjustmentjsonldsyliusshopcartshow' });
export type Adjustmentjsonldsyliusshopcartshow = Schema.Schema.Type<
  typeof Adjustmentjsonldsyliusshopcartshow
>;
export type AdjustmentjsonldsyliusshopcartshowEncoded = Schema.Codec.Encoded<
  typeof Adjustmentjsonldsyliusshopcartshow
>;

/* AvatarImage */

export const AvatarImage = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.Union([Schema.String, Schema.Null]),
    file: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'binary' }),
    path: Schema.String,
    owner: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'AvatarImage' });
export type AvatarImage = Schema.Schema.Type<typeof AvatarImage>;
export type AvatarImageEncoded = Schema.Codec.Encoded<typeof AvatarImage>;

/* ImageInterface */

export const ImageInterface = Schema.StructWithRest(
  Schema.Struct({
    type: Schema.Union([Schema.String, Schema.Null]),
    file: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'binary' }),
    path: Schema.Union([Schema.String, Schema.Null]),
    owner: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    id: Schema.optionalKey(Schema.Json.annotate({ expected: 'JSON value', readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ImageInterface' });
export type ImageInterface = Schema.Schema.Type<typeof ImageInterface>;
export type ImageInterfaceEncoded = Schema.Codec.Encoded<typeof ImageInterface>;

/* Administratorsyliusadminadminusercreate */

export const Administratorsyliusadminadminusercreate = Schema.StructWithRest(
  Schema.Struct({
    firstName: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    lastName: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    localeCode: Schema.String,
    username: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    plainPassword: Schema.Union([
      Schema.String.check(
        Schema.isMinLength(4).annotate({ expected: 'a value with a length of at least 4' })
      ).check(
        Schema.isMaxLength(254).annotate({ expected: 'a value with a length of at most 254' })
      ),
      Schema.Null,
    ]).annotate({
      description: 'Password before encryption. Used for model validation. Must not be persisted.',
      writeOnly: true,
    }),
    email: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'email' }),
    enabled: Schema.Boolean.annotate({ default: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Administratorsyliusadminadminusercreate' });
export type Administratorsyliusadminadminusercreate = Schema.Schema.Type<
  typeof Administratorsyliusadminadminusercreate
>;
export type AdministratorsyliusadminadminusercreateEncoded = Schema.Codec.Encoded<
  typeof Administratorsyliusadminadminusercreate
>;

/* Administratorsyliusadminadminuserupdate */

export const Administratorsyliusadminadminuserupdate = Schema.StructWithRest(
  Schema.Struct({
    firstName: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    lastName: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    localeCode: Schema.String,
    username: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    plainPassword: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'Password before encryption. Used for model validation. Must not be persisted.',
      writeOnly: true,
    }),
    email: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'email' }),
    enabled: Schema.Boolean.annotate({ default: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Administratorsyliusadminadminuserupdate' });
export type Administratorsyliusadminadminuserupdate = Schema.Schema.Type<
  typeof Administratorsyliusadminadminuserupdate
>;
export type AdministratorsyliusadminadminuserupdateEncoded = Schema.Codec.Encoded<
  typeof Administratorsyliusadminadminuserupdate
>;

/* AvatarImagejsonld */

export const AvatarImagejsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.Union([Schema.String, Schema.Null]),
    file: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'binary' }),
    path: Schema.String,
    owner: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'AvatarImagejsonld' });
export type AvatarImagejsonld = Schema.Schema.Type<typeof AvatarImagejsonld>;
export type AvatarImagejsonldEncoded = Schema.Codec.Encoded<typeof AvatarImagejsonld>;

/* ImageInterfacejsonld */

export const ImageInterfacejsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    type: Schema.Union([Schema.String, Schema.Null]),
    file: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'binary' }),
    path: Schema.Union([Schema.String, Schema.Null]),
    owner: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    id: Schema.optionalKey(Schema.Json.annotate({ expected: 'JSON value', readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ImageInterfacejsonld' });
export type ImageInterfacejsonld = Schema.Schema.Type<typeof ImageInterfacejsonld>;
export type ImageInterfacejsonldEncoded = Schema.Codec.Encoded<typeof ImageInterfacejsonld>;

/* Administratorjsonldsyliusadminadminusercreate */

export const Administratorjsonldsyliusadminadminusercreate = Schema.StructWithRest(
  Schema.Struct({
    firstName: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    lastName: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    localeCode: Schema.String,
    username: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    plainPassword: Schema.Union([
      Schema.String.check(
        Schema.isMinLength(4).annotate({ expected: 'a value with a length of at least 4' })
      ).check(
        Schema.isMaxLength(254).annotate({ expected: 'a value with a length of at most 254' })
      ),
      Schema.Null,
    ]).annotate({
      description: 'Password before encryption. Used for model validation. Must not be persisted.',
      writeOnly: true,
    }),
    email: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'email' }),
    enabled: Schema.Boolean.annotate({ default: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Administratorjsonldsyliusadminadminusercreate' });
export type Administratorjsonldsyliusadminadminusercreate = Schema.Schema.Type<
  typeof Administratorjsonldsyliusadminadminusercreate
>;
export type AdministratorjsonldsyliusadminadminusercreateEncoded = Schema.Codec.Encoded<
  typeof Administratorjsonldsyliusadminadminusercreate
>;

/* Administratorjsonldsyliusadminadminuserupdate */

export const Administratorjsonldsyliusadminadminuserupdate = Schema.StructWithRest(
  Schema.Struct({
    firstName: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    lastName: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    localeCode: Schema.String,
    username: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    plainPassword: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'Password before encryption. Used for model validation. Must not be persisted.',
      writeOnly: true,
    }),
    email: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'email' }),
    enabled: Schema.Boolean.annotate({ default: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Administratorjsonldsyliusadminadminuserupdate' });
export type Administratorjsonldsyliusadminadminuserupdate = Schema.Schema.Type<
  typeof Administratorjsonldsyliusadminadminuserupdate
>;
export type AdministratorjsonldsyliusadminadminuserupdateEncoded = Schema.Codec.Encoded<
  typeof Administratorjsonldsyliusadminadminuserupdate
>;

/* Sectionsyliusshoparticleindex */

export const Sectionsyliusshoparticleindex = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.String.annotate({ format: 'uuid' }),
    code: Schema.String,
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Sectionsyliusshoparticleindex' });
export type Sectionsyliusshoparticleindex = Schema.Schema.Type<
  typeof Sectionsyliusshoparticleindex
>;
export type SectionsyliusshoparticleindexEncoded = Schema.Codec.Encoded<
  typeof Sectionsyliusshoparticleindex
>;

/* CategoryImagesyliusshoparticleindex */

export const CategoryImagesyliusshoparticleindex = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CategoryImagesyliusshoparticleindex' });
export type CategoryImagesyliusshoparticleindex = Schema.Schema.Type<
  typeof CategoryImagesyliusshoparticleindex
>;
export type CategoryImagesyliusshoparticleindexEncoded = Schema.Codec.Encoded<
  typeof CategoryImagesyliusshoparticleindex
>;

/* Tagsyliusshoparticleindex */

export const Tagsyliusshoparticleindex = Schema.StructWithRest(
  Schema.Struct({
    color: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Tagsyliusshoparticleindex' });
export type Tagsyliusshoparticleindex = Schema.Schema.Type<typeof Tagsyliusshoparticleindex>;
export type TagsyliusshoparticleindexEncoded = Schema.Codec.Encoded<
  typeof Tagsyliusshoparticleindex
>;

/* Authorsyliusshoparticleindex */

export const Authorsyliusshoparticleindex = Schema.StructWithRest(
  Schema.Struct({
    favourite: Schema.Boolean.annotate({ default: false }),
    name: Schema.String,
    image: Schema.Union([Schema.String, Schema.Null]),
    imageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    description: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Authorsyliusshoparticleindex' });
export type Authorsyliusshoparticleindex = Schema.Schema.Type<typeof Authorsyliusshoparticleindex>;
export type AuthorsyliusshoparticleindexEncoded = Schema.Codec.Encoded<
  typeof Authorsyliusshoparticleindex
>;

/* Sectionsyliusshoparticleshow */

export const Sectionsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.String.annotate({ format: 'uuid' }),
    code: Schema.String,
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Sectionsyliusshoparticleshow' });
export type Sectionsyliusshoparticleshow = Schema.Schema.Type<typeof Sectionsyliusshoparticleshow>;
export type SectionsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof Sectionsyliusshoparticleshow
>;

/* CategoryImagesyliusshoparticleshow */

export const CategoryImagesyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CategoryImagesyliusshoparticleshow' });
export type CategoryImagesyliusshoparticleshow = Schema.Schema.Type<
  typeof CategoryImagesyliusshoparticleshow
>;
export type CategoryImagesyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof CategoryImagesyliusshoparticleshow
>;

/* Tagsyliusshoparticleshow */

export const Tagsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    color: Schema.Union([Schema.String, Schema.Null]),
    favourite: Schema.Boolean.annotate({ default: false }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Tagsyliusshoparticleshow' });
export type Tagsyliusshoparticleshow = Schema.Schema.Type<typeof Tagsyliusshoparticleshow>;
export type TagsyliusshoparticleshowEncoded = Schema.Codec.Encoded<typeof Tagsyliusshoparticleshow>;

/* Authorsyliusshoparticleshow */

export const Authorsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    favourite: Schema.Boolean.annotate({ default: false }),
    name: Schema.String,
    image: Schema.Union([Schema.String, Schema.Null]),
    imageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    description: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Authorsyliusshoparticleshow' });
export type Authorsyliusshoparticleshow = Schema.Schema.Type<typeof Authorsyliusshoparticleshow>;
export type AuthorsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof Authorsyliusshoparticleshow
>;

/* TitleElementDTOsyliusshoparticleshow */

export const TitleElementDTOsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    content: Schema.String,
    tag: Schema.Union([Schema.String, Schema.Null]),
    type: Schema.Literal('title').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TitleElementDTOsyliusshoparticleshow' });
export type TitleElementDTOsyliusshoparticleshow = Schema.Schema.Type<
  typeof TitleElementDTOsyliusshoparticleshow
>;
export type TitleElementDTOsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof TitleElementDTOsyliusshoparticleshow
>;

/* MarkdownTextElementDTOsyliusshoparticleshow */

export const MarkdownTextElementDTOsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    content: Schema.String,
    type: Schema.Literal('markdown_text').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'MarkdownTextElementDTOsyliusshoparticleshow' });
export type MarkdownTextElementDTOsyliusshoparticleshow = Schema.Schema.Type<
  typeof MarkdownTextElementDTOsyliusshoparticleshow
>;
export type MarkdownTextElementDTOsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof MarkdownTextElementDTOsyliusshoparticleshow
>;

/* MarkdownPerexElementDTOsyliusshoparticleshow */

export const MarkdownPerexElementDTOsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    content: Schema.String,
    type: Schema.Literal('markdown_perex').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'MarkdownPerexElementDTOsyliusshoparticleshow' });
export type MarkdownPerexElementDTOsyliusshoparticleshow = Schema.Schema.Type<
  typeof MarkdownPerexElementDTOsyliusshoparticleshow
>;
export type MarkdownPerexElementDTOsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof MarkdownPerexElementDTOsyliusshoparticleshow
>;

/* QuoteElementDTOsyliusshoparticleshow */

export const QuoteElementDTOsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    content: Schema.String,
    author: Schema.Union([Schema.String, Schema.Null]),
    type: Schema.Literal('quote').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'QuoteElementDTOsyliusshoparticleshow' });
export type QuoteElementDTOsyliusshoparticleshow = Schema.Schema.Type<
  typeof QuoteElementDTOsyliusshoparticleshow
>;
export type QuoteElementDTOsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof QuoteElementDTOsyliusshoparticleshow
>;

/* ImageElementDTOsyliusshoparticleshow */

export const ImageElementDTOsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    size: Schema.Literals(['wide', 'fit']),
    alt: Schema.Union([Schema.String, Schema.Null]),
    type: Schema.Literal('image').annotate({ readOnly: true }),
    imageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ImageElementDTOsyliusshoparticleshow' });
export type ImageElementDTOsyliusshoparticleshow = Schema.Schema.Type<
  typeof ImageElementDTOsyliusshoparticleshow
>;
export type ImageElementDTOsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof ImageElementDTOsyliusshoparticleshow
>;

/* ImageItemDTOsyliusshoparticleshow */

export const ImageItemDTOsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    alt: Schema.Union([Schema.String, Schema.Null]),
    link: Schema.Union([Schema.String, Schema.Null]),
    linkType: Schema.Union([Schema.String, Schema.Null]),
    imageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ImageItemDTOsyliusshoparticleshow' });
export type ImageItemDTOsyliusshoparticleshow = Schema.Schema.Type<
  typeof ImageItemDTOsyliusshoparticleshow
>;
export type ImageItemDTOsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof ImageItemDTOsyliusshoparticleshow
>;

/* ProductImagesyliusshoparticleshow */

export const ProductImagesyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    type: Schema.Union([Schema.String, Schema.Null]),
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductImagesyliusshoparticleshow' });
export type ProductImagesyliusshoparticleshow = Schema.Schema.Type<
  typeof ProductImagesyliusshoparticleshow
>;
export type ProductImagesyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof ProductImagesyliusshoparticleshow
>;

/* YoutubeElementDTOsyliusshoparticleshow */

export const YoutubeElementDTOsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    link: Schema.String,
    type: Schema.Literal('youtube').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'YoutubeElementDTOsyliusshoparticleshow' });
export type YoutubeElementDTOsyliusshoparticleshow = Schema.Schema.Type<
  typeof YoutubeElementDTOsyliusshoparticleshow
>;
export type YoutubeElementDTOsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof YoutubeElementDTOsyliusshoparticleshow
>;

/* MarkdownTwoColumnsElementDTOsyliusshoparticleshow */

export const MarkdownTwoColumnsElementDTOsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    left: Schema.String,
    right: Schema.String,
    type: Schema.Literal('markdown_two_columns').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'MarkdownTwoColumnsElementDTOsyliusshoparticleshow' });
export type MarkdownTwoColumnsElementDTOsyliusshoparticleshow = Schema.Schema.Type<
  typeof MarkdownTwoColumnsElementDTOsyliusshoparticleshow
>;
export type MarkdownTwoColumnsElementDTOsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof MarkdownTwoColumnsElementDTOsyliusshoparticleshow
>;

/* MarkdownThreeColumnsElementDTOsyliusshoparticleshow */

export const MarkdownThreeColumnsElementDTOsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    left: Schema.String,
    center: Schema.String,
    right: Schema.String,
    type: Schema.Literal('markdown_three_columns').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'MarkdownThreeColumnsElementDTOsyliusshoparticleshow' });
export type MarkdownThreeColumnsElementDTOsyliusshoparticleshow = Schema.Schema.Type<
  typeof MarkdownThreeColumnsElementDTOsyliusshoparticleshow
>;
export type MarkdownThreeColumnsElementDTOsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof MarkdownThreeColumnsElementDTOsyliusshoparticleshow
>;

/* RetinoWidgetElementDTOsyliusshoparticleshow */

export const RetinoWidgetElementDTOsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    companyId: Schema.String,
    type: Schema.Literal('retino-widget').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'RetinoWidgetElementDTOsyliusshoparticleshow' });
export type RetinoWidgetElementDTOsyliusshoparticleshow = Schema.Schema.Type<
  typeof RetinoWidgetElementDTOsyliusshoparticleshow
>;
export type RetinoWidgetElementDTOsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof RetinoWidgetElementDTOsyliusshoparticleshow
>;

/* AdvantagesElementDTOsyliusshoparticleshow */

export const AdvantagesElementDTOsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    textOne: Schema.String,
    textTwo: Schema.String,
    textThree: Schema.String,
    textFour: Schema.String,
    type: Schema.Literal('advantages').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'AdvantagesElementDTOsyliusshoparticleshow' });
export type AdvantagesElementDTOsyliusshoparticleshow = Schema.Schema.Type<
  typeof AdvantagesElementDTOsyliusshoparticleshow
>;
export type AdvantagesElementDTOsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof AdvantagesElementDTOsyliusshoparticleshow
>;

/* WhiteBoxElementDTOsyliusshoparticleshow */

export const WhiteBoxElementDTOsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    text: Schema.String,
    type: Schema.Literal('white_box').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'WhiteBoxElementDTOsyliusshoparticleshow' });
export type WhiteBoxElementDTOsyliusshoparticleshow = Schema.Schema.Type<
  typeof WhiteBoxElementDTOsyliusshoparticleshow
>;
export type WhiteBoxElementDTOsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof WhiteBoxElementDTOsyliusshoparticleshow
>;

/* ImageClearItemDTOsyliusshoparticleshow */

export const ImageClearItemDTOsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    alt: Schema.Union([Schema.String, Schema.Null]),
    imageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ImageClearItemDTOsyliusshoparticleshow' });
export type ImageClearItemDTOsyliusshoparticleshow = Schema.Schema.Type<
  typeof ImageClearItemDTOsyliusshoparticleshow
>;
export type ImageClearItemDTOsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof ImageClearItemDTOsyliusshoparticleshow
>;

/* BaseButtonElementDTOsyliusshoparticleshow */

export const BaseButtonElementDTOsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    link: Schema.String,
    text: Schema.String,
    type: Schema.Literal('base_button').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'BaseButtonElementDTOsyliusshoparticleshow' });
export type BaseButtonElementDTOsyliusshoparticleshow = Schema.Schema.Type<
  typeof BaseButtonElementDTOsyliusshoparticleshow
>;
export type BaseButtonElementDTOsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof BaseButtonElementDTOsyliusshoparticleshow
>;

/* ProductListElementDTOsyliusshoparticleshow */

export const ProductListElementDTOsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    style: Schema.Literals(['withoutDescription', 'normal']),
    products: Schema.Array(Schema.String),
    productsPerPage: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    type: Schema.Literal('product_list').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductListElementDTOsyliusshoparticleshow' });
export type ProductListElementDTOsyliusshoparticleshow = Schema.Schema.Type<
  typeof ProductListElementDTOsyliusshoparticleshow
>;
export type ProductListElementDTOsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof ProductListElementDTOsyliusshoparticleshow
>;

/* TableCellItemDTOsyliusshoparticleshow */

export const TableCellItemDTOsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({ content: Schema.String, color: Schema.Literals(['black', 'gray', 'white']) }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TableCellItemDTOsyliusshoparticleshow' });
export type TableCellItemDTOsyliusshoparticleshow = Schema.Schema.Type<
  typeof TableCellItemDTOsyliusshoparticleshow
>;
export type TableCellItemDTOsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof TableCellItemDTOsyliusshoparticleshow
>;

/* Sectionsyliusshophomepageshow */

export const Sectionsyliusshophomepageshow = Schema.StructWithRest(
  Schema.Struct({ code: Schema.String, name: Schema.Union([Schema.String, Schema.Null]) }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Sectionsyliusshophomepageshow' });
export type Sectionsyliusshophomepageshow = Schema.Schema.Type<
  typeof Sectionsyliusshophomepageshow
>;
export type SectionsyliusshophomepageshowEncoded = Schema.Codec.Encoded<
  typeof Sectionsyliusshophomepageshow
>;

/* Tagsyliusshophomepageshow */

export const Tagsyliusshophomepageshow = Schema.StructWithRest(
  Schema.Struct({
    color: Schema.Union([Schema.String, Schema.Null]),
    name: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Tagsyliusshophomepageshow' });
export type Tagsyliusshophomepageshow = Schema.Schema.Type<typeof Tagsyliusshophomepageshow>;
export type TagsyliusshophomepageshowEncoded = Schema.Codec.Encoded<
  typeof Tagsyliusshophomepageshow
>;

/* Authorsyliusshophomepageshow */

export const Authorsyliusshophomepageshow = Schema.StructWithRest(
  Schema.Struct({
    name: Schema.String,
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Authorsyliusshophomepageshow' });
export type Authorsyliusshophomepageshow = Schema.Schema.Type<typeof Authorsyliusshophomepageshow>;
export type AuthorsyliusshophomepageshowEncoded = Schema.Codec.Encoded<
  typeof Authorsyliusshophomepageshow
>;

/* Sectionjsonldsyliusshoparticleindex */

export const Sectionjsonldsyliusshoparticleindex = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.String.annotate({ format: 'uuid' }),
    code: Schema.String,
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Sectionjsonldsyliusshoparticleindex' });
export type Sectionjsonldsyliusshoparticleindex = Schema.Schema.Type<
  typeof Sectionjsonldsyliusshoparticleindex
>;
export type SectionjsonldsyliusshoparticleindexEncoded = Schema.Codec.Encoded<
  typeof Sectionjsonldsyliusshoparticleindex
>;

/* CategoryImagejsonldsyliusshoparticleindex */

export const CategoryImagejsonldsyliusshoparticleindex = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CategoryImagejsonldsyliusshoparticleindex' });
export type CategoryImagejsonldsyliusshoparticleindex = Schema.Schema.Type<
  typeof CategoryImagejsonldsyliusshoparticleindex
>;
export type CategoryImagejsonldsyliusshoparticleindexEncoded = Schema.Codec.Encoded<
  typeof CategoryImagejsonldsyliusshoparticleindex
>;

/* Tagjsonldsyliusshoparticleindex */

export const Tagjsonldsyliusshoparticleindex = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    color: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Tagjsonldsyliusshoparticleindex' });
export type Tagjsonldsyliusshoparticleindex = Schema.Schema.Type<
  typeof Tagjsonldsyliusshoparticleindex
>;
export type TagjsonldsyliusshoparticleindexEncoded = Schema.Codec.Encoded<
  typeof Tagjsonldsyliusshoparticleindex
>;

/* Authorjsonldsyliusshoparticleindex */

export const Authorjsonldsyliusshoparticleindex = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    favourite: Schema.Boolean.annotate({ default: false }),
    name: Schema.String,
    image: Schema.Union([Schema.String, Schema.Null]),
    imageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    description: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Authorjsonldsyliusshoparticleindex' });
export type Authorjsonldsyliusshoparticleindex = Schema.Schema.Type<
  typeof Authorjsonldsyliusshoparticleindex
>;
export type AuthorjsonldsyliusshoparticleindexEncoded = Schema.Codec.Encoded<
  typeof Authorjsonldsyliusshoparticleindex
>;

/* Sectionjsonldsyliusshoparticleshow */

export const Sectionjsonldsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.String.annotate({ format: 'uuid' }),
    code: Schema.String,
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Sectionjsonldsyliusshoparticleshow' });
export type Sectionjsonldsyliusshoparticleshow = Schema.Schema.Type<
  typeof Sectionjsonldsyliusshoparticleshow
>;
export type SectionjsonldsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof Sectionjsonldsyliusshoparticleshow
>;

/* CategoryImagejsonldsyliusshoparticleshow */

export const CategoryImagejsonldsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CategoryImagejsonldsyliusshoparticleshow' });
export type CategoryImagejsonldsyliusshoparticleshow = Schema.Schema.Type<
  typeof CategoryImagejsonldsyliusshoparticleshow
>;
export type CategoryImagejsonldsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof CategoryImagejsonldsyliusshoparticleshow
>;

/* Tagjsonldsyliusshoparticleshow */

export const Tagjsonldsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    color: Schema.Union([Schema.String, Schema.Null]),
    favourite: Schema.Boolean.annotate({ default: false }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Tagjsonldsyliusshoparticleshow' });
export type Tagjsonldsyliusshoparticleshow = Schema.Schema.Type<
  typeof Tagjsonldsyliusshoparticleshow
>;
export type TagjsonldsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof Tagjsonldsyliusshoparticleshow
>;

/* Authorjsonldsyliusshoparticleshow */

export const Authorjsonldsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    favourite: Schema.Boolean.annotate({ default: false }),
    name: Schema.String,
    image: Schema.Union([Schema.String, Schema.Null]),
    imageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    description: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Authorjsonldsyliusshoparticleshow' });
export type Authorjsonldsyliusshoparticleshow = Schema.Schema.Type<
  typeof Authorjsonldsyliusshoparticleshow
>;
export type AuthorjsonldsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof Authorjsonldsyliusshoparticleshow
>;

/* TitleElementDTOjsonldsyliusshoparticleshow */

export const TitleElementDTOjsonldsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    content: Schema.String,
    tag: Schema.Union([Schema.String, Schema.Null]),
    type: Schema.Literal('title').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TitleElementDTOjsonldsyliusshoparticleshow' });
export type TitleElementDTOjsonldsyliusshoparticleshow = Schema.Schema.Type<
  typeof TitleElementDTOjsonldsyliusshoparticleshow
>;
export type TitleElementDTOjsonldsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof TitleElementDTOjsonldsyliusshoparticleshow
>;

/* MarkdownTextElementDTOjsonldsyliusshoparticleshow */

export const MarkdownTextElementDTOjsonldsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    content: Schema.String,
    type: Schema.Literal('markdown_text').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'MarkdownTextElementDTOjsonldsyliusshoparticleshow' });
export type MarkdownTextElementDTOjsonldsyliusshoparticleshow = Schema.Schema.Type<
  typeof MarkdownTextElementDTOjsonldsyliusshoparticleshow
>;
export type MarkdownTextElementDTOjsonldsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof MarkdownTextElementDTOjsonldsyliusshoparticleshow
>;

/* MarkdownPerexElementDTOjsonldsyliusshoparticleshow */

export const MarkdownPerexElementDTOjsonldsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    content: Schema.String,
    type: Schema.Literal('markdown_perex').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'MarkdownPerexElementDTOjsonldsyliusshoparticleshow' });
export type MarkdownPerexElementDTOjsonldsyliusshoparticleshow = Schema.Schema.Type<
  typeof MarkdownPerexElementDTOjsonldsyliusshoparticleshow
>;
export type MarkdownPerexElementDTOjsonldsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof MarkdownPerexElementDTOjsonldsyliusshoparticleshow
>;

/* QuoteElementDTOjsonldsyliusshoparticleshow */

export const QuoteElementDTOjsonldsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    content: Schema.String,
    author: Schema.Union([Schema.String, Schema.Null]),
    type: Schema.Literal('quote').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'QuoteElementDTOjsonldsyliusshoparticleshow' });
export type QuoteElementDTOjsonldsyliusshoparticleshow = Schema.Schema.Type<
  typeof QuoteElementDTOjsonldsyliusshoparticleshow
>;
export type QuoteElementDTOjsonldsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof QuoteElementDTOjsonldsyliusshoparticleshow
>;

/* ImageElementDTOjsonldsyliusshoparticleshow */

export const ImageElementDTOjsonldsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    size: Schema.Literals(['wide', 'fit']),
    alt: Schema.Union([Schema.String, Schema.Null]),
    type: Schema.Literal('image').annotate({ readOnly: true }),
    imageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ImageElementDTOjsonldsyliusshoparticleshow' });
export type ImageElementDTOjsonldsyliusshoparticleshow = Schema.Schema.Type<
  typeof ImageElementDTOjsonldsyliusshoparticleshow
>;
export type ImageElementDTOjsonldsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof ImageElementDTOjsonldsyliusshoparticleshow
>;

/* ImageItemDTOjsonldsyliusshoparticleshow */

export const ImageItemDTOjsonldsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    alt: Schema.Union([Schema.String, Schema.Null]),
    link: Schema.Union([Schema.String, Schema.Null]),
    linkType: Schema.Union([Schema.String, Schema.Null]),
    imageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ImageItemDTOjsonldsyliusshoparticleshow' });
export type ImageItemDTOjsonldsyliusshoparticleshow = Schema.Schema.Type<
  typeof ImageItemDTOjsonldsyliusshoparticleshow
>;
export type ImageItemDTOjsonldsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof ImageItemDTOjsonldsyliusshoparticleshow
>;

/* ProductImagejsonldsyliusshoparticleshow */

export const ProductImagejsonldsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    type: Schema.Union([Schema.String, Schema.Null]),
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductImagejsonldsyliusshoparticleshow' });
export type ProductImagejsonldsyliusshoparticleshow = Schema.Schema.Type<
  typeof ProductImagejsonldsyliusshoparticleshow
>;
export type ProductImagejsonldsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof ProductImagejsonldsyliusshoparticleshow
>;

/* YoutubeElementDTOjsonldsyliusshoparticleshow */

export const YoutubeElementDTOjsonldsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    link: Schema.String,
    type: Schema.Literal('youtube').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'YoutubeElementDTOjsonldsyliusshoparticleshow' });
export type YoutubeElementDTOjsonldsyliusshoparticleshow = Schema.Schema.Type<
  typeof YoutubeElementDTOjsonldsyliusshoparticleshow
>;
export type YoutubeElementDTOjsonldsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof YoutubeElementDTOjsonldsyliusshoparticleshow
>;

/* MarkdownTwoColumnsElementDTOjsonldsyliusshoparticleshow */

export const MarkdownTwoColumnsElementDTOjsonldsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    left: Schema.String,
    right: Schema.String,
    type: Schema.Literal('markdown_two_columns').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'MarkdownTwoColumnsElementDTOjsonldsyliusshoparticleshow' });
export type MarkdownTwoColumnsElementDTOjsonldsyliusshoparticleshow = Schema.Schema.Type<
  typeof MarkdownTwoColumnsElementDTOjsonldsyliusshoparticleshow
>;
export type MarkdownTwoColumnsElementDTOjsonldsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof MarkdownTwoColumnsElementDTOjsonldsyliusshoparticleshow
>;

/* MarkdownThreeColumnsElementDTOjsonldsyliusshoparticleshow */

export const MarkdownThreeColumnsElementDTOjsonldsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    left: Schema.String,
    center: Schema.String,
    right: Schema.String,
    type: Schema.Literal('markdown_three_columns').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'MarkdownThreeColumnsElementDTOjsonldsyliusshoparticleshow' });
export type MarkdownThreeColumnsElementDTOjsonldsyliusshoparticleshow = Schema.Schema.Type<
  typeof MarkdownThreeColumnsElementDTOjsonldsyliusshoparticleshow
>;
export type MarkdownThreeColumnsElementDTOjsonldsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof MarkdownThreeColumnsElementDTOjsonldsyliusshoparticleshow
>;

/* RetinoWidgetElementDTOjsonldsyliusshoparticleshow */

export const RetinoWidgetElementDTOjsonldsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    companyId: Schema.String,
    type: Schema.Literal('retino-widget').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'RetinoWidgetElementDTOjsonldsyliusshoparticleshow' });
export type RetinoWidgetElementDTOjsonldsyliusshoparticleshow = Schema.Schema.Type<
  typeof RetinoWidgetElementDTOjsonldsyliusshoparticleshow
>;
export type RetinoWidgetElementDTOjsonldsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof RetinoWidgetElementDTOjsonldsyliusshoparticleshow
>;

/* AdvantagesElementDTOjsonldsyliusshoparticleshow */

export const AdvantagesElementDTOjsonldsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    textOne: Schema.String,
    textTwo: Schema.String,
    textThree: Schema.String,
    textFour: Schema.String,
    type: Schema.Literal('advantages').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'AdvantagesElementDTOjsonldsyliusshoparticleshow' });
export type AdvantagesElementDTOjsonldsyliusshoparticleshow = Schema.Schema.Type<
  typeof AdvantagesElementDTOjsonldsyliusshoparticleshow
>;
export type AdvantagesElementDTOjsonldsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof AdvantagesElementDTOjsonldsyliusshoparticleshow
>;

/* WhiteBoxElementDTOjsonldsyliusshoparticleshow */

export const WhiteBoxElementDTOjsonldsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    text: Schema.String,
    type: Schema.Literal('white_box').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'WhiteBoxElementDTOjsonldsyliusshoparticleshow' });
export type WhiteBoxElementDTOjsonldsyliusshoparticleshow = Schema.Schema.Type<
  typeof WhiteBoxElementDTOjsonldsyliusshoparticleshow
>;
export type WhiteBoxElementDTOjsonldsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof WhiteBoxElementDTOjsonldsyliusshoparticleshow
>;

/* ImageClearItemDTOjsonldsyliusshoparticleshow */

export const ImageClearItemDTOjsonldsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    alt: Schema.Union([Schema.String, Schema.Null]),
    imageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ImageClearItemDTOjsonldsyliusshoparticleshow' });
export type ImageClearItemDTOjsonldsyliusshoparticleshow = Schema.Schema.Type<
  typeof ImageClearItemDTOjsonldsyliusshoparticleshow
>;
export type ImageClearItemDTOjsonldsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof ImageClearItemDTOjsonldsyliusshoparticleshow
>;

/* BaseButtonElementDTOjsonldsyliusshoparticleshow */

export const BaseButtonElementDTOjsonldsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    link: Schema.String,
    text: Schema.String,
    type: Schema.Literal('base_button').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'BaseButtonElementDTOjsonldsyliusshoparticleshow' });
export type BaseButtonElementDTOjsonldsyliusshoparticleshow = Schema.Schema.Type<
  typeof BaseButtonElementDTOjsonldsyliusshoparticleshow
>;
export type BaseButtonElementDTOjsonldsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof BaseButtonElementDTOjsonldsyliusshoparticleshow
>;

/* ProductListElementDTOjsonldsyliusshoparticleshow */

export const ProductListElementDTOjsonldsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    style: Schema.Literals(['withoutDescription', 'normal']),
    products: Schema.Array(Schema.String),
    productsPerPage: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    type: Schema.Literal('product_list').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductListElementDTOjsonldsyliusshoparticleshow' });
export type ProductListElementDTOjsonldsyliusshoparticleshow = Schema.Schema.Type<
  typeof ProductListElementDTOjsonldsyliusshoparticleshow
>;
export type ProductListElementDTOjsonldsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof ProductListElementDTOjsonldsyliusshoparticleshow
>;

/* TableCellItemDTOjsonldsyliusshoparticleshow */

export const TableCellItemDTOjsonldsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    content: Schema.String,
    color: Schema.Literals(['black', 'gray', 'white']),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TableCellItemDTOjsonldsyliusshoparticleshow' });
export type TableCellItemDTOjsonldsyliusshoparticleshow = Schema.Schema.Type<
  typeof TableCellItemDTOjsonldsyliusshoparticleshow
>;
export type TableCellItemDTOjsonldsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof TableCellItemDTOjsonldsyliusshoparticleshow
>;

/* Sectionjsonldsyliusshophomepageshow */

export const Sectionjsonldsyliusshophomepageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String,
    name: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Sectionjsonldsyliusshophomepageshow' });
export type Sectionjsonldsyliusshophomepageshow = Schema.Schema.Type<
  typeof Sectionjsonldsyliusshophomepageshow
>;
export type SectionjsonldsyliusshophomepageshowEncoded = Schema.Codec.Encoded<
  typeof Sectionjsonldsyliusshophomepageshow
>;

/* Tagjsonldsyliusshophomepageshow */

export const Tagjsonldsyliusshophomepageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    color: Schema.Union([Schema.String, Schema.Null]),
    name: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Tagjsonldsyliusshophomepageshow' });
export type Tagjsonldsyliusshophomepageshow = Schema.Schema.Type<
  typeof Tagjsonldsyliusshophomepageshow
>;
export type TagjsonldsyliusshophomepageshowEncoded = Schema.Codec.Encoded<
  typeof Tagjsonldsyliusshophomepageshow
>;

/* Authorjsonldsyliusshophomepageshow */

export const Authorjsonldsyliusshophomepageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    name: Schema.String,
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Authorjsonldsyliusshophomepageshow' });
export type Authorjsonldsyliusshophomepageshow = Schema.Schema.Type<
  typeof Authorjsonldsyliusshophomepageshow
>;
export type AuthorjsonldsyliusshophomepageshowEncoded = Schema.Codec.Encoded<
  typeof Authorjsonldsyliusshophomepageshow
>;

/* Authorsyliusshopauthorindex */

export const Authorsyliusshopauthorindex = Schema.StructWithRest(
  Schema.Struct({
    favourite: Schema.Boolean.annotate({ default: false }),
    name: Schema.String,
    image: Schema.Union([Schema.String, Schema.Null]),
    imageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    description: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    articlesCount: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Authorsyliusshopauthorindex' });
export type Authorsyliusshopauthorindex = Schema.Schema.Type<typeof Authorsyliusshopauthorindex>;
export type AuthorsyliusshopauthorindexEncoded = Schema.Codec.Encoded<
  typeof Authorsyliusshopauthorindex
>;

/* Authorsyliusshopauthorshow */

export const Authorsyliusshopauthorshow = Schema.StructWithRest(
  Schema.Struct({
    favourite: Schema.Boolean.annotate({ default: false }),
    name: Schema.String,
    image: Schema.Union([Schema.String, Schema.Null]),
    imageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    description: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    metaDescription: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Authorsyliusshopauthorshow' });
export type Authorsyliusshopauthorshow = Schema.Schema.Type<typeof Authorsyliusshopauthorshow>;
export type AuthorsyliusshopauthorshowEncoded = Schema.Codec.Encoded<
  typeof Authorsyliusshopauthorshow
>;

/* Authorjsonldsyliusshopauthorindex */

export const Authorjsonldsyliusshopauthorindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    favourite: Schema.Boolean.annotate({ default: false }),
    name: Schema.String,
    image: Schema.Union([Schema.String, Schema.Null]),
    imageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    description: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    articlesCount: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Authorjsonldsyliusshopauthorindex' });
export type Authorjsonldsyliusshopauthorindex = Schema.Schema.Type<
  typeof Authorjsonldsyliusshopauthorindex
>;
export type AuthorjsonldsyliusshopauthorindexEncoded = Schema.Codec.Encoded<
  typeof Authorjsonldsyliusshopauthorindex
>;

/* Authorjsonldsyliusshopauthorshow */

export const Authorjsonldsyliusshopauthorshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    favourite: Schema.Boolean.annotate({ default: false }),
    name: Schema.String,
    image: Schema.Union([Schema.String, Schema.Null]),
    imageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    description: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    metaDescription: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Authorjsonldsyliusshopauthorshow' });
export type Authorjsonldsyliusshopauthorshow = Schema.Schema.Type<
  typeof Authorjsonldsyliusshopauthorshow
>;
export type AuthorjsonldsyliusshopauthorshowEncoded = Schema.Codec.Encoded<
  typeof Authorjsonldsyliusshopauthorshow
>;

/* AvatarImagesyliusadminavatarimageshow */

export const AvatarImagesyliusadminavatarimageshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    path: Schema.String,
    owner: Schema.String.annotate({ format: 'iri-reference' }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'AvatarImagesyliusadminavatarimageshow' });
export type AvatarImagesyliusadminavatarimageshow = Schema.Schema.Type<
  typeof AvatarImagesyliusadminavatarimageshow
>;
export type AvatarImagesyliusadminavatarimageshowEncoded = Schema.Codec.Encoded<
  typeof AvatarImagesyliusadminavatarimageshow
>;

/* AvatarImagejsonldsyliusadminavatarimageshow */

export const AvatarImagejsonldsyliusadminavatarimageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    path: Schema.String,
    owner: Schema.String.annotate({ format: 'iri-reference' }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'AvatarImagejsonldsyliusadminavatarimageshow' });
export type AvatarImagejsonldsyliusadminavatarimageshow = Schema.Schema.Type<
  typeof AvatarImagejsonldsyliusadminavatarimageshow
>;
export type AvatarImagejsonldsyliusadminavatarimageshowEncoded = Schema.Codec.Encoded<
  typeof AvatarImagejsonldsyliusadminavatarimageshow
>;

/* BrandImagesyliusshopbrandshow */

export const BrandImagesyliusshopbrandshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'BrandImagesyliusshopbrandshow' });
export type BrandImagesyliusshopbrandshow = Schema.Schema.Type<
  typeof BrandImagesyliusshopbrandshow
>;
export type BrandImagesyliusshopbrandshowEncoded = Schema.Codec.Encoded<
  typeof BrandImagesyliusshopbrandshow
>;

/* BrandImagesyliusshopbrandshowdetail */

export const BrandImagesyliusshopbrandshowdetail = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'BrandImagesyliusshopbrandshowdetail' });
export type BrandImagesyliusshopbrandshowdetail = Schema.Schema.Type<
  typeof BrandImagesyliusshopbrandshowdetail
>;
export type BrandImagesyliusshopbrandshowdetailEncoded = Schema.Codec.Encoded<
  typeof BrandImagesyliusshopbrandshowdetail
>;

/* Brandsyliusshopcartshowsyliusshopcartshowdetail */

export const Brandsyliusshopcartshowsyliusshopcartshowdetail = Schema.StructWithRest(
  Schema.Struct({
    name: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Brandsyliusshopcartshowsyliusshopcartshowdetail' });
export type Brandsyliusshopcartshowsyliusshopcartshowdetail = Schema.Schema.Type<
  typeof Brandsyliusshopcartshowsyliusshopcartshowdetail
>;
export type BrandsyliusshopcartshowsyliusshopcartshowdetailEncoded = Schema.Codec.Encoded<
  typeof Brandsyliusshopcartshowsyliusshopcartshowdetail
>;

/* Brandsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const Brandsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      name: Schema.Union([Schema.String, Schema.Null]),
      routerUrl: Schema.String.annotate({
        description: 'Frontend router URL for this resource.',
        readOnly: true,
      }),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier: 'Brandsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type Brandsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<typeof Brandsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid>;
export type BrandsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof Brandsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* BrandImagesyliusshophomepageshow */

export const BrandImagesyliusshophomepageshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'BrandImagesyliusshophomepageshow' });
export type BrandImagesyliusshophomepageshow = Schema.Schema.Type<
  typeof BrandImagesyliusshophomepageshow
>;
export type BrandImagesyliusshophomepageshowEncoded = Schema.Codec.Encoded<
  typeof BrandImagesyliusshophomepageshow
>;

/* Brandsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const Brandsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      name: Schema.Union([Schema.String, Schema.Null]),
      routerUrl: Schema.String.annotate({
        description: 'Frontend router URL for this resource.',
        readOnly: true,
      }),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'Brandsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type Brandsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof Brandsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type BrandsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof Brandsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* BrandImagesyliusshopproductshowsyliusshopproductshowdetail */

export const BrandImagesyliusshopproductshowsyliusshopproductshowdetail = Schema.StructWithRest(
  Schema.Struct({
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'BrandImagesyliusshopproductshowsyliusshopproductshowdetail' });
export type BrandImagesyliusshopproductshowsyliusshopproductshowdetail = Schema.Schema.Type<
  typeof BrandImagesyliusshopproductshowsyliusshopproductshowdetail
>;
export type BrandImagesyliusshopproductshowsyliusshopproductshowdetailEncoded =
  Schema.Codec.Encoded<typeof BrandImagesyliusshopproductshowsyliusshopproductshowdetail>;

/* BrandImagejsonldsyliusshopbrandshow */

export const BrandImagejsonldsyliusshopbrandshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'BrandImagejsonldsyliusshopbrandshow' });
export type BrandImagejsonldsyliusshopbrandshow = Schema.Schema.Type<
  typeof BrandImagejsonldsyliusshopbrandshow
>;
export type BrandImagejsonldsyliusshopbrandshowEncoded = Schema.Codec.Encoded<
  typeof BrandImagejsonldsyliusshopbrandshow
>;

/* BrandImagejsonldsyliusshopbrandshowdetail */

export const BrandImagejsonldsyliusshopbrandshowdetail = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'BrandImagejsonldsyliusshopbrandshowdetail' });
export type BrandImagejsonldsyliusshopbrandshowdetail = Schema.Schema.Type<
  typeof BrandImagejsonldsyliusshopbrandshowdetail
>;
export type BrandImagejsonldsyliusshopbrandshowdetailEncoded = Schema.Codec.Encoded<
  typeof BrandImagejsonldsyliusshopbrandshowdetail
>;

/* Brandjsonldsyliusshopcartshowsyliusshopcartshowdetail */

export const Brandjsonldsyliusshopcartshowsyliusshopcartshowdetail = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    name: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Brandjsonldsyliusshopcartshowsyliusshopcartshowdetail' });
export type Brandjsonldsyliusshopcartshowsyliusshopcartshowdetail = Schema.Schema.Type<
  typeof Brandjsonldsyliusshopcartshowsyliusshopcartshowdetail
>;
export type BrandjsonldsyliusshopcartshowsyliusshopcartshowdetailEncoded = Schema.Codec.Encoded<
  typeof Brandjsonldsyliusshopcartshowsyliusshopcartshowdetail
>;

/* Brandjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const Brandjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      name: Schema.Union([Schema.String, Schema.Null]),
      routerUrl: Schema.String.annotate({
        description: 'Frontend router URL for this resource.',
        readOnly: true,
      }),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier: 'Brandjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type Brandjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof Brandjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type BrandjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof Brandjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* BrandImagejsonldsyliusshophomepageshow */

export const BrandImagejsonldsyliusshophomepageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'BrandImagejsonldsyliusshophomepageshow' });
export type BrandImagejsonldsyliusshophomepageshow = Schema.Schema.Type<
  typeof BrandImagejsonldsyliusshophomepageshow
>;
export type BrandImagejsonldsyliusshophomepageshowEncoded = Schema.Codec.Encoded<
  typeof BrandImagejsonldsyliusshophomepageshow
>;

/* Brandjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const Brandjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      name: Schema.Union([Schema.String, Schema.Null]),
      routerUrl: Schema.String.annotate({
        description: 'Frontend router URL for this resource.',
        readOnly: true,
      }),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'Brandjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type Brandjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof Brandjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type BrandjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof Brandjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* BrandImagejsonldsyliusshopproductshowsyliusshopproductshowdetail */

export const BrandImagejsonldsyliusshopproductshowsyliusshopproductshowdetail =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      pathAbstract: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({ identifier: 'BrandImagejsonldsyliusshopproductshowsyliusshopproductshowdetail' });
export type BrandImagejsonldsyliusshopproductshowsyliusshopproductshowdetail = Schema.Schema.Type<
  typeof BrandImagejsonldsyliusshopproductshowsyliusshopproductshowdetail
>;
export type BrandImagejsonldsyliusshopproductshowsyliusshopproductshowdetailEncoded =
  Schema.Codec.Encoded<typeof BrandImagejsonldsyliusshopproductshowsyliusshopproductshowdetail>;

/* BrandAlphabetshopbrandshowalphabet */

export const BrandAlphabetshopbrandshowalphabet = Schema.StructWithRest(
  Schema.Struct({ alphabet: Schema.Array(Schema.String) }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'BrandAlphabetshopbrandshowalphabet' });
export type BrandAlphabetshopbrandshowalphabet = Schema.Schema.Type<
  typeof BrandAlphabetshopbrandshowalphabet
>;
export type BrandAlphabetshopbrandshowalphabetEncoded = Schema.Codec.Encoded<
  typeof BrandAlphabetshopbrandshowalphabet
>;

/* BrandAlphabetjsonldshopbrandshowalphabet */

export const BrandAlphabetjsonldshopbrandshowalphabet = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    alphabet: Schema.Array(Schema.String),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'BrandAlphabetjsonldshopbrandshowalphabet' });
export type BrandAlphabetjsonldshopbrandshowalphabet = Schema.Schema.Type<
  typeof BrandAlphabetjsonldshopbrandshowalphabet
>;
export type BrandAlphabetjsonldshopbrandshowalphabetEncoded = Schema.Codec.Encoded<
  typeof BrandAlphabetjsonldshopbrandshowalphabet
>;

/* ShippingDiscountRuleHintsyliusshopcartshow */

export const ShippingDiscountRuleHintsyliusshopcartshow = Schema.StructWithRest(
  Schema.Struct({
    itemThresholdTotal: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    missingItemTotal: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    percentageDiscountAmount: Schema.Number.check(
      Schema.isFinite().annotate({ expected: 'a finite number' })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingDiscountRuleHintsyliusshopcartshow' });
export type ShippingDiscountRuleHintsyliusshopcartshow = Schema.Schema.Type<
  typeof ShippingDiscountRuleHintsyliusshopcartshow
>;
export type ShippingDiscountRuleHintsyliusshopcartshowEncoded = Schema.Codec.Encoded<
  typeof ShippingDiscountRuleHintsyliusshopcartshow
>;

/* ShippingDiscountRuleHintsyliusshopcartshowsyliusshopcartshowdetail */

export const ShippingDiscountRuleHintsyliusshopcartshowsyliusshopcartshowdetail =
  Schema.StructWithRest(
    Schema.Struct({
      itemThresholdTotal: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      missingItemTotal: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      percentageDiscountAmount: Schema.Number.check(
        Schema.isFinite().annotate({ expected: 'a finite number' })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({ identifier: 'ShippingDiscountRuleHintsyliusshopcartshowsyliusshopcartshowdetail' });
export type ShippingDiscountRuleHintsyliusshopcartshowsyliusshopcartshowdetail = Schema.Schema.Type<
  typeof ShippingDiscountRuleHintsyliusshopcartshowsyliusshopcartshowdetail
>;
export type ShippingDiscountRuleHintsyliusshopcartshowsyliusshopcartshowdetailEncoded =
  Schema.Codec.Encoded<typeof ShippingDiscountRuleHintsyliusshopcartshowsyliusshopcartshowdetail>;

/* ShippingDiscountRuleHintsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const ShippingDiscountRuleHintsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      itemThresholdTotal: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      missingItemTotal: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      percentageDiscountAmount: Schema.Number.check(
        Schema.isFinite().annotate({ expected: 'a finite number' })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'ShippingDiscountRuleHintsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type ShippingDiscountRuleHintsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof ShippingDiscountRuleHintsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type ShippingDiscountRuleHintsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof ShippingDiscountRuleHintsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* ShippingDiscountRuleHintsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const ShippingDiscountRuleHintsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      itemThresholdTotal: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      missingItemTotal: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      percentageDiscountAmount: Schema.Number.check(
        Schema.isFinite().annotate({ expected: 'a finite number' })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'ShippingDiscountRuleHintsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type ShippingDiscountRuleHintsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof ShippingDiscountRuleHintsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type ShippingDiscountRuleHintsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof ShippingDiscountRuleHintsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* ShippingDiscountRuleHintjsonldsyliusshopcartshow */

export const ShippingDiscountRuleHintjsonldsyliusshopcartshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    itemThresholdTotal: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    missingItemTotal: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    percentageDiscountAmount: Schema.Number.check(
      Schema.isFinite().annotate({ expected: 'a finite number' })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingDiscountRuleHintjsonldsyliusshopcartshow' });
export type ShippingDiscountRuleHintjsonldsyliusshopcartshow = Schema.Schema.Type<
  typeof ShippingDiscountRuleHintjsonldsyliusshopcartshow
>;
export type ShippingDiscountRuleHintjsonldsyliusshopcartshowEncoded = Schema.Codec.Encoded<
  typeof ShippingDiscountRuleHintjsonldsyliusshopcartshow
>;

/* ShippingDiscountRuleHintjsonldsyliusshopcartshowsyliusshopcartshowdetail */

export const ShippingDiscountRuleHintjsonldsyliusshopcartshowsyliusshopcartshowdetail =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      itemThresholdTotal: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      missingItemTotal: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      percentageDiscountAmount: Schema.Number.check(
        Schema.isFinite().annotate({ expected: 'a finite number' })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier: 'ShippingDiscountRuleHintjsonldsyliusshopcartshowsyliusshopcartshowdetail',
  });
export type ShippingDiscountRuleHintjsonldsyliusshopcartshowsyliusshopcartshowdetail =
  Schema.Schema.Type<
    typeof ShippingDiscountRuleHintjsonldsyliusshopcartshowsyliusshopcartshowdetail
  >;
export type ShippingDiscountRuleHintjsonldsyliusshopcartshowsyliusshopcartshowdetailEncoded =
  Schema.Codec.Encoded<
    typeof ShippingDiscountRuleHintjsonldsyliusshopcartshowsyliusshopcartshowdetail
  >;

/* ShippingDiscountRuleHintjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const ShippingDiscountRuleHintjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      itemThresholdTotal: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      missingItemTotal: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      percentageDiscountAmount: Schema.Number.check(
        Schema.isFinite().annotate({ expected: 'a finite number' })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'ShippingDiscountRuleHintjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type ShippingDiscountRuleHintjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof ShippingDiscountRuleHintjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type ShippingDiscountRuleHintjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof ShippingDiscountRuleHintjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* ShippingDiscountRuleHintjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const ShippingDiscountRuleHintjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      itemThresholdTotal: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      missingItemTotal: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      percentageDiscountAmount: Schema.Number.check(
        Schema.isFinite().annotate({ expected: 'a finite number' })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'ShippingDiscountRuleHintjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type ShippingDiscountRuleHintjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof ShippingDiscountRuleHintjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type ShippingDiscountRuleHintjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof ShippingDiscountRuleHintjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* CatalogPromotionScope */

export const CatalogPromotionScope = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.String,
    configuration: Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
    catalogPromotion: Schema.Union([Schema.String, Schema.Null]).annotate({
      format: 'iri-reference',
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CatalogPromotionScope' });
export type CatalogPromotionScope = Schema.Schema.Type<typeof CatalogPromotionScope>;
export type CatalogPromotionScopeEncoded = Schema.Codec.Encoded<typeof CatalogPromotionScope>;

/* CatalogPromotionAction */

export const CatalogPromotionAction = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.String,
    configuration: Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
    catalogPromotion: Schema.Union([Schema.String, Schema.Null]).annotate({
      format: 'iri-reference',
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CatalogPromotionAction' });
export type CatalogPromotionAction = Schema.Schema.Type<typeof CatalogPromotionAction>;
export type CatalogPromotionActionEncoded = Schema.Codec.Encoded<typeof CatalogPromotionAction>;

/* CatalogPromotionScopesyliusadmincatalogpromotioncreate */

export const CatalogPromotionScopesyliusadmincatalogpromotioncreate = Schema.StructWithRest(
  Schema.Struct({
    type: Schema.String,
    configuration: Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CatalogPromotionScopesyliusadmincatalogpromotioncreate' });
export type CatalogPromotionScopesyliusadmincatalogpromotioncreate = Schema.Schema.Type<
  typeof CatalogPromotionScopesyliusadmincatalogpromotioncreate
>;
export type CatalogPromotionScopesyliusadmincatalogpromotioncreateEncoded = Schema.Codec.Encoded<
  typeof CatalogPromotionScopesyliusadmincatalogpromotioncreate
>;

/* CatalogPromotionActionsyliusadmincatalogpromotioncreate */

export const CatalogPromotionActionsyliusadmincatalogpromotioncreate = Schema.StructWithRest(
  Schema.Struct({
    type: Schema.String,
    configuration: Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CatalogPromotionActionsyliusadmincatalogpromotioncreate' });
export type CatalogPromotionActionsyliusadmincatalogpromotioncreate = Schema.Schema.Type<
  typeof CatalogPromotionActionsyliusadmincatalogpromotioncreate
>;
export type CatalogPromotionActionsyliusadmincatalogpromotioncreateEncoded = Schema.Codec.Encoded<
  typeof CatalogPromotionActionsyliusadmincatalogpromotioncreate
>;

/* CatalogPromotionScopesyliusadmincatalogpromotionindex */

export const CatalogPromotionScopesyliusadmincatalogpromotionindex = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.String,
    configuration: Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CatalogPromotionScopesyliusadmincatalogpromotionindex' });
export type CatalogPromotionScopesyliusadmincatalogpromotionindex = Schema.Schema.Type<
  typeof CatalogPromotionScopesyliusadmincatalogpromotionindex
>;
export type CatalogPromotionScopesyliusadmincatalogpromotionindexEncoded = Schema.Codec.Encoded<
  typeof CatalogPromotionScopesyliusadmincatalogpromotionindex
>;

/* CatalogPromotionActionsyliusadmincatalogpromotionindex */

export const CatalogPromotionActionsyliusadmincatalogpromotionindex = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.String,
    configuration: Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CatalogPromotionActionsyliusadmincatalogpromotionindex' });
export type CatalogPromotionActionsyliusadmincatalogpromotionindex = Schema.Schema.Type<
  typeof CatalogPromotionActionsyliusadmincatalogpromotionindex
>;
export type CatalogPromotionActionsyliusadmincatalogpromotionindexEncoded = Schema.Codec.Encoded<
  typeof CatalogPromotionActionsyliusadmincatalogpromotionindex
>;

/* CatalogPromotionScopesyliusadmincatalogpromotionshow */

export const CatalogPromotionScopesyliusadmincatalogpromotionshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.String,
    configuration: Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CatalogPromotionScopesyliusadmincatalogpromotionshow' });
export type CatalogPromotionScopesyliusadmincatalogpromotionshow = Schema.Schema.Type<
  typeof CatalogPromotionScopesyliusadmincatalogpromotionshow
>;
export type CatalogPromotionScopesyliusadmincatalogpromotionshowEncoded = Schema.Codec.Encoded<
  typeof CatalogPromotionScopesyliusadmincatalogpromotionshow
>;

/* CatalogPromotionActionsyliusadmincatalogpromotionshow */

export const CatalogPromotionActionsyliusadmincatalogpromotionshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.String,
    configuration: Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CatalogPromotionActionsyliusadmincatalogpromotionshow' });
export type CatalogPromotionActionsyliusadmincatalogpromotionshow = Schema.Schema.Type<
  typeof CatalogPromotionActionsyliusadmincatalogpromotionshow
>;
export type CatalogPromotionActionsyliusadmincatalogpromotionshowEncoded = Schema.Codec.Encoded<
  typeof CatalogPromotionActionsyliusadmincatalogpromotionshow
>;

/* CatalogPromotionScopesyliusadmincatalogpromotionupdate */

export const CatalogPromotionScopesyliusadmincatalogpromotionupdate = Schema.StructWithRest(
  Schema.Struct({
    type: Schema.String,
    configuration: Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CatalogPromotionScopesyliusadmincatalogpromotionupdate' });
export type CatalogPromotionScopesyliusadmincatalogpromotionupdate = Schema.Schema.Type<
  typeof CatalogPromotionScopesyliusadmincatalogpromotionupdate
>;
export type CatalogPromotionScopesyliusadmincatalogpromotionupdateEncoded = Schema.Codec.Encoded<
  typeof CatalogPromotionScopesyliusadmincatalogpromotionupdate
>;

/* CatalogPromotionActionsyliusadmincatalogpromotionupdate */

export const CatalogPromotionActionsyliusadmincatalogpromotionupdate = Schema.StructWithRest(
  Schema.Struct({
    type: Schema.String,
    configuration: Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CatalogPromotionActionsyliusadmincatalogpromotionupdate' });
export type CatalogPromotionActionsyliusadmincatalogpromotionupdate = Schema.Schema.Type<
  typeof CatalogPromotionActionsyliusadmincatalogpromotionupdate
>;
export type CatalogPromotionActionsyliusadmincatalogpromotionupdateEncoded = Schema.Codec.Encoded<
  typeof CatalogPromotionActionsyliusadmincatalogpromotionupdate
>;

/* CatalogPromotionsyliusshopcatalogpromotionshow */

export const CatalogPromotionsyliusshopcatalogpromotionshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    label: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CatalogPromotionsyliusshopcatalogpromotionshow' });
export type CatalogPromotionsyliusshopcatalogpromotionshow = Schema.Schema.Type<
  typeof CatalogPromotionsyliusshopcatalogpromotionshow
>;
export type CatalogPromotionsyliusshopcatalogpromotionshowEncoded = Schema.Codec.Encoded<
  typeof CatalogPromotionsyliusshopcatalogpromotionshow
>;

/* CatalogPromotionScopejsonld */

export const CatalogPromotionScopejsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.String,
    configuration: Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
    catalogPromotion: Schema.Union([Schema.String, Schema.Null]).annotate({
      format: 'iri-reference',
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CatalogPromotionScopejsonld' });
export type CatalogPromotionScopejsonld = Schema.Schema.Type<typeof CatalogPromotionScopejsonld>;
export type CatalogPromotionScopejsonldEncoded = Schema.Codec.Encoded<
  typeof CatalogPromotionScopejsonld
>;

/* CatalogPromotionActionjsonld */

export const CatalogPromotionActionjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.String,
    configuration: Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
    catalogPromotion: Schema.Union([Schema.String, Schema.Null]).annotate({
      format: 'iri-reference',
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CatalogPromotionActionjsonld' });
export type CatalogPromotionActionjsonld = Schema.Schema.Type<typeof CatalogPromotionActionjsonld>;
export type CatalogPromotionActionjsonldEncoded = Schema.Codec.Encoded<
  typeof CatalogPromotionActionjsonld
>;

/* CatalogPromotionScopejsonldsyliusadmincatalogpromotioncreate */

export const CatalogPromotionScopejsonldsyliusadmincatalogpromotioncreate = Schema.StructWithRest(
  Schema.Struct({
    type: Schema.String,
    configuration: Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CatalogPromotionScopejsonldsyliusadmincatalogpromotioncreate' });
export type CatalogPromotionScopejsonldsyliusadmincatalogpromotioncreate = Schema.Schema.Type<
  typeof CatalogPromotionScopejsonldsyliusadmincatalogpromotioncreate
>;
export type CatalogPromotionScopejsonldsyliusadmincatalogpromotioncreateEncoded =
  Schema.Codec.Encoded<typeof CatalogPromotionScopejsonldsyliusadmincatalogpromotioncreate>;

/* CatalogPromotionActionjsonldsyliusadmincatalogpromotioncreate */

export const CatalogPromotionActionjsonldsyliusadmincatalogpromotioncreate = Schema.StructWithRest(
  Schema.Struct({
    type: Schema.String,
    configuration: Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CatalogPromotionActionjsonldsyliusadmincatalogpromotioncreate' });
export type CatalogPromotionActionjsonldsyliusadmincatalogpromotioncreate = Schema.Schema.Type<
  typeof CatalogPromotionActionjsonldsyliusadmincatalogpromotioncreate
>;
export type CatalogPromotionActionjsonldsyliusadmincatalogpromotioncreateEncoded =
  Schema.Codec.Encoded<typeof CatalogPromotionActionjsonldsyliusadmincatalogpromotioncreate>;

/* CatalogPromotionScopejsonldsyliusadmincatalogpromotionindex */

export const CatalogPromotionScopejsonldsyliusadmincatalogpromotionindex = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.String,
    configuration: Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CatalogPromotionScopejsonldsyliusadmincatalogpromotionindex' });
export type CatalogPromotionScopejsonldsyliusadmincatalogpromotionindex = Schema.Schema.Type<
  typeof CatalogPromotionScopejsonldsyliusadmincatalogpromotionindex
>;
export type CatalogPromotionScopejsonldsyliusadmincatalogpromotionindexEncoded =
  Schema.Codec.Encoded<typeof CatalogPromotionScopejsonldsyliusadmincatalogpromotionindex>;

/* CatalogPromotionActionjsonldsyliusadmincatalogpromotionindex */

export const CatalogPromotionActionjsonldsyliusadmincatalogpromotionindex = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.String,
    configuration: Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CatalogPromotionActionjsonldsyliusadmincatalogpromotionindex' });
export type CatalogPromotionActionjsonldsyliusadmincatalogpromotionindex = Schema.Schema.Type<
  typeof CatalogPromotionActionjsonldsyliusadmincatalogpromotionindex
>;
export type CatalogPromotionActionjsonldsyliusadmincatalogpromotionindexEncoded =
  Schema.Codec.Encoded<typeof CatalogPromotionActionjsonldsyliusadmincatalogpromotionindex>;

/* CatalogPromotionScopejsonldsyliusadmincatalogpromotionshow */

export const CatalogPromotionScopejsonldsyliusadmincatalogpromotionshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.String,
    configuration: Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CatalogPromotionScopejsonldsyliusadmincatalogpromotionshow' });
export type CatalogPromotionScopejsonldsyliusadmincatalogpromotionshow = Schema.Schema.Type<
  typeof CatalogPromotionScopejsonldsyliusadmincatalogpromotionshow
>;
export type CatalogPromotionScopejsonldsyliusadmincatalogpromotionshowEncoded =
  Schema.Codec.Encoded<typeof CatalogPromotionScopejsonldsyliusadmincatalogpromotionshow>;

/* CatalogPromotionActionjsonldsyliusadmincatalogpromotionshow */

export const CatalogPromotionActionjsonldsyliusadmincatalogpromotionshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.String,
    configuration: Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CatalogPromotionActionjsonldsyliusadmincatalogpromotionshow' });
export type CatalogPromotionActionjsonldsyliusadmincatalogpromotionshow = Schema.Schema.Type<
  typeof CatalogPromotionActionjsonldsyliusadmincatalogpromotionshow
>;
export type CatalogPromotionActionjsonldsyliusadmincatalogpromotionshowEncoded =
  Schema.Codec.Encoded<typeof CatalogPromotionActionjsonldsyliusadmincatalogpromotionshow>;

/* CatalogPromotionScopejsonldsyliusadmincatalogpromotionupdate */

export const CatalogPromotionScopejsonldsyliusadmincatalogpromotionupdate = Schema.StructWithRest(
  Schema.Struct({
    type: Schema.String,
    configuration: Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CatalogPromotionScopejsonldsyliusadmincatalogpromotionupdate' });
export type CatalogPromotionScopejsonldsyliusadmincatalogpromotionupdate = Schema.Schema.Type<
  typeof CatalogPromotionScopejsonldsyliusadmincatalogpromotionupdate
>;
export type CatalogPromotionScopejsonldsyliusadmincatalogpromotionupdateEncoded =
  Schema.Codec.Encoded<typeof CatalogPromotionScopejsonldsyliusadmincatalogpromotionupdate>;

/* CatalogPromotionActionjsonldsyliusadmincatalogpromotionupdate */

export const CatalogPromotionActionjsonldsyliusadmincatalogpromotionupdate = Schema.StructWithRest(
  Schema.Struct({
    type: Schema.String,
    configuration: Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CatalogPromotionActionjsonldsyliusadmincatalogpromotionupdate' });
export type CatalogPromotionActionjsonldsyliusadmincatalogpromotionupdate = Schema.Schema.Type<
  typeof CatalogPromotionActionjsonldsyliusadmincatalogpromotionupdate
>;
export type CatalogPromotionActionjsonldsyliusadmincatalogpromotionupdateEncoded =
  Schema.Codec.Encoded<typeof CatalogPromotionActionjsonldsyliusadmincatalogpromotionupdate>;

/* CatalogPromotionjsonldsyliusshopcatalogpromotionshow */

export const CatalogPromotionjsonldsyliusshopcatalogpromotionshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    label: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CatalogPromotionjsonldsyliusshopcatalogpromotionshow' });
export type CatalogPromotionjsonldsyliusshopcatalogpromotionshow = Schema.Schema.Type<
  typeof CatalogPromotionjsonldsyliusshopcatalogpromotionshow
>;
export type CatalogPromotionjsonldsyliusshopcatalogpromotionshowEncoded = Schema.Codec.Encoded<
  typeof CatalogPromotionjsonldsyliusshopcatalogpromotionshow
>;

/* CategoryImagesyliusshopcategoryindex */

export const CategoryImagesyliusshopcategoryindex = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CategoryImagesyliusshopcategoryindex' });
export type CategoryImagesyliusshopcategoryindex = Schema.Schema.Type<
  typeof CategoryImagesyliusshopcategoryindex
>;
export type CategoryImagesyliusshopcategoryindexEncoded = Schema.Codec.Encoded<
  typeof CategoryImagesyliusshopcategoryindex
>;

/* CategoryImagejsonldsyliusshopcategoryindex */

export const CategoryImagejsonldsyliusshopcategoryindex = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CategoryImagejsonldsyliusshopcategoryindex' });
export type CategoryImagejsonldsyliusshopcategoryindex = Schema.Schema.Type<
  typeof CategoryImagejsonldsyliusshopcategoryindex
>;
export type CategoryImagejsonldsyliusshopcategoryindexEncoded = Schema.Codec.Encoded<
  typeof CategoryImagejsonldsyliusshopcategoryindex
>;

/* Channelroutershow */

export const Channelroutershow = Schema.StructWithRest(
  Schema.Struct({ code: Schema.String, hostname: Schema.Union([Schema.String, Schema.Null]) }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Channelroutershow' });
export type Channelroutershow = Schema.Schema.Type<typeof Channelroutershow>;
export type ChannelroutershowEncoded = Schema.Codec.Encoded<typeof Channelroutershow>;

/* ShopBillingDatasyliusadminchannelcreatenoid */

export const ShopBillingDatasyliusadminchannelcreatenoid = Schema.StructWithRest(
  Schema.Struct({
    company: Schema.Union([Schema.String, Schema.Null]),
    taxId: Schema.Union([Schema.String, Schema.Null]),
    countryCode: Schema.Union([Schema.String, Schema.Null]),
    street: Schema.Union([Schema.String, Schema.Null]),
    city: Schema.Union([Schema.String, Schema.Null]),
    postcode: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShopBillingDatasyliusadminchannelcreatenoid' });
export type ShopBillingDatasyliusadminchannelcreatenoid = Schema.Schema.Type<
  typeof ShopBillingDatasyliusadminchannelcreatenoid
>;
export type ShopBillingDatasyliusadminchannelcreatenoidEncoded = Schema.Codec.Encoded<
  typeof ShopBillingDatasyliusadminchannelcreatenoid
>;

/* Taxonsyliusadminchannelcreatenoid */

export const Taxonsyliusadminchannelcreatenoid = Schema.StructWithRest(
  Schema.Struct({
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonsyliusadminchannelcreatenoid' });
export type Taxonsyliusadminchannelcreatenoid = Schema.Schema.Type<
  typeof Taxonsyliusadminchannelcreatenoid
>;
export type TaxonsyliusadminchannelcreatenoidEncoded = Schema.Codec.Encoded<
  typeof Taxonsyliusadminchannelcreatenoid
>;

/* ShopBillingDatasyliusadminchannelindexnoid */

export const ShopBillingDatasyliusadminchannelindexnoid = Schema.StructWithRest(
  Schema.Struct({
    company: Schema.Union([Schema.String, Schema.Null]),
    taxId: Schema.Union([Schema.String, Schema.Null]),
    countryCode: Schema.Union([Schema.String, Schema.Null]),
    street: Schema.Union([Schema.String, Schema.Null]),
    city: Schema.Union([Schema.String, Schema.Null]),
    postcode: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShopBillingDatasyliusadminchannelindexnoid' });
export type ShopBillingDatasyliusadminchannelindexnoid = Schema.Schema.Type<
  typeof ShopBillingDatasyliusadminchannelindexnoid
>;
export type ShopBillingDatasyliusadminchannelindexnoidEncoded = Schema.Codec.Encoded<
  typeof ShopBillingDatasyliusadminchannelindexnoid
>;

/* Taxonsyliusadminchannelindexnoid */

export const Taxonsyliusadminchannelindexnoid = Schema.StructWithRest(
  Schema.Struct({
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonsyliusadminchannelindexnoid' });
export type Taxonsyliusadminchannelindexnoid = Schema.Schema.Type<
  typeof Taxonsyliusadminchannelindexnoid
>;
export type TaxonsyliusadminchannelindexnoidEncoded = Schema.Codec.Encoded<
  typeof Taxonsyliusadminchannelindexnoid
>;

/* ShopBillingDatasyliusadminchannelshownoid */

export const ShopBillingDatasyliusadminchannelshownoid = Schema.StructWithRest(
  Schema.Struct({
    company: Schema.Union([Schema.String, Schema.Null]),
    taxId: Schema.Union([Schema.String, Schema.Null]),
    countryCode: Schema.Union([Schema.String, Schema.Null]),
    street: Schema.Union([Schema.String, Schema.Null]),
    city: Schema.Union([Schema.String, Schema.Null]),
    postcode: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShopBillingDatasyliusadminchannelshownoid' });
export type ShopBillingDatasyliusadminchannelshownoid = Schema.Schema.Type<
  typeof ShopBillingDatasyliusadminchannelshownoid
>;
export type ShopBillingDatasyliusadminchannelshownoidEncoded = Schema.Codec.Encoded<
  typeof ShopBillingDatasyliusadminchannelshownoid
>;

/* Taxonsyliusadminchannelshownoid */

export const Taxonsyliusadminchannelshownoid = Schema.StructWithRest(
  Schema.Struct({
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonsyliusadminchannelshownoid' });
export type Taxonsyliusadminchannelshownoid = Schema.Schema.Type<
  typeof Taxonsyliusadminchannelshownoid
>;
export type TaxonsyliusadminchannelshownoidEncoded = Schema.Codec.Encoded<
  typeof Taxonsyliusadminchannelshownoid
>;

/* ShopBillingDatasyliusadminchannelupdatenoid */

export const ShopBillingDatasyliusadminchannelupdatenoid = Schema.StructWithRest(
  Schema.Struct({
    company: Schema.Union([Schema.String, Schema.Null]),
    taxId: Schema.Union([Schema.String, Schema.Null]),
    countryCode: Schema.Union([Schema.String, Schema.Null]),
    street: Schema.Union([Schema.String, Schema.Null]),
    city: Schema.Union([Schema.String, Schema.Null]),
    postcode: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShopBillingDatasyliusadminchannelupdatenoid' });
export type ShopBillingDatasyliusadminchannelupdatenoid = Schema.Schema.Type<
  typeof ShopBillingDatasyliusadminchannelupdatenoid
>;
export type ShopBillingDatasyliusadminchannelupdatenoidEncoded = Schema.Codec.Encoded<
  typeof ShopBillingDatasyliusadminchannelupdatenoid
>;

/* Taxonsyliusadminchannelupdatenoid */

export const Taxonsyliusadminchannelupdatenoid = Schema.StructWithRest(
  Schema.Struct({
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonsyliusadminchannelupdatenoid' });
export type Taxonsyliusadminchannelupdatenoid = Schema.Schema.Type<
  typeof Taxonsyliusadminchannelupdatenoid
>;
export type TaxonsyliusadminchannelupdatenoidEncoded = Schema.Codec.Encoded<
  typeof Taxonsyliusadminchannelupdatenoid
>;

/* Channelsyliusshopchannelindex */

export const Channelsyliusshopchannelindex = Schema.StructWithRest(
  Schema.Struct({
    baseCurrency: Schema.String.annotate({ format: 'iri-reference' }),
    defaultLocale: Schema.String.annotate({ format: 'iri-reference' }),
    currencies: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    locales: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    code: Schema.String,
    name: Schema.String,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Channelsyliusshopchannelindex' });
export type Channelsyliusshopchannelindex = Schema.Schema.Type<
  typeof Channelsyliusshopchannelindex
>;
export type ChannelsyliusshopchannelindexEncoded = Schema.Codec.Encoded<
  typeof Channelsyliusshopchannelindex
>;

/* Channelsyliusshopchannelshow */

export const Channelsyliusshopchannelshow = Schema.StructWithRest(
  Schema.Struct({
    baseCurrency: Schema.String.annotate({ format: 'iri-reference' }),
    defaultLocale: Schema.String.annotate({ format: 'iri-reference' }),
    currencies: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    locales: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    code: Schema.String,
    name: Schema.String,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Channelsyliusshopchannelshow' });
export type Channelsyliusshopchannelshow = Schema.Schema.Type<typeof Channelsyliusshopchannelshow>;
export type ChannelsyliusshopchannelshowEncoded = Schema.Codec.Encoded<
  typeof Channelsyliusshopchannelshow
>;

/* Channeljsonldroutershow */

export const Channeljsonldroutershow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String,
    hostname: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Channeljsonldroutershow' });
export type Channeljsonldroutershow = Schema.Schema.Type<typeof Channeljsonldroutershow>;
export type ChanneljsonldroutershowEncoded = Schema.Codec.Encoded<typeof Channeljsonldroutershow>;

/* ShopBillingDatajsonldsyliusadminchannelcreatenoid */

export const ShopBillingDatajsonldsyliusadminchannelcreatenoid = Schema.StructWithRest(
  Schema.Struct({
    company: Schema.Union([Schema.String, Schema.Null]),
    taxId: Schema.Union([Schema.String, Schema.Null]),
    countryCode: Schema.Union([Schema.String, Schema.Null]),
    street: Schema.Union([Schema.String, Schema.Null]),
    city: Schema.Union([Schema.String, Schema.Null]),
    postcode: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShopBillingDatajsonldsyliusadminchannelcreatenoid' });
export type ShopBillingDatajsonldsyliusadminchannelcreatenoid = Schema.Schema.Type<
  typeof ShopBillingDatajsonldsyliusadminchannelcreatenoid
>;
export type ShopBillingDatajsonldsyliusadminchannelcreatenoidEncoded = Schema.Codec.Encoded<
  typeof ShopBillingDatajsonldsyliusadminchannelcreatenoid
>;

/* Taxonjsonldsyliusadminchannelcreatenoid */

export const Taxonjsonldsyliusadminchannelcreatenoid = Schema.StructWithRest(
  Schema.Struct({
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonjsonldsyliusadminchannelcreatenoid' });
export type Taxonjsonldsyliusadminchannelcreatenoid = Schema.Schema.Type<
  typeof Taxonjsonldsyliusadminchannelcreatenoid
>;
export type TaxonjsonldsyliusadminchannelcreatenoidEncoded = Schema.Codec.Encoded<
  typeof Taxonjsonldsyliusadminchannelcreatenoid
>;

/* ShopBillingDatajsonldsyliusadminchannelindexnoid */

export const ShopBillingDatajsonldsyliusadminchannelindexnoid = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    company: Schema.Union([Schema.String, Schema.Null]),
    taxId: Schema.Union([Schema.String, Schema.Null]),
    countryCode: Schema.Union([Schema.String, Schema.Null]),
    street: Schema.Union([Schema.String, Schema.Null]),
    city: Schema.Union([Schema.String, Schema.Null]),
    postcode: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShopBillingDatajsonldsyliusadminchannelindexnoid' });
export type ShopBillingDatajsonldsyliusadminchannelindexnoid = Schema.Schema.Type<
  typeof ShopBillingDatajsonldsyliusadminchannelindexnoid
>;
export type ShopBillingDatajsonldsyliusadminchannelindexnoidEncoded = Schema.Codec.Encoded<
  typeof ShopBillingDatajsonldsyliusadminchannelindexnoid
>;

/* Taxonjsonldsyliusadminchannelindexnoid */

export const Taxonjsonldsyliusadminchannelindexnoid = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonjsonldsyliusadminchannelindexnoid' });
export type Taxonjsonldsyliusadminchannelindexnoid = Schema.Schema.Type<
  typeof Taxonjsonldsyliusadminchannelindexnoid
>;
export type TaxonjsonldsyliusadminchannelindexnoidEncoded = Schema.Codec.Encoded<
  typeof Taxonjsonldsyliusadminchannelindexnoid
>;

/* ShopBillingDatajsonldsyliusadminchannelshownoid */

export const ShopBillingDatajsonldsyliusadminchannelshownoid = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    company: Schema.Union([Schema.String, Schema.Null]),
    taxId: Schema.Union([Schema.String, Schema.Null]),
    countryCode: Schema.Union([Schema.String, Schema.Null]),
    street: Schema.Union([Schema.String, Schema.Null]),
    city: Schema.Union([Schema.String, Schema.Null]),
    postcode: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShopBillingDatajsonldsyliusadminchannelshownoid' });
export type ShopBillingDatajsonldsyliusadminchannelshownoid = Schema.Schema.Type<
  typeof ShopBillingDatajsonldsyliusadminchannelshownoid
>;
export type ShopBillingDatajsonldsyliusadminchannelshownoidEncoded = Schema.Codec.Encoded<
  typeof ShopBillingDatajsonldsyliusadminchannelshownoid
>;

/* Taxonjsonldsyliusadminchannelshownoid */

export const Taxonjsonldsyliusadminchannelshownoid = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonjsonldsyliusadminchannelshownoid' });
export type Taxonjsonldsyliusadminchannelshownoid = Schema.Schema.Type<
  typeof Taxonjsonldsyliusadminchannelshownoid
>;
export type TaxonjsonldsyliusadminchannelshownoidEncoded = Schema.Codec.Encoded<
  typeof Taxonjsonldsyliusadminchannelshownoid
>;

/* ShopBillingDatajsonldsyliusadminchannelupdatenoid */

export const ShopBillingDatajsonldsyliusadminchannelupdatenoid = Schema.StructWithRest(
  Schema.Struct({
    company: Schema.Union([Schema.String, Schema.Null]),
    taxId: Schema.Union([Schema.String, Schema.Null]),
    countryCode: Schema.Union([Schema.String, Schema.Null]),
    street: Schema.Union([Schema.String, Schema.Null]),
    city: Schema.Union([Schema.String, Schema.Null]),
    postcode: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShopBillingDatajsonldsyliusadminchannelupdatenoid' });
export type ShopBillingDatajsonldsyliusadminchannelupdatenoid = Schema.Schema.Type<
  typeof ShopBillingDatajsonldsyliusadminchannelupdatenoid
>;
export type ShopBillingDatajsonldsyliusadminchannelupdatenoidEncoded = Schema.Codec.Encoded<
  typeof ShopBillingDatajsonldsyliusadminchannelupdatenoid
>;

/* Taxonjsonldsyliusadminchannelupdatenoid */

export const Taxonjsonldsyliusadminchannelupdatenoid = Schema.StructWithRest(
  Schema.Struct({
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonjsonldsyliusadminchannelupdatenoid' });
export type Taxonjsonldsyliusadminchannelupdatenoid = Schema.Schema.Type<
  typeof Taxonjsonldsyliusadminchannelupdatenoid
>;
export type TaxonjsonldsyliusadminchannelupdatenoidEncoded = Schema.Codec.Encoded<
  typeof Taxonjsonldsyliusadminchannelupdatenoid
>;

/* Channeljsonldsyliusshopchannelindex */

export const Channeljsonldsyliusshopchannelindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    baseCurrency: Schema.String.annotate({ format: 'iri-reference' }),
    defaultLocale: Schema.String.annotate({ format: 'iri-reference' }),
    currencies: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    locales: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    code: Schema.String,
    name: Schema.String,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Channeljsonldsyliusshopchannelindex' });
export type Channeljsonldsyliusshopchannelindex = Schema.Schema.Type<
  typeof Channeljsonldsyliusshopchannelindex
>;
export type ChanneljsonldsyliusshopchannelindexEncoded = Schema.Codec.Encoded<
  typeof Channeljsonldsyliusshopchannelindex
>;

/* Channeljsonldsyliusshopchannelshow */

export const Channeljsonldsyliusshopchannelshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    baseCurrency: Schema.String.annotate({ format: 'iri-reference' }),
    defaultLocale: Schema.String.annotate({ format: 'iri-reference' }),
    currencies: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    locales: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    code: Schema.String,
    name: Schema.String,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Channeljsonldsyliusshopchannelshow' });
export type Channeljsonldsyliusshopchannelshow = Schema.Schema.Type<
  typeof Channeljsonldsyliusshopchannelshow
>;
export type ChanneljsonldsyliusshopchannelshowEncoded = Schema.Codec.Encoded<
  typeof Channeljsonldsyliusshopchannelshow
>;

/* Collectionmultipart */

export const Collectionmultipart = Schema.StructWithRest(
  Schema.Struct({
    empty: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Checks whether the collection is empty (contains no elements).',
        readOnly: true,
      })
    ),
    keys: Schema.optionalKey(
      Schema.Union([
        Schema.Array(Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' }))),
        Schema.Array(Schema.String),
      ]).annotate({ description: 'Gets all keys/indices of the collection.', readOnly: true })
    ),
    values: Schema.optionalKey(
      Schema.Array(Schema.Union([Schema.String, Schema.Null])).annotate({
        description: 'Gets all values of the collection.',
        readOnly: true,
      })
    ),
    iterator: Schema.optionalKey(Schema.Json.annotate({ expected: 'JSON value', readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Collectionmultipart' });
export type Collectionmultipart = Schema.Schema.Type<typeof Collectionmultipart>;
export type CollectionmultipartEncoded = Schema.Codec.Encoded<typeof Collectionmultipart>;

/* ConstraintViolation */

export const ConstraintViolation = Schema.StructWithRest(
  Schema.Struct({
    status: Schema.Number.annotate({ default: 422 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    violations: Schema.Array(
      Schema.StructWithRest(
        Schema.Struct({
          propertyPath: Schema.String.annotate({
            description: 'The property path of the violation',
          }),
          message: Schema.String.annotate({
            description: 'The message associated with the violation',
          }),
          code: Schema.optionalKey(Schema.Union([Schema.String, Schema.Null])),
          hint: Schema.optionalKey(
            Schema.String.annotate({ description: 'An extra hint to understand the violation' })
          ),
          payload: Schema.optionalKey(
            Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })).annotate(
              { description: 'The serialized payload of the violation' }
            )
          ),
        }),
        [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
      )
    ),
    detail: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    type: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    title: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    instance: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ description: 'Unprocessable entity', identifier: 'ConstraintViolation' });
export type ConstraintViolation = Schema.Schema.Type<typeof ConstraintViolation>;
export type ConstraintViolationEncoded = Schema.Codec.Encoded<typeof ConstraintViolation>;

/* ConstraintViolationjsonld */

export const ConstraintViolationjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    status: Schema.Number.annotate({ default: 422 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    violations: Schema.Array(
      Schema.StructWithRest(
        Schema.Struct({
          propertyPath: Schema.String.annotate({
            description: 'The property path of the violation',
          }),
          message: Schema.String.annotate({
            description: 'The message associated with the violation',
          }),
          code: Schema.optionalKey(Schema.Union([Schema.String, Schema.Null])),
          hint: Schema.optionalKey(
            Schema.String.annotate({ description: 'An extra hint to understand the violation' })
          ),
          payload: Schema.optionalKey(
            Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })).annotate(
              { description: 'The serialized payload of the violation' }
            )
          ),
        }),
        [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
      )
    ),
    detail: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    description: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    type: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    title: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    instance: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ description: 'Unprocessable entity', identifier: 'ConstraintViolationjsonld' });
export type ConstraintViolationjsonld = Schema.Schema.Type<typeof ConstraintViolationjsonld>;
export type ConstraintViolationjsonldEncoded = Schema.Codec.Encoded<
  typeof ConstraintViolationjsonld
>;

/* Contactsyliusshopcontactrequestcreate */

export const Contactsyliusshopcontactrequestcreate = Schema.StructWithRest(
  Schema.Struct({
    email: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'email' }),
    message: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Contactsyliusshopcontactrequestcreate' });
export type Contactsyliusshopcontactrequestcreate = Schema.Schema.Type<
  typeof Contactsyliusshopcontactrequestcreate
>;
export type ContactsyliusshopcontactrequestcreateEncoded = Schema.Codec.Encoded<
  typeof Contactsyliusshopcontactrequestcreate
>;

/* Contactjsonldsyliusshopcontactrequestcreate */

export const Contactjsonldsyliusshopcontactrequestcreate = Schema.StructWithRest(
  Schema.Struct({
    email: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'email' }),
    message: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Contactjsonldsyliusshopcontactrequestcreate' });
export type Contactjsonldsyliusshopcontactrequestcreate = Schema.Schema.Type<
  typeof Contactjsonldsyliusshopcontactrequestcreate
>;
export type ContactjsonldsyliusshopcontactrequestcreateEncoded = Schema.Codec.Encoded<
  typeof Contactjsonldsyliusshopcontactrequestcreate
>;

/* Provincesyliusadmincountrycreate */

export const Provincesyliusadmincountrycreate = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ).check(
      Schema.isPattern(new RegExp('^([A-Z]{2}-[A-Z0-9]{1,})$')).annotate({
        expected: 'a string matching the RegExp ^([A-Z]{2}-[A-Z0-9]{1,})$',
      })
    ),
    name: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    abbreviation: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Provincesyliusadmincountrycreate' });
export type Provincesyliusadmincountrycreate = Schema.Schema.Type<
  typeof Provincesyliusadmincountrycreate
>;
export type ProvincesyliusadmincountrycreateEncoded = Schema.Codec.Encoded<
  typeof Provincesyliusadmincountrycreate
>;

/* Countrysyliusadmincountryindex */

export const Countrysyliusadmincountryindex = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String.annotate({ description: 'Country code ISO 3166-1 alpha-2.' }),
    provinces: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    enabled: Schema.Boolean.annotate({ default: true }),
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Countrysyliusadmincountryindex' });
export type Countrysyliusadmincountryindex = Schema.Schema.Type<
  typeof Countrysyliusadmincountryindex
>;
export type CountrysyliusadmincountryindexEncoded = Schema.Codec.Encoded<
  typeof Countrysyliusadmincountryindex
>;

/* Countrysyliusadmincountryshow */

export const Countrysyliusadmincountryshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String.annotate({ description: 'Country code ISO 3166-1 alpha-2.' }),
    provinces: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    enabled: Schema.Boolean.annotate({ default: true }),
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Countrysyliusadmincountryshow' });
export type Countrysyliusadmincountryshow = Schema.Schema.Type<
  typeof Countrysyliusadmincountryshow
>;
export type CountrysyliusadmincountryshowEncoded = Schema.Codec.Encoded<
  typeof Countrysyliusadmincountryshow
>;

/* Provincesyliusadmincountryupdate */

export const Provincesyliusadmincountryupdate = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ).check(
      Schema.isPattern(new RegExp('^([A-Z]{2}-[A-Z0-9]{1,})$')).annotate({
        expected: 'a string matching the RegExp ^([A-Z]{2}-[A-Z0-9]{1,})$',
      })
    ),
    name: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    abbreviation: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Provincesyliusadmincountryupdate' });
export type Provincesyliusadmincountryupdate = Schema.Schema.Type<
  typeof Provincesyliusadmincountryupdate
>;
export type ProvincesyliusadmincountryupdateEncoded = Schema.Codec.Encoded<
  typeof Provincesyliusadmincountryupdate
>;

/* Provincesyliusshopcountryshow */

export const Provincesyliusshopcountryshow = Schema.StructWithRest(
  Schema.Struct({ code: Schema.String, name: Schema.String }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Provincesyliusshopcountryshow' });
export type Provincesyliusshopcountryshow = Schema.Schema.Type<
  typeof Provincesyliusshopcountryshow
>;
export type ProvincesyliusshopcountryshowEncoded = Schema.Codec.Encoded<
  typeof Provincesyliusshopcountryshow
>;

/* Provincejsonldsyliusadmincountrycreate */

export const Provincejsonldsyliusadmincountrycreate = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ).check(
      Schema.isPattern(new RegExp('^([A-Z]{2}-[A-Z0-9]{1,})$')).annotate({
        expected: 'a string matching the RegExp ^([A-Z]{2}-[A-Z0-9]{1,})$',
      })
    ),
    name: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    abbreviation: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Provincejsonldsyliusadmincountrycreate' });
export type Provincejsonldsyliusadmincountrycreate = Schema.Schema.Type<
  typeof Provincejsonldsyliusadmincountrycreate
>;
export type ProvincejsonldsyliusadmincountrycreateEncoded = Schema.Codec.Encoded<
  typeof Provincejsonldsyliusadmincountrycreate
>;

/* Countryjsonldsyliusadmincountryindex */

export const Countryjsonldsyliusadmincountryindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String.annotate({ description: 'Country code ISO 3166-1 alpha-2.' }),
    provinces: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    enabled: Schema.Boolean.annotate({ default: true }),
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Countryjsonldsyliusadmincountryindex' });
export type Countryjsonldsyliusadmincountryindex = Schema.Schema.Type<
  typeof Countryjsonldsyliusadmincountryindex
>;
export type CountryjsonldsyliusadmincountryindexEncoded = Schema.Codec.Encoded<
  typeof Countryjsonldsyliusadmincountryindex
>;

/* Countryjsonldsyliusadmincountryshow */

export const Countryjsonldsyliusadmincountryshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String.annotate({ description: 'Country code ISO 3166-1 alpha-2.' }),
    provinces: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    enabled: Schema.Boolean.annotate({ default: true }),
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Countryjsonldsyliusadmincountryshow' });
export type Countryjsonldsyliusadmincountryshow = Schema.Schema.Type<
  typeof Countryjsonldsyliusadmincountryshow
>;
export type CountryjsonldsyliusadmincountryshowEncoded = Schema.Codec.Encoded<
  typeof Countryjsonldsyliusadmincountryshow
>;

/* Provincejsonldsyliusadmincountryupdate */

export const Provincejsonldsyliusadmincountryupdate = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ).check(
      Schema.isPattern(new RegExp('^([A-Z]{2}-[A-Z0-9]{1,})$')).annotate({
        expected: 'a string matching the RegExp ^([A-Z]{2}-[A-Z0-9]{1,})$',
      })
    ),
    name: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    abbreviation: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Provincejsonldsyliusadmincountryupdate' });
export type Provincejsonldsyliusadmincountryupdate = Schema.Schema.Type<
  typeof Provincejsonldsyliusadmincountryupdate
>;
export type ProvincejsonldsyliusadmincountryupdateEncoded = Schema.Codec.Encoded<
  typeof Provincejsonldsyliusadmincountryupdate
>;

/* Provincejsonldsyliusshopcountryshow */

export const Provincejsonldsyliusshopcountryshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String,
    name: Schema.String,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Provincejsonldsyliusshopcountryshow' });
export type Provincejsonldsyliusshopcountryshow = Schema.Schema.Type<
  typeof Provincejsonldsyliusshopcountryshow
>;
export type ProvincejsonldsyliusshopcountryshowEncoded = Schema.Codec.Encoded<
  typeof Provincejsonldsyliusshopcountryshow
>;

/* CurrencyshopshippingAndPaymentOptionsindex */

export const CurrencyshopshippingAndPaymentOptionsindex = Schema.StructWithRest(
  Schema.Struct({ code: Schema.String }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CurrencyshopshippingAndPaymentOptionsindex' });
export type CurrencyshopshippingAndPaymentOptionsindex = Schema.Schema.Type<
  typeof CurrencyshopshippingAndPaymentOptionsindex
>;
export type CurrencyshopshippingAndPaymentOptionsindexEncoded = Schema.Codec.Encoded<
  typeof CurrencyshopshippingAndPaymentOptionsindex
>;

/* Currencysyliusadmincurrencycreate */

export const Currencysyliusadmincurrencycreate = Schema.StructWithRest(
  Schema.Struct({ code: Schema.String }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Currencysyliusadmincurrencycreate' });
export type Currencysyliusadmincurrencycreate = Schema.Schema.Type<
  typeof Currencysyliusadmincurrencycreate
>;
export type CurrencysyliusadmincurrencycreateEncoded = Schema.Codec.Encoded<
  typeof Currencysyliusadmincurrencycreate
>;

/* Currencysyliusadmincurrencyindex */

export const Currencysyliusadmincurrencyindex = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String,
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Currencysyliusadmincurrencyindex' });
export type Currencysyliusadmincurrencyindex = Schema.Schema.Type<
  typeof Currencysyliusadmincurrencyindex
>;
export type CurrencysyliusadmincurrencyindexEncoded = Schema.Codec.Encoded<
  typeof Currencysyliusadmincurrencyindex
>;

/* Currencysyliusadmincurrencyshow */

export const Currencysyliusadmincurrencyshow = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String,
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Currencysyliusadmincurrencyshow' });
export type Currencysyliusadmincurrencyshow = Schema.Schema.Type<
  typeof Currencysyliusadmincurrencyshow
>;
export type CurrencysyliusadmincurrencyshowEncoded = Schema.Codec.Encoded<
  typeof Currencysyliusadmincurrencyshow
>;

/* Currencysyliusshopcurrencyindex */

export const Currencysyliusshopcurrencyindex = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String,
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Currencysyliusshopcurrencyindex' });
export type Currencysyliusshopcurrencyindex = Schema.Schema.Type<
  typeof Currencysyliusshopcurrencyindex
>;
export type CurrencysyliusshopcurrencyindexEncoded = Schema.Codec.Encoded<
  typeof Currencysyliusshopcurrencyindex
>;

/* Currencysyliusshopcurrencyshow */

export const Currencysyliusshopcurrencyshow = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String,
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Currencysyliusshopcurrencyshow' });
export type Currencysyliusshopcurrencyshow = Schema.Schema.Type<
  typeof Currencysyliusshopcurrencyshow
>;
export type CurrencysyliusshopcurrencyshowEncoded = Schema.Codec.Encoded<
  typeof Currencysyliusshopcurrencyshow
>;

/* CurrencyjsonldshopshippingAndPaymentOptionsindex */

export const CurrencyjsonldshopshippingAndPaymentOptionsindex = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CurrencyjsonldshopshippingAndPaymentOptionsindex' });
export type CurrencyjsonldshopshippingAndPaymentOptionsindex = Schema.Schema.Type<
  typeof CurrencyjsonldshopshippingAndPaymentOptionsindex
>;
export type CurrencyjsonldshopshippingAndPaymentOptionsindexEncoded = Schema.Codec.Encoded<
  typeof CurrencyjsonldshopshippingAndPaymentOptionsindex
>;

/* Currencyjsonldsyliusadmincurrencycreate */

export const Currencyjsonldsyliusadmincurrencycreate = Schema.StructWithRest(
  Schema.Struct({ code: Schema.String }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Currencyjsonldsyliusadmincurrencycreate' });
export type Currencyjsonldsyliusadmincurrencycreate = Schema.Schema.Type<
  typeof Currencyjsonldsyliusadmincurrencycreate
>;
export type CurrencyjsonldsyliusadmincurrencycreateEncoded = Schema.Codec.Encoded<
  typeof Currencyjsonldsyliusadmincurrencycreate
>;

/* Currencyjsonldsyliusadmincurrencyindex */

export const Currencyjsonldsyliusadmincurrencyindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String,
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Currencyjsonldsyliusadmincurrencyindex' });
export type Currencyjsonldsyliusadmincurrencyindex = Schema.Schema.Type<
  typeof Currencyjsonldsyliusadmincurrencyindex
>;
export type CurrencyjsonldsyliusadmincurrencyindexEncoded = Schema.Codec.Encoded<
  typeof Currencyjsonldsyliusadmincurrencyindex
>;

/* Currencyjsonldsyliusadmincurrencyshow */

export const Currencyjsonldsyliusadmincurrencyshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String,
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Currencyjsonldsyliusadmincurrencyshow' });
export type Currencyjsonldsyliusadmincurrencyshow = Schema.Schema.Type<
  typeof Currencyjsonldsyliusadmincurrencyshow
>;
export type CurrencyjsonldsyliusadmincurrencyshowEncoded = Schema.Codec.Encoded<
  typeof Currencyjsonldsyliusadmincurrencyshow
>;

/* Currencyjsonldsyliusshopcurrencyindex */

export const Currencyjsonldsyliusshopcurrencyindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String,
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Currencyjsonldsyliusshopcurrencyindex' });
export type Currencyjsonldsyliusshopcurrencyindex = Schema.Schema.Type<
  typeof Currencyjsonldsyliusshopcurrencyindex
>;
export type CurrencyjsonldsyliusshopcurrencyindexEncoded = Schema.Codec.Encoded<
  typeof Currencyjsonldsyliusshopcurrencyindex
>;

/* Currencyjsonldsyliusshopcurrencyshow */

export const Currencyjsonldsyliusshopcurrencyshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String,
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Currencyjsonldsyliusshopcurrencyshow' });
export type Currencyjsonldsyliusshopcurrencyshow = Schema.Schema.Type<
  typeof Currencyjsonldsyliusshopcurrencyshow
>;
export type CurrencyjsonldsyliusshopcurrencyshowEncoded = Schema.Codec.Encoded<
  typeof Currencyjsonldsyliusshopcurrencyshow
>;

/* ShopUsersyliusadmincustomercreate */

export const ShopUsersyliusadmincustomercreate = Schema.StructWithRest(
  Schema.Struct({
    plainPassword: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'Password before encryption. Used for model validation. Must not be persisted.',
    }),
    verified: Schema.Boolean,
    enabled: Schema.Boolean.annotate({ default: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShopUsersyliusadmincustomercreate' });
export type ShopUsersyliusadmincustomercreate = Schema.Schema.Type<
  typeof ShopUsersyliusadmincustomercreate
>;
export type ShopUsersyliusadmincustomercreateEncoded = Schema.Codec.Encoded<
  typeof ShopUsersyliusadmincustomercreate
>;

/* ShopUsersyliusadmincustomerindex */

export const ShopUsersyliusadmincustomerindex = Schema.StructWithRest(
  Schema.Struct({
    enabled: Schema.Boolean.annotate({ default: true }),
    verified: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShopUsersyliusadmincustomerindex' });
export type ShopUsersyliusadmincustomerindex = Schema.Schema.Type<
  typeof ShopUsersyliusadmincustomerindex
>;
export type ShopUsersyliusadmincustomerindexEncoded = Schema.Codec.Encoded<
  typeof ShopUsersyliusadmincustomerindex
>;

/* ShopUsersyliusadmincustomershow */

export const ShopUsersyliusadmincustomershow = Schema.StructWithRest(
  Schema.Struct({
    enabled: Schema.Boolean.annotate({ default: true }),
    verified: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShopUsersyliusadmincustomershow' });
export type ShopUsersyliusadmincustomershow = Schema.Schema.Type<
  typeof ShopUsersyliusadmincustomershow
>;
export type ShopUsersyliusadmincustomershowEncoded = Schema.Codec.Encoded<
  typeof ShopUsersyliusadmincustomershow
>;

/* Customersyliusadmincustomerstatisticsshow */

export const Customersyliusadmincustomerstatisticsshow = Schema.Record(
  Schema.String,
  Schema.Json.annotate({ expected: 'JSON value' })
).annotate({ identifier: 'Customersyliusadmincustomerstatisticsshow' });
export type Customersyliusadmincustomerstatisticsshow = Schema.Schema.Type<
  typeof Customersyliusadmincustomerstatisticsshow
>;
export type CustomersyliusadmincustomerstatisticsshowEncoded = Schema.Codec.Encoded<
  typeof Customersyliusadmincustomerstatisticsshow
>;

/* ShopUsersyliusadmincustomerupdate */

export const ShopUsersyliusadmincustomerupdate = Schema.StructWithRest(
  Schema.Struct({
    plainPassword: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'Password before encryption. Used for model validation. Must not be persisted.',
    }),
    verified: Schema.Boolean,
    enabled: Schema.Boolean.annotate({ default: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShopUsersyliusadmincustomerupdate' });
export type ShopUsersyliusadmincustomerupdate = Schema.Schema.Type<
  typeof ShopUsersyliusadmincustomerupdate
>;
export type ShopUsersyliusadmincustomerupdateEncoded = Schema.Codec.Encoded<
  typeof ShopUsersyliusadmincustomerupdate
>;

/* Customersyliusshopcartshow */

export const Customersyliusshopcartshow = Schema.StructWithRest(
  Schema.Struct({ email: Schema.String, phoneNumber: Schema.Union([Schema.String, Schema.Null]) }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Customersyliusshopcartshow' });
export type Customersyliusshopcartshow = Schema.Schema.Type<typeof Customersyliusshopcartshow>;
export type CustomersyliusshopcartshowEncoded = Schema.Codec.Encoded<
  typeof Customersyliusshopcartshow
>;

/* Customersyliusshopcartshowsyliusshopcartshowdetail */

export const Customersyliusshopcartshowsyliusshopcartshowdetail = Schema.StructWithRest(
  Schema.Struct({ email: Schema.String, phoneNumber: Schema.Union([Schema.String, Schema.Null]) }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Customersyliusshopcartshowsyliusshopcartshowdetail' });
export type Customersyliusshopcartshowsyliusshopcartshowdetail = Schema.Schema.Type<
  typeof Customersyliusshopcartshowsyliusshopcartshowdetail
>;
export type CustomersyliusshopcartshowsyliusshopcartshowdetailEncoded = Schema.Codec.Encoded<
  typeof Customersyliusshopcartshowsyliusshopcartshowdetail
>;

/* Customersyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const Customersyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      email: Schema.String,
      phoneNumber: Schema.Union([Schema.String, Schema.Null]),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier: 'Customersyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type Customersyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof Customersyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type CustomersyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof Customersyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* ShopUsersyliusshopcustomershow */

export const ShopUsersyliusshopcustomershow = Schema.StructWithRest(
  Schema.Struct({ verified: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })) }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShopUsersyliusshopcustomershow' });
export type ShopUsersyliusshopcustomershow = Schema.Schema.Type<
  typeof ShopUsersyliusshopcustomershow
>;
export type ShopUsersyliusshopcustomershowEncoded = Schema.Codec.Encoded<
  typeof ShopUsersyliusshopcustomershow
>;

/* Customersyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const Customersyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      email: Schema.String,
      phoneNumber: Schema.Union([Schema.String, Schema.Null]),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'Customersyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type Customersyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof Customersyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type CustomersyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof Customersyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* Customersyliusshopproductreviewindex */

export const Customersyliusshopproductreviewindex = Schema.StructWithRest(
  Schema.Struct({ firstName: Schema.Union([Schema.String, Schema.Null]) }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Customersyliusshopproductreviewindex' });
export type Customersyliusshopproductreviewindex = Schema.Schema.Type<
  typeof Customersyliusshopproductreviewindex
>;
export type CustomersyliusshopproductreviewindexEncoded = Schema.Codec.Encoded<
  typeof Customersyliusshopproductreviewindex
>;

/* Customersyliusshopproductreviewshow */

export const Customersyliusshopproductreviewshow = Schema.StructWithRest(
  Schema.Struct({ firstName: Schema.Union([Schema.String, Schema.Null]) }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Customersyliusshopproductreviewshow' });
export type Customersyliusshopproductreviewshow = Schema.Schema.Type<
  typeof Customersyliusshopproductreviewshow
>;
export type CustomersyliusshopproductreviewshowEncoded = Schema.Codec.Encoded<
  typeof Customersyliusshopproductreviewshow
>;

/* CustomerChangeShopUserPasswordsyliusshopcustomerpasswordupdate */

export const CustomerChangeShopUserPasswordsyliusshopcustomerpasswordupdate = Schema.StructWithRest(
  Schema.Struct({
    newPassword: Schema.String.check(
      Schema.isMinLength(4).annotate({ expected: 'a value with a length of at least 4' })
    ).check(Schema.isMaxLength(254).annotate({ expected: 'a value with a length of at most 254' })),
    confirmNewPassword: Schema.String,
    currentPassword: Schema.String.check(
      Schema.isMinLength(4).annotate({ expected: 'a value with a length of at least 4' })
    ).check(Schema.isMaxLength(254).annotate({ expected: 'a value with a length of at most 254' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CustomerChangeShopUserPasswordsyliusshopcustomerpasswordupdate' });
export type CustomerChangeShopUserPasswordsyliusshopcustomerpasswordupdate = Schema.Schema.Type<
  typeof CustomerChangeShopUserPasswordsyliusshopcustomerpasswordupdate
>;
export type CustomerChangeShopUserPasswordsyliusshopcustomerpasswordupdateEncoded =
  Schema.Codec.Encoded<typeof CustomerChangeShopUserPasswordsyliusshopcustomerpasswordupdate>;

/* CustomerChangeShopUserPasswordjsonldsyliusshopcustomerpasswordupdate */

export const CustomerChangeShopUserPasswordjsonldsyliusshopcustomerpasswordupdate =
  Schema.StructWithRest(
    Schema.Struct({
      newPassword: Schema.String.check(
        Schema.isMinLength(4).annotate({ expected: 'a value with a length of at least 4' })
      ).check(
        Schema.isMaxLength(254).annotate({ expected: 'a value with a length of at most 254' })
      ),
      confirmNewPassword: Schema.String,
      currentPassword: Schema.String.check(
        Schema.isMinLength(4).annotate({ expected: 'a value with a length of at least 4' })
      ).check(
        Schema.isMaxLength(254).annotate({ expected: 'a value with a length of at most 254' })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier: 'CustomerChangeShopUserPasswordjsonldsyliusshopcustomerpasswordupdate',
  });
export type CustomerChangeShopUserPasswordjsonldsyliusshopcustomerpasswordupdate =
  Schema.Schema.Type<typeof CustomerChangeShopUserPasswordjsonldsyliusshopcustomerpasswordupdate>;
export type CustomerChangeShopUserPasswordjsonldsyliusshopcustomerpasswordupdateEncoded =
  Schema.Codec.Encoded<typeof CustomerChangeShopUserPasswordjsonldsyliusshopcustomerpasswordupdate>;

/* CustomerRegisterShopUsersyliusshopcustomercreate */

export const CustomerRegisterShopUsersyliusshopcustomercreate = Schema.StructWithRest(
  Schema.Struct({
    firstName: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    lastName: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    email: Schema.String.annotate({ format: 'email' }).check(
      Schema.isMaxLength(254).annotate({ expected: 'a value with a length of at most 254' })
    ),
    password: Schema.String.check(
      Schema.isMinLength(4).annotate({ expected: 'a value with a length of at least 4' })
    ).check(Schema.isMaxLength(254).annotate({ expected: 'a value with a length of at most 254' })),
    subscribedToNewsletter: Schema.Boolean,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CustomerRegisterShopUsersyliusshopcustomercreate' });
export type CustomerRegisterShopUsersyliusshopcustomercreate = Schema.Schema.Type<
  typeof CustomerRegisterShopUsersyliusshopcustomercreate
>;
export type CustomerRegisterShopUsersyliusshopcustomercreateEncoded = Schema.Codec.Encoded<
  typeof CustomerRegisterShopUsersyliusshopcustomercreate
>;

/* CustomerRegisterShopUserjsonldsyliusshopcustomercreate */

export const CustomerRegisterShopUserjsonldsyliusshopcustomercreate = Schema.StructWithRest(
  Schema.Struct({
    firstName: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    lastName: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    email: Schema.String.annotate({ format: 'email' }).check(
      Schema.isMaxLength(254).annotate({ expected: 'a value with a length of at most 254' })
    ),
    password: Schema.String.check(
      Schema.isMinLength(4).annotate({ expected: 'a value with a length of at least 4' })
    ).check(Schema.isMaxLength(254).annotate({ expected: 'a value with a length of at most 254' })),
    subscribedToNewsletter: Schema.Boolean,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CustomerRegisterShopUserjsonldsyliusshopcustomercreate' });
export type CustomerRegisterShopUserjsonldsyliusshopcustomercreate = Schema.Schema.Type<
  typeof CustomerRegisterShopUserjsonldsyliusshopcustomercreate
>;
export type CustomerRegisterShopUserjsonldsyliusshopcustomercreateEncoded = Schema.Codec.Encoded<
  typeof CustomerRegisterShopUserjsonldsyliusshopcustomercreate
>;

/* CustomerRegisterShopUserFromOrdersyliusshopcustomercreate */

export const CustomerRegisterShopUserFromOrdersyliusshopcustomercreate = Schema.StructWithRest(
  Schema.Struct({
    orderToken: Schema.String,
    password: Schema.String,
    subscribedToNewsletter: Schema.Boolean,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CustomerRegisterShopUserFromOrdersyliusshopcustomercreate' });
export type CustomerRegisterShopUserFromOrdersyliusshopcustomercreate = Schema.Schema.Type<
  typeof CustomerRegisterShopUserFromOrdersyliusshopcustomercreate
>;
export type CustomerRegisterShopUserFromOrdersyliusshopcustomercreateEncoded = Schema.Codec.Encoded<
  typeof CustomerRegisterShopUserFromOrdersyliusshopcustomercreate
>;

/* CustomerRegisterShopUserFromOrderjsonldsyliusshopcustomercreate */

export const CustomerRegisterShopUserFromOrderjsonldsyliusshopcustomercreate =
  Schema.StructWithRest(
    Schema.Struct({
      orderToken: Schema.String,
      password: Schema.String,
      subscribedToNewsletter: Schema.Boolean,
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({ identifier: 'CustomerRegisterShopUserFromOrderjsonldsyliusshopcustomercreate' });
export type CustomerRegisterShopUserFromOrderjsonldsyliusshopcustomercreate = Schema.Schema.Type<
  typeof CustomerRegisterShopUserFromOrderjsonldsyliusshopcustomercreate
>;
export type CustomerRegisterShopUserFromOrderjsonldsyliusshopcustomercreateEncoded =
  Schema.Codec.Encoded<typeof CustomerRegisterShopUserFromOrderjsonldsyliusshopcustomercreate>;

/* ShopUserjsonldsyliusadmincustomercreate */

export const ShopUserjsonldsyliusadmincustomercreate = Schema.StructWithRest(
  Schema.Struct({
    plainPassword: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'Password before encryption. Used for model validation. Must not be persisted.',
    }),
    verified: Schema.Boolean,
    enabled: Schema.Boolean.annotate({ default: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShopUserjsonldsyliusadmincustomercreate' });
export type ShopUserjsonldsyliusadmincustomercreate = Schema.Schema.Type<
  typeof ShopUserjsonldsyliusadmincustomercreate
>;
export type ShopUserjsonldsyliusadmincustomercreateEncoded = Schema.Codec.Encoded<
  typeof ShopUserjsonldsyliusadmincustomercreate
>;

/* ShopUserjsonldsyliusadmincustomerindex */

export const ShopUserjsonldsyliusadmincustomerindex = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    enabled: Schema.Boolean.annotate({ default: true }),
    verified: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShopUserjsonldsyliusadmincustomerindex' });
export type ShopUserjsonldsyliusadmincustomerindex = Schema.Schema.Type<
  typeof ShopUserjsonldsyliusadmincustomerindex
>;
export type ShopUserjsonldsyliusadmincustomerindexEncoded = Schema.Codec.Encoded<
  typeof ShopUserjsonldsyliusadmincustomerindex
>;

/* ShopUserjsonldsyliusadmincustomershow */

export const ShopUserjsonldsyliusadmincustomershow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    enabled: Schema.Boolean.annotate({ default: true }),
    verified: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShopUserjsonldsyliusadmincustomershow' });
export type ShopUserjsonldsyliusadmincustomershow = Schema.Schema.Type<
  typeof ShopUserjsonldsyliusadmincustomershow
>;
export type ShopUserjsonldsyliusadmincustomershowEncoded = Schema.Codec.Encoded<
  typeof ShopUserjsonldsyliusadmincustomershow
>;

/* Customerjsonldsyliusadmincustomerstatisticsshow */

export const Customerjsonldsyliusadmincustomerstatisticsshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Customerjsonldsyliusadmincustomerstatisticsshow' });
export type Customerjsonldsyliusadmincustomerstatisticsshow = Schema.Schema.Type<
  typeof Customerjsonldsyliusadmincustomerstatisticsshow
>;
export type CustomerjsonldsyliusadmincustomerstatisticsshowEncoded = Schema.Codec.Encoded<
  typeof Customerjsonldsyliusadmincustomerstatisticsshow
>;

/* ShopUserjsonldsyliusadmincustomerupdate */

export const ShopUserjsonldsyliusadmincustomerupdate = Schema.StructWithRest(
  Schema.Struct({
    plainPassword: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'Password before encryption. Used for model validation. Must not be persisted.',
    }),
    verified: Schema.Boolean,
    enabled: Schema.Boolean.annotate({ default: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShopUserjsonldsyliusadmincustomerupdate' });
export type ShopUserjsonldsyliusadmincustomerupdate = Schema.Schema.Type<
  typeof ShopUserjsonldsyliusadmincustomerupdate
>;
export type ShopUserjsonldsyliusadmincustomerupdateEncoded = Schema.Codec.Encoded<
  typeof ShopUserjsonldsyliusadmincustomerupdate
>;

/* Customerjsonldsyliusshopcartshow */

export const Customerjsonldsyliusshopcartshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    email: Schema.String,
    phoneNumber: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Customerjsonldsyliusshopcartshow' });
export type Customerjsonldsyliusshopcartshow = Schema.Schema.Type<
  typeof Customerjsonldsyliusshopcartshow
>;
export type CustomerjsonldsyliusshopcartshowEncoded = Schema.Codec.Encoded<
  typeof Customerjsonldsyliusshopcartshow
>;

/* Customerjsonldsyliusshopcartshowsyliusshopcartshowdetail */

export const Customerjsonldsyliusshopcartshowsyliusshopcartshowdetail = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    email: Schema.String,
    phoneNumber: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Customerjsonldsyliusshopcartshowsyliusshopcartshowdetail' });
export type Customerjsonldsyliusshopcartshowsyliusshopcartshowdetail = Schema.Schema.Type<
  typeof Customerjsonldsyliusshopcartshowsyliusshopcartshowdetail
>;
export type CustomerjsonldsyliusshopcartshowsyliusshopcartshowdetailEncoded = Schema.Codec.Encoded<
  typeof Customerjsonldsyliusshopcartshowsyliusshopcartshowdetail
>;

/* Customerjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const Customerjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      email: Schema.String,
      phoneNumber: Schema.Union([Schema.String, Schema.Null]),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier: 'Customerjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type Customerjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof Customerjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type CustomerjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof Customerjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* ShopUserjsonldsyliusshopcustomershow */

export const ShopUserjsonldsyliusshopcustomershow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    verified: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShopUserjsonldsyliusshopcustomershow' });
export type ShopUserjsonldsyliusshopcustomershow = Schema.Schema.Type<
  typeof ShopUserjsonldsyliusshopcustomershow
>;
export type ShopUserjsonldsyliusshopcustomershowEncoded = Schema.Codec.Encoded<
  typeof ShopUserjsonldsyliusshopcustomershow
>;

/* Customerjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const Customerjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      email: Schema.String,
      phoneNumber: Schema.Union([Schema.String, Schema.Null]),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'Customerjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type Customerjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof Customerjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type CustomerjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof Customerjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* Customerjsonldsyliusshopproductreviewindex */

export const Customerjsonldsyliusshopproductreviewindex = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    firstName: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Customerjsonldsyliusshopproductreviewindex' });
export type Customerjsonldsyliusshopproductreviewindex = Schema.Schema.Type<
  typeof Customerjsonldsyliusshopproductreviewindex
>;
export type CustomerjsonldsyliusshopproductreviewindexEncoded = Schema.Codec.Encoded<
  typeof Customerjsonldsyliusshopproductreviewindex
>;

/* Customerjsonldsyliusshopproductreviewshow */

export const Customerjsonldsyliusshopproductreviewshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    firstName: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Customerjsonldsyliusshopproductreviewshow' });
export type Customerjsonldsyliusshopproductreviewshow = Schema.Schema.Type<
  typeof Customerjsonldsyliusshopproductreviewshow
>;
export type CustomerjsonldsyliusshopproductreviewshowEncoded = Schema.Codec.Encoded<
  typeof Customerjsonldsyliusshopproductreviewshow
>;

/* CustomerGroupsyliusadmincustomergroupcreate */

export const CustomerGroupsyliusadmincustomergroupcreate = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ).check(
      Schema.isPattern(new RegExp('^([\\w-]*)$')).annotate({
        expected: 'a string matching the RegExp ^([\\w-]*)$',
      })
    ),
    name: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CustomerGroupsyliusadmincustomergroupcreate' });
export type CustomerGroupsyliusadmincustomergroupcreate = Schema.Schema.Type<
  typeof CustomerGroupsyliusadmincustomergroupcreate
>;
export type CustomerGroupsyliusadmincustomergroupcreateEncoded = Schema.Codec.Encoded<
  typeof CustomerGroupsyliusadmincustomergroupcreate
>;

/* CustomerGroupsyliusadmincustomergroupindex */

export const CustomerGroupsyliusadmincustomergroupindex = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.String,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CustomerGroupsyliusadmincustomergroupindex' });
export type CustomerGroupsyliusadmincustomergroupindex = Schema.Schema.Type<
  typeof CustomerGroupsyliusadmincustomergroupindex
>;
export type CustomerGroupsyliusadmincustomergroupindexEncoded = Schema.Codec.Encoded<
  typeof CustomerGroupsyliusadmincustomergroupindex
>;

/* CustomerGroupsyliusadmincustomergroupshow */

export const CustomerGroupsyliusadmincustomergroupshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.String,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CustomerGroupsyliusadmincustomergroupshow' });
export type CustomerGroupsyliusadmincustomergroupshow = Schema.Schema.Type<
  typeof CustomerGroupsyliusadmincustomergroupshow
>;
export type CustomerGroupsyliusadmincustomergroupshowEncoded = Schema.Codec.Encoded<
  typeof CustomerGroupsyliusadmincustomergroupshow
>;

/* CustomerGroupsyliusadmincustomergroupupdate */

export const CustomerGroupsyliusadmincustomergroupupdate = Schema.StructWithRest(
  Schema.Struct({
    name: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CustomerGroupsyliusadmincustomergroupupdate' });
export type CustomerGroupsyliusadmincustomergroupupdate = Schema.Schema.Type<
  typeof CustomerGroupsyliusadmincustomergroupupdate
>;
export type CustomerGroupsyliusadmincustomergroupupdateEncoded = Schema.Codec.Encoded<
  typeof CustomerGroupsyliusadmincustomergroupupdate
>;

/* CustomerGroupjsonldsyliusadmincustomergroupcreate */

export const CustomerGroupjsonldsyliusadmincustomergroupcreate = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ).check(
      Schema.isPattern(new RegExp('^([\\w-]*)$')).annotate({
        expected: 'a string matching the RegExp ^([\\w-]*)$',
      })
    ),
    name: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CustomerGroupjsonldsyliusadmincustomergroupcreate' });
export type CustomerGroupjsonldsyliusadmincustomergroupcreate = Schema.Schema.Type<
  typeof CustomerGroupjsonldsyliusadmincustomergroupcreate
>;
export type CustomerGroupjsonldsyliusadmincustomergroupcreateEncoded = Schema.Codec.Encoded<
  typeof CustomerGroupjsonldsyliusadmincustomergroupcreate
>;

/* CustomerGroupjsonldsyliusadmincustomergroupindex */

export const CustomerGroupjsonldsyliusadmincustomergroupindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.String,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CustomerGroupjsonldsyliusadmincustomergroupindex' });
export type CustomerGroupjsonldsyliusadmincustomergroupindex = Schema.Schema.Type<
  typeof CustomerGroupjsonldsyliusadmincustomergroupindex
>;
export type CustomerGroupjsonldsyliusadmincustomergroupindexEncoded = Schema.Codec.Encoded<
  typeof CustomerGroupjsonldsyliusadmincustomergroupindex
>;

/* CustomerGroupjsonldsyliusadmincustomergroupshow */

export const CustomerGroupjsonldsyliusadmincustomergroupshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.String,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CustomerGroupjsonldsyliusadmincustomergroupshow' });
export type CustomerGroupjsonldsyliusadmincustomergroupshow = Schema.Schema.Type<
  typeof CustomerGroupjsonldsyliusadmincustomergroupshow
>;
export type CustomerGroupjsonldsyliusadmincustomergroupshowEncoded = Schema.Codec.Encoded<
  typeof CustomerGroupjsonldsyliusadmincustomergroupshow
>;

/* CustomerGroupjsonldsyliusadmincustomergroupupdate */

export const CustomerGroupjsonldsyliusadmincustomergroupupdate = Schema.StructWithRest(
  Schema.Struct({
    name: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CustomerGroupjsonldsyliusadmincustomergroupupdate' });
export type CustomerGroupjsonldsyliusadmincustomergroupupdate = Schema.Schema.Type<
  typeof CustomerGroupjsonldsyliusadmincustomergroupupdate
>;
export type CustomerGroupjsonldsyliusadmincustomergroupupdateEncoded = Schema.Codec.Encoded<
  typeof CustomerGroupjsonldsyliusadmincustomergroupupdate
>;

/* DocumentTypeadminproductdocumentcreate */

export const DocumentTypeadminproductdocumentcreate = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'DocumentTypeadminproductdocumentcreate' });
export type DocumentTypeadminproductdocumentcreate = Schema.Schema.Type<
  typeof DocumentTypeadminproductdocumentcreate
>;
export type DocumentTypeadminproductdocumentcreateEncoded = Schema.Codec.Encoded<
  typeof DocumentTypeadminproductdocumentcreate
>;

/* DocumentTypeadminproductdocumentread */

export const DocumentTypeadminproductdocumentread = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'DocumentTypeadminproductdocumentread' });
export type DocumentTypeadminproductdocumentread = Schema.Schema.Type<
  typeof DocumentTypeadminproductdocumentread
>;
export type DocumentTypeadminproductdocumentreadEncoded = Schema.Codec.Encoded<
  typeof DocumentTypeadminproductdocumentread
>;

/* DocumentTypejsonldadminproductdocumentcreate */

export const DocumentTypejsonldadminproductdocumentcreate = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'DocumentTypejsonldadminproductdocumentcreate' });
export type DocumentTypejsonldadminproductdocumentcreate = Schema.Schema.Type<
  typeof DocumentTypejsonldadminproductdocumentcreate
>;
export type DocumentTypejsonldadminproductdocumentcreateEncoded = Schema.Codec.Encoded<
  typeof DocumentTypejsonldadminproductdocumentcreate
>;

/* DocumentTypejsonldadminproductdocumentread */

export const DocumentTypejsonldadminproductdocumentread = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'DocumentTypejsonldadminproductdocumentread' });
export type DocumentTypejsonldadminproductdocumentread = Schema.Schema.Type<
  typeof DocumentTypejsonldadminproductdocumentread
>;
export type DocumentTypejsonldadminproductdocumentreadEncoded = Schema.Codec.Encoded<
  typeof DocumentTypejsonldadminproductdocumentread
>;

/* Error */

export const Error = Schema.StructWithRest(
  Schema.Struct({
    title: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        description: 'A short, human-readable summary of the problem.',
        readOnly: true,
      })
    ),
    detail: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        description: 'A human-readable explanation specific to this occurrence of the problem.',
        readOnly: true,
      })
    ),
    status: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({ default: 400, examples: [404] }),
    instance: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        description:
          'A URI reference that identifies the specific occurrence of the problem. It may or may not yield further information if dereferenced.',
        readOnly: true,
      })
    ),
    type: Schema.optionalKey(
      Schema.String.annotate({
        description: 'A URI reference that identifies the problem type',
        readOnly: true,
      })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ description: 'A representation of common errors.', identifier: 'Error' });
export type Error = Schema.Schema.Type<typeof Error>;
export type ErrorEncoded = Schema.Codec.Encoded<typeof Error>;

/* Errorjsonld */

export const Errorjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    title: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        description: 'A short, human-readable summary of the problem.',
        readOnly: true,
      })
    ),
    detail: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        description: 'A human-readable explanation specific to this occurrence of the problem.',
        readOnly: true,
      })
    ),
    status: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({ default: 400, examples: [404] }),
    instance: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        description:
          'A URI reference that identifies the specific occurrence of the problem. It may or may not yield further information if dereferenced.',
        readOnly: true,
      })
    ),
    type: Schema.optionalKey(
      Schema.String.annotate({
        description: 'A URI reference that identifies the problem type',
        readOnly: true,
      })
    ),
    description: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ description: 'A representation of common errors.', identifier: 'Errorjsonld' });
export type Errorjsonld = Schema.Schema.Type<typeof Errorjsonld>;
export type ErrorjsonldEncoded = Schema.Codec.Encoded<typeof Errorjsonld>;

/* ExchangeRatesyliusadminexchangeratecreate */

export const ExchangeRatesyliusadminexchangeratecreate = Schema.StructWithRest(
  Schema.Struct({
    ratio: Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' }))
      .check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      )
      .check(
        Schema.isLessThanOrEqualTo(100000).annotate({
          expected: 'a value less than or equal to 100000',
        })
      )
      .check(Schema.isGreaterThan(0).annotate({ expected: 'a value greater than 0' }))
      .check(Schema.isLessThan(100000).annotate({ expected: 'a value less than 100000' })),
    sourceCurrency: Schema.String.annotate({ format: 'iri-reference' }),
    targetCurrency: Schema.String.annotate({ format: 'iri-reference' }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ExchangeRatesyliusadminexchangeratecreate' });
export type ExchangeRatesyliusadminexchangeratecreate = Schema.Schema.Type<
  typeof ExchangeRatesyliusadminexchangeratecreate
>;
export type ExchangeRatesyliusadminexchangeratecreateEncoded = Schema.Codec.Encoded<
  typeof ExchangeRatesyliusadminexchangeratecreate
>;

/* ExchangeRatesyliusadminexchangerateindex */

export const ExchangeRatesyliusadminexchangerateindex = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    ratio: Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
    sourceCurrency: Schema.String.annotate({ format: 'iri-reference' }),
    targetCurrency: Schema.String.annotate({ format: 'iri-reference' }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ExchangeRatesyliusadminexchangerateindex' });
export type ExchangeRatesyliusadminexchangerateindex = Schema.Schema.Type<
  typeof ExchangeRatesyliusadminexchangerateindex
>;
export type ExchangeRatesyliusadminexchangerateindexEncoded = Schema.Codec.Encoded<
  typeof ExchangeRatesyliusadminexchangerateindex
>;

/* ExchangeRatesyliusadminexchangerateshow */

export const ExchangeRatesyliusadminexchangerateshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    ratio: Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
    sourceCurrency: Schema.String.annotate({ format: 'iri-reference' }),
    targetCurrency: Schema.String.annotate({ format: 'iri-reference' }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ExchangeRatesyliusadminexchangerateshow' });
export type ExchangeRatesyliusadminexchangerateshow = Schema.Schema.Type<
  typeof ExchangeRatesyliusadminexchangerateshow
>;
export type ExchangeRatesyliusadminexchangerateshowEncoded = Schema.Codec.Encoded<
  typeof ExchangeRatesyliusadminexchangerateshow
>;

/* ExchangeRatesyliusadminexchangerateupdate */

export const ExchangeRatesyliusadminexchangerateupdate = Schema.StructWithRest(
  Schema.Struct({
    ratio: Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' }))
      .check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      )
      .check(
        Schema.isLessThanOrEqualTo(100000).annotate({
          expected: 'a value less than or equal to 100000',
        })
      )
      .check(Schema.isGreaterThan(0).annotate({ expected: 'a value greater than 0' }))
      .check(Schema.isLessThan(100000).annotate({ expected: 'a value less than 100000' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ExchangeRatesyliusadminexchangerateupdate' });
export type ExchangeRatesyliusadminexchangerateupdate = Schema.Schema.Type<
  typeof ExchangeRatesyliusadminexchangerateupdate
>;
export type ExchangeRatesyliusadminexchangerateupdateEncoded = Schema.Codec.Encoded<
  typeof ExchangeRatesyliusadminexchangerateupdate
>;

/* ExchangeRatesyliusshopexchangerateindex */

export const ExchangeRatesyliusshopexchangerateindex = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    ratio: Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
    sourceCurrency: Schema.String.annotate({ format: 'iri-reference' }),
    targetCurrency: Schema.String.annotate({ format: 'iri-reference' }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ExchangeRatesyliusshopexchangerateindex' });
export type ExchangeRatesyliusshopexchangerateindex = Schema.Schema.Type<
  typeof ExchangeRatesyliusshopexchangerateindex
>;
export type ExchangeRatesyliusshopexchangerateindexEncoded = Schema.Codec.Encoded<
  typeof ExchangeRatesyliusshopexchangerateindex
>;

/* ExchangeRatesyliusshopexchangerateshow */

export const ExchangeRatesyliusshopexchangerateshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    ratio: Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
    sourceCurrency: Schema.String.annotate({ format: 'iri-reference' }),
    targetCurrency: Schema.String.annotate({ format: 'iri-reference' }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ExchangeRatesyliusshopexchangerateshow' });
export type ExchangeRatesyliusshopexchangerateshow = Schema.Schema.Type<
  typeof ExchangeRatesyliusshopexchangerateshow
>;
export type ExchangeRatesyliusshopexchangerateshowEncoded = Schema.Codec.Encoded<
  typeof ExchangeRatesyliusshopexchangerateshow
>;

/* ExchangeRatejsonldsyliusadminexchangeratecreate */

export const ExchangeRatejsonldsyliusadminexchangeratecreate = Schema.StructWithRest(
  Schema.Struct({
    ratio: Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' }))
      .check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      )
      .check(
        Schema.isLessThanOrEqualTo(100000).annotate({
          expected: 'a value less than or equal to 100000',
        })
      )
      .check(Schema.isGreaterThan(0).annotate({ expected: 'a value greater than 0' }))
      .check(Schema.isLessThan(100000).annotate({ expected: 'a value less than 100000' })),
    sourceCurrency: Schema.String.annotate({ format: 'iri-reference' }),
    targetCurrency: Schema.String.annotate({ format: 'iri-reference' }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ExchangeRatejsonldsyliusadminexchangeratecreate' });
export type ExchangeRatejsonldsyliusadminexchangeratecreate = Schema.Schema.Type<
  typeof ExchangeRatejsonldsyliusadminexchangeratecreate
>;
export type ExchangeRatejsonldsyliusadminexchangeratecreateEncoded = Schema.Codec.Encoded<
  typeof ExchangeRatejsonldsyliusadminexchangeratecreate
>;

/* ExchangeRatejsonldsyliusadminexchangerateindex */

export const ExchangeRatejsonldsyliusadminexchangerateindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    ratio: Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
    sourceCurrency: Schema.String.annotate({ format: 'iri-reference' }),
    targetCurrency: Schema.String.annotate({ format: 'iri-reference' }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ExchangeRatejsonldsyliusadminexchangerateindex' });
export type ExchangeRatejsonldsyliusadminexchangerateindex = Schema.Schema.Type<
  typeof ExchangeRatejsonldsyliusadminexchangerateindex
>;
export type ExchangeRatejsonldsyliusadminexchangerateindexEncoded = Schema.Codec.Encoded<
  typeof ExchangeRatejsonldsyliusadminexchangerateindex
>;

/* ExchangeRatejsonldsyliusadminexchangerateshow */

export const ExchangeRatejsonldsyliusadminexchangerateshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    ratio: Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
    sourceCurrency: Schema.String.annotate({ format: 'iri-reference' }),
    targetCurrency: Schema.String.annotate({ format: 'iri-reference' }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ExchangeRatejsonldsyliusadminexchangerateshow' });
export type ExchangeRatejsonldsyliusadminexchangerateshow = Schema.Schema.Type<
  typeof ExchangeRatejsonldsyliusadminexchangerateshow
>;
export type ExchangeRatejsonldsyliusadminexchangerateshowEncoded = Schema.Codec.Encoded<
  typeof ExchangeRatejsonldsyliusadminexchangerateshow
>;

/* ExchangeRatejsonldsyliusadminexchangerateupdate */

export const ExchangeRatejsonldsyliusadminexchangerateupdate = Schema.StructWithRest(
  Schema.Struct({
    ratio: Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' }))
      .check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      )
      .check(
        Schema.isLessThanOrEqualTo(100000).annotate({
          expected: 'a value less than or equal to 100000',
        })
      )
      .check(Schema.isGreaterThan(0).annotate({ expected: 'a value greater than 0' }))
      .check(Schema.isLessThan(100000).annotate({ expected: 'a value less than 100000' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ExchangeRatejsonldsyliusadminexchangerateupdate' });
export type ExchangeRatejsonldsyliusadminexchangerateupdate = Schema.Schema.Type<
  typeof ExchangeRatejsonldsyliusadminexchangerateupdate
>;
export type ExchangeRatejsonldsyliusadminexchangerateupdateEncoded = Schema.Codec.Encoded<
  typeof ExchangeRatejsonldsyliusadminexchangerateupdate
>;

/* ExchangeRatejsonldsyliusshopexchangerateindex */

export const ExchangeRatejsonldsyliusshopexchangerateindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    ratio: Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
    sourceCurrency: Schema.String.annotate({ format: 'iri-reference' }),
    targetCurrency: Schema.String.annotate({ format: 'iri-reference' }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ExchangeRatejsonldsyliusshopexchangerateindex' });
export type ExchangeRatejsonldsyliusshopexchangerateindex = Schema.Schema.Type<
  typeof ExchangeRatejsonldsyliusshopexchangerateindex
>;
export type ExchangeRatejsonldsyliusshopexchangerateindexEncoded = Schema.Codec.Encoded<
  typeof ExchangeRatejsonldsyliusshopexchangerateindex
>;

/* ExchangeRatejsonldsyliusshopexchangerateshow */

export const ExchangeRatejsonldsyliusshopexchangerateshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    ratio: Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
    sourceCurrency: Schema.String.annotate({ format: 'iri-reference' }),
    targetCurrency: Schema.String.annotate({ format: 'iri-reference' }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ExchangeRatejsonldsyliusshopexchangerateshow' });
export type ExchangeRatejsonldsyliusshopexchangerateshow = Schema.Schema.Type<
  typeof ExchangeRatejsonldsyliusshopexchangerateshow
>;
export type ExchangeRatejsonldsyliusshopexchangerateshowEncoded = Schema.Codec.Encoded<
  typeof ExchangeRatejsonldsyliusshopexchangerateshow
>;

/* FaqTopicsyliusshopfaqquestionindex */

export const FaqTopicsyliusshopfaqquestionindex = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.annotate({ default: '' }),
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    description: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    slug: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'FaqTopicsyliusshopfaqquestionindex' });
export type FaqTopicsyliusshopfaqquestionindex = Schema.Schema.Type<
  typeof FaqTopicsyliusshopfaqquestionindex
>;
export type FaqTopicsyliusshopfaqquestionindexEncoded = Schema.Codec.Encoded<
  typeof FaqTopicsyliusshopfaqquestionindex
>;

/* FaqTopicsyliusshopfaqquestionshow */

export const FaqTopicsyliusshopfaqquestionshow = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.annotate({ default: '' }),
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    description: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    slug: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'FaqTopicsyliusshopfaqquestionshow' });
export type FaqTopicsyliusshopfaqquestionshow = Schema.Schema.Type<
  typeof FaqTopicsyliusshopfaqquestionshow
>;
export type FaqTopicsyliusshopfaqquestionshowEncoded = Schema.Codec.Encoded<
  typeof FaqTopicsyliusshopfaqquestionshow
>;

/* FaqTopicjsonldsyliusshopfaqquestionshow */

export const FaqTopicjsonldsyliusshopfaqquestionshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String.annotate({ default: '' }),
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    description: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    slug: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'FaqTopicjsonldsyliusshopfaqquestionshow' });
export type FaqTopicjsonldsyliusshopfaqquestionshow = Schema.Schema.Type<
  typeof FaqTopicjsonldsyliusshopfaqquestionshow
>;
export type FaqTopicjsonldsyliusshopfaqquestionshowEncoded = Schema.Codec.Encoded<
  typeof FaqTopicjsonldsyliusshopfaqquestionshow
>;

/* FaqQuestionsyliusshopfaqtopicdetail */

export const FaqQuestionsyliusshopfaqtopicdetail = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.annotate({ default: '' }),
    priority: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    question: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    answer: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    slug: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'FaqQuestionsyliusshopfaqtopicdetail' });
export type FaqQuestionsyliusshopfaqtopicdetail = Schema.Schema.Type<
  typeof FaqQuestionsyliusshopfaqtopicdetail
>;
export type FaqQuestionsyliusshopfaqtopicdetailEncoded = Schema.Codec.Encoded<
  typeof FaqQuestionsyliusshopfaqtopicdetail
>;

/* FaqQuestionsyliusshopfaqtopicindex */

export const FaqQuestionsyliusshopfaqtopicindex = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.annotate({ default: '' }),
    priority: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    question: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    slug: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'FaqQuestionsyliusshopfaqtopicindex' });
export type FaqQuestionsyliusshopfaqtopicindex = Schema.Schema.Type<
  typeof FaqQuestionsyliusshopfaqtopicindex
>;
export type FaqQuestionsyliusshopfaqtopicindexEncoded = Schema.Codec.Encoded<
  typeof FaqQuestionsyliusshopfaqtopicindex
>;

/* FaqTopicjsonldsyliusshopfaqquestionindex */

export const FaqTopicjsonldsyliusshopfaqquestionindex = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String.annotate({ default: '' }),
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    description: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    slug: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'FaqTopicjsonldsyliusshopfaqquestionindex' });
export type FaqTopicjsonldsyliusshopfaqquestionindex = Schema.Schema.Type<
  typeof FaqTopicjsonldsyliusshopfaqquestionindex
>;
export type FaqTopicjsonldsyliusshopfaqquestionindexEncoded = Schema.Codec.Encoded<
  typeof FaqTopicjsonldsyliusshopfaqquestionindex
>;

/* FaqQuestionjsonldsyliusshopfaqtopicdetail */

export const FaqQuestionjsonldsyliusshopfaqtopicdetail = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String.annotate({ default: '' }),
    priority: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    question: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    answer: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    slug: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'FaqQuestionjsonldsyliusshopfaqtopicdetail' });
export type FaqQuestionjsonldsyliusshopfaqtopicdetail = Schema.Schema.Type<
  typeof FaqQuestionjsonldsyliusshopfaqtopicdetail
>;
export type FaqQuestionjsonldsyliusshopfaqtopicdetailEncoded = Schema.Codec.Encoded<
  typeof FaqQuestionjsonldsyliusshopfaqtopicdetail
>;

/* FaqQuestionjsonldsyliusshopfaqtopicindex */

export const FaqQuestionjsonldsyliusshopfaqtopicindex = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String.annotate({ default: '' }),
    priority: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    question: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    slug: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'FaqQuestionjsonldsyliusshopfaqtopicindex' });
export type FaqQuestionjsonldsyliusshopfaqtopicindex = Schema.Schema.Type<
  typeof FaqQuestionjsonldsyliusshopfaqtopicindex
>;
export type FaqQuestionjsonldsyliusshopfaqtopicindexEncoded = Schema.Codec.Encoded<
  typeof FaqQuestionjsonldsyliusshopfaqtopicindex
>;

/* FavouriteListsyliusshopfavoritelistindex */

export const FavouriteListsyliusshopfavoritelistindex = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(Schema.String.annotate({ readOnly: true, format: 'uuid' })),
    name: Schema.String.annotate({ default: '' }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'FavouriteListsyliusshopfavoritelistindex' });
export type FavouriteListsyliusshopfavoritelistindex = Schema.Schema.Type<
  typeof FavouriteListsyliusshopfavoritelistindex
>;
export type FavouriteListsyliusshopfavoritelistindexEncoded = Schema.Codec.Encoded<
  typeof FavouriteListsyliusshopfavoritelistindex
>;

/* FavouriteListsyliusshopfavoritelistshow */

export const FavouriteListsyliusshopfavoritelistshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(Schema.String.annotate({ readOnly: true, format: 'uuid' })),
    name: Schema.String.annotate({ default: '' }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'FavouriteListsyliusshopfavoritelistshow' });
export type FavouriteListsyliusshopfavoritelistshow = Schema.Schema.Type<
  typeof FavouriteListsyliusshopfavoritelistshow
>;
export type FavouriteListsyliusshopfavoritelistshowEncoded = Schema.Codec.Encoded<
  typeof FavouriteListsyliusshopfavoritelistshow
>;

/* FavouriteListsyliusshopfavoritelistshowproducts */

export const FavouriteListsyliusshopfavoritelistshowproducts = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(Schema.String.annotate({ readOnly: true, format: 'uuid' })),
    name: Schema.String.annotate({ default: '' }),
    productVariantCodes: Schema.optionalKey(
      Schema.Array(Schema.String).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'FavouriteListsyliusshopfavoritelistshowproducts' });
export type FavouriteListsyliusshopfavoritelistshowproducts = Schema.Schema.Type<
  typeof FavouriteListsyliusshopfavoritelistshowproducts
>;
export type FavouriteListsyliusshopfavoritelistshowproductsEncoded = Schema.Codec.Encoded<
  typeof FavouriteListsyliusshopfavoritelistshowproducts
>;

/* FavouriteListjsonldsyliusshopfavoritelistindex */

export const FavouriteListjsonldsyliusshopfavoritelistindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(Schema.String.annotate({ readOnly: true, format: 'uuid' })),
    name: Schema.String.annotate({ default: '' }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'FavouriteListjsonldsyliusshopfavoritelistindex' });
export type FavouriteListjsonldsyliusshopfavoritelistindex = Schema.Schema.Type<
  typeof FavouriteListjsonldsyliusshopfavoritelistindex
>;
export type FavouriteListjsonldsyliusshopfavoritelistindexEncoded = Schema.Codec.Encoded<
  typeof FavouriteListjsonldsyliusshopfavoritelistindex
>;

/* FavouriteListjsonldsyliusshopfavoritelistshow */

export const FavouriteListjsonldsyliusshopfavoritelistshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(Schema.String.annotate({ readOnly: true, format: 'uuid' })),
    name: Schema.String.annotate({ default: '' }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'FavouriteListjsonldsyliusshopfavoritelistshow' });
export type FavouriteListjsonldsyliusshopfavoritelistshow = Schema.Schema.Type<
  typeof FavouriteListjsonldsyliusshopfavoritelistshow
>;
export type FavouriteListjsonldsyliusshopfavoritelistshowEncoded = Schema.Codec.Encoded<
  typeof FavouriteListjsonldsyliusshopfavoritelistshow
>;

/* FavouriteListjsonldsyliusshopfavoritelistshowproducts */

export const FavouriteListjsonldsyliusshopfavoritelistshowproducts = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(Schema.String.annotate({ readOnly: true, format: 'uuid' })),
    name: Schema.String.annotate({ default: '' }),
    productVariantCodes: Schema.optionalKey(
      Schema.Array(Schema.String).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'FavouriteListjsonldsyliusshopfavoritelistshowproducts' });
export type FavouriteListjsonldsyliusshopfavoritelistshowproducts = Schema.Schema.Type<
  typeof FavouriteListjsonldsyliusshopfavoritelistshowproducts
>;
export type FavouriteListjsonldsyliusshopfavoritelistshowproductsEncoded = Schema.Codec.Encoded<
  typeof FavouriteListjsonldsyliusshopfavoritelistshowproducts
>;

/* FeedCategorymultipart */

export const FeedCategorymultipart = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(Schema.String.annotate({ readOnly: true, format: 'uuid' })),
    taxon: Schema.String.annotate({ format: 'iri-reference' }),
    feedCode: Schema.Literals([
      'google_product_category',
      'google_product_type',
      'heureka_category_text',
      'zbozi_category_id',
    ]),
    channel: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'iri-reference' }),
    text: Schema.String,
    textNotNull: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'FeedCategorymultipart' });
export type FeedCategorymultipart = Schema.Schema.Type<typeof FeedCategorymultipart>;
export type FeedCategorymultipartEncoded = Schema.Codec.Encoded<typeof FeedCategorymultipart>;

/* GatewayConfigsyliusadminpaymentmethodcreate */

export const GatewayConfigsyliusadminpaymentmethodcreate = Schema.StructWithRest(
  Schema.Struct({
    factoryName: Schema.String,
    gatewayName: Schema.String,
    config: Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'GatewayConfigsyliusadminpaymentmethodcreate' });
export type GatewayConfigsyliusadminpaymentmethodcreate = Schema.Schema.Type<
  typeof GatewayConfigsyliusadminpaymentmethodcreate
>;
export type GatewayConfigsyliusadminpaymentmethodcreateEncoded = Schema.Codec.Encoded<
  typeof GatewayConfigsyliusadminpaymentmethodcreate
>;

/* GatewayConfigsyliusadminpaymentmethodindex */

export const GatewayConfigsyliusadminpaymentmethodindex = Schema.StructWithRest(
  Schema.Struct({
    factoryName: Schema.String,
    gatewayName: Schema.String,
    config: Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'GatewayConfigsyliusadminpaymentmethodindex' });
export type GatewayConfigsyliusadminpaymentmethodindex = Schema.Schema.Type<
  typeof GatewayConfigsyliusadminpaymentmethodindex
>;
export type GatewayConfigsyliusadminpaymentmethodindexEncoded = Schema.Codec.Encoded<
  typeof GatewayConfigsyliusadminpaymentmethodindex
>;

/* GatewayConfigsyliusadminpaymentmethodshow */

export const GatewayConfigsyliusadminpaymentmethodshow = Schema.StructWithRest(
  Schema.Struct({
    factoryName: Schema.String,
    gatewayName: Schema.String,
    config: Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'GatewayConfigsyliusadminpaymentmethodshow' });
export type GatewayConfigsyliusadminpaymentmethodshow = Schema.Schema.Type<
  typeof GatewayConfigsyliusadminpaymentmethodshow
>;
export type GatewayConfigsyliusadminpaymentmethodshowEncoded = Schema.Codec.Encoded<
  typeof GatewayConfigsyliusadminpaymentmethodshow
>;

/* GatewayConfigsyliusadminpaymentmethodupdate */

export const GatewayConfigsyliusadminpaymentmethodupdate = Schema.StructWithRest(
  Schema.Struct({
    config: Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'GatewayConfigsyliusadminpaymentmethodupdate' });
export type GatewayConfigsyliusadminpaymentmethodupdate = Schema.Schema.Type<
  typeof GatewayConfigsyliusadminpaymentmethodupdate
>;
export type GatewayConfigsyliusadminpaymentmethodupdateEncoded = Schema.Codec.Encoded<
  typeof GatewayConfigsyliusadminpaymentmethodupdate
>;

/* GatewayConfigjsonldsyliusadminpaymentmethodcreate */

export const GatewayConfigjsonldsyliusadminpaymentmethodcreate = Schema.StructWithRest(
  Schema.Struct({
    factoryName: Schema.String,
    gatewayName: Schema.String,
    config: Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'GatewayConfigjsonldsyliusadminpaymentmethodcreate' });
export type GatewayConfigjsonldsyliusadminpaymentmethodcreate = Schema.Schema.Type<
  typeof GatewayConfigjsonldsyliusadminpaymentmethodcreate
>;
export type GatewayConfigjsonldsyliusadminpaymentmethodcreateEncoded = Schema.Codec.Encoded<
  typeof GatewayConfigjsonldsyliusadminpaymentmethodcreate
>;

/* GatewayConfigjsonldsyliusadminpaymentmethodindex */

export const GatewayConfigjsonldsyliusadminpaymentmethodindex = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    factoryName: Schema.String,
    gatewayName: Schema.String,
    config: Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'GatewayConfigjsonldsyliusadminpaymentmethodindex' });
export type GatewayConfigjsonldsyliusadminpaymentmethodindex = Schema.Schema.Type<
  typeof GatewayConfigjsonldsyliusadminpaymentmethodindex
>;
export type GatewayConfigjsonldsyliusadminpaymentmethodindexEncoded = Schema.Codec.Encoded<
  typeof GatewayConfigjsonldsyliusadminpaymentmethodindex
>;

/* GatewayConfigjsonldsyliusadminpaymentmethodshow */

export const GatewayConfigjsonldsyliusadminpaymentmethodshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    factoryName: Schema.String,
    gatewayName: Schema.String,
    config: Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'GatewayConfigjsonldsyliusadminpaymentmethodshow' });
export type GatewayConfigjsonldsyliusadminpaymentmethodshow = Schema.Schema.Type<
  typeof GatewayConfigjsonldsyliusadminpaymentmethodshow
>;
export type GatewayConfigjsonldsyliusadminpaymentmethodshowEncoded = Schema.Codec.Encoded<
  typeof GatewayConfigjsonldsyliusadminpaymentmethodshow
>;

/* GatewayConfigjsonldsyliusadminpaymentmethodupdate */

export const GatewayConfigjsonldsyliusadminpaymentmethodupdate = Schema.StructWithRest(
  Schema.Struct({
    config: Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'GatewayConfigjsonldsyliusadminpaymentmethodupdate' });
export type GatewayConfigjsonldsyliusadminpaymentmethodupdate = Schema.Schema.Type<
  typeof GatewayConfigjsonldsyliusadminpaymentmethodupdate
>;
export type GatewayConfigjsonldsyliusadminpaymentmethodupdateEncoded = Schema.Codec.Encoded<
  typeof GatewayConfigjsonldsyliusadminpaymentmethodupdate
>;

/* GlossaryAlphabetshopglossaryshowalphabet */

export const GlossaryAlphabetshopglossaryshowalphabet = Schema.StructWithRest(
  Schema.Struct({ alphabet: Schema.Array(Schema.String) }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'GlossaryAlphabetshopglossaryshowalphabet' });
export type GlossaryAlphabetshopglossaryshowalphabet = Schema.Schema.Type<
  typeof GlossaryAlphabetshopglossaryshowalphabet
>;
export type GlossaryAlphabetshopglossaryshowalphabetEncoded = Schema.Codec.Encoded<
  typeof GlossaryAlphabetshopglossaryshowalphabet
>;

/* GlossaryAlphabetjsonldshopglossaryshowalphabet */

export const GlossaryAlphabetjsonldshopglossaryshowalphabet = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    alphabet: Schema.Array(Schema.String),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'GlossaryAlphabetjsonldshopglossaryshowalphabet' });
export type GlossaryAlphabetjsonldshopglossaryshowalphabet = Schema.Schema.Type<
  typeof GlossaryAlphabetjsonldshopglossaryshowalphabet
>;
export type GlossaryAlphabetjsonldshopglossaryshowalphabetEncoded = Schema.Codec.Encoded<
  typeof GlossaryAlphabetjsonldshopglossaryshowalphabet
>;

/* GlossaryTermsyliusshopglossaryindex */

export const GlossaryTermsyliusshopglossaryindex = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(Schema.String.annotate({ readOnly: true, format: 'uuid' })),
    code: Schema.String.annotate({ default: '' }),
    enabled: Schema.Boolean.annotate({ default: true }),
    favorite: Schema.Boolean.annotate({ default: false }),
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    tooltip: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'GlossaryTermsyliusshopglossaryindex' });
export type GlossaryTermsyliusshopglossaryindex = Schema.Schema.Type<
  typeof GlossaryTermsyliusshopglossaryindex
>;
export type GlossaryTermsyliusshopglossaryindexEncoded = Schema.Codec.Encoded<
  typeof GlossaryTermsyliusshopglossaryindex
>;

/* TitleElementDTOsyliusshopglossaryshow */

export const TitleElementDTOsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    content: Schema.String,
    tag: Schema.Union([Schema.String, Schema.Null]),
    type: Schema.Literal('title').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TitleElementDTOsyliusshopglossaryshow' });
export type TitleElementDTOsyliusshopglossaryshow = Schema.Schema.Type<
  typeof TitleElementDTOsyliusshopglossaryshow
>;
export type TitleElementDTOsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof TitleElementDTOsyliusshopglossaryshow
>;

/* MarkdownTextElementDTOsyliusshopglossaryshow */

export const MarkdownTextElementDTOsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    content: Schema.String,
    type: Schema.Literal('markdown_text').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'MarkdownTextElementDTOsyliusshopglossaryshow' });
export type MarkdownTextElementDTOsyliusshopglossaryshow = Schema.Schema.Type<
  typeof MarkdownTextElementDTOsyliusshopglossaryshow
>;
export type MarkdownTextElementDTOsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof MarkdownTextElementDTOsyliusshopglossaryshow
>;

/* QuoteElementDTOsyliusshopglossaryshow */

export const QuoteElementDTOsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    content: Schema.String,
    author: Schema.Union([Schema.String, Schema.Null]),
    type: Schema.Literal('quote').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'QuoteElementDTOsyliusshopglossaryshow' });
export type QuoteElementDTOsyliusshopglossaryshow = Schema.Schema.Type<
  typeof QuoteElementDTOsyliusshopglossaryshow
>;
export type QuoteElementDTOsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof QuoteElementDTOsyliusshopglossaryshow
>;

/* ImageElementDTOsyliusshopglossaryshow */

export const ImageElementDTOsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    size: Schema.Literals(['wide', 'fit']),
    alt: Schema.Union([Schema.String, Schema.Null]),
    type: Schema.Literal('image').annotate({ readOnly: true }),
    imageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ImageElementDTOsyliusshopglossaryshow' });
export type ImageElementDTOsyliusshopglossaryshow = Schema.Schema.Type<
  typeof ImageElementDTOsyliusshopglossaryshow
>;
export type ImageElementDTOsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof ImageElementDTOsyliusshopglossaryshow
>;

/* ImageItemDTOsyliusshopglossaryshow */

export const ImageItemDTOsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    alt: Schema.Union([Schema.String, Schema.Null]),
    link: Schema.Union([Schema.String, Schema.Null]),
    linkType: Schema.Union([Schema.String, Schema.Null]),
    imageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ImageItemDTOsyliusshopglossaryshow' });
export type ImageItemDTOsyliusshopglossaryshow = Schema.Schema.Type<
  typeof ImageItemDTOsyliusshopglossaryshow
>;
export type ImageItemDTOsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof ImageItemDTOsyliusshopglossaryshow
>;

/* YoutubeElementDTOsyliusshopglossaryshow */

export const YoutubeElementDTOsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    link: Schema.String,
    type: Schema.Literal('youtube').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'YoutubeElementDTOsyliusshopglossaryshow' });
export type YoutubeElementDTOsyliusshopglossaryshow = Schema.Schema.Type<
  typeof YoutubeElementDTOsyliusshopglossaryshow
>;
export type YoutubeElementDTOsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof YoutubeElementDTOsyliusshopglossaryshow
>;

/* MarkdownTwoColumnsElementDTOsyliusshopglossaryshow */

export const MarkdownTwoColumnsElementDTOsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    left: Schema.String,
    right: Schema.String,
    type: Schema.Literal('markdown_two_columns').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'MarkdownTwoColumnsElementDTOsyliusshopglossaryshow' });
export type MarkdownTwoColumnsElementDTOsyliusshopglossaryshow = Schema.Schema.Type<
  typeof MarkdownTwoColumnsElementDTOsyliusshopglossaryshow
>;
export type MarkdownTwoColumnsElementDTOsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof MarkdownTwoColumnsElementDTOsyliusshopglossaryshow
>;

/* MarkdownThreeColumnsElementDTOsyliusshopglossaryshow */

export const MarkdownThreeColumnsElementDTOsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    left: Schema.String,
    center: Schema.String,
    right: Schema.String,
    type: Schema.Literal('markdown_three_columns').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'MarkdownThreeColumnsElementDTOsyliusshopglossaryshow' });
export type MarkdownThreeColumnsElementDTOsyliusshopglossaryshow = Schema.Schema.Type<
  typeof MarkdownThreeColumnsElementDTOsyliusshopglossaryshow
>;
export type MarkdownThreeColumnsElementDTOsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof MarkdownThreeColumnsElementDTOsyliusshopglossaryshow
>;

/* RetinoWidgetElementDTOsyliusshopglossaryshow */

export const RetinoWidgetElementDTOsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    companyId: Schema.String,
    type: Schema.Literal('retino-widget').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'RetinoWidgetElementDTOsyliusshopglossaryshow' });
export type RetinoWidgetElementDTOsyliusshopglossaryshow = Schema.Schema.Type<
  typeof RetinoWidgetElementDTOsyliusshopglossaryshow
>;
export type RetinoWidgetElementDTOsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof RetinoWidgetElementDTOsyliusshopglossaryshow
>;

/* AdvantagesElementDTOsyliusshopglossaryshow */

export const AdvantagesElementDTOsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    textOne: Schema.String,
    textTwo: Schema.String,
    textThree: Schema.String,
    textFour: Schema.String,
    type: Schema.Literal('advantages').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'AdvantagesElementDTOsyliusshopglossaryshow' });
export type AdvantagesElementDTOsyliusshopglossaryshow = Schema.Schema.Type<
  typeof AdvantagesElementDTOsyliusshopglossaryshow
>;
export type AdvantagesElementDTOsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof AdvantagesElementDTOsyliusshopglossaryshow
>;

/* WhiteBoxElementDTOsyliusshopglossaryshow */

export const WhiteBoxElementDTOsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    text: Schema.String,
    type: Schema.Literal('white_box').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'WhiteBoxElementDTOsyliusshopglossaryshow' });
export type WhiteBoxElementDTOsyliusshopglossaryshow = Schema.Schema.Type<
  typeof WhiteBoxElementDTOsyliusshopglossaryshow
>;
export type WhiteBoxElementDTOsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof WhiteBoxElementDTOsyliusshopglossaryshow
>;

/* ImageClearItemDTOsyliusshopglossaryshow */

export const ImageClearItemDTOsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    alt: Schema.Union([Schema.String, Schema.Null]),
    imageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ImageClearItemDTOsyliusshopglossaryshow' });
export type ImageClearItemDTOsyliusshopglossaryshow = Schema.Schema.Type<
  typeof ImageClearItemDTOsyliusshopglossaryshow
>;
export type ImageClearItemDTOsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof ImageClearItemDTOsyliusshopglossaryshow
>;

/* BaseButtonElementDTOsyliusshopglossaryshow */

export const BaseButtonElementDTOsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    link: Schema.String,
    text: Schema.String,
    type: Schema.Literal('base_button').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'BaseButtonElementDTOsyliusshopglossaryshow' });
export type BaseButtonElementDTOsyliusshopglossaryshow = Schema.Schema.Type<
  typeof BaseButtonElementDTOsyliusshopglossaryshow
>;
export type BaseButtonElementDTOsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof BaseButtonElementDTOsyliusshopglossaryshow
>;

/* ProductListElementDTOsyliusshopglossaryshow */

export const ProductListElementDTOsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    style: Schema.Literals(['withoutDescription', 'normal']),
    products: Schema.Array(Schema.String),
    productsPerPage: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    type: Schema.Literal('product_list').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductListElementDTOsyliusshopglossaryshow' });
export type ProductListElementDTOsyliusshopglossaryshow = Schema.Schema.Type<
  typeof ProductListElementDTOsyliusshopglossaryshow
>;
export type ProductListElementDTOsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof ProductListElementDTOsyliusshopglossaryshow
>;

/* TableCellItemDTOsyliusshopglossaryshow */

export const TableCellItemDTOsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({ content: Schema.String, color: Schema.Literals(['black', 'gray', 'white']) }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TableCellItemDTOsyliusshopglossaryshow' });
export type TableCellItemDTOsyliusshopglossaryshow = Schema.Schema.Type<
  typeof TableCellItemDTOsyliusshopglossaryshow
>;
export type TableCellItemDTOsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof TableCellItemDTOsyliusshopglossaryshow
>;

/* GlossaryTermjsonldsyliusshopglossaryindex */

export const GlossaryTermjsonldsyliusshopglossaryindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(Schema.String.annotate({ readOnly: true, format: 'uuid' })),
    code: Schema.String.annotate({ default: '' }),
    enabled: Schema.Boolean.annotate({ default: true }),
    favorite: Schema.Boolean.annotate({ default: false }),
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    tooltip: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'GlossaryTermjsonldsyliusshopglossaryindex' });
export type GlossaryTermjsonldsyliusshopglossaryindex = Schema.Schema.Type<
  typeof GlossaryTermjsonldsyliusshopglossaryindex
>;
export type GlossaryTermjsonldsyliusshopglossaryindexEncoded = Schema.Codec.Encoded<
  typeof GlossaryTermjsonldsyliusshopglossaryindex
>;

/* TitleElementDTOjsonldsyliusshopglossaryshow */

export const TitleElementDTOjsonldsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    content: Schema.String,
    tag: Schema.Union([Schema.String, Schema.Null]),
    type: Schema.Literal('title').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TitleElementDTOjsonldsyliusshopglossaryshow' });
export type TitleElementDTOjsonldsyliusshopglossaryshow = Schema.Schema.Type<
  typeof TitleElementDTOjsonldsyliusshopglossaryshow
>;
export type TitleElementDTOjsonldsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof TitleElementDTOjsonldsyliusshopglossaryshow
>;

/* MarkdownTextElementDTOjsonldsyliusshopglossaryshow */

export const MarkdownTextElementDTOjsonldsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    content: Schema.String,
    type: Schema.Literal('markdown_text').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'MarkdownTextElementDTOjsonldsyliusshopglossaryshow' });
export type MarkdownTextElementDTOjsonldsyliusshopglossaryshow = Schema.Schema.Type<
  typeof MarkdownTextElementDTOjsonldsyliusshopglossaryshow
>;
export type MarkdownTextElementDTOjsonldsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof MarkdownTextElementDTOjsonldsyliusshopglossaryshow
>;

/* QuoteElementDTOjsonldsyliusshopglossaryshow */

export const QuoteElementDTOjsonldsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    content: Schema.String,
    author: Schema.Union([Schema.String, Schema.Null]),
    type: Schema.Literal('quote').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'QuoteElementDTOjsonldsyliusshopglossaryshow' });
export type QuoteElementDTOjsonldsyliusshopglossaryshow = Schema.Schema.Type<
  typeof QuoteElementDTOjsonldsyliusshopglossaryshow
>;
export type QuoteElementDTOjsonldsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof QuoteElementDTOjsonldsyliusshopglossaryshow
>;

/* ImageElementDTOjsonldsyliusshopglossaryshow */

export const ImageElementDTOjsonldsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    size: Schema.Literals(['wide', 'fit']),
    alt: Schema.Union([Schema.String, Schema.Null]),
    type: Schema.Literal('image').annotate({ readOnly: true }),
    imageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ImageElementDTOjsonldsyliusshopglossaryshow' });
export type ImageElementDTOjsonldsyliusshopglossaryshow = Schema.Schema.Type<
  typeof ImageElementDTOjsonldsyliusshopglossaryshow
>;
export type ImageElementDTOjsonldsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof ImageElementDTOjsonldsyliusshopglossaryshow
>;

/* ImageItemDTOjsonldsyliusshopglossaryshow */

export const ImageItemDTOjsonldsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    alt: Schema.Union([Schema.String, Schema.Null]),
    link: Schema.Union([Schema.String, Schema.Null]),
    linkType: Schema.Union([Schema.String, Schema.Null]),
    imageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ImageItemDTOjsonldsyliusshopglossaryshow' });
export type ImageItemDTOjsonldsyliusshopglossaryshow = Schema.Schema.Type<
  typeof ImageItemDTOjsonldsyliusshopglossaryshow
>;
export type ImageItemDTOjsonldsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof ImageItemDTOjsonldsyliusshopglossaryshow
>;

/* YoutubeElementDTOjsonldsyliusshopglossaryshow */

export const YoutubeElementDTOjsonldsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    link: Schema.String,
    type: Schema.Literal('youtube').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'YoutubeElementDTOjsonldsyliusshopglossaryshow' });
export type YoutubeElementDTOjsonldsyliusshopglossaryshow = Schema.Schema.Type<
  typeof YoutubeElementDTOjsonldsyliusshopglossaryshow
>;
export type YoutubeElementDTOjsonldsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof YoutubeElementDTOjsonldsyliusshopglossaryshow
>;

/* MarkdownTwoColumnsElementDTOjsonldsyliusshopglossaryshow */

export const MarkdownTwoColumnsElementDTOjsonldsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    left: Schema.String,
    right: Schema.String,
    type: Schema.Literal('markdown_two_columns').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'MarkdownTwoColumnsElementDTOjsonldsyliusshopglossaryshow' });
export type MarkdownTwoColumnsElementDTOjsonldsyliusshopglossaryshow = Schema.Schema.Type<
  typeof MarkdownTwoColumnsElementDTOjsonldsyliusshopglossaryshow
>;
export type MarkdownTwoColumnsElementDTOjsonldsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof MarkdownTwoColumnsElementDTOjsonldsyliusshopglossaryshow
>;

/* MarkdownThreeColumnsElementDTOjsonldsyliusshopglossaryshow */

export const MarkdownThreeColumnsElementDTOjsonldsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    left: Schema.String,
    center: Schema.String,
    right: Schema.String,
    type: Schema.Literal('markdown_three_columns').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'MarkdownThreeColumnsElementDTOjsonldsyliusshopglossaryshow' });
export type MarkdownThreeColumnsElementDTOjsonldsyliusshopglossaryshow = Schema.Schema.Type<
  typeof MarkdownThreeColumnsElementDTOjsonldsyliusshopglossaryshow
>;
export type MarkdownThreeColumnsElementDTOjsonldsyliusshopglossaryshowEncoded =
  Schema.Codec.Encoded<typeof MarkdownThreeColumnsElementDTOjsonldsyliusshopglossaryshow>;

/* RetinoWidgetElementDTOjsonldsyliusshopglossaryshow */

export const RetinoWidgetElementDTOjsonldsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    companyId: Schema.String,
    type: Schema.Literal('retino-widget').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'RetinoWidgetElementDTOjsonldsyliusshopglossaryshow' });
export type RetinoWidgetElementDTOjsonldsyliusshopglossaryshow = Schema.Schema.Type<
  typeof RetinoWidgetElementDTOjsonldsyliusshopglossaryshow
>;
export type RetinoWidgetElementDTOjsonldsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof RetinoWidgetElementDTOjsonldsyliusshopglossaryshow
>;

/* AdvantagesElementDTOjsonldsyliusshopglossaryshow */

export const AdvantagesElementDTOjsonldsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    textOne: Schema.String,
    textTwo: Schema.String,
    textThree: Schema.String,
    textFour: Schema.String,
    type: Schema.Literal('advantages').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'AdvantagesElementDTOjsonldsyliusshopglossaryshow' });
export type AdvantagesElementDTOjsonldsyliusshopglossaryshow = Schema.Schema.Type<
  typeof AdvantagesElementDTOjsonldsyliusshopglossaryshow
>;
export type AdvantagesElementDTOjsonldsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof AdvantagesElementDTOjsonldsyliusshopglossaryshow
>;

/* WhiteBoxElementDTOjsonldsyliusshopglossaryshow */

export const WhiteBoxElementDTOjsonldsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    text: Schema.String,
    type: Schema.Literal('white_box').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'WhiteBoxElementDTOjsonldsyliusshopglossaryshow' });
export type WhiteBoxElementDTOjsonldsyliusshopglossaryshow = Schema.Schema.Type<
  typeof WhiteBoxElementDTOjsonldsyliusshopglossaryshow
>;
export type WhiteBoxElementDTOjsonldsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof WhiteBoxElementDTOjsonldsyliusshopglossaryshow
>;

/* ImageClearItemDTOjsonldsyliusshopglossaryshow */

export const ImageClearItemDTOjsonldsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    alt: Schema.Union([Schema.String, Schema.Null]),
    imageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ImageClearItemDTOjsonldsyliusshopglossaryshow' });
export type ImageClearItemDTOjsonldsyliusshopglossaryshow = Schema.Schema.Type<
  typeof ImageClearItemDTOjsonldsyliusshopglossaryshow
>;
export type ImageClearItemDTOjsonldsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof ImageClearItemDTOjsonldsyliusshopglossaryshow
>;

/* BaseButtonElementDTOjsonldsyliusshopglossaryshow */

export const BaseButtonElementDTOjsonldsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    link: Schema.String,
    text: Schema.String,
    type: Schema.Literal('base_button').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'BaseButtonElementDTOjsonldsyliusshopglossaryshow' });
export type BaseButtonElementDTOjsonldsyliusshopglossaryshow = Schema.Schema.Type<
  typeof BaseButtonElementDTOjsonldsyliusshopglossaryshow
>;
export type BaseButtonElementDTOjsonldsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof BaseButtonElementDTOjsonldsyliusshopglossaryshow
>;

/* ProductListElementDTOjsonldsyliusshopglossaryshow */

export const ProductListElementDTOjsonldsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    style: Schema.Literals(['withoutDescription', 'normal']),
    products: Schema.Array(Schema.String),
    productsPerPage: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    type: Schema.Literal('product_list').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductListElementDTOjsonldsyliusshopglossaryshow' });
export type ProductListElementDTOjsonldsyliusshopglossaryshow = Schema.Schema.Type<
  typeof ProductListElementDTOjsonldsyliusshopglossaryshow
>;
export type ProductListElementDTOjsonldsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof ProductListElementDTOjsonldsyliusshopglossaryshow
>;

/* TableCellItemDTOjsonldsyliusshopglossaryshow */

export const TableCellItemDTOjsonldsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    content: Schema.String,
    color: Schema.Literals(['black', 'gray', 'white']),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TableCellItemDTOjsonldsyliusshopglossaryshow' });
export type TableCellItemDTOjsonldsyliusshopglossaryshow = Schema.Schema.Type<
  typeof TableCellItemDTOjsonldsyliusshopglossaryshow
>;
export type TableCellItemDTOjsonldsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof TableCellItemDTOjsonldsyliusshopglossaryshow
>;

/* Taxonsyliusshophomepageshow */

export const Taxonsyliusshophomepageshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    nameInTaxonList: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonsyliusshophomepageshow' });
export type Taxonsyliusshophomepageshow = Schema.Schema.Type<typeof Taxonsyliusshophomepageshow>;
export type TaxonsyliusshophomepageshowEncoded = Schema.Codec.Encoded<
  typeof Taxonsyliusshophomepageshow
>;

/* Taxonjsonldsyliusshophomepageshow */

export const Taxonjsonldsyliusshophomepageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    nameInTaxonList: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonjsonldsyliusshophomepageshow' });
export type Taxonjsonldsyliusshophomepageshow = Schema.Schema.Type<
  typeof Taxonjsonldsyliusshophomepageshow
>;
export type TaxonjsonldsyliusshophomepageshowEncoded = Schema.Codec.Encoded<
  typeof Taxonjsonldsyliusshophomepageshow
>;

/* Labelsyliusshopproductindex */

export const Labelsyliusshopproductindex = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.annotate({ default: '' }),
    color: Schema.String.annotate({ default: '' }),
    textColor: Schema.String.annotate({ default: '' }),
    icon: Schema.Union([Schema.String, Schema.Null]),
    name: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Labelsyliusshopproductindex' });
export type Labelsyliusshopproductindex = Schema.Schema.Type<typeof Labelsyliusshopproductindex>;
export type LabelsyliusshopproductindexEncoded = Schema.Codec.Encoded<
  typeof Labelsyliusshopproductindex
>;

/* Labelsyliusshopproductvariantindex */

export const Labelsyliusshopproductvariantindex = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.annotate({ default: '' }),
    color: Schema.String.annotate({ default: '' }),
    textColor: Schema.String.annotate({ default: '' }),
    icon: Schema.Union([Schema.String, Schema.Null]),
    name: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Labelsyliusshopproductvariantindex' });
export type Labelsyliusshopproductvariantindex = Schema.Schema.Type<
  typeof Labelsyliusshopproductvariantindex
>;
export type LabelsyliusshopproductvariantindexEncoded = Schema.Codec.Encoded<
  typeof Labelsyliusshopproductvariantindex
>;

/* Labelsyliusshopproductvariantshow */

export const Labelsyliusshopproductvariantshow = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.annotate({ default: '' }),
    color: Schema.String.annotate({ default: '' }),
    textColor: Schema.String.annotate({ default: '' }),
    icon: Schema.Union([Schema.String, Schema.Null]),
    name: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Labelsyliusshopproductvariantshow' });
export type Labelsyliusshopproductvariantshow = Schema.Schema.Type<
  typeof Labelsyliusshopproductvariantshow
>;
export type LabelsyliusshopproductvariantshowEncoded = Schema.Codec.Encoded<
  typeof Labelsyliusshopproductvariantshow
>;

/* Labelsyliusshopproductvariantshowdetail */

export const Labelsyliusshopproductvariantshowdetail = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.annotate({ default: '' }),
    color: Schema.String.annotate({ default: '' }),
    textColor: Schema.String.annotate({ default: '' }),
    icon: Schema.Union([Schema.String, Schema.Null]),
    name: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Labelsyliusshopproductvariantshowdetail' });
export type Labelsyliusshopproductvariantshowdetail = Schema.Schema.Type<
  typeof Labelsyliusshopproductvariantshowdetail
>;
export type LabelsyliusshopproductvariantshowdetailEncoded = Schema.Codec.Encoded<
  typeof Labelsyliusshopproductvariantshowdetail
>;

/* Labeljsonldsyliusshopproductindex */

export const Labeljsonldsyliusshopproductindex = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String.annotate({ default: '' }),
    color: Schema.String.annotate({ default: '' }),
    textColor: Schema.String.annotate({ default: '' }),
    icon: Schema.Union([Schema.String, Schema.Null]),
    name: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Labeljsonldsyliusshopproductindex' });
export type Labeljsonldsyliusshopproductindex = Schema.Schema.Type<
  typeof Labeljsonldsyliusshopproductindex
>;
export type LabeljsonldsyliusshopproductindexEncoded = Schema.Codec.Encoded<
  typeof Labeljsonldsyliusshopproductindex
>;

/* Labeljsonldsyliusshopproductvariantindex */

export const Labeljsonldsyliusshopproductvariantindex = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String.annotate({ default: '' }),
    color: Schema.String.annotate({ default: '' }),
    textColor: Schema.String.annotate({ default: '' }),
    icon: Schema.Union([Schema.String, Schema.Null]),
    name: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Labeljsonldsyliusshopproductvariantindex' });
export type Labeljsonldsyliusshopproductvariantindex = Schema.Schema.Type<
  typeof Labeljsonldsyliusshopproductvariantindex
>;
export type LabeljsonldsyliusshopproductvariantindexEncoded = Schema.Codec.Encoded<
  typeof Labeljsonldsyliusshopproductvariantindex
>;

/* Labeljsonldsyliusshopproductvariantshow */

export const Labeljsonldsyliusshopproductvariantshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String.annotate({ default: '' }),
    color: Schema.String.annotate({ default: '' }),
    textColor: Schema.String.annotate({ default: '' }),
    icon: Schema.Union([Schema.String, Schema.Null]),
    name: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Labeljsonldsyliusshopproductvariantshow' });
export type Labeljsonldsyliusshopproductvariantshow = Schema.Schema.Type<
  typeof Labeljsonldsyliusshopproductvariantshow
>;
export type LabeljsonldsyliusshopproductvariantshowEncoded = Schema.Codec.Encoded<
  typeof Labeljsonldsyliusshopproductvariantshow
>;

/* Labeljsonldsyliusshopproductvariantshowdetail */

export const Labeljsonldsyliusshopproductvariantshowdetail = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String.annotate({ default: '' }),
    color: Schema.String.annotate({ default: '' }),
    textColor: Schema.String.annotate({ default: '' }),
    icon: Schema.Union([Schema.String, Schema.Null]),
    name: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Labeljsonldsyliusshopproductvariantshowdetail' });
export type Labeljsonldsyliusshopproductvariantshowdetail = Schema.Schema.Type<
  typeof Labeljsonldsyliusshopproductvariantshowdetail
>;
export type LabeljsonldsyliusshopproductvariantshowdetailEncoded = Schema.Codec.Encoded<
  typeof Labeljsonldsyliusshopproductvariantshowdetail
>;

/* Localesyliusadminlocalecreate */

export const Localesyliusadminlocalecreate = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.check(
      Schema.isMaxLength(10).annotate({ expected: 'a value with a length of at most 10' })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Localesyliusadminlocalecreate' });
export type Localesyliusadminlocalecreate = Schema.Schema.Type<
  typeof Localesyliusadminlocalecreate
>;
export type LocalesyliusadminlocalecreateEncoded = Schema.Codec.Encoded<
  typeof Localesyliusadminlocalecreate
>;

/* Localesyliusadminlocaleindex */

export const Localesyliusadminlocaleindex = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Localesyliusadminlocaleindex' });
export type Localesyliusadminlocaleindex = Schema.Schema.Type<typeof Localesyliusadminlocaleindex>;
export type LocalesyliusadminlocaleindexEncoded = Schema.Codec.Encoded<
  typeof Localesyliusadminlocaleindex
>;

/* Localesyliusadminlocaleshow */

export const Localesyliusadminlocaleshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Localesyliusadminlocaleshow' });
export type Localesyliusadminlocaleshow = Schema.Schema.Type<typeof Localesyliusadminlocaleshow>;
export type LocalesyliusadminlocaleshowEncoded = Schema.Codec.Encoded<
  typeof Localesyliusadminlocaleshow
>;

/* Localesyliusshoplocaleindex */

export const Localesyliusshoplocaleindex = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String,
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Localesyliusshoplocaleindex' });
export type Localesyliusshoplocaleindex = Schema.Schema.Type<typeof Localesyliusshoplocaleindex>;
export type LocalesyliusshoplocaleindexEncoded = Schema.Codec.Encoded<
  typeof Localesyliusshoplocaleindex
>;

/* Localesyliusshoplocaleshow */

export const Localesyliusshoplocaleshow = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String,
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Localesyliusshoplocaleshow' });
export type Localesyliusshoplocaleshow = Schema.Schema.Type<typeof Localesyliusshoplocaleshow>;
export type LocalesyliusshoplocaleshowEncoded = Schema.Codec.Encoded<
  typeof Localesyliusshoplocaleshow
>;

/* Localejsonldsyliusadminlocalecreate */

export const Localejsonldsyliusadminlocalecreate = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.check(
      Schema.isMaxLength(10).annotate({ expected: 'a value with a length of at most 10' })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Localejsonldsyliusadminlocalecreate' });
export type Localejsonldsyliusadminlocalecreate = Schema.Schema.Type<
  typeof Localejsonldsyliusadminlocalecreate
>;
export type LocalejsonldsyliusadminlocalecreateEncoded = Schema.Codec.Encoded<
  typeof Localejsonldsyliusadminlocalecreate
>;

/* Localejsonldsyliusadminlocaleindex */

export const Localejsonldsyliusadminlocaleindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Localejsonldsyliusadminlocaleindex' });
export type Localejsonldsyliusadminlocaleindex = Schema.Schema.Type<
  typeof Localejsonldsyliusadminlocaleindex
>;
export type LocalejsonldsyliusadminlocaleindexEncoded = Schema.Codec.Encoded<
  typeof Localejsonldsyliusadminlocaleindex
>;

/* Localejsonldsyliusadminlocaleshow */

export const Localejsonldsyliusadminlocaleshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Localejsonldsyliusadminlocaleshow' });
export type Localejsonldsyliusadminlocaleshow = Schema.Schema.Type<
  typeof Localejsonldsyliusadminlocaleshow
>;
export type LocalejsonldsyliusadminlocaleshowEncoded = Schema.Codec.Encoded<
  typeof Localejsonldsyliusadminlocaleshow
>;

/* Localejsonldsyliusshoplocaleindex */

export const Localejsonldsyliusshoplocaleindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String,
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Localejsonldsyliusshoplocaleindex' });
export type Localejsonldsyliusshoplocaleindex = Schema.Schema.Type<
  typeof Localejsonldsyliusshoplocaleindex
>;
export type LocalejsonldsyliusshoplocaleindexEncoded = Schema.Codec.Encoded<
  typeof Localejsonldsyliusshoplocaleindex
>;

/* Localejsonldsyliusshoplocaleshow */

export const Localejsonldsyliusshoplocaleshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String,
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Localejsonldsyliusshoplocaleshow' });
export type Localejsonldsyliusshoplocaleshow = Schema.Schema.Type<
  typeof Localejsonldsyliusshoplocaleshow
>;
export type LocalejsonldsyliusshoplocaleshowEncoded = Schema.Codec.Encoded<
  typeof Localejsonldsyliusshoplocaleshow
>;

/* NewsletterSubscribeInput */

export const NewsletterSubscribeInput = Schema.StructWithRest(
  Schema.Struct({
    email: Schema.String,
    name: Schema.Union([Schema.String, Schema.Null]),
    surname: Schema.Union([Schema.String, Schema.Null]),
    company: Schema.Union([Schema.String, Schema.Null]),
    city: Schema.Union([Schema.String, Schema.Null]),
    street: Schema.Union([Schema.String, Schema.Null]),
    zip: Schema.Union([Schema.String, Schema.Null]),
    country: Schema.Union([Schema.String, Schema.Null]),
    phone: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'NewsletterSubscribeInput' });
export type NewsletterSubscribeInput = Schema.Schema.Type<typeof NewsletterSubscribeInput>;
export type NewsletterSubscribeInputEncoded = Schema.Codec.Encoded<typeof NewsletterSubscribeInput>;

/* NewsletterSubscribeInputjsonld */

export const NewsletterSubscribeInputjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    email: Schema.String,
    name: Schema.Union([Schema.String, Schema.Null]),
    surname: Schema.Union([Schema.String, Schema.Null]),
    company: Schema.Union([Schema.String, Schema.Null]),
    city: Schema.Union([Schema.String, Schema.Null]),
    street: Schema.Union([Schema.String, Schema.Null]),
    zip: Schema.Union([Schema.String, Schema.Null]),
    country: Schema.Union([Schema.String, Schema.Null]),
    phone: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'NewsletterSubscribeInputjsonld' });
export type NewsletterSubscribeInputjsonld = Schema.Schema.Type<
  typeof NewsletterSubscribeInputjsonld
>;
export type NewsletterSubscribeInputjsonldEncoded = Schema.Codec.Encoded<
  typeof NewsletterSubscribeInputjsonld
>;

/* Paymentsyliusadminorderindex */

export const Paymentsyliusadminorderindex = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    method: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    price: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Paymentsyliusadminorderindex' });
export type Paymentsyliusadminorderindex = Schema.Schema.Type<typeof Paymentsyliusadminorderindex>;
export type PaymentsyliusadminorderindexEncoded = Schema.Codec.Encoded<
  typeof Paymentsyliusadminorderindex
>;

/* Shipmentsyliusadminorderindex */

export const Shipmentsyliusadminorderindex = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    method: Schema.String.annotate({ format: 'iri-reference' }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Shipmentsyliusadminorderindex' });
export type Shipmentsyliusadminorderindex = Schema.Schema.Type<
  typeof Shipmentsyliusadminorderindex
>;
export type ShipmentsyliusadminorderindexEncoded = Schema.Codec.Encoded<
  typeof Shipmentsyliusadminorderindex
>;

/* OrderItemsyliusadminorderindex */

export const OrderItemsyliusadminorderindex = Schema.StructWithRest(
  Schema.Struct({
    variant: Schema.String.annotate({ format: 'iri-reference' }),
    productName: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    quantity: Schema.Number.annotate({ default: 0, readOnly: true })
      .check(Schema.isInt().annotate({ expected: 'an integer' }))
      .check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
    unitPrice: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    originalUnitPrice: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({ default: 0 }),
    total: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    units: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    subtotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    fullDiscountedUnitPrice: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'OrderItemsyliusadminorderindex' });
export type OrderItemsyliusadminorderindex = Schema.Schema.Type<
  typeof OrderItemsyliusadminorderindex
>;
export type OrderItemsyliusadminorderindexEncoded = Schema.Codec.Encoded<
  typeof OrderItemsyliusadminorderindex
>;

/* Paymentsyliusadminordershow */

export const Paymentsyliusadminordershow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    method: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    price: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Paymentsyliusadminordershow' });
export type Paymentsyliusadminordershow = Schema.Schema.Type<typeof Paymentsyliusadminordershow>;
export type PaymentsyliusadminordershowEncoded = Schema.Codec.Encoded<
  typeof Paymentsyliusadminordershow
>;

/* Shipmentsyliusadminordershow */

export const Shipmentsyliusadminordershow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    method: Schema.String.annotate({ format: 'iri-reference' }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Shipmentsyliusadminordershow' });
export type Shipmentsyliusadminordershow = Schema.Schema.Type<typeof Shipmentsyliusadminordershow>;
export type ShipmentsyliusadminordershowEncoded = Schema.Codec.Encoded<
  typeof Shipmentsyliusadminordershow
>;

/* OrderItemsyliusadminordershow */

export const OrderItemsyliusadminordershow = Schema.StructWithRest(
  Schema.Struct({
    variant: Schema.String.annotate({ format: 'iri-reference' }),
    productName: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    quantity: Schema.Number.annotate({ default: 0, readOnly: true })
      .check(Schema.isInt().annotate({ expected: 'an integer' }))
      .check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
    unitPrice: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    originalUnitPrice: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({ default: 0 }),
    total: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    units: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    subtotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    fullDiscountedUnitPrice: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'OrderItemsyliusadminordershow' });
export type OrderItemsyliusadminordershow = Schema.Schema.Type<
  typeof OrderItemsyliusadminordershow
>;
export type OrderItemsyliusadminordershowEncoded = Schema.Codec.Encoded<
  typeof OrderItemsyliusadminordershow
>;

/* Paymentsyliusshopcartshow */

export const Paymentsyliusshopcartshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    method: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    price: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Paymentsyliusshopcartshow' });
export type Paymentsyliusshopcartshow = Schema.Schema.Type<typeof Paymentsyliusshopcartshow>;
export type PaymentsyliusshopcartshowEncoded = Schema.Codec.Encoded<
  typeof Paymentsyliusshopcartshow
>;

/* Shipmentsyliusshopcartshow */

export const Shipmentsyliusshopcartshow = Schema.StructWithRest(
  Schema.Struct({
    placementId: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    method: Schema.String.annotate({ format: 'iri-reference' }),
    price: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Shipmentsyliusshopcartshow' });
export type Shipmentsyliusshopcartshow = Schema.Schema.Type<typeof Shipmentsyliusshopcartshow>;
export type ShipmentsyliusshopcartshowEncoded = Schema.Codec.Encoded<
  typeof Shipmentsyliusshopcartshow
>;

/* PromotionCouponsyliusshopcartshow */

export const PromotionCouponsyliusshopcartshow = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String,
    promotionName: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    promotionLabel: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PromotionCouponsyliusshopcartshow' });
export type PromotionCouponsyliusshopcartshow = Schema.Schema.Type<
  typeof PromotionCouponsyliusshopcartshow
>;
export type PromotionCouponsyliusshopcartshowEncoded = Schema.Codec.Encoded<
  typeof PromotionCouponsyliusshopcartshow
>;

/* PaymentMethodImagesyliusshopcartshowsyliusshopcartshowdetail */

export const PaymentMethodImagesyliusshopcartshowsyliusshopcartshowdetail = Schema.StructWithRest(
  Schema.Struct({
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PaymentMethodImagesyliusshopcartshowsyliusshopcartshowdetail' });
export type PaymentMethodImagesyliusshopcartshowsyliusshopcartshowdetail = Schema.Schema.Type<
  typeof PaymentMethodImagesyliusshopcartshowsyliusshopcartshowdetail
>;
export type PaymentMethodImagesyliusshopcartshowsyliusshopcartshowdetailEncoded =
  Schema.Codec.Encoded<typeof PaymentMethodImagesyliusshopcartshowsyliusshopcartshowdetail>;

/* ShippingMethodImagesyliusshopcartshowsyliusshopcartshowdetail */

export const ShippingMethodImagesyliusshopcartshowsyliusshopcartshowdetail = Schema.StructWithRest(
  Schema.Struct({
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingMethodImagesyliusshopcartshowsyliusshopcartshowdetail' });
export type ShippingMethodImagesyliusshopcartshowsyliusshopcartshowdetail = Schema.Schema.Type<
  typeof ShippingMethodImagesyliusshopcartshowsyliusshopcartshowdetail
>;
export type ShippingMethodImagesyliusshopcartshowsyliusshopcartshowdetailEncoded =
  Schema.Codec.Encoded<typeof ShippingMethodImagesyliusshopcartshowsyliusshopcartshowdetail>;

/* PromotionCouponsyliusshopcartshowsyliusshopcartshowdetail */

export const PromotionCouponsyliusshopcartshowsyliusshopcartshowdetail = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String,
    promotionName: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    promotionLabel: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PromotionCouponsyliusshopcartshowsyliusshopcartshowdetail' });
export type PromotionCouponsyliusshopcartshowsyliusshopcartshowdetail = Schema.Schema.Type<
  typeof PromotionCouponsyliusshopcartshowsyliusshopcartshowdetail
>;
export type PromotionCouponsyliusshopcartshowsyliusshopcartshowdetailEncoded = Schema.Codec.Encoded<
  typeof PromotionCouponsyliusshopcartshowsyliusshopcartshowdetail
>;

/* Taxonsyliusshopcartshowsyliusshopcartshowdetail */

export const Taxonsyliusshopcartshowsyliusshopcartshowdetail = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String,
    name: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonsyliusshopcartshowsyliusshopcartshowdetail' });
export type Taxonsyliusshopcartshowsyliusshopcartshowdetail = Schema.Schema.Type<
  typeof Taxonsyliusshopcartshowsyliusshopcartshowdetail
>;
export type TaxonsyliusshopcartshowsyliusshopcartshowdetailEncoded = Schema.Codec.Encoded<
  typeof Taxonsyliusshopcartshowsyliusshopcartshowdetail
>;

/* ProductImagesyliusshopcartshowsyliusshopcartshowdetail */

export const ProductImagesyliusshopcartshowsyliusshopcartshowdetail = Schema.StructWithRest(
  Schema.Struct({
    type: Schema.Union([Schema.String, Schema.Null]),
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductImagesyliusshopcartshowsyliusshopcartshowdetail' });
export type ProductImagesyliusshopcartshowsyliusshopcartshowdetail = Schema.Schema.Type<
  typeof ProductImagesyliusshopcartshowsyliusshopcartshowdetail
>;
export type ProductImagesyliusshopcartshowsyliusshopcartshowdetailEncoded = Schema.Codec.Encoded<
  typeof ProductImagesyliusshopcartshowsyliusshopcartshowdetail
>;

/* PaymentMethodImagesyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const PaymentMethodImagesyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      pathAbstract: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'PaymentMethodImagesyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type PaymentMethodImagesyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof PaymentMethodImagesyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type PaymentMethodImagesyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof PaymentMethodImagesyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* ShippingMethodImagesyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const ShippingMethodImagesyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      pathAbstract: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'ShippingMethodImagesyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type ShippingMethodImagesyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof ShippingMethodImagesyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type ShippingMethodImagesyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof ShippingMethodImagesyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* PromotionCouponsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const PromotionCouponsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      code: Schema.String,
      promotionName: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
      promotionLabel: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier: 'PromotionCouponsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type PromotionCouponsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof PromotionCouponsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type PromotionCouponsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof PromotionCouponsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* Taxonsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const Taxonsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      code: Schema.String,
      name: Schema.Union([Schema.String, Schema.Null]),
      routerUrl: Schema.String.annotate({
        description: 'Frontend router URL for this resource.',
        readOnly: true,
      }),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier: 'Taxonsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type Taxonsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<typeof Taxonsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid>;
export type TaxonsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof Taxonsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* ProductImagesyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const ProductImagesyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      type: Schema.Union([Schema.String, Schema.Null]),
      pathAbstract: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier: 'ProductImagesyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type ProductImagesyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof ProductImagesyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type ProductImagesyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof ProductImagesyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* ProductDocumentsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const ProductDocumentsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      name: Schema.Union([
        Schema.String.check(
          Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
        ),
        Schema.Null,
      ]),
      publicPath: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier: 'ProductDocumentsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type ProductDocumentsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof ProductDocumentsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type ProductDocumentsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof ProductDocumentsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* Paymentsyliusshoporderaccountshow */

export const Paymentsyliusshoporderaccountshow = Schema.StructWithRest(
  Schema.Struct({
    method: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    price: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Paymentsyliusshoporderaccountshow' });
export type Paymentsyliusshoporderaccountshow = Schema.Schema.Type<
  typeof Paymentsyliusshoporderaccountshow
>;
export type PaymentsyliusshoporderaccountshowEncoded = Schema.Codec.Encoded<
  typeof Paymentsyliusshoporderaccountshow
>;

/* Shipmentsyliusshoporderaccountshow */

export const Shipmentsyliusshoporderaccountshow = Schema.StructWithRest(
  Schema.Struct({
    method: Schema.String.annotate({ format: 'iri-reference' }),
    tracking: Schema.Union([Schema.String, Schema.Null]),
    absoluteTrackingUrl: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Shipmentsyliusshoporderaccountshow' });
export type Shipmentsyliusshoporderaccountshow = Schema.Schema.Type<
  typeof Shipmentsyliusshoporderaccountshow
>;
export type ShipmentsyliusshoporderaccountshowEncoded = Schema.Codec.Encoded<
  typeof Shipmentsyliusshoporderaccountshow
>;

/* OrderItemsyliusshoporderaccountshow */

export const OrderItemsyliusshoporderaccountshow = Schema.StructWithRest(
  Schema.Struct({
    variant: Schema.String.annotate({ format: 'iri-reference' }),
    productName: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    quantity: Schema.Number.annotate({ default: 0, readOnly: true })
      .check(Schema.isInt().annotate({ expected: 'an integer' }))
      .check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'OrderItemsyliusshoporderaccountshow' });
export type OrderItemsyliusshoporderaccountshow = Schema.Schema.Type<
  typeof OrderItemsyliusshoporderaccountshow
>;
export type OrderItemsyliusshoporderaccountshowEncoded = Schema.Codec.Encoded<
  typeof OrderItemsyliusshoporderaccountshow
>;

/* PaymentMethodImagesyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const PaymentMethodImagesyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      pathAbstract: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'PaymentMethodImagesyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type PaymentMethodImagesyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof PaymentMethodImagesyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type PaymentMethodImagesyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof PaymentMethodImagesyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* ShippingMethodImagesyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const ShippingMethodImagesyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      pathAbstract: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'ShippingMethodImagesyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type ShippingMethodImagesyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof ShippingMethodImagesyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type ShippingMethodImagesyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof ShippingMethodImagesyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* PromotionCouponsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const PromotionCouponsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      code: Schema.String,
      promotionName: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
      promotionLabel: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'PromotionCouponsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type PromotionCouponsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof PromotionCouponsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type PromotionCouponsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof PromotionCouponsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* Taxonsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const Taxonsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      code: Schema.String,
      name: Schema.Union([Schema.String, Schema.Null]),
      routerUrl: Schema.String.annotate({
        description: 'Frontend router URL for this resource.',
        readOnly: true,
      }),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'Taxonsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type Taxonsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof Taxonsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type TaxonsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof Taxonsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* ProductImagesyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const ProductImagesyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      type: Schema.Union([Schema.String, Schema.Null]),
      pathAbstract: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'ProductImagesyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type ProductImagesyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof ProductImagesyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type ProductImagesyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof ProductImagesyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* ProductDocumentsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const ProductDocumentsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      name: Schema.Union([
        Schema.String.check(
          Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
        ),
        Schema.Null,
      ]),
      publicPath: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'ProductDocumentsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type ProductDocumentsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof ProductDocumentsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type ProductDocumentsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof ProductDocumentsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* Shipmentsyliusshoporderindex */

export const Shipmentsyliusshoporderindex = Schema.StructWithRest(
  Schema.Struct({
    absoluteTrackingUrl: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Shipmentsyliusshoporderindex' });
export type Shipmentsyliusshoporderindex = Schema.Schema.Type<typeof Shipmentsyliusshoporderindex>;
export type ShipmentsyliusshoporderindexEncoded = Schema.Codec.Encoded<
  typeof Shipmentsyliusshoporderindex
>;

/* ProductImagesyliusshoporderindex */

export const ProductImagesyliusshoporderindex = Schema.StructWithRest(
  Schema.Struct({
    type: Schema.Union([Schema.String, Schema.Null]),
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductImagesyliusshoporderindex' });
export type ProductImagesyliusshoporderindex = Schema.Schema.Type<
  typeof ProductImagesyliusshoporderindex
>;
export type ProductImagesyliusshoporderindexEncoded = Schema.Codec.Encoded<
  typeof ProductImagesyliusshoporderindex
>;

/* Ordersyliusshoporderitemshow */

export const Ordersyliusshoporderitemshow = Schema.StructWithRest(
  Schema.Struct({
    vatFree: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'This is TRUE if Order price does NOT contain any VAT tax.',
        readOnly: true,
      })
    ),
    frontAllItemsPriceWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Sum of price of all items (without shipment and payment) after all discounts with VAT\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontAllItemsPriceWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Sum of price of all items (without shipment and payment) after all discounts without VAT',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontAllItemsDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Nominal value of sum of all discounts applied on (all) items\nValue is nominal for both nominal and percentage discounts\nNote: Because discount includes VAT, this sum also technically always includes discount from base+VAT price event\nif customer is verified to NOT pay VAT for Order!\nNumber is positive.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontAllItemsTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns nominal value of VAT from price AFTER discounts for all items\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontTotalWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns price including all items, shipment, payment and applied discounts\nAlways with VAT or NULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontTotalWithoutVat: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns price including all items, shipment, payment and applied discounts\nAlways without VAT even if customer pays VAT.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontFinalRounding: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns final rounding on entire Order. This correction is applied after everything even after TAX/VAT.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontTotalTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns nominal value of VAT from price AFTER discounts for all items\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontTotalPaid: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns FINAL price to be paid by customer including all items, shipment, payment, applied discounts\nand applied taxes if any. This number is number which should be sent to payment gate or displayed as number\nrepresenting how much will customer pay.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontShipmentTotalPaid: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns FINAL price to be paid by customer for shipment (after discount and including taxes if applied)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontPaymentTotalPaid: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns FINAL price to be paid by customer for payment (after discount and including taxes if applied)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontDeliveryTotalPaid: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns FINAL price to be paid by customer for delivery: shipment+payment (after discount and including taxes if applied)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontShipmentWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns shipment price before discount with VAT\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontShipmentDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns discount in nominal value of shipment (for both percentage and nominal discount)\nPositive number.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontShipmentWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns shipment price with VAT after applied discounts\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontShipmentWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns shipment price without VAT after applied discounts',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontShipmentTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns nominal value of VAT from price AFTER discounts for shipment\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontPaymentWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns payment price before discount with VAT\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontPaymentDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns discount in nominal value of payment (for both percentage and nominal discount)\nPositive number.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontPaymentWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns payment price with VAT after applied discounts\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontPaymentWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns payment price without VAT after applied discounts',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontPaymentTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns nominal value of VAT from price AFTER discounts for payment\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontDeliveryWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns delivery: shipment+payment price before discount with VAT\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontDeliveryDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns discount in nominal value of delivery: shipment+payment (for both percentage and nominal discount)\nPositive number.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontDeliveryWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns delivery: shipment+payment price with VAT after applied discounts\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontDeliveryWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns delivery: shipment+payment price without VAT after applied discounts',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontDeliveryTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns nominal value of VAT from price AFTER discounts for delivery: shipment+payment\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontShipmentDiscountPercentage: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns overall percentage discount on shipments calculated from base price with tax and applied nominal discounts.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontPaymentDiscountPercentage: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns overall percentage discount on payments calculated from base price with tax and applied nominal discounts.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontDeliveryDiscountPercentage: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Ordersyliusshoporderitemshow' });
export type Ordersyliusshoporderitemshow = Schema.Schema.Type<typeof Ordersyliusshoporderitemshow>;
export type OrdersyliusshoporderitemshowEncoded = Schema.Codec.Encoded<
  typeof Ordersyliusshoporderitemshow
>;

/* OrderAddItemToCartsyliusshopcartadditem */

export const OrderAddItemToCartsyliusshopcartadditem = Schema.StructWithRest(
  Schema.Struct({
    productVariant: Schema.String,
    quantity: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })).check(
      Schema.isGreaterThanOrEqualTo(1).annotate({ expected: 'a value greater than or equal to 1' })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'OrderAddItemToCartsyliusshopcartadditem' });
export type OrderAddItemToCartsyliusshopcartadditem = Schema.Schema.Type<
  typeof OrderAddItemToCartsyliusshopcartadditem
>;
export type OrderAddItemToCartsyliusshopcartadditemEncoded = Schema.Codec.Encoded<
  typeof OrderAddItemToCartsyliusshopcartadditem
>;

/* OrderAddItemToCartjsonldsyliusshopcartadditem */

export const OrderAddItemToCartjsonldsyliusshopcartadditem = Schema.StructWithRest(
  Schema.Struct({
    productVariant: Schema.String,
    quantity: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })).check(
      Schema.isGreaterThanOrEqualTo(1).annotate({ expected: 'a value greater than or equal to 1' })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'OrderAddItemToCartjsonldsyliusshopcartadditem' });
export type OrderAddItemToCartjsonldsyliusshopcartadditem = Schema.Schema.Type<
  typeof OrderAddItemToCartjsonldsyliusshopcartadditem
>;
export type OrderAddItemToCartjsonldsyliusshopcartadditemEncoded = Schema.Codec.Encoded<
  typeof OrderAddItemToCartjsonldsyliusshopcartadditem
>;

/* OrderChangeItemQuantityInCartsyliusshopcartchangequantityjsonMergePatch */

export const OrderChangeItemQuantityInCartsyliusshopcartchangequantityjsonMergePatch =
  Schema.StructWithRest(
    Schema.Struct({
      quantity: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })).check(
        Schema.isGreaterThanOrEqualTo(1).annotate({
          expected: 'a value greater than or equal to 1',
        })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier: 'OrderChangeItemQuantityInCartsyliusshopcartchangequantityjsonMergePatch',
  });
export type OrderChangeItemQuantityInCartsyliusshopcartchangequantityjsonMergePatch =
  Schema.Schema.Type<
    typeof OrderChangeItemQuantityInCartsyliusshopcartchangequantityjsonMergePatch
  >;
export type OrderChangeItemQuantityInCartsyliusshopcartchangequantityjsonMergePatchEncoded =
  Schema.Codec.Encoded<
    typeof OrderChangeItemQuantityInCartsyliusshopcartchangequantityjsonMergePatch
  >;

/* OrderChangePaymentMethodsyliusshoporderaccountchangepaymentmethodjsonMergePatch */

export const OrderChangePaymentMethodsyliusshoporderaccountchangepaymentmethodjsonMergePatch =
  Schema.StructWithRest(Schema.Struct({ paymentMethod: Schema.String }), [
    Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
  ]).annotate({
    identifier: 'OrderChangePaymentMethodsyliusshoporderaccountchangepaymentmethodjsonMergePatch',
  });
export type OrderChangePaymentMethodsyliusshoporderaccountchangepaymentmethodjsonMergePatch =
  Schema.Schema.Type<
    typeof OrderChangePaymentMethodsyliusshoporderaccountchangepaymentmethodjsonMergePatch
  >;
export type OrderChangePaymentMethodsyliusshoporderaccountchangepaymentmethodjsonMergePatchEncoded =
  Schema.Codec.Encoded<
    typeof OrderChangePaymentMethodsyliusshoporderaccountchangepaymentmethodjsonMergePatch
  >;

/* OrderChoosePaymentMethodsyliusshopcartselectpaymentmethodjsonMergePatch */

export const OrderChoosePaymentMethodsyliusshopcartselectpaymentmethodjsonMergePatch =
  Schema.StructWithRest(Schema.Struct({ paymentMethod: Schema.String }), [
    Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
  ]).annotate({
    identifier: 'OrderChoosePaymentMethodsyliusshopcartselectpaymentmethodjsonMergePatch',
  });
export type OrderChoosePaymentMethodsyliusshopcartselectpaymentmethodjsonMergePatch =
  Schema.Schema.Type<
    typeof OrderChoosePaymentMethodsyliusshopcartselectpaymentmethodjsonMergePatch
  >;
export type OrderChoosePaymentMethodsyliusshopcartselectpaymentmethodjsonMergePatchEncoded =
  Schema.Codec.Encoded<
    typeof OrderChoosePaymentMethodsyliusshopcartselectpaymentmethodjsonMergePatch
  >;

/* OrderChooseShippingMethodsyliusshopcartselectshippingmethodjsonMergePatch */

export const OrderChooseShippingMethodsyliusshopcartselectshippingmethodjsonMergePatch =
  Schema.StructWithRest(
    Schema.Struct({
      placementId: Schema.Union([Schema.String, Schema.Null]).annotate({
        description:
          "Id of the pickup point in the carrier's network (or the merchant branch), required by methods with a placement, must be null otherwise.",
      }),
      shippingMethod: Schema.String,
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier: 'OrderChooseShippingMethodsyliusshopcartselectshippingmethodjsonMergePatch',
  });
export type OrderChooseShippingMethodsyliusshopcartselectshippingmethodjsonMergePatch =
  Schema.Schema.Type<
    typeof OrderChooseShippingMethodsyliusshopcartselectshippingmethodjsonMergePatch
  >;
export type OrderChooseShippingMethodsyliusshopcartselectshippingmethodjsonMergePatchEncoded =
  Schema.Codec.Encoded<
    typeof OrderChooseShippingMethodsyliusshopcartselectshippingmethodjsonMergePatch
  >;

/* OrderCompleteOrdersyliusshopcartcompletejsonMergePatch */

export const OrderCompleteOrdersyliusshopcartcompletejsonMergePatch = Schema.StructWithRest(
  Schema.Struct({
    newsletterOptIn: Schema.Boolean.annotate({
      description: 'Customer agreed to receive the newsletter (Customer::subscribedToNewsletter).',
    }),
    surveyOptIn: Schema.Boolean.annotate({
      description:
        'Customer agreed to a post-purchase satisfaction survey (Heureka, Zboží — SurveyOptInOrderInterface).',
    }),
    notes: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'OrderCompleteOrdersyliusshopcartcompletejsonMergePatch' });
export type OrderCompleteOrdersyliusshopcartcompletejsonMergePatch = Schema.Schema.Type<
  typeof OrderCompleteOrdersyliusshopcartcompletejsonMergePatch
>;
export type OrderCompleteOrdersyliusshopcartcompletejsonMergePatchEncoded = Schema.Codec.Encoded<
  typeof OrderCompleteOrdersyliusshopcartcompletejsonMergePatch
>;

/* OrderPickupCartsyliusshopordercreate */

export const OrderPickupCartsyliusshopordercreate = Schema.Record(
  Schema.String,
  Schema.Json.annotate({ expected: 'JSON value' })
).annotate({ identifier: 'OrderPickupCartsyliusshopordercreate' });
export type OrderPickupCartsyliusshopordercreate = Schema.Schema.Type<
  typeof OrderPickupCartsyliusshopordercreate
>;
export type OrderPickupCartsyliusshopordercreateEncoded = Schema.Codec.Encoded<
  typeof OrderPickupCartsyliusshopordercreate
>;

/* OrderPickupCartjsonldsyliusshopordercreate */

export const OrderPickupCartjsonldsyliusshopordercreate = Schema.Record(
  Schema.String,
  Schema.Json.annotate({ expected: 'JSON value' })
).annotate({ identifier: 'OrderPickupCartjsonldsyliusshopordercreate' });
export type OrderPickupCartjsonldsyliusshopordercreate = Schema.Schema.Type<
  typeof OrderPickupCartjsonldsyliusshopordercreate
>;
export type OrderPickupCartjsonldsyliusshopordercreateEncoded = Schema.Codec.Encoded<
  typeof OrderPickupCartjsonldsyliusshopordercreate
>;

/* OrderResendOrderConfirmationEmail */

export const OrderResendOrderConfirmationEmail = Schema.StructWithRest(
  Schema.Struct({ orderTokenValue: Schema.String }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'OrderResendOrderConfirmationEmail' });
export type OrderResendOrderConfirmationEmail = Schema.Schema.Type<
  typeof OrderResendOrderConfirmationEmail
>;
export type OrderResendOrderConfirmationEmailEncoded = Schema.Codec.Encoded<
  typeof OrderResendOrderConfirmationEmail
>;

/* OrderResendOrderConfirmationEmailjsonld */

export const OrderResendOrderConfirmationEmailjsonld = Schema.StructWithRest(
  Schema.Struct({ orderTokenValue: Schema.String }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'OrderResendOrderConfirmationEmailjsonld' });
export type OrderResendOrderConfirmationEmailjsonld = Schema.Schema.Type<
  typeof OrderResendOrderConfirmationEmailjsonld
>;
export type OrderResendOrderConfirmationEmailjsonldEncoded = Schema.Codec.Encoded<
  typeof OrderResendOrderConfirmationEmailjsonld
>;

/* Paymentjsonldsyliusadminorderindex */

export const Paymentjsonldsyliusadminorderindex = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    method: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    price: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Paymentjsonldsyliusadminorderindex' });
export type Paymentjsonldsyliusadminorderindex = Schema.Schema.Type<
  typeof Paymentjsonldsyliusadminorderindex
>;
export type PaymentjsonldsyliusadminorderindexEncoded = Schema.Codec.Encoded<
  typeof Paymentjsonldsyliusadminorderindex
>;

/* Shipmentjsonldsyliusadminorderindex */

export const Shipmentjsonldsyliusadminorderindex = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    method: Schema.String.annotate({ format: 'iri-reference' }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Shipmentjsonldsyliusadminorderindex' });
export type Shipmentjsonldsyliusadminorderindex = Schema.Schema.Type<
  typeof Shipmentjsonldsyliusadminorderindex
>;
export type ShipmentjsonldsyliusadminorderindexEncoded = Schema.Codec.Encoded<
  typeof Shipmentjsonldsyliusadminorderindex
>;

/* OrderItemjsonldsyliusadminorderindex */

export const OrderItemjsonldsyliusadminorderindex = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    variant: Schema.String.annotate({ format: 'iri-reference' }),
    productName: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    quantity: Schema.Number.annotate({ default: 0, readOnly: true })
      .check(Schema.isInt().annotate({ expected: 'an integer' }))
      .check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
    unitPrice: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    originalUnitPrice: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({ default: 0 }),
    total: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    units: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    subtotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    fullDiscountedUnitPrice: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'OrderItemjsonldsyliusadminorderindex' });
export type OrderItemjsonldsyliusadminorderindex = Schema.Schema.Type<
  typeof OrderItemjsonldsyliusadminorderindex
>;
export type OrderItemjsonldsyliusadminorderindexEncoded = Schema.Codec.Encoded<
  typeof OrderItemjsonldsyliusadminorderindex
>;

/* Paymentjsonldsyliusadminordershow */

export const Paymentjsonldsyliusadminordershow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    method: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    price: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Paymentjsonldsyliusadminordershow' });
export type Paymentjsonldsyliusadminordershow = Schema.Schema.Type<
  typeof Paymentjsonldsyliusadminordershow
>;
export type PaymentjsonldsyliusadminordershowEncoded = Schema.Codec.Encoded<
  typeof Paymentjsonldsyliusadminordershow
>;

/* Shipmentjsonldsyliusadminordershow */

export const Shipmentjsonldsyliusadminordershow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    method: Schema.String.annotate({ format: 'iri-reference' }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Shipmentjsonldsyliusadminordershow' });
export type Shipmentjsonldsyliusadminordershow = Schema.Schema.Type<
  typeof Shipmentjsonldsyliusadminordershow
>;
export type ShipmentjsonldsyliusadminordershowEncoded = Schema.Codec.Encoded<
  typeof Shipmentjsonldsyliusadminordershow
>;

/* OrderItemjsonldsyliusadminordershow */

export const OrderItemjsonldsyliusadminordershow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    variant: Schema.String.annotate({ format: 'iri-reference' }),
    productName: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    quantity: Schema.Number.annotate({ default: 0, readOnly: true })
      .check(Schema.isInt().annotate({ expected: 'an integer' }))
      .check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
    unitPrice: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    originalUnitPrice: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({ default: 0 }),
    total: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    units: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    subtotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    fullDiscountedUnitPrice: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'OrderItemjsonldsyliusadminordershow' });
export type OrderItemjsonldsyliusadminordershow = Schema.Schema.Type<
  typeof OrderItemjsonldsyliusadminordershow
>;
export type OrderItemjsonldsyliusadminordershowEncoded = Schema.Codec.Encoded<
  typeof OrderItemjsonldsyliusadminordershow
>;

/* Paymentjsonldsyliusshopcartshow */

export const Paymentjsonldsyliusshopcartshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    method: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    price: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Paymentjsonldsyliusshopcartshow' });
export type Paymentjsonldsyliusshopcartshow = Schema.Schema.Type<
  typeof Paymentjsonldsyliusshopcartshow
>;
export type PaymentjsonldsyliusshopcartshowEncoded = Schema.Codec.Encoded<
  typeof Paymentjsonldsyliusshopcartshow
>;

/* Shipmentjsonldsyliusshopcartshow */

export const Shipmentjsonldsyliusshopcartshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    placementId: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    method: Schema.String.annotate({ format: 'iri-reference' }),
    price: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Shipmentjsonldsyliusshopcartshow' });
export type Shipmentjsonldsyliusshopcartshow = Schema.Schema.Type<
  typeof Shipmentjsonldsyliusshopcartshow
>;
export type ShipmentjsonldsyliusshopcartshowEncoded = Schema.Codec.Encoded<
  typeof Shipmentjsonldsyliusshopcartshow
>;

/* PromotionCouponjsonldsyliusshopcartshow */

export const PromotionCouponjsonldsyliusshopcartshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String,
    promotionName: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    promotionLabel: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PromotionCouponjsonldsyliusshopcartshow' });
export type PromotionCouponjsonldsyliusshopcartshow = Schema.Schema.Type<
  typeof PromotionCouponjsonldsyliusshopcartshow
>;
export type PromotionCouponjsonldsyliusshopcartshowEncoded = Schema.Codec.Encoded<
  typeof PromotionCouponjsonldsyliusshopcartshow
>;

/* PaymentMethodImagejsonldsyliusshopcartshowsyliusshopcartshowdetail */

export const PaymentMethodImagejsonldsyliusshopcartshowsyliusshopcartshowdetail =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      pathAbstract: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({ identifier: 'PaymentMethodImagejsonldsyliusshopcartshowsyliusshopcartshowdetail' });
export type PaymentMethodImagejsonldsyliusshopcartshowsyliusshopcartshowdetail = Schema.Schema.Type<
  typeof PaymentMethodImagejsonldsyliusshopcartshowsyliusshopcartshowdetail
>;
export type PaymentMethodImagejsonldsyliusshopcartshowsyliusshopcartshowdetailEncoded =
  Schema.Codec.Encoded<typeof PaymentMethodImagejsonldsyliusshopcartshowsyliusshopcartshowdetail>;

/* ShippingMethodImagejsonldsyliusshopcartshowsyliusshopcartshowdetail */

export const ShippingMethodImagejsonldsyliusshopcartshowsyliusshopcartshowdetail =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      pathAbstract: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({ identifier: 'ShippingMethodImagejsonldsyliusshopcartshowsyliusshopcartshowdetail' });
export type ShippingMethodImagejsonldsyliusshopcartshowsyliusshopcartshowdetail =
  Schema.Schema.Type<typeof ShippingMethodImagejsonldsyliusshopcartshowsyliusshopcartshowdetail>;
export type ShippingMethodImagejsonldsyliusshopcartshowsyliusshopcartshowdetailEncoded =
  Schema.Codec.Encoded<typeof ShippingMethodImagejsonldsyliusshopcartshowsyliusshopcartshowdetail>;

/* PromotionCouponjsonldsyliusshopcartshowsyliusshopcartshowdetail */

export const PromotionCouponjsonldsyliusshopcartshowsyliusshopcartshowdetail =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      code: Schema.String,
      promotionName: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
      promotionLabel: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({ identifier: 'PromotionCouponjsonldsyliusshopcartshowsyliusshopcartshowdetail' });
export type PromotionCouponjsonldsyliusshopcartshowsyliusshopcartshowdetail = Schema.Schema.Type<
  typeof PromotionCouponjsonldsyliusshopcartshowsyliusshopcartshowdetail
>;
export type PromotionCouponjsonldsyliusshopcartshowsyliusshopcartshowdetailEncoded =
  Schema.Codec.Encoded<typeof PromotionCouponjsonldsyliusshopcartshowsyliusshopcartshowdetail>;

/* Taxonjsonldsyliusshopcartshowsyliusshopcartshowdetail */

export const Taxonjsonldsyliusshopcartshowsyliusshopcartshowdetail = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String,
    name: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonjsonldsyliusshopcartshowsyliusshopcartshowdetail' });
export type Taxonjsonldsyliusshopcartshowsyliusshopcartshowdetail = Schema.Schema.Type<
  typeof Taxonjsonldsyliusshopcartshowsyliusshopcartshowdetail
>;
export type TaxonjsonldsyliusshopcartshowsyliusshopcartshowdetailEncoded = Schema.Codec.Encoded<
  typeof Taxonjsonldsyliusshopcartshowsyliusshopcartshowdetail
>;

/* ProductImagejsonldsyliusshopcartshowsyliusshopcartshowdetail */

export const ProductImagejsonldsyliusshopcartshowsyliusshopcartshowdetail = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    type: Schema.Union([Schema.String, Schema.Null]),
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductImagejsonldsyliusshopcartshowsyliusshopcartshowdetail' });
export type ProductImagejsonldsyliusshopcartshowsyliusshopcartshowdetail = Schema.Schema.Type<
  typeof ProductImagejsonldsyliusshopcartshowsyliusshopcartshowdetail
>;
export type ProductImagejsonldsyliusshopcartshowsyliusshopcartshowdetailEncoded =
  Schema.Codec.Encoded<typeof ProductImagejsonldsyliusshopcartshowsyliusshopcartshowdetail>;

/* PaymentMethodImagejsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const PaymentMethodImagejsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      pathAbstract: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'PaymentMethodImagejsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type PaymentMethodImagejsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof PaymentMethodImagejsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type PaymentMethodImagejsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof PaymentMethodImagejsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* ShippingMethodImagejsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const ShippingMethodImagejsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      pathAbstract: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'ShippingMethodImagejsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type ShippingMethodImagejsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof ShippingMethodImagejsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type ShippingMethodImagejsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof ShippingMethodImagejsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* PromotionCouponjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const PromotionCouponjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      code: Schema.String,
      promotionName: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
      promotionLabel: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'PromotionCouponjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type PromotionCouponjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof PromotionCouponjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type PromotionCouponjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof PromotionCouponjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* Taxonjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const Taxonjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      code: Schema.String,
      name: Schema.Union([Schema.String, Schema.Null]),
      routerUrl: Schema.String.annotate({
        description: 'Frontend router URL for this resource.',
        readOnly: true,
      }),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier: 'Taxonjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type Taxonjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof Taxonjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type TaxonjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof Taxonjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* ProductImagejsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const ProductImagejsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      type: Schema.Union([Schema.String, Schema.Null]),
      pathAbstract: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'ProductImagejsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type ProductImagejsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof ProductImagejsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type ProductImagejsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof ProductImagejsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* ProductDocumentjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const ProductDocumentjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      name: Schema.Union([
        Schema.String.check(
          Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
        ),
        Schema.Null,
      ]),
      publicPath: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'ProductDocumentjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type ProductDocumentjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof ProductDocumentjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type ProductDocumentjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof ProductDocumentjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* Paymentjsonldsyliusshoporderaccountshow */

export const Paymentjsonldsyliusshoporderaccountshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    method: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    price: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Paymentjsonldsyliusshoporderaccountshow' });
export type Paymentjsonldsyliusshoporderaccountshow = Schema.Schema.Type<
  typeof Paymentjsonldsyliusshoporderaccountshow
>;
export type PaymentjsonldsyliusshoporderaccountshowEncoded = Schema.Codec.Encoded<
  typeof Paymentjsonldsyliusshoporderaccountshow
>;

/* Shipmentjsonldsyliusshoporderaccountshow */

export const Shipmentjsonldsyliusshoporderaccountshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    method: Schema.String.annotate({ format: 'iri-reference' }),
    tracking: Schema.Union([Schema.String, Schema.Null]),
    absoluteTrackingUrl: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Shipmentjsonldsyliusshoporderaccountshow' });
export type Shipmentjsonldsyliusshoporderaccountshow = Schema.Schema.Type<
  typeof Shipmentjsonldsyliusshoporderaccountshow
>;
export type ShipmentjsonldsyliusshoporderaccountshowEncoded = Schema.Codec.Encoded<
  typeof Shipmentjsonldsyliusshoporderaccountshow
>;

/* OrderItemjsonldsyliusshoporderaccountshow */

export const OrderItemjsonldsyliusshoporderaccountshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    variant: Schema.String.annotate({ format: 'iri-reference' }),
    productName: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    quantity: Schema.Number.annotate({ default: 0, readOnly: true })
      .check(Schema.isInt().annotate({ expected: 'an integer' }))
      .check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'OrderItemjsonldsyliusshoporderaccountshow' });
export type OrderItemjsonldsyliusshoporderaccountshow = Schema.Schema.Type<
  typeof OrderItemjsonldsyliusshoporderaccountshow
>;
export type OrderItemjsonldsyliusshoporderaccountshowEncoded = Schema.Codec.Encoded<
  typeof OrderItemjsonldsyliusshoporderaccountshow
>;

/* PaymentMethodImagejsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const PaymentMethodImagejsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      pathAbstract: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'PaymentMethodImagejsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type PaymentMethodImagejsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof PaymentMethodImagejsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type PaymentMethodImagejsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof PaymentMethodImagejsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* ShippingMethodImagejsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const ShippingMethodImagejsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      pathAbstract: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'ShippingMethodImagejsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type ShippingMethodImagejsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof ShippingMethodImagejsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type ShippingMethodImagejsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof ShippingMethodImagejsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* PromotionCouponjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const PromotionCouponjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      code: Schema.String,
      promotionName: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
      promotionLabel: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'PromotionCouponjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type PromotionCouponjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof PromotionCouponjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type PromotionCouponjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof PromotionCouponjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* Taxonjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const Taxonjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      code: Schema.String,
      name: Schema.Union([Schema.String, Schema.Null]),
      routerUrl: Schema.String.annotate({
        description: 'Frontend router URL for this resource.',
        readOnly: true,
      }),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'Taxonjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type Taxonjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof Taxonjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type TaxonjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof Taxonjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* ProductImagejsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const ProductImagejsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      type: Schema.Union([Schema.String, Schema.Null]),
      pathAbstract: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'ProductImagejsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type ProductImagejsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof ProductImagejsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type ProductImagejsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof ProductImagejsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* ProductDocumentjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const ProductDocumentjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      name: Schema.Union([
        Schema.String.check(
          Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
        ),
        Schema.Null,
      ]),
      publicPath: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'ProductDocumentjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type ProductDocumentjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof ProductDocumentjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type ProductDocumentjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof ProductDocumentjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* Shipmentjsonldsyliusshoporderindex */

export const Shipmentjsonldsyliusshoporderindex = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    absoluteTrackingUrl: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Shipmentjsonldsyliusshoporderindex' });
export type Shipmentjsonldsyliusshoporderindex = Schema.Schema.Type<
  typeof Shipmentjsonldsyliusshoporderindex
>;
export type ShipmentjsonldsyliusshoporderindexEncoded = Schema.Codec.Encoded<
  typeof Shipmentjsonldsyliusshoporderindex
>;

/* ProductImagejsonldsyliusshoporderindex */

export const ProductImagejsonldsyliusshoporderindex = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    type: Schema.Union([Schema.String, Schema.Null]),
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductImagejsonldsyliusshoporderindex' });
export type ProductImagejsonldsyliusshoporderindex = Schema.Schema.Type<
  typeof ProductImagejsonldsyliusshoporderindex
>;
export type ProductImagejsonldsyliusshoporderindexEncoded = Schema.Codec.Encoded<
  typeof ProductImagejsonldsyliusshoporderindex
>;

/* Orderjsonldsyliusshoporderitemshow */

export const Orderjsonldsyliusshoporderitemshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    vatFree: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'This is TRUE if Order price does NOT contain any VAT tax.',
        readOnly: true,
      })
    ),
    frontAllItemsPriceWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Sum of price of all items (without shipment and payment) after all discounts with VAT\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontAllItemsPriceWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Sum of price of all items (without shipment and payment) after all discounts without VAT',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontAllItemsDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Nominal value of sum of all discounts applied on (all) items\nValue is nominal for both nominal and percentage discounts\nNote: Because discount includes VAT, this sum also technically always includes discount from base+VAT price event\nif customer is verified to NOT pay VAT for Order!\nNumber is positive.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontAllItemsTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns nominal value of VAT from price AFTER discounts for all items\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontTotalWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns price including all items, shipment, payment and applied discounts\nAlways with VAT or NULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontTotalWithoutVat: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns price including all items, shipment, payment and applied discounts\nAlways without VAT even if customer pays VAT.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontFinalRounding: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns final rounding on entire Order. This correction is applied after everything even after TAX/VAT.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontTotalTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns nominal value of VAT from price AFTER discounts for all items\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontTotalPaid: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns FINAL price to be paid by customer including all items, shipment, payment, applied discounts\nand applied taxes if any. This number is number which should be sent to payment gate or displayed as number\nrepresenting how much will customer pay.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontShipmentTotalPaid: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns FINAL price to be paid by customer for shipment (after discount and including taxes if applied)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontPaymentTotalPaid: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns FINAL price to be paid by customer for payment (after discount and including taxes if applied)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontDeliveryTotalPaid: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns FINAL price to be paid by customer for delivery: shipment+payment (after discount and including taxes if applied)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontShipmentWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns shipment price before discount with VAT\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontShipmentDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns discount in nominal value of shipment (for both percentage and nominal discount)\nPositive number.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontShipmentWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns shipment price with VAT after applied discounts\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontShipmentWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns shipment price without VAT after applied discounts',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontShipmentTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns nominal value of VAT from price AFTER discounts for shipment\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontPaymentWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns payment price before discount with VAT\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontPaymentDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns discount in nominal value of payment (for both percentage and nominal discount)\nPositive number.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontPaymentWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns payment price with VAT after applied discounts\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontPaymentWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns payment price without VAT after applied discounts',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontPaymentTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns nominal value of VAT from price AFTER discounts for payment\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontDeliveryWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns delivery: shipment+payment price before discount with VAT\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontDeliveryDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns discount in nominal value of delivery: shipment+payment (for both percentage and nominal discount)\nPositive number.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontDeliveryWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns delivery: shipment+payment price with VAT after applied discounts\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontDeliveryWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns delivery: shipment+payment price without VAT after applied discounts',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontDeliveryTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns nominal value of VAT from price AFTER discounts for delivery: shipment+payment\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontShipmentDiscountPercentage: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns overall percentage discount on shipments calculated from base price with tax and applied nominal discounts.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontPaymentDiscountPercentage: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns overall percentage discount on payments calculated from base price with tax and applied nominal discounts.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontDeliveryDiscountPercentage: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Orderjsonldsyliusshoporderitemshow' });
export type Orderjsonldsyliusshoporderitemshow = Schema.Schema.Type<
  typeof Orderjsonldsyliusshoporderitemshow
>;
export type OrderjsonldsyliusshoporderitemshowEncoded = Schema.Codec.Encoded<
  typeof Orderjsonldsyliusshoporderitemshow
>;

/* OrderItemsyliusadminorderitemshow */

export const OrderItemsyliusadminorderitemshow = Schema.StructWithRest(
  Schema.Struct({
    variant: Schema.String.annotate({ format: 'iri-reference' }),
    productName: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    order: Schema.String.annotate({ format: 'iri-reference' }),
    quantity: Schema.Number.annotate({ default: 0, readOnly: true })
      .check(Schema.isInt().annotate({ expected: 'an integer' }))
      .check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
    unitPrice: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    originalUnitPrice: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({ default: 0 }),
    total: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    units: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    adjustments: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    adjustmentsTotal: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    product: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        readOnly: true,
        format: 'iri-reference',
      })
    ),
    adjustmentsRecursively: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    adjustmentsTotalRecursively: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    subtotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    fullDiscountedUnitPrice: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'OrderItemsyliusadminorderitemshow' });
export type OrderItemsyliusadminorderitemshow = Schema.Schema.Type<
  typeof OrderItemsyliusadminorderitemshow
>;
export type OrderItemsyliusadminorderitemshowEncoded = Schema.Codec.Encoded<
  typeof OrderItemsyliusadminorderitemshow
>;

/* OrderItemsyliusshopcartshow */

export const OrderItemsyliusshopcartshow = Schema.StructWithRest(
  Schema.Struct({
    variant: Schema.String.annotate({ format: 'iri-reference' }),
    productName: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    quantity: Schema.Number.annotate({ default: 0, readOnly: true })
      .check(Schema.isInt().annotate({ expected: 'an integer' }))
      .check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
    unitPrice: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    originalUnitPrice: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({ default: 0 }),
    total: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    frontUnitPriceWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    frontItemsPriceWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    frontUnitPriceDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Nominal value of sum of all discounts applied on unit\nDiscount technically contains VAT part (is applied for source price including VAT)\nValue is nominal for both nominal and percentage discounts\nValue is average for all units (if special discounts are per unit, this filed must be calculated custom for each every unit)\nNumber is positive.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontItemsPriceDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Nominal value of sum of all discounts applied on items (all units)\nDiscount technically contains VAT part (is applied for source price including VAT)\nValue is nominal for both nominal and percentage discounts\nNumber is positive.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontUnitPriceWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Unit price with VAT and after all product discounts (including order level discounts on products)\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontUnitPriceWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Unit price without VAT and after all product discounts (including order level discounts on products)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontUnitPricePaid: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    frontItemsPriceWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Sum of items (all units) with VAT and after all product discounts (including order level discounts on products)\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontItemsPriceWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Sum of items (all units) without VAT and after all product discounts (including order level discounts on products)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontUnitTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Tax as nominal value applied on unit price AFTER discount\nNULL if customer is verified to NOT pay VAT for Order (basically zero tax)',
        readOnly: true,
      })
    ),
    frontItemsTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Tax as nominal value applied on items (all units) price AFTER discount\nNULL if customer is verified to NOT pay VAT for Order (basically zero tax)',
        readOnly: true,
      })
    ),
    frontItemsPricePaid: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    discountedUnitPrice: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns single unit price lowered by order unit promotions (each unit must have the same unit promotion discount)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    subtotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'OrderItemsyliusshopcartshow' });
export type OrderItemsyliusshopcartshow = Schema.Schema.Type<typeof OrderItemsyliusshopcartshow>;
export type OrderItemsyliusshopcartshowEncoded = Schema.Codec.Encoded<
  typeof OrderItemsyliusshopcartshow
>;

/* OrderItemjsonldsyliusadminorderitemshow */

export const OrderItemjsonldsyliusadminorderitemshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    variant: Schema.String.annotate({ format: 'iri-reference' }),
    productName: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    order: Schema.String.annotate({ format: 'iri-reference' }),
    quantity: Schema.Number.annotate({ default: 0, readOnly: true })
      .check(Schema.isInt().annotate({ expected: 'an integer' }))
      .check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
    unitPrice: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    originalUnitPrice: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({ default: 0 }),
    total: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    units: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    adjustments: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    adjustmentsTotal: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    product: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        readOnly: true,
        format: 'iri-reference',
      })
    ),
    adjustmentsRecursively: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    adjustmentsTotalRecursively: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    subtotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    fullDiscountedUnitPrice: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'OrderItemjsonldsyliusadminorderitemshow' });
export type OrderItemjsonldsyliusadminorderitemshow = Schema.Schema.Type<
  typeof OrderItemjsonldsyliusadminorderitemshow
>;
export type OrderItemjsonldsyliusadminorderitemshowEncoded = Schema.Codec.Encoded<
  typeof OrderItemjsonldsyliusadminorderitemshow
>;

/* OrderItemjsonldsyliusshopcartshow */

export const OrderItemjsonldsyliusshopcartshow = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    variant: Schema.String.annotate({ format: 'iri-reference' }),
    productName: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    quantity: Schema.Number.annotate({ default: 0, readOnly: true })
      .check(Schema.isInt().annotate({ expected: 'an integer' }))
      .check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
    unitPrice: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    originalUnitPrice: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({ default: 0 }),
    total: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    frontUnitPriceWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    frontItemsPriceWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    frontUnitPriceDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Nominal value of sum of all discounts applied on unit\nDiscount technically contains VAT part (is applied for source price including VAT)\nValue is nominal for both nominal and percentage discounts\nValue is average for all units (if special discounts are per unit, this filed must be calculated custom for each every unit)\nNumber is positive.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontItemsPriceDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Nominal value of sum of all discounts applied on items (all units)\nDiscount technically contains VAT part (is applied for source price including VAT)\nValue is nominal for both nominal and percentage discounts\nNumber is positive.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontUnitPriceWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Unit price with VAT and after all product discounts (including order level discounts on products)\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontUnitPriceWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Unit price without VAT and after all product discounts (including order level discounts on products)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontUnitPricePaid: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    frontItemsPriceWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Sum of items (all units) with VAT and after all product discounts (including order level discounts on products)\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontItemsPriceWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Sum of items (all units) without VAT and after all product discounts (including order level discounts on products)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontUnitTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Tax as nominal value applied on unit price AFTER discount\nNULL if customer is verified to NOT pay VAT for Order (basically zero tax)',
        readOnly: true,
      })
    ),
    frontItemsTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Tax as nominal value applied on items (all units) price AFTER discount\nNULL if customer is verified to NOT pay VAT for Order (basically zero tax)',
        readOnly: true,
      })
    ),
    frontItemsPricePaid: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    discountedUnitPrice: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns single unit price lowered by order unit promotions (each unit must have the same unit promotion discount)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    subtotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'OrderItemjsonldsyliusshopcartshow' });
export type OrderItemjsonldsyliusshopcartshow = Schema.Schema.Type<
  typeof OrderItemjsonldsyliusshopcartshow
>;
export type OrderItemjsonldsyliusshopcartshowEncoded = Schema.Codec.Encoded<
  typeof OrderItemjsonldsyliusshopcartshow
>;

/* OrderItemUnitsyliusadminorderitemunitshow */

export const OrderItemUnitsyliusadminorderitemunitshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    shippable: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        readOnly: true,
        format: 'iri-reference',
      })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'OrderItemUnitsyliusadminorderitemunitshow' });
export type OrderItemUnitsyliusadminorderitemunitshow = Schema.Schema.Type<
  typeof OrderItemUnitsyliusadminorderitemunitshow
>;
export type OrderItemUnitsyliusadminorderitemunitshowEncoded = Schema.Codec.Encoded<
  typeof OrderItemUnitsyliusadminorderitemunitshow
>;

/* OrderItemUnitjsonldsyliusadminorderitemunitshow */

export const OrderItemUnitjsonldsyliusadminorderitemunitshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    shippable: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        readOnly: true,
        format: 'iri-reference',
      })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'OrderItemUnitjsonldsyliusadminorderitemunitshow' });
export type OrderItemUnitjsonldsyliusadminorderitemunitshow = Schema.Schema.Type<
  typeof OrderItemUnitjsonldsyliusadminorderitemunitshow
>;
export type OrderItemUnitjsonldsyliusadminorderitemunitshowEncoded = Schema.Codec.Encoded<
  typeof OrderItemUnitjsonldsyliusadminorderitemunitshow
>;

/* TitleElementDTOsyliusshoppageshow */

export const TitleElementDTOsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    content: Schema.String,
    tag: Schema.Union([Schema.String, Schema.Null]),
    type: Schema.Literal('title').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TitleElementDTOsyliusshoppageshow' });
export type TitleElementDTOsyliusshoppageshow = Schema.Schema.Type<
  typeof TitleElementDTOsyliusshoppageshow
>;
export type TitleElementDTOsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof TitleElementDTOsyliusshoppageshow
>;

/* MarkdownTextElementDTOsyliusshoppageshow */

export const MarkdownTextElementDTOsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    content: Schema.String,
    type: Schema.Literal('markdown_text').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'MarkdownTextElementDTOsyliusshoppageshow' });
export type MarkdownTextElementDTOsyliusshoppageshow = Schema.Schema.Type<
  typeof MarkdownTextElementDTOsyliusshoppageshow
>;
export type MarkdownTextElementDTOsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof MarkdownTextElementDTOsyliusshoppageshow
>;

/* QuoteElementDTOsyliusshoppageshow */

export const QuoteElementDTOsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    content: Schema.String,
    author: Schema.Union([Schema.String, Schema.Null]),
    type: Schema.Literal('quote').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'QuoteElementDTOsyliusshoppageshow' });
export type QuoteElementDTOsyliusshoppageshow = Schema.Schema.Type<
  typeof QuoteElementDTOsyliusshoppageshow
>;
export type QuoteElementDTOsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof QuoteElementDTOsyliusshoppageshow
>;

/* ImageElementDTOsyliusshoppageshow */

export const ImageElementDTOsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    size: Schema.Literals(['wide', 'fit']),
    alt: Schema.Union([Schema.String, Schema.Null]),
    type: Schema.Literal('image').annotate({ readOnly: true }),
    imageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ImageElementDTOsyliusshoppageshow' });
export type ImageElementDTOsyliusshoppageshow = Schema.Schema.Type<
  typeof ImageElementDTOsyliusshoppageshow
>;
export type ImageElementDTOsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof ImageElementDTOsyliusshoppageshow
>;

/* ImageItemDTOsyliusshoppageshow */

export const ImageItemDTOsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    alt: Schema.Union([Schema.String, Schema.Null]),
    link: Schema.Union([Schema.String, Schema.Null]),
    linkType: Schema.Union([Schema.String, Schema.Null]),
    imageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ImageItemDTOsyliusshoppageshow' });
export type ImageItemDTOsyliusshoppageshow = Schema.Schema.Type<
  typeof ImageItemDTOsyliusshoppageshow
>;
export type ImageItemDTOsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof ImageItemDTOsyliusshoppageshow
>;

/* ProductImagesyliusshoppageshow */

export const ProductImagesyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    type: Schema.Union([Schema.String, Schema.Null]),
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductImagesyliusshoppageshow' });
export type ProductImagesyliusshoppageshow = Schema.Schema.Type<
  typeof ProductImagesyliusshoppageshow
>;
export type ProductImagesyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof ProductImagesyliusshoppageshow
>;

/* YoutubeElementDTOsyliusshoppageshow */

export const YoutubeElementDTOsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    link: Schema.String,
    type: Schema.Literal('youtube').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'YoutubeElementDTOsyliusshoppageshow' });
export type YoutubeElementDTOsyliusshoppageshow = Schema.Schema.Type<
  typeof YoutubeElementDTOsyliusshoppageshow
>;
export type YoutubeElementDTOsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof YoutubeElementDTOsyliusshoppageshow
>;

/* MarkdownTwoColumnsElementDTOsyliusshoppageshow */

export const MarkdownTwoColumnsElementDTOsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    left: Schema.String,
    right: Schema.String,
    type: Schema.Literal('markdown_two_columns').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'MarkdownTwoColumnsElementDTOsyliusshoppageshow' });
export type MarkdownTwoColumnsElementDTOsyliusshoppageshow = Schema.Schema.Type<
  typeof MarkdownTwoColumnsElementDTOsyliusshoppageshow
>;
export type MarkdownTwoColumnsElementDTOsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof MarkdownTwoColumnsElementDTOsyliusshoppageshow
>;

/* MarkdownThreeColumnsElementDTOsyliusshoppageshow */

export const MarkdownThreeColumnsElementDTOsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    left: Schema.String,
    center: Schema.String,
    right: Schema.String,
    type: Schema.Literal('markdown_three_columns').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'MarkdownThreeColumnsElementDTOsyliusshoppageshow' });
export type MarkdownThreeColumnsElementDTOsyliusshoppageshow = Schema.Schema.Type<
  typeof MarkdownThreeColumnsElementDTOsyliusshoppageshow
>;
export type MarkdownThreeColumnsElementDTOsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof MarkdownThreeColumnsElementDTOsyliusshoppageshow
>;

/* RetinoWidgetElementDTOsyliusshoppageshow */

export const RetinoWidgetElementDTOsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    companyId: Schema.String,
    type: Schema.Literal('retino-widget').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'RetinoWidgetElementDTOsyliusshoppageshow' });
export type RetinoWidgetElementDTOsyliusshoppageshow = Schema.Schema.Type<
  typeof RetinoWidgetElementDTOsyliusshoppageshow
>;
export type RetinoWidgetElementDTOsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof RetinoWidgetElementDTOsyliusshoppageshow
>;

/* AdvantagesElementDTOsyliusshoppageshow */

export const AdvantagesElementDTOsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    textOne: Schema.String,
    textTwo: Schema.String,
    textThree: Schema.String,
    textFour: Schema.String,
    type: Schema.Literal('advantages').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'AdvantagesElementDTOsyliusshoppageshow' });
export type AdvantagesElementDTOsyliusshoppageshow = Schema.Schema.Type<
  typeof AdvantagesElementDTOsyliusshoppageshow
>;
export type AdvantagesElementDTOsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof AdvantagesElementDTOsyliusshoppageshow
>;

/* WhiteBoxElementDTOsyliusshoppageshow */

export const WhiteBoxElementDTOsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    text: Schema.String,
    type: Schema.Literal('white_box').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'WhiteBoxElementDTOsyliusshoppageshow' });
export type WhiteBoxElementDTOsyliusshoppageshow = Schema.Schema.Type<
  typeof WhiteBoxElementDTOsyliusshoppageshow
>;
export type WhiteBoxElementDTOsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof WhiteBoxElementDTOsyliusshoppageshow
>;

/* ImageClearItemDTOsyliusshoppageshow */

export const ImageClearItemDTOsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    alt: Schema.Union([Schema.String, Schema.Null]),
    imageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ImageClearItemDTOsyliusshoppageshow' });
export type ImageClearItemDTOsyliusshoppageshow = Schema.Schema.Type<
  typeof ImageClearItemDTOsyliusshoppageshow
>;
export type ImageClearItemDTOsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof ImageClearItemDTOsyliusshoppageshow
>;

/* GoogleMapsElementDTOsyliusshoppageshow */

export const GoogleMapsElementDTOsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    lat: Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
    long: Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
    zoom: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    type: Schema.Literal('google-maps').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'GoogleMapsElementDTOsyliusshoppageshow' });
export type GoogleMapsElementDTOsyliusshoppageshow = Schema.Schema.Type<
  typeof GoogleMapsElementDTOsyliusshoppageshow
>;
export type GoogleMapsElementDTOsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof GoogleMapsElementDTOsyliusshoppageshow
>;

/* BaseButtonElementDTOsyliusshoppageshow */

export const BaseButtonElementDTOsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    link: Schema.String,
    text: Schema.String,
    type: Schema.Literal('base_button').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'BaseButtonElementDTOsyliusshoppageshow' });
export type BaseButtonElementDTOsyliusshoppageshow = Schema.Schema.Type<
  typeof BaseButtonElementDTOsyliusshoppageshow
>;
export type BaseButtonElementDTOsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof BaseButtonElementDTOsyliusshoppageshow
>;

/* ProductListElementDTOsyliusshoppageshow */

export const ProductListElementDTOsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    style: Schema.Literals(['withoutDescription', 'normal']),
    products: Schema.Array(Schema.String),
    productsPerPage: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    type: Schema.Literal('product_list').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductListElementDTOsyliusshoppageshow' });
export type ProductListElementDTOsyliusshoppageshow = Schema.Schema.Type<
  typeof ProductListElementDTOsyliusshoppageshow
>;
export type ProductListElementDTOsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof ProductListElementDTOsyliusshoppageshow
>;

/* TableCellItemDTOsyliusshoppageshow */

export const TableCellItemDTOsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({ content: Schema.String, color: Schema.Literals(['black', 'gray', 'white']) }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TableCellItemDTOsyliusshoppageshow' });
export type TableCellItemDTOsyliusshoppageshow = Schema.Schema.Type<
  typeof TableCellItemDTOsyliusshoppageshow
>;
export type TableCellItemDTOsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof TableCellItemDTOsyliusshoppageshow
>;

/* TitleElementDTOjsonldsyliusshoppageshow */

export const TitleElementDTOjsonldsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    content: Schema.String,
    tag: Schema.Union([Schema.String, Schema.Null]),
    type: Schema.Literal('title').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TitleElementDTOjsonldsyliusshoppageshow' });
export type TitleElementDTOjsonldsyliusshoppageshow = Schema.Schema.Type<
  typeof TitleElementDTOjsonldsyliusshoppageshow
>;
export type TitleElementDTOjsonldsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof TitleElementDTOjsonldsyliusshoppageshow
>;

/* MarkdownTextElementDTOjsonldsyliusshoppageshow */

export const MarkdownTextElementDTOjsonldsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    content: Schema.String,
    type: Schema.Literal('markdown_text').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'MarkdownTextElementDTOjsonldsyliusshoppageshow' });
export type MarkdownTextElementDTOjsonldsyliusshoppageshow = Schema.Schema.Type<
  typeof MarkdownTextElementDTOjsonldsyliusshoppageshow
>;
export type MarkdownTextElementDTOjsonldsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof MarkdownTextElementDTOjsonldsyliusshoppageshow
>;

/* QuoteElementDTOjsonldsyliusshoppageshow */

export const QuoteElementDTOjsonldsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    content: Schema.String,
    author: Schema.Union([Schema.String, Schema.Null]),
    type: Schema.Literal('quote').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'QuoteElementDTOjsonldsyliusshoppageshow' });
export type QuoteElementDTOjsonldsyliusshoppageshow = Schema.Schema.Type<
  typeof QuoteElementDTOjsonldsyliusshoppageshow
>;
export type QuoteElementDTOjsonldsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof QuoteElementDTOjsonldsyliusshoppageshow
>;

/* ImageElementDTOjsonldsyliusshoppageshow */

export const ImageElementDTOjsonldsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    size: Schema.Literals(['wide', 'fit']),
    alt: Schema.Union([Schema.String, Schema.Null]),
    type: Schema.Literal('image').annotate({ readOnly: true }),
    imageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ImageElementDTOjsonldsyliusshoppageshow' });
export type ImageElementDTOjsonldsyliusshoppageshow = Schema.Schema.Type<
  typeof ImageElementDTOjsonldsyliusshoppageshow
>;
export type ImageElementDTOjsonldsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof ImageElementDTOjsonldsyliusshoppageshow
>;

/* ImageItemDTOjsonldsyliusshoppageshow */

export const ImageItemDTOjsonldsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    alt: Schema.Union([Schema.String, Schema.Null]),
    link: Schema.Union([Schema.String, Schema.Null]),
    linkType: Schema.Union([Schema.String, Schema.Null]),
    imageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ImageItemDTOjsonldsyliusshoppageshow' });
export type ImageItemDTOjsonldsyliusshoppageshow = Schema.Schema.Type<
  typeof ImageItemDTOjsonldsyliusshoppageshow
>;
export type ImageItemDTOjsonldsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof ImageItemDTOjsonldsyliusshoppageshow
>;

/* ProductImagejsonldsyliusshoppageshow */

export const ProductImagejsonldsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    type: Schema.Union([Schema.String, Schema.Null]),
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductImagejsonldsyliusshoppageshow' });
export type ProductImagejsonldsyliusshoppageshow = Schema.Schema.Type<
  typeof ProductImagejsonldsyliusshoppageshow
>;
export type ProductImagejsonldsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof ProductImagejsonldsyliusshoppageshow
>;

/* YoutubeElementDTOjsonldsyliusshoppageshow */

export const YoutubeElementDTOjsonldsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    link: Schema.String,
    type: Schema.Literal('youtube').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'YoutubeElementDTOjsonldsyliusshoppageshow' });
export type YoutubeElementDTOjsonldsyliusshoppageshow = Schema.Schema.Type<
  typeof YoutubeElementDTOjsonldsyliusshoppageshow
>;
export type YoutubeElementDTOjsonldsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof YoutubeElementDTOjsonldsyliusshoppageshow
>;

/* MarkdownTwoColumnsElementDTOjsonldsyliusshoppageshow */

export const MarkdownTwoColumnsElementDTOjsonldsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    left: Schema.String,
    right: Schema.String,
    type: Schema.Literal('markdown_two_columns').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'MarkdownTwoColumnsElementDTOjsonldsyliusshoppageshow' });
export type MarkdownTwoColumnsElementDTOjsonldsyliusshoppageshow = Schema.Schema.Type<
  typeof MarkdownTwoColumnsElementDTOjsonldsyliusshoppageshow
>;
export type MarkdownTwoColumnsElementDTOjsonldsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof MarkdownTwoColumnsElementDTOjsonldsyliusshoppageshow
>;

/* MarkdownThreeColumnsElementDTOjsonldsyliusshoppageshow */

export const MarkdownThreeColumnsElementDTOjsonldsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    left: Schema.String,
    center: Schema.String,
    right: Schema.String,
    type: Schema.Literal('markdown_three_columns').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'MarkdownThreeColumnsElementDTOjsonldsyliusshoppageshow' });
export type MarkdownThreeColumnsElementDTOjsonldsyliusshoppageshow = Schema.Schema.Type<
  typeof MarkdownThreeColumnsElementDTOjsonldsyliusshoppageshow
>;
export type MarkdownThreeColumnsElementDTOjsonldsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof MarkdownThreeColumnsElementDTOjsonldsyliusshoppageshow
>;

/* RetinoWidgetElementDTOjsonldsyliusshoppageshow */

export const RetinoWidgetElementDTOjsonldsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    companyId: Schema.String,
    type: Schema.Literal('retino-widget').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'RetinoWidgetElementDTOjsonldsyliusshoppageshow' });
export type RetinoWidgetElementDTOjsonldsyliusshoppageshow = Schema.Schema.Type<
  typeof RetinoWidgetElementDTOjsonldsyliusshoppageshow
>;
export type RetinoWidgetElementDTOjsonldsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof RetinoWidgetElementDTOjsonldsyliusshoppageshow
>;

/* AdvantagesElementDTOjsonldsyliusshoppageshow */

export const AdvantagesElementDTOjsonldsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    textOne: Schema.String,
    textTwo: Schema.String,
    textThree: Schema.String,
    textFour: Schema.String,
    type: Schema.Literal('advantages').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'AdvantagesElementDTOjsonldsyliusshoppageshow' });
export type AdvantagesElementDTOjsonldsyliusshoppageshow = Schema.Schema.Type<
  typeof AdvantagesElementDTOjsonldsyliusshoppageshow
>;
export type AdvantagesElementDTOjsonldsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof AdvantagesElementDTOjsonldsyliusshoppageshow
>;

/* WhiteBoxElementDTOjsonldsyliusshoppageshow */

export const WhiteBoxElementDTOjsonldsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    text: Schema.String,
    type: Schema.Literal('white_box').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'WhiteBoxElementDTOjsonldsyliusshoppageshow' });
export type WhiteBoxElementDTOjsonldsyliusshoppageshow = Schema.Schema.Type<
  typeof WhiteBoxElementDTOjsonldsyliusshoppageshow
>;
export type WhiteBoxElementDTOjsonldsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof WhiteBoxElementDTOjsonldsyliusshoppageshow
>;

/* ImageClearItemDTOjsonldsyliusshoppageshow */

export const ImageClearItemDTOjsonldsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    alt: Schema.Union([Schema.String, Schema.Null]),
    imageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ImageClearItemDTOjsonldsyliusshoppageshow' });
export type ImageClearItemDTOjsonldsyliusshoppageshow = Schema.Schema.Type<
  typeof ImageClearItemDTOjsonldsyliusshoppageshow
>;
export type ImageClearItemDTOjsonldsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof ImageClearItemDTOjsonldsyliusshoppageshow
>;

/* GoogleMapsElementDTOjsonldsyliusshoppageshow */

export const GoogleMapsElementDTOjsonldsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    lat: Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
    long: Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
    zoom: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    type: Schema.Literal('google-maps').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'GoogleMapsElementDTOjsonldsyliusshoppageshow' });
export type GoogleMapsElementDTOjsonldsyliusshoppageshow = Schema.Schema.Type<
  typeof GoogleMapsElementDTOjsonldsyliusshoppageshow
>;
export type GoogleMapsElementDTOjsonldsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof GoogleMapsElementDTOjsonldsyliusshoppageshow
>;

/* BaseButtonElementDTOjsonldsyliusshoppageshow */

export const BaseButtonElementDTOjsonldsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    link: Schema.String,
    text: Schema.String,
    type: Schema.Literal('base_button').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'BaseButtonElementDTOjsonldsyliusshoppageshow' });
export type BaseButtonElementDTOjsonldsyliusshoppageshow = Schema.Schema.Type<
  typeof BaseButtonElementDTOjsonldsyliusshoppageshow
>;
export type BaseButtonElementDTOjsonldsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof BaseButtonElementDTOjsonldsyliusshoppageshow
>;

/* ProductListElementDTOjsonldsyliusshoppageshow */

export const ProductListElementDTOjsonldsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    style: Schema.Literals(['withoutDescription', 'normal']),
    products: Schema.Array(Schema.String),
    productsPerPage: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    type: Schema.Literal('product_list').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductListElementDTOjsonldsyliusshoppageshow' });
export type ProductListElementDTOjsonldsyliusshoppageshow = Schema.Schema.Type<
  typeof ProductListElementDTOjsonldsyliusshoppageshow
>;
export type ProductListElementDTOjsonldsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof ProductListElementDTOjsonldsyliusshoppageshow
>;

/* TableCellItemDTOjsonldsyliusshoppageshow */

export const TableCellItemDTOjsonldsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    content: Schema.String,
    color: Schema.Literals(['black', 'gray', 'white']),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TableCellItemDTOjsonldsyliusshoppageshow' });
export type TableCellItemDTOjsonldsyliusshoppageshow = Schema.Schema.Type<
  typeof TableCellItemDTOjsonldsyliusshoppageshow
>;
export type TableCellItemDTOjsonldsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof TableCellItemDTOjsonldsyliusshoppageshow
>;

/* PaymentMethodsyliusadminpaymentindex */

export const PaymentMethodsyliusadminpaymentindex = Schema.StructWithRest(
  Schema.Struct({
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PaymentMethodsyliusadminpaymentindex' });
export type PaymentMethodsyliusadminpaymentindex = Schema.Schema.Type<
  typeof PaymentMethodsyliusadminpaymentindex
>;
export type PaymentMethodsyliusadminpaymentindexEncoded = Schema.Codec.Encoded<
  typeof PaymentMethodsyliusadminpaymentindex
>;

/* PaymentMethodsyliusadminpaymentshow */

export const PaymentMethodsyliusadminpaymentshow = Schema.StructWithRest(
  Schema.Struct({
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PaymentMethodsyliusadminpaymentshow' });
export type PaymentMethodsyliusadminpaymentshow = Schema.Schema.Type<
  typeof PaymentMethodsyliusadminpaymentshow
>;
export type PaymentMethodsyliusadminpaymentshowEncoded = Schema.Codec.Encoded<
  typeof PaymentMethodsyliusadminpaymentshow
>;

/* PaymentMethodsyliusshoppaymentshow */

export const PaymentMethodsyliusshoppaymentshow = Schema.StructWithRest(
  Schema.Struct({ name: Schema.Union([Schema.String, Schema.Null]) }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PaymentMethodsyliusshoppaymentshow' });
export type PaymentMethodsyliusshoppaymentshow = Schema.Schema.Type<
  typeof PaymentMethodsyliusshoppaymentshow
>;
export type PaymentMethodsyliusshoppaymentshowEncoded = Schema.Codec.Encoded<
  typeof PaymentMethodsyliusshoppaymentshow
>;

/* PaymentMethodjsonldsyliusadminpaymentindex */

export const PaymentMethodjsonldsyliusadminpaymentindex = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PaymentMethodjsonldsyliusadminpaymentindex' });
export type PaymentMethodjsonldsyliusadminpaymentindex = Schema.Schema.Type<
  typeof PaymentMethodjsonldsyliusadminpaymentindex
>;
export type PaymentMethodjsonldsyliusadminpaymentindexEncoded = Schema.Codec.Encoded<
  typeof PaymentMethodjsonldsyliusadminpaymentindex
>;

/* PaymentMethodjsonldsyliusadminpaymentshow */

export const PaymentMethodjsonldsyliusadminpaymentshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PaymentMethodjsonldsyliusadminpaymentshow' });
export type PaymentMethodjsonldsyliusadminpaymentshow = Schema.Schema.Type<
  typeof PaymentMethodjsonldsyliusadminpaymentshow
>;
export type PaymentMethodjsonldsyliusadminpaymentshowEncoded = Schema.Codec.Encoded<
  typeof PaymentMethodjsonldsyliusadminpaymentshow
>;

/* PaymentMethodjsonldsyliusshoppaymentshow */

export const PaymentMethodjsonldsyliusshoppaymentshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    name: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PaymentMethodjsonldsyliusshoppaymentshow' });
export type PaymentMethodjsonldsyliusshoppaymentshow = Schema.Schema.Type<
  typeof PaymentMethodjsonldsyliusshoppaymentshow
>;
export type PaymentMethodjsonldsyliusshoppaymentshowEncoded = Schema.Codec.Encoded<
  typeof PaymentMethodjsonldsyliusshoppaymentshow
>;

/* PaymentMethodsyliusshoppaymentmethodindex */

export const PaymentMethodsyliusshoppaymentmethodindex = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    name: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
    instructions: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PaymentMethodsyliusshoppaymentmethodindex' });
export type PaymentMethodsyliusshoppaymentmethodindex = Schema.Schema.Type<
  typeof PaymentMethodsyliusshoppaymentmethodindex
>;
export type PaymentMethodsyliusshoppaymentmethodindexEncoded = Schema.Codec.Encoded<
  typeof PaymentMethodsyliusshoppaymentmethodindex
>;

/* PaymentMethodsyliusshoppaymentmethodshow */

export const PaymentMethodsyliusshoppaymentmethodshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    name: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
    instructions: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PaymentMethodsyliusshoppaymentmethodshow' });
export type PaymentMethodsyliusshoppaymentmethodshow = Schema.Schema.Type<
  typeof PaymentMethodsyliusshoppaymentmethodshow
>;
export type PaymentMethodsyliusshoppaymentmethodshowEncoded = Schema.Codec.Encoded<
  typeof PaymentMethodsyliusshoppaymentmethodshow
>;

/* PaymentMethodjsonldsyliusshoppaymentmethodindex */

export const PaymentMethodjsonldsyliusshoppaymentmethodindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    name: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
    instructions: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PaymentMethodjsonldsyliusshoppaymentmethodindex' });
export type PaymentMethodjsonldsyliusshoppaymentmethodindex = Schema.Schema.Type<
  typeof PaymentMethodjsonldsyliusshoppaymentmethodindex
>;
export type PaymentMethodjsonldsyliusshoppaymentmethodindexEncoded = Schema.Codec.Encoded<
  typeof PaymentMethodjsonldsyliusshoppaymentmethodindex
>;

/* PaymentMethodjsonldsyliusshoppaymentmethodshow */

export const PaymentMethodjsonldsyliusshoppaymentmethodshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    name: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
    instructions: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PaymentMethodjsonldsyliusshoppaymentmethodshow' });
export type PaymentMethodjsonldsyliusshoppaymentmethodshow = Schema.Schema.Type<
  typeof PaymentMethodjsonldsyliusshoppaymentmethodshow
>;
export type PaymentMethodjsonldsyliusshoppaymentmethodshowEncoded = Schema.Codec.Encoded<
  typeof PaymentMethodjsonldsyliusshoppaymentmethodshow
>;

/* PaymentRequestsyliusadminpaymentrequestindex */

export const PaymentRequestsyliusadminpaymentrequestindex = Schema.StructWithRest(
  Schema.Struct({
    hash: Schema.optionalKey(Schema.String.annotate({ readOnly: true, format: 'uuid' })),
    state: Schema.String.annotate({ default: 'new' }),
    action: Schema.String.annotate({ default: 'capture' }),
    payment: Schema.String.annotate({ format: 'iri-reference' }),
    method: Schema.String.annotate({ format: 'iri-reference' }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PaymentRequestsyliusadminpaymentrequestindex' });
export type PaymentRequestsyliusadminpaymentrequestindex = Schema.Schema.Type<
  typeof PaymentRequestsyliusadminpaymentrequestindex
>;
export type PaymentRequestsyliusadminpaymentrequestindexEncoded = Schema.Codec.Encoded<
  typeof PaymentRequestsyliusadminpaymentrequestindex
>;

/* PaymentRequestAddPaymentRequestsyliusshoppaymentrequestcreate */

export const PaymentRequestAddPaymentRequestsyliusshoppaymentrequestcreate = Schema.StructWithRest(
  Schema.Struct({
    paymentId: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    paymentMethodCode: Schema.String,
    action: Schema.Union([Schema.String, Schema.Null]),
    payload: Schema.Json.annotate({ expected: 'JSON value' }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PaymentRequestAddPaymentRequestsyliusshoppaymentrequestcreate' });
export type PaymentRequestAddPaymentRequestsyliusshoppaymentrequestcreate = Schema.Schema.Type<
  typeof PaymentRequestAddPaymentRequestsyliusshoppaymentrequestcreate
>;
export type PaymentRequestAddPaymentRequestsyliusshoppaymentrequestcreateEncoded =
  Schema.Codec.Encoded<typeof PaymentRequestAddPaymentRequestsyliusshoppaymentrequestcreate>;

/* PaymentRequestAddPaymentRequestjsonldsyliusshoppaymentrequestcreate */

export const PaymentRequestAddPaymentRequestjsonldsyliusshoppaymentrequestcreate =
  Schema.StructWithRest(
    Schema.Struct({
      paymentId: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      paymentMethodCode: Schema.String,
      action: Schema.Union([Schema.String, Schema.Null]),
      payload: Schema.Json.annotate({ expected: 'JSON value' }),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({ identifier: 'PaymentRequestAddPaymentRequestjsonldsyliusshoppaymentrequestcreate' });
export type PaymentRequestAddPaymentRequestjsonldsyliusshoppaymentrequestcreate =
  Schema.Schema.Type<typeof PaymentRequestAddPaymentRequestjsonldsyliusshoppaymentrequestcreate>;
export type PaymentRequestAddPaymentRequestjsonldsyliusshoppaymentrequestcreateEncoded =
  Schema.Codec.Encoded<typeof PaymentRequestAddPaymentRequestjsonldsyliusshoppaymentrequestcreate>;

/* PaymentRequestUpdatePaymentRequestsyliusshoppaymentrequestupdate */

export const PaymentRequestUpdatePaymentRequestsyliusshoppaymentrequestupdate =
  Schema.StructWithRest(
    Schema.Struct({ payload: Schema.Json.annotate({ expected: 'JSON value' }) }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({ identifier: 'PaymentRequestUpdatePaymentRequestsyliusshoppaymentrequestupdate' });
export type PaymentRequestUpdatePaymentRequestsyliusshoppaymentrequestupdate = Schema.Schema.Type<
  typeof PaymentRequestUpdatePaymentRequestsyliusshoppaymentrequestupdate
>;
export type PaymentRequestUpdatePaymentRequestsyliusshoppaymentrequestupdateEncoded =
  Schema.Codec.Encoded<typeof PaymentRequestUpdatePaymentRequestsyliusshoppaymentrequestupdate>;

/* PaymentRequestUpdatePaymentRequestjsonldsyliusshoppaymentrequestupdate */

export const PaymentRequestUpdatePaymentRequestjsonldsyliusshoppaymentrequestupdate =
  Schema.StructWithRest(
    Schema.Struct({ payload: Schema.Json.annotate({ expected: 'JSON value' }) }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier: 'PaymentRequestUpdatePaymentRequestjsonldsyliusshoppaymentrequestupdate',
  });
export type PaymentRequestUpdatePaymentRequestjsonldsyliusshoppaymentrequestupdate =
  Schema.Schema.Type<typeof PaymentRequestUpdatePaymentRequestjsonldsyliusshoppaymentrequestupdate>;
export type PaymentRequestUpdatePaymentRequestjsonldsyliusshoppaymentrequestupdateEncoded =
  Schema.Codec.Encoded<
    typeof PaymentRequestUpdatePaymentRequestjsonldsyliusshoppaymentrequestupdate
  >;

/* PaymentRequestjsonldsyliusadminpaymentrequestindex */

export const PaymentRequestjsonldsyliusadminpaymentrequestindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    hash: Schema.optionalKey(Schema.String.annotate({ readOnly: true, format: 'uuid' })),
    state: Schema.String.annotate({ default: 'new' }),
    action: Schema.String.annotate({ default: 'capture' }),
    payment: Schema.String.annotate({ format: 'iri-reference' }),
    method: Schema.String.annotate({ format: 'iri-reference' }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PaymentRequestjsonldsyliusadminpaymentrequestindex' });
export type PaymentRequestjsonldsyliusadminpaymentrequestindex = Schema.Schema.Type<
  typeof PaymentRequestjsonldsyliusadminpaymentrequestindex
>;
export type PaymentRequestjsonldsyliusadminpaymentrequestindexEncoded = Schema.Codec.Encoded<
  typeof PaymentRequestjsonldsyliusadminpaymentrequestindex
>;

/* ProductAttributeValuesyliusadminproductcreate */

export const ProductAttributeValuesyliusadminproductcreate = Schema.StructWithRest(
  Schema.Struct({
    attribute: Schema.String.annotate({ writeOnly: true, format: 'iri-reference' }),
    localeCode: Schema.Union([Schema.String, Schema.Null]),
    value: Schema.Union([
      Schema.String,
      Schema.Boolean,
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Array(Schema.String),
      Schema.Null,
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAttributeValuesyliusadminproductcreate' });
export type ProductAttributeValuesyliusadminproductcreate = Schema.Schema.Type<
  typeof ProductAttributeValuesyliusadminproductcreate
>;
export type ProductAttributeValuesyliusadminproductcreateEncoded = Schema.Codec.Encoded<
  typeof ProductAttributeValuesyliusadminproductcreate
>;

/* ProductAttributeValuesyliusadminproductindex */

export const ProductAttributeValuesyliusadminproductindex = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    attribute: Schema.String.annotate({ writeOnly: true, format: 'iri-reference' }),
    localeCode: Schema.Union([Schema.String, Schema.Null]),
    value: Schema.Union([
      Schema.String,
      Schema.Boolean,
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Array(Schema.String),
      Schema.Null,
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAttributeValuesyliusadminproductindex' });
export type ProductAttributeValuesyliusadminproductindex = Schema.Schema.Type<
  typeof ProductAttributeValuesyliusadminproductindex
>;
export type ProductAttributeValuesyliusadminproductindexEncoded = Schema.Codec.Encoded<
  typeof ProductAttributeValuesyliusadminproductindex
>;

/* ProductImagesyliusadminproductshow */

export const ProductImagesyliusadminproductshow = Schema.StructWithRest(
  Schema.Struct({
    cropX: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    cropY: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    cropWidth: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    cropHeight: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    type: Schema.Union([Schema.String, Schema.Null]),
    path: Schema.String,
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductImagesyliusadminproductshow' });
export type ProductImagesyliusadminproductshow = Schema.Schema.Type<
  typeof ProductImagesyliusadminproductshow
>;
export type ProductImagesyliusadminproductshowEncoded = Schema.Codec.Encoded<
  typeof ProductImagesyliusadminproductshow
>;

/* ProductAttributeValuesyliusadminproductshow */

export const ProductAttributeValuesyliusadminproductshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    attribute: Schema.String.annotate({ writeOnly: true, format: 'iri-reference' }),
    localeCode: Schema.Union([Schema.String, Schema.Null]),
    value: Schema.Union([
      Schema.String,
      Schema.Boolean,
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Array(Schema.String),
      Schema.Null,
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAttributeValuesyliusadminproductshow' });
export type ProductAttributeValuesyliusadminproductshow = Schema.Schema.Type<
  typeof ProductAttributeValuesyliusadminproductshow
>;
export type ProductAttributeValuesyliusadminproductshowEncoded = Schema.Codec.Encoded<
  typeof ProductAttributeValuesyliusadminproductshow
>;

/* ProductImagesyliusadminproductupdate */

export const ProductImagesyliusadminproductupdate = Schema.StructWithRest(
  Schema.Struct({
    cropX: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    cropY: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    cropWidth: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    cropHeight: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    type: Schema.Union([Schema.String, Schema.Null]),
    path: Schema.String,
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductImagesyliusadminproductupdate' });
export type ProductImagesyliusadminproductupdate = Schema.Schema.Type<
  typeof ProductImagesyliusadminproductupdate
>;
export type ProductImagesyliusadminproductupdateEncoded = Schema.Codec.Encoded<
  typeof ProductImagesyliusadminproductupdate
>;

/* ProductAttributeValuesyliusadminproductupdate */

export const ProductAttributeValuesyliusadminproductupdate = Schema.StructWithRest(
  Schema.Struct({
    attribute: Schema.String.annotate({ writeOnly: true, format: 'iri-reference' }),
    localeCode: Schema.Union([Schema.String, Schema.Null]),
    value: Schema.Union([
      Schema.String,
      Schema.Boolean,
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Array(Schema.String),
      Schema.Null,
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAttributeValuesyliusadminproductupdate' });
export type ProductAttributeValuesyliusadminproductupdate = Schema.Schema.Type<
  typeof ProductAttributeValuesyliusadminproductupdate
>;
export type ProductAttributeValuesyliusadminproductupdateEncoded = Schema.Codec.Encoded<
  typeof ProductAttributeValuesyliusadminproductupdate
>;

/* Productsyliusadminproductimageshow */

export const Productsyliusadminproductimageshow = Schema.StructWithRest(
  Schema.Struct({
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Productsyliusadminproductimageshow' });
export type Productsyliusadminproductimageshow = Schema.Schema.Type<
  typeof Productsyliusadminproductimageshow
>;
export type ProductsyliusadminproductimageshowEncoded = Schema.Codec.Encoded<
  typeof Productsyliusadminproductimageshow
>;

/* ProductImagesyliusshopproductindex */

export const ProductImagesyliusshopproductindex = Schema.StructWithRest(
  Schema.Struct({
    type: Schema.Union([Schema.String, Schema.Null]),
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductImagesyliusshopproductindex' });
export type ProductImagesyliusshopproductindex = Schema.Schema.Type<
  typeof ProductImagesyliusshopproductindex
>;
export type ProductImagesyliusshopproductindexEncoded = Schema.Codec.Encoded<
  typeof ProductImagesyliusshopproductindex
>;

/* ProductImagesyliusshopproductindexbase */

export const ProductImagesyliusshopproductindexbase = Schema.StructWithRest(
  Schema.Struct({
    type: Schema.Union([Schema.String, Schema.Null]),
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductImagesyliusshopproductindexbase' });
export type ProductImagesyliusshopproductindexbase = Schema.Schema.Type<
  typeof ProductImagesyliusshopproductindexbase
>;
export type ProductImagesyliusshopproductindexbaseEncoded = Schema.Codec.Encoded<
  typeof ProductImagesyliusshopproductindexbase
>;

/* ProductVideosyliusshopproductshow */

export const ProductVideosyliusshopproductshow = Schema.StructWithRest(
  Schema.Struct({
    type: Schema.Literal('youtube').annotate({ default: 'youtube' }),
    path: Schema.String.annotate({ default: '' }),
    position: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductVideosyliusshopproductshow' });
export type ProductVideosyliusshopproductshow = Schema.Schema.Type<
  typeof ProductVideosyliusshopproductshow
>;
export type ProductVideosyliusshopproductshowEncoded = Schema.Codec.Encoded<
  typeof ProductVideosyliusshopproductshow
>;

/* ProductVideosyliusshopproductshowsyliusshopproductshowdetail */

export const ProductVideosyliusshopproductshowsyliusshopproductshowdetail = Schema.StructWithRest(
  Schema.Struct({
    type: Schema.Literal('youtube').annotate({ default: 'youtube' }),
    path: Schema.String.annotate({ default: '' }),
    position: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductVideosyliusshopproductshowsyliusshopproductshowdetail' });
export type ProductVideosyliusshopproductshowsyliusshopproductshowdetail = Schema.Schema.Type<
  typeof ProductVideosyliusshopproductshowsyliusshopproductshowdetail
>;
export type ProductVideosyliusshopproductshowsyliusshopproductshowdetailEncoded =
  Schema.Codec.Encoded<typeof ProductVideosyliusshopproductshowsyliusshopproductshowdetail>;

/* Taxonsyliusshopproductshowsyliusshopproductshowdetail */

export const Taxonsyliusshopproductshowsyliusshopproductshowdetail = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String,
    name: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonsyliusshopproductshowsyliusshopproductshowdetail' });
export type Taxonsyliusshopproductshowsyliusshopproductshowdetail = Schema.Schema.Type<
  typeof Taxonsyliusshopproductshowsyliusshopproductshowdetail
>;
export type TaxonsyliusshopproductshowsyliusshopproductshowdetailEncoded = Schema.Codec.Encoded<
  typeof Taxonsyliusshopproductshowsyliusshopproductshowdetail
>;

/* ProductImagesyliusshopproductshowsyliusshopproductshowdetail */

export const ProductImagesyliusshopproductshowsyliusshopproductshowdetail = Schema.StructWithRest(
  Schema.Struct({
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    type: Schema.Union([Schema.String, Schema.Null]),
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductImagesyliusshopproductshowsyliusshopproductshowdetail' });
export type ProductImagesyliusshopproductshowsyliusshopproductshowdetail = Schema.Schema.Type<
  typeof ProductImagesyliusshopproductshowsyliusshopproductshowdetail
>;
export type ProductImagesyliusshopproductshowsyliusshopproductshowdetailEncoded =
  Schema.Codec.Encoded<typeof ProductImagesyliusshopproductshowsyliusshopproductshowdetail>;

/* ProductAttributeValuesyliusshopproductshowsyliusshopproductshowdetail */

export const ProductAttributeValuesyliusshopproductshowsyliusshopproductshowdetail =
  Schema.StructWithRest(
    Schema.Struct({
      id: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      attributeGroupId: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true, format: 'uuid' })
      ),
      unit: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
      position: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({ readOnly: true })
      ),
      value: Schema.Union([
        Schema.String,
        Schema.Boolean,
        Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
        Schema.Array(Schema.String),
        Schema.Null,
      ]),
      name: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier: 'ProductAttributeValuesyliusshopproductshowsyliusshopproductshowdetail',
  });
export type ProductAttributeValuesyliusshopproductshowsyliusshopproductshowdetail =
  Schema.Schema.Type<typeof ProductAttributeValuesyliusshopproductshowsyliusshopproductshowdetail>;
export type ProductAttributeValuesyliusshopproductshowsyliusshopproductshowdetailEncoded =
  Schema.Codec.Encoded<
    typeof ProductAttributeValuesyliusshopproductshowsyliusshopproductshowdetail
  >;

/* ProductDocumentsyliusshopproductshowsyliusshopproductshowdetail */

export const ProductDocumentsyliusshopproductshowsyliusshopproductshowdetail =
  Schema.StructWithRest(
    Schema.Struct({
      id: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      name: Schema.Union([
        Schema.String.check(
          Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
        ),
        Schema.Null,
      ]),
      path: Schema.String,
      publicPath: Schema.Union([Schema.String, Schema.Null]),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({ identifier: 'ProductDocumentsyliusshopproductshowsyliusshopproductshowdetail' });
export type ProductDocumentsyliusshopproductshowsyliusshopproductshowdetail = Schema.Schema.Type<
  typeof ProductDocumentsyliusshopproductshowsyliusshopproductshowdetail
>;
export type ProductDocumentsyliusshopproductshowsyliusshopproductshowdetailEncoded =
  Schema.Codec.Encoded<typeof ProductDocumentsyliusshopproductshowsyliusshopproductshowdetail>;

/* Taxonsyliusshoptaxonindexshort */

export const Taxonsyliusshoptaxonindexshort = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    nameInTaxonList: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonsyliusshoptaxonindexshort' });
export type Taxonsyliusshoptaxonindexshort = Schema.Schema.Type<
  typeof Taxonsyliusshoptaxonindexshort
>;
export type TaxonsyliusshoptaxonindexshortEncoded = Schema.Codec.Encoded<
  typeof Taxonsyliusshoptaxonindexshort
>;

/* ProductAttributeValuejsonldsyliusadminproductcreate */

export const ProductAttributeValuejsonldsyliusadminproductcreate = Schema.StructWithRest(
  Schema.Struct({
    attribute: Schema.String.annotate({ writeOnly: true, format: 'iri-reference' }),
    localeCode: Schema.Union([Schema.String, Schema.Null]),
    value: Schema.Union([
      Schema.String,
      Schema.Boolean,
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Array(Schema.String),
      Schema.Null,
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAttributeValuejsonldsyliusadminproductcreate' });
export type ProductAttributeValuejsonldsyliusadminproductcreate = Schema.Schema.Type<
  typeof ProductAttributeValuejsonldsyliusadminproductcreate
>;
export type ProductAttributeValuejsonldsyliusadminproductcreateEncoded = Schema.Codec.Encoded<
  typeof ProductAttributeValuejsonldsyliusadminproductcreate
>;

/* ProductAttributeValuejsonldsyliusadminproductindex */

export const ProductAttributeValuejsonldsyliusadminproductindex = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    attribute: Schema.String.annotate({ writeOnly: true, format: 'iri-reference' }),
    localeCode: Schema.Union([Schema.String, Schema.Null]),
    value: Schema.Union([
      Schema.String,
      Schema.Boolean,
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Array(Schema.String),
      Schema.Null,
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAttributeValuejsonldsyliusadminproductindex' });
export type ProductAttributeValuejsonldsyliusadminproductindex = Schema.Schema.Type<
  typeof ProductAttributeValuejsonldsyliusadminproductindex
>;
export type ProductAttributeValuejsonldsyliusadminproductindexEncoded = Schema.Codec.Encoded<
  typeof ProductAttributeValuejsonldsyliusadminproductindex
>;

/* ProductImagejsonldsyliusadminproductshow */

export const ProductImagejsonldsyliusadminproductshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    cropX: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    cropY: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    cropWidth: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    cropHeight: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    type: Schema.Union([Schema.String, Schema.Null]),
    path: Schema.String,
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductImagejsonldsyliusadminproductshow' });
export type ProductImagejsonldsyliusadminproductshow = Schema.Schema.Type<
  typeof ProductImagejsonldsyliusadminproductshow
>;
export type ProductImagejsonldsyliusadminproductshowEncoded = Schema.Codec.Encoded<
  typeof ProductImagejsonldsyliusadminproductshow
>;

/* ProductAttributeValuejsonldsyliusadminproductshow */

export const ProductAttributeValuejsonldsyliusadminproductshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    attribute: Schema.String.annotate({ writeOnly: true, format: 'iri-reference' }),
    localeCode: Schema.Union([Schema.String, Schema.Null]),
    value: Schema.Union([
      Schema.String,
      Schema.Boolean,
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Array(Schema.String),
      Schema.Null,
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAttributeValuejsonldsyliusadminproductshow' });
export type ProductAttributeValuejsonldsyliusadminproductshow = Schema.Schema.Type<
  typeof ProductAttributeValuejsonldsyliusadminproductshow
>;
export type ProductAttributeValuejsonldsyliusadminproductshowEncoded = Schema.Codec.Encoded<
  typeof ProductAttributeValuejsonldsyliusadminproductshow
>;

/* ProductImagejsonldsyliusadminproductupdate */

export const ProductImagejsonldsyliusadminproductupdate = Schema.StructWithRest(
  Schema.Struct({
    cropX: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    cropY: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    cropWidth: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    cropHeight: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    type: Schema.Union([Schema.String, Schema.Null]),
    path: Schema.String,
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductImagejsonldsyliusadminproductupdate' });
export type ProductImagejsonldsyliusadminproductupdate = Schema.Schema.Type<
  typeof ProductImagejsonldsyliusadminproductupdate
>;
export type ProductImagejsonldsyliusadminproductupdateEncoded = Schema.Codec.Encoded<
  typeof ProductImagejsonldsyliusadminproductupdate
>;

/* ProductAttributeValuejsonldsyliusadminproductupdate */

export const ProductAttributeValuejsonldsyliusadminproductupdate = Schema.StructWithRest(
  Schema.Struct({
    attribute: Schema.String.annotate({ writeOnly: true, format: 'iri-reference' }),
    localeCode: Schema.Union([Schema.String, Schema.Null]),
    value: Schema.Union([
      Schema.String,
      Schema.Boolean,
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Array(Schema.String),
      Schema.Null,
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAttributeValuejsonldsyliusadminproductupdate' });
export type ProductAttributeValuejsonldsyliusadminproductupdate = Schema.Schema.Type<
  typeof ProductAttributeValuejsonldsyliusadminproductupdate
>;
export type ProductAttributeValuejsonldsyliusadminproductupdateEncoded = Schema.Codec.Encoded<
  typeof ProductAttributeValuejsonldsyliusadminproductupdate
>;

/* Productjsonldsyliusadminproductimageshow */

export const Productjsonldsyliusadminproductimageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Productjsonldsyliusadminproductimageshow' });
export type Productjsonldsyliusadminproductimageshow = Schema.Schema.Type<
  typeof Productjsonldsyliusadminproductimageshow
>;
export type ProductjsonldsyliusadminproductimageshowEncoded = Schema.Codec.Encoded<
  typeof Productjsonldsyliusadminproductimageshow
>;

/* ProductImagejsonldsyliusshopproductindex */

export const ProductImagejsonldsyliusshopproductindex = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    type: Schema.Union([Schema.String, Schema.Null]),
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductImagejsonldsyliusshopproductindex' });
export type ProductImagejsonldsyliusshopproductindex = Schema.Schema.Type<
  typeof ProductImagejsonldsyliusshopproductindex
>;
export type ProductImagejsonldsyliusshopproductindexEncoded = Schema.Codec.Encoded<
  typeof ProductImagejsonldsyliusshopproductindex
>;

/* ProductImagejsonldsyliusshopproductindexbase */

export const ProductImagejsonldsyliusshopproductindexbase = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    type: Schema.Union([Schema.String, Schema.Null]),
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductImagejsonldsyliusshopproductindexbase' });
export type ProductImagejsonldsyliusshopproductindexbase = Schema.Schema.Type<
  typeof ProductImagejsonldsyliusshopproductindexbase
>;
export type ProductImagejsonldsyliusshopproductindexbaseEncoded = Schema.Codec.Encoded<
  typeof ProductImagejsonldsyliusshopproductindexbase
>;

/* ProductVideojsonldsyliusshopproductshow */

export const ProductVideojsonldsyliusshopproductshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    type: Schema.Literal('youtube').annotate({ default: 'youtube' }),
    path: Schema.String.annotate({ default: '' }),
    position: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductVideojsonldsyliusshopproductshow' });
export type ProductVideojsonldsyliusshopproductshow = Schema.Schema.Type<
  typeof ProductVideojsonldsyliusshopproductshow
>;
export type ProductVideojsonldsyliusshopproductshowEncoded = Schema.Codec.Encoded<
  typeof ProductVideojsonldsyliusshopproductshow
>;

/* ProductVideojsonldsyliusshopproductshowsyliusshopproductshowdetail */

export const ProductVideojsonldsyliusshopproductshowsyliusshopproductshowdetail =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      type: Schema.Literal('youtube').annotate({ default: 'youtube' }),
      path: Schema.String.annotate({ default: '' }),
      position: Schema.Number.annotate({ default: 0 }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({ identifier: 'ProductVideojsonldsyliusshopproductshowsyliusshopproductshowdetail' });
export type ProductVideojsonldsyliusshopproductshowsyliusshopproductshowdetail = Schema.Schema.Type<
  typeof ProductVideojsonldsyliusshopproductshowsyliusshopproductshowdetail
>;
export type ProductVideojsonldsyliusshopproductshowsyliusshopproductshowdetailEncoded =
  Schema.Codec.Encoded<typeof ProductVideojsonldsyliusshopproductshowsyliusshopproductshowdetail>;

/* Taxonjsonldsyliusshopproductshowsyliusshopproductshowdetail */

export const Taxonjsonldsyliusshopproductshowsyliusshopproductshowdetail = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String,
    name: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonjsonldsyliusshopproductshowsyliusshopproductshowdetail' });
export type Taxonjsonldsyliusshopproductshowsyliusshopproductshowdetail = Schema.Schema.Type<
  typeof Taxonjsonldsyliusshopproductshowsyliusshopproductshowdetail
>;
export type TaxonjsonldsyliusshopproductshowsyliusshopproductshowdetailEncoded =
  Schema.Codec.Encoded<typeof Taxonjsonldsyliusshopproductshowsyliusshopproductshowdetail>;

/* ProductImagejsonldsyliusshopproductshowsyliusshopproductshowdetail */

export const ProductImagejsonldsyliusshopproductshowsyliusshopproductshowdetail =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      type: Schema.Union([Schema.String, Schema.Null]),
      pathAbstract: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({ identifier: 'ProductImagejsonldsyliusshopproductshowsyliusshopproductshowdetail' });
export type ProductImagejsonldsyliusshopproductshowsyliusshopproductshowdetail = Schema.Schema.Type<
  typeof ProductImagejsonldsyliusshopproductshowsyliusshopproductshowdetail
>;
export type ProductImagejsonldsyliusshopproductshowsyliusshopproductshowdetailEncoded =
  Schema.Codec.Encoded<typeof ProductImagejsonldsyliusshopproductshowsyliusshopproductshowdetail>;

/* ProductAttributeValuejsonldsyliusshopproductshowsyliusshopproductshowdetail */

export const ProductAttributeValuejsonldsyliusshopproductshowsyliusshopproductshowdetail =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      id: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      attributeGroupId: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true, format: 'uuid' })
      ),
      unit: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
      position: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({ readOnly: true })
      ),
      value: Schema.Union([
        Schema.String,
        Schema.Boolean,
        Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
        Schema.Array(Schema.String),
        Schema.Null,
      ]),
      name: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier: 'ProductAttributeValuejsonldsyliusshopproductshowsyliusshopproductshowdetail',
  });
export type ProductAttributeValuejsonldsyliusshopproductshowsyliusshopproductshowdetail =
  Schema.Schema.Type<
    typeof ProductAttributeValuejsonldsyliusshopproductshowsyliusshopproductshowdetail
  >;
export type ProductAttributeValuejsonldsyliusshopproductshowsyliusshopproductshowdetailEncoded =
  Schema.Codec.Encoded<
    typeof ProductAttributeValuejsonldsyliusshopproductshowsyliusshopproductshowdetail
  >;

/* ProductDocumentjsonldsyliusshopproductshowsyliusshopproductshowdetail */

export const ProductDocumentjsonldsyliusshopproductshowsyliusshopproductshowdetail =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      id: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      name: Schema.Union([
        Schema.String.check(
          Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
        ),
        Schema.Null,
      ]),
      path: Schema.String,
      publicPath: Schema.Union([Schema.String, Schema.Null]),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier: 'ProductDocumentjsonldsyliusshopproductshowsyliusshopproductshowdetail',
  });
export type ProductDocumentjsonldsyliusshopproductshowsyliusshopproductshowdetail =
  Schema.Schema.Type<typeof ProductDocumentjsonldsyliusshopproductshowsyliusshopproductshowdetail>;
export type ProductDocumentjsonldsyliusshopproductshowsyliusshopproductshowdetailEncoded =
  Schema.Codec.Encoded<
    typeof ProductDocumentjsonldsyliusshopproductshowsyliusshopproductshowdetail
  >;

/* Taxonjsonldsyliusshoptaxonindexshort */

export const Taxonjsonldsyliusshoptaxonindexshort = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    nameInTaxonList: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonjsonldsyliusshoptaxonindexshort' });
export type Taxonjsonldsyliusshoptaxonindexshort = Schema.Schema.Type<
  typeof Taxonjsonldsyliusshoptaxonindexshort
>;
export type TaxonjsonldsyliusshoptaxonindexshortEncoded = Schema.Codec.Encoded<
  typeof Taxonjsonldsyliusshoptaxonindexshort
>;

/* ProductVideomultipart */

export const ProductVideomultipart = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.String.annotate({ format: 'uuid' }),
    product: Schema.String.annotate({ format: 'iri-reference' }),
    type: Schema.Literal('youtube').annotate({ default: 'youtube' }),
    path: Schema.String.annotate({ default: '' }),
    position: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductVideomultipart' });
export type ProductVideomultipart = Schema.Schema.Type<typeof ProductVideomultipart>;
export type ProductVideomultipartEncoded = Schema.Codec.Encoded<typeof ProductVideomultipart>;

/* ProductAssociationsyliusadminproductassociationcreate */

export const ProductAssociationsyliusadminproductassociationcreate = Schema.StructWithRest(
  Schema.Struct({
    type: Schema.String.annotate({ format: 'iri-reference' }),
    owner: Schema.String.annotate({ format: 'iri-reference' }),
    associatedProducts: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAssociationsyliusadminproductassociationcreate' });
export type ProductAssociationsyliusadminproductassociationcreate = Schema.Schema.Type<
  typeof ProductAssociationsyliusadminproductassociationcreate
>;
export type ProductAssociationsyliusadminproductassociationcreateEncoded = Schema.Codec.Encoded<
  typeof ProductAssociationsyliusadminproductassociationcreate
>;

/* ProductAssociationsyliusadminproductassociationindex */

export const ProductAssociationsyliusadminproductassociationindex = Schema.StructWithRest(
  Schema.Struct({
    type: Schema.String.annotate({ format: 'iri-reference' }),
    owner: Schema.String.annotate({ format: 'iri-reference' }),
    associatedProducts: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAssociationsyliusadminproductassociationindex' });
export type ProductAssociationsyliusadminproductassociationindex = Schema.Schema.Type<
  typeof ProductAssociationsyliusadminproductassociationindex
>;
export type ProductAssociationsyliusadminproductassociationindexEncoded = Schema.Codec.Encoded<
  typeof ProductAssociationsyliusadminproductassociationindex
>;

/* ProductAssociationsyliusadminproductassociationshow */

export const ProductAssociationsyliusadminproductassociationshow = Schema.StructWithRest(
  Schema.Struct({
    type: Schema.String.annotate({ format: 'iri-reference' }),
    owner: Schema.String.annotate({ format: 'iri-reference' }),
    associatedProducts: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAssociationsyliusadminproductassociationshow' });
export type ProductAssociationsyliusadminproductassociationshow = Schema.Schema.Type<
  typeof ProductAssociationsyliusadminproductassociationshow
>;
export type ProductAssociationsyliusadminproductassociationshowEncoded = Schema.Codec.Encoded<
  typeof ProductAssociationsyliusadminproductassociationshow
>;

/* ProductAssociationsyliusadminproductassociationupdate */

export const ProductAssociationsyliusadminproductassociationupdate = Schema.StructWithRest(
  Schema.Struct({
    associatedProducts: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAssociationsyliusadminproductassociationupdate' });
export type ProductAssociationsyliusadminproductassociationupdate = Schema.Schema.Type<
  typeof ProductAssociationsyliusadminproductassociationupdate
>;
export type ProductAssociationsyliusadminproductassociationupdateEncoded = Schema.Codec.Encoded<
  typeof ProductAssociationsyliusadminproductassociationupdate
>;

/* ProductAssociationsyliusshopproductassociationshow */

export const ProductAssociationsyliusshopproductassociationshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.String.annotate({ format: 'iri-reference' }),
    associatedProducts: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAssociationsyliusshopproductassociationshow' });
export type ProductAssociationsyliusshopproductassociationshow = Schema.Schema.Type<
  typeof ProductAssociationsyliusshopproductassociationshow
>;
export type ProductAssociationsyliusshopproductassociationshowEncoded = Schema.Codec.Encoded<
  typeof ProductAssociationsyliusshopproductassociationshow
>;

/* ProductAssociationjsonldsyliusadminproductassociationcreate */

export const ProductAssociationjsonldsyliusadminproductassociationcreate = Schema.StructWithRest(
  Schema.Struct({
    type: Schema.String.annotate({ format: 'iri-reference' }),
    owner: Schema.String.annotate({ format: 'iri-reference' }),
    associatedProducts: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAssociationjsonldsyliusadminproductassociationcreate' });
export type ProductAssociationjsonldsyliusadminproductassociationcreate = Schema.Schema.Type<
  typeof ProductAssociationjsonldsyliusadminproductassociationcreate
>;
export type ProductAssociationjsonldsyliusadminproductassociationcreateEncoded =
  Schema.Codec.Encoded<typeof ProductAssociationjsonldsyliusadminproductassociationcreate>;

/* ProductAssociationjsonldsyliusadminproductassociationindex */

export const ProductAssociationjsonldsyliusadminproductassociationindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    type: Schema.String.annotate({ format: 'iri-reference' }),
    owner: Schema.String.annotate({ format: 'iri-reference' }),
    associatedProducts: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAssociationjsonldsyliusadminproductassociationindex' });
export type ProductAssociationjsonldsyliusadminproductassociationindex = Schema.Schema.Type<
  typeof ProductAssociationjsonldsyliusadminproductassociationindex
>;
export type ProductAssociationjsonldsyliusadminproductassociationindexEncoded =
  Schema.Codec.Encoded<typeof ProductAssociationjsonldsyliusadminproductassociationindex>;

/* ProductAssociationjsonldsyliusadminproductassociationshow */

export const ProductAssociationjsonldsyliusadminproductassociationshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    type: Schema.String.annotate({ format: 'iri-reference' }),
    owner: Schema.String.annotate({ format: 'iri-reference' }),
    associatedProducts: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAssociationjsonldsyliusadminproductassociationshow' });
export type ProductAssociationjsonldsyliusadminproductassociationshow = Schema.Schema.Type<
  typeof ProductAssociationjsonldsyliusadminproductassociationshow
>;
export type ProductAssociationjsonldsyliusadminproductassociationshowEncoded = Schema.Codec.Encoded<
  typeof ProductAssociationjsonldsyliusadminproductassociationshow
>;

/* ProductAssociationjsonldsyliusadminproductassociationupdate */

export const ProductAssociationjsonldsyliusadminproductassociationupdate = Schema.StructWithRest(
  Schema.Struct({
    associatedProducts: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAssociationjsonldsyliusadminproductassociationupdate' });
export type ProductAssociationjsonldsyliusadminproductassociationupdate = Schema.Schema.Type<
  typeof ProductAssociationjsonldsyliusadminproductassociationupdate
>;
export type ProductAssociationjsonldsyliusadminproductassociationupdateEncoded =
  Schema.Codec.Encoded<typeof ProductAssociationjsonldsyliusadminproductassociationupdate>;

/* ProductAssociationjsonldsyliusshopproductassociationshow */

export const ProductAssociationjsonldsyliusshopproductassociationshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.String.annotate({ format: 'iri-reference' }),
    associatedProducts: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAssociationjsonldsyliusshopproductassociationshow' });
export type ProductAssociationjsonldsyliusshopproductassociationshow = Schema.Schema.Type<
  typeof ProductAssociationjsonldsyliusshopproductassociationshow
>;
export type ProductAssociationjsonldsyliusshopproductassociationshowEncoded = Schema.Codec.Encoded<
  typeof ProductAssociationjsonldsyliusshopproductassociationshow
>;

/* ProductAssociationTypesyliusadminproductassociationtypecreate */

export const ProductAssociationTypesyliusadminproductassociationtypecreate = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    )
      .check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' }))
      .check(
        Schema.isPattern(new RegExp('^([\\w-]*)$')).annotate({
          expected: 'a string matching the RegExp ^([\\w-]*)$',
        })
      ),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAssociationTypesyliusadminproductassociationtypecreate' });
export type ProductAssociationTypesyliusadminproductassociationtypecreate = Schema.Schema.Type<
  typeof ProductAssociationTypesyliusadminproductassociationtypecreate
>;
export type ProductAssociationTypesyliusadminproductassociationtypecreateEncoded =
  Schema.Codec.Encoded<typeof ProductAssociationTypesyliusadminproductassociationtypecreate>;

/* ProductAssociationTypesyliusadminproductassociationtypeupdate */

export const ProductAssociationTypesyliusadminproductassociationtypeupdate = Schema.StructWithRest(
  Schema.Struct({
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAssociationTypesyliusadminproductassociationtypeupdate' });
export type ProductAssociationTypesyliusadminproductassociationtypeupdate = Schema.Schema.Type<
  typeof ProductAssociationTypesyliusadminproductassociationtypeupdate
>;
export type ProductAssociationTypesyliusadminproductassociationtypeupdateEncoded =
  Schema.Codec.Encoded<typeof ProductAssociationTypesyliusadminproductassociationtypeupdate>;

/* ProductAssociationTypesyliusshopproductassociationtypeindex */

export const ProductAssociationTypesyliusshopproductassociationtypeindex = Schema.StructWithRest(
  Schema.Struct({ code: Schema.String, name: Schema.Union([Schema.String, Schema.Null]) }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAssociationTypesyliusshopproductassociationtypeindex' });
export type ProductAssociationTypesyliusshopproductassociationtypeindex = Schema.Schema.Type<
  typeof ProductAssociationTypesyliusshopproductassociationtypeindex
>;
export type ProductAssociationTypesyliusshopproductassociationtypeindexEncoded =
  Schema.Codec.Encoded<typeof ProductAssociationTypesyliusshopproductassociationtypeindex>;

/* ProductAssociationTypesyliusshopproductassociationtypeshow */

export const ProductAssociationTypesyliusshopproductassociationtypeshow = Schema.StructWithRest(
  Schema.Struct({ code: Schema.String, name: Schema.Union([Schema.String, Schema.Null]) }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAssociationTypesyliusshopproductassociationtypeshow' });
export type ProductAssociationTypesyliusshopproductassociationtypeshow = Schema.Schema.Type<
  typeof ProductAssociationTypesyliusshopproductassociationtypeshow
>;
export type ProductAssociationTypesyliusshopproductassociationtypeshowEncoded =
  Schema.Codec.Encoded<typeof ProductAssociationTypesyliusshopproductassociationtypeshow>;

/* ProductAssociationTypejsonldsyliusadminproductassociationtypecreate */

export const ProductAssociationTypejsonldsyliusadminproductassociationtypecreate =
  Schema.StructWithRest(
    Schema.Struct({
      code: Schema.String.check(
        Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
      )
        .check(
          Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
        )
        .check(
          Schema.isPattern(new RegExp('^([\\w-]*)$')).annotate({
            expected: 'a string matching the RegExp ^([\\w-]*)$',
          })
        ),
      translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({ identifier: 'ProductAssociationTypejsonldsyliusadminproductassociationtypecreate' });
export type ProductAssociationTypejsonldsyliusadminproductassociationtypecreate =
  Schema.Schema.Type<typeof ProductAssociationTypejsonldsyliusadminproductassociationtypecreate>;
export type ProductAssociationTypejsonldsyliusadminproductassociationtypecreateEncoded =
  Schema.Codec.Encoded<typeof ProductAssociationTypejsonldsyliusadminproductassociationtypecreate>;

/* ProductAssociationTypejsonldsyliusadminproductassociationtypeupdate */

export const ProductAssociationTypejsonldsyliusadminproductassociationtypeupdate =
  Schema.StructWithRest(
    Schema.Struct({
      translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({ identifier: 'ProductAssociationTypejsonldsyliusadminproductassociationtypeupdate' });
export type ProductAssociationTypejsonldsyliusadminproductassociationtypeupdate =
  Schema.Schema.Type<typeof ProductAssociationTypejsonldsyliusadminproductassociationtypeupdate>;
export type ProductAssociationTypejsonldsyliusadminproductassociationtypeupdateEncoded =
  Schema.Codec.Encoded<typeof ProductAssociationTypejsonldsyliusadminproductassociationtypeupdate>;

/* ProductAssociationTypejsonldsyliusshopproductassociationtypeindex */

export const ProductAssociationTypejsonldsyliusshopproductassociationtypeindex =
  Schema.StructWithRest(
    Schema.Struct({
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      code: Schema.String,
      name: Schema.Union([Schema.String, Schema.Null]),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({ identifier: 'ProductAssociationTypejsonldsyliusshopproductassociationtypeindex' });
export type ProductAssociationTypejsonldsyliusshopproductassociationtypeindex = Schema.Schema.Type<
  typeof ProductAssociationTypejsonldsyliusshopproductassociationtypeindex
>;
export type ProductAssociationTypejsonldsyliusshopproductassociationtypeindexEncoded =
  Schema.Codec.Encoded<typeof ProductAssociationTypejsonldsyliusshopproductassociationtypeindex>;

/* ProductAssociationTypejsonldsyliusshopproductassociationtypeshow */

export const ProductAssociationTypejsonldsyliusshopproductassociationtypeshow =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      code: Schema.String,
      name: Schema.Union([Schema.String, Schema.Null]),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({ identifier: 'ProductAssociationTypejsonldsyliusshopproductassociationtypeshow' });
export type ProductAssociationTypejsonldsyliusshopproductassociationtypeshow = Schema.Schema.Type<
  typeof ProductAssociationTypejsonldsyliusshopproductassociationtypeshow
>;
export type ProductAssociationTypejsonldsyliusshopproductassociationtypeshowEncoded =
  Schema.Codec.Encoded<typeof ProductAssociationTypejsonldsyliusshopproductassociationtypeshow>;

/* ProductAttributeproductAttributeread */

export const ProductAttributeproductAttributeread = Schema.StructWithRest(
  Schema.Struct({
    group: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'iri-reference' }),
    unit: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'Unit of the attribute values (e.g. "mm", "g"), shown next to the value',
    }),
    filterState: Schema.Literals(['open', 'close']).annotate({
      description: 'Whether the filter is rendered expanded or collapsed by default',
    }),
    numberOfShow: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({
      description: 'How many filter values are shown before the "show more" expander; null = all',
    }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    type: Schema.String.annotate({ default: 'text' }),
    storageType: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    name: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAttributeproductAttributeread' });
export type ProductAttributeproductAttributeread = Schema.Schema.Type<
  typeof ProductAttributeproductAttributeread
>;
export type ProductAttributeproductAttributereadEncoded = Schema.Codec.Encoded<
  typeof ProductAttributeproductAttributeread
>;

/* ProductAttributesyliusadminproductattributecreate */

export const ProductAttributesyliusadminproductattributecreate = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.check(
      Schema.isMinLength(1).annotate({ expected: 'a value with a length of at least 1' })
    )
      .check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' }))
      .check(
        Schema.isPattern(new RegExp('^([\\w-]*)$')).annotate({
          expected: 'a string matching the RegExp ^([\\w-]*)$',
        })
      ),
    type: Schema.Literals([
      'text',
      'textarea',
      'checkbox',
      'integer',
      'float',
      'percent',
      'datetime',
      'date',
      'select',
    ]),
    configuration: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    translatable: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAttributesyliusadminproductattributecreate' });
export type ProductAttributesyliusadminproductattributecreate = Schema.Schema.Type<
  typeof ProductAttributesyliusadminproductattributecreate
>;
export type ProductAttributesyliusadminproductattributecreateEncoded = Schema.Codec.Encoded<
  typeof ProductAttributesyliusadminproductattributecreate
>;

/* ProductAttributesyliusadminproductattributeindex */

export const ProductAttributesyliusadminproductattributeindex = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String,
    type: Schema.Literals([
      'text',
      'textarea',
      'checkbox',
      'integer',
      'float',
      'percent',
      'datetime',
      'date',
      'select',
    ]),
    configuration: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    storageType: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    translatable: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAttributesyliusadminproductattributeindex' });
export type ProductAttributesyliusadminproductattributeindex = Schema.Schema.Type<
  typeof ProductAttributesyliusadminproductattributeindex
>;
export type ProductAttributesyliusadminproductattributeindexEncoded = Schema.Codec.Encoded<
  typeof ProductAttributesyliusadminproductattributeindex
>;

/* ProductAttributesyliusadminproductattributeshow */

export const ProductAttributesyliusadminproductattributeshow = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String,
    type: Schema.Literals([
      'text',
      'textarea',
      'checkbox',
      'integer',
      'float',
      'percent',
      'datetime',
      'date',
      'select',
    ]),
    configuration: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    storageType: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    translatable: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAttributesyliusadminproductattributeshow' });
export type ProductAttributesyliusadminproductattributeshow = Schema.Schema.Type<
  typeof ProductAttributesyliusadminproductattributeshow
>;
export type ProductAttributesyliusadminproductattributeshowEncoded = Schema.Codec.Encoded<
  typeof ProductAttributesyliusadminproductattributeshow
>;

/* ProductAttributesyliusadminproductattributeupdate */

export const ProductAttributesyliusadminproductattributeupdate = Schema.StructWithRest(
  Schema.Struct({
    configuration: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    translatable: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
    type: Schema.optionalKey(
      Schema.Literals([
        'text',
        'textarea',
        'checkbox',
        'integer',
        'float',
        'percent',
        'datetime',
        'date',
        'select',
      ])
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAttributesyliusadminproductattributeupdate' });
export type ProductAttributesyliusadminproductattributeupdate = Schema.Schema.Type<
  typeof ProductAttributesyliusadminproductattributeupdate
>;
export type ProductAttributesyliusadminproductattributeupdateEncoded = Schema.Codec.Encoded<
  typeof ProductAttributesyliusadminproductattributeupdate
>;

/* ProductAttributesyliusshopproductattributeshow */

export const ProductAttributesyliusshopproductattributeshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    type: Schema.String.annotate({ default: 'text' }),
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    name: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAttributesyliusshopproductattributeshow' });
export type ProductAttributesyliusshopproductattributeshow = Schema.Schema.Type<
  typeof ProductAttributesyliusshopproductattributeshow
>;
export type ProductAttributesyliusshopproductattributeshowEncoded = Schema.Codec.Encoded<
  typeof ProductAttributesyliusshopproductattributeshow
>;

/* ProductAttributejsonldproductAttributeread */

export const ProductAttributejsonldproductAttributeread = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    group: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'iri-reference' }),
    unit: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'Unit of the attribute values (e.g. "mm", "g"), shown next to the value',
    }),
    filterState: Schema.Literals(['open', 'close']).annotate({
      description: 'Whether the filter is rendered expanded or collapsed by default',
    }),
    numberOfShow: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({
      description: 'How many filter values are shown before the "show more" expander; null = all',
    }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    type: Schema.String.annotate({ default: 'text' }),
    storageType: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    name: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAttributejsonldproductAttributeread' });
export type ProductAttributejsonldproductAttributeread = Schema.Schema.Type<
  typeof ProductAttributejsonldproductAttributeread
>;
export type ProductAttributejsonldproductAttributereadEncoded = Schema.Codec.Encoded<
  typeof ProductAttributejsonldproductAttributeread
>;

/* ProductAttributejsonldsyliusadminproductattributecreate */

export const ProductAttributejsonldsyliusadminproductattributecreate = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.check(
      Schema.isMinLength(1).annotate({ expected: 'a value with a length of at least 1' })
    )
      .check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' }))
      .check(
        Schema.isPattern(new RegExp('^([\\w-]*)$')).annotate({
          expected: 'a string matching the RegExp ^([\\w-]*)$',
        })
      ),
    type: Schema.Literals([
      'text',
      'textarea',
      'checkbox',
      'integer',
      'float',
      'percent',
      'datetime',
      'date',
      'select',
    ]),
    configuration: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    translatable: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAttributejsonldsyliusadminproductattributecreate' });
export type ProductAttributejsonldsyliusadminproductattributecreate = Schema.Schema.Type<
  typeof ProductAttributejsonldsyliusadminproductattributecreate
>;
export type ProductAttributejsonldsyliusadminproductattributecreateEncoded = Schema.Codec.Encoded<
  typeof ProductAttributejsonldsyliusadminproductattributecreate
>;

/* ProductAttributejsonldsyliusadminproductattributeindex */

export const ProductAttributejsonldsyliusadminproductattributeindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String,
    type: Schema.Literals([
      'text',
      'textarea',
      'checkbox',
      'integer',
      'float',
      'percent',
      'datetime',
      'date',
      'select',
    ]),
    configuration: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    storageType: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    translatable: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAttributejsonldsyliusadminproductattributeindex' });
export type ProductAttributejsonldsyliusadminproductattributeindex = Schema.Schema.Type<
  typeof ProductAttributejsonldsyliusadminproductattributeindex
>;
export type ProductAttributejsonldsyliusadminproductattributeindexEncoded = Schema.Codec.Encoded<
  typeof ProductAttributejsonldsyliusadminproductattributeindex
>;

/* ProductAttributejsonldsyliusadminproductattributeshow */

export const ProductAttributejsonldsyliusadminproductattributeshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String,
    type: Schema.Literals([
      'text',
      'textarea',
      'checkbox',
      'integer',
      'float',
      'percent',
      'datetime',
      'date',
      'select',
    ]),
    configuration: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    storageType: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    translatable: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAttributejsonldsyliusadminproductattributeshow' });
export type ProductAttributejsonldsyliusadminproductattributeshow = Schema.Schema.Type<
  typeof ProductAttributejsonldsyliusadminproductattributeshow
>;
export type ProductAttributejsonldsyliusadminproductattributeshowEncoded = Schema.Codec.Encoded<
  typeof ProductAttributejsonldsyliusadminproductattributeshow
>;

/* ProductAttributejsonldsyliusadminproductattributeupdate */

export const ProductAttributejsonldsyliusadminproductattributeupdate = Schema.StructWithRest(
  Schema.Struct({
    configuration: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    translatable: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
    type: Schema.optionalKey(
      Schema.Literals([
        'text',
        'textarea',
        'checkbox',
        'integer',
        'float',
        'percent',
        'datetime',
        'date',
        'select',
      ])
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAttributejsonldsyliusadminproductattributeupdate' });
export type ProductAttributejsonldsyliusadminproductattributeupdate = Schema.Schema.Type<
  typeof ProductAttributejsonldsyliusadminproductattributeupdate
>;
export type ProductAttributejsonldsyliusadminproductattributeupdateEncoded = Schema.Codec.Encoded<
  typeof ProductAttributejsonldsyliusadminproductattributeupdate
>;

/* ProductAttributejsonldsyliusshopproductattributeshow */

export const ProductAttributejsonldsyliusshopproductattributeshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    type: Schema.String.annotate({ default: 'text' }),
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    name: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAttributejsonldsyliusshopproductattributeshow' });
export type ProductAttributejsonldsyliusshopproductattributeshow = Schema.Schema.Type<
  typeof ProductAttributejsonldsyliusshopproductattributeshow
>;
export type ProductAttributejsonldsyliusshopproductattributeshowEncoded = Schema.Codec.Encoded<
  typeof ProductAttributejsonldsyliusshopproductattributeshow
>;

/* ProductAttributeGroupsyliusshopproductattributegroupindex */

export const ProductAttributeGroupsyliusshopproductattributegroupindex = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.String.annotate({ format: 'uuid' }),
    name: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAttributeGroupsyliusshopproductattributegroupindex' });
export type ProductAttributeGroupsyliusshopproductattributegroupindex = Schema.Schema.Type<
  typeof ProductAttributeGroupsyliusshopproductattributegroupindex
>;
export type ProductAttributeGroupsyliusshopproductattributegroupindexEncoded = Schema.Codec.Encoded<
  typeof ProductAttributeGroupsyliusshopproductattributegroupindex
>;

/* ProductAttributeGroupsyliusshopproductattributegroupshow */

export const ProductAttributeGroupsyliusshopproductattributegroupshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.String.annotate({ format: 'uuid' }),
    name: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAttributeGroupsyliusshopproductattributegroupshow' });
export type ProductAttributeGroupsyliusshopproductattributegroupshow = Schema.Schema.Type<
  typeof ProductAttributeGroupsyliusshopproductattributegroupshow
>;
export type ProductAttributeGroupsyliusshopproductattributegroupshowEncoded = Schema.Codec.Encoded<
  typeof ProductAttributeGroupsyliusshopproductattributegroupshow
>;

/* ProductAttributeGroupjsonldsyliusshopproductattributegroupindex */

export const ProductAttributeGroupjsonldsyliusshopproductattributegroupindex =
  Schema.StructWithRest(
    Schema.Struct({
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      id: Schema.String.annotate({ format: 'uuid' }),
      name: Schema.Union([Schema.String, Schema.Null]),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({ identifier: 'ProductAttributeGroupjsonldsyliusshopproductattributegroupindex' });
export type ProductAttributeGroupjsonldsyliusshopproductattributegroupindex = Schema.Schema.Type<
  typeof ProductAttributeGroupjsonldsyliusshopproductattributegroupindex
>;
export type ProductAttributeGroupjsonldsyliusshopproductattributegroupindexEncoded =
  Schema.Codec.Encoded<typeof ProductAttributeGroupjsonldsyliusshopproductattributegroupindex>;

/* ProductAttributeGroupjsonldsyliusshopproductattributegroupshow */

export const ProductAttributeGroupjsonldsyliusshopproductattributegroupshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.String.annotate({ format: 'uuid' }),
    name: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAttributeGroupjsonldsyliusshopproductattributegroupshow' });
export type ProductAttributeGroupjsonldsyliusshopproductattributegroupshow = Schema.Schema.Type<
  typeof ProductAttributeGroupjsonldsyliusshopproductattributegroupshow
>;
export type ProductAttributeGroupjsonldsyliusshopproductattributegroupshowEncoded =
  Schema.Codec.Encoded<typeof ProductAttributeGroupjsonldsyliusshopproductattributegroupshow>;

/* ProductAttributeValuesyliusadminproductattributevalueshow */

export const ProductAttributeValuesyliusadminproductattributevalueshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    attribute: Schema.String.annotate({ writeOnly: true, format: 'iri-reference' }),
    localeCode: Schema.Union([Schema.String, Schema.Null]),
    value: Schema.Union([
      Schema.String,
      Schema.Boolean,
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Array(Schema.String),
      Schema.Null,
    ]),
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    type: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    code: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAttributeValuesyliusadminproductattributevalueshow' });
export type ProductAttributeValuesyliusadminproductattributevalueshow = Schema.Schema.Type<
  typeof ProductAttributeValuesyliusadminproductattributevalueshow
>;
export type ProductAttributeValuesyliusadminproductattributevalueshowEncoded = Schema.Codec.Encoded<
  typeof ProductAttributeValuesyliusadminproductattributevalueshow
>;

/* ProductAttributeValuesyliusshopproductattributevalueshow */

export const ProductAttributeValuesyliusshopproductattributevalueshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    attribute: Schema.String.annotate({ writeOnly: true, format: 'iri-reference' }),
    localeCode: Schema.Union([Schema.String, Schema.Null]),
    value: Schema.Union([
      Schema.String,
      Schema.Boolean,
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Array(Schema.String),
      Schema.Null,
    ]),
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    type: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    code: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAttributeValuesyliusshopproductattributevalueshow' });
export type ProductAttributeValuesyliusshopproductattributevalueshow = Schema.Schema.Type<
  typeof ProductAttributeValuesyliusshopproductattributevalueshow
>;
export type ProductAttributeValuesyliusshopproductattributevalueshowEncoded = Schema.Codec.Encoded<
  typeof ProductAttributeValuesyliusshopproductattributevalueshow
>;

/* ProductAttributeValuejsonldsyliusadminproductattributevalueshow */

export const ProductAttributeValuejsonldsyliusadminproductattributevalueshow =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      id: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      attribute: Schema.String.annotate({ writeOnly: true, format: 'iri-reference' }),
      localeCode: Schema.Union([Schema.String, Schema.Null]),
      value: Schema.Union([
        Schema.String,
        Schema.Boolean,
        Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
        Schema.Array(Schema.String),
        Schema.Null,
      ]),
      name: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
      type: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
      code: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({ identifier: 'ProductAttributeValuejsonldsyliusadminproductattributevalueshow' });
export type ProductAttributeValuejsonldsyliusadminproductattributevalueshow = Schema.Schema.Type<
  typeof ProductAttributeValuejsonldsyliusadminproductattributevalueshow
>;
export type ProductAttributeValuejsonldsyliusadminproductattributevalueshowEncoded =
  Schema.Codec.Encoded<typeof ProductAttributeValuejsonldsyliusadminproductattributevalueshow>;

/* ProductAttributeValuejsonldsyliusshopproductattributevalueshow */

export const ProductAttributeValuejsonldsyliusshopproductattributevalueshow = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    attribute: Schema.String.annotate({ writeOnly: true, format: 'iri-reference' }),
    localeCode: Schema.Union([Schema.String, Schema.Null]),
    value: Schema.Union([
      Schema.String,
      Schema.Boolean,
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Array(Schema.String),
      Schema.Null,
    ]),
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    type: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    code: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAttributeValuejsonldsyliusshopproductattributevalueshow' });
export type ProductAttributeValuejsonldsyliusshopproductattributevalueshow = Schema.Schema.Type<
  typeof ProductAttributeValuejsonldsyliusshopproductattributevalueshow
>;
export type ProductAttributeValuejsonldsyliusshopproductattributevalueshowEncoded =
  Schema.Codec.Encoded<typeof ProductAttributeValuejsonldsyliusshopproductattributevalueshow>;

/* ProductAttributeValueItem */

export const ProductAttributeValueItem = Schema.StructWithRest(
  Schema.Struct({
    value: Schema.Union([Schema.String, Schema.Null]),
    count: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAttributeValueItem' });
export type ProductAttributeValueItem = Schema.Schema.Type<typeof ProductAttributeValueItem>;
export type ProductAttributeValueItemEncoded = Schema.Codec.Encoded<
  typeof ProductAttributeValueItem
>;

/* ProductAttributeValueItemjsonld */

export const ProductAttributeValueItemjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    value: Schema.Union([Schema.String, Schema.Null]),
    count: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAttributeValueItemjsonld' });
export type ProductAttributeValueItemjsonld = Schema.Schema.Type<
  typeof ProductAttributeValueItemjsonld
>;
export type ProductAttributeValueItemjsonldEncoded = Schema.Codec.Encoded<
  typeof ProductAttributeValueItemjsonld
>;

/* ProductFavouriteListfavouritelistread */

export const ProductFavouriteListfavouritelistread = Schema.StructWithRest(
  Schema.Struct({
    uuid: Schema.String,
    name: Schema.String,
    productVariantCodes: Schema.Array(Schema.String),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductFavouriteListfavouritelistread' });
export type ProductFavouriteListfavouritelistread = Schema.Schema.Type<
  typeof ProductFavouriteListfavouritelistread
>;
export type ProductFavouriteListfavouritelistreadEncoded = Schema.Codec.Encoded<
  typeof ProductFavouriteListfavouritelistread
>;

/* ProductFavouriteListCreateFavouriteListInput */

export const ProductFavouriteListCreateFavouriteListInput = Schema.StructWithRest(
  Schema.Struct({
    name: Schema.String.annotate({ default: '' }),
    productVariantCodes: Schema.Union([Schema.Array(Schema.String), Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductFavouriteListCreateFavouriteListInput' });
export type ProductFavouriteListCreateFavouriteListInput = Schema.Schema.Type<
  typeof ProductFavouriteListCreateFavouriteListInput
>;
export type ProductFavouriteListCreateFavouriteListInputEncoded = Schema.Codec.Encoded<
  typeof ProductFavouriteListCreateFavouriteListInput
>;

/* ProductFavouriteListCreateFavouriteListInputjsonld */

export const ProductFavouriteListCreateFavouriteListInputjsonld = Schema.StructWithRest(
  Schema.Struct({
    name: Schema.String.annotate({ default: '' }),
    productVariantCodes: Schema.Union([Schema.Array(Schema.String), Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductFavouriteListCreateFavouriteListInputjsonld' });
export type ProductFavouriteListCreateFavouriteListInputjsonld = Schema.Schema.Type<
  typeof ProductFavouriteListCreateFavouriteListInputjsonld
>;
export type ProductFavouriteListCreateFavouriteListInputjsonldEncoded = Schema.Codec.Encoded<
  typeof ProductFavouriteListCreateFavouriteListInputjsonld
>;

/* ProductFavouriteListModifyFavouriteListProductsInput */

export const ProductFavouriteListModifyFavouriteListProductsInput = Schema.StructWithRest(
  Schema.Struct({
    productVariantCodes: Schema.Array(Schema.String).check(
      Schema.isMinLength(1).annotate({ expected: 'a value with a length of at least 1' })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductFavouriteListModifyFavouriteListProductsInput' });
export type ProductFavouriteListModifyFavouriteListProductsInput = Schema.Schema.Type<
  typeof ProductFavouriteListModifyFavouriteListProductsInput
>;
export type ProductFavouriteListModifyFavouriteListProductsInputEncoded = Schema.Codec.Encoded<
  typeof ProductFavouriteListModifyFavouriteListProductsInput
>;

/* ProductFavouriteListModifyFavouriteListProductsInputjsonld */

export const ProductFavouriteListModifyFavouriteListProductsInputjsonld = Schema.StructWithRest(
  Schema.Struct({
    productVariantCodes: Schema.Array(Schema.String).check(
      Schema.isMinLength(1).annotate({ expected: 'a value with a length of at least 1' })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductFavouriteListModifyFavouriteListProductsInputjsonld' });
export type ProductFavouriteListModifyFavouriteListProductsInputjsonld = Schema.Schema.Type<
  typeof ProductFavouriteListModifyFavouriteListProductsInputjsonld
>;
export type ProductFavouriteListModifyFavouriteListProductsInputjsonldEncoded =
  Schema.Codec.Encoded<typeof ProductFavouriteListModifyFavouriteListProductsInputjsonld>;

/* ProductFavouriteListRenameFavouriteListInput */

export const ProductFavouriteListRenameFavouriteListInput = Schema.StructWithRest(
  Schema.Struct({ name: Schema.String.annotate({ default: '' }) }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductFavouriteListRenameFavouriteListInput' });
export type ProductFavouriteListRenameFavouriteListInput = Schema.Schema.Type<
  typeof ProductFavouriteListRenameFavouriteListInput
>;
export type ProductFavouriteListRenameFavouriteListInputEncoded = Schema.Codec.Encoded<
  typeof ProductFavouriteListRenameFavouriteListInput
>;

/* ProductFavouriteListRenameFavouriteListInputjsonld */

export const ProductFavouriteListRenameFavouriteListInputjsonld = Schema.StructWithRest(
  Schema.Struct({ name: Schema.String.annotate({ default: '' }) }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductFavouriteListRenameFavouriteListInputjsonld' });
export type ProductFavouriteListRenameFavouriteListInputjsonld = Schema.Schema.Type<
  typeof ProductFavouriteListRenameFavouriteListInputjsonld
>;
export type ProductFavouriteListRenameFavouriteListInputjsonldEncoded = Schema.Codec.Encoded<
  typeof ProductFavouriteListRenameFavouriteListInputjsonld
>;

/* ProductFavouriteListjsonldfavouritelistread */

export const ProductFavouriteListjsonldfavouritelistread = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    uuid: Schema.String,
    name: Schema.String,
    productVariantCodes: Schema.Array(Schema.String),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductFavouriteListjsonldfavouritelistread' });
export type ProductFavouriteListjsonldfavouritelistread = Schema.Schema.Type<
  typeof ProductFavouriteListjsonldfavouritelistread
>;
export type ProductFavouriteListjsonldfavouritelistreadEncoded = Schema.Codec.Encoded<
  typeof ProductFavouriteListjsonldfavouritelistread
>;

/* ProductImagesyliusadminproductimageindex */

export const ProductImagesyliusadminproductimageindex = Schema.Record(
  Schema.String,
  Schema.Json.annotate({ expected: 'JSON value' })
).annotate({ identifier: 'ProductImagesyliusadminproductimageindex' });
export type ProductImagesyliusadminproductimageindex = Schema.Schema.Type<
  typeof ProductImagesyliusadminproductimageindex
>;
export type ProductImagesyliusadminproductimageindexEncoded = Schema.Codec.Encoded<
  typeof ProductImagesyliusadminproductimageindex
>;

/* ProductImagesyliusadminproductimageupdate */

export const ProductImagesyliusadminproductimageupdate = Schema.Record(
  Schema.String,
  Schema.Json.annotate({ expected: 'JSON value' })
).annotate({ identifier: 'ProductImagesyliusadminproductimageupdate' });
export type ProductImagesyliusadminproductimageupdate = Schema.Schema.Type<
  typeof ProductImagesyliusadminproductimageupdate
>;
export type ProductImagesyliusadminproductimageupdateEncoded = Schema.Codec.Encoded<
  typeof ProductImagesyliusadminproductimageupdate
>;

/* ProductImagesyliusshopproductimageindex */

export const ProductImagesyliusshopproductimageindex = Schema.Record(
  Schema.String,
  Schema.Json.annotate({ expected: 'JSON value' })
).annotate({ identifier: 'ProductImagesyliusshopproductimageindex' });
export type ProductImagesyliusshopproductimageindex = Schema.Schema.Type<
  typeof ProductImagesyliusshopproductimageindex
>;
export type ProductImagesyliusshopproductimageindexEncoded = Schema.Codec.Encoded<
  typeof ProductImagesyliusshopproductimageindex
>;

/* ProductImagesyliusshopproductimageshow */

export const ProductImagesyliusshopproductimageshow = Schema.Record(
  Schema.String,
  Schema.Json.annotate({ expected: 'JSON value' })
).annotate({ identifier: 'ProductImagesyliusshopproductimageshow' });
export type ProductImagesyliusshopproductimageshow = Schema.Schema.Type<
  typeof ProductImagesyliusshopproductimageshow
>;
export type ProductImagesyliusshopproductimageshowEncoded = Schema.Codec.Encoded<
  typeof ProductImagesyliusshopproductimageshow
>;

/* ProductImagejsonldsyliusadminproductimageindex */

export const ProductImagejsonldsyliusadminproductimageindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductImagejsonldsyliusadminproductimageindex' });
export type ProductImagejsonldsyliusadminproductimageindex = Schema.Schema.Type<
  typeof ProductImagejsonldsyliusadminproductimageindex
>;
export type ProductImagejsonldsyliusadminproductimageindexEncoded = Schema.Codec.Encoded<
  typeof ProductImagejsonldsyliusadminproductimageindex
>;

/* ProductImagejsonldsyliusadminproductimageupdate */

export const ProductImagejsonldsyliusadminproductimageupdate = Schema.Record(
  Schema.String,
  Schema.Json.annotate({ expected: 'JSON value' })
).annotate({ identifier: 'ProductImagejsonldsyliusadminproductimageupdate' });
export type ProductImagejsonldsyliusadminproductimageupdate = Schema.Schema.Type<
  typeof ProductImagejsonldsyliusadminproductimageupdate
>;
export type ProductImagejsonldsyliusadminproductimageupdateEncoded = Schema.Codec.Encoded<
  typeof ProductImagejsonldsyliusadminproductimageupdate
>;

/* ProductImagejsonldsyliusshopproductimageindex */

export const ProductImagejsonldsyliusshopproductimageindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductImagejsonldsyliusshopproductimageindex' });
export type ProductImagejsonldsyliusshopproductimageindex = Schema.Schema.Type<
  typeof ProductImagejsonldsyliusshopproductimageindex
>;
export type ProductImagejsonldsyliusshopproductimageindexEncoded = Schema.Codec.Encoded<
  typeof ProductImagejsonldsyliusshopproductimageindex
>;

/* ProductImagejsonldsyliusshopproductimageshow */

export const ProductImagejsonldsyliusshopproductimageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductImagejsonldsyliusshopproductimageshow' });
export type ProductImagejsonldsyliusshopproductimageshow = Schema.Schema.Type<
  typeof ProductImagejsonldsyliusshopproductimageshow
>;
export type ProductImagejsonldsyliusshopproductimageshowEncoded = Schema.Codec.Encoded<
  typeof ProductImagejsonldsyliusshopproductimageshow
>;

/* ProductOptionValuesyliusadminproductoptioncreate */

export const ProductOptionValuesyliusadminproductoptioncreate = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String,
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductOptionValuesyliusadminproductoptioncreate' });
export type ProductOptionValuesyliusadminproductoptioncreate = Schema.Schema.Type<
  typeof ProductOptionValuesyliusadminproductoptioncreate
>;
export type ProductOptionValuesyliusadminproductoptioncreateEncoded = Schema.Codec.Encoded<
  typeof ProductOptionValuesyliusadminproductoptioncreate
>;

/* ProductOptionValuesyliusadminproductoptionupdate */

export const ProductOptionValuesyliusadminproductoptionupdate = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String,
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductOptionValuesyliusadminproductoptionupdate' });
export type ProductOptionValuesyliusadminproductoptionupdate = Schema.Schema.Type<
  typeof ProductOptionValuesyliusadminproductoptionupdate
>;
export type ProductOptionValuesyliusadminproductoptionupdateEncoded = Schema.Codec.Encoded<
  typeof ProductOptionValuesyliusadminproductoptionupdate
>;

/* ProductOptionsyliusshopproductoptionindex */

export const ProductOptionsyliusshopproductoptionindex = Schema.StructWithRest(
  Schema.Struct({ code: Schema.String, name: Schema.Union([Schema.String, Schema.Null]) }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductOptionsyliusshopproductoptionindex' });
export type ProductOptionsyliusshopproductoptionindex = Schema.Schema.Type<
  typeof ProductOptionsyliusshopproductoptionindex
>;
export type ProductOptionsyliusshopproductoptionindexEncoded = Schema.Codec.Encoded<
  typeof ProductOptionsyliusshopproductoptionindex
>;

/* ProductOptionsyliusshopproductoptionshow */

export const ProductOptionsyliusshopproductoptionshow = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String,
    values: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    name: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductOptionsyliusshopproductoptionshow' });
export type ProductOptionsyliusshopproductoptionshow = Schema.Schema.Type<
  typeof ProductOptionsyliusshopproductoptionshow
>;
export type ProductOptionsyliusshopproductoptionshowEncoded = Schema.Codec.Encoded<
  typeof ProductOptionsyliusshopproductoptionshow
>;

/* ProductOptionValuejsonldsyliusadminproductoptioncreate */

export const ProductOptionValuejsonldsyliusadminproductoptioncreate = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String,
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductOptionValuejsonldsyliusadminproductoptioncreate' });
export type ProductOptionValuejsonldsyliusadminproductoptioncreate = Schema.Schema.Type<
  typeof ProductOptionValuejsonldsyliusadminproductoptioncreate
>;
export type ProductOptionValuejsonldsyliusadminproductoptioncreateEncoded = Schema.Codec.Encoded<
  typeof ProductOptionValuejsonldsyliusadminproductoptioncreate
>;

/* ProductOptionValuejsonldsyliusadminproductoptionupdate */

export const ProductOptionValuejsonldsyliusadminproductoptionupdate = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String,
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductOptionValuejsonldsyliusadminproductoptionupdate' });
export type ProductOptionValuejsonldsyliusadminproductoptionupdate = Schema.Schema.Type<
  typeof ProductOptionValuejsonldsyliusadminproductoptionupdate
>;
export type ProductOptionValuejsonldsyliusadminproductoptionupdateEncoded = Schema.Codec.Encoded<
  typeof ProductOptionValuejsonldsyliusadminproductoptionupdate
>;

/* ProductOptionjsonldsyliusshopproductoptionindex */

export const ProductOptionjsonldsyliusshopproductoptionindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String,
    name: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductOptionjsonldsyliusshopproductoptionindex' });
export type ProductOptionjsonldsyliusshopproductoptionindex = Schema.Schema.Type<
  typeof ProductOptionjsonldsyliusshopproductoptionindex
>;
export type ProductOptionjsonldsyliusshopproductoptionindexEncoded = Schema.Codec.Encoded<
  typeof ProductOptionjsonldsyliusshopproductoptionindex
>;

/* ProductOptionjsonldsyliusshopproductoptionshow */

export const ProductOptionjsonldsyliusshopproductoptionshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String,
    values: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    name: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductOptionjsonldsyliusshopproductoptionshow' });
export type ProductOptionjsonldsyliusshopproductoptionshow = Schema.Schema.Type<
  typeof ProductOptionjsonldsyliusshopproductoptionshow
>;
export type ProductOptionjsonldsyliusshopproductoptionshowEncoded = Schema.Codec.Encoded<
  typeof ProductOptionjsonldsyliusshopproductoptionshow
>;

/* ProductOptionValuesyliusadminproductoptionvalueshow */

export const ProductOptionValuesyliusadminproductoptionvalueshow = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String,
    option: Schema.String.annotate({ format: 'iri-reference' }),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
    value: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductOptionValuesyliusadminproductoptionvalueshow' });
export type ProductOptionValuesyliusadminproductoptionvalueshow = Schema.Schema.Type<
  typeof ProductOptionValuesyliusadminproductoptionvalueshow
>;
export type ProductOptionValuesyliusadminproductoptionvalueshowEncoded = Schema.Codec.Encoded<
  typeof ProductOptionValuesyliusadminproductoptionvalueshow
>;

/* ProductOptionValuesyliusshopproductoptionvalueindex */

export const ProductOptionValuesyliusshopproductoptionvalueindex = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String,
    option: Schema.String.annotate({ format: 'iri-reference' }),
    value: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductOptionValuesyliusshopproductoptionvalueindex' });
export type ProductOptionValuesyliusshopproductoptionvalueindex = Schema.Schema.Type<
  typeof ProductOptionValuesyliusshopproductoptionvalueindex
>;
export type ProductOptionValuesyliusshopproductoptionvalueindexEncoded = Schema.Codec.Encoded<
  typeof ProductOptionValuesyliusshopproductoptionvalueindex
>;

/* ProductOptionValuesyliusshopproductoptionvalueshow */

export const ProductOptionValuesyliusshopproductoptionvalueshow = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String,
    option: Schema.String.annotate({ format: 'iri-reference' }),
    value: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductOptionValuesyliusshopproductoptionvalueshow' });
export type ProductOptionValuesyliusshopproductoptionvalueshow = Schema.Schema.Type<
  typeof ProductOptionValuesyliusshopproductoptionvalueshow
>;
export type ProductOptionValuesyliusshopproductoptionvalueshowEncoded = Schema.Codec.Encoded<
  typeof ProductOptionValuesyliusshopproductoptionvalueshow
>;

/* ProductOptionValuejsonldsyliusadminproductoptionvalueshow */

export const ProductOptionValuejsonldsyliusadminproductoptionvalueshow = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    code: Schema.String,
    option: Schema.String.annotate({ format: 'iri-reference' }),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
    value: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductOptionValuejsonldsyliusadminproductoptionvalueshow' });
export type ProductOptionValuejsonldsyliusadminproductoptionvalueshow = Schema.Schema.Type<
  typeof ProductOptionValuejsonldsyliusadminproductoptionvalueshow
>;
export type ProductOptionValuejsonldsyliusadminproductoptionvalueshowEncoded = Schema.Codec.Encoded<
  typeof ProductOptionValuejsonldsyliusadminproductoptionvalueshow
>;

/* ProductOptionValuejsonldsyliusshopproductoptionvalueindex */

export const ProductOptionValuejsonldsyliusshopproductoptionvalueindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String,
    option: Schema.String.annotate({ format: 'iri-reference' }),
    value: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductOptionValuejsonldsyliusshopproductoptionvalueindex' });
export type ProductOptionValuejsonldsyliusshopproductoptionvalueindex = Schema.Schema.Type<
  typeof ProductOptionValuejsonldsyliusshopproductoptionvalueindex
>;
export type ProductOptionValuejsonldsyliusshopproductoptionvalueindexEncoded = Schema.Codec.Encoded<
  typeof ProductOptionValuejsonldsyliusshopproductoptionvalueindex
>;

/* ProductOptionValuejsonldsyliusshopproductoptionvalueshow */

export const ProductOptionValuejsonldsyliusshopproductoptionvalueshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String,
    option: Schema.String.annotate({ format: 'iri-reference' }),
    value: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductOptionValuejsonldsyliusshopproductoptionvalueshow' });
export type ProductOptionValuejsonldsyliusshopproductoptionvalueshow = Schema.Schema.Type<
  typeof ProductOptionValuejsonldsyliusshopproductoptionvalueshow
>;
export type ProductOptionValuejsonldsyliusshopproductoptionvalueshowEncoded = Schema.Codec.Encoded<
  typeof ProductOptionValuejsonldsyliusshopproductoptionvalueshow
>;

/* ProductReviewsyliusadminproductreviewupdate */

export const ProductReviewsyliusadminproductreviewupdate = Schema.StructWithRest(
  Schema.Struct({
    title: Schema.Union([
      Schema.String.check(
        Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
      ).check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    rating: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' }))
      .check(
        Schema.isGreaterThanOrEqualTo(1).annotate({
          expected: 'a value greater than or equal to 1',
        })
      )
      .check(
        Schema.isLessThanOrEqualTo(5).annotate({ expected: 'a value less than or equal to 5' })
      ),
    comment: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductReviewsyliusadminproductreviewupdate' });
export type ProductReviewsyliusadminproductreviewupdate = Schema.Schema.Type<
  typeof ProductReviewsyliusadminproductreviewupdate
>;
export type ProductReviewsyliusadminproductreviewupdateEncoded = Schema.Codec.Encoded<
  typeof ProductReviewsyliusadminproductreviewupdate
>;

/* ProductReviewAddProductReviewsyliusshopproductreviewcreate */

export const ProductReviewAddProductReviewsyliusshopproductreviewcreate = Schema.StructWithRest(
  Schema.Struct({
    title: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    rating: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' }))
      .check(
        Schema.isGreaterThanOrEqualTo(1).annotate({
          expected: 'a value greater than or equal to 1',
        })
      )
      .check(
        Schema.isLessThanOrEqualTo(5).annotate({ expected: 'a value less than or equal to 5' })
      ),
    comment: Schema.String,
    product: Schema.String,
    email: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductReviewAddProductReviewsyliusshopproductreviewcreate' });
export type ProductReviewAddProductReviewsyliusshopproductreviewcreate = Schema.Schema.Type<
  typeof ProductReviewAddProductReviewsyliusshopproductreviewcreate
>;
export type ProductReviewAddProductReviewsyliusshopproductreviewcreateEncoded =
  Schema.Codec.Encoded<typeof ProductReviewAddProductReviewsyliusshopproductreviewcreate>;

/* ProductReviewAddProductReviewjsonldsyliusshopproductreviewcreate */

export const ProductReviewAddProductReviewjsonldsyliusshopproductreviewcreate =
  Schema.StructWithRest(
    Schema.Struct({
      title: Schema.String.check(
        Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
      ).check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      rating: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' }))
        .check(
          Schema.isGreaterThanOrEqualTo(1).annotate({
            expected: 'a value greater than or equal to 1',
          })
        )
        .check(
          Schema.isLessThanOrEqualTo(5).annotate({ expected: 'a value less than or equal to 5' })
        ),
      comment: Schema.String,
      product: Schema.String,
      email: Schema.Union([Schema.String, Schema.Null]),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({ identifier: 'ProductReviewAddProductReviewjsonldsyliusshopproductreviewcreate' });
export type ProductReviewAddProductReviewjsonldsyliusshopproductreviewcreate = Schema.Schema.Type<
  typeof ProductReviewAddProductReviewjsonldsyliusshopproductreviewcreate
>;
export type ProductReviewAddProductReviewjsonldsyliusshopproductreviewcreateEncoded =
  Schema.Codec.Encoded<typeof ProductReviewAddProductReviewjsonldsyliusshopproductreviewcreate>;

/* ProductReviewjsonldsyliusadminproductreviewupdate */

export const ProductReviewjsonldsyliusadminproductreviewupdate = Schema.StructWithRest(
  Schema.Struct({
    title: Schema.Union([
      Schema.String.check(
        Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
      ).check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    rating: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' }))
      .check(
        Schema.isGreaterThanOrEqualTo(1).annotate({
          expected: 'a value greater than or equal to 1',
        })
      )
      .check(
        Schema.isLessThanOrEqualTo(5).annotate({ expected: 'a value less than or equal to 5' })
      ),
    comment: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductReviewjsonldsyliusadminproductreviewupdate' });
export type ProductReviewjsonldsyliusadminproductreviewupdate = Schema.Schema.Type<
  typeof ProductReviewjsonldsyliusadminproductreviewupdate
>;
export type ProductReviewjsonldsyliusadminproductreviewupdateEncoded = Schema.Codec.Encoded<
  typeof ProductReviewjsonldsyliusadminproductreviewupdate
>;

/* ProductTaxonsyliusadminproducttaxoncreate */

export const ProductTaxonsyliusadminproducttaxoncreate = Schema.StructWithRest(
  Schema.Struct({
    product: Schema.String.annotate({ format: 'iri-reference' }),
    taxon: Schema.String.annotate({ format: 'iri-reference' }),
    position: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductTaxonsyliusadminproducttaxoncreate' });
export type ProductTaxonsyliusadminproducttaxoncreate = Schema.Schema.Type<
  typeof ProductTaxonsyliusadminproducttaxoncreate
>;
export type ProductTaxonsyliusadminproducttaxoncreateEncoded = Schema.Codec.Encoded<
  typeof ProductTaxonsyliusadminproducttaxoncreate
>;

/* ProductTaxonsyliusadminproducttaxonindex */

export const ProductTaxonsyliusadminproducttaxonindex = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    product: Schema.String.annotate({ format: 'iri-reference' }),
    taxon: Schema.String.annotate({ format: 'iri-reference' }),
    position: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductTaxonsyliusadminproducttaxonindex' });
export type ProductTaxonsyliusadminproducttaxonindex = Schema.Schema.Type<
  typeof ProductTaxonsyliusadminproducttaxonindex
>;
export type ProductTaxonsyliusadminproducttaxonindexEncoded = Schema.Codec.Encoded<
  typeof ProductTaxonsyliusadminproducttaxonindex
>;

/* ProductTaxonsyliusadminproducttaxonshow */

export const ProductTaxonsyliusadminproducttaxonshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    product: Schema.String.annotate({ format: 'iri-reference' }),
    taxon: Schema.String.annotate({ format: 'iri-reference' }),
    position: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductTaxonsyliusadminproducttaxonshow' });
export type ProductTaxonsyliusadminproducttaxonshow = Schema.Schema.Type<
  typeof ProductTaxonsyliusadminproducttaxonshow
>;
export type ProductTaxonsyliusadminproducttaxonshowEncoded = Schema.Codec.Encoded<
  typeof ProductTaxonsyliusadminproducttaxonshow
>;

/* ProductTaxonsyliusadminproducttaxonupdate */

export const ProductTaxonsyliusadminproducttaxonupdate = Schema.StructWithRest(
  Schema.Struct({
    position: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductTaxonsyliusadminproducttaxonupdate' });
export type ProductTaxonsyliusadminproducttaxonupdate = Schema.Schema.Type<
  typeof ProductTaxonsyliusadminproducttaxonupdate
>;
export type ProductTaxonsyliusadminproducttaxonupdateEncoded = Schema.Codec.Encoded<
  typeof ProductTaxonsyliusadminproducttaxonupdate
>;

/* ProductTaxonsyliusshopproducttaxonshow */

export const ProductTaxonsyliusshopproducttaxonshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    product: Schema.String.annotate({ format: 'iri-reference' }),
    taxon: Schema.String.annotate({ format: 'iri-reference' }),
    position: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductTaxonsyliusshopproducttaxonshow' });
export type ProductTaxonsyliusshopproducttaxonshow = Schema.Schema.Type<
  typeof ProductTaxonsyliusshopproducttaxonshow
>;
export type ProductTaxonsyliusshopproducttaxonshowEncoded = Schema.Codec.Encoded<
  typeof ProductTaxonsyliusshopproducttaxonshow
>;

/* ProductTaxonjsonldsyliusadminproducttaxoncreate */

export const ProductTaxonjsonldsyliusadminproducttaxoncreate = Schema.StructWithRest(
  Schema.Struct({
    product: Schema.String.annotate({ format: 'iri-reference' }),
    taxon: Schema.String.annotate({ format: 'iri-reference' }),
    position: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductTaxonjsonldsyliusadminproducttaxoncreate' });
export type ProductTaxonjsonldsyliusadminproducttaxoncreate = Schema.Schema.Type<
  typeof ProductTaxonjsonldsyliusadminproducttaxoncreate
>;
export type ProductTaxonjsonldsyliusadminproducttaxoncreateEncoded = Schema.Codec.Encoded<
  typeof ProductTaxonjsonldsyliusadminproducttaxoncreate
>;

/* ProductTaxonjsonldsyliusadminproducttaxonindex */

export const ProductTaxonjsonldsyliusadminproducttaxonindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    product: Schema.String.annotate({ format: 'iri-reference' }),
    taxon: Schema.String.annotate({ format: 'iri-reference' }),
    position: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductTaxonjsonldsyliusadminproducttaxonindex' });
export type ProductTaxonjsonldsyliusadminproducttaxonindex = Schema.Schema.Type<
  typeof ProductTaxonjsonldsyliusadminproducttaxonindex
>;
export type ProductTaxonjsonldsyliusadminproducttaxonindexEncoded = Schema.Codec.Encoded<
  typeof ProductTaxonjsonldsyliusadminproducttaxonindex
>;

/* ProductTaxonjsonldsyliusadminproducttaxonshow */

export const ProductTaxonjsonldsyliusadminproducttaxonshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    product: Schema.String.annotate({ format: 'iri-reference' }),
    taxon: Schema.String.annotate({ format: 'iri-reference' }),
    position: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductTaxonjsonldsyliusadminproducttaxonshow' });
export type ProductTaxonjsonldsyliusadminproducttaxonshow = Schema.Schema.Type<
  typeof ProductTaxonjsonldsyliusadminproducttaxonshow
>;
export type ProductTaxonjsonldsyliusadminproducttaxonshowEncoded = Schema.Codec.Encoded<
  typeof ProductTaxonjsonldsyliusadminproducttaxonshow
>;

/* ProductTaxonjsonldsyliusadminproducttaxonupdate */

export const ProductTaxonjsonldsyliusadminproducttaxonupdate = Schema.StructWithRest(
  Schema.Struct({
    position: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductTaxonjsonldsyliusadminproducttaxonupdate' });
export type ProductTaxonjsonldsyliusadminproducttaxonupdate = Schema.Schema.Type<
  typeof ProductTaxonjsonldsyliusadminproducttaxonupdate
>;
export type ProductTaxonjsonldsyliusadminproducttaxonupdateEncoded = Schema.Codec.Encoded<
  typeof ProductTaxonjsonldsyliusadminproducttaxonupdate
>;

/* ProductTaxonjsonldsyliusshopproducttaxonshow */

export const ProductTaxonjsonldsyliusshopproducttaxonshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    product: Schema.String.annotate({ format: 'iri-reference' }),
    taxon: Schema.String.annotate({ format: 'iri-reference' }),
    position: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductTaxonjsonldsyliusshopproducttaxonshow' });
export type ProductTaxonjsonldsyliusshopproducttaxonshow = Schema.Schema.Type<
  typeof ProductTaxonjsonldsyliusshopproducttaxonshow
>;
export type ProductTaxonjsonldsyliusshopproducttaxonshowEncoded = Schema.Codec.Encoded<
  typeof ProductTaxonjsonldsyliusshopproducttaxonshow
>;

/* ProductVariantsyliusadminproductvariantcreate */

export const ProductVariantsyliusadminproductvariantcreate = Schema.StructWithRest(
  Schema.Struct({
    onHold: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    onHand: Schema.Number.annotate({ default: 0 })
      .check(Schema.isInt().annotate({ expected: 'an integer' }))
      .check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
    tracked: Schema.Boolean.annotate({ default: false }),
    weight: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })).check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
      Schema.Null,
    ]),
    width: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })).check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
      Schema.Null,
    ]),
    height: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })).check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
      Schema.Null,
    ]),
    depth: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })).check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
      Schema.Null,
    ]),
    taxCategory: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    shippingCategory: Schema.Union([
      Schema.String.annotate({ format: 'iri-reference' }),
      Schema.Null,
    ]),
    channelPricings: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    shippingRequired: Schema.Boolean.annotate({ default: true }),
    code: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ).check(
      Schema.isPattern(new RegExp('^([\\w/()-]*)$')).annotate({
        expected: 'a string matching the RegExp ^([\\w/()-]*)$',
      })
    ),
    product: Schema.String.annotate({ format: 'iri-reference' }),
    optionValues: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    inStock: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductVariantsyliusadminproductvariantcreate' });
export type ProductVariantsyliusadminproductvariantcreate = Schema.Schema.Type<
  typeof ProductVariantsyliusadminproductvariantcreate
>;
export type ProductVariantsyliusadminproductvariantcreateEncoded = Schema.Codec.Encoded<
  typeof ProductVariantsyliusadminproductvariantcreate
>;

/* ProductVariantsyliusadminproductvariantupdate */

export const ProductVariantsyliusadminproductvariantupdate = Schema.StructWithRest(
  Schema.Struct({
    onHold: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    onHand: Schema.Number.annotate({ default: 0 })
      .check(Schema.isInt().annotate({ expected: 'an integer' }))
      .check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
    tracked: Schema.Boolean.annotate({ default: false }),
    weight: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })).check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
      Schema.Null,
    ]),
    width: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })).check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
      Schema.Null,
    ]),
    height: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })).check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
      Schema.Null,
    ]),
    depth: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })).check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
      Schema.Null,
    ]),
    taxCategory: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    shippingCategory: Schema.Union([
      Schema.String.annotate({ format: 'iri-reference' }),
      Schema.Null,
    ]),
    channelPricings: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    shippingRequired: Schema.Boolean.annotate({ default: true }),
    optionValues: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    inStock: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductVariantsyliusadminproductvariantupdate' });
export type ProductVariantsyliusadminproductvariantupdate = Schema.Schema.Type<
  typeof ProductVariantsyliusadminproductvariantupdate
>;
export type ProductVariantsyliusadminproductvariantupdateEncoded = Schema.Codec.Encoded<
  typeof ProductVariantsyliusadminproductvariantupdate
>;

/* ProductVariantjsonldsyliusadminproductvariantcreate */

export const ProductVariantjsonldsyliusadminproductvariantcreate = Schema.StructWithRest(
  Schema.Struct({
    onHold: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    onHand: Schema.Number.annotate({ default: 0 })
      .check(Schema.isInt().annotate({ expected: 'an integer' }))
      .check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
    tracked: Schema.Boolean.annotate({ default: false }),
    weight: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })).check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
      Schema.Null,
    ]),
    width: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })).check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
      Schema.Null,
    ]),
    height: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })).check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
      Schema.Null,
    ]),
    depth: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })).check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
      Schema.Null,
    ]),
    taxCategory: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    shippingCategory: Schema.Union([
      Schema.String.annotate({ format: 'iri-reference' }),
      Schema.Null,
    ]),
    channelPricings: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    shippingRequired: Schema.Boolean.annotate({ default: true }),
    code: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ).check(
      Schema.isPattern(new RegExp('^([\\w/()-]*)$')).annotate({
        expected: 'a string matching the RegExp ^([\\w/()-]*)$',
      })
    ),
    product: Schema.String.annotate({ format: 'iri-reference' }),
    optionValues: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    inStock: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductVariantjsonldsyliusadminproductvariantcreate' });
export type ProductVariantjsonldsyliusadminproductvariantcreate = Schema.Schema.Type<
  typeof ProductVariantjsonldsyliusadminproductvariantcreate
>;
export type ProductVariantjsonldsyliusadminproductvariantcreateEncoded = Schema.Codec.Encoded<
  typeof ProductVariantjsonldsyliusadminproductvariantcreate
>;

/* ProductVariantjsonldsyliusadminproductvariantupdate */

export const ProductVariantjsonldsyliusadminproductvariantupdate = Schema.StructWithRest(
  Schema.Struct({
    onHold: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    onHand: Schema.Number.annotate({ default: 0 })
      .check(Schema.isInt().annotate({ expected: 'an integer' }))
      .check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
    tracked: Schema.Boolean.annotate({ default: false }),
    weight: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })).check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
      Schema.Null,
    ]),
    width: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })).check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
      Schema.Null,
    ]),
    height: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })).check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
      Schema.Null,
    ]),
    depth: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })).check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
      Schema.Null,
    ]),
    taxCategory: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    shippingCategory: Schema.Union([
      Schema.String.annotate({ format: 'iri-reference' }),
      Schema.Null,
    ]),
    channelPricings: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    shippingRequired: Schema.Boolean.annotate({ default: true }),
    optionValues: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    inStock: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductVariantjsonldsyliusadminproductvariantupdate' });
export type ProductVariantjsonldsyliusadminproductvariantupdate = Schema.Schema.Type<
  typeof ProductVariantjsonldsyliusadminproductvariantupdate
>;
export type ProductVariantjsonldsyliusadminproductvariantupdateEncoded = Schema.Codec.Encoded<
  typeof ProductVariantjsonldsyliusadminproductvariantupdate
>;

/* PromotionRulesyliusadminpromotioncreate */

export const PromotionRulesyliusadminpromotioncreate = Schema.StructWithRest(
  Schema.Struct({
    type: Schema.String,
    configuration: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PromotionRulesyliusadminpromotioncreate' });
export type PromotionRulesyliusadminpromotioncreate = Schema.Schema.Type<
  typeof PromotionRulesyliusadminpromotioncreate
>;
export type PromotionRulesyliusadminpromotioncreateEncoded = Schema.Codec.Encoded<
  typeof PromotionRulesyliusadminpromotioncreate
>;

/* PromotionActionsyliusadminpromotioncreate */

export const PromotionActionsyliusadminpromotioncreate = Schema.StructWithRest(
  Schema.Struct({
    type: Schema.String,
    configuration: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PromotionActionsyliusadminpromotioncreate' });
export type PromotionActionsyliusadminpromotioncreate = Schema.Schema.Type<
  typeof PromotionActionsyliusadminpromotioncreate
>;
export type PromotionActionsyliusadminpromotioncreateEncoded = Schema.Codec.Encoded<
  typeof PromotionActionsyliusadminpromotioncreate
>;

/* PromotionRulesyliusadminpromotionindex */

export const PromotionRulesyliusadminpromotionindex = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.String,
    configuration: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PromotionRulesyliusadminpromotionindex' });
export type PromotionRulesyliusadminpromotionindex = Schema.Schema.Type<
  typeof PromotionRulesyliusadminpromotionindex
>;
export type PromotionRulesyliusadminpromotionindexEncoded = Schema.Codec.Encoded<
  typeof PromotionRulesyliusadminpromotionindex
>;

/* PromotionActionsyliusadminpromotionindex */

export const PromotionActionsyliusadminpromotionindex = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.String,
    configuration: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PromotionActionsyliusadminpromotionindex' });
export type PromotionActionsyliusadminpromotionindex = Schema.Schema.Type<
  typeof PromotionActionsyliusadminpromotionindex
>;
export type PromotionActionsyliusadminpromotionindexEncoded = Schema.Codec.Encoded<
  typeof PromotionActionsyliusadminpromotionindex
>;

/* PromotionRulesyliusadminpromotionshow */

export const PromotionRulesyliusadminpromotionshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.String,
    configuration: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PromotionRulesyliusadminpromotionshow' });
export type PromotionRulesyliusadminpromotionshow = Schema.Schema.Type<
  typeof PromotionRulesyliusadminpromotionshow
>;
export type PromotionRulesyliusadminpromotionshowEncoded = Schema.Codec.Encoded<
  typeof PromotionRulesyliusadminpromotionshow
>;

/* PromotionActionsyliusadminpromotionshow */

export const PromotionActionsyliusadminpromotionshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.String,
    configuration: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PromotionActionsyliusadminpromotionshow' });
export type PromotionActionsyliusadminpromotionshow = Schema.Schema.Type<
  typeof PromotionActionsyliusadminpromotionshow
>;
export type PromotionActionsyliusadminpromotionshowEncoded = Schema.Codec.Encoded<
  typeof PromotionActionsyliusadminpromotionshow
>;

/* PromotionRulesyliusadminpromotionupdate */

export const PromotionRulesyliusadminpromotionupdate = Schema.StructWithRest(
  Schema.Struct({
    type: Schema.String,
    configuration: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PromotionRulesyliusadminpromotionupdate' });
export type PromotionRulesyliusadminpromotionupdate = Schema.Schema.Type<
  typeof PromotionRulesyliusadminpromotionupdate
>;
export type PromotionRulesyliusadminpromotionupdateEncoded = Schema.Codec.Encoded<
  typeof PromotionRulesyliusadminpromotionupdate
>;

/* PromotionActionsyliusadminpromotionupdate */

export const PromotionActionsyliusadminpromotionupdate = Schema.StructWithRest(
  Schema.Struct({
    type: Schema.String,
    configuration: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PromotionActionsyliusadminpromotionupdate' });
export type PromotionActionsyliusadminpromotionupdate = Schema.Schema.Type<
  typeof PromotionActionsyliusadminpromotionupdate
>;
export type PromotionActionsyliusadminpromotionupdateEncoded = Schema.Codec.Encoded<
  typeof PromotionActionsyliusadminpromotionupdate
>;

/* PromotionRulejsonldsyliusadminpromotioncreate */

export const PromotionRulejsonldsyliusadminpromotioncreate = Schema.StructWithRest(
  Schema.Struct({
    type: Schema.String,
    configuration: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PromotionRulejsonldsyliusadminpromotioncreate' });
export type PromotionRulejsonldsyliusadminpromotioncreate = Schema.Schema.Type<
  typeof PromotionRulejsonldsyliusadminpromotioncreate
>;
export type PromotionRulejsonldsyliusadminpromotioncreateEncoded = Schema.Codec.Encoded<
  typeof PromotionRulejsonldsyliusadminpromotioncreate
>;

/* PromotionActionjsonldsyliusadminpromotioncreate */

export const PromotionActionjsonldsyliusadminpromotioncreate = Schema.StructWithRest(
  Schema.Struct({
    type: Schema.String,
    configuration: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PromotionActionjsonldsyliusadminpromotioncreate' });
export type PromotionActionjsonldsyliusadminpromotioncreate = Schema.Schema.Type<
  typeof PromotionActionjsonldsyliusadminpromotioncreate
>;
export type PromotionActionjsonldsyliusadminpromotioncreateEncoded = Schema.Codec.Encoded<
  typeof PromotionActionjsonldsyliusadminpromotioncreate
>;

/* PromotionRulejsonldsyliusadminpromotionindex */

export const PromotionRulejsonldsyliusadminpromotionindex = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.String,
    configuration: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PromotionRulejsonldsyliusadminpromotionindex' });
export type PromotionRulejsonldsyliusadminpromotionindex = Schema.Schema.Type<
  typeof PromotionRulejsonldsyliusadminpromotionindex
>;
export type PromotionRulejsonldsyliusadminpromotionindexEncoded = Schema.Codec.Encoded<
  typeof PromotionRulejsonldsyliusadminpromotionindex
>;

/* PromotionActionjsonldsyliusadminpromotionindex */

export const PromotionActionjsonldsyliusadminpromotionindex = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.String,
    configuration: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PromotionActionjsonldsyliusadminpromotionindex' });
export type PromotionActionjsonldsyliusadminpromotionindex = Schema.Schema.Type<
  typeof PromotionActionjsonldsyliusadminpromotionindex
>;
export type PromotionActionjsonldsyliusadminpromotionindexEncoded = Schema.Codec.Encoded<
  typeof PromotionActionjsonldsyliusadminpromotionindex
>;

/* PromotionRulejsonldsyliusadminpromotionshow */

export const PromotionRulejsonldsyliusadminpromotionshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.String,
    configuration: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PromotionRulejsonldsyliusadminpromotionshow' });
export type PromotionRulejsonldsyliusadminpromotionshow = Schema.Schema.Type<
  typeof PromotionRulejsonldsyliusadminpromotionshow
>;
export type PromotionRulejsonldsyliusadminpromotionshowEncoded = Schema.Codec.Encoded<
  typeof PromotionRulejsonldsyliusadminpromotionshow
>;

/* PromotionActionjsonldsyliusadminpromotionshow */

export const PromotionActionjsonldsyliusadminpromotionshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.String,
    configuration: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PromotionActionjsonldsyliusadminpromotionshow' });
export type PromotionActionjsonldsyliusadminpromotionshow = Schema.Schema.Type<
  typeof PromotionActionjsonldsyliusadminpromotionshow
>;
export type PromotionActionjsonldsyliusadminpromotionshowEncoded = Schema.Codec.Encoded<
  typeof PromotionActionjsonldsyliusadminpromotionshow
>;

/* PromotionRulejsonldsyliusadminpromotionupdate */

export const PromotionRulejsonldsyliusadminpromotionupdate = Schema.StructWithRest(
  Schema.Struct({
    type: Schema.String,
    configuration: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PromotionRulejsonldsyliusadminpromotionupdate' });
export type PromotionRulejsonldsyliusadminpromotionupdate = Schema.Schema.Type<
  typeof PromotionRulejsonldsyliusadminpromotionupdate
>;
export type PromotionRulejsonldsyliusadminpromotionupdateEncoded = Schema.Codec.Encoded<
  typeof PromotionRulejsonldsyliusadminpromotionupdate
>;

/* PromotionActionjsonldsyliusadminpromotionupdate */

export const PromotionActionjsonldsyliusadminpromotionupdate = Schema.StructWithRest(
  Schema.Struct({
    type: Schema.String,
    configuration: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PromotionActionjsonldsyliusadminpromotionupdate' });
export type PromotionActionjsonldsyliusadminpromotionupdate = Schema.Schema.Type<
  typeof PromotionActionjsonldsyliusadminpromotionupdate
>;
export type PromotionActionjsonldsyliusadminpromotionupdateEncoded = Schema.Codec.Encoded<
  typeof PromotionActionjsonldsyliusadminpromotionupdate
>;

/* Provincesyliusadminprovinceindex */

export const Provincesyliusadminprovinceindex = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String,
    name: Schema.String,
    abbreviation: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Provincesyliusadminprovinceindex' });
export type Provincesyliusadminprovinceindex = Schema.Schema.Type<
  typeof Provincesyliusadminprovinceindex
>;
export type ProvincesyliusadminprovinceindexEncoded = Schema.Codec.Encoded<
  typeof Provincesyliusadminprovinceindex
>;

/* Provincesyliusadminprovinceshow */

export const Provincesyliusadminprovinceshow = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String,
    name: Schema.String,
    abbreviation: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Provincesyliusadminprovinceshow' });
export type Provincesyliusadminprovinceshow = Schema.Schema.Type<
  typeof Provincesyliusadminprovinceshow
>;
export type ProvincesyliusadminprovinceshowEncoded = Schema.Codec.Encoded<
  typeof Provincesyliusadminprovinceshow
>;

/* Provincesyliusadminprovinceupdate */

export const Provincesyliusadminprovinceupdate = Schema.StructWithRest(
  Schema.Struct({
    name: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    abbreviation: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Provincesyliusadminprovinceupdate' });
export type Provincesyliusadminprovinceupdate = Schema.Schema.Type<
  typeof Provincesyliusadminprovinceupdate
>;
export type ProvincesyliusadminprovinceupdateEncoded = Schema.Codec.Encoded<
  typeof Provincesyliusadminprovinceupdate
>;

/* Provincesyliusshopprovinceshow */

export const Provincesyliusshopprovinceshow = Schema.StructWithRest(
  Schema.Struct({ code: Schema.String, name: Schema.String }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Provincesyliusshopprovinceshow' });
export type Provincesyliusshopprovinceshow = Schema.Schema.Type<
  typeof Provincesyliusshopprovinceshow
>;
export type ProvincesyliusshopprovinceshowEncoded = Schema.Codec.Encoded<
  typeof Provincesyliusshopprovinceshow
>;

/* Provincejsonldsyliusadminprovinceindex */

export const Provincejsonldsyliusadminprovinceindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String,
    name: Schema.String,
    abbreviation: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Provincejsonldsyliusadminprovinceindex' });
export type Provincejsonldsyliusadminprovinceindex = Schema.Schema.Type<
  typeof Provincejsonldsyliusadminprovinceindex
>;
export type ProvincejsonldsyliusadminprovinceindexEncoded = Schema.Codec.Encoded<
  typeof Provincejsonldsyliusadminprovinceindex
>;

/* Provincejsonldsyliusadminprovinceshow */

export const Provincejsonldsyliusadminprovinceshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String,
    name: Schema.String,
    abbreviation: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Provincejsonldsyliusadminprovinceshow' });
export type Provincejsonldsyliusadminprovinceshow = Schema.Schema.Type<
  typeof Provincejsonldsyliusadminprovinceshow
>;
export type ProvincejsonldsyliusadminprovinceshowEncoded = Schema.Codec.Encoded<
  typeof Provincejsonldsyliusadminprovinceshow
>;

/* Provincejsonldsyliusadminprovinceupdate */

export const Provincejsonldsyliusadminprovinceupdate = Schema.StructWithRest(
  Schema.Struct({
    name: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    abbreviation: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Provincejsonldsyliusadminprovinceupdate' });
export type Provincejsonldsyliusadminprovinceupdate = Schema.Schema.Type<
  typeof Provincejsonldsyliusadminprovinceupdate
>;
export type ProvincejsonldsyliusadminprovinceupdateEncoded = Schema.Codec.Encoded<
  typeof Provincejsonldsyliusadminprovinceupdate
>;

/* Provincejsonldsyliusshopprovinceshow */

export const Provincejsonldsyliusshopprovinceshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String,
    name: Schema.String,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Provincejsonldsyliusshopprovinceshow' });
export type Provincejsonldsyliusshopprovinceshow = Schema.Schema.Type<
  typeof Provincejsonldsyliusshopprovinceshow
>;
export type ProvincejsonldsyliusshopprovinceshowEncoded = Schema.Codec.Encoded<
  typeof Provincejsonldsyliusshopprovinceshow
>;

/* ResetPasswordsyliusadminresetpasswordupdatejsonMergePatch */

export const ResetPasswordsyliusadminresetpasswordupdatejsonMergePatch = Schema.StructWithRest(
  Schema.Struct({
    newPassword: Schema.String.check(
      Schema.isMinLength(4).annotate({ expected: 'a value with a length of at least 4' })
    ).check(Schema.isMaxLength(254).annotate({ expected: 'a value with a length of at most 254' })),
    confirmNewPassword: Schema.Union([
      Schema.String.check(
        Schema.isMinLength(4).annotate({ expected: 'a value with a length of at least 4' })
      ).check(
        Schema.isMaxLength(254).annotate({ expected: 'a value with a length of at most 254' })
      ),
      Schema.Null,
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ResetPasswordsyliusadminresetpasswordupdatejsonMergePatch' });
export type ResetPasswordsyliusadminresetpasswordupdatejsonMergePatch = Schema.Schema.Type<
  typeof ResetPasswordsyliusadminresetpasswordupdatejsonMergePatch
>;
export type ResetPasswordsyliusadminresetpasswordupdatejsonMergePatchEncoded = Schema.Codec.Encoded<
  typeof ResetPasswordsyliusadminresetpasswordupdatejsonMergePatch
>;

/* ResetPasswordRequestResetPasswordEmailsyliusadminresetpasswordcreate */

export const ResetPasswordRequestResetPasswordEmailsyliusadminresetpasswordcreate =
  Schema.StructWithRest(
    Schema.Struct({
      email: Schema.String.annotate({ format: 'email' })
        .check(Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' }))
        .check(
          Schema.isMaxLength(254).annotate({ expected: 'a value with a length of at most 254' })
        ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier: 'ResetPasswordRequestResetPasswordEmailsyliusadminresetpasswordcreate',
  });
export type ResetPasswordRequestResetPasswordEmailsyliusadminresetpasswordcreate =
  Schema.Schema.Type<typeof ResetPasswordRequestResetPasswordEmailsyliusadminresetpasswordcreate>;
export type ResetPasswordRequestResetPasswordEmailsyliusadminresetpasswordcreateEncoded =
  Schema.Codec.Encoded<typeof ResetPasswordRequestResetPasswordEmailsyliusadminresetpasswordcreate>;

/* ResetPasswordRequestResetPasswordEmailjsonldsyliusadminresetpasswordcreate */

export const ResetPasswordRequestResetPasswordEmailjsonldsyliusadminresetpasswordcreate =
  Schema.StructWithRest(
    Schema.Struct({
      email: Schema.String.annotate({ format: 'email' })
        .check(Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' }))
        .check(
          Schema.isMaxLength(254).annotate({ expected: 'a value with a length of at most 254' })
        ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier: 'ResetPasswordRequestResetPasswordEmailjsonldsyliusadminresetpasswordcreate',
  });
export type ResetPasswordRequestResetPasswordEmailjsonldsyliusadminresetpasswordcreate =
  Schema.Schema.Type<
    typeof ResetPasswordRequestResetPasswordEmailjsonldsyliusadminresetpasswordcreate
  >;
export type ResetPasswordRequestResetPasswordEmailjsonldsyliusadminresetpasswordcreateEncoded =
  Schema.Codec.Encoded<
    typeof ResetPasswordRequestResetPasswordEmailjsonldsyliusadminresetpasswordcreate
  >;

/* SearchFacetBrandBucket */

export const SearchFacetBrandBucket = Schema.StructWithRest(
  Schema.Struct({
    key: Schema.String.annotate({
      description: 'Brand id — the value of the `brand` filter.',
      format: 'uuid',
    }),
    label: Schema.String.annotate({
      description: 'Brand name in the request locale; the id when the brand has no translation.',
    }),
    count: Schema.Number.annotate({
      description: 'Products of this brand within the current result set.',
    }).check(Schema.isInt().annotate({ expected: 'an integer' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({
  description: 'One brand the current result set can be narrowed to.',
  identifier: 'SearchFacetBrandBucket',
});
export type SearchFacetBrandBucket = Schema.Schema.Type<typeof SearchFacetBrandBucket>;
export type SearchFacetBrandBucketEncoded = Schema.Codec.Encoded<typeof SearchFacetBrandBucket>;

/* SearchFacetTaxonBucket */

export const SearchFacetTaxonBucket = Schema.StructWithRest(
  Schema.Struct({
    key: Schema.String.annotate({ description: 'Taxon code — the value of the `taxon` filter.' }),
    label: Schema.String.annotate({
      description: 'Taxon name in the request locale; the code when the taxon has no translation.',
    }),
    count: Schema.Number.annotate({
      description: 'Products in this category within the current result set.',
    }).check(Schema.isInt().annotate({ expected: 'an integer' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({
  description: 'One category the current result set can be narrowed to.',
  identifier: 'SearchFacetTaxonBucket',
});
export type SearchFacetTaxonBucket = Schema.Schema.Type<typeof SearchFacetTaxonBucket>;
export type SearchFacetTaxonBucketEncoded = Schema.Codec.Encoded<typeof SearchFacetTaxonBucket>;

/* SearchAttributeFacetValue */

export const SearchAttributeFacetValue = Schema.StructWithRest(
  Schema.Struct({
    key: Schema.String.annotate({
      description:
        'The value as sent back in `attribute_<code>` — a choice key for `select` attributes, the value itself otherwise.',
    }),
    label: Schema.Union([Schema.String, Schema.Null]).annotate({
      description:
        'Choice label in the request locale for `select` attributes; null for other types, whose key is the display value.',
    }),
    count: Schema.Number.annotate({
      description: 'Products with this value within the current result set.',
    }).check(Schema.isInt().annotate({ expected: 'an integer' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'SearchAttributeFacetValue' });
export type SearchAttributeFacetValue = Schema.Schema.Type<typeof SearchAttributeFacetValue>;
export type SearchAttributeFacetValueEncoded = Schema.Codec.Encoded<
  typeof SearchAttributeFacetValue
>;

/* Sectionsyliusshopsectionindex */

export const Sectionsyliusshopsectionindex = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.String.annotate({ format: 'uuid' }),
    code: Schema.String,
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    articlesCount: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Sectionsyliusshopsectionindex' });
export type Sectionsyliusshopsectionindex = Schema.Schema.Type<
  typeof Sectionsyliusshopsectionindex
>;
export type SectionsyliusshopsectionindexEncoded = Schema.Codec.Encoded<
  typeof Sectionsyliusshopsectionindex
>;

/* Sectionjsonldsyliusshopsectionindex */

export const Sectionjsonldsyliusshopsectionindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.String.annotate({ format: 'uuid' }),
    code: Schema.String,
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    articlesCount: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Sectionjsonldsyliusshopsectionindex' });
export type Sectionjsonldsyliusshopsectionindex = Schema.Schema.Type<
  typeof Sectionjsonldsyliusshopsectionindex
>;
export type SectionjsonldsyliusshopsectionindexEncoded = Schema.Codec.Encoded<
  typeof Sectionjsonldsyliusshopsectionindex
>;

/* ShipmentResendShipmentConfirmationEmail */

export const ShipmentResendShipmentConfirmationEmail = Schema.StructWithRest(
  Schema.Struct({ shipmentId: Schema.Union([Schema.String, Schema.Null]) }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShipmentResendShipmentConfirmationEmail' });
export type ShipmentResendShipmentConfirmationEmail = Schema.Schema.Type<
  typeof ShipmentResendShipmentConfirmationEmail
>;
export type ShipmentResendShipmentConfirmationEmailEncoded = Schema.Codec.Encoded<
  typeof ShipmentResendShipmentConfirmationEmail
>;

/* ShipmentResendShipmentConfirmationEmailjsonld */

export const ShipmentResendShipmentConfirmationEmailjsonld = Schema.StructWithRest(
  Schema.Struct({ shipmentId: Schema.Union([Schema.String, Schema.Null]) }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShipmentResendShipmentConfirmationEmailjsonld' });
export type ShipmentResendShipmentConfirmationEmailjsonld = Schema.Schema.Type<
  typeof ShipmentResendShipmentConfirmationEmailjsonld
>;
export type ShipmentResendShipmentConfirmationEmailjsonldEncoded = Schema.Codec.Encoded<
  typeof ShipmentResendShipmentConfirmationEmailjsonld
>;

/* ShipmentShipShipmentsyliusadminshipmentupdatejsonMergePatch */

export const ShipmentShipShipmentsyliusadminshipmentupdatejsonMergePatch = Schema.StructWithRest(
  Schema.Struct({ trackingCode: Schema.Union([Schema.String, Schema.Null]) }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShipmentShipShipmentsyliusadminshipmentupdatejsonMergePatch' });
export type ShipmentShipShipmentsyliusadminshipmentupdatejsonMergePatch = Schema.Schema.Type<
  typeof ShipmentShipShipmentsyliusadminshipmentupdatejsonMergePatch
>;
export type ShipmentShipShipmentsyliusadminshipmentupdatejsonMergePatchEncoded =
  Schema.Codec.Encoded<typeof ShipmentShipShipmentsyliusadminshipmentupdatejsonMergePatch>;

/* ShippingCategorysyliusadminshippingcategorycreate */

export const ShippingCategorysyliusadminshippingcategorycreate = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ).check(
      Schema.isPattern(new RegExp('^([\\w-]*)$')).annotate({
        expected: 'a string matching the RegExp ^([\\w-]*)$',
      })
    ),
    name: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    description: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingCategorysyliusadminshippingcategorycreate' });
export type ShippingCategorysyliusadminshippingcategorycreate = Schema.Schema.Type<
  typeof ShippingCategorysyliusadminshippingcategorycreate
>;
export type ShippingCategorysyliusadminshippingcategorycreateEncoded = Schema.Codec.Encoded<
  typeof ShippingCategorysyliusadminshippingcategorycreate
>;

/* ShippingCategorysyliusadminshippingcategoryupdate */

export const ShippingCategorysyliusadminshippingcategoryupdate = Schema.StructWithRest(
  Schema.Struct({
    name: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    description: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingCategorysyliusadminshippingcategoryupdate' });
export type ShippingCategorysyliusadminshippingcategoryupdate = Schema.Schema.Type<
  typeof ShippingCategorysyliusadminshippingcategoryupdate
>;
export type ShippingCategorysyliusadminshippingcategoryupdateEncoded = Schema.Codec.Encoded<
  typeof ShippingCategorysyliusadminshippingcategoryupdate
>;

/* ShippingCategoryjsonldsyliusadminshippingcategorycreate */

export const ShippingCategoryjsonldsyliusadminshippingcategorycreate = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ).check(
      Schema.isPattern(new RegExp('^([\\w-]*)$')).annotate({
        expected: 'a string matching the RegExp ^([\\w-]*)$',
      })
    ),
    name: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    description: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingCategoryjsonldsyliusadminshippingcategorycreate' });
export type ShippingCategoryjsonldsyliusadminshippingcategorycreate = Schema.Schema.Type<
  typeof ShippingCategoryjsonldsyliusadminshippingcategorycreate
>;
export type ShippingCategoryjsonldsyliusadminshippingcategorycreateEncoded = Schema.Codec.Encoded<
  typeof ShippingCategoryjsonldsyliusadminshippingcategorycreate
>;

/* ShippingCategoryjsonldsyliusadminshippingcategoryupdate */

export const ShippingCategoryjsonldsyliusadminshippingcategoryupdate = Schema.StructWithRest(
  Schema.Struct({
    name: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    description: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingCategoryjsonldsyliusadminshippingcategoryupdate' });
export type ShippingCategoryjsonldsyliusadminshippingcategoryupdate = Schema.Schema.Type<
  typeof ShippingCategoryjsonldsyliusadminshippingcategoryupdate
>;
export type ShippingCategoryjsonldsyliusadminshippingcategoryupdateEncoded = Schema.Codec.Encoded<
  typeof ShippingCategoryjsonldsyliusadminshippingcategoryupdate
>;

/* ShippingMethodImageshopshippingAndPaymentOptionsindex */

export const ShippingMethodImageshopshippingAndPaymentOptionsindex = Schema.StructWithRest(
  Schema.Struct({
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingMethodImageshopshippingAndPaymentOptionsindex' });
export type ShippingMethodImageshopshippingAndPaymentOptionsindex = Schema.Schema.Type<
  typeof ShippingMethodImageshopshippingAndPaymentOptionsindex
>;
export type ShippingMethodImageshopshippingAndPaymentOptionsindexEncoded = Schema.Codec.Encoded<
  typeof ShippingMethodImageshopshippingAndPaymentOptionsindex
>;

/* ShippingMethodRulesyliusadminshippingmethodcreate */

export const ShippingMethodRulesyliusadminshippingmethodcreate = Schema.StructWithRest(
  Schema.Struct({
    type: Schema.String,
    configuration: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingMethodRulesyliusadminshippingmethodcreate' });
export type ShippingMethodRulesyliusadminshippingmethodcreate = Schema.Schema.Type<
  typeof ShippingMethodRulesyliusadminshippingmethodcreate
>;
export type ShippingMethodRulesyliusadminshippingmethodcreateEncoded = Schema.Codec.Encoded<
  typeof ShippingMethodRulesyliusadminshippingmethodcreate
>;

/* ShippingMethodRulesyliusadminshippingmethodindex */

export const ShippingMethodRulesyliusadminshippingmethodindex = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.String,
    configuration: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingMethodRulesyliusadminshippingmethodindex' });
export type ShippingMethodRulesyliusadminshippingmethodindex = Schema.Schema.Type<
  typeof ShippingMethodRulesyliusadminshippingmethodindex
>;
export type ShippingMethodRulesyliusadminshippingmethodindexEncoded = Schema.Codec.Encoded<
  typeof ShippingMethodRulesyliusadminshippingmethodindex
>;

/* ShippingMethodRulesyliusadminshippingmethodshow */

export const ShippingMethodRulesyliusadminshippingmethodshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.String,
    configuration: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingMethodRulesyliusadminshippingmethodshow' });
export type ShippingMethodRulesyliusadminshippingmethodshow = Schema.Schema.Type<
  typeof ShippingMethodRulesyliusadminshippingmethodshow
>;
export type ShippingMethodRulesyliusadminshippingmethodshowEncoded = Schema.Codec.Encoded<
  typeof ShippingMethodRulesyliusadminshippingmethodshow
>;

/* ShippingMethodRulesyliusadminshippingmethodupdate */

export const ShippingMethodRulesyliusadminshippingmethodupdate = Schema.StructWithRest(
  Schema.Struct({
    type: Schema.String,
    configuration: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingMethodRulesyliusadminshippingmethodupdate' });
export type ShippingMethodRulesyliusadminshippingmethodupdate = Schema.Schema.Type<
  typeof ShippingMethodRulesyliusadminshippingmethodupdate
>;
export type ShippingMethodRulesyliusadminshippingmethodupdateEncoded = Schema.Codec.Encoded<
  typeof ShippingMethodRulesyliusadminshippingmethodupdate
>;

/* ShippingMethodsyliusshopshippingmethodindex */

export const ShippingMethodsyliusshopshippingmethodindex = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    name: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
    price: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingMethodsyliusshopshippingmethodindex' });
export type ShippingMethodsyliusshopshippingmethodindex = Schema.Schema.Type<
  typeof ShippingMethodsyliusshopshippingmethodindex
>;
export type ShippingMethodsyliusshopshippingmethodindexEncoded = Schema.Codec.Encoded<
  typeof ShippingMethodsyliusshopshippingmethodindex
>;

/* ShippingMethodsyliusshopshippingmethodshow */

export const ShippingMethodsyliusshopshippingmethodshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    name: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
    price: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingMethodsyliusshopshippingmethodshow' });
export type ShippingMethodsyliusshopshippingmethodshow = Schema.Schema.Type<
  typeof ShippingMethodsyliusshopshippingmethodshow
>;
export type ShippingMethodsyliusshopshippingmethodshowEncoded = Schema.Codec.Encoded<
  typeof ShippingMethodsyliusshopshippingmethodshow
>;

/* ShippingMethodImagejsonldshopshippingAndPaymentOptionsindex */

export const ShippingMethodImagejsonldshopshippingAndPaymentOptionsindex = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingMethodImagejsonldshopshippingAndPaymentOptionsindex' });
export type ShippingMethodImagejsonldshopshippingAndPaymentOptionsindex = Schema.Schema.Type<
  typeof ShippingMethodImagejsonldshopshippingAndPaymentOptionsindex
>;
export type ShippingMethodImagejsonldshopshippingAndPaymentOptionsindexEncoded =
  Schema.Codec.Encoded<typeof ShippingMethodImagejsonldshopshippingAndPaymentOptionsindex>;

/* ShippingMethodRulejsonldsyliusadminshippingmethodcreate */

export const ShippingMethodRulejsonldsyliusadminshippingmethodcreate = Schema.StructWithRest(
  Schema.Struct({
    type: Schema.String,
    configuration: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingMethodRulejsonldsyliusadminshippingmethodcreate' });
export type ShippingMethodRulejsonldsyliusadminshippingmethodcreate = Schema.Schema.Type<
  typeof ShippingMethodRulejsonldsyliusadminshippingmethodcreate
>;
export type ShippingMethodRulejsonldsyliusadminshippingmethodcreateEncoded = Schema.Codec.Encoded<
  typeof ShippingMethodRulejsonldsyliusadminshippingmethodcreate
>;

/* ShippingMethodRulejsonldsyliusadminshippingmethodindex */

export const ShippingMethodRulejsonldsyliusadminshippingmethodindex = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.String,
    configuration: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingMethodRulejsonldsyliusadminshippingmethodindex' });
export type ShippingMethodRulejsonldsyliusadminshippingmethodindex = Schema.Schema.Type<
  typeof ShippingMethodRulejsonldsyliusadminshippingmethodindex
>;
export type ShippingMethodRulejsonldsyliusadminshippingmethodindexEncoded = Schema.Codec.Encoded<
  typeof ShippingMethodRulejsonldsyliusadminshippingmethodindex
>;

/* ShippingMethodRulejsonldsyliusadminshippingmethodshow */

export const ShippingMethodRulejsonldsyliusadminshippingmethodshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.String,
    configuration: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingMethodRulejsonldsyliusadminshippingmethodshow' });
export type ShippingMethodRulejsonldsyliusadminshippingmethodshow = Schema.Schema.Type<
  typeof ShippingMethodRulejsonldsyliusadminshippingmethodshow
>;
export type ShippingMethodRulejsonldsyliusadminshippingmethodshowEncoded = Schema.Codec.Encoded<
  typeof ShippingMethodRulejsonldsyliusadminshippingmethodshow
>;

/* ShippingMethodRulejsonldsyliusadminshippingmethodupdate */

export const ShippingMethodRulejsonldsyliusadminshippingmethodupdate = Schema.StructWithRest(
  Schema.Struct({
    type: Schema.String,
    configuration: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingMethodRulejsonldsyliusadminshippingmethodupdate' });
export type ShippingMethodRulejsonldsyliusadminshippingmethodupdate = Schema.Schema.Type<
  typeof ShippingMethodRulejsonldsyliusadminshippingmethodupdate
>;
export type ShippingMethodRulejsonldsyliusadminshippingmethodupdateEncoded = Schema.Codec.Encoded<
  typeof ShippingMethodRulejsonldsyliusadminshippingmethodupdate
>;

/* ShippingMethodjsonldsyliusshopshippingmethodindex */

export const ShippingMethodjsonldsyliusshopshippingmethodindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    name: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
    price: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingMethodjsonldsyliusshopshippingmethodindex' });
export type ShippingMethodjsonldsyliusshopshippingmethodindex = Schema.Schema.Type<
  typeof ShippingMethodjsonldsyliusshopshippingmethodindex
>;
export type ShippingMethodjsonldsyliusshopshippingmethodindexEncoded = Schema.Codec.Encoded<
  typeof ShippingMethodjsonldsyliusshopshippingmethodindex
>;

/* ShippingMethodjsonldsyliusshopshippingmethodshow */

export const ShippingMethodjsonldsyliusshopshippingmethodshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    name: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
    price: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingMethodjsonldsyliusshopshippingmethodshow' });
export type ShippingMethodjsonldsyliusshopshippingmethodshow = Schema.Schema.Type<
  typeof ShippingMethodjsonldsyliusshopshippingmethodshow
>;
export type ShippingMethodjsonldsyliusshopshippingmethodshowEncoded = Schema.Codec.Encoded<
  typeof ShippingMethodjsonldsyliusshopshippingmethodshow
>;

/* PaymentMethodsyliusshopshippingandpaymentoptionsindex */

export const PaymentMethodsyliusshopshippingandpaymentoptionsindex = Schema.Struct({
  name: Schema.optionalKey(Schema.Union([Schema.String, Schema.Null])),
  code: Schema.optionalKey(Schema.Union([Schema.String, Schema.Null])),
  image: Schema.optionalKey(
    Schema.Union([
      Schema.StructWithRest(
        Schema.Struct({
          pathAbstract: Schema.optionalKey(Schema.Union([Schema.String, Schema.Null])),
        }),
        [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
      ),
      Schema.Null,
    ])
  ),
}).annotate({ identifier: 'PaymentMethodsyliusshopshippingandpaymentoptionsindex' });
export type PaymentMethodsyliusshopshippingandpaymentoptionsindex = Schema.Schema.Type<
  typeof PaymentMethodsyliusshopshippingandpaymentoptionsindex
>;
export type PaymentMethodsyliusshopshippingandpaymentoptionsindexEncoded = Schema.Codec.Encoded<
  typeof PaymentMethodsyliusshopshippingandpaymentoptionsindex
>;

/* Currencysyliusshopshippingandpaymentoptionsindex */

export const Currencysyliusshopshippingandpaymentoptionsindex = Schema.Struct({
  code: Schema.optionalKey(Schema.Union([Schema.String, Schema.Null])),
}).annotate({ identifier: 'Currencysyliusshopshippingandpaymentoptionsindex' });
export type Currencysyliusshopshippingandpaymentoptionsindex = Schema.Schema.Type<
  typeof Currencysyliusshopshippingandpaymentoptionsindex
>;
export type CurrencysyliusshopshippingandpaymentoptionsindexEncoded = Schema.Codec.Encoded<
  typeof Currencysyliusshopshippingandpaymentoptionsindex
>;

/* SuggestHit */

export const SuggestHit = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.String,
    label: Schema.String,
    routerUrl: Schema.String,
    imagePath: Schema.Union([Schema.String, Schema.Null]),
    price: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'SuggestHit' });
export type SuggestHit = Schema.Schema.Type<typeof SuggestHit>;
export type SuggestHitEncoded = Schema.Codec.Encoded<typeof SuggestHit>;

/* SuggestHitjsonld */

export const SuggestHitjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.String,
    label: Schema.String,
    routerUrl: Schema.String,
    imagePath: Schema.Union([Schema.String, Schema.Null]),
    price: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'SuggestHitjsonld' });
export type SuggestHitjsonld = Schema.Schema.Type<typeof SuggestHitjsonld>;
export type SuggestHitjsonldEncoded = Schema.Codec.Encoded<typeof SuggestHitjsonld>;

/* Tagsyliusshoptagindex */

export const Tagsyliusshoptagindex = Schema.StructWithRest(
  Schema.Struct({
    color: Schema.Union([Schema.String, Schema.Null]),
    favourite: Schema.Boolean.annotate({ default: false }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Tagsyliusshoptagindex' });
export type Tagsyliusshoptagindex = Schema.Schema.Type<typeof Tagsyliusshoptagindex>;
export type TagsyliusshoptagindexEncoded = Schema.Codec.Encoded<typeof Tagsyliusshoptagindex>;

/* Tagjsonldsyliusshoptagindex */

export const Tagjsonldsyliusshoptagindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    color: Schema.Union([Schema.String, Schema.Null]),
    favourite: Schema.Boolean.annotate({ default: false }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Tagjsonldsyliusshoptagindex' });
export type Tagjsonldsyliusshoptagindex = Schema.Schema.Type<typeof Tagjsonldsyliusshoptagindex>;
export type TagjsonldsyliusshoptagindexEncoded = Schema.Codec.Encoded<
  typeof Tagjsonldsyliusshoptagindex
>;

/* TaxCategorysyliusadmintaxcategorycreate */

export const TaxCategorysyliusadmintaxcategorycreate = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ).check(
      Schema.isPattern(new RegExp('^([\\w-]*)$')).annotate({
        expected: 'a string matching the RegExp ^([\\w-]*)$',
      })
    ),
    name: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    description: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TaxCategorysyliusadmintaxcategorycreate' });
export type TaxCategorysyliusadmintaxcategorycreate = Schema.Schema.Type<
  typeof TaxCategorysyliusadmintaxcategorycreate
>;
export type TaxCategorysyliusadmintaxcategorycreateEncoded = Schema.Codec.Encoded<
  typeof TaxCategorysyliusadmintaxcategorycreate
>;

/* TaxCategorysyliusadmintaxcategoryupdate */

export const TaxCategorysyliusadmintaxcategoryupdate = Schema.StructWithRest(
  Schema.Struct({
    name: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    description: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TaxCategorysyliusadmintaxcategoryupdate' });
export type TaxCategorysyliusadmintaxcategoryupdate = Schema.Schema.Type<
  typeof TaxCategorysyliusadmintaxcategoryupdate
>;
export type TaxCategorysyliusadmintaxcategoryupdateEncoded = Schema.Codec.Encoded<
  typeof TaxCategorysyliusadmintaxcategoryupdate
>;

/* TaxCategoryjsonldsyliusadmintaxcategorycreate */

export const TaxCategoryjsonldsyliusadmintaxcategorycreate = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ).check(
      Schema.isPattern(new RegExp('^([\\w-]*)$')).annotate({
        expected: 'a string matching the RegExp ^([\\w-]*)$',
      })
    ),
    name: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    description: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TaxCategoryjsonldsyliusadmintaxcategorycreate' });
export type TaxCategoryjsonldsyliusadmintaxcategorycreate = Schema.Schema.Type<
  typeof TaxCategoryjsonldsyliusadmintaxcategorycreate
>;
export type TaxCategoryjsonldsyliusadmintaxcategorycreateEncoded = Schema.Codec.Encoded<
  typeof TaxCategoryjsonldsyliusadmintaxcategorycreate
>;

/* TaxCategoryjsonldsyliusadmintaxcategoryupdate */

export const TaxCategoryjsonldsyliusadmintaxcategoryupdate = Schema.StructWithRest(
  Schema.Struct({
    name: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    description: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TaxCategoryjsonldsyliusadmintaxcategoryupdate' });
export type TaxCategoryjsonldsyliusadmintaxcategoryupdate = Schema.Schema.Type<
  typeof TaxCategoryjsonldsyliusadmintaxcategoryupdate
>;
export type TaxCategoryjsonldsyliusadmintaxcategoryupdateEncoded = Schema.Codec.Encoded<
  typeof TaxCategoryjsonldsyliusadmintaxcategoryupdate
>;

/* Taxonsyliusadmintaxonimageshow */

export const Taxonsyliusadmintaxonimageshow = Schema.StructWithRest(
  Schema.Struct({
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonsyliusadmintaxonimageshow' });
export type Taxonsyliusadmintaxonimageshow = Schema.Schema.Type<
  typeof Taxonsyliusadmintaxonimageshow
>;
export type TaxonsyliusadmintaxonimageshowEncoded = Schema.Codec.Encoded<
  typeof Taxonsyliusadmintaxonimageshow
>;

/* TaxonImagesyliusshoptaxonmenu */

export const TaxonImagesyliusshoptaxonmenu = Schema.StructWithRest(
  Schema.Struct({
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TaxonImagesyliusshoptaxonmenu' });
export type TaxonImagesyliusshoptaxonmenu = Schema.Schema.Type<
  typeof TaxonImagesyliusshoptaxonmenu
>;
export type TaxonImagesyliusshoptaxonmenuEncoded = Schema.Codec.Encoded<
  typeof TaxonImagesyliusshoptaxonmenu
>;

/* TaxonImagesyliusshoptaxonshow */

export const TaxonImagesyliusshoptaxonshow = Schema.StructWithRest(
  Schema.Struct({
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TaxonImagesyliusshoptaxonshow' });
export type TaxonImagesyliusshoptaxonshow = Schema.Schema.Type<
  typeof TaxonImagesyliusshoptaxonshow
>;
export type TaxonImagesyliusshoptaxonshowEncoded = Schema.Codec.Encoded<
  typeof TaxonImagesyliusshoptaxonshow
>;

/* TaxonImagesyliusshoptaxontree */

export const TaxonImagesyliusshoptaxontree = Schema.StructWithRest(
  Schema.Struct({
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TaxonImagesyliusshoptaxontree' });
export type TaxonImagesyliusshoptaxontree = Schema.Schema.Type<
  typeof TaxonImagesyliusshoptaxontree
>;
export type TaxonImagesyliusshoptaxontreeEncoded = Schema.Codec.Encoded<
  typeof TaxonImagesyliusshoptaxontree
>;

/* Taxonsyliusshoptaxontreebranch */

export const Taxonsyliusshoptaxontreebranch = Schema.StructWithRest(
  Schema.Struct({
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonsyliusshoptaxontreebranch' });
export type Taxonsyliusshoptaxontreebranch = Schema.Schema.Type<
  typeof Taxonsyliusshoptaxontreebranch
>;
export type TaxonsyliusshoptaxontreebranchEncoded = Schema.Codec.Encoded<
  typeof Taxonsyliusshoptaxontreebranch
>;

/* Taxonsyliusshoptaxontreepath */

export const Taxonsyliusshoptaxontreepath = Schema.StructWithRest(
  Schema.Struct({
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonsyliusshoptaxontreepath' });
export type Taxonsyliusshoptaxontreepath = Schema.Schema.Type<typeof Taxonsyliusshoptaxontreepath>;
export type TaxonsyliusshoptaxontreepathEncoded = Schema.Codec.Encoded<
  typeof Taxonsyliusshoptaxontreepath
>;

/* Taxonjsonldsyliusadmintaxonimageshow */

export const Taxonjsonldsyliusadmintaxonimageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonjsonldsyliusadmintaxonimageshow' });
export type Taxonjsonldsyliusadmintaxonimageshow = Schema.Schema.Type<
  typeof Taxonjsonldsyliusadmintaxonimageshow
>;
export type TaxonjsonldsyliusadmintaxonimageshowEncoded = Schema.Codec.Encoded<
  typeof Taxonjsonldsyliusadmintaxonimageshow
>;

/* TaxonImagejsonldsyliusshoptaxonmenu */

export const TaxonImagejsonldsyliusshoptaxonmenu = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TaxonImagejsonldsyliusshoptaxonmenu' });
export type TaxonImagejsonldsyliusshoptaxonmenu = Schema.Schema.Type<
  typeof TaxonImagejsonldsyliusshoptaxonmenu
>;
export type TaxonImagejsonldsyliusshoptaxonmenuEncoded = Schema.Codec.Encoded<
  typeof TaxonImagejsonldsyliusshoptaxonmenu
>;

/* TaxonImagejsonldsyliusshoptaxonshow */

export const TaxonImagejsonldsyliusshoptaxonshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TaxonImagejsonldsyliusshoptaxonshow' });
export type TaxonImagejsonldsyliusshoptaxonshow = Schema.Schema.Type<
  typeof TaxonImagejsonldsyliusshoptaxonshow
>;
export type TaxonImagejsonldsyliusshoptaxonshowEncoded = Schema.Codec.Encoded<
  typeof TaxonImagejsonldsyliusshoptaxonshow
>;

/* TaxonImagejsonldsyliusshoptaxontree */

export const TaxonImagejsonldsyliusshoptaxontree = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TaxonImagejsonldsyliusshoptaxontree' });
export type TaxonImagejsonldsyliusshoptaxontree = Schema.Schema.Type<
  typeof TaxonImagejsonldsyliusshoptaxontree
>;
export type TaxonImagejsonldsyliusshoptaxontreeEncoded = Schema.Codec.Encoded<
  typeof TaxonImagejsonldsyliusshoptaxontree
>;

/* Taxonjsonldsyliusshoptaxontreebranch */

export const Taxonjsonldsyliusshoptaxontreebranch = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonjsonldsyliusshoptaxontreebranch' });
export type Taxonjsonldsyliusshoptaxontreebranch = Schema.Schema.Type<
  typeof Taxonjsonldsyliusshoptaxontreebranch
>;
export type TaxonjsonldsyliusshoptaxontreebranchEncoded = Schema.Codec.Encoded<
  typeof Taxonjsonldsyliusshoptaxontreebranch
>;

/* Taxonjsonldsyliusshoptaxontreepath */

export const Taxonjsonldsyliusshoptaxontreepath = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonjsonldsyliusshoptaxontreepath' });
export type Taxonjsonldsyliusshoptaxontreepath = Schema.Schema.Type<
  typeof Taxonjsonldsyliusshoptaxontreepath
>;
export type TaxonjsonldsyliusshoptaxontreepathEncoded = Schema.Codec.Encoded<
  typeof Taxonjsonldsyliusshoptaxontreepath
>;

/* TaxonImagesyliusadmintaxonimageindex */

export const TaxonImagesyliusadmintaxonimageindex = Schema.Record(
  Schema.String,
  Schema.Json.annotate({ expected: 'JSON value' })
).annotate({ identifier: 'TaxonImagesyliusadmintaxonimageindex' });
export type TaxonImagesyliusadmintaxonimageindex = Schema.Schema.Type<
  typeof TaxonImagesyliusadmintaxonimageindex
>;
export type TaxonImagesyliusadmintaxonimageindexEncoded = Schema.Codec.Encoded<
  typeof TaxonImagesyliusadmintaxonimageindex
>;

/* TaxonImagesyliusadmintaxonimageshow */

export const TaxonImagesyliusadmintaxonimageshow = Schema.Record(
  Schema.String,
  Schema.Json.annotate({ expected: 'JSON value' })
).annotate({ identifier: 'TaxonImagesyliusadmintaxonimageshow' });
export type TaxonImagesyliusadmintaxonimageshow = Schema.Schema.Type<
  typeof TaxonImagesyliusadmintaxonimageshow
>;
export type TaxonImagesyliusadmintaxonimageshowEncoded = Schema.Codec.Encoded<
  typeof TaxonImagesyliusadmintaxonimageshow
>;

/* TaxonImagesyliusadmintaxonimageupdate */

export const TaxonImagesyliusadmintaxonimageupdate = Schema.Record(
  Schema.String,
  Schema.Json.annotate({ expected: 'JSON value' })
).annotate({ identifier: 'TaxonImagesyliusadmintaxonimageupdate' });
export type TaxonImagesyliusadmintaxonimageupdate = Schema.Schema.Type<
  typeof TaxonImagesyliusadmintaxonimageupdate
>;
export type TaxonImagesyliusadmintaxonimageupdateEncoded = Schema.Codec.Encoded<
  typeof TaxonImagesyliusadmintaxonimageupdate
>;

/* TaxonImagesyliusshoptaxonimageindex */

export const TaxonImagesyliusshoptaxonimageindex = Schema.Record(
  Schema.String,
  Schema.Json.annotate({ expected: 'JSON value' })
).annotate({ identifier: 'TaxonImagesyliusshoptaxonimageindex' });
export type TaxonImagesyliusshoptaxonimageindex = Schema.Schema.Type<
  typeof TaxonImagesyliusshoptaxonimageindex
>;
export type TaxonImagesyliusshoptaxonimageindexEncoded = Schema.Codec.Encoded<
  typeof TaxonImagesyliusshoptaxonimageindex
>;

/* TaxonImagesyliusshoptaxonimageshow */

export const TaxonImagesyliusshoptaxonimageshow = Schema.Record(
  Schema.String,
  Schema.Json.annotate({ expected: 'JSON value' })
).annotate({ identifier: 'TaxonImagesyliusshoptaxonimageshow' });
export type TaxonImagesyliusshoptaxonimageshow = Schema.Schema.Type<
  typeof TaxonImagesyliusshoptaxonimageshow
>;
export type TaxonImagesyliusshoptaxonimageshowEncoded = Schema.Codec.Encoded<
  typeof TaxonImagesyliusshoptaxonimageshow
>;

/* TaxonImagejsonldsyliusadmintaxonimageindex */

export const TaxonImagejsonldsyliusadmintaxonimageindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TaxonImagejsonldsyliusadmintaxonimageindex' });
export type TaxonImagejsonldsyliusadmintaxonimageindex = Schema.Schema.Type<
  typeof TaxonImagejsonldsyliusadmintaxonimageindex
>;
export type TaxonImagejsonldsyliusadmintaxonimageindexEncoded = Schema.Codec.Encoded<
  typeof TaxonImagejsonldsyliusadmintaxonimageindex
>;

/* TaxonImagejsonldsyliusadmintaxonimageshow */

export const TaxonImagejsonldsyliusadmintaxonimageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TaxonImagejsonldsyliusadmintaxonimageshow' });
export type TaxonImagejsonldsyliusadmintaxonimageshow = Schema.Schema.Type<
  typeof TaxonImagejsonldsyliusadmintaxonimageshow
>;
export type TaxonImagejsonldsyliusadmintaxonimageshowEncoded = Schema.Codec.Encoded<
  typeof TaxonImagejsonldsyliusadmintaxonimageshow
>;

/* TaxonImagejsonldsyliusadmintaxonimageupdate */

export const TaxonImagejsonldsyliusadmintaxonimageupdate = Schema.Record(
  Schema.String,
  Schema.Json.annotate({ expected: 'JSON value' })
).annotate({ identifier: 'TaxonImagejsonldsyliusadmintaxonimageupdate' });
export type TaxonImagejsonldsyliusadmintaxonimageupdate = Schema.Schema.Type<
  typeof TaxonImagejsonldsyliusadmintaxonimageupdate
>;
export type TaxonImagejsonldsyliusadmintaxonimageupdateEncoded = Schema.Codec.Encoded<
  typeof TaxonImagejsonldsyliusadmintaxonimageupdate
>;

/* TaxonImagejsonldsyliusshoptaxonimageindex */

export const TaxonImagejsonldsyliusshoptaxonimageindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TaxonImagejsonldsyliusshoptaxonimageindex' });
export type TaxonImagejsonldsyliusshoptaxonimageindex = Schema.Schema.Type<
  typeof TaxonImagejsonldsyliusshoptaxonimageindex
>;
export type TaxonImagejsonldsyliusshoptaxonimageindexEncoded = Schema.Codec.Encoded<
  typeof TaxonImagejsonldsyliusshoptaxonimageindex
>;

/* TaxonImagejsonldsyliusshoptaxonimageshow */

export const TaxonImagejsonldsyliusshoptaxonimageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TaxonImagejsonldsyliusshoptaxonimageshow' });
export type TaxonImagejsonldsyliusshoptaxonimageshow = Schema.Schema.Type<
  typeof TaxonImagejsonldsyliusshoptaxonimageshow
>;
export type TaxonImagejsonldsyliusshoptaxonimageshowEncoded = Schema.Codec.Encoded<
  typeof TaxonImagejsonldsyliusshoptaxonimageshow
>;

/* UrlConstructroutershow */

export const UrlConstructroutershow = Schema.StructWithRest(
  Schema.Struct({
    relativeUrl: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    absoluteUrl: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    canonicalUrl: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'UrlConstructroutershow' });
export type UrlConstructroutershow = Schema.Schema.Type<typeof UrlConstructroutershow>;
export type UrlConstructroutershowEncoded = Schema.Codec.Encoded<typeof UrlConstructroutershow>;

/* UrlConstructjsonldroutershow */

export const UrlConstructjsonldroutershow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    relativeUrl: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    absoluteUrl: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    canonicalUrl: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'UrlConstructjsonldroutershow' });
export type UrlConstructjsonldroutershow = Schema.Schema.Type<typeof UrlConstructjsonldroutershow>;
export type UrlConstructjsonldroutershowEncoded = Schema.Codec.Encoded<
  typeof UrlConstructjsonldroutershow
>;

/* VerifyShopUsersyliusshopshopuserverificationupdatejsonMergePatch */

export const VerifyShopUsersyliusshopshopuserverificationupdatejsonMergePatch = Schema.Record(
  Schema.String,
  Schema.Json.annotate({ expected: 'JSON value' })
).annotate({ identifier: 'VerifyShopUsersyliusshopshopuserverificationupdatejsonMergePatch' });
export type VerifyShopUsersyliusshopshopuserverificationupdatejsonMergePatch = Schema.Schema.Type<
  typeof VerifyShopUsersyliusshopshopuserverificationupdatejsonMergePatch
>;
export type VerifyShopUsersyliusshopshopuserverificationupdatejsonMergePatchEncoded =
  Schema.Codec.Encoded<typeof VerifyShopUsersyliusshopshopuserverificationupdatejsonMergePatch>;

/* VerifyShopUserRequestShopUserVerificationsyliusshopshopuserverificationcreate */

export const VerifyShopUserRequestShopUserVerificationsyliusshopshopuserverificationcreate =
  Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })).annotate({
    identifier: 'VerifyShopUserRequestShopUserVerificationsyliusshopshopuserverificationcreate',
  });
export type VerifyShopUserRequestShopUserVerificationsyliusshopshopuserverificationcreate =
  Schema.Schema.Type<
    typeof VerifyShopUserRequestShopUserVerificationsyliusshopshopuserverificationcreate
  >;
export type VerifyShopUserRequestShopUserVerificationsyliusshopshopuserverificationcreateEncoded =
  Schema.Codec.Encoded<
    typeof VerifyShopUserRequestShopUserVerificationsyliusshopshopuserverificationcreate
  >;

/* VerifyShopUserRequestShopUserVerificationjsonldsyliusshopshopuserverificationcreate */

export const VerifyShopUserRequestShopUserVerificationjsonldsyliusshopshopuserverificationcreate =
  Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })).annotate({
    identifier:
      'VerifyShopUserRequestShopUserVerificationjsonldsyliusshopshopuserverificationcreate',
  });
export type VerifyShopUserRequestShopUserVerificationjsonldsyliusshopshopuserverificationcreate =
  Schema.Schema.Type<
    typeof VerifyShopUserRequestShopUserVerificationjsonldsyliusshopshopuserverificationcreate
  >;
export type VerifyShopUserRequestShopUserVerificationjsonldsyliusshopshopuserverificationcreateEncoded =
  Schema.Codec.Encoded<
    typeof VerifyShopUserRequestShopUserVerificationjsonldsyliusshopshopuserverificationcreate
  >;

/* ZoneMembersyliusadminzonecreatenoid */

export const ZoneMembersyliusadminzonecreatenoid = Schema.StructWithRest(
  Schema.Struct({ code: Schema.String }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ZoneMembersyliusadminzonecreatenoid' });
export type ZoneMembersyliusadminzonecreatenoid = Schema.Schema.Type<
  typeof ZoneMembersyliusadminzonecreatenoid
>;
export type ZoneMembersyliusadminzonecreatenoidEncoded = Schema.Codec.Encoded<
  typeof ZoneMembersyliusadminzonecreatenoid
>;

/* ZoneMembersyliusadminzoneindexnoid */

export const ZoneMembersyliusadminzoneindexnoid = Schema.StructWithRest(
  Schema.Struct({ code: Schema.String }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ZoneMembersyliusadminzoneindexnoid' });
export type ZoneMembersyliusadminzoneindexnoid = Schema.Schema.Type<
  typeof ZoneMembersyliusadminzoneindexnoid
>;
export type ZoneMembersyliusadminzoneindexnoidEncoded = Schema.Codec.Encoded<
  typeof ZoneMembersyliusadminzoneindexnoid
>;

/* ZoneMembersyliusadminzoneshownoid */

export const ZoneMembersyliusadminzoneshownoid = Schema.StructWithRest(
  Schema.Struct({ code: Schema.String }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ZoneMembersyliusadminzoneshownoid' });
export type ZoneMembersyliusadminzoneshownoid = Schema.Schema.Type<
  typeof ZoneMembersyliusadminzoneshownoid
>;
export type ZoneMembersyliusadminzoneshownoidEncoded = Schema.Codec.Encoded<
  typeof ZoneMembersyliusadminzoneshownoid
>;

/* ZoneMembersyliusadminzoneupdatenoid */

export const ZoneMembersyliusadminzoneupdatenoid = Schema.StructWithRest(
  Schema.Struct({ code: Schema.String }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ZoneMembersyliusadminzoneupdatenoid' });
export type ZoneMembersyliusadminzoneupdatenoid = Schema.Schema.Type<
  typeof ZoneMembersyliusadminzoneupdatenoid
>;
export type ZoneMembersyliusadminzoneupdatenoidEncoded = Schema.Codec.Encoded<
  typeof ZoneMembersyliusadminzoneupdatenoid
>;

/* ZoneMemberjsonldsyliusadminzonecreatenoid */

export const ZoneMemberjsonldsyliusadminzonecreatenoid = Schema.StructWithRest(
  Schema.Struct({ code: Schema.String }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ZoneMemberjsonldsyliusadminzonecreatenoid' });
export type ZoneMemberjsonldsyliusadminzonecreatenoid = Schema.Schema.Type<
  typeof ZoneMemberjsonldsyliusadminzonecreatenoid
>;
export type ZoneMemberjsonldsyliusadminzonecreatenoidEncoded = Schema.Codec.Encoded<
  typeof ZoneMemberjsonldsyliusadminzonecreatenoid
>;

/* ZoneMemberjsonldsyliusadminzoneindexnoid */

export const ZoneMemberjsonldsyliusadminzoneindexnoid = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ZoneMemberjsonldsyliusadminzoneindexnoid' });
export type ZoneMemberjsonldsyliusadminzoneindexnoid = Schema.Schema.Type<
  typeof ZoneMemberjsonldsyliusadminzoneindexnoid
>;
export type ZoneMemberjsonldsyliusadminzoneindexnoidEncoded = Schema.Codec.Encoded<
  typeof ZoneMemberjsonldsyliusadminzoneindexnoid
>;

/* ZoneMemberjsonldsyliusadminzoneshownoid */

export const ZoneMemberjsonldsyliusadminzoneshownoid = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ZoneMemberjsonldsyliusadminzoneshownoid' });
export type ZoneMemberjsonldsyliusadminzoneshownoid = Schema.Schema.Type<
  typeof ZoneMemberjsonldsyliusadminzoneshownoid
>;
export type ZoneMemberjsonldsyliusadminzoneshownoidEncoded = Schema.Codec.Encoded<
  typeof ZoneMemberjsonldsyliusadminzoneshownoid
>;

/* ZoneMemberjsonldsyliusadminzoneupdatenoid */

export const ZoneMemberjsonldsyliusadminzoneupdatenoid = Schema.StructWithRest(
  Schema.Struct({ code: Schema.String }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ZoneMemberjsonldsyliusadminzoneupdatenoid' });
export type ZoneMemberjsonldsyliusadminzoneupdatenoid = Schema.Schema.Type<
  typeof ZoneMemberjsonldsyliusadminzoneupdatenoid
>;
export type ZoneMemberjsonldsyliusadminzoneupdatenoidEncoded = Schema.Codec.Encoded<
  typeof ZoneMemberjsonldsyliusadminzoneupdatenoid
>;

/* Administratoradminadministratortokenread */

export const Administratoradminadministratortokenread = Schema.StructWithRest(
  Schema.Struct({
    token: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    adminUser: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    refresh_token: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    refresh_token_expiration: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Administratoradminadministratortokenread' });
export type Administratoradminadministratortokenread = Schema.Schema.Type<
  typeof Administratoradminadministratortokenread
>;
export type AdministratoradminadministratortokenreadEncoded = Schema.Codec.Encoded<
  typeof Administratoradminadministratortokenread
>;

/* Administratoradminadministratortokenreadunauthorized */

export const Administratoradminadministratortokenreadunauthorized = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    message: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Administratoradminadministratortokenreadunauthorized' });
export type Administratoradminadministratortokenreadunauthorized = Schema.Schema.Type<
  typeof Administratoradminadministratortokenreadunauthorized
>;
export type AdministratoradminadministratortokenreadunauthorizedEncoded = Schema.Codec.Encoded<
  typeof Administratoradminadministratortokenreadunauthorized
>;

/* Administratoradminadministratortokenreadbadrequest */

export const Administratoradminadministratortokenreadbadrequest = Schema.StructWithRest(
  Schema.Struct({
    type: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    title: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    status: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    detail: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Administratoradminadministratortokenreadbadrequest' });
export type Administratoradminadministratortokenreadbadrequest = Schema.Schema.Type<
  typeof Administratoradminadministratortokenreadbadrequest
>;
export type AdministratoradminadministratortokenreadbadrequestEncoded = Schema.Codec.Encoded<
  typeof Administratoradminadministratortokenreadbadrequest
>;

/* Administratoradminadministratortokencreate */

export const Administratoradminadministratortokencreate = Schema.StructWithRest(
  Schema.Struct({
    email: Schema.optionalKey(Schema.String),
    password: Schema.optionalKey(Schema.String),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Administratoradminadministratortokencreate' });
export type Administratoradminadministratortokencreate = Schema.Schema.Type<
  typeof Administratoradminadministratortokencreate
>;
export type AdministratoradminadministratortokencreateEncoded = Schema.Codec.Encoded<
  typeof Administratoradminadministratortokencreate
>;

/* ShopUserjsonldadmincustomercreate */

export const ShopUserjsonldadmincustomercreate = Schema.Union([
  Schema.Null,
  Schema.String,
  Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
  Schema.Boolean,
  Schema.StructWithRest(
    Schema.Struct({ verified: Schema.optionalKey(Schema.Boolean.annotate({ default: false })) }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ),
  Schema.Array(Schema.Json.annotate({ expected: 'JSON value' })),
]).annotate({ identifier: 'ShopUserjsonldadmincustomercreate' });
export type ShopUserjsonldadmincustomercreate = Schema.Schema.Type<
  typeof ShopUserjsonldadmincustomercreate
>;
export type ShopUserjsonldadmincustomercreateEncoded = Schema.Codec.Encoded<
  typeof ShopUserjsonldadmincustomercreate
>;

/* ShopUserjsonldadmincustomerupdate */

export const ShopUserjsonldadmincustomerupdate = Schema.Union([
  Schema.Null,
  Schema.String,
  Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
  Schema.Boolean,
  Schema.StructWithRest(
    Schema.Struct({ verified: Schema.optionalKey(Schema.Boolean.annotate({ default: false })) }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ),
  Schema.Array(Schema.Json.annotate({ expected: 'JSON value' })),
]).annotate({ identifier: 'ShopUserjsonldadmincustomerupdate' });
export type ShopUserjsonldadmincustomerupdate = Schema.Schema.Type<
  typeof ShopUserjsonldadmincustomerupdate
>;
export type ShopUserjsonldadmincustomerupdateEncoded = Schema.Codec.Encoded<
  typeof ShopUserjsonldadmincustomerupdate
>;

/* Customeradmincustomerstatisticsread */

export const Customeradmincustomerstatisticsread = Schema.StructWithRest(
  Schema.Struct({
    perChannelsStatistics: Schema.optionalKey(
      Schema.Array(Schema.String).annotate({ readOnly: true })
    ),
    allOrdersCount: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Customeradmincustomerstatisticsread' });
export type Customeradmincustomerstatisticsread = Schema.Schema.Type<
  typeof Customeradmincustomerstatisticsread
>;
export type CustomeradmincustomerstatisticsreadEncoded = Schema.Codec.Encoded<
  typeof Customeradmincustomerstatisticsread
>;

/* Customerjsonldadmincustomerstatisticsread */

export const Customerjsonldadmincustomerstatisticsread = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    perChannelsStatistics: Schema.optionalKey(
      Schema.Array(Schema.String).annotate({ readOnly: true })
    ),
    allOrdersCount: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Customerjsonldadmincustomerstatisticsread' });
export type Customerjsonldadmincustomerstatisticsread = Schema.Schema.Type<
  typeof Customerjsonldadmincustomerstatisticsread
>;
export type CustomerjsonldadmincustomerstatisticsreadEncoded = Schema.Codec.Encoded<
  typeof Customerjsonldadmincustomerstatisticsread
>;

/* Customershopcustomertokenread */

export const Customershopcustomertokenread = Schema.StructWithRest(
  Schema.Struct({
    token: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    customer: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    refresh_token: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    refresh_token_expiration: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Customershopcustomertokenread' });
export type Customershopcustomertokenread = Schema.Schema.Type<
  typeof Customershopcustomertokenread
>;
export type CustomershopcustomertokenreadEncoded = Schema.Codec.Encoded<
  typeof Customershopcustomertokenread
>;

/* Customershopcustomertokenreadunauthorized */

export const Customershopcustomertokenreadunauthorized = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    message: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Customershopcustomertokenreadunauthorized' });
export type Customershopcustomertokenreadunauthorized = Schema.Schema.Type<
  typeof Customershopcustomertokenreadunauthorized
>;
export type CustomershopcustomertokenreadunauthorizedEncoded = Schema.Codec.Encoded<
  typeof Customershopcustomertokenreadunauthorized
>;

/* Customershopcustomertokenreadbadrequest */

export const Customershopcustomertokenreadbadrequest = Schema.StructWithRest(
  Schema.Struct({
    type: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    title: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    status: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    detail: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Customershopcustomertokenreadbadrequest' });
export type Customershopcustomertokenreadbadrequest = Schema.Schema.Type<
  typeof Customershopcustomertokenreadbadrequest
>;
export type CustomershopcustomertokenreadbadrequestEncoded = Schema.Codec.Encoded<
  typeof Customershopcustomertokenreadbadrequest
>;

/* Customershopcustomertokencreate */

export const Customershopcustomertokencreate = Schema.StructWithRest(
  Schema.Struct({
    email: Schema.optionalKey(Schema.String),
    password: Schema.optionalKey(Schema.String),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Customershopcustomertokencreate' });
export type Customershopcustomertokencreate = Schema.Schema.Type<
  typeof Customershopcustomertokencreate
>;
export type CustomershopcustomertokencreateEncoded = Schema.Codec.Encoded<
  typeof Customershopcustomertokencreate
>;

/* Administratoradminadministratortokenrefreshcreate */

export const Administratoradminadministratortokenrefreshcreate = Schema.StructWithRest(
  Schema.Struct({ refresh_token: Schema.optionalKey(Schema.String) }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Administratoradminadministratortokenrefreshcreate' });
export type Administratoradminadministratortokenrefreshcreate = Schema.Schema.Type<
  typeof Administratoradminadministratortokenrefreshcreate
>;
export type AdministratoradminadministratortokenrefreshcreateEncoded = Schema.Codec.Encoded<
  typeof Administratoradminadministratortokenrefreshcreate
>;

/* Customershopcustomertokenrefreshcreate */

export const Customershopcustomertokenrefreshcreate = Schema.StructWithRest(
  Schema.Struct({ refresh_token: Schema.optionalKey(Schema.String) }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Customershopcustomertokenrefreshcreate' });
export type Customershopcustomertokenrefreshcreate = Schema.Schema.Type<
  typeof Customershopcustomertokenrefreshcreate
>;
export type CustomershopcustomertokenrefreshcreateEncoded = Schema.Codec.Encoded<
  typeof Customershopcustomertokenrefreshcreate
>;

/* Currency */

export const Currency = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Currency' });
export type Currency = Schema.Schema.Type<typeof Currency>;
export type CurrencyEncoded = Schema.Codec.Encoded<typeof Currency>;

/* Locale */

export const Locale = Schema.StructWithRest(
  Schema.Struct({
    termsOfServicePdf: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Locale' });
export type Locale = Schema.Schema.Type<typeof Locale>;
export type LocaleEncoded = Schema.Codec.Encoded<typeof Locale>;

/* ApplicablePromotionCode */

export const ApplicablePromotionCode = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.annotate({ description: 'The promotion code.' }),
    promotedPrice: Schema.Number.annotate({
      description: 'Price after applying the promotion.',
    }).check(Schema.isInt().annotate({ expected: 'an integer' })),
    style: Schema.Literals(['none', 'clickable', 'static']),
    salePercentage: Schema.Number.check(
      Schema.isFinite().annotate({ expected: 'a finite number' })
    ),
    couponExpiresAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    couponStartsAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ApplicablePromotionCode' });
export type ApplicablePromotionCode = Schema.Schema.Type<typeof ApplicablePromotionCode>;
export type ApplicablePromotionCodeEncoded = Schema.Codec.Encoded<typeof ApplicablePromotionCode>;

/* ShippingCategory */

export const ShippingCategory = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.String,
    description: Schema.Union([Schema.String, Schema.Null]),
    createdAt: Schema.optionalKey(DateTimeSerializableFromString),
    updatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingCategory' });
export type ShippingCategory = Schema.Schema.Type<typeof ShippingCategory>;
export type ShippingCategoryEncoded = Schema.Codec.Encoded<typeof ShippingCategory>;

/* ProductAssociationType */

export const ProductAssociationType = Schema.StructWithRest(
  Schema.Struct({
    relationType: Schema.Literals(['one', 'two', 'omni']).annotate({
      description:
        'Directionality of this association type; drives the automatically maintained reciprocal associations',
      default: 'one',
    }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.Union([Schema.String, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    currentLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    fallbackLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    translation: Schema.Array(
      Schema.suspend((): Schema.Codec<TranslationInterface> => TranslationInterface)
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAssociationType' });
export type ProductAssociationType = Schema.Schema.Type<typeof ProductAssociationType>;
export type ProductAssociationTypeEncoded = Schema.Codec.Encoded<typeof ProductAssociationType>;

/* Tag */

export const Tag = Schema.StructWithRest(
  Schema.Struct({
    color: Schema.Union([Schema.String, Schema.Null]),
    favourite: Schema.Boolean.annotate({ default: false }),
    enabled: Schema.Boolean.annotate({ default: true }),
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    articles: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    createdAt: DateTimeSerializableFromString,
    updatedAt: DateTimeSerializableFromString,
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
    currentLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    fallbackLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    translation: Schema.Array(
      Schema.suspend((): Schema.Codec<TranslationInterface> => TranslationInterface)
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Tag' });
export type Tag = Schema.Schema.Type<typeof Tag>;
export type TagEncoded = Schema.Codec.Encoded<typeof Tag>;

/* Bannerjsonldsyliusshopbannerindex */

export const Bannerjsonldsyliusshopbannerindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(Schema.String.annotate({ readOnly: true, format: 'uuid' })),
    code: Schema.String.annotate({ default: '' }),
    priority: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    placement: Schema.Literals([
      'homepage',
      'category_listing_1',
      'category_listing_2',
      'category_description',
      'category_footer',
      'product_under_gallery',
      'product_main_info',
      'customer_guide',
    ]),
    imageDesktop: Schema.Union([Schema.String, Schema.Null]),
    imageTablet: Schema.Union([Schema.String, Schema.Null]),
    imageMobil: Schema.Union([Schema.String, Schema.Null]),
    url: Schema.Union([Schema.String, Schema.Null]),
    titleColor: Schema.String.annotate({ default: '#FFFFFF' }),
    descriptionColor: Schema.String.annotate({ default: '#FFFFFF' }),
    labelColor: Schema.String.annotate({ default: '#AFD816' }),
    highlightEnabled: Schema.Boolean.annotate({ default: false }),
    highlightColor: Schema.String.annotate({ default: '#000000' }),
    buttonTextColor: Schema.String.annotate({ default: '#FFFFFF' }),
    imageDesktopAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    imageTabletAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    imageMobilAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    title: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    description: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    label: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    link: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    buttonText: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    toDate: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Bannerjsonldsyliusshopbannerindex' });
export type Bannerjsonldsyliusshopbannerindex = Schema.Schema.Type<
  typeof Bannerjsonldsyliusshopbannerindex
>;
export type BannerjsonldsyliusshopbannerindexEncoded = Schema.Codec.Encoded<
  typeof Bannerjsonldsyliusshopbannerindex
>;

/* Bannersyliusshopbannerindex */

export const Bannersyliusshopbannerindex = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(Schema.String.annotate({ readOnly: true, format: 'uuid' })),
    code: Schema.String.annotate({ default: '' }),
    priority: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    placement: Schema.Literals([
      'homepage',
      'category_listing_1',
      'category_listing_2',
      'category_description',
      'category_footer',
      'product_under_gallery',
      'product_main_info',
      'customer_guide',
    ]),
    imageDesktop: Schema.Union([Schema.String, Schema.Null]),
    imageTablet: Schema.Union([Schema.String, Schema.Null]),
    imageMobil: Schema.Union([Schema.String, Schema.Null]),
    url: Schema.Union([Schema.String, Schema.Null]),
    titleColor: Schema.String.annotate({ default: '#FFFFFF' }),
    descriptionColor: Schema.String.annotate({ default: '#FFFFFF' }),
    labelColor: Schema.String.annotate({ default: '#AFD816' }),
    highlightEnabled: Schema.Boolean.annotate({ default: false }),
    highlightColor: Schema.String.annotate({ default: '#000000' }),
    buttonTextColor: Schema.String.annotate({ default: '#FFFFFF' }),
    imageDesktopAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    imageTabletAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    imageMobilAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    title: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    description: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    label: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    link: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    buttonText: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    toDate: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Bannersyliusshopbannerindex' });
export type Bannersyliusshopbannerindex = Schema.Schema.Type<typeof Bannersyliusshopbannerindex>;
export type BannersyliusshopbannerindexEncoded = Schema.Codec.Encoded<
  typeof Bannersyliusshopbannerindex
>;

/* PromotionCoupon */

export const PromotionCoupon = Schema.StructWithRest(
  Schema.Struct({
    applicablePromotionStyle: Schema.Literals(['none', 'clickable', 'static']).annotate({
      description:
        'How (and whether) the coupon is presented on eligible product pages. Column: show_on_product.',
      default: 'none',
    }),
    perCustomerUsageLimit: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    reusableFromCancelledOrders: Schema.Boolean.annotate({ default: true }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    usageLimit: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    used: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    promotion: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'iri-reference' }),
    expiresAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    promotionName: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    promotionLabel: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    showOnProduct: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    valid: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PromotionCoupon' });
export type PromotionCoupon = Schema.Schema.Type<typeof PromotionCoupon>;
export type PromotionCouponEncoded = Schema.Codec.Encoded<typeof PromotionCoupon>;

/* Addresssyliusshopcartshow */

export const Addresssyliusshopcartshow = Schema.StructWithRest(
  Schema.Struct({
    vatNumber: Schema.Union([Schema.String, Schema.Null]),
    vatValid: Schema.Boolean.annotate({ default: false }),
    vatVerified: Schema.Boolean.annotate({ default: true }),
    vatValidatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    businessId: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'IČO or similar ID for other countries',
    }),
    firstName: Schema.String,
    lastName: Schema.String,
    phoneNumber: Schema.Union([Schema.String, Schema.Null]),
    company: Schema.Union([Schema.String, Schema.Null]),
    countryCode: Schema.String,
    provinceCode: Schema.Union([Schema.String, Schema.Null]),
    provinceName: Schema.Union([Schema.String, Schema.Null]),
    street: Schema.String,
    city: Schema.String,
    postcode: Schema.String,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Addresssyliusshopcartshow' });
export type Addresssyliusshopcartshow = Schema.Schema.Type<typeof Addresssyliusshopcartshow>;
export type AddresssyliusshopcartshowEncoded = Schema.Codec.Encoded<
  typeof Addresssyliusshopcartshow
>;

/* Addresssyliusshopcartshowsyliusshopcartshowdetail */

export const Addresssyliusshopcartshowsyliusshopcartshowdetail = Schema.StructWithRest(
  Schema.Struct({
    vatNumber: Schema.Union([Schema.String, Schema.Null]),
    vatValid: Schema.Boolean.annotate({ default: false }),
    vatVerified: Schema.Boolean.annotate({ default: true }),
    vatValidatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    businessId: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'IČO or similar ID for other countries',
    }),
    firstName: Schema.String,
    lastName: Schema.String,
    phoneNumber: Schema.Union([Schema.String, Schema.Null]),
    company: Schema.Union([Schema.String, Schema.Null]),
    countryCode: Schema.String,
    provinceCode: Schema.Union([Schema.String, Schema.Null]),
    provinceName: Schema.Union([Schema.String, Schema.Null]),
    street: Schema.String,
    city: Schema.String,
    postcode: Schema.String,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Addresssyliusshopcartshowsyliusshopcartshowdetail' });
export type Addresssyliusshopcartshowsyliusshopcartshowdetail = Schema.Schema.Type<
  typeof Addresssyliusshopcartshowsyliusshopcartshowdetail
>;
export type AddresssyliusshopcartshowsyliusshopcartshowdetailEncoded = Schema.Codec.Encoded<
  typeof Addresssyliusshopcartshowsyliusshopcartshowdetail
>;

/* Addresssyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const Addresssyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      vatNumber: Schema.Union([Schema.String, Schema.Null]),
      vatValid: Schema.Boolean.annotate({ default: false }),
      vatVerified: Schema.Boolean.annotate({ default: true }),
      vatValidatedAt: Schema.optionalKey(
        Schema.Union([DateTimeSerializableFromString, Schema.Null])
      ),
      businessId: Schema.Union([Schema.String, Schema.Null]).annotate({
        description: 'IČO or similar ID for other countries',
      }),
      firstName: Schema.String,
      lastName: Schema.String,
      phoneNumber: Schema.Union([Schema.String, Schema.Null]),
      company: Schema.Union([Schema.String, Schema.Null]),
      countryCode: Schema.String,
      provinceCode: Schema.Union([Schema.String, Schema.Null]),
      provinceName: Schema.Union([Schema.String, Schema.Null]),
      street: Schema.String,
      city: Schema.String,
      postcode: Schema.String,
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier: 'Addresssyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type Addresssyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof Addresssyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type AddresssyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof Addresssyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* Addresssyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const Addresssyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      vatNumber: Schema.Union([Schema.String, Schema.Null]),
      vatValid: Schema.Boolean.annotate({ default: false }),
      vatVerified: Schema.Boolean.annotate({ default: true }),
      vatValidatedAt: Schema.optionalKey(
        Schema.Union([DateTimeSerializableFromString, Schema.Null])
      ),
      businessId: Schema.Union([Schema.String, Schema.Null]).annotate({
        description: 'IČO or similar ID for other countries',
      }),
      firstName: Schema.String,
      lastName: Schema.String,
      phoneNumber: Schema.Union([Schema.String, Schema.Null]),
      company: Schema.Union([Schema.String, Schema.Null]),
      countryCode: Schema.String,
      provinceCode: Schema.Union([Schema.String, Schema.Null]),
      provinceName: Schema.Union([Schema.String, Schema.Null]),
      street: Schema.String,
      city: Schema.String,
      postcode: Schema.String,
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'Addresssyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type Addresssyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof Addresssyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type AddresssyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof Addresssyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* Currencyjsonld */

export const Currencyjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Currencyjsonld' });
export type Currencyjsonld = Schema.Schema.Type<typeof Currencyjsonld>;
export type CurrencyjsonldEncoded = Schema.Codec.Encoded<typeof Currencyjsonld>;

/* Localejsonld */

export const Localejsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    termsOfServicePdf: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Localejsonld' });
export type Localejsonld = Schema.Schema.Type<typeof Localejsonld>;
export type LocalejsonldEncoded = Schema.Codec.Encoded<typeof Localejsonld>;

/* ApplicablePromotionCodejsonld */

export const ApplicablePromotionCodejsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String.annotate({ description: 'The promotion code.' }),
    promotedPrice: Schema.Number.annotate({
      description: 'Price after applying the promotion.',
    }).check(Schema.isInt().annotate({ expected: 'an integer' })),
    style: Schema.Literals(['none', 'clickable', 'static']),
    salePercentage: Schema.Number.check(
      Schema.isFinite().annotate({ expected: 'a finite number' })
    ),
    couponExpiresAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    couponStartsAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ApplicablePromotionCodejsonld' });
export type ApplicablePromotionCodejsonld = Schema.Schema.Type<
  typeof ApplicablePromotionCodejsonld
>;
export type ApplicablePromotionCodejsonldEncoded = Schema.Codec.Encoded<
  typeof ApplicablePromotionCodejsonld
>;

/* ShippingCategoryjsonld */

export const ShippingCategoryjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.String,
    description: Schema.Union([Schema.String, Schema.Null]),
    createdAt: Schema.optionalKey(DateTimeSerializableFromString),
    updatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingCategoryjsonld' });
export type ShippingCategoryjsonld = Schema.Schema.Type<typeof ShippingCategoryjsonld>;
export type ShippingCategoryjsonldEncoded = Schema.Codec.Encoded<typeof ShippingCategoryjsonld>;

/* ProductAssociationTypejsonld */

export const ProductAssociationTypejsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    relationType: Schema.Literals(['one', 'two', 'omni']).annotate({
      description:
        'Directionality of this association type; drives the automatically maintained reciprocal associations',
      default: 'one',
    }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.Union([Schema.String, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    currentLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    fallbackLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    translation: Schema.Array(
      Schema.suspend((): Schema.Codec<TranslationInterfacejsonld> => TranslationInterfacejsonld)
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAssociationTypejsonld' });
export type ProductAssociationTypejsonld = Schema.Schema.Type<typeof ProductAssociationTypejsonld>;
export type ProductAssociationTypejsonldEncoded = Schema.Codec.Encoded<
  typeof ProductAssociationTypejsonld
>;

/* Tagjsonld */

export const Tagjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    color: Schema.Union([Schema.String, Schema.Null]),
    favourite: Schema.Boolean.annotate({ default: false }),
    enabled: Schema.Boolean.annotate({ default: true }),
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    articles: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    createdAt: DateTimeSerializableFromString,
    updatedAt: DateTimeSerializableFromString,
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
    currentLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    fallbackLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    translation: Schema.Array(
      Schema.suspend((): Schema.Codec<TranslationInterfacejsonld> => TranslationInterfacejsonld)
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Tagjsonld' });
export type Tagjsonld = Schema.Schema.Type<typeof Tagjsonld>;
export type TagjsonldEncoded = Schema.Codec.Encoded<typeof Tagjsonld>;

/* PromotionCouponjsonld */

export const PromotionCouponjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    applicablePromotionStyle: Schema.Literals(['none', 'clickable', 'static']).annotate({
      description:
        'How (and whether) the coupon is presented on eligible product pages. Column: show_on_product.',
      default: 'none',
    }),
    perCustomerUsageLimit: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    reusableFromCancelledOrders: Schema.Boolean.annotate({ default: true }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    usageLimit: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    used: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    promotion: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'iri-reference' }),
    expiresAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    promotionName: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    promotionLabel: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    showOnProduct: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    valid: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PromotionCouponjsonld' });
export type PromotionCouponjsonld = Schema.Schema.Type<typeof PromotionCouponjsonld>;
export type PromotionCouponjsonldEncoded = Schema.Codec.Encoded<typeof PromotionCouponjsonld>;

/* Addressjsonldsyliusshopcartshow */

export const Addressjsonldsyliusshopcartshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    vatNumber: Schema.Union([Schema.String, Schema.Null]),
    vatValid: Schema.Boolean.annotate({ default: false }),
    vatVerified: Schema.Boolean.annotate({ default: true }),
    vatValidatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    businessId: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'IČO or similar ID for other countries',
    }),
    firstName: Schema.String,
    lastName: Schema.String,
    phoneNumber: Schema.Union([Schema.String, Schema.Null]),
    company: Schema.Union([Schema.String, Schema.Null]),
    countryCode: Schema.String,
    provinceCode: Schema.Union([Schema.String, Schema.Null]),
    provinceName: Schema.Union([Schema.String, Schema.Null]),
    street: Schema.String,
    city: Schema.String,
    postcode: Schema.String,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Addressjsonldsyliusshopcartshow' });
export type Addressjsonldsyliusshopcartshow = Schema.Schema.Type<
  typeof Addressjsonldsyliusshopcartshow
>;
export type AddressjsonldsyliusshopcartshowEncoded = Schema.Codec.Encoded<
  typeof Addressjsonldsyliusshopcartshow
>;

/* Addressjsonldsyliusshopcartshowsyliusshopcartshowdetail */

export const Addressjsonldsyliusshopcartshowsyliusshopcartshowdetail = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    vatNumber: Schema.Union([Schema.String, Schema.Null]),
    vatValid: Schema.Boolean.annotate({ default: false }),
    vatVerified: Schema.Boolean.annotate({ default: true }),
    vatValidatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    businessId: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'IČO or similar ID for other countries',
    }),
    firstName: Schema.String,
    lastName: Schema.String,
    phoneNumber: Schema.Union([Schema.String, Schema.Null]),
    company: Schema.Union([Schema.String, Schema.Null]),
    countryCode: Schema.String,
    provinceCode: Schema.Union([Schema.String, Schema.Null]),
    provinceName: Schema.Union([Schema.String, Schema.Null]),
    street: Schema.String,
    city: Schema.String,
    postcode: Schema.String,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Addressjsonldsyliusshopcartshowsyliusshopcartshowdetail' });
export type Addressjsonldsyliusshopcartshowsyliusshopcartshowdetail = Schema.Schema.Type<
  typeof Addressjsonldsyliusshopcartshowsyliusshopcartshowdetail
>;
export type AddressjsonldsyliusshopcartshowsyliusshopcartshowdetailEncoded = Schema.Codec.Encoded<
  typeof Addressjsonldsyliusshopcartshowsyliusshopcartshowdetail
>;

/* Addressjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const Addressjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      vatNumber: Schema.Union([Schema.String, Schema.Null]),
      vatValid: Schema.Boolean.annotate({ default: false }),
      vatVerified: Schema.Boolean.annotate({ default: true }),
      vatValidatedAt: Schema.optionalKey(
        Schema.Union([DateTimeSerializableFromString, Schema.Null])
      ),
      businessId: Schema.Union([Schema.String, Schema.Null]).annotate({
        description: 'IČO or similar ID for other countries',
      }),
      firstName: Schema.String,
      lastName: Schema.String,
      phoneNumber: Schema.Union([Schema.String, Schema.Null]),
      company: Schema.Union([Schema.String, Schema.Null]),
      countryCode: Schema.String,
      provinceCode: Schema.Union([Schema.String, Schema.Null]),
      provinceName: Schema.Union([Schema.String, Schema.Null]),
      street: Schema.String,
      city: Schema.String,
      postcode: Schema.String,
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier: 'Addressjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type Addressjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof Addressjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type AddressjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof Addressjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* Addressjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const Addressjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      vatNumber: Schema.Union([Schema.String, Schema.Null]),
      vatValid: Schema.Boolean.annotate({ default: false }),
      vatVerified: Schema.Boolean.annotate({ default: true }),
      vatValidatedAt: Schema.optionalKey(
        Schema.Union([DateTimeSerializableFromString, Schema.Null])
      ),
      businessId: Schema.Union([Schema.String, Schema.Null]).annotate({
        description: 'IČO or similar ID for other countries',
      }),
      firstName: Schema.String,
      lastName: Schema.String,
      phoneNumber: Schema.Union([Schema.String, Schema.Null]),
      company: Schema.Union([Schema.String, Schema.Null]),
      countryCode: Schema.String,
      provinceCode: Schema.Union([Schema.String, Schema.Null]),
      provinceName: Schema.Union([Schema.String, Schema.Null]),
      street: Schema.String,
      city: Schema.String,
      postcode: Schema.String,
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'Addressjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type Addressjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof Addressjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type AddressjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof Addressjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* AddressLogEntrysyliusadminaddresslogentryshow */

export const AddressLogEntrysyliusadminaddresslogentryshow = Schema.StructWithRest(
  Schema.Struct({
    action: Schema.String,
    loggedAt: Schema.optionalKey(DateTimeSerializableFromString),
    version: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    data: Schema.Union([
      Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
      Schema.Null,
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'AddressLogEntrysyliusadminaddresslogentryshow' });
export type AddressLogEntrysyliusadminaddresslogentryshow = Schema.Schema.Type<
  typeof AddressLogEntrysyliusadminaddresslogentryshow
>;
export type AddressLogEntrysyliusadminaddresslogentryshowEncoded = Schema.Codec.Encoded<
  typeof AddressLogEntrysyliusadminaddresslogentryshow
>;

/* AddressLogEntryjsonldsyliusadminaddresslogentryshow */

export const AddressLogEntryjsonldsyliusadminaddresslogentryshow = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    action: Schema.String,
    loggedAt: Schema.optionalKey(DateTimeSerializableFromString),
    version: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    data: Schema.Union([
      Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
      Schema.Null,
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'AddressLogEntryjsonldsyliusadminaddresslogentryshow' });
export type AddressLogEntryjsonldsyliusadminaddresslogentryshow = Schema.Schema.Type<
  typeof AddressLogEntryjsonldsyliusadminaddresslogentryshow
>;
export type AddressLogEntryjsonldsyliusadminaddresslogentryshowEncoded = Schema.Codec.Encoded<
  typeof AddressLogEntryjsonldsyliusadminaddresslogentryshow
>;

/* Administratorsyliusadminadminuserindex */

export const Administratorsyliusadminadminuserindex = Schema.StructWithRest(
  Schema.Struct({
    firstName: Schema.Union([Schema.String, Schema.Null]),
    lastName: Schema.Union([Schema.String, Schema.Null]),
    localeCode: Schema.String,
    avatar: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    username: Schema.Union([Schema.String, Schema.Null]),
    lastLogin: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    verifiedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    email: Schema.Union([Schema.String, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    enabled: Schema.Boolean.annotate({ default: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Administratorsyliusadminadminuserindex' });
export type Administratorsyliusadminadminuserindex = Schema.Schema.Type<
  typeof Administratorsyliusadminadminuserindex
>;
export type AdministratorsyliusadminadminuserindexEncoded = Schema.Codec.Encoded<
  typeof Administratorsyliusadminadminuserindex
>;

/* Administratorsyliusadminadminusershow */

export const Administratorsyliusadminadminusershow = Schema.StructWithRest(
  Schema.Struct({
    firstName: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    lastName: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    localeCode: Schema.String,
    avatar: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    username: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    lastLogin: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    verifiedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    email: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'email' }),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    enabled: Schema.Boolean.annotate({ default: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Administratorsyliusadminadminusershow' });
export type Administratorsyliusadminadminusershow = Schema.Schema.Type<
  typeof Administratorsyliusadminadminusershow
>;
export type AdministratorsyliusadminadminusershowEncoded = Schema.Codec.Encoded<
  typeof Administratorsyliusadminadminusershow
>;

/* Administratorjsonldsyliusadminadminuserindex */

export const Administratorjsonldsyliusadminadminuserindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    firstName: Schema.Union([Schema.String, Schema.Null]),
    lastName: Schema.Union([Schema.String, Schema.Null]),
    localeCode: Schema.String,
    avatar: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    username: Schema.Union([Schema.String, Schema.Null]),
    lastLogin: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    verifiedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    email: Schema.Union([Schema.String, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    enabled: Schema.Boolean.annotate({ default: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Administratorjsonldsyliusadminadminuserindex' });
export type Administratorjsonldsyliusadminadminuserindex = Schema.Schema.Type<
  typeof Administratorjsonldsyliusadminadminuserindex
>;
export type AdministratorjsonldsyliusadminadminuserindexEncoded = Schema.Codec.Encoded<
  typeof Administratorjsonldsyliusadminadminuserindex
>;

/* Administratorjsonldsyliusadminadminusershow */

export const Administratorjsonldsyliusadminadminusershow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    firstName: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    lastName: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    localeCode: Schema.String,
    avatar: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    username: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    lastLogin: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    verifiedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    email: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'email' }),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    enabled: Schema.Boolean.annotate({ default: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Administratorjsonldsyliusadminadminusershow' });
export type Administratorjsonldsyliusadminadminusershow = Schema.Schema.Type<
  typeof Administratorjsonldsyliusadminadminusershow
>;
export type AdministratorjsonldsyliusadminadminusershowEncoded = Schema.Codec.Encoded<
  typeof Administratorjsonldsyliusadminadminusershow
>;

/* AlertMessagesyliusshopmessageindex */

export const AlertMessagesyliusshopmessageindex = Schema.StructWithRest(
  Schema.Struct({
    type: Schema.Literals(['base', 'warning', 'error', 'success']).annotate({ default: 'base' }),
    icon: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    name: Schema.String,
    description: Schema.Union([Schema.String, Schema.Null]),
    toDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    updatedAt: DateTimeSerializableFromString,
    link: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    buttonText: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    title: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    message: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'AlertMessagesyliusshopmessageindex' });
export type AlertMessagesyliusshopmessageindex = Schema.Schema.Type<
  typeof AlertMessagesyliusshopmessageindex
>;
export type AlertMessagesyliusshopmessageindexEncoded = Schema.Codec.Encoded<
  typeof AlertMessagesyliusshopmessageindex
>;

/* AlertMessagejsonldsyliusshopmessageindex */

export const AlertMessagejsonldsyliusshopmessageindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    type: Schema.Literals(['base', 'warning', 'error', 'success']).annotate({ default: 'base' }),
    icon: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    name: Schema.String,
    description: Schema.Union([Schema.String, Schema.Null]),
    toDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    updatedAt: DateTimeSerializableFromString,
    link: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    buttonText: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    title: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    message: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'AlertMessagejsonldsyliusshopmessageindex' });
export type AlertMessagejsonldsyliusshopmessageindex = Schema.Schema.Type<
  typeof AlertMessagejsonldsyliusshopmessageindex
>;
export type AlertMessagejsonldsyliusshopmessageindexEncoded = Schema.Codec.Encoded<
  typeof AlertMessagejsonldsyliusshopmessageindex
>;

/* ApplicablePromotionCodesyliusshopproductindex */

export const ApplicablePromotionCodesyliusshopproductindex = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.annotate({ description: 'The promotion code.' }),
    promotedPrice: Schema.Number.annotate({
      description: 'Price after applying the promotion.',
    }).check(Schema.isInt().annotate({ expected: 'an integer' })),
    style: Schema.Literals(['none', 'clickable', 'static']),
    salePercentage: Schema.Number.check(
      Schema.isFinite().annotate({ expected: 'a finite number' })
    ),
    couponExpiresAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    couponStartsAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ApplicablePromotionCodesyliusshopproductindex' });
export type ApplicablePromotionCodesyliusshopproductindex = Schema.Schema.Type<
  typeof ApplicablePromotionCodesyliusshopproductindex
>;
export type ApplicablePromotionCodesyliusshopproductindexEncoded = Schema.Codec.Encoded<
  typeof ApplicablePromotionCodesyliusshopproductindex
>;

/* ApplicablePromotionCodesyliusshopproductvariantindex */

export const ApplicablePromotionCodesyliusshopproductvariantindex = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.annotate({ description: 'The promotion code.' }),
    promotedPrice: Schema.Number.annotate({
      description: 'Price after applying the promotion.',
    }).check(Schema.isInt().annotate({ expected: 'an integer' })),
    style: Schema.Literals(['none', 'clickable', 'static']),
    salePercentage: Schema.Number.check(
      Schema.isFinite().annotate({ expected: 'a finite number' })
    ),
    couponExpiresAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    couponStartsAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ApplicablePromotionCodesyliusshopproductvariantindex' });
export type ApplicablePromotionCodesyliusshopproductvariantindex = Schema.Schema.Type<
  typeof ApplicablePromotionCodesyliusshopproductvariantindex
>;
export type ApplicablePromotionCodesyliusshopproductvariantindexEncoded = Schema.Codec.Encoded<
  typeof ApplicablePromotionCodesyliusshopproductvariantindex
>;

/* ApplicablePromotionCodesyliusshopproductvariantshow */

export const ApplicablePromotionCodesyliusshopproductvariantshow = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.annotate({ description: 'The promotion code.' }),
    promotedPrice: Schema.Number.annotate({
      description: 'Price after applying the promotion.',
    }).check(Schema.isInt().annotate({ expected: 'an integer' })),
    style: Schema.Literals(['none', 'clickable', 'static']),
    salePercentage: Schema.Number.check(
      Schema.isFinite().annotate({ expected: 'a finite number' })
    ),
    couponExpiresAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    couponStartsAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ApplicablePromotionCodesyliusshopproductvariantshow' });
export type ApplicablePromotionCodesyliusshopproductvariantshow = Schema.Schema.Type<
  typeof ApplicablePromotionCodesyliusshopproductvariantshow
>;
export type ApplicablePromotionCodesyliusshopproductvariantshowEncoded = Schema.Codec.Encoded<
  typeof ApplicablePromotionCodesyliusshopproductvariantshow
>;

/* ApplicablePromotionCodesyliusshopproductvariantshowdetail */

export const ApplicablePromotionCodesyliusshopproductvariantshowdetail = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.annotate({ description: 'The promotion code.' }),
    promotedPrice: Schema.Number.annotate({
      description: 'Price after applying the promotion.',
    }).check(Schema.isInt().annotate({ expected: 'an integer' })),
    style: Schema.Literals(['none', 'clickable', 'static']),
    salePercentage: Schema.Number.check(
      Schema.isFinite().annotate({ expected: 'a finite number' })
    ),
    couponExpiresAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    couponStartsAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ApplicablePromotionCodesyliusshopproductvariantshowdetail' });
export type ApplicablePromotionCodesyliusshopproductvariantshowdetail = Schema.Schema.Type<
  typeof ApplicablePromotionCodesyliusshopproductvariantshowdetail
>;
export type ApplicablePromotionCodesyliusshopproductvariantshowdetailEncoded = Schema.Codec.Encoded<
  typeof ApplicablePromotionCodesyliusshopproductvariantshowdetail
>;

/* ApplicablePromotionCodejsonldsyliusshopproductindex */

export const ApplicablePromotionCodejsonldsyliusshopproductindex = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String.annotate({ description: 'The promotion code.' }),
    promotedPrice: Schema.Number.annotate({
      description: 'Price after applying the promotion.',
    }).check(Schema.isInt().annotate({ expected: 'an integer' })),
    style: Schema.Literals(['none', 'clickable', 'static']),
    salePercentage: Schema.Number.check(
      Schema.isFinite().annotate({ expected: 'a finite number' })
    ),
    couponExpiresAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    couponStartsAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ApplicablePromotionCodejsonldsyliusshopproductindex' });
export type ApplicablePromotionCodejsonldsyliusshopproductindex = Schema.Schema.Type<
  typeof ApplicablePromotionCodejsonldsyliusshopproductindex
>;
export type ApplicablePromotionCodejsonldsyliusshopproductindexEncoded = Schema.Codec.Encoded<
  typeof ApplicablePromotionCodejsonldsyliusshopproductindex
>;

/* ApplicablePromotionCodejsonldsyliusshopproductvariantindex */

export const ApplicablePromotionCodejsonldsyliusshopproductvariantindex = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String.annotate({ description: 'The promotion code.' }),
    promotedPrice: Schema.Number.annotate({
      description: 'Price after applying the promotion.',
    }).check(Schema.isInt().annotate({ expected: 'an integer' })),
    style: Schema.Literals(['none', 'clickable', 'static']),
    salePercentage: Schema.Number.check(
      Schema.isFinite().annotate({ expected: 'a finite number' })
    ),
    couponExpiresAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    couponStartsAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ApplicablePromotionCodejsonldsyliusshopproductvariantindex' });
export type ApplicablePromotionCodejsonldsyliusshopproductvariantindex = Schema.Schema.Type<
  typeof ApplicablePromotionCodejsonldsyliusshopproductvariantindex
>;
export type ApplicablePromotionCodejsonldsyliusshopproductvariantindexEncoded =
  Schema.Codec.Encoded<typeof ApplicablePromotionCodejsonldsyliusshopproductvariantindex>;

/* ApplicablePromotionCodejsonldsyliusshopproductvariantshow */

export const ApplicablePromotionCodejsonldsyliusshopproductvariantshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String.annotate({ description: 'The promotion code.' }),
    promotedPrice: Schema.Number.annotate({
      description: 'Price after applying the promotion.',
    }).check(Schema.isInt().annotate({ expected: 'an integer' })),
    style: Schema.Literals(['none', 'clickable', 'static']),
    salePercentage: Schema.Number.check(
      Schema.isFinite().annotate({ expected: 'a finite number' })
    ),
    couponExpiresAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    couponStartsAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ApplicablePromotionCodejsonldsyliusshopproductvariantshow' });
export type ApplicablePromotionCodejsonldsyliusshopproductvariantshow = Schema.Schema.Type<
  typeof ApplicablePromotionCodejsonldsyliusshopproductvariantshow
>;
export type ApplicablePromotionCodejsonldsyliusshopproductvariantshowEncoded = Schema.Codec.Encoded<
  typeof ApplicablePromotionCodejsonldsyliusshopproductvariantshow
>;

/* ApplicablePromotionCodejsonldsyliusshopproductvariantshowdetail */

export const ApplicablePromotionCodejsonldsyliusshopproductvariantshowdetail =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      code: Schema.String.annotate({ description: 'The promotion code.' }),
      promotedPrice: Schema.Number.annotate({
        description: 'Price after applying the promotion.',
      }).check(Schema.isInt().annotate({ expected: 'an integer' })),
      style: Schema.Literals(['none', 'clickable', 'static']),
      salePercentage: Schema.Number.check(
        Schema.isFinite().annotate({ expected: 'a finite number' })
      ),
      couponExpiresAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
      couponStartsAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({ identifier: 'ApplicablePromotionCodejsonldsyliusshopproductvariantshowdetail' });
export type ApplicablePromotionCodejsonldsyliusshopproductvariantshowdetail = Schema.Schema.Type<
  typeof ApplicablePromotionCodejsonldsyliusshopproductvariantshowdetail
>;
export type ApplicablePromotionCodejsonldsyliusshopproductvariantshowdetailEncoded =
  Schema.Codec.Encoded<typeof ApplicablePromotionCodejsonldsyliusshopproductvariantshowdetail>;

/* Bannersyliusshophomepageshow */

export const Bannersyliusshophomepageshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(Schema.String.annotate({ readOnly: true, format: 'uuid' })),
    code: Schema.String.annotate({ default: '' }),
    priority: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    imageDesktop: Schema.Union([Schema.String, Schema.Null]),
    imageTablet: Schema.Union([Schema.String, Schema.Null]),
    imageMobil: Schema.Union([Schema.String, Schema.Null]),
    url: Schema.Union([Schema.String, Schema.Null]),
    titleColor: Schema.String.annotate({ default: '#FFFFFF' }),
    descriptionColor: Schema.String.annotate({ default: '#FFFFFF' }),
    labelColor: Schema.String.annotate({ default: '#AFD816' }),
    highlightEnabled: Schema.Boolean.annotate({ default: false }),
    highlightColor: Schema.String.annotate({ default: '#000000' }),
    buttonTextColor: Schema.String.annotate({ default: '#FFFFFF' }),
    imageDesktopAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    imageTabletAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    imageMobilAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    title: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    description: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    label: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    link: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    buttonText: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    toDate: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Bannersyliusshophomepageshow' });
export type Bannersyliusshophomepageshow = Schema.Schema.Type<typeof Bannersyliusshophomepageshow>;
export type BannersyliusshophomepageshowEncoded = Schema.Codec.Encoded<
  typeof Bannersyliusshophomepageshow
>;

/* Bannerjsonldsyliusshophomepageshow */

export const Bannerjsonldsyliusshophomepageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(Schema.String.annotate({ readOnly: true, format: 'uuid' })),
    code: Schema.String.annotate({ default: '' }),
    priority: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    imageDesktop: Schema.Union([Schema.String, Schema.Null]),
    imageTablet: Schema.Union([Schema.String, Schema.Null]),
    imageMobil: Schema.Union([Schema.String, Schema.Null]),
    url: Schema.Union([Schema.String, Schema.Null]),
    titleColor: Schema.String.annotate({ default: '#FFFFFF' }),
    descriptionColor: Schema.String.annotate({ default: '#FFFFFF' }),
    labelColor: Schema.String.annotate({ default: '#AFD816' }),
    highlightEnabled: Schema.Boolean.annotate({ default: false }),
    highlightColor: Schema.String.annotate({ default: '#000000' }),
    buttonTextColor: Schema.String.annotate({ default: '#FFFFFF' }),
    imageDesktopAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    imageTabletAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    imageMobilAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    title: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    description: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    label: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    link: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    buttonText: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    toDate: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Bannerjsonldsyliusshophomepageshow' });
export type Bannerjsonldsyliusshophomepageshow = Schema.Schema.Type<
  typeof Bannerjsonldsyliusshophomepageshow
>;
export type BannerjsonldsyliusshophomepageshowEncoded = Schema.Codec.Encoded<
  typeof Bannerjsonldsyliusshophomepageshow
>;

/* Customersyliusshopcustomerupdate */

export const Customersyliusshopcustomerupdate = Schema.StructWithRest(
  Schema.Struct({
    defaultAddress: Schema.Union([Schema.String, Schema.Null]).annotate({
      format: 'iri-reference',
    }),
    email: Schema.String.annotate({ format: 'email' }).check(
      Schema.isMaxLength(254).annotate({ expected: 'a value with a length of at most 254' })
    ),
    firstName: Schema.Union([
      Schema.String.check(
        Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
      ).check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    lastName: Schema.Union([
      Schema.String.check(
        Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
      ).check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    birthday: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    gender: Schema.Literals(['u', 'm', 'f']).annotate({ default: 'u' }),
    phoneNumber: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    subscribedToNewsletter: Schema.Boolean.annotate({ default: false }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Customersyliusshopcustomerupdate' });
export type Customersyliusshopcustomerupdate = Schema.Schema.Type<
  typeof Customersyliusshopcustomerupdate
>;
export type CustomersyliusshopcustomerupdateEncoded = Schema.Codec.Encoded<
  typeof Customersyliusshopcustomerupdate
>;

/* Customerjsonldsyliusshopcustomerupdate */

export const Customerjsonldsyliusshopcustomerupdate = Schema.StructWithRest(
  Schema.Struct({
    defaultAddress: Schema.Union([Schema.String, Schema.Null]).annotate({
      format: 'iri-reference',
    }),
    email: Schema.String.annotate({ format: 'email' }).check(
      Schema.isMaxLength(254).annotate({ expected: 'a value with a length of at most 254' })
    ),
    firstName: Schema.Union([
      Schema.String.check(
        Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
      ).check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    lastName: Schema.Union([
      Schema.String.check(
        Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
      ).check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    birthday: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    gender: Schema.Literals(['u', 'm', 'f']).annotate({ default: 'u' }),
    phoneNumber: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    subscribedToNewsletter: Schema.Boolean.annotate({ default: false }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Customerjsonldsyliusshopcustomerupdate' });
export type Customerjsonldsyliusshopcustomerupdate = Schema.Schema.Type<
  typeof Customerjsonldsyliusshopcustomerupdate
>;
export type CustomerjsonldsyliusshopcustomerupdateEncoded = Schema.Codec.Encoded<
  typeof Customerjsonldsyliusshopcustomerupdate
>;

/* HeurekaReviewsyliusshophomepageshow */

export const HeurekaReviewsyliusshophomepageshow = Schema.StructWithRest(
  Schema.Struct({
    ratingId: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    posted: DateTimeSerializableFromString,
    totalRating: Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
    text: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    customerName: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'HeurekaReviewsyliusshophomepageshow' });
export type HeurekaReviewsyliusshophomepageshow = Schema.Schema.Type<
  typeof HeurekaReviewsyliusshophomepageshow
>;
export type HeurekaReviewsyliusshophomepageshowEncoded = Schema.Codec.Encoded<
  typeof HeurekaReviewsyliusshophomepageshow
>;

/* HeurekaReviewjsonldsyliusshophomepageshow */

export const HeurekaReviewjsonldsyliusshophomepageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    ratingId: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    posted: DateTimeSerializableFromString,
    totalRating: Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
    text: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    customerName: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'HeurekaReviewjsonldsyliusshophomepageshow' });
export type HeurekaReviewjsonldsyliusshophomepageshow = Schema.Schema.Type<
  typeof HeurekaReviewjsonldsyliusshophomepageshow
>;
export type HeurekaReviewjsonldsyliusshophomepageshowEncoded = Schema.Codec.Encoded<
  typeof HeurekaReviewjsonldsyliusshophomepageshow
>;

/* PaymentRequestsyliusadminpaymentrequestshow */

export const PaymentRequestsyliusadminpaymentrequestshow = Schema.StructWithRest(
  Schema.Struct({
    hash: Schema.optionalKey(Schema.String.annotate({ readOnly: true, format: 'uuid' })),
    state: Schema.String.annotate({ default: 'new' }),
    action: Schema.String.annotate({ default: 'capture' }),
    payload: Schema.Json.annotate({ expected: 'JSON value' }),
    responseData: Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
    payment: Schema.String.annotate({ format: 'iri-reference' }),
    method: Schema.String.annotate({ format: 'iri-reference' }),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    orderToken: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PaymentRequestsyliusadminpaymentrequestshow' });
export type PaymentRequestsyliusadminpaymentrequestshow = Schema.Schema.Type<
  typeof PaymentRequestsyliusadminpaymentrequestshow
>;
export type PaymentRequestsyliusadminpaymentrequestshowEncoded = Schema.Codec.Encoded<
  typeof PaymentRequestsyliusadminpaymentrequestshow
>;

/* PaymentRequestsyliusshoppaymentrequestshow */

export const PaymentRequestsyliusshoppaymentrequestshow = Schema.StructWithRest(
  Schema.Struct({
    hash: Schema.optionalKey(Schema.String.annotate({ readOnly: true, format: 'uuid' })),
    state: Schema.String.annotate({ default: 'new' }),
    action: Schema.String.annotate({ default: 'capture' }),
    payload: Schema.Json.annotate({ expected: 'JSON value' }),
    responseData: Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
    payment: Schema.String.annotate({ format: 'iri-reference' }),
    method: Schema.String.annotate({ format: 'iri-reference' }),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    orderToken: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PaymentRequestsyliusshoppaymentrequestshow' });
export type PaymentRequestsyliusshoppaymentrequestshow = Schema.Schema.Type<
  typeof PaymentRequestsyliusshoppaymentrequestshow
>;
export type PaymentRequestsyliusshoppaymentrequestshowEncoded = Schema.Codec.Encoded<
  typeof PaymentRequestsyliusshoppaymentrequestshow
>;

/* PaymentRequestjsonldsyliusadminpaymentrequestshow */

export const PaymentRequestjsonldsyliusadminpaymentrequestshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    hash: Schema.optionalKey(Schema.String.annotate({ readOnly: true, format: 'uuid' })),
    state: Schema.String.annotate({ default: 'new' }),
    action: Schema.String.annotate({ default: 'capture' }),
    payload: Schema.Json.annotate({ expected: 'JSON value' }),
    responseData: Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
    payment: Schema.String.annotate({ format: 'iri-reference' }),
    method: Schema.String.annotate({ format: 'iri-reference' }),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    orderToken: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PaymentRequestjsonldsyliusadminpaymentrequestshow' });
export type PaymentRequestjsonldsyliusadminpaymentrequestshow = Schema.Schema.Type<
  typeof PaymentRequestjsonldsyliusadminpaymentrequestshow
>;
export type PaymentRequestjsonldsyliusadminpaymentrequestshowEncoded = Schema.Codec.Encoded<
  typeof PaymentRequestjsonldsyliusadminpaymentrequestshow
>;

/* PaymentRequestjsonldsyliusshoppaymentrequestshow */

export const PaymentRequestjsonldsyliusshoppaymentrequestshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    hash: Schema.optionalKey(Schema.String.annotate({ readOnly: true, format: 'uuid' })),
    state: Schema.String.annotate({ default: 'new' }),
    action: Schema.String.annotate({ default: 'capture' }),
    payload: Schema.Json.annotate({ expected: 'JSON value' }),
    responseData: Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
    payment: Schema.String.annotate({ format: 'iri-reference' }),
    method: Schema.String.annotate({ format: 'iri-reference' }),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    orderToken: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PaymentRequestjsonldsyliusshoppaymentrequestshow' });
export type PaymentRequestjsonldsyliusshoppaymentrequestshow = Schema.Schema.Type<
  typeof PaymentRequestjsonldsyliusshoppaymentrequestshow
>;
export type PaymentRequestjsonldsyliusshoppaymentrequestshowEncoded = Schema.Codec.Encoded<
  typeof PaymentRequestjsonldsyliusshoppaymentrequestshow
>;

/* PriceHistorysyliusshopproductvariantshowpricehistory */

export const PriceHistorysyliusshopproductvariantshowpricehistory = Schema.StructWithRest(
  Schema.Struct({
    date: DateTimeSerializableFromString,
    price: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    type: Schema.Literal('regular'),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PriceHistorysyliusshopproductvariantshowpricehistory' });
export type PriceHistorysyliusshopproductvariantshowpricehistory = Schema.Schema.Type<
  typeof PriceHistorysyliusshopproductvariantshowpricehistory
>;
export type PriceHistorysyliusshopproductvariantshowpricehistoryEncoded = Schema.Codec.Encoded<
  typeof PriceHistorysyliusshopproductvariantshowpricehistory
>;

/* PriceHistoryjsonldsyliusshopproductvariantshowpricehistory */

export const PriceHistoryjsonldsyliusshopproductvariantshowpricehistory = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    date: DateTimeSerializableFromString,
    price: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    type: Schema.Literal('regular'),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PriceHistoryjsonldsyliusshopproductvariantshowpricehistory' });
export type PriceHistoryjsonldsyliusshopproductvariantshowpricehistory = Schema.Schema.Type<
  typeof PriceHistoryjsonldsyliusshopproductvariantshowpricehistory
>;
export type PriceHistoryjsonldsyliusshopproductvariantshowpricehistoryEncoded =
  Schema.Codec.Encoded<typeof PriceHistoryjsonldsyliusshopproductvariantshowpricehistory>;

/* ProductAssociationTypesyliusadminproductassociationtypeindex */

export const ProductAssociationTypesyliusadminproductassociationtypeindex = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.Union([Schema.String, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAssociationTypesyliusadminproductassociationtypeindex' });
export type ProductAssociationTypesyliusadminproductassociationtypeindex = Schema.Schema.Type<
  typeof ProductAssociationTypesyliusadminproductassociationtypeindex
>;
export type ProductAssociationTypesyliusadminproductassociationtypeindexEncoded =
  Schema.Codec.Encoded<typeof ProductAssociationTypesyliusadminproductassociationtypeindex>;

/* ProductAssociationTypesyliusadminproductassociationtypeshow */

export const ProductAssociationTypesyliusadminproductassociationtypeshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.Union([Schema.String, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAssociationTypesyliusadminproductassociationtypeshow' });
export type ProductAssociationTypesyliusadminproductassociationtypeshow = Schema.Schema.Type<
  typeof ProductAssociationTypesyliusadminproductassociationtypeshow
>;
export type ProductAssociationTypesyliusadminproductassociationtypeshowEncoded =
  Schema.Codec.Encoded<typeof ProductAssociationTypesyliusadminproductassociationtypeshow>;

/* ProductAssociationTypejsonldsyliusadminproductassociationtypeindex */

export const ProductAssociationTypejsonldsyliusadminproductassociationtypeindex =
  Schema.StructWithRest(
    Schema.Struct({
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      id: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      code: Schema.String,
      name: Schema.Union([Schema.String, Schema.Null]),
      createdAt: DateTimeSerializableFromString,
      updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
      translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({ identifier: 'ProductAssociationTypejsonldsyliusadminproductassociationtypeindex' });
export type ProductAssociationTypejsonldsyliusadminproductassociationtypeindex = Schema.Schema.Type<
  typeof ProductAssociationTypejsonldsyliusadminproductassociationtypeindex
>;
export type ProductAssociationTypejsonldsyliusadminproductassociationtypeindexEncoded =
  Schema.Codec.Encoded<typeof ProductAssociationTypejsonldsyliusadminproductassociationtypeindex>;

/* ProductAssociationTypejsonldsyliusadminproductassociationtypeshow */

export const ProductAssociationTypejsonldsyliusadminproductassociationtypeshow =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      id: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      code: Schema.String,
      name: Schema.Union([Schema.String, Schema.Null]),
      createdAt: DateTimeSerializableFromString,
      updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
      translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({ identifier: 'ProductAssociationTypejsonldsyliusadminproductassociationtypeshow' });
export type ProductAssociationTypejsonldsyliusadminproductassociationtypeshow = Schema.Schema.Type<
  typeof ProductAssociationTypejsonldsyliusadminproductassociationtypeshow
>;
export type ProductAssociationTypejsonldsyliusadminproductassociationtypeshowEncoded =
  Schema.Codec.Encoded<typeof ProductAssociationTypejsonldsyliusadminproductassociationtypeshow>;

/* ProductAttribute */

export const ProductAttribute = Schema.StructWithRest(
  Schema.Struct({
    group: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'iri-reference' }),
    attributeValues: Schema.Array(
      Schema.Union(
        [
          Schema.String,
          Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
          Schema.Boolean,
          Schema.StructWithRest(
            Schema.Struct({
              label: Schema.optionalKey(Schema.String),
              value: Schema.optionalKey(Schema.String),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      )
    ).annotate({
      description:
        'The values this attribute takes here, i.e. the choices its filter should offer. Scalar attributes yield bare values; `select` attributes yield `{label, value}` pairs.',
    }),
    unit: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'Unit of the attribute values (e.g. "mm", "g"), shown next to the value',
    }),
    filterUrlMode: Schema.Literals(['path', 'fragment', 'hide']).annotate({
      description: 'How the attribute filter is represented in the storefront URL',
    }),
    filterDisplayTaxons: Schema.Array(Schema.suspend((): Schema.Codec<Taxon> => Taxon)),
    filterState: Schema.Literals(['open', 'close']).annotate({
      description: 'Whether the filter is rendered expanded or collapsed by default',
    }),
    numberOfShow: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({
      description: 'How many filter values are shown before the "show more" expander; null = all',
    }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    type: Schema.Literals([
      'text',
      'textarea',
      'checkbox',
      'integer',
      'float',
      'percent',
      'datetime',
      'date',
      'select',
    ]),
    configuration: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    storageType: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    translatable: Schema.Boolean.annotate({ default: true }),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
    currentLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    fallbackLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    name: Schema.Union([Schema.String, Schema.Null]),
    translation: Schema.Array(
      Schema.suspend((): Schema.Codec<TranslationInterface> => TranslationInterface)
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAttribute' });
export type ProductAttribute = Schema.Schema.Type<typeof ProductAttribute>;
export type ProductAttributeEncoded = Schema.Codec.Encoded<typeof ProductAttribute>;

/* ProductAttributejsonld */

export const ProductAttributejsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    group: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'iri-reference' }),
    attributeValues: Schema.Array(
      Schema.Union(
        [
          Schema.String,
          Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
          Schema.Boolean,
          Schema.StructWithRest(
            Schema.Struct({
              label: Schema.optionalKey(Schema.String),
              value: Schema.optionalKey(Schema.String),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      )
    ).annotate({
      description:
        'The values this attribute takes here, i.e. the choices its filter should offer. Scalar attributes yield bare values; `select` attributes yield `{label, value}` pairs.',
    }),
    unit: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'Unit of the attribute values (e.g. "mm", "g"), shown next to the value',
    }),
    filterUrlMode: Schema.Literals(['path', 'fragment', 'hide']).annotate({
      description: 'How the attribute filter is represented in the storefront URL',
    }),
    filterDisplayTaxons: Schema.Array(Schema.suspend((): Schema.Codec<Taxonjsonld> => Taxonjsonld)),
    filterState: Schema.Literals(['open', 'close']).annotate({
      description: 'Whether the filter is rendered expanded or collapsed by default',
    }),
    numberOfShow: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({
      description: 'How many filter values are shown before the "show more" expander; null = all',
    }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    type: Schema.Literals([
      'text',
      'textarea',
      'checkbox',
      'integer',
      'float',
      'percent',
      'datetime',
      'date',
      'select',
    ]),
    configuration: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    storageType: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    translatable: Schema.Boolean.annotate({ default: true }),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
    currentLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    fallbackLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    name: Schema.Union([Schema.String, Schema.Null]),
    translation: Schema.Array(
      Schema.suspend((): Schema.Codec<TranslationInterfacejsonld> => TranslationInterfacejsonld)
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAttributejsonld' });
export type ProductAttributejsonld = Schema.Schema.Type<typeof ProductAttributejsonld>;
export type ProductAttributejsonldEncoded = Schema.Codec.Encoded<typeof ProductAttributejsonld>;

/* ProductOptionsyliusadminproductoptionindex */

export const ProductOptionsyliusadminproductoptionindex = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    values: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
    name: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductOptionsyliusadminproductoptionindex' });
export type ProductOptionsyliusadminproductoptionindex = Schema.Schema.Type<
  typeof ProductOptionsyliusadminproductoptionindex
>;
export type ProductOptionsyliusadminproductoptionindexEncoded = Schema.Codec.Encoded<
  typeof ProductOptionsyliusadminproductoptionindex
>;

/* ProductOptionsyliusadminproductoptionshow */

export const ProductOptionsyliusadminproductoptionshow = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    values: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
    name: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductOptionsyliusadminproductoptionshow' });
export type ProductOptionsyliusadminproductoptionshow = Schema.Schema.Type<
  typeof ProductOptionsyliusadminproductoptionshow
>;
export type ProductOptionsyliusadminproductoptionshowEncoded = Schema.Codec.Encoded<
  typeof ProductOptionsyliusadminproductoptionshow
>;

/* ProductOptionjsonldsyliusadminproductoptionindex */

export const ProductOptionjsonldsyliusadminproductoptionindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    values: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
    name: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductOptionjsonldsyliusadminproductoptionindex' });
export type ProductOptionjsonldsyliusadminproductoptionindex = Schema.Schema.Type<
  typeof ProductOptionjsonldsyliusadminproductoptionindex
>;
export type ProductOptionjsonldsyliusadminproductoptionindexEncoded = Schema.Codec.Encoded<
  typeof ProductOptionjsonldsyliusadminproductoptionindex
>;

/* ProductOptionjsonldsyliusadminproductoptionshow */

export const ProductOptionjsonldsyliusadminproductoptionshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    values: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
    name: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductOptionjsonldsyliusadminproductoptionshow' });
export type ProductOptionjsonldsyliusadminproductoptionshow = Schema.Schema.Type<
  typeof ProductOptionjsonldsyliusadminproductoptionshow
>;
export type ProductOptionjsonldsyliusadminproductoptionshowEncoded = Schema.Codec.Encoded<
  typeof ProductOptionjsonldsyliusadminproductoptionshow
>;

/* ProductReviewsyliusadminproductreviewindex */

export const ProductReviewsyliusadminproductreviewindex = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    title: Schema.Union([Schema.String, Schema.Null]),
    rating: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    comment: Schema.Union([Schema.String, Schema.Null]),
    author: Schema.String.annotate({ format: 'iri-reference' }),
    status: Schema.String.annotate({ default: 'new' }),
    reviewSubject: Schema.String.annotate({ format: 'iri-reference' }),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductReviewsyliusadminproductreviewindex' });
export type ProductReviewsyliusadminproductreviewindex = Schema.Schema.Type<
  typeof ProductReviewsyliusadminproductreviewindex
>;
export type ProductReviewsyliusadminproductreviewindexEncoded = Schema.Codec.Encoded<
  typeof ProductReviewsyliusadminproductreviewindex
>;

/* ProductReviewsyliusadminproductreviewshow */

export const ProductReviewsyliusadminproductreviewshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    title: Schema.Union([Schema.String, Schema.Null]),
    rating: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    comment: Schema.Union([Schema.String, Schema.Null]),
    author: Schema.String.annotate({ format: 'iri-reference' }),
    status: Schema.String.annotate({ default: 'new' }),
    reviewSubject: Schema.String.annotate({ format: 'iri-reference' }),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductReviewsyliusadminproductreviewshow' });
export type ProductReviewsyliusadminproductreviewshow = Schema.Schema.Type<
  typeof ProductReviewsyliusadminproductreviewshow
>;
export type ProductReviewsyliusadminproductreviewshowEncoded = Schema.Codec.Encoded<
  typeof ProductReviewsyliusadminproductreviewshow
>;

/* ProductReviewjsonldsyliusadminproductreviewindex */

export const ProductReviewjsonldsyliusadminproductreviewindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    title: Schema.Union([Schema.String, Schema.Null]),
    rating: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    comment: Schema.Union([Schema.String, Schema.Null]),
    author: Schema.String.annotate({ format: 'iri-reference' }),
    status: Schema.String.annotate({ default: 'new' }),
    reviewSubject: Schema.String.annotate({ format: 'iri-reference' }),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductReviewjsonldsyliusadminproductreviewindex' });
export type ProductReviewjsonldsyliusadminproductreviewindex = Schema.Schema.Type<
  typeof ProductReviewjsonldsyliusadminproductreviewindex
>;
export type ProductReviewjsonldsyliusadminproductreviewindexEncoded = Schema.Codec.Encoded<
  typeof ProductReviewjsonldsyliusadminproductreviewindex
>;

/* ProductReviewjsonldsyliusadminproductreviewshow */

export const ProductReviewjsonldsyliusadminproductreviewshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    title: Schema.Union([Schema.String, Schema.Null]),
    rating: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    comment: Schema.Union([Schema.String, Schema.Null]),
    author: Schema.String.annotate({ format: 'iri-reference' }),
    status: Schema.String.annotate({ default: 'new' }),
    reviewSubject: Schema.String.annotate({ format: 'iri-reference' }),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductReviewjsonldsyliusadminproductreviewshow' });
export type ProductReviewjsonldsyliusadminproductreviewshow = Schema.Schema.Type<
  typeof ProductReviewjsonldsyliusadminproductreviewshow
>;
export type ProductReviewjsonldsyliusadminproductreviewshowEncoded = Schema.Codec.Encoded<
  typeof ProductReviewjsonldsyliusadminproductreviewshow
>;

/* ProductVariantsyliusadminproductvariantindex */

export const ProductVariantsyliusadminproductvariantindex = Schema.StructWithRest(
  Schema.Struct({
    onHold: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    onHand: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    tracked: Schema.Boolean.annotate({ default: false }),
    weight: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Null,
    ]),
    width: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Null,
    ]),
    height: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Null,
    ]),
    depth: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Null,
    ]),
    taxCategory: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    shippingCategory: Schema.Union([
      Schema.String.annotate({ format: 'iri-reference' }),
      Schema.Null,
    ]),
    channelPricings: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    shippingRequired: Schema.Boolean.annotate({ default: true }),
    code: Schema.String,
    product: Schema.String.annotate({ format: 'iri-reference' }),
    optionValues: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    inStock: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductVariantsyliusadminproductvariantindex' });
export type ProductVariantsyliusadminproductvariantindex = Schema.Schema.Type<
  typeof ProductVariantsyliusadminproductvariantindex
>;
export type ProductVariantsyliusadminproductvariantindexEncoded = Schema.Codec.Encoded<
  typeof ProductVariantsyliusadminproductvariantindex
>;

/* ProductVariantsyliusadminproductvariantshow */

export const ProductVariantsyliusadminproductvariantshow = Schema.StructWithRest(
  Schema.Struct({
    onHold: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    onHand: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    tracked: Schema.Boolean.annotate({ default: false }),
    weight: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Null,
    ]),
    width: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Null,
    ]),
    height: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Null,
    ]),
    depth: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Null,
    ]),
    taxCategory: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    shippingCategory: Schema.Union([
      Schema.String.annotate({ format: 'iri-reference' }),
      Schema.Null,
    ]),
    channelPricings: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    shippingRequired: Schema.Boolean.annotate({ default: true }),
    code: Schema.String,
    product: Schema.String.annotate({ format: 'iri-reference' }),
    optionValues: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    inStock: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductVariantsyliusadminproductvariantshow' });
export type ProductVariantsyliusadminproductvariantshow = Schema.Schema.Type<
  typeof ProductVariantsyliusadminproductvariantshow
>;
export type ProductVariantsyliusadminproductvariantshowEncoded = Schema.Codec.Encoded<
  typeof ProductVariantsyliusadminproductvariantshow
>;

/* ProductVariantjsonldsyliusadminproductvariantindex */

export const ProductVariantjsonldsyliusadminproductvariantindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    onHold: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    onHand: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    tracked: Schema.Boolean.annotate({ default: false }),
    weight: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Null,
    ]),
    width: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Null,
    ]),
    height: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Null,
    ]),
    depth: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Null,
    ]),
    taxCategory: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    shippingCategory: Schema.Union([
      Schema.String.annotate({ format: 'iri-reference' }),
      Schema.Null,
    ]),
    channelPricings: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    shippingRequired: Schema.Boolean.annotate({ default: true }),
    code: Schema.String,
    product: Schema.String.annotate({ format: 'iri-reference' }),
    optionValues: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    inStock: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductVariantjsonldsyliusadminproductvariantindex' });
export type ProductVariantjsonldsyliusadminproductvariantindex = Schema.Schema.Type<
  typeof ProductVariantjsonldsyliusadminproductvariantindex
>;
export type ProductVariantjsonldsyliusadminproductvariantindexEncoded = Schema.Codec.Encoded<
  typeof ProductVariantjsonldsyliusadminproductvariantindex
>;

/* ProductVariantjsonldsyliusadminproductvariantshow */

export const ProductVariantjsonldsyliusadminproductvariantshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    onHold: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    onHand: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    tracked: Schema.Boolean.annotate({ default: false }),
    weight: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Null,
    ]),
    width: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Null,
    ]),
    height: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Null,
    ]),
    depth: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Null,
    ]),
    taxCategory: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    shippingCategory: Schema.Union([
      Schema.String.annotate({ format: 'iri-reference' }),
      Schema.Null,
    ]),
    channelPricings: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    shippingRequired: Schema.Boolean.annotate({ default: true }),
    code: Schema.String,
    product: Schema.String.annotate({ format: 'iri-reference' }),
    optionValues: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    inStock: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductVariantjsonldsyliusadminproductvariantshow' });
export type ProductVariantjsonldsyliusadminproductvariantshow = Schema.Schema.Type<
  typeof ProductVariantjsonldsyliusadminproductvariantshow
>;
export type ProductVariantjsonldsyliusadminproductvariantshowEncoded = Schema.Codec.Encoded<
  typeof ProductVariantjsonldsyliusadminproductvariantshow
>;

/* PromotionCouponsyliusadminpromotioncouponcreate */

export const PromotionCouponsyliusadminpromotioncouponcreate = Schema.StructWithRest(
  Schema.Struct({
    perCustomerUsageLimit: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })).check(
        Schema.isGreaterThanOrEqualTo(1).annotate({
          expected: 'a value greater than or equal to 1',
        })
      ),
      Schema.Null,
    ]),
    reusableFromCancelledOrders: Schema.Boolean.annotate({ default: true }),
    code: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    )
      .check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' }))
      .check(
        Schema.isPattern(new RegExp('^([\\w-]*)$')).annotate({
          expected: 'a string matching the RegExp ^([\\w-]*)$',
        })
      ),
    usageLimit: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })).check(
        Schema.isGreaterThanOrEqualTo(1).annotate({
          expected: 'a value greater than or equal to 1',
        })
      ),
      Schema.Null,
    ]),
    expiresAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PromotionCouponsyliusadminpromotioncouponcreate' });
export type PromotionCouponsyliusadminpromotioncouponcreate = Schema.Schema.Type<
  typeof PromotionCouponsyliusadminpromotioncouponcreate
>;
export type PromotionCouponsyliusadminpromotioncouponcreateEncoded = Schema.Codec.Encoded<
  typeof PromotionCouponsyliusadminpromotioncouponcreate
>;

/* PromotionCouponsyliusadminpromotioncouponindex */

export const PromotionCouponsyliusadminpromotioncouponindex = Schema.StructWithRest(
  Schema.Struct({
    perCustomerUsageLimit: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    reusableFromCancelledOrders: Schema.Boolean.annotate({ default: true }),
    code: Schema.String,
    usageLimit: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    used: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    promotion: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'iri-reference' }),
    expiresAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PromotionCouponsyliusadminpromotioncouponindex' });
export type PromotionCouponsyliusadminpromotioncouponindex = Schema.Schema.Type<
  typeof PromotionCouponsyliusadminpromotioncouponindex
>;
export type PromotionCouponsyliusadminpromotioncouponindexEncoded = Schema.Codec.Encoded<
  typeof PromotionCouponsyliusadminpromotioncouponindex
>;

/* PromotionCouponsyliusadminpromotioncouponshow */

export const PromotionCouponsyliusadminpromotioncouponshow = Schema.StructWithRest(
  Schema.Struct({
    perCustomerUsageLimit: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    reusableFromCancelledOrders: Schema.Boolean.annotate({ default: true }),
    code: Schema.String,
    usageLimit: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    used: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    promotion: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'iri-reference' }),
    expiresAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PromotionCouponsyliusadminpromotioncouponshow' });
export type PromotionCouponsyliusadminpromotioncouponshow = Schema.Schema.Type<
  typeof PromotionCouponsyliusadminpromotioncouponshow
>;
export type PromotionCouponsyliusadminpromotioncouponshowEncoded = Schema.Codec.Encoded<
  typeof PromotionCouponsyliusadminpromotioncouponshow
>;

/* PromotionCouponsyliusadminpromotioncouponupdate */

export const PromotionCouponsyliusadminpromotioncouponupdate = Schema.StructWithRest(
  Schema.Struct({
    perCustomerUsageLimit: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })).check(
        Schema.isGreaterThanOrEqualTo(1).annotate({
          expected: 'a value greater than or equal to 1',
        })
      ),
      Schema.Null,
    ]),
    reusableFromCancelledOrders: Schema.Boolean.annotate({ default: true }),
    usageLimit: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })).check(
        Schema.isGreaterThanOrEqualTo(1).annotate({
          expected: 'a value greater than or equal to 1',
        })
      ),
      Schema.Null,
    ]),
    expiresAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PromotionCouponsyliusadminpromotioncouponupdate' });
export type PromotionCouponsyliusadminpromotioncouponupdate = Schema.Schema.Type<
  typeof PromotionCouponsyliusadminpromotioncouponupdate
>;
export type PromotionCouponsyliusadminpromotioncouponupdateEncoded = Schema.Codec.Encoded<
  typeof PromotionCouponsyliusadminpromotioncouponupdate
>;

/* PromotionCouponGeneratePromotionCouponsyliusadminpromotioncoupongenerate */

export const PromotionCouponGeneratePromotionCouponsyliusadminpromotioncoupongenerate =
  Schema.StructWithRest(
    Schema.Struct({
      promotionCode: Schema.String,
      prefix: Schema.Union([Schema.String, Schema.Null]),
      codeLength: Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' }))
          .check(
            Schema.isGreaterThanOrEqualTo(1).annotate({
              expected: 'a value greater than or equal to 1',
            })
          )
          .check(
            Schema.isLessThanOrEqualTo(40).annotate({
              expected: 'a value less than or equal to 40',
            })
          ),
        Schema.Null,
      ]),
      suffix: Schema.Union([Schema.String, Schema.Null]),
      amount: Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })).check(
          Schema.isGreaterThanOrEqualTo(1).annotate({
            expected: 'a value greater than or equal to 1',
          })
        ),
        Schema.Null,
      ]),
      expiresAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
      usageLimit: Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })).check(
          Schema.isGreaterThanOrEqualTo(1).annotate({
            expected: 'a value greater than or equal to 1',
          })
        ),
        Schema.Null,
      ]),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier: 'PromotionCouponGeneratePromotionCouponsyliusadminpromotioncoupongenerate',
  });
export type PromotionCouponGeneratePromotionCouponsyliusadminpromotioncoupongenerate =
  Schema.Schema.Type<
    typeof PromotionCouponGeneratePromotionCouponsyliusadminpromotioncoupongenerate
  >;
export type PromotionCouponGeneratePromotionCouponsyliusadminpromotioncoupongenerateEncoded =
  Schema.Codec.Encoded<
    typeof PromotionCouponGeneratePromotionCouponsyliusadminpromotioncoupongenerate
  >;

/* PromotionCouponGeneratePromotionCouponjsonldsyliusadminpromotioncoupongenerate */

export const PromotionCouponGeneratePromotionCouponjsonldsyliusadminpromotioncoupongenerate =
  Schema.StructWithRest(
    Schema.Struct({
      promotionCode: Schema.String,
      prefix: Schema.Union([Schema.String, Schema.Null]),
      codeLength: Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' }))
          .check(
            Schema.isGreaterThanOrEqualTo(1).annotate({
              expected: 'a value greater than or equal to 1',
            })
          )
          .check(
            Schema.isLessThanOrEqualTo(40).annotate({
              expected: 'a value less than or equal to 40',
            })
          ),
        Schema.Null,
      ]),
      suffix: Schema.Union([Schema.String, Schema.Null]),
      amount: Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })).check(
          Schema.isGreaterThanOrEqualTo(1).annotate({
            expected: 'a value greater than or equal to 1',
          })
        ),
        Schema.Null,
      ]),
      expiresAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
      usageLimit: Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })).check(
          Schema.isGreaterThanOrEqualTo(1).annotate({
            expected: 'a value greater than or equal to 1',
          })
        ),
        Schema.Null,
      ]),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier: 'PromotionCouponGeneratePromotionCouponjsonldsyliusadminpromotioncoupongenerate',
  });
export type PromotionCouponGeneratePromotionCouponjsonldsyliusadminpromotioncoupongenerate =
  Schema.Schema.Type<
    typeof PromotionCouponGeneratePromotionCouponjsonldsyliusadminpromotioncoupongenerate
  >;
export type PromotionCouponGeneratePromotionCouponjsonldsyliusadminpromotioncoupongenerateEncoded =
  Schema.Codec.Encoded<
    typeof PromotionCouponGeneratePromotionCouponjsonldsyliusadminpromotioncoupongenerate
  >;

/* PromotionCouponjsonldsyliusadminpromotioncouponcreate */

export const PromotionCouponjsonldsyliusadminpromotioncouponcreate = Schema.StructWithRest(
  Schema.Struct({
    perCustomerUsageLimit: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })).check(
        Schema.isGreaterThanOrEqualTo(1).annotate({
          expected: 'a value greater than or equal to 1',
        })
      ),
      Schema.Null,
    ]),
    reusableFromCancelledOrders: Schema.Boolean.annotate({ default: true }),
    code: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    )
      .check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' }))
      .check(
        Schema.isPattern(new RegExp('^([\\w-]*)$')).annotate({
          expected: 'a string matching the RegExp ^([\\w-]*)$',
        })
      ),
    usageLimit: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })).check(
        Schema.isGreaterThanOrEqualTo(1).annotate({
          expected: 'a value greater than or equal to 1',
        })
      ),
      Schema.Null,
    ]),
    expiresAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PromotionCouponjsonldsyliusadminpromotioncouponcreate' });
export type PromotionCouponjsonldsyliusadminpromotioncouponcreate = Schema.Schema.Type<
  typeof PromotionCouponjsonldsyliusadminpromotioncouponcreate
>;
export type PromotionCouponjsonldsyliusadminpromotioncouponcreateEncoded = Schema.Codec.Encoded<
  typeof PromotionCouponjsonldsyliusadminpromotioncouponcreate
>;

/* PromotionCouponjsonldsyliusadminpromotioncouponindex */

export const PromotionCouponjsonldsyliusadminpromotioncouponindex = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    perCustomerUsageLimit: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    reusableFromCancelledOrders: Schema.Boolean.annotate({ default: true }),
    code: Schema.String,
    usageLimit: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    used: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    promotion: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'iri-reference' }),
    expiresAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PromotionCouponjsonldsyliusadminpromotioncouponindex' });
export type PromotionCouponjsonldsyliusadminpromotioncouponindex = Schema.Schema.Type<
  typeof PromotionCouponjsonldsyliusadminpromotioncouponindex
>;
export type PromotionCouponjsonldsyliusadminpromotioncouponindexEncoded = Schema.Codec.Encoded<
  typeof PromotionCouponjsonldsyliusadminpromotioncouponindex
>;

/* PromotionCouponjsonldsyliusadminpromotioncouponshow */

export const PromotionCouponjsonldsyliusadminpromotioncouponshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    perCustomerUsageLimit: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    reusableFromCancelledOrders: Schema.Boolean.annotate({ default: true }),
    code: Schema.String,
    usageLimit: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    used: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    promotion: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'iri-reference' }),
    expiresAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PromotionCouponjsonldsyliusadminpromotioncouponshow' });
export type PromotionCouponjsonldsyliusadminpromotioncouponshow = Schema.Schema.Type<
  typeof PromotionCouponjsonldsyliusadminpromotioncouponshow
>;
export type PromotionCouponjsonldsyliusadminpromotioncouponshowEncoded = Schema.Codec.Encoded<
  typeof PromotionCouponjsonldsyliusadminpromotioncouponshow
>;

/* PromotionCouponjsonldsyliusadminpromotioncouponupdate */

export const PromotionCouponjsonldsyliusadminpromotioncouponupdate = Schema.StructWithRest(
  Schema.Struct({
    perCustomerUsageLimit: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })).check(
        Schema.isGreaterThanOrEqualTo(1).annotate({
          expected: 'a value greater than or equal to 1',
        })
      ),
      Schema.Null,
    ]),
    reusableFromCancelledOrders: Schema.Boolean.annotate({ default: true }),
    usageLimit: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })).check(
        Schema.isGreaterThanOrEqualTo(1).annotate({
          expected: 'a value greater than or equal to 1',
        })
      ),
      Schema.Null,
    ]),
    expiresAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PromotionCouponjsonldsyliusadminpromotioncouponupdate' });
export type PromotionCouponjsonldsyliusadminpromotioncouponupdate = Schema.Schema.Type<
  typeof PromotionCouponjsonldsyliusadminpromotioncouponupdate
>;
export type PromotionCouponjsonldsyliusadminpromotioncouponupdateEncoded = Schema.Codec.Encoded<
  typeof PromotionCouponjsonldsyliusadminpromotioncouponupdate
>;

/* Shipmentsyliusadminshipmentindex */

export const Shipmentsyliusadminshipmentindex = Schema.StructWithRest(
  Schema.Struct({
    placementId: Schema.Union([Schema.String, Schema.Null]),
    order: Schema.String.annotate({ format: 'iri-reference' }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    state: Schema.String.annotate({ default: 'cart' }),
    method: Schema.String.annotate({ format: 'iri-reference' }),
    units: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    tracking: Schema.Union([Schema.String, Schema.Null]),
    shippedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    price: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Shipmentsyliusadminshipmentindex' });
export type Shipmentsyliusadminshipmentindex = Schema.Schema.Type<
  typeof Shipmentsyliusadminshipmentindex
>;
export type ShipmentsyliusadminshipmentindexEncoded = Schema.Codec.Encoded<
  typeof Shipmentsyliusadminshipmentindex
>;

/* Shipmentsyliusadminshipmentshow */

export const Shipmentsyliusadminshipmentshow = Schema.StructWithRest(
  Schema.Struct({
    placementId: Schema.Union([Schema.String, Schema.Null]),
    order: Schema.String.annotate({ format: 'iri-reference' }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    state: Schema.String.annotate({ default: 'cart' }),
    method: Schema.String.annotate({ format: 'iri-reference' }),
    units: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    tracking: Schema.Union([Schema.String, Schema.Null]),
    shippedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    price: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Shipmentsyliusadminshipmentshow' });
export type Shipmentsyliusadminshipmentshow = Schema.Schema.Type<
  typeof Shipmentsyliusadminshipmentshow
>;
export type ShipmentsyliusadminshipmentshowEncoded = Schema.Codec.Encoded<
  typeof Shipmentsyliusadminshipmentshow
>;

/* Shipmentsyliusshopshipmentshow */

export const Shipmentsyliusshopshipmentshow = Schema.StructWithRest(
  Schema.Struct({
    placementId: Schema.Union([Schema.String, Schema.Null]),
    order: Schema.String.annotate({ format: 'iri-reference' }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    state: Schema.String.annotate({ default: 'cart' }),
    method: Schema.String.annotate({ format: 'iri-reference' }),
    units: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    tracking: Schema.Union([Schema.String, Schema.Null]),
    shippedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    absoluteTrackingUrl: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    price: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Shipmentsyliusshopshipmentshow' });
export type Shipmentsyliusshopshipmentshow = Schema.Schema.Type<
  typeof Shipmentsyliusshopshipmentshow
>;
export type ShipmentsyliusshopshipmentshowEncoded = Schema.Codec.Encoded<
  typeof Shipmentsyliusshopshipmentshow
>;

/* Shipmentjsonldsyliusadminshipmentindex */

export const Shipmentjsonldsyliusadminshipmentindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    placementId: Schema.Union([Schema.String, Schema.Null]),
    order: Schema.String.annotate({ format: 'iri-reference' }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    state: Schema.String.annotate({ default: 'cart' }),
    method: Schema.String.annotate({ format: 'iri-reference' }),
    units: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    tracking: Schema.Union([Schema.String, Schema.Null]),
    shippedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    price: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Shipmentjsonldsyliusadminshipmentindex' });
export type Shipmentjsonldsyliusadminshipmentindex = Schema.Schema.Type<
  typeof Shipmentjsonldsyliusadminshipmentindex
>;
export type ShipmentjsonldsyliusadminshipmentindexEncoded = Schema.Codec.Encoded<
  typeof Shipmentjsonldsyliusadminshipmentindex
>;

/* Shipmentjsonldsyliusadminshipmentshow */

export const Shipmentjsonldsyliusadminshipmentshow = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    placementId: Schema.Union([Schema.String, Schema.Null]),
    order: Schema.String.annotate({ format: 'iri-reference' }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    state: Schema.String.annotate({ default: 'cart' }),
    method: Schema.String.annotate({ format: 'iri-reference' }),
    units: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    tracking: Schema.Union([Schema.String, Schema.Null]),
    shippedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    price: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Shipmentjsonldsyliusadminshipmentshow' });
export type Shipmentjsonldsyliusadminshipmentshow = Schema.Schema.Type<
  typeof Shipmentjsonldsyliusadminshipmentshow
>;
export type ShipmentjsonldsyliusadminshipmentshowEncoded = Schema.Codec.Encoded<
  typeof Shipmentjsonldsyliusadminshipmentshow
>;

/* Shipmentjsonldsyliusshopshipmentshow */

export const Shipmentjsonldsyliusshopshipmentshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    placementId: Schema.Union([Schema.String, Schema.Null]),
    order: Schema.String.annotate({ format: 'iri-reference' }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    state: Schema.String.annotate({ default: 'cart' }),
    method: Schema.String.annotate({ format: 'iri-reference' }),
    units: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    tracking: Schema.Union([Schema.String, Schema.Null]),
    shippedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    absoluteTrackingUrl: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    price: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Shipmentjsonldsyliusshopshipmentshow' });
export type Shipmentjsonldsyliusshopshipmentshow = Schema.Schema.Type<
  typeof Shipmentjsonldsyliusshopshipmentshow
>;
export type ShipmentjsonldsyliusshopshipmentshowEncoded = Schema.Codec.Encoded<
  typeof Shipmentjsonldsyliusshopshipmentshow
>;

/* ShippingCategorysyliusadminshippingcategoryindex */

export const ShippingCategorysyliusadminshippingcategoryindex = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.String,
    description: Schema.Union([Schema.String, Schema.Null]),
    createdAt: Schema.optionalKey(DateTimeSerializableFromString),
    updatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingCategorysyliusadminshippingcategoryindex' });
export type ShippingCategorysyliusadminshippingcategoryindex = Schema.Schema.Type<
  typeof ShippingCategorysyliusadminshippingcategoryindex
>;
export type ShippingCategorysyliusadminshippingcategoryindexEncoded = Schema.Codec.Encoded<
  typeof ShippingCategorysyliusadminshippingcategoryindex
>;

/* ShippingCategorysyliusadminshippingcategoryshow */

export const ShippingCategorysyliusadminshippingcategoryshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.String,
    description: Schema.Union([Schema.String, Schema.Null]),
    createdAt: Schema.optionalKey(DateTimeSerializableFromString),
    updatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingCategorysyliusadminshippingcategoryshow' });
export type ShippingCategorysyliusadminshippingcategoryshow = Schema.Schema.Type<
  typeof ShippingCategorysyliusadminshippingcategoryshow
>;
export type ShippingCategorysyliusadminshippingcategoryshowEncoded = Schema.Codec.Encoded<
  typeof ShippingCategorysyliusadminshippingcategoryshow
>;

/* ShippingCategoryjsonldsyliusadminshippingcategoryindex */

export const ShippingCategoryjsonldsyliusadminshippingcategoryindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.String,
    description: Schema.Union([Schema.String, Schema.Null]),
    createdAt: Schema.optionalKey(DateTimeSerializableFromString),
    updatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingCategoryjsonldsyliusadminshippingcategoryindex' });
export type ShippingCategoryjsonldsyliusadminshippingcategoryindex = Schema.Schema.Type<
  typeof ShippingCategoryjsonldsyliusadminshippingcategoryindex
>;
export type ShippingCategoryjsonldsyliusadminshippingcategoryindexEncoded = Schema.Codec.Encoded<
  typeof ShippingCategoryjsonldsyliusadminshippingcategoryindex
>;

/* ShippingCategoryjsonldsyliusadminshippingcategoryshow */

export const ShippingCategoryjsonldsyliusadminshippingcategoryshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.String,
    description: Schema.Union([Schema.String, Schema.Null]),
    createdAt: Schema.optionalKey(DateTimeSerializableFromString),
    updatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingCategoryjsonldsyliusadminshippingcategoryshow' });
export type ShippingCategoryjsonldsyliusadminshippingcategoryshow = Schema.Schema.Type<
  typeof ShippingCategoryjsonldsyliusadminshippingcategoryshow
>;
export type ShippingCategoryjsonldsyliusadminshippingcategoryshowEncoded = Schema.Codec.Encoded<
  typeof ShippingCategoryjsonldsyliusadminshippingcategoryshow
>;

/* TaxCategorysyliusadmintaxcategoryindex */

export const TaxCategorysyliusadmintaxcategoryindex = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.String,
    description: Schema.Union([Schema.String, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TaxCategorysyliusadmintaxcategoryindex' });
export type TaxCategorysyliusadmintaxcategoryindex = Schema.Schema.Type<
  typeof TaxCategorysyliusadmintaxcategoryindex
>;
export type TaxCategorysyliusadmintaxcategoryindexEncoded = Schema.Codec.Encoded<
  typeof TaxCategorysyliusadmintaxcategoryindex
>;

/* TaxCategorysyliusadmintaxcategoryshow */

export const TaxCategorysyliusadmintaxcategoryshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.String,
    description: Schema.Union([Schema.String, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TaxCategorysyliusadmintaxcategoryshow' });
export type TaxCategorysyliusadmintaxcategoryshow = Schema.Schema.Type<
  typeof TaxCategorysyliusadmintaxcategoryshow
>;
export type TaxCategorysyliusadmintaxcategoryshowEncoded = Schema.Codec.Encoded<
  typeof TaxCategorysyliusadmintaxcategoryshow
>;

/* TaxCategoryjsonldsyliusadmintaxcategoryindex */

export const TaxCategoryjsonldsyliusadmintaxcategoryindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.String,
    description: Schema.Union([Schema.String, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TaxCategoryjsonldsyliusadmintaxcategoryindex' });
export type TaxCategoryjsonldsyliusadmintaxcategoryindex = Schema.Schema.Type<
  typeof TaxCategoryjsonldsyliusadmintaxcategoryindex
>;
export type TaxCategoryjsonldsyliusadmintaxcategoryindexEncoded = Schema.Codec.Encoded<
  typeof TaxCategoryjsonldsyliusadmintaxcategoryindex
>;

/* TaxCategoryjsonldsyliusadmintaxcategoryshow */

export const TaxCategoryjsonldsyliusadmintaxcategoryshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.String,
    description: Schema.Union([Schema.String, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TaxCategoryjsonldsyliusadmintaxcategoryshow' });
export type TaxCategoryjsonldsyliusadmintaxcategoryshow = Schema.Schema.Type<
  typeof TaxCategoryjsonldsyliusadmintaxcategoryshow
>;
export type TaxCategoryjsonldsyliusadmintaxcategoryshowEncoded = Schema.Codec.Encoded<
  typeof TaxCategoryjsonldsyliusadmintaxcategoryshow
>;

/* TaxRatesyliusadmintaxratecreate */

export const TaxRatesyliusadmintaxratecreate = Schema.StructWithRest(
  Schema.Struct({
    zone: Schema.String.annotate({ format: 'iri-reference' }),
    code: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ).check(
      Schema.isPattern(new RegExp('^([\\w-]*)$')).annotate({
        expected: 'a string matching the RegExp ^([\\w-]*)$',
      })
    ),
    category: Schema.String.annotate({ format: 'iri-reference' }),
    name: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    amount: Schema.Number.annotate({ default: 0 })
      .check(Schema.isFinite().annotate({ expected: 'a finite number' }))
      .check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
    includedInPrice: Schema.Boolean.annotate({ default: false }),
    calculator: Schema.String,
    startDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    endDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TaxRatesyliusadmintaxratecreate' });
export type TaxRatesyliusadmintaxratecreate = Schema.Schema.Type<
  typeof TaxRatesyliusadmintaxratecreate
>;
export type TaxRatesyliusadmintaxratecreateEncoded = Schema.Codec.Encoded<
  typeof TaxRatesyliusadmintaxratecreate
>;

/* TaxRatesyliusadmintaxrateindex */

export const TaxRatesyliusadmintaxrateindex = Schema.StructWithRest(
  Schema.Struct({
    zone: Schema.String.annotate({ format: 'iri-reference' }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    category: Schema.String.annotate({ format: 'iri-reference' }),
    name: Schema.String,
    amount: Schema.Number.annotate({ default: 0 }).check(
      Schema.isFinite().annotate({ expected: 'a finite number' })
    ),
    includedInPrice: Schema.Boolean.annotate({ default: false }),
    calculator: Schema.String,
    startDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    endDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TaxRatesyliusadmintaxrateindex' });
export type TaxRatesyliusadmintaxrateindex = Schema.Schema.Type<
  typeof TaxRatesyliusadmintaxrateindex
>;
export type TaxRatesyliusadmintaxrateindexEncoded = Schema.Codec.Encoded<
  typeof TaxRatesyliusadmintaxrateindex
>;

/* TaxRatesyliusadmintaxrateshow */

export const TaxRatesyliusadmintaxrateshow = Schema.StructWithRest(
  Schema.Struct({
    zone: Schema.String.annotate({ format: 'iri-reference' }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    category: Schema.String.annotate({ format: 'iri-reference' }),
    name: Schema.String,
    amount: Schema.Number.annotate({ default: 0 }).check(
      Schema.isFinite().annotate({ expected: 'a finite number' })
    ),
    includedInPrice: Schema.Boolean.annotate({ default: false }),
    calculator: Schema.String,
    startDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    endDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TaxRatesyliusadmintaxrateshow' });
export type TaxRatesyliusadmintaxrateshow = Schema.Schema.Type<
  typeof TaxRatesyliusadmintaxrateshow
>;
export type TaxRatesyliusadmintaxrateshowEncoded = Schema.Codec.Encoded<
  typeof TaxRatesyliusadmintaxrateshow
>;

/* TaxRatesyliusadmintaxrateupdate */

export const TaxRatesyliusadmintaxrateupdate = Schema.StructWithRest(
  Schema.Struct({
    zone: Schema.String.annotate({ format: 'iri-reference' }),
    category: Schema.String.annotate({ format: 'iri-reference' }),
    name: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    amount: Schema.Number.annotate({ default: 0 })
      .check(Schema.isFinite().annotate({ expected: 'a finite number' }))
      .check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
    includedInPrice: Schema.Boolean.annotate({ default: false }),
    calculator: Schema.String,
    startDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    endDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TaxRatesyliusadmintaxrateupdate' });
export type TaxRatesyliusadmintaxrateupdate = Schema.Schema.Type<
  typeof TaxRatesyliusadmintaxrateupdate
>;
export type TaxRatesyliusadmintaxrateupdateEncoded = Schema.Codec.Encoded<
  typeof TaxRatesyliusadmintaxrateupdate
>;

/* TaxRatejsonldsyliusadmintaxratecreate */

export const TaxRatejsonldsyliusadmintaxratecreate = Schema.StructWithRest(
  Schema.Struct({
    zone: Schema.String.annotate({ format: 'iri-reference' }),
    code: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ).check(
      Schema.isPattern(new RegExp('^([\\w-]*)$')).annotate({
        expected: 'a string matching the RegExp ^([\\w-]*)$',
      })
    ),
    category: Schema.String.annotate({ format: 'iri-reference' }),
    name: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    amount: Schema.Number.annotate({ default: 0 })
      .check(Schema.isFinite().annotate({ expected: 'a finite number' }))
      .check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
    includedInPrice: Schema.Boolean.annotate({ default: false }),
    calculator: Schema.String,
    startDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    endDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TaxRatejsonldsyliusadmintaxratecreate' });
export type TaxRatejsonldsyliusadmintaxratecreate = Schema.Schema.Type<
  typeof TaxRatejsonldsyliusadmintaxratecreate
>;
export type TaxRatejsonldsyliusadmintaxratecreateEncoded = Schema.Codec.Encoded<
  typeof TaxRatejsonldsyliusadmintaxratecreate
>;

/* TaxRatejsonldsyliusadmintaxrateindex */

export const TaxRatejsonldsyliusadmintaxrateindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    zone: Schema.String.annotate({ format: 'iri-reference' }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    category: Schema.String.annotate({ format: 'iri-reference' }),
    name: Schema.String,
    amount: Schema.Number.annotate({ default: 0 }).check(
      Schema.isFinite().annotate({ expected: 'a finite number' })
    ),
    includedInPrice: Schema.Boolean.annotate({ default: false }),
    calculator: Schema.String,
    startDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    endDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TaxRatejsonldsyliusadmintaxrateindex' });
export type TaxRatejsonldsyliusadmintaxrateindex = Schema.Schema.Type<
  typeof TaxRatejsonldsyliusadmintaxrateindex
>;
export type TaxRatejsonldsyliusadmintaxrateindexEncoded = Schema.Codec.Encoded<
  typeof TaxRatejsonldsyliusadmintaxrateindex
>;

/* TaxRatejsonldsyliusadmintaxrateshow */

export const TaxRatejsonldsyliusadmintaxrateshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    zone: Schema.String.annotate({ format: 'iri-reference' }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    category: Schema.String.annotate({ format: 'iri-reference' }),
    name: Schema.String,
    amount: Schema.Number.annotate({ default: 0 }).check(
      Schema.isFinite().annotate({ expected: 'a finite number' })
    ),
    includedInPrice: Schema.Boolean.annotate({ default: false }),
    calculator: Schema.String,
    startDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    endDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TaxRatejsonldsyliusadmintaxrateshow' });
export type TaxRatejsonldsyliusadmintaxrateshow = Schema.Schema.Type<
  typeof TaxRatejsonldsyliusadmintaxrateshow
>;
export type TaxRatejsonldsyliusadmintaxrateshowEncoded = Schema.Codec.Encoded<
  typeof TaxRatejsonldsyliusadmintaxrateshow
>;

/* TaxRatejsonldsyliusadmintaxrateupdate */

export const TaxRatejsonldsyliusadmintaxrateupdate = Schema.StructWithRest(
  Schema.Struct({
    zone: Schema.String.annotate({ format: 'iri-reference' }),
    category: Schema.String.annotate({ format: 'iri-reference' }),
    name: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    amount: Schema.Number.annotate({ default: 0 })
      .check(Schema.isFinite().annotate({ expected: 'a finite number' }))
      .check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
    includedInPrice: Schema.Boolean.annotate({ default: false }),
    calculator: Schema.String,
    startDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    endDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TaxRatejsonldsyliusadmintaxrateupdate' });
export type TaxRatejsonldsyliusadmintaxrateupdate = Schema.Schema.Type<
  typeof TaxRatejsonldsyliusadmintaxrateupdate
>;
export type TaxRatejsonldsyliusadmintaxrateupdateEncoded = Schema.Codec.Encoded<
  typeof TaxRatejsonldsyliusadmintaxrateupdate
>;

/* Statistics */

export const Statistics = Schema.StructWithRest(
  Schema.Struct({
    sales: Schema.optionalKey(
      Schema.Array(
        Schema.StructWithRest(
          Schema.Struct({
            period: Schema.optionalKey(DateTimeSerializableFromString),
            total: Schema.optionalKey(
              Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' }))
            ),
          }),
          [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
        )
      )
    ),
    businessActivitySummary: Schema.optionalKey(
      Schema.Array(
        Schema.StructWithRest(
          Schema.Struct({
            totalSales: Schema.optionalKey(
              Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' }))
            ),
            paidOrdersCount: Schema.optionalKey(
              Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' }))
            ),
            newCustomersCount: Schema.optionalKey(
              Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' }))
            ),
            averageOrderValue: Schema.optionalKey(
              Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' }))
            ),
          }),
          [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
        )
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Statistics' });
export type Statistics = Schema.Schema.Type<typeof Statistics>;
export type StatisticsEncoded = Schema.Codec.Encoded<typeof Statistics>;

/* CartPromotionRuleHints */

export const CartPromotionRuleHints = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String,
    name: Schema.Union([Schema.String, Schema.Null]),
    label: Schema.Union([Schema.String, Schema.Null]),
    shippingDiscountRuleHint: Schema.Union([ShippingDiscountRuleHint, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CartPromotionRuleHints' });
export type CartPromotionRuleHints = Schema.Schema.Type<typeof CartPromotionRuleHints>;
export type CartPromotionRuleHintsEncoded = Schema.Codec.Encoded<typeof CartPromotionRuleHints>;

/* BigDecimal */

export const BigDecimal = Schema.StructWithRest(
  Schema.Struct({
    scale: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'The scale (number of digits after the decimal point) of this decimal number.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    sign: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    unscaledValue: BigInteger,
    precision: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns the number of significant digits in the number.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    integralPart: Schema.optionalKey(
      Schema.String.annotate({
        description: 'Returns a string representing the integral part of this decimal number.',
        readOnly: true,
      })
    ),
    fractionalPart: Schema.optionalKey(
      Schema.String.annotate({
        description: 'Returns a string representing the fractional part of this decimal number.',
        readOnly: true,
      })
    ),
    nonZeroFractionalPart: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Returns whether this decimal number has a non-zero fractional part.',
        readOnly: true,
      })
    ),
    zero: Schema.optionalKey(
      Schema.Boolean.annotate({ description: 'Checks if this number equals zero.', readOnly: true })
    ),
    negative: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Checks if this number is strictly negative.',
        readOnly: true,
      })
    ),
    negativeOrZero: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Checks if this number is negative or zero.',
        readOnly: true,
      })
    ),
    positive: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Checks if this number is strictly positive.',
        readOnly: true,
      })
    ),
    positiveOrZero: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Checks if this number is positive or zero.',
        readOnly: true,
      })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'BigDecimal' });
export type BigDecimal = Schema.Schema.Type<typeof BigDecimal>;
export type BigDecimalEncoded = Schema.Codec.Encoded<typeof BigDecimal>;

/* MoneyCurrency */

export const MoneyCurrency = Schema.StructWithRest(
  Schema.Struct({
    currencyCode: Schema.String.annotate({
      description:
        'The currency code. For ISO currencies this will be the 3-letter\nuppercase ISO 4217 currency code. For non-ISO currencies no\nconstraints are defined, but the code must be unique across an\napplication and must not conflict with ISO currency codes.',
    }),
    numericCode: Schema.Number.annotate({
      description:
        'The numeric currency code. For ISO currencies this will be the\nISO 4217 numeric currency code, without leading zeros. For non-ISO\ncurrencies no constraints are defined, but the code must be unique\nacross an application and must not conflict with ISO currency codes.\nSet to zero if the currency does not have a numeric code.',
    }).check(Schema.isInt().annotate({ expected: 'an integer' })),
    name: Schema.String.annotate({
      description:
        'The currency name. For ISO currencies this will be the official\nEnglish name of the currency. For non-ISO currencies no constraints\nare defined.',
    }),
    defaultFractionDigits: Schema.Number.annotate({
      description:
        'The default number of fraction digits (typical scale) used with this\ncurrency. For example, the default number of fraction digits for the\nEuro is 2, while for the Japanese Yen it is 0. This cannot be a\nnegative number.',
    }).check(Schema.isInt().annotate({ expected: 'an integer' })),
    currencyType: CurrencyType,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'MoneyCurrency' });
export type MoneyCurrency = Schema.Schema.Type<typeof MoneyCurrency>;
export type MoneyCurrencyEncoded = Schema.Codec.Encoded<typeof MoneyCurrency>;

/* LocalDateTime */

export const LocalDateTime = Schema.StructWithRest(
  Schema.Struct({
    date: Schema.suspend((): Schema.Codec<LocalDate> => LocalDate),
    time: LocalTime,
    year: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    month: Schema.optionalKey(
      Schema.Literals([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]).annotate({
        description: 'Returns the month-of-year as a Month enum.',
        readOnly: true,
      })
    ),
    monthValue: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns the month-of-year value from 1 to 12.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    dayOfMonth: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    dayOfWeek: Schema.optionalKey(
      Schema.Literals([1, 2, 3, 4, 5, 6, 7]).annotate({ readOnly: true })
    ),
    dayOfYear: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    hour: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    minute: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    second: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    nano: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'LocalDateTime' });
export type LocalDateTime = Schema.Schema.Type<typeof LocalDateTime>;
export type LocalDateTimeEncoded = Schema.Codec.Encoded<typeof LocalDateTime>;

/* Taxonjsonldsyliusshoptaxonindex */

export const Taxonjsonldsyliusshoptaxonindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    listing: Schema.Literals(['ajax', 'inline']),
    visibility: Schema.Literals(['hideInMenu', 'hideCompletely', 'visible']),
    images: Schema.optionalKey(
      Schema.Array(TaxonImagejsonldsyliusshoptaxonindex).annotate({ readOnly: true })
    ),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    nameInTaxonList: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonjsonldsyliusshoptaxonindex' });
export type Taxonjsonldsyliusshoptaxonindex = Schema.Schema.Type<
  typeof Taxonjsonldsyliusshoptaxonindex
>;
export type TaxonjsonldsyliusshoptaxonindexEncoded = Schema.Codec.Encoded<
  typeof Taxonjsonldsyliusshoptaxonindex
>;

/* Articlejsonldsyliusshoparticleindexfavourite */

export const Articlejsonldsyliusshoparticleindexfavourite = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    publishedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    authors: Schema.Array(Authorjsonldsyliusshoparticleindexfavourite),
    thumbnailImageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    title: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Articlejsonldsyliusshoparticleindexfavourite' });
export type Articlejsonldsyliusshoparticleindexfavourite = Schema.Schema.Type<
  typeof Articlejsonldsyliusshoparticleindexfavourite
>;
export type ArticlejsonldsyliusshoparticleindexfavouriteEncoded = Schema.Codec.Encoded<
  typeof Articlejsonldsyliusshoparticleindexfavourite
>;

/* Brandjsonldsyliusshopbrandindexdetail */

export const Brandjsonldsyliusshopbrandindexdetail = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.String.annotate({ format: 'uuid' }),
    code: Schema.String,
    priority: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    page: Schema.Literals(['yes', 'hidden', 'no']),
    image: Schema.Union([BrandImagejsonldsyliusshopbrandindex, Schema.Null]),
    name: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    totalProducts: Schema.optionalKey(
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Brandjsonldsyliusshopbrandindexdetail' });
export type Brandjsonldsyliusshopbrandindexdetail = Schema.Schema.Type<
  typeof Brandjsonldsyliusshopbrandindexdetail
>;
export type BrandjsonldsyliusshopbrandindexdetailEncoded = Schema.Codec.Encoded<
  typeof Brandjsonldsyliusshopbrandindexdetail
>;

/* Brandjsonldsyliusshopbrandindex */

export const Brandjsonldsyliusshopbrandindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.String.annotate({ format: 'uuid' }),
    code: Schema.String,
    priority: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    page: Schema.Literals(['yes', 'hidden', 'no']),
    image: Schema.Union([BrandImagejsonldsyliusshopbrandindex, Schema.Null]),
    name: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Brandjsonldsyliusshopbrandindex' });
export type Brandjsonldsyliusshopbrandindex = Schema.Schema.Type<
  typeof Brandjsonldsyliusshopbrandindex
>;
export type BrandjsonldsyliusshopbrandindexEncoded = Schema.Codec.Encoded<
  typeof Brandjsonldsyliusshopbrandindex
>;

/* Taxonsyliusshoptaxonindex */

export const Taxonsyliusshoptaxonindex = Schema.StructWithRest(
  Schema.Struct({
    listing: Schema.Literals(['ajax', 'inline']),
    visibility: Schema.Literals(['hideInMenu', 'hideCompletely', 'visible']),
    images: Schema.optionalKey(
      Schema.Array(TaxonImagesyliusshoptaxonindex).annotate({ readOnly: true })
    ),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    nameInTaxonList: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonsyliusshoptaxonindex' });
export type Taxonsyliusshoptaxonindex = Schema.Schema.Type<typeof Taxonsyliusshoptaxonindex>;
export type TaxonsyliusshoptaxonindexEncoded = Schema.Codec.Encoded<
  typeof Taxonsyliusshoptaxonindex
>;

/* Articlesyliusshoparticleindexfavourite */

export const Articlesyliusshoparticleindexfavourite = Schema.StructWithRest(
  Schema.Struct({
    publishedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    authors: Schema.Array(Authorsyliusshoparticleindexfavourite),
    thumbnailImageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    title: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Articlesyliusshoparticleindexfavourite' });
export type Articlesyliusshoparticleindexfavourite = Schema.Schema.Type<
  typeof Articlesyliusshoparticleindexfavourite
>;
export type ArticlesyliusshoparticleindexfavouriteEncoded = Schema.Codec.Encoded<
  typeof Articlesyliusshoparticleindexfavourite
>;

/* Brandsyliusshopbrandindexdetail */

export const Brandsyliusshopbrandindexdetail = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.String.annotate({ format: 'uuid' }),
    code: Schema.String,
    priority: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    page: Schema.Literals(['yes', 'hidden', 'no']),
    image: Schema.Union([BrandImagesyliusshopbrandindex, Schema.Null]),
    name: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    totalProducts: Schema.optionalKey(
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Brandsyliusshopbrandindexdetail' });
export type Brandsyliusshopbrandindexdetail = Schema.Schema.Type<
  typeof Brandsyliusshopbrandindexdetail
>;
export type BrandsyliusshopbrandindexdetailEncoded = Schema.Codec.Encoded<
  typeof Brandsyliusshopbrandindexdetail
>;

/* Brandsyliusshopbrandindex */

export const Brandsyliusshopbrandindex = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.String.annotate({ format: 'uuid' }),
    code: Schema.String,
    priority: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    page: Schema.Literals(['yes', 'hidden', 'no']),
    image: Schema.Union([BrandImagesyliusshopbrandindex, Schema.Null]),
    name: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Brandsyliusshopbrandindex' });
export type Brandsyliusshopbrandindex = Schema.Schema.Type<typeof Brandsyliusshopbrandindex>;
export type BrandsyliusshopbrandindexEncoded = Schema.Codec.Encoded<
  typeof Brandsyliusshopbrandindex
>;

/* PaymentMethod */

export const PaymentMethod = Schema.StructWithRest(
  Schema.Struct({
    accountingType: Schema.Union([
      Schema.Literals([
        'Store',
        'Draft',
        'Cash',
        'Postal',
        'Delivery',
        'Creditcard',
        'Advance',
        'Encashment',
        'Cheque',
        'Compensation',
      ]),
      Schema.Null,
    ]),
    image: Schema.Union([PaymentMethodImage, Schema.Null]),
    channels: Schema.Array(Schema.suspend((): Schema.Codec<Channel> => Channel)),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    environment: Schema.Union([Schema.String, Schema.Null]),
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    gatewayConfig: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'iri-reference' }),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
    currentLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    fallbackLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    name: Schema.Union([Schema.String, Schema.Null]),
    channelsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    translation: Schema.Array(
      Schema.suspend((): Schema.Codec<TranslationInterface> => TranslationInterface)
    ),
    translationClass: Schema.optionalKey(
      Schema.Json.annotate({ expected: 'JSON value', readOnly: true })
    ),
    description: Schema.Union([Schema.String, Schema.Null]),
    instructions: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PaymentMethod' });
export type PaymentMethod = Schema.Schema.Type<typeof PaymentMethod>;
export type PaymentMethodEncoded = Schema.Codec.Encoded<typeof PaymentMethod>;

/* FavouriteList */

export const FavouriteList = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(Schema.String.annotate({ readOnly: true, format: 'uuid' })),
    shopUser: Schema.String.annotate({ format: 'iri-reference' }),
    name: Schema.String.annotate({ default: '' }),
    favouriteListProducts: Schema.optionalKey(
      Schema.Array(FavouriteListProductVariant).annotate({ readOnly: true })
    ),
    productVariantCodes: Schema.optionalKey(
      Schema.Array(Schema.String).annotate({ readOnly: true })
    ),
    products: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'FavouriteList' });
export type FavouriteList = Schema.Schema.Type<typeof FavouriteList>;
export type FavouriteListEncoded = Schema.Codec.Encoded<typeof FavouriteList>;

/* OrderUpdateCartsyliusshopcartupdate */

export const OrderUpdateCartsyliusshopcartupdate = Schema.StructWithRest(
  Schema.Struct({
    email: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(254).annotate({ expected: 'a value with a length of at most 254' })
      ),
      Schema.Null,
    ]).annotate({ format: 'email' }),
    billingAddress: Schema.Union([Addresssyliusshopcartupdate, Schema.Null]),
    shippingAddress: Schema.Union([Addresssyliusshopcartupdate, Schema.Null]),
    couponCode: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'OrderUpdateCartsyliusshopcartupdate' });
export type OrderUpdateCartsyliusshopcartupdate = Schema.Schema.Type<
  typeof OrderUpdateCartsyliusshopcartupdate
>;
export type OrderUpdateCartsyliusshopcartupdateEncoded = Schema.Codec.Encoded<
  typeof OrderUpdateCartsyliusshopcartupdate
>;

/* Customersyliusshopcustomerme */

export const Customersyliusshopcustomerme = Schema.StructWithRest(
  Schema.Struct({
    defaultAddress: Schema.Union([Addresssyliusshopcustomerme, Schema.Null]),
    addresses: Schema.Array(Addresssyliusshopcustomerme),
    user: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    email: Schema.String,
    firstName: Schema.Union([Schema.String, Schema.Null]),
    lastName: Schema.Union([Schema.String, Schema.Null]),
    birthday: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    gender: Schema.String.annotate({ default: 'u' }),
    phoneNumber: Schema.Union([Schema.String, Schema.Null]),
    subscribedToNewsletter: Schema.Boolean.annotate({ default: false }),
    fullName: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Customersyliusshopcustomerme' });
export type Customersyliusshopcustomerme = Schema.Schema.Type<typeof Customersyliusshopcustomerme>;
export type CustomersyliusshopcustomermeEncoded = Schema.Codec.Encoded<
  typeof Customersyliusshopcustomerme
>;

/* Storesyliusshopstoreindex */

export const Storesyliusshopstoreindex = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(Schema.String.annotate({ readOnly: true, format: 'uuid' })),
    name: Schema.String.annotate({ default: '' }),
    code: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: "Machine code identifying the store (unique), e.g. 'PCE'",
    }),
    address: Addresssyliusshopstoreindex,
    latitude: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Null,
    ]).annotate({ description: 'GPS latitude in decimal degrees (WGS-84), e.g. 49.9510' }),
    longitude: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Null,
    ]).annotate({ description: 'GPS longitude in decimal degrees (WGS-84), e.g. 15.7959' }),
    openingHours: Schema.Union([
      Schema.Record(Schema.String, Schema.Array(Schema.Record(Schema.String, Schema.String))),
      Schema.Null,
    ]).annotate({
      description:
        'Opening hours keyed by OpeningDay value; each day holds a list of\n{from, to} "HH:MM" intervals (several = breaks in between), an empty\nlist means explicitly closed. Stored as JSON — never queried.',
    }),
    aggregatedOpeningHours: Schema.optionalKey(
      Schema.Array(
        Schema.Record(
          Schema.String,
          Schema.Union([
            Schema.Boolean,
            Schema.Array(Schema.Record(Schema.String, Schema.String)),
            Schema.Array(Schema.String),
            Schema.String,
          ])
        )
      ).annotate({
        description:
          'Consecutive days sharing identical hours grouped together — the structured,\nmachine-readable form of "po–pá: 8–16 hod., so: 9–11 hod.".',
        readOnly: true,
      })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Storesyliusshopstoreindex' });
export type Storesyliusshopstoreindex = Schema.Schema.Type<typeof Storesyliusshopstoreindex>;
export type StoresyliusshopstoreindexEncoded = Schema.Codec.Encoded<
  typeof Storesyliusshopstoreindex
>;

/* CartPromotionRuleHintsjsonld */

export const CartPromotionRuleHintsjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String,
    name: Schema.Union([Schema.String, Schema.Null]),
    label: Schema.Union([Schema.String, Schema.Null]),
    shippingDiscountRuleHint: Schema.Union([ShippingDiscountRuleHintjsonld, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CartPromotionRuleHintsjsonld' });
export type CartPromotionRuleHintsjsonld = Schema.Schema.Type<typeof CartPromotionRuleHintsjsonld>;
export type CartPromotionRuleHintsjsonldEncoded = Schema.Codec.Encoded<
  typeof CartPromotionRuleHintsjsonld
>;

/* BigDecimaljsonld */

export const BigDecimaljsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    scale: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'The scale (number of digits after the decimal point) of this decimal number.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    sign: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    unscaledValue: BigIntegerjsonld,
    precision: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns the number of significant digits in the number.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    integralPart: Schema.optionalKey(
      Schema.String.annotate({
        description: 'Returns a string representing the integral part of this decimal number.',
        readOnly: true,
      })
    ),
    fractionalPart: Schema.optionalKey(
      Schema.String.annotate({
        description: 'Returns a string representing the fractional part of this decimal number.',
        readOnly: true,
      })
    ),
    nonZeroFractionalPart: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Returns whether this decimal number has a non-zero fractional part.',
        readOnly: true,
      })
    ),
    zero: Schema.optionalKey(
      Schema.Boolean.annotate({ description: 'Checks if this number equals zero.', readOnly: true })
    ),
    negative: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Checks if this number is strictly negative.',
        readOnly: true,
      })
    ),
    negativeOrZero: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Checks if this number is negative or zero.',
        readOnly: true,
      })
    ),
    positive: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Checks if this number is strictly positive.',
        readOnly: true,
      })
    ),
    positiveOrZero: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Checks if this number is positive or zero.',
        readOnly: true,
      })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'BigDecimaljsonld' });
export type BigDecimaljsonld = Schema.Schema.Type<typeof BigDecimaljsonld>;
export type BigDecimaljsonldEncoded = Schema.Codec.Encoded<typeof BigDecimaljsonld>;

/* MoneyCurrencyjsonld */

export const MoneyCurrencyjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    currencyCode: Schema.String.annotate({
      description:
        'The currency code. For ISO currencies this will be the 3-letter\nuppercase ISO 4217 currency code. For non-ISO currencies no\nconstraints are defined, but the code must be unique across an\napplication and must not conflict with ISO currency codes.',
    }),
    numericCode: Schema.Number.annotate({
      description:
        'The numeric currency code. For ISO currencies this will be the\nISO 4217 numeric currency code, without leading zeros. For non-ISO\ncurrencies no constraints are defined, but the code must be unique\nacross an application and must not conflict with ISO currency codes.\nSet to zero if the currency does not have a numeric code.',
    }).check(Schema.isInt().annotate({ expected: 'an integer' })),
    name: Schema.String.annotate({
      description:
        'The currency name. For ISO currencies this will be the official\nEnglish name of the currency. For non-ISO currencies no constraints\nare defined.',
    }),
    defaultFractionDigits: Schema.Number.annotate({
      description:
        'The default number of fraction digits (typical scale) used with this\ncurrency. For example, the default number of fraction digits for the\nEuro is 2, while for the Japanese Yen it is 0. This cannot be a\nnegative number.',
    }).check(Schema.isInt().annotate({ expected: 'an integer' })),
    currencyType: CurrencyTypejsonld,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'MoneyCurrencyjsonld' });
export type MoneyCurrencyjsonld = Schema.Schema.Type<typeof MoneyCurrencyjsonld>;
export type MoneyCurrencyjsonldEncoded = Schema.Codec.Encoded<typeof MoneyCurrencyjsonld>;

/* LocalDateTimejsonld */

export const LocalDateTimejsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    date: Schema.suspend((): Schema.Codec<LocalDatejsonld> => LocalDatejsonld),
    time: LocalTimejsonld,
    year: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    month: Schema.optionalKey(
      Schema.Literals([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]).annotate({
        description: 'Returns the month-of-year as a Month enum.',
        readOnly: true,
      })
    ),
    monthValue: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns the month-of-year value from 1 to 12.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    dayOfMonth: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    dayOfWeek: Schema.optionalKey(
      Schema.Literals([1, 2, 3, 4, 5, 6, 7]).annotate({ readOnly: true })
    ),
    dayOfYear: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    hour: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    minute: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    second: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    nano: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'LocalDateTimejsonld' });
export type LocalDateTimejsonld = Schema.Schema.Type<typeof LocalDateTimejsonld>;
export type LocalDateTimejsonldEncoded = Schema.Codec.Encoded<typeof LocalDateTimejsonld>;

/* PaymentMethodjsonld */

export const PaymentMethodjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    accountingType: Schema.Union([
      Schema.Literals([
        'Store',
        'Draft',
        'Cash',
        'Postal',
        'Delivery',
        'Creditcard',
        'Advance',
        'Encashment',
        'Cheque',
        'Compensation',
      ]),
      Schema.Null,
    ]),
    image: Schema.Union([PaymentMethodImagejsonld, Schema.Null]),
    channels: Schema.Array(Schema.suspend((): Schema.Codec<Channeljsonld> => Channeljsonld)),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    environment: Schema.Union([Schema.String, Schema.Null]),
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    gatewayConfig: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'iri-reference' }),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
    currentLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    fallbackLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    name: Schema.Union([Schema.String, Schema.Null]),
    channelsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    translation: Schema.Array(
      Schema.suspend((): Schema.Codec<TranslationInterfacejsonld> => TranslationInterfacejsonld)
    ),
    translationClass: Schema.optionalKey(
      Schema.Json.annotate({ expected: 'JSON value', readOnly: true })
    ),
    description: Schema.Union([Schema.String, Schema.Null]),
    instructions: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PaymentMethodjsonld' });
export type PaymentMethodjsonld = Schema.Schema.Type<typeof PaymentMethodjsonld>;
export type PaymentMethodjsonldEncoded = Schema.Codec.Encoded<typeof PaymentMethodjsonld>;

/* FavouriteListjsonld */

export const FavouriteListjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(Schema.String.annotate({ readOnly: true, format: 'uuid' })),
    shopUser: Schema.String.annotate({ format: 'iri-reference' }),
    name: Schema.String.annotate({ default: '' }),
    favouriteListProducts: Schema.optionalKey(
      Schema.Array(FavouriteListProductVariantjsonld).annotate({ readOnly: true })
    ),
    productVariantCodes: Schema.optionalKey(
      Schema.Array(Schema.String).annotate({ readOnly: true })
    ),
    products: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'FavouriteListjsonld' });
export type FavouriteListjsonld = Schema.Schema.Type<typeof FavouriteListjsonld>;
export type FavouriteListjsonldEncoded = Schema.Codec.Encoded<typeof FavouriteListjsonld>;

/* OrderUpdateCartjsonldsyliusshopcartupdate */

export const OrderUpdateCartjsonldsyliusshopcartupdate = Schema.StructWithRest(
  Schema.Struct({
    email: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(254).annotate({ expected: 'a value with a length of at most 254' })
      ),
      Schema.Null,
    ]).annotate({ format: 'email' }),
    billingAddress: Schema.Union([Addressjsonldsyliusshopcartupdate, Schema.Null]),
    shippingAddress: Schema.Union([Addressjsonldsyliusshopcartupdate, Schema.Null]),
    couponCode: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'OrderUpdateCartjsonldsyliusshopcartupdate' });
export type OrderUpdateCartjsonldsyliusshopcartupdate = Schema.Schema.Type<
  typeof OrderUpdateCartjsonldsyliusshopcartupdate
>;
export type OrderUpdateCartjsonldsyliusshopcartupdateEncoded = Schema.Codec.Encoded<
  typeof OrderUpdateCartjsonldsyliusshopcartupdate
>;

/* Customerjsonldsyliusshopcustomerme */

export const Customerjsonldsyliusshopcustomerme = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    defaultAddress: Schema.Union([Addressjsonldsyliusshopcustomerme, Schema.Null]),
    addresses: Schema.Array(Addressjsonldsyliusshopcustomerme),
    user: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    email: Schema.String,
    firstName: Schema.Union([Schema.String, Schema.Null]),
    lastName: Schema.Union([Schema.String, Schema.Null]),
    birthday: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    gender: Schema.String.annotate({ default: 'u' }),
    phoneNumber: Schema.Union([Schema.String, Schema.Null]),
    subscribedToNewsletter: Schema.Boolean.annotate({ default: false }),
    fullName: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Customerjsonldsyliusshopcustomerme' });
export type Customerjsonldsyliusshopcustomerme = Schema.Schema.Type<
  typeof Customerjsonldsyliusshopcustomerme
>;
export type CustomerjsonldsyliusshopcustomermeEncoded = Schema.Codec.Encoded<
  typeof Customerjsonldsyliusshopcustomerme
>;

/* Storejsonldsyliusshopstoreindex */

export const Storejsonldsyliusshopstoreindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(Schema.String.annotate({ readOnly: true, format: 'uuid' })),
    name: Schema.String.annotate({ default: '' }),
    code: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: "Machine code identifying the store (unique), e.g. 'PCE'",
    }),
    address: Addressjsonldsyliusshopstoreindex,
    latitude: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Null,
    ]).annotate({ description: 'GPS latitude in decimal degrees (WGS-84), e.g. 49.9510' }),
    longitude: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Null,
    ]).annotate({ description: 'GPS longitude in decimal degrees (WGS-84), e.g. 15.7959' }),
    openingHours: Schema.Union([
      Schema.Record(Schema.String, Schema.Array(Schema.Record(Schema.String, Schema.String))),
      Schema.Null,
    ]).annotate({
      description:
        'Opening hours keyed by OpeningDay value; each day holds a list of\n{from, to} "HH:MM" intervals (several = breaks in between), an empty\nlist means explicitly closed. Stored as JSON — never queried.',
    }),
    aggregatedOpeningHours: Schema.optionalKey(
      Schema.Array(
        Schema.Record(
          Schema.String,
          Schema.Union([
            Schema.Boolean,
            Schema.Array(Schema.Record(Schema.String, Schema.String)),
            Schema.Array(Schema.String),
            Schema.String,
          ])
        )
      ).annotate({
        description:
          'Consecutive days sharing identical hours grouped together — the structured,\nmachine-readable form of "po–pá: 8–16 hod., so: 9–11 hod.".',
        readOnly: true,
      })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Storejsonldsyliusshopstoreindex' });
export type Storejsonldsyliusshopstoreindex = Schema.Schema.Type<
  typeof Storejsonldsyliusshopstoreindex
>;
export type StorejsonldsyliusshopstoreindexEncoded = Schema.Codec.Encoded<
  typeof Storejsonldsyliusshopstoreindex
>;

/* Administrator */

export const Administrator = Schema.StructWithRest(
  Schema.Struct({
    firstName: Schema.Union([Schema.String, Schema.Null]),
    lastName: Schema.Union([Schema.String, Schema.Null]),
    localeCode: Schema.String,
    avatar: Schema.Union([AvatarImage, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    username: Schema.Union([Schema.String, Schema.Null]),
    usernameCanonical: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'Normalized representation of a username.',
    }),
    password: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'Encrypted password. Must be persisted.',
    }),
    plainPassword: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'Password before encryption. Used for model validation. Must not be persisted.',
      writeOnly: true,
    }),
    lastLogin: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    emailVerificationToken: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'Random string sent to the user email address in order to verify it',
    }),
    passwordResetToken: Schema.Union([Schema.String, Schema.Null]).annotate({
      description:
        'Random string sent to the user email address in order to verify the password resetting request',
    }),
    passwordRequestedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    verifiedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    roles: Schema.Array(Schema.Union([Schema.String, Schema.Null])).annotate({
      description: 'We need at least one role to be able to authenticate',
      default: ['ROLE_USER'],
    }),
    oauthAccounts: Schema.Array(Schema.suspend((): Schema.Codec<UserOAuth> => UserOAuth)),
    email: Schema.Union([Schema.String, Schema.Null]),
    emailCanonical: Schema.Union([Schema.String, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    enabled: Schema.Boolean.annotate({ default: true }),
    image: Schema.Union([ImageInterface, Schema.Null]),
    oAuthAccountsTyped: Schema.optionalKey(
      Schema.Array(Schema.suspend((): Schema.Codec<UserOAuth> => UserOAuth)).annotate({
        readOnly: true,
      })
    ),
    userIdentifier: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    verified: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    oAuthAccounts: Schema.Array(Schema.suspend((): Schema.Codec<UserOAuth> => UserOAuth)),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Administrator' });
export type Administrator = Schema.Schema.Type<typeof Administrator>;
export type AdministratorEncoded = Schema.Codec.Encoded<typeof Administrator>;

/* Administratorjsonld */

export const Administratorjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    firstName: Schema.Union([Schema.String, Schema.Null]),
    lastName: Schema.Union([Schema.String, Schema.Null]),
    localeCode: Schema.String,
    avatar: Schema.Union([AvatarImagejsonld, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    username: Schema.Union([Schema.String, Schema.Null]),
    usernameCanonical: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'Normalized representation of a username.',
    }),
    password: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'Encrypted password. Must be persisted.',
    }),
    plainPassword: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'Password before encryption. Used for model validation. Must not be persisted.',
      writeOnly: true,
    }),
    lastLogin: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    emailVerificationToken: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'Random string sent to the user email address in order to verify it',
    }),
    passwordResetToken: Schema.Union([Schema.String, Schema.Null]).annotate({
      description:
        'Random string sent to the user email address in order to verify the password resetting request',
    }),
    passwordRequestedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    verifiedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    roles: Schema.Array(Schema.Union([Schema.String, Schema.Null])).annotate({
      description: 'We need at least one role to be able to authenticate',
      default: ['ROLE_USER'],
    }),
    oauthAccounts: Schema.Array(
      Schema.suspend((): Schema.Codec<UserOAuthjsonld> => UserOAuthjsonld)
    ),
    email: Schema.Union([Schema.String, Schema.Null]),
    emailCanonical: Schema.Union([Schema.String, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    enabled: Schema.Boolean.annotate({ default: true }),
    image: Schema.Union([ImageInterfacejsonld, Schema.Null]),
    oAuthAccountsTyped: Schema.optionalKey(
      Schema.Array(Schema.suspend((): Schema.Codec<UserOAuthjsonld> => UserOAuthjsonld)).annotate({
        readOnly: true,
      })
    ),
    userIdentifier: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    verified: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    oAuthAccounts: Schema.Array(
      Schema.suspend((): Schema.Codec<UserOAuthjsonld> => UserOAuthjsonld)
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Administratorjsonld' });
export type Administratorjsonld = Schema.Schema.Type<typeof Administratorjsonld>;
export type AdministratorjsonldEncoded = Schema.Codec.Encoded<typeof Administratorjsonld>;

/* Categorysyliusshoparticleindex */

export const Categorysyliusshoparticleindex = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.String.annotate({ format: 'uuid' }),
    code: Schema.String,
    image: Schema.Union([CategoryImagesyliusshoparticleindex, Schema.Null]),
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Categorysyliusshoparticleindex' });
export type Categorysyliusshoparticleindex = Schema.Schema.Type<
  typeof Categorysyliusshoparticleindex
>;
export type CategorysyliusshoparticleindexEncoded = Schema.Codec.Encoded<
  typeof Categorysyliusshoparticleindex
>;

/* Categorysyliusshoparticleshow */

export const Categorysyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.String.annotate({ format: 'uuid' }),
    code: Schema.String,
    image: Schema.Union([CategoryImagesyliusshoparticleshow, Schema.Null]),
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    metaDescription: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Categorysyliusshoparticleshow' });
export type Categorysyliusshoparticleshow = Schema.Schema.Type<
  typeof Categorysyliusshoparticleshow
>;
export type CategorysyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof Categorysyliusshoparticleshow
>;

/* ImageCollectionElementDTOsyliusshoparticleshow */

export const ImageCollectionElementDTOsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    images: Schema.Array(ImageItemDTOsyliusshoparticleshow),
    type: Schema.Literal('image_collection').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ImageCollectionElementDTOsyliusshoparticleshow' });
export type ImageCollectionElementDTOsyliusshoparticleshow = Schema.Schema.Type<
  typeof ImageCollectionElementDTOsyliusshoparticleshow
>;
export type ImageCollectionElementDTOsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof ImageCollectionElementDTOsyliusshoparticleshow
>;

/* ImagePairElementDTOsyliusshoparticleshow */

export const ImagePairElementDTOsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    first: Schema.Union([ImageItemDTOsyliusshoparticleshow, Schema.Null]),
    second: Schema.Union([ImageItemDTOsyliusshoparticleshow, Schema.Null]),
    type: Schema.Literal('image_pair').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ImagePairElementDTOsyliusshoparticleshow' });
export type ImagePairElementDTOsyliusshoparticleshow = Schema.Schema.Type<
  typeof ImagePairElementDTOsyliusshoparticleshow
>;
export type ImagePairElementDTOsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof ImagePairElementDTOsyliusshoparticleshow
>;

/* MarkdownTextWithImageElementDTOsyliusshoparticleshow */

export const MarkdownTextWithImageElementDTOsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    text: Schema.String,
    image: ImageItemDTOsyliusshoparticleshow,
    direction: Schema.Literals(['textImage', 'imageText']),
    type: Schema.Literal('markdown_text_with_image').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'MarkdownTextWithImageElementDTOsyliusshoparticleshow' });
export type MarkdownTextWithImageElementDTOsyliusshoparticleshow = Schema.Schema.Type<
  typeof MarkdownTextWithImageElementDTOsyliusshoparticleshow
>;
export type MarkdownTextWithImageElementDTOsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof MarkdownTextWithImageElementDTOsyliusshoparticleshow
>;

/* Productsyliusshoparticleshow */

export const Productsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    ageRestriction: Schema.Literals(['none', '18+']),
    averageRating: Schema.Number.annotate({ default: 0 }).check(
      Schema.isFinite().annotate({ expected: 'a finite number' })
    ),
    code: Schema.String,
    createdAt: Schema.optionalKey(DateTimeSerializableFromString),
    updatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    mainImage: Schema.optionalKey(
      Schema.Union([ProductImagesyliusshoparticleshow, Schema.Null]).annotate({ readOnly: true })
    ),
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    shortDescription: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    subtitle: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Productsyliusshoparticleshow' });
export type Productsyliusshoparticleshow = Schema.Schema.Type<typeof Productsyliusshoparticleshow>;
export type ProductsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof Productsyliusshoparticleshow
>;

/* TeamMemberItemDTOsyliusshoparticleshow */

export const TeamMemberItemDTOsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    name: Schema.String,
    position: Schema.Union([Schema.String, Schema.Null]),
    phone: Schema.Union([Schema.String, Schema.Null]),
    email: Schema.Union([Schema.String, Schema.Null]),
    avatar: Schema.Union([ImageClearItemDTOsyliusshoparticleshow, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TeamMemberItemDTOsyliusshoparticleshow' });
export type TeamMemberItemDTOsyliusshoparticleshow = Schema.Schema.Type<
  typeof TeamMemberItemDTOsyliusshoparticleshow
>;
export type TeamMemberItemDTOsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof TeamMemberItemDTOsyliusshoparticleshow
>;

/* ButtonGridItemDTOsyliusshoparticleshow */

export const ButtonGridItemDTOsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    link: Schema.String,
    text: Schema.String,
    image: Schema.Union([ImageClearItemDTOsyliusshoparticleshow, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ButtonGridItemDTOsyliusshoparticleshow' });
export type ButtonGridItemDTOsyliusshoparticleshow = Schema.Schema.Type<
  typeof ButtonGridItemDTOsyliusshoparticleshow
>;
export type ButtonGridItemDTOsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof ButtonGridItemDTOsyliusshoparticleshow
>;

/* TableRowItemDTOsyliusshoparticleshow */

export const TableRowItemDTOsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({ cells: Schema.Array(TableCellItemDTOsyliusshoparticleshow) }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TableRowItemDTOsyliusshoparticleshow' });
export type TableRowItemDTOsyliusshoparticleshow = Schema.Schema.Type<
  typeof TableRowItemDTOsyliusshoparticleshow
>;
export type TableRowItemDTOsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof TableRowItemDTOsyliusshoparticleshow
>;

/* Articlesyliusshophomepageshow */

export const Articlesyliusshophomepageshow = Schema.StructWithRest(
  Schema.Struct({
    section: Sectionsyliusshophomepageshow,
    tags: Schema.Array(Tagsyliusshophomepageshow),
    publishedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    authors: Schema.Array(Authorsyliusshophomepageshow),
    thumbnailImageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    title: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Articlesyliusshophomepageshow' });
export type Articlesyliusshophomepageshow = Schema.Schema.Type<
  typeof Articlesyliusshophomepageshow
>;
export type ArticlesyliusshophomepageshowEncoded = Schema.Codec.Encoded<
  typeof Articlesyliusshophomepageshow
>;

/* Categoryjsonldsyliusshoparticleindex */

export const Categoryjsonldsyliusshoparticleindex = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.String.annotate({ format: 'uuid' }),
    code: Schema.String,
    image: Schema.Union([CategoryImagejsonldsyliusshoparticleindex, Schema.Null]),
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Categoryjsonldsyliusshoparticleindex' });
export type Categoryjsonldsyliusshoparticleindex = Schema.Schema.Type<
  typeof Categoryjsonldsyliusshoparticleindex
>;
export type CategoryjsonldsyliusshoparticleindexEncoded = Schema.Codec.Encoded<
  typeof Categoryjsonldsyliusshoparticleindex
>;

/* Categoryjsonldsyliusshoparticleshow */

export const Categoryjsonldsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.String.annotate({ format: 'uuid' }),
    code: Schema.String,
    image: Schema.Union([CategoryImagejsonldsyliusshoparticleshow, Schema.Null]),
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    metaDescription: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Categoryjsonldsyliusshoparticleshow' });
export type Categoryjsonldsyliusshoparticleshow = Schema.Schema.Type<
  typeof Categoryjsonldsyliusshoparticleshow
>;
export type CategoryjsonldsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof Categoryjsonldsyliusshoparticleshow
>;

/* ImageCollectionElementDTOjsonldsyliusshoparticleshow */

export const ImageCollectionElementDTOjsonldsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    images: Schema.Array(ImageItemDTOjsonldsyliusshoparticleshow),
    type: Schema.Literal('image_collection').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ImageCollectionElementDTOjsonldsyliusshoparticleshow' });
export type ImageCollectionElementDTOjsonldsyliusshoparticleshow = Schema.Schema.Type<
  typeof ImageCollectionElementDTOjsonldsyliusshoparticleshow
>;
export type ImageCollectionElementDTOjsonldsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof ImageCollectionElementDTOjsonldsyliusshoparticleshow
>;

/* ImagePairElementDTOjsonldsyliusshoparticleshow */

export const ImagePairElementDTOjsonldsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    first: Schema.Union([ImageItemDTOjsonldsyliusshoparticleshow, Schema.Null]),
    second: Schema.Union([ImageItemDTOjsonldsyliusshoparticleshow, Schema.Null]),
    type: Schema.Literal('image_pair').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ImagePairElementDTOjsonldsyliusshoparticleshow' });
export type ImagePairElementDTOjsonldsyliusshoparticleshow = Schema.Schema.Type<
  typeof ImagePairElementDTOjsonldsyliusshoparticleshow
>;
export type ImagePairElementDTOjsonldsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof ImagePairElementDTOjsonldsyliusshoparticleshow
>;

/* MarkdownTextWithImageElementDTOjsonldsyliusshoparticleshow */

export const MarkdownTextWithImageElementDTOjsonldsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    text: Schema.String,
    image: ImageItemDTOjsonldsyliusshoparticleshow,
    direction: Schema.Literals(['textImage', 'imageText']),
    type: Schema.Literal('markdown_text_with_image').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'MarkdownTextWithImageElementDTOjsonldsyliusshoparticleshow' });
export type MarkdownTextWithImageElementDTOjsonldsyliusshoparticleshow = Schema.Schema.Type<
  typeof MarkdownTextWithImageElementDTOjsonldsyliusshoparticleshow
>;
export type MarkdownTextWithImageElementDTOjsonldsyliusshoparticleshowEncoded =
  Schema.Codec.Encoded<typeof MarkdownTextWithImageElementDTOjsonldsyliusshoparticleshow>;

/* Productjsonldsyliusshoparticleshow */

export const Productjsonldsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    ageRestriction: Schema.Literals(['none', '18+']),
    averageRating: Schema.Number.annotate({ default: 0 }).check(
      Schema.isFinite().annotate({ expected: 'a finite number' })
    ),
    code: Schema.String,
    createdAt: Schema.optionalKey(DateTimeSerializableFromString),
    updatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    mainImage: Schema.optionalKey(
      Schema.Union([ProductImagejsonldsyliusshoparticleshow, Schema.Null]).annotate({
        readOnly: true,
      })
    ),
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    shortDescription: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    subtitle: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Productjsonldsyliusshoparticleshow' });
export type Productjsonldsyliusshoparticleshow = Schema.Schema.Type<
  typeof Productjsonldsyliusshoparticleshow
>;
export type ProductjsonldsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof Productjsonldsyliusshoparticleshow
>;

/* TeamMemberItemDTOjsonldsyliusshoparticleshow */

export const TeamMemberItemDTOjsonldsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    name: Schema.String,
    position: Schema.Union([Schema.String, Schema.Null]),
    phone: Schema.Union([Schema.String, Schema.Null]),
    email: Schema.Union([Schema.String, Schema.Null]),
    avatar: Schema.Union([ImageClearItemDTOjsonldsyliusshoparticleshow, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TeamMemberItemDTOjsonldsyliusshoparticleshow' });
export type TeamMemberItemDTOjsonldsyliusshoparticleshow = Schema.Schema.Type<
  typeof TeamMemberItemDTOjsonldsyliusshoparticleshow
>;
export type TeamMemberItemDTOjsonldsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof TeamMemberItemDTOjsonldsyliusshoparticleshow
>;

/* ButtonGridItemDTOjsonldsyliusshoparticleshow */

export const ButtonGridItemDTOjsonldsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    link: Schema.String,
    text: Schema.String,
    image: Schema.Union([ImageClearItemDTOjsonldsyliusshoparticleshow, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ButtonGridItemDTOjsonldsyliusshoparticleshow' });
export type ButtonGridItemDTOjsonldsyliusshoparticleshow = Schema.Schema.Type<
  typeof ButtonGridItemDTOjsonldsyliusshoparticleshow
>;
export type ButtonGridItemDTOjsonldsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof ButtonGridItemDTOjsonldsyliusshoparticleshow
>;

/* TableRowItemDTOjsonldsyliusshoparticleshow */

export const TableRowItemDTOjsonldsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    cells: Schema.Array(TableCellItemDTOjsonldsyliusshoparticleshow),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TableRowItemDTOjsonldsyliusshoparticleshow' });
export type TableRowItemDTOjsonldsyliusshoparticleshow = Schema.Schema.Type<
  typeof TableRowItemDTOjsonldsyliusshoparticleshow
>;
export type TableRowItemDTOjsonldsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof TableRowItemDTOjsonldsyliusshoparticleshow
>;

/* Articlejsonldsyliusshophomepageshow */

export const Articlejsonldsyliusshophomepageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    section: Sectionjsonldsyliusshophomepageshow,
    tags: Schema.Array(Tagjsonldsyliusshophomepageshow),
    publishedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    authors: Schema.Array(Authorjsonldsyliusshophomepageshow),
    thumbnailImageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    title: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Articlejsonldsyliusshophomepageshow' });
export type Articlejsonldsyliusshophomepageshow = Schema.Schema.Type<
  typeof Articlejsonldsyliusshophomepageshow
>;
export type ArticlejsonldsyliusshophomepageshowEncoded = Schema.Codec.Encoded<
  typeof Articlejsonldsyliusshophomepageshow
>;

/* Brandsyliusshopbrandshow */

export const Brandsyliusshopbrandshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.String.annotate({ format: 'uuid' }),
    code: Schema.String,
    priority: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    page: Schema.Literals(['yes', 'hidden', 'no']),
    image: Schema.Union([BrandImagesyliusshopbrandshow, Schema.Null]),
    name: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Brandsyliusshopbrandshow' });
export type Brandsyliusshopbrandshow = Schema.Schema.Type<typeof Brandsyliusshopbrandshow>;
export type BrandsyliusshopbrandshowEncoded = Schema.Codec.Encoded<typeof Brandsyliusshopbrandshow>;

/* Brandsyliusshophomepageshow */

export const Brandsyliusshophomepageshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.String.annotate({ format: 'uuid' }),
    code: Schema.String,
    priority: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    page: Schema.Literals(['yes', 'hidden', 'no']),
    image: Schema.Union([BrandImagesyliusshophomepageshow, Schema.Null]),
    name: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Brandsyliusshophomepageshow' });
export type Brandsyliusshophomepageshow = Schema.Schema.Type<typeof Brandsyliusshophomepageshow>;
export type BrandsyliusshophomepageshowEncoded = Schema.Codec.Encoded<
  typeof Brandsyliusshophomepageshow
>;

/* Brandsyliusshopproductshowsyliusshopproductshowdetail */

export const Brandsyliusshopproductshowsyliusshopproductshowdetail = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.String.annotate({ format: 'uuid' }),
    code: Schema.String,
    page: Schema.Literals(['yes', 'hidden', 'no']),
    image: Schema.Union([BrandImagesyliusshopproductshowsyliusshopproductshowdetail, Schema.Null]),
    name: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Brandsyliusshopproductshowsyliusshopproductshowdetail' });
export type Brandsyliusshopproductshowsyliusshopproductshowdetail = Schema.Schema.Type<
  typeof Brandsyliusshopproductshowsyliusshopproductshowdetail
>;
export type BrandsyliusshopproductshowsyliusshopproductshowdetailEncoded = Schema.Codec.Encoded<
  typeof Brandsyliusshopproductshowsyliusshopproductshowdetail
>;

/* Brandjsonldsyliusshopbrandshow */

export const Brandjsonldsyliusshopbrandshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.String.annotate({ format: 'uuid' }),
    code: Schema.String,
    priority: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    page: Schema.Literals(['yes', 'hidden', 'no']),
    image: Schema.Union([BrandImagejsonldsyliusshopbrandshow, Schema.Null]),
    name: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Brandjsonldsyliusshopbrandshow' });
export type Brandjsonldsyliusshopbrandshow = Schema.Schema.Type<
  typeof Brandjsonldsyliusshopbrandshow
>;
export type BrandjsonldsyliusshopbrandshowEncoded = Schema.Codec.Encoded<
  typeof Brandjsonldsyliusshopbrandshow
>;

/* Brandjsonldsyliusshophomepageshow */

export const Brandjsonldsyliusshophomepageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.String.annotate({ format: 'uuid' }),
    code: Schema.String,
    priority: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    page: Schema.Literals(['yes', 'hidden', 'no']),
    image: Schema.Union([BrandImagejsonldsyliusshophomepageshow, Schema.Null]),
    name: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Brandjsonldsyliusshophomepageshow' });
export type Brandjsonldsyliusshophomepageshow = Schema.Schema.Type<
  typeof Brandjsonldsyliusshophomepageshow
>;
export type BrandjsonldsyliusshophomepageshowEncoded = Schema.Codec.Encoded<
  typeof Brandjsonldsyliusshophomepageshow
>;

/* Brandjsonldsyliusshopproductshowsyliusshopproductshowdetail */

export const Brandjsonldsyliusshopproductshowsyliusshopproductshowdetail = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.String.annotate({ format: 'uuid' }),
    code: Schema.String,
    page: Schema.Literals(['yes', 'hidden', 'no']),
    image: Schema.Union([
      BrandImagejsonldsyliusshopproductshowsyliusshopproductshowdetail,
      Schema.Null,
    ]),
    name: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Brandjsonldsyliusshopproductshowsyliusshopproductshowdetail' });
export type Brandjsonldsyliusshopproductshowsyliusshopproductshowdetail = Schema.Schema.Type<
  typeof Brandjsonldsyliusshopproductshowsyliusshopproductshowdetail
>;
export type BrandjsonldsyliusshopproductshowsyliusshopproductshowdetailEncoded =
  Schema.Codec.Encoded<typeof Brandjsonldsyliusshopproductshowsyliusshopproductshowdetail>;

/* CartPromotionRuleHintssyliusshopcartshow */

export const CartPromotionRuleHintssyliusshopcartshow = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String,
    name: Schema.Union([Schema.String, Schema.Null]),
    label: Schema.Union([Schema.String, Schema.Null]),
    shippingDiscountRuleHint: Schema.Union([
      ShippingDiscountRuleHintsyliusshopcartshow,
      Schema.Null,
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CartPromotionRuleHintssyliusshopcartshow' });
export type CartPromotionRuleHintssyliusshopcartshow = Schema.Schema.Type<
  typeof CartPromotionRuleHintssyliusshopcartshow
>;
export type CartPromotionRuleHintssyliusshopcartshowEncoded = Schema.Codec.Encoded<
  typeof CartPromotionRuleHintssyliusshopcartshow
>;

/* CartPromotionRuleHintssyliusshopcartshowsyliusshopcartshowdetail */

export const CartPromotionRuleHintssyliusshopcartshowsyliusshopcartshowdetail =
  Schema.StructWithRest(
    Schema.Struct({
      code: Schema.String,
      name: Schema.Union([Schema.String, Schema.Null]),
      label: Schema.Union([Schema.String, Schema.Null]),
      shippingDiscountRuleHint: Schema.Union([
        ShippingDiscountRuleHintsyliusshopcartshowsyliusshopcartshowdetail,
        Schema.Null,
      ]),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({ identifier: 'CartPromotionRuleHintssyliusshopcartshowsyliusshopcartshowdetail' });
export type CartPromotionRuleHintssyliusshopcartshowsyliusshopcartshowdetail = Schema.Schema.Type<
  typeof CartPromotionRuleHintssyliusshopcartshowsyliusshopcartshowdetail
>;
export type CartPromotionRuleHintssyliusshopcartshowsyliusshopcartshowdetailEncoded =
  Schema.Codec.Encoded<typeof CartPromotionRuleHintssyliusshopcartshowsyliusshopcartshowdetail>;

/* CartPromotionRuleHintssyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const CartPromotionRuleHintssyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      code: Schema.String,
      name: Schema.Union([Schema.String, Schema.Null]),
      label: Schema.Union([Schema.String, Schema.Null]),
      shippingDiscountRuleHint: Schema.Union([
        ShippingDiscountRuleHintsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
        Schema.Null,
      ]),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'CartPromotionRuleHintssyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type CartPromotionRuleHintssyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof CartPromotionRuleHintssyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type CartPromotionRuleHintssyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof CartPromotionRuleHintssyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* CartPromotionRuleHintssyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const CartPromotionRuleHintssyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      code: Schema.String,
      name: Schema.Union([Schema.String, Schema.Null]),
      label: Schema.Union([Schema.String, Schema.Null]),
      shippingDiscountRuleHint: Schema.Union([
        ShippingDiscountRuleHintsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
        Schema.Null,
      ]),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'CartPromotionRuleHintssyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type CartPromotionRuleHintssyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof CartPromotionRuleHintssyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type CartPromotionRuleHintssyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof CartPromotionRuleHintssyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* CartPromotionRuleHintsjsonldsyliusshopcartshow */

export const CartPromotionRuleHintsjsonldsyliusshopcartshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String,
    name: Schema.Union([Schema.String, Schema.Null]),
    label: Schema.Union([Schema.String, Schema.Null]),
    shippingDiscountRuleHint: Schema.Union([
      ShippingDiscountRuleHintjsonldsyliusshopcartshow,
      Schema.Null,
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CartPromotionRuleHintsjsonldsyliusshopcartshow' });
export type CartPromotionRuleHintsjsonldsyliusshopcartshow = Schema.Schema.Type<
  typeof CartPromotionRuleHintsjsonldsyliusshopcartshow
>;
export type CartPromotionRuleHintsjsonldsyliusshopcartshowEncoded = Schema.Codec.Encoded<
  typeof CartPromotionRuleHintsjsonldsyliusshopcartshow
>;

/* CartPromotionRuleHintsjsonldsyliusshopcartshowsyliusshopcartshowdetail */

export const CartPromotionRuleHintsjsonldsyliusshopcartshowsyliusshopcartshowdetail =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      code: Schema.String,
      name: Schema.Union([Schema.String, Schema.Null]),
      label: Schema.Union([Schema.String, Schema.Null]),
      shippingDiscountRuleHint: Schema.Union([
        ShippingDiscountRuleHintjsonldsyliusshopcartshowsyliusshopcartshowdetail,
        Schema.Null,
      ]),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier: 'CartPromotionRuleHintsjsonldsyliusshopcartshowsyliusshopcartshowdetail',
  });
export type CartPromotionRuleHintsjsonldsyliusshopcartshowsyliusshopcartshowdetail =
  Schema.Schema.Type<typeof CartPromotionRuleHintsjsonldsyliusshopcartshowsyliusshopcartshowdetail>;
export type CartPromotionRuleHintsjsonldsyliusshopcartshowsyliusshopcartshowdetailEncoded =
  Schema.Codec.Encoded<
    typeof CartPromotionRuleHintsjsonldsyliusshopcartshowsyliusshopcartshowdetail
  >;

/* CartPromotionRuleHintsjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const CartPromotionRuleHintsjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      code: Schema.String,
      name: Schema.Union([Schema.String, Schema.Null]),
      label: Schema.Union([Schema.String, Schema.Null]),
      shippingDiscountRuleHint: Schema.Union([
        ShippingDiscountRuleHintjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
        Schema.Null,
      ]),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'CartPromotionRuleHintsjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type CartPromotionRuleHintsjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof CartPromotionRuleHintsjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type CartPromotionRuleHintsjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof CartPromotionRuleHintsjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* CartPromotionRuleHintsjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const CartPromotionRuleHintsjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      code: Schema.String,
      name: Schema.Union([Schema.String, Schema.Null]),
      label: Schema.Union([Schema.String, Schema.Null]),
      shippingDiscountRuleHint: Schema.Union([
        ShippingDiscountRuleHintjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
        Schema.Null,
      ]),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'CartPromotionRuleHintsjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type CartPromotionRuleHintsjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof CartPromotionRuleHintsjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type CartPromotionRuleHintsjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof CartPromotionRuleHintsjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* CatalogPromotion */

export const CatalogPromotion = Schema.StructWithRest(
  Schema.Struct({
    channels: Schema.Array(Schema.suspend((): Schema.Codec<Channel> => Channel)),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    name: Schema.String,
    code: Schema.String,
    startDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    endDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    priority: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    exclusive: Schema.Boolean.annotate({ default: false }),
    state: Schema.String.annotate({ default: 'inactive' }),
    scopes: Schema.Array(CatalogPromotionScope),
    actions: Schema.Array(CatalogPromotionAction),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    currentLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    fallbackLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    channelsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    translation: Schema.Array(
      Schema.suspend((): Schema.Codec<TranslationInterface> => TranslationInterface)
    ),
    scopesTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    actionsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    translationClass: Schema.optionalKey(
      Schema.Json.annotate({ expected: 'JSON value', readOnly: true })
    ),
    label: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CatalogPromotion' });
export type CatalogPromotion = Schema.Schema.Type<typeof CatalogPromotion>;
export type CatalogPromotionEncoded = Schema.Codec.Encoded<typeof CatalogPromotion>;

/* CatalogPromotionsyliusadmincatalogpromotioncreate */

export const CatalogPromotionsyliusadmincatalogpromotioncreate = Schema.StructWithRest(
  Schema.Struct({
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    name: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    code: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ).check(
      Schema.isPattern(new RegExp('^([\\w-]*)$')).annotate({
        expected: 'a string matching the RegExp ^([\\w-]*)$',
      })
    ),
    startDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    endDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    priority: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    exclusive: Schema.Boolean.annotate({ default: false }),
    scopes: Schema.Array(CatalogPromotionScopesyliusadmincatalogpromotioncreate),
    actions: Schema.Array(CatalogPromotionActionsyliusadmincatalogpromotioncreate),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CatalogPromotionsyliusadmincatalogpromotioncreate' });
export type CatalogPromotionsyliusadmincatalogpromotioncreate = Schema.Schema.Type<
  typeof CatalogPromotionsyliusadmincatalogpromotioncreate
>;
export type CatalogPromotionsyliusadmincatalogpromotioncreateEncoded = Schema.Codec.Encoded<
  typeof CatalogPromotionsyliusadmincatalogpromotioncreate
>;

/* CatalogPromotionsyliusadmincatalogpromotionindex */

export const CatalogPromotionsyliusadmincatalogpromotionindex = Schema.StructWithRest(
  Schema.Struct({
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    name: Schema.String,
    code: Schema.String,
    startDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    endDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    priority: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    exclusive: Schema.Boolean.annotate({ default: false }),
    state: Schema.String.annotate({ default: 'inactive' }),
    scopes: Schema.Array(CatalogPromotionScopesyliusadmincatalogpromotionindex),
    actions: Schema.Array(CatalogPromotionActionsyliusadmincatalogpromotionindex),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CatalogPromotionsyliusadmincatalogpromotionindex' });
export type CatalogPromotionsyliusadmincatalogpromotionindex = Schema.Schema.Type<
  typeof CatalogPromotionsyliusadmincatalogpromotionindex
>;
export type CatalogPromotionsyliusadmincatalogpromotionindexEncoded = Schema.Codec.Encoded<
  typeof CatalogPromotionsyliusadmincatalogpromotionindex
>;

/* CatalogPromotionsyliusadmincatalogpromotionshow */

export const CatalogPromotionsyliusadmincatalogpromotionshow = Schema.StructWithRest(
  Schema.Struct({
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    name: Schema.String,
    code: Schema.String,
    startDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    endDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    priority: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    exclusive: Schema.Boolean.annotate({ default: false }),
    state: Schema.String.annotate({ default: 'inactive' }),
    scopes: Schema.Array(CatalogPromotionScopesyliusadmincatalogpromotionshow),
    actions: Schema.Array(CatalogPromotionActionsyliusadmincatalogpromotionshow),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CatalogPromotionsyliusadmincatalogpromotionshow' });
export type CatalogPromotionsyliusadmincatalogpromotionshow = Schema.Schema.Type<
  typeof CatalogPromotionsyliusadmincatalogpromotionshow
>;
export type CatalogPromotionsyliusadmincatalogpromotionshowEncoded = Schema.Codec.Encoded<
  typeof CatalogPromotionsyliusadmincatalogpromotionshow
>;

/* CatalogPromotionsyliusadmincatalogpromotionupdate */

export const CatalogPromotionsyliusadmincatalogpromotionupdate = Schema.StructWithRest(
  Schema.Struct({
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    name: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    startDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    endDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    priority: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    exclusive: Schema.Boolean.annotate({ default: false }),
    scopes: Schema.Array(CatalogPromotionScopesyliusadmincatalogpromotionupdate),
    actions: Schema.Array(CatalogPromotionActionsyliusadmincatalogpromotionupdate),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CatalogPromotionsyliusadmincatalogpromotionupdate' });
export type CatalogPromotionsyliusadmincatalogpromotionupdate = Schema.Schema.Type<
  typeof CatalogPromotionsyliusadmincatalogpromotionupdate
>;
export type CatalogPromotionsyliusadmincatalogpromotionupdateEncoded = Schema.Codec.Encoded<
  typeof CatalogPromotionsyliusadmincatalogpromotionupdate
>;

/* CatalogPromotionjsonld */

export const CatalogPromotionjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    channels: Schema.Array(Schema.suspend((): Schema.Codec<Channeljsonld> => Channeljsonld)),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    name: Schema.String,
    code: Schema.String,
    startDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    endDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    priority: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    exclusive: Schema.Boolean.annotate({ default: false }),
    state: Schema.String.annotate({ default: 'inactive' }),
    scopes: Schema.Array(CatalogPromotionScopejsonld),
    actions: Schema.Array(CatalogPromotionActionjsonld),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    currentLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    fallbackLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    channelsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    translation: Schema.Array(
      Schema.suspend((): Schema.Codec<TranslationInterfacejsonld> => TranslationInterfacejsonld)
    ),
    scopesTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    actionsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    translationClass: Schema.optionalKey(
      Schema.Json.annotate({ expected: 'JSON value', readOnly: true })
    ),
    label: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CatalogPromotionjsonld' });
export type CatalogPromotionjsonld = Schema.Schema.Type<typeof CatalogPromotionjsonld>;
export type CatalogPromotionjsonldEncoded = Schema.Codec.Encoded<typeof CatalogPromotionjsonld>;

/* CatalogPromotionjsonldsyliusadmincatalogpromotioncreate */

export const CatalogPromotionjsonldsyliusadmincatalogpromotioncreate = Schema.StructWithRest(
  Schema.Struct({
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    name: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    code: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ).check(
      Schema.isPattern(new RegExp('^([\\w-]*)$')).annotate({
        expected: 'a string matching the RegExp ^([\\w-]*)$',
      })
    ),
    startDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    endDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    priority: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    exclusive: Schema.Boolean.annotate({ default: false }),
    scopes: Schema.Array(CatalogPromotionScopejsonldsyliusadmincatalogpromotioncreate),
    actions: Schema.Array(CatalogPromotionActionjsonldsyliusadmincatalogpromotioncreate),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CatalogPromotionjsonldsyliusadmincatalogpromotioncreate' });
export type CatalogPromotionjsonldsyliusadmincatalogpromotioncreate = Schema.Schema.Type<
  typeof CatalogPromotionjsonldsyliusadmincatalogpromotioncreate
>;
export type CatalogPromotionjsonldsyliusadmincatalogpromotioncreateEncoded = Schema.Codec.Encoded<
  typeof CatalogPromotionjsonldsyliusadmincatalogpromotioncreate
>;

/* CatalogPromotionjsonldsyliusadmincatalogpromotionindex */

export const CatalogPromotionjsonldsyliusadmincatalogpromotionindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    name: Schema.String,
    code: Schema.String,
    startDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    endDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    priority: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    exclusive: Schema.Boolean.annotate({ default: false }),
    state: Schema.String.annotate({ default: 'inactive' }),
    scopes: Schema.Array(CatalogPromotionScopejsonldsyliusadmincatalogpromotionindex),
    actions: Schema.Array(CatalogPromotionActionjsonldsyliusadmincatalogpromotionindex),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CatalogPromotionjsonldsyliusadmincatalogpromotionindex' });
export type CatalogPromotionjsonldsyliusadmincatalogpromotionindex = Schema.Schema.Type<
  typeof CatalogPromotionjsonldsyliusadmincatalogpromotionindex
>;
export type CatalogPromotionjsonldsyliusadmincatalogpromotionindexEncoded = Schema.Codec.Encoded<
  typeof CatalogPromotionjsonldsyliusadmincatalogpromotionindex
>;

/* CatalogPromotionjsonldsyliusadmincatalogpromotionshow */

export const CatalogPromotionjsonldsyliusadmincatalogpromotionshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    name: Schema.String,
    code: Schema.String,
    startDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    endDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    priority: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    exclusive: Schema.Boolean.annotate({ default: false }),
    state: Schema.String.annotate({ default: 'inactive' }),
    scopes: Schema.Array(CatalogPromotionScopejsonldsyliusadmincatalogpromotionshow),
    actions: Schema.Array(CatalogPromotionActionjsonldsyliusadmincatalogpromotionshow),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CatalogPromotionjsonldsyliusadmincatalogpromotionshow' });
export type CatalogPromotionjsonldsyliusadmincatalogpromotionshow = Schema.Schema.Type<
  typeof CatalogPromotionjsonldsyliusadmincatalogpromotionshow
>;
export type CatalogPromotionjsonldsyliusadmincatalogpromotionshowEncoded = Schema.Codec.Encoded<
  typeof CatalogPromotionjsonldsyliusadmincatalogpromotionshow
>;

/* CatalogPromotionjsonldsyliusadmincatalogpromotionupdate */

export const CatalogPromotionjsonldsyliusadmincatalogpromotionupdate = Schema.StructWithRest(
  Schema.Struct({
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    name: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    startDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    endDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    priority: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    exclusive: Schema.Boolean.annotate({ default: false }),
    scopes: Schema.Array(CatalogPromotionScopejsonldsyliusadmincatalogpromotionupdate),
    actions: Schema.Array(CatalogPromotionActionjsonldsyliusadmincatalogpromotionupdate),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'CatalogPromotionjsonldsyliusadmincatalogpromotionupdate' });
export type CatalogPromotionjsonldsyliusadmincatalogpromotionupdate = Schema.Schema.Type<
  typeof CatalogPromotionjsonldsyliusadmincatalogpromotionupdate
>;
export type CatalogPromotionjsonldsyliusadmincatalogpromotionupdateEncoded = Schema.Codec.Encoded<
  typeof CatalogPromotionjsonldsyliusadmincatalogpromotionupdate
>;

/* Categorysyliusshopcategoryindex */

export const Categorysyliusshopcategoryindex = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.String.annotate({ format: 'uuid' }),
    code: Schema.String,
    image: Schema.Union([CategoryImagesyliusshopcategoryindex, Schema.Null]),
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    metaDescription: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Categorysyliusshopcategoryindex' });
export type Categorysyliusshopcategoryindex = Schema.Schema.Type<
  typeof Categorysyliusshopcategoryindex
>;
export type CategorysyliusshopcategoryindexEncoded = Schema.Codec.Encoded<
  typeof Categorysyliusshopcategoryindex
>;

/* Categoryjsonldsyliusshopcategoryindex */

export const Categoryjsonldsyliusshopcategoryindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    id: Schema.String.annotate({ format: 'uuid' }),
    code: Schema.String,
    image: Schema.Union([CategoryImagejsonldsyliusshopcategoryindex, Schema.Null]),
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    metaDescription: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Categoryjsonldsyliusshopcategoryindex' });
export type Categoryjsonldsyliusshopcategoryindex = Schema.Schema.Type<
  typeof Categoryjsonldsyliusshopcategoryindex
>;
export type CategoryjsonldsyliusshopcategoryindexEncoded = Schema.Codec.Encoded<
  typeof Categoryjsonldsyliusshopcategoryindex
>;

/* ChannelPriceHistoryConfigsyliusadminchannelcreatenoid */

export const ChannelPriceHistoryConfigsyliusadminchannelcreatenoid = Schema.StructWithRest(
  Schema.Struct({
    lowestPriceForDiscountedProductsCheckingPeriod: Schema.Number.annotate({ default: 30 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    lowestPriceForDiscountedProductsVisible: Schema.Boolean.annotate({ default: true }),
    taxonsExcludedFromShowingLowestPrice: Schema.optionalKey(
      Schema.Array(Taxonsyliusadminchannelcreatenoid).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ChannelPriceHistoryConfigsyliusadminchannelcreatenoid' });
export type ChannelPriceHistoryConfigsyliusadminchannelcreatenoid = Schema.Schema.Type<
  typeof ChannelPriceHistoryConfigsyliusadminchannelcreatenoid
>;
export type ChannelPriceHistoryConfigsyliusadminchannelcreatenoidEncoded = Schema.Codec.Encoded<
  typeof ChannelPriceHistoryConfigsyliusadminchannelcreatenoid
>;

/* ChannelPriceHistoryConfigsyliusadminchannelindexnoid */

export const ChannelPriceHistoryConfigsyliusadminchannelindexnoid = Schema.StructWithRest(
  Schema.Struct({
    lowestPriceForDiscountedProductsCheckingPeriod: Schema.Number.annotate({ default: 30 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    lowestPriceForDiscountedProductsVisible: Schema.Boolean.annotate({ default: true }),
    taxonsExcludedFromShowingLowestPrice: Schema.optionalKey(
      Schema.Array(Taxonsyliusadminchannelindexnoid).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ChannelPriceHistoryConfigsyliusadminchannelindexnoid' });
export type ChannelPriceHistoryConfigsyliusadminchannelindexnoid = Schema.Schema.Type<
  typeof ChannelPriceHistoryConfigsyliusadminchannelindexnoid
>;
export type ChannelPriceHistoryConfigsyliusadminchannelindexnoidEncoded = Schema.Codec.Encoded<
  typeof ChannelPriceHistoryConfigsyliusadminchannelindexnoid
>;

/* ChannelPriceHistoryConfigsyliusadminchannelshownoid */

export const ChannelPriceHistoryConfigsyliusadminchannelshownoid = Schema.StructWithRest(
  Schema.Struct({
    lowestPriceForDiscountedProductsCheckingPeriod: Schema.Number.annotate({ default: 30 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    lowestPriceForDiscountedProductsVisible: Schema.Boolean.annotate({ default: true }),
    taxonsExcludedFromShowingLowestPrice: Schema.optionalKey(
      Schema.Array(Taxonsyliusadminchannelshownoid).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ChannelPriceHistoryConfigsyliusadminchannelshownoid' });
export type ChannelPriceHistoryConfigsyliusadminchannelshownoid = Schema.Schema.Type<
  typeof ChannelPriceHistoryConfigsyliusadminchannelshownoid
>;
export type ChannelPriceHistoryConfigsyliusadminchannelshownoidEncoded = Schema.Codec.Encoded<
  typeof ChannelPriceHistoryConfigsyliusadminchannelshownoid
>;

/* ChannelPriceHistoryConfigsyliusadminchannelupdatenoid */

export const ChannelPriceHistoryConfigsyliusadminchannelupdatenoid = Schema.StructWithRest(
  Schema.Struct({
    lowestPriceForDiscountedProductsCheckingPeriod: Schema.Number.annotate({ default: 30 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    lowestPriceForDiscountedProductsVisible: Schema.Boolean.annotate({ default: true }),
    taxonsExcludedFromShowingLowestPrice: Schema.optionalKey(
      Schema.Array(Taxonsyliusadminchannelupdatenoid).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ChannelPriceHistoryConfigsyliusadminchannelupdatenoid' });
export type ChannelPriceHistoryConfigsyliusadminchannelupdatenoid = Schema.Schema.Type<
  typeof ChannelPriceHistoryConfigsyliusadminchannelupdatenoid
>;
export type ChannelPriceHistoryConfigsyliusadminchannelupdatenoidEncoded = Schema.Codec.Encoded<
  typeof ChannelPriceHistoryConfigsyliusadminchannelupdatenoid
>;

/* ChannelPriceHistoryConfigjsonldsyliusadminchannelcreatenoid */

export const ChannelPriceHistoryConfigjsonldsyliusadminchannelcreatenoid = Schema.StructWithRest(
  Schema.Struct({
    lowestPriceForDiscountedProductsCheckingPeriod: Schema.Number.annotate({ default: 30 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    lowestPriceForDiscountedProductsVisible: Schema.Boolean.annotate({ default: true }),
    taxonsExcludedFromShowingLowestPrice: Schema.optionalKey(
      Schema.Array(Taxonjsonldsyliusadminchannelcreatenoid).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ChannelPriceHistoryConfigjsonldsyliusadminchannelcreatenoid' });
export type ChannelPriceHistoryConfigjsonldsyliusadminchannelcreatenoid = Schema.Schema.Type<
  typeof ChannelPriceHistoryConfigjsonldsyliusadminchannelcreatenoid
>;
export type ChannelPriceHistoryConfigjsonldsyliusadminchannelcreatenoidEncoded =
  Schema.Codec.Encoded<typeof ChannelPriceHistoryConfigjsonldsyliusadminchannelcreatenoid>;

/* ChannelPriceHistoryConfigjsonldsyliusadminchannelindexnoid */

export const ChannelPriceHistoryConfigjsonldsyliusadminchannelindexnoid = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    lowestPriceForDiscountedProductsCheckingPeriod: Schema.Number.annotate({ default: 30 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    lowestPriceForDiscountedProductsVisible: Schema.Boolean.annotate({ default: true }),
    taxonsExcludedFromShowingLowestPrice: Schema.optionalKey(
      Schema.Array(Taxonjsonldsyliusadminchannelindexnoid).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ChannelPriceHistoryConfigjsonldsyliusadminchannelindexnoid' });
export type ChannelPriceHistoryConfigjsonldsyliusadminchannelindexnoid = Schema.Schema.Type<
  typeof ChannelPriceHistoryConfigjsonldsyliusadminchannelindexnoid
>;
export type ChannelPriceHistoryConfigjsonldsyliusadminchannelindexnoidEncoded =
  Schema.Codec.Encoded<typeof ChannelPriceHistoryConfigjsonldsyliusadminchannelindexnoid>;

/* ChannelPriceHistoryConfigjsonldsyliusadminchannelshownoid */

export const ChannelPriceHistoryConfigjsonldsyliusadminchannelshownoid = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    lowestPriceForDiscountedProductsCheckingPeriod: Schema.Number.annotate({ default: 30 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    lowestPriceForDiscountedProductsVisible: Schema.Boolean.annotate({ default: true }),
    taxonsExcludedFromShowingLowestPrice: Schema.optionalKey(
      Schema.Array(Taxonjsonldsyliusadminchannelshownoid).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ChannelPriceHistoryConfigjsonldsyliusadminchannelshownoid' });
export type ChannelPriceHistoryConfigjsonldsyliusadminchannelshownoid = Schema.Schema.Type<
  typeof ChannelPriceHistoryConfigjsonldsyliusadminchannelshownoid
>;
export type ChannelPriceHistoryConfigjsonldsyliusadminchannelshownoidEncoded = Schema.Codec.Encoded<
  typeof ChannelPriceHistoryConfigjsonldsyliusadminchannelshownoid
>;

/* ChannelPriceHistoryConfigjsonldsyliusadminchannelupdatenoid */

export const ChannelPriceHistoryConfigjsonldsyliusadminchannelupdatenoid = Schema.StructWithRest(
  Schema.Struct({
    lowestPriceForDiscountedProductsCheckingPeriod: Schema.Number.annotate({ default: 30 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    lowestPriceForDiscountedProductsVisible: Schema.Boolean.annotate({ default: true }),
    taxonsExcludedFromShowingLowestPrice: Schema.optionalKey(
      Schema.Array(Taxonjsonldsyliusadminchannelupdatenoid).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ChannelPriceHistoryConfigjsonldsyliusadminchannelupdatenoid' });
export type ChannelPriceHistoryConfigjsonldsyliusadminchannelupdatenoid = Schema.Schema.Type<
  typeof ChannelPriceHistoryConfigjsonldsyliusadminchannelupdatenoid
>;
export type ChannelPriceHistoryConfigjsonldsyliusadminchannelupdatenoidEncoded =
  Schema.Codec.Encoded<typeof ChannelPriceHistoryConfigjsonldsyliusadminchannelupdatenoid>;

/* Countrysyliusadmincountrycreate */

export const Countrysyliusadmincountrycreate = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.annotate({ description: 'Country code ISO 3166-1 alpha-2.' }),
    provinces: Schema.Array(Provincesyliusadmincountrycreate),
    enabled: Schema.Boolean.annotate({ default: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Countrysyliusadmincountrycreate' });
export type Countrysyliusadmincountrycreate = Schema.Schema.Type<
  typeof Countrysyliusadmincountrycreate
>;
export type CountrysyliusadmincountrycreateEncoded = Schema.Codec.Encoded<
  typeof Countrysyliusadmincountrycreate
>;

/* Countrysyliusadmincountryupdate */

export const Countrysyliusadmincountryupdate = Schema.StructWithRest(
  Schema.Struct({
    provinces: Schema.Array(Provincesyliusadmincountryupdate),
    enabled: Schema.Boolean.annotate({ default: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Countrysyliusadmincountryupdate' });
export type Countrysyliusadmincountryupdate = Schema.Schema.Type<
  typeof Countrysyliusadmincountryupdate
>;
export type CountrysyliusadmincountryupdateEncoded = Schema.Codec.Encoded<
  typeof Countrysyliusadmincountryupdate
>;

/* Countrysyliusshopcountryshow */

export const Countrysyliusshopcountryshow = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.annotate({ description: 'Country code ISO 3166-1 alpha-2.' }),
    provinces: Schema.Array(Provincesyliusshopcountryshow),
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Countrysyliusshopcountryshow' });
export type Countrysyliusshopcountryshow = Schema.Schema.Type<typeof Countrysyliusshopcountryshow>;
export type CountrysyliusshopcountryshowEncoded = Schema.Codec.Encoded<
  typeof Countrysyliusshopcountryshow
>;

/* Countryjsonldsyliusadmincountrycreate */

export const Countryjsonldsyliusadmincountrycreate = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.annotate({ description: 'Country code ISO 3166-1 alpha-2.' }),
    provinces: Schema.Array(Provincejsonldsyliusadmincountrycreate),
    enabled: Schema.Boolean.annotate({ default: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Countryjsonldsyliusadmincountrycreate' });
export type Countryjsonldsyliusadmincountrycreate = Schema.Schema.Type<
  typeof Countryjsonldsyliusadmincountrycreate
>;
export type CountryjsonldsyliusadmincountrycreateEncoded = Schema.Codec.Encoded<
  typeof Countryjsonldsyliusadmincountrycreate
>;

/* Countryjsonldsyliusadmincountryupdate */

export const Countryjsonldsyliusadmincountryupdate = Schema.StructWithRest(
  Schema.Struct({
    provinces: Schema.Array(Provincejsonldsyliusadmincountryupdate),
    enabled: Schema.Boolean.annotate({ default: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Countryjsonldsyliusadmincountryupdate' });
export type Countryjsonldsyliusadmincountryupdate = Schema.Schema.Type<
  typeof Countryjsonldsyliusadmincountryupdate
>;
export type CountryjsonldsyliusadmincountryupdateEncoded = Schema.Codec.Encoded<
  typeof Countryjsonldsyliusadmincountryupdate
>;

/* Countryjsonldsyliusshopcountryshow */

export const Countryjsonldsyliusshopcountryshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String.annotate({ description: 'Country code ISO 3166-1 alpha-2.' }),
    provinces: Schema.Array(Provincejsonldsyliusshopcountryshow),
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Countryjsonldsyliusshopcountryshow' });
export type Countryjsonldsyliusshopcountryshow = Schema.Schema.Type<
  typeof Countryjsonldsyliusshopcountryshow
>;
export type CountryjsonldsyliusshopcountryshowEncoded = Schema.Codec.Encoded<
  typeof Countryjsonldsyliusshopcountryshow
>;

/* Customersyliusadmincustomercreate */

export const Customersyliusadmincustomercreate = Schema.StructWithRest(
  Schema.Struct({
    user: Schema.Union([ShopUsersyliusadmincustomercreate, Schema.Null]),
    email: Schema.String.annotate({ format: 'email' }).check(
      Schema.isMaxLength(254).annotate({ expected: 'a value with a length of at most 254' })
    ),
    firstName: Schema.Union([
      Schema.String.check(
        Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
      ).check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    lastName: Schema.Union([
      Schema.String.check(
        Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
      ).check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    birthday: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    gender: Schema.Literals(['u', 'm', 'f']).annotate({ default: 'u' }),
    group: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    phoneNumber: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    subscribedToNewsletter: Schema.Boolean.annotate({ default: false }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Customersyliusadmincustomercreate' });
export type Customersyliusadmincustomercreate = Schema.Schema.Type<
  typeof Customersyliusadmincustomercreate
>;
export type CustomersyliusadmincustomercreateEncoded = Schema.Codec.Encoded<
  typeof Customersyliusadmincustomercreate
>;

/* Customersyliusadmincustomerindex */

export const Customersyliusadmincustomerindex = Schema.StructWithRest(
  Schema.Struct({
    defaultAddress: Schema.Union([
      Schema.String.annotate({ format: 'iri-reference' }),
      Schema.Null,
    ]),
    user: Schema.Union([ShopUsersyliusadmincustomerindex, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    email: Schema.String,
    firstName: Schema.Union([Schema.String, Schema.Null]),
    lastName: Schema.Union([Schema.String, Schema.Null]),
    birthday: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    gender: Schema.String.annotate({ default: 'u' }),
    group: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    phoneNumber: Schema.Union([Schema.String, Schema.Null]),
    subscribedToNewsletter: Schema.Boolean.annotate({ default: false }),
    createdAt: DateTimeSerializableFromString,
    fullName: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Customersyliusadmincustomerindex' });
export type Customersyliusadmincustomerindex = Schema.Schema.Type<
  typeof Customersyliusadmincustomerindex
>;
export type CustomersyliusadmincustomerindexEncoded = Schema.Codec.Encoded<
  typeof Customersyliusadmincustomerindex
>;

/* Customersyliusadmincustomershow */

export const Customersyliusadmincustomershow = Schema.StructWithRest(
  Schema.Struct({
    defaultAddress: Schema.Union([
      Schema.String.annotate({ format: 'iri-reference' }),
      Schema.Null,
    ]),
    user: Schema.Union([ShopUsersyliusadmincustomershow, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    email: Schema.String,
    firstName: Schema.Union([Schema.String, Schema.Null]),
    lastName: Schema.Union([Schema.String, Schema.Null]),
    birthday: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    gender: Schema.String.annotate({ default: 'u' }),
    group: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    phoneNumber: Schema.Union([Schema.String, Schema.Null]),
    subscribedToNewsletter: Schema.Boolean.annotate({ default: false }),
    createdAt: DateTimeSerializableFromString,
    fullName: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Customersyliusadmincustomershow' });
export type Customersyliusadmincustomershow = Schema.Schema.Type<
  typeof Customersyliusadmincustomershow
>;
export type CustomersyliusadmincustomershowEncoded = Schema.Codec.Encoded<
  typeof Customersyliusadmincustomershow
>;

/* Customersyliusadmincustomerupdate */

export const Customersyliusadmincustomerupdate = Schema.StructWithRest(
  Schema.Struct({
    user: Schema.Union([ShopUsersyliusadmincustomerupdate, Schema.Null]),
    email: Schema.String.annotate({ format: 'email' }).check(
      Schema.isMaxLength(254).annotate({ expected: 'a value with a length of at most 254' })
    ),
    firstName: Schema.Union([
      Schema.String.check(
        Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
      ).check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    lastName: Schema.Union([
      Schema.String.check(
        Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
      ).check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    birthday: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    gender: Schema.Literals(['u', 'm', 'f']).annotate({ default: 'u' }),
    group: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    phoneNumber: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    subscribedToNewsletter: Schema.Boolean.annotate({ default: false }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Customersyliusadmincustomerupdate' });
export type Customersyliusadmincustomerupdate = Schema.Schema.Type<
  typeof Customersyliusadmincustomerupdate
>;
export type CustomersyliusadmincustomerupdateEncoded = Schema.Codec.Encoded<
  typeof Customersyliusadmincustomerupdate
>;

/* Customersyliusshopcustomershow */

export const Customersyliusshopcustomershow = Schema.StructWithRest(
  Schema.Struct({
    defaultAddress: Schema.Union([
      Schema.String.annotate({ format: 'iri-reference' }),
      Schema.Null,
    ]),
    user: Schema.Union([ShopUsersyliusshopcustomershow, Schema.Null]),
    email: Schema.String,
    firstName: Schema.Union([Schema.String, Schema.Null]),
    lastName: Schema.Union([Schema.String, Schema.Null]),
    birthday: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    gender: Schema.String.annotate({ default: 'u' }),
    phoneNumber: Schema.Union([Schema.String, Schema.Null]),
    subscribedToNewsletter: Schema.Boolean.annotate({ default: false }),
    fullName: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Customersyliusshopcustomershow' });
export type Customersyliusshopcustomershow = Schema.Schema.Type<
  typeof Customersyliusshopcustomershow
>;
export type CustomersyliusshopcustomershowEncoded = Schema.Codec.Encoded<
  typeof Customersyliusshopcustomershow
>;

/* ProductReviewsyliusshopproductreviewindex */

export const ProductReviewsyliusshopproductreviewindex = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    title: Schema.Union([Schema.String, Schema.Null]),
    rating: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    comment: Schema.Union([Schema.String, Schema.Null]),
    author: Customersyliusshopproductreviewindex,
    reviewSubject: Schema.String.annotate({ format: 'iri-reference' }),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductReviewsyliusshopproductreviewindex' });
export type ProductReviewsyliusshopproductreviewindex = Schema.Schema.Type<
  typeof ProductReviewsyliusshopproductreviewindex
>;
export type ProductReviewsyliusshopproductreviewindexEncoded = Schema.Codec.Encoded<
  typeof ProductReviewsyliusshopproductreviewindex
>;

/* ProductReviewsyliusshopproductreviewshow */

export const ProductReviewsyliusshopproductreviewshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    title: Schema.Union([Schema.String, Schema.Null]),
    rating: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    comment: Schema.Union([Schema.String, Schema.Null]),
    author: Customersyliusshopproductreviewshow,
    reviewSubject: Schema.String.annotate({ format: 'iri-reference' }),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductReviewsyliusshopproductreviewshow' });
export type ProductReviewsyliusshopproductreviewshow = Schema.Schema.Type<
  typeof ProductReviewsyliusshopproductreviewshow
>;
export type ProductReviewsyliusshopproductreviewshowEncoded = Schema.Codec.Encoded<
  typeof ProductReviewsyliusshopproductreviewshow
>;

/* Customerjsonldsyliusadmincustomercreate */

export const Customerjsonldsyliusadmincustomercreate = Schema.StructWithRest(
  Schema.Struct({
    user: Schema.Union([ShopUserjsonldsyliusadmincustomercreate, Schema.Null]),
    email: Schema.String.annotate({ format: 'email' }).check(
      Schema.isMaxLength(254).annotate({ expected: 'a value with a length of at most 254' })
    ),
    firstName: Schema.Union([
      Schema.String.check(
        Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
      ).check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    lastName: Schema.Union([
      Schema.String.check(
        Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
      ).check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    birthday: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    gender: Schema.Literals(['u', 'm', 'f']).annotate({ default: 'u' }),
    group: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    phoneNumber: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    subscribedToNewsletter: Schema.Boolean.annotate({ default: false }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Customerjsonldsyliusadmincustomercreate' });
export type Customerjsonldsyliusadmincustomercreate = Schema.Schema.Type<
  typeof Customerjsonldsyliusadmincustomercreate
>;
export type CustomerjsonldsyliusadmincustomercreateEncoded = Schema.Codec.Encoded<
  typeof Customerjsonldsyliusadmincustomercreate
>;

/* Customerjsonldsyliusadmincustomerindex */

export const Customerjsonldsyliusadmincustomerindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    defaultAddress: Schema.Union([
      Schema.String.annotate({ format: 'iri-reference' }),
      Schema.Null,
    ]),
    user: Schema.Union([ShopUserjsonldsyliusadmincustomerindex, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    email: Schema.String,
    firstName: Schema.Union([Schema.String, Schema.Null]),
    lastName: Schema.Union([Schema.String, Schema.Null]),
    birthday: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    gender: Schema.String.annotate({ default: 'u' }),
    group: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    phoneNumber: Schema.Union([Schema.String, Schema.Null]),
    subscribedToNewsletter: Schema.Boolean.annotate({ default: false }),
    createdAt: DateTimeSerializableFromString,
    fullName: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Customerjsonldsyliusadmincustomerindex' });
export type Customerjsonldsyliusadmincustomerindex = Schema.Schema.Type<
  typeof Customerjsonldsyliusadmincustomerindex
>;
export type CustomerjsonldsyliusadmincustomerindexEncoded = Schema.Codec.Encoded<
  typeof Customerjsonldsyliusadmincustomerindex
>;

/* Customerjsonldsyliusadmincustomershow */

export const Customerjsonldsyliusadmincustomershow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    defaultAddress: Schema.Union([
      Schema.String.annotate({ format: 'iri-reference' }),
      Schema.Null,
    ]),
    user: Schema.Union([ShopUserjsonldsyliusadmincustomershow, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    email: Schema.String,
    firstName: Schema.Union([Schema.String, Schema.Null]),
    lastName: Schema.Union([Schema.String, Schema.Null]),
    birthday: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    gender: Schema.String.annotate({ default: 'u' }),
    group: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    phoneNumber: Schema.Union([Schema.String, Schema.Null]),
    subscribedToNewsletter: Schema.Boolean.annotate({ default: false }),
    createdAt: DateTimeSerializableFromString,
    fullName: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Customerjsonldsyliusadmincustomershow' });
export type Customerjsonldsyliusadmincustomershow = Schema.Schema.Type<
  typeof Customerjsonldsyliusadmincustomershow
>;
export type CustomerjsonldsyliusadmincustomershowEncoded = Schema.Codec.Encoded<
  typeof Customerjsonldsyliusadmincustomershow
>;

/* Customerjsonldsyliusadmincustomerupdate */

export const Customerjsonldsyliusadmincustomerupdate = Schema.StructWithRest(
  Schema.Struct({
    user: Schema.Union([ShopUserjsonldsyliusadmincustomerupdate, Schema.Null]),
    email: Schema.String.annotate({ format: 'email' }).check(
      Schema.isMaxLength(254).annotate({ expected: 'a value with a length of at most 254' })
    ),
    firstName: Schema.Union([
      Schema.String.check(
        Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
      ).check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    lastName: Schema.Union([
      Schema.String.check(
        Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
      ).check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    birthday: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    gender: Schema.Literals(['u', 'm', 'f']).annotate({ default: 'u' }),
    group: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    phoneNumber: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    subscribedToNewsletter: Schema.Boolean.annotate({ default: false }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Customerjsonldsyliusadmincustomerupdate' });
export type Customerjsonldsyliusadmincustomerupdate = Schema.Schema.Type<
  typeof Customerjsonldsyliusadmincustomerupdate
>;
export type CustomerjsonldsyliusadmincustomerupdateEncoded = Schema.Codec.Encoded<
  typeof Customerjsonldsyliusadmincustomerupdate
>;

/* Customerjsonldsyliusshopcustomershow */

export const Customerjsonldsyliusshopcustomershow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    defaultAddress: Schema.Union([
      Schema.String.annotate({ format: 'iri-reference' }),
      Schema.Null,
    ]),
    user: Schema.Union([ShopUserjsonldsyliusshopcustomershow, Schema.Null]),
    email: Schema.String,
    firstName: Schema.Union([Schema.String, Schema.Null]),
    lastName: Schema.Union([Schema.String, Schema.Null]),
    birthday: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    gender: Schema.String.annotate({ default: 'u' }),
    phoneNumber: Schema.Union([Schema.String, Schema.Null]),
    subscribedToNewsletter: Schema.Boolean.annotate({ default: false }),
    fullName: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Customerjsonldsyliusshopcustomershow' });
export type Customerjsonldsyliusshopcustomershow = Schema.Schema.Type<
  typeof Customerjsonldsyliusshopcustomershow
>;
export type CustomerjsonldsyliusshopcustomershowEncoded = Schema.Codec.Encoded<
  typeof Customerjsonldsyliusshopcustomershow
>;

/* ProductReviewjsonldsyliusshopproductreviewindex */

export const ProductReviewjsonldsyliusshopproductreviewindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    title: Schema.Union([Schema.String, Schema.Null]),
    rating: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    comment: Schema.Union([Schema.String, Schema.Null]),
    author: Customerjsonldsyliusshopproductreviewindex,
    reviewSubject: Schema.String.annotate({ format: 'iri-reference' }),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductReviewjsonldsyliusshopproductreviewindex' });
export type ProductReviewjsonldsyliusshopproductreviewindex = Schema.Schema.Type<
  typeof ProductReviewjsonldsyliusshopproductreviewindex
>;
export type ProductReviewjsonldsyliusshopproductreviewindexEncoded = Schema.Codec.Encoded<
  typeof ProductReviewjsonldsyliusshopproductreviewindex
>;

/* ProductReviewjsonldsyliusshopproductreviewshow */

export const ProductReviewjsonldsyliusshopproductreviewshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    title: Schema.Union([Schema.String, Schema.Null]),
    rating: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    comment: Schema.Union([Schema.String, Schema.Null]),
    author: Customerjsonldsyliusshopproductreviewshow,
    reviewSubject: Schema.String.annotate({ format: 'iri-reference' }),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductReviewjsonldsyliusshopproductreviewshow' });
export type ProductReviewjsonldsyliusshopproductreviewshow = Schema.Schema.Type<
  typeof ProductReviewjsonldsyliusshopproductreviewshow
>;
export type ProductReviewjsonldsyliusshopproductreviewshowEncoded = Schema.Codec.Encoded<
  typeof ProductReviewjsonldsyliusshopproductreviewshow
>;

/* ProductDocumentadminproductdocumentcreate */

export const ProductDocumentadminproductdocumentcreate = Schema.StructWithRest(
  Schema.Struct({
    createdAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    documentType: DocumentTypeadminproductdocumentcreate,
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    path: Schema.String,
    publicPath: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({
  description: 'Class ProductDocument',
  identifier: 'ProductDocumentadminproductdocumentcreate',
});
export type ProductDocumentadminproductdocumentcreate = Schema.Schema.Type<
  typeof ProductDocumentadminproductdocumentcreate
>;
export type ProductDocumentadminproductdocumentcreateEncoded = Schema.Codec.Encoded<
  typeof ProductDocumentadminproductdocumentcreate
>;

/* ProductDocumentadminproductdocumentread */

export const ProductDocumentadminproductdocumentread = Schema.StructWithRest(
  Schema.Struct({
    createdAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    documentType: DocumentTypeadminproductdocumentread,
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    path: Schema.String,
    publicPath: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({
  description: 'Class ProductDocument',
  identifier: 'ProductDocumentadminproductdocumentread',
});
export type ProductDocumentadminproductdocumentread = Schema.Schema.Type<
  typeof ProductDocumentadminproductdocumentread
>;
export type ProductDocumentadminproductdocumentreadEncoded = Schema.Codec.Encoded<
  typeof ProductDocumentadminproductdocumentread
>;

/* ProductDocumentjsonldadminproductdocumentcreate */

export const ProductDocumentjsonldadminproductdocumentcreate = Schema.StructWithRest(
  Schema.Struct({
    createdAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    documentType: DocumentTypejsonldadminproductdocumentcreate,
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    path: Schema.String,
    publicPath: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({
  description: 'Class ProductDocument',
  identifier: 'ProductDocumentjsonldadminproductdocumentcreate',
});
export type ProductDocumentjsonldadminproductdocumentcreate = Schema.Schema.Type<
  typeof ProductDocumentjsonldadminproductdocumentcreate
>;
export type ProductDocumentjsonldadminproductdocumentcreateEncoded = Schema.Codec.Encoded<
  typeof ProductDocumentjsonldadminproductdocumentcreate
>;

/* ProductDocumentjsonldadminproductdocumentread */

export const ProductDocumentjsonldadminproductdocumentread = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    createdAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    documentType: DocumentTypejsonldadminproductdocumentread,
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    path: Schema.String,
    publicPath: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({
  description: 'Class ProductDocument',
  identifier: 'ProductDocumentjsonldadminproductdocumentread',
});
export type ProductDocumentjsonldadminproductdocumentread = Schema.Schema.Type<
  typeof ProductDocumentjsonldadminproductdocumentread
>;
export type ProductDocumentjsonldadminproductdocumentreadEncoded = Schema.Codec.Encoded<
  typeof ProductDocumentjsonldadminproductdocumentread
>;

/* FaqQuestionsyliusshopfaqquestionindex */

export const FaqQuestionsyliusshopfaqquestionindex = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.annotate({ default: '' }),
    topic: FaqTopicsyliusshopfaqquestionindex,
    priority: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    favourite: Schema.Boolean.annotate({
      description:
        'Hand-picked for prominent placement (a homepage, a "top questions" box) — the shop decides where.',
      default: false,
    }),
    question: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    answer: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    slug: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'FaqQuestionsyliusshopfaqquestionindex' });
export type FaqQuestionsyliusshopfaqquestionindex = Schema.Schema.Type<
  typeof FaqQuestionsyliusshopfaqquestionindex
>;
export type FaqQuestionsyliusshopfaqquestionindexEncoded = Schema.Codec.Encoded<
  typeof FaqQuestionsyliusshopfaqquestionindex
>;

/* FaqTopicsyliusshopfaqtopicdetail */

export const FaqTopicsyliusshopfaqtopicdetail = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.annotate({ default: '' }),
    icon: Schema.Union([Schema.String, Schema.Null]),
    questions: Schema.Array(FaqQuestionsyliusshopfaqtopicdetail),
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    description: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    slug: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'FaqTopicsyliusshopfaqtopicdetail' });
export type FaqTopicsyliusshopfaqtopicdetail = Schema.Schema.Type<
  typeof FaqTopicsyliusshopfaqtopicdetail
>;
export type FaqTopicsyliusshopfaqtopicdetailEncoded = Schema.Codec.Encoded<
  typeof FaqTopicsyliusshopfaqtopicdetail
>;

/* FaqTopicsyliusshopfaqtopicindex */

export const FaqTopicsyliusshopfaqtopicindex = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.annotate({ default: '' }),
    icon: Schema.Union([Schema.String, Schema.Null]),
    priority: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    questions: Schema.Array(FaqQuestionsyliusshopfaqtopicindex),
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    description: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    slug: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'FaqTopicsyliusshopfaqtopicindex' });
export type FaqTopicsyliusshopfaqtopicindex = Schema.Schema.Type<
  typeof FaqTopicsyliusshopfaqtopicindex
>;
export type FaqTopicsyliusshopfaqtopicindexEncoded = Schema.Codec.Encoded<
  typeof FaqTopicsyliusshopfaqtopicindex
>;

/* FaqQuestionjsonldsyliusshopfaqquestionindex */

export const FaqQuestionjsonldsyliusshopfaqquestionindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String.annotate({ default: '' }),
    topic: FaqTopicjsonldsyliusshopfaqquestionindex,
    priority: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    favourite: Schema.Boolean.annotate({
      description:
        'Hand-picked for prominent placement (a homepage, a "top questions" box) — the shop decides where.',
      default: false,
    }),
    question: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    answer: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    slug: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'FaqQuestionjsonldsyliusshopfaqquestionindex' });
export type FaqQuestionjsonldsyliusshopfaqquestionindex = Schema.Schema.Type<
  typeof FaqQuestionjsonldsyliusshopfaqquestionindex
>;
export type FaqQuestionjsonldsyliusshopfaqquestionindexEncoded = Schema.Codec.Encoded<
  typeof FaqQuestionjsonldsyliusshopfaqquestionindex
>;

/* FaqTopicjsonldsyliusshopfaqtopicdetail */

export const FaqTopicjsonldsyliusshopfaqtopicdetail = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String.annotate({ default: '' }),
    icon: Schema.Union([Schema.String, Schema.Null]),
    questions: Schema.Array(FaqQuestionjsonldsyliusshopfaqtopicdetail),
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    description: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    slug: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'FaqTopicjsonldsyliusshopfaqtopicdetail' });
export type FaqTopicjsonldsyliusshopfaqtopicdetail = Schema.Schema.Type<
  typeof FaqTopicjsonldsyliusshopfaqtopicdetail
>;
export type FaqTopicjsonldsyliusshopfaqtopicdetailEncoded = Schema.Codec.Encoded<
  typeof FaqTopicjsonldsyliusshopfaqtopicdetail
>;

/* FaqTopicjsonldsyliusshopfaqtopicindex */

export const FaqTopicjsonldsyliusshopfaqtopicindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String.annotate({ default: '' }),
    icon: Schema.Union([Schema.String, Schema.Null]),
    priority: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    questions: Schema.Array(FaqQuestionjsonldsyliusshopfaqtopicindex),
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    description: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    slug: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'FaqTopicjsonldsyliusshopfaqtopicindex' });
export type FaqTopicjsonldsyliusshopfaqtopicindex = Schema.Schema.Type<
  typeof FaqTopicjsonldsyliusshopfaqtopicindex
>;
export type FaqTopicjsonldsyliusshopfaqtopicindexEncoded = Schema.Codec.Encoded<
  typeof FaqTopicjsonldsyliusshopfaqtopicindex
>;

/* PaymentMethodsyliusadminpaymentmethodcreate */

export const PaymentMethodsyliusadminpaymentmethodcreate = Schema.StructWithRest(
  Schema.Struct({
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    code: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    gatewayConfig: Schema.Union([GatewayConfigsyliusadminpaymentmethodcreate, Schema.Null]),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PaymentMethodsyliusadminpaymentmethodcreate' });
export type PaymentMethodsyliusadminpaymentmethodcreate = Schema.Schema.Type<
  typeof PaymentMethodsyliusadminpaymentmethodcreate
>;
export type PaymentMethodsyliusadminpaymentmethodcreateEncoded = Schema.Codec.Encoded<
  typeof PaymentMethodsyliusadminpaymentmethodcreate
>;

/* PaymentMethodsyliusadminpaymentmethodindex */

export const PaymentMethodsyliusadminpaymentmethodindex = Schema.StructWithRest(
  Schema.Struct({
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    gatewayConfig: Schema.Union([GatewayConfigsyliusadminpaymentmethodindex, Schema.Null]),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PaymentMethodsyliusadminpaymentmethodindex' });
export type PaymentMethodsyliusadminpaymentmethodindex = Schema.Schema.Type<
  typeof PaymentMethodsyliusadminpaymentmethodindex
>;
export type PaymentMethodsyliusadminpaymentmethodindexEncoded = Schema.Codec.Encoded<
  typeof PaymentMethodsyliusadminpaymentmethodindex
>;

/* PaymentMethodsyliusadminpaymentmethodshow */

export const PaymentMethodsyliusadminpaymentmethodshow = Schema.StructWithRest(
  Schema.Struct({
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    gatewayConfig: Schema.Union([GatewayConfigsyliusadminpaymentmethodshow, Schema.Null]),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PaymentMethodsyliusadminpaymentmethodshow' });
export type PaymentMethodsyliusadminpaymentmethodshow = Schema.Schema.Type<
  typeof PaymentMethodsyliusadminpaymentmethodshow
>;
export type PaymentMethodsyliusadminpaymentmethodshowEncoded = Schema.Codec.Encoded<
  typeof PaymentMethodsyliusadminpaymentmethodshow
>;

/* PaymentMethodsyliusadminpaymentmethodupdate */

export const PaymentMethodsyliusadminpaymentmethodupdate = Schema.StructWithRest(
  Schema.Struct({
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    gatewayConfig: Schema.Union([GatewayConfigsyliusadminpaymentmethodupdate, Schema.Null]),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PaymentMethodsyliusadminpaymentmethodupdate' });
export type PaymentMethodsyliusadminpaymentmethodupdate = Schema.Schema.Type<
  typeof PaymentMethodsyliusadminpaymentmethodupdate
>;
export type PaymentMethodsyliusadminpaymentmethodupdateEncoded = Schema.Codec.Encoded<
  typeof PaymentMethodsyliusadminpaymentmethodupdate
>;

/* PaymentMethodjsonldsyliusadminpaymentmethodcreate */

export const PaymentMethodjsonldsyliusadminpaymentmethodcreate = Schema.StructWithRest(
  Schema.Struct({
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    code: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    gatewayConfig: Schema.Union([GatewayConfigjsonldsyliusadminpaymentmethodcreate, Schema.Null]),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PaymentMethodjsonldsyliusadminpaymentmethodcreate' });
export type PaymentMethodjsonldsyliusadminpaymentmethodcreate = Schema.Schema.Type<
  typeof PaymentMethodjsonldsyliusadminpaymentmethodcreate
>;
export type PaymentMethodjsonldsyliusadminpaymentmethodcreateEncoded = Schema.Codec.Encoded<
  typeof PaymentMethodjsonldsyliusadminpaymentmethodcreate
>;

/* PaymentMethodjsonldsyliusadminpaymentmethodindex */

export const PaymentMethodjsonldsyliusadminpaymentmethodindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    gatewayConfig: Schema.Union([GatewayConfigjsonldsyliusadminpaymentmethodindex, Schema.Null]),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PaymentMethodjsonldsyliusadminpaymentmethodindex' });
export type PaymentMethodjsonldsyliusadminpaymentmethodindex = Schema.Schema.Type<
  typeof PaymentMethodjsonldsyliusadminpaymentmethodindex
>;
export type PaymentMethodjsonldsyliusadminpaymentmethodindexEncoded = Schema.Codec.Encoded<
  typeof PaymentMethodjsonldsyliusadminpaymentmethodindex
>;

/* PaymentMethodjsonldsyliusadminpaymentmethodshow */

export const PaymentMethodjsonldsyliusadminpaymentmethodshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    gatewayConfig: Schema.Union([GatewayConfigjsonldsyliusadminpaymentmethodshow, Schema.Null]),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PaymentMethodjsonldsyliusadminpaymentmethodshow' });
export type PaymentMethodjsonldsyliusadminpaymentmethodshow = Schema.Schema.Type<
  typeof PaymentMethodjsonldsyliusadminpaymentmethodshow
>;
export type PaymentMethodjsonldsyliusadminpaymentmethodshowEncoded = Schema.Codec.Encoded<
  typeof PaymentMethodjsonldsyliusadminpaymentmethodshow
>;

/* PaymentMethodjsonldsyliusadminpaymentmethodupdate */

export const PaymentMethodjsonldsyliusadminpaymentmethodupdate = Schema.StructWithRest(
  Schema.Struct({
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    gatewayConfig: Schema.Union([GatewayConfigjsonldsyliusadminpaymentmethodupdate, Schema.Null]),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PaymentMethodjsonldsyliusadminpaymentmethodupdate' });
export type PaymentMethodjsonldsyliusadminpaymentmethodupdate = Schema.Schema.Type<
  typeof PaymentMethodjsonldsyliusadminpaymentmethodupdate
>;
export type PaymentMethodjsonldsyliusadminpaymentmethodupdateEncoded = Schema.Codec.Encoded<
  typeof PaymentMethodjsonldsyliusadminpaymentmethodupdate
>;

/* ImageCollectionElementDTOsyliusshopglossaryshow */

export const ImageCollectionElementDTOsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    images: Schema.Array(ImageItemDTOsyliusshopglossaryshow),
    type: Schema.Literal('image_collection').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ImageCollectionElementDTOsyliusshopglossaryshow' });
export type ImageCollectionElementDTOsyliusshopglossaryshow = Schema.Schema.Type<
  typeof ImageCollectionElementDTOsyliusshopglossaryshow
>;
export type ImageCollectionElementDTOsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof ImageCollectionElementDTOsyliusshopglossaryshow
>;

/* ImagePairElementDTOsyliusshopglossaryshow */

export const ImagePairElementDTOsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    first: Schema.Union([ImageItemDTOsyliusshopglossaryshow, Schema.Null]),
    second: Schema.Union([ImageItemDTOsyliusshopglossaryshow, Schema.Null]),
    type: Schema.Literal('image_pair').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ImagePairElementDTOsyliusshopglossaryshow' });
export type ImagePairElementDTOsyliusshopglossaryshow = Schema.Schema.Type<
  typeof ImagePairElementDTOsyliusshopglossaryshow
>;
export type ImagePairElementDTOsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof ImagePairElementDTOsyliusshopglossaryshow
>;

/* MarkdownTextWithImageElementDTOsyliusshopglossaryshow */

export const MarkdownTextWithImageElementDTOsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    text: Schema.String,
    image: ImageItemDTOsyliusshopglossaryshow,
    direction: Schema.Literals(['textImage', 'imageText']),
    type: Schema.Literal('markdown_text_with_image').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'MarkdownTextWithImageElementDTOsyliusshopglossaryshow' });
export type MarkdownTextWithImageElementDTOsyliusshopglossaryshow = Schema.Schema.Type<
  typeof MarkdownTextWithImageElementDTOsyliusshopglossaryshow
>;
export type MarkdownTextWithImageElementDTOsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof MarkdownTextWithImageElementDTOsyliusshopglossaryshow
>;

/* TeamMemberItemDTOsyliusshopglossaryshow */

export const TeamMemberItemDTOsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    name: Schema.String,
    position: Schema.Union([Schema.String, Schema.Null]),
    phone: Schema.Union([Schema.String, Schema.Null]),
    email: Schema.Union([Schema.String, Schema.Null]),
    avatar: Schema.Union([ImageClearItemDTOsyliusshopglossaryshow, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TeamMemberItemDTOsyliusshopglossaryshow' });
export type TeamMemberItemDTOsyliusshopglossaryshow = Schema.Schema.Type<
  typeof TeamMemberItemDTOsyliusshopglossaryshow
>;
export type TeamMemberItemDTOsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof TeamMemberItemDTOsyliusshopglossaryshow
>;

/* ButtonGridItemDTOsyliusshopglossaryshow */

export const ButtonGridItemDTOsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    link: Schema.String,
    text: Schema.String,
    image: Schema.Union([ImageClearItemDTOsyliusshopglossaryshow, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ButtonGridItemDTOsyliusshopglossaryshow' });
export type ButtonGridItemDTOsyliusshopglossaryshow = Schema.Schema.Type<
  typeof ButtonGridItemDTOsyliusshopglossaryshow
>;
export type ButtonGridItemDTOsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof ButtonGridItemDTOsyliusshopglossaryshow
>;

/* TableRowItemDTOsyliusshopglossaryshow */

export const TableRowItemDTOsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({ cells: Schema.Array(TableCellItemDTOsyliusshopglossaryshow) }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TableRowItemDTOsyliusshopglossaryshow' });
export type TableRowItemDTOsyliusshopglossaryshow = Schema.Schema.Type<
  typeof TableRowItemDTOsyliusshopglossaryshow
>;
export type TableRowItemDTOsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof TableRowItemDTOsyliusshopglossaryshow
>;

/* ImageCollectionElementDTOjsonldsyliusshopglossaryshow */

export const ImageCollectionElementDTOjsonldsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    images: Schema.Array(ImageItemDTOjsonldsyliusshopglossaryshow),
    type: Schema.Literal('image_collection').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ImageCollectionElementDTOjsonldsyliusshopglossaryshow' });
export type ImageCollectionElementDTOjsonldsyliusshopglossaryshow = Schema.Schema.Type<
  typeof ImageCollectionElementDTOjsonldsyliusshopglossaryshow
>;
export type ImageCollectionElementDTOjsonldsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof ImageCollectionElementDTOjsonldsyliusshopglossaryshow
>;

/* ImagePairElementDTOjsonldsyliusshopglossaryshow */

export const ImagePairElementDTOjsonldsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    first: Schema.Union([ImageItemDTOjsonldsyliusshopglossaryshow, Schema.Null]),
    second: Schema.Union([ImageItemDTOjsonldsyliusshopglossaryshow, Schema.Null]),
    type: Schema.Literal('image_pair').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ImagePairElementDTOjsonldsyliusshopglossaryshow' });
export type ImagePairElementDTOjsonldsyliusshopglossaryshow = Schema.Schema.Type<
  typeof ImagePairElementDTOjsonldsyliusshopglossaryshow
>;
export type ImagePairElementDTOjsonldsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof ImagePairElementDTOjsonldsyliusshopglossaryshow
>;

/* MarkdownTextWithImageElementDTOjsonldsyliusshopglossaryshow */

export const MarkdownTextWithImageElementDTOjsonldsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    text: Schema.String,
    image: ImageItemDTOjsonldsyliusshopglossaryshow,
    direction: Schema.Literals(['textImage', 'imageText']),
    type: Schema.Literal('markdown_text_with_image').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'MarkdownTextWithImageElementDTOjsonldsyliusshopglossaryshow' });
export type MarkdownTextWithImageElementDTOjsonldsyliusshopglossaryshow = Schema.Schema.Type<
  typeof MarkdownTextWithImageElementDTOjsonldsyliusshopglossaryshow
>;
export type MarkdownTextWithImageElementDTOjsonldsyliusshopglossaryshowEncoded =
  Schema.Codec.Encoded<typeof MarkdownTextWithImageElementDTOjsonldsyliusshopglossaryshow>;

/* TeamMemberItemDTOjsonldsyliusshopglossaryshow */

export const TeamMemberItemDTOjsonldsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    name: Schema.String,
    position: Schema.Union([Schema.String, Schema.Null]),
    phone: Schema.Union([Schema.String, Schema.Null]),
    email: Schema.Union([Schema.String, Schema.Null]),
    avatar: Schema.Union([ImageClearItemDTOjsonldsyliusshopglossaryshow, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TeamMemberItemDTOjsonldsyliusshopglossaryshow' });
export type TeamMemberItemDTOjsonldsyliusshopglossaryshow = Schema.Schema.Type<
  typeof TeamMemberItemDTOjsonldsyliusshopglossaryshow
>;
export type TeamMemberItemDTOjsonldsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof TeamMemberItemDTOjsonldsyliusshopglossaryshow
>;

/* ButtonGridItemDTOjsonldsyliusshopglossaryshow */

export const ButtonGridItemDTOjsonldsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    link: Schema.String,
    text: Schema.String,
    image: Schema.Union([ImageClearItemDTOjsonldsyliusshopglossaryshow, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ButtonGridItemDTOjsonldsyliusshopglossaryshow' });
export type ButtonGridItemDTOjsonldsyliusshopglossaryshow = Schema.Schema.Type<
  typeof ButtonGridItemDTOjsonldsyliusshopglossaryshow
>;
export type ButtonGridItemDTOjsonldsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof ButtonGridItemDTOjsonldsyliusshopglossaryshow
>;

/* TableRowItemDTOjsonldsyliusshopglossaryshow */

export const TableRowItemDTOjsonldsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    cells: Schema.Array(TableCellItemDTOjsonldsyliusshopglossaryshow),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TableRowItemDTOjsonldsyliusshopglossaryshow' });
export type TableRowItemDTOjsonldsyliusshopglossaryshow = Schema.Schema.Type<
  typeof TableRowItemDTOjsonldsyliusshopglossaryshow
>;
export type TableRowItemDTOjsonldsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof TableRowItemDTOjsonldsyliusshopglossaryshow
>;

/* Ordersyliusadminorderindex */

export const Ordersyliusadminorderindex = Schema.StructWithRest(
  Schema.Struct({
    customer: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    channel: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    shippingAddress: Schema.Union([Addresssyliusadminorderindex, Schema.Null]),
    billingAddress: Schema.Union([Addresssyliusadminorderindex, Schema.Null]),
    payments: Schema.Array(Paymentsyliusadminorderindex),
    shipments: Schema.Array(Shipmentsyliusadminorderindex),
    currencyCode: Schema.String,
    localeCode: Schema.String,
    checkoutState: Schema.String.annotate({ default: 'cart' }),
    paymentState: Schema.String.annotate({ default: 'cart' }),
    shippingState: Schema.String.annotate({ default: 'cart' }),
    tokenValue: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    number: Schema.Union([Schema.String, Schema.Null]),
    notes: Schema.Union([Schema.String, Schema.Null]),
    items: Schema.Array(OrderItemsyliusadminorderindex),
    itemsTotal: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    total: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Items total + adjustments total.',
        default: 0,
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    state: Schema.String.annotate({ default: 'cart' }),
    totalWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    itemsTotalWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Sum of price of all items WITHOUT VAT tax and WITHOUT shipping and payment price',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    shippingWithoutTaxTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Shipping price without VAT (total for all shipments)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    orderPromotionTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns amount of order discount. Does not include shipping discounts.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    shippingPromotionTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    itemsSubtotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    taxTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns sum of neutral and non neutral tax adjustments on order and total tax of order items.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    shippingTaxTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    taxIncludedTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    shippingTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns shipping fee together with taxes decreased by shipping discount.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Ordersyliusadminorderindex' });
export type Ordersyliusadminorderindex = Schema.Schema.Type<typeof Ordersyliusadminorderindex>;
export type OrdersyliusadminorderindexEncoded = Schema.Codec.Encoded<
  typeof Ordersyliusadminorderindex
>;

/* Ordersyliusadminordershow */

export const Ordersyliusadminordershow = Schema.StructWithRest(
  Schema.Struct({
    customer: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    channel: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    shippingAddress: Schema.Union([Addresssyliusadminordershow, Schema.Null]),
    billingAddress: Schema.Union([Addresssyliusadminordershow, Schema.Null]),
    payments: Schema.Array(Paymentsyliusadminordershow),
    shipments: Schema.Array(Shipmentsyliusadminordershow),
    currencyCode: Schema.String,
    localeCode: Schema.String,
    checkoutState: Schema.String.annotate({ default: 'cart' }),
    paymentState: Schema.String.annotate({ default: 'cart' }),
    shippingState: Schema.String.annotate({ default: 'cart' }),
    tokenValue: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    customerIp: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    number: Schema.Union([Schema.String, Schema.Null]),
    notes: Schema.Union([Schema.String, Schema.Null]),
    items: Schema.Array(OrderItemsyliusadminordershow),
    itemsTotal: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    total: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Items total + adjustments total.',
        default: 0,
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    state: Schema.String.annotate({ default: 'cart' }),
    totalWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    itemsTotalWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Sum of price of all items WITHOUT VAT tax and WITHOUT shipping and payment price',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    shippingWithoutTaxTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Shipping price without VAT (total for all shipments)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    orderPromotionTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns amount of order discount. Does not include shipping discounts.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    shippingPromotionTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    itemsSubtotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    taxTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns sum of neutral and non neutral tax adjustments on order and total tax of order items.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    shippingTaxTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    taxIncludedTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    shippingTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns shipping fee together with taxes decreased by shipping discount.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Ordersyliusadminordershow' });
export type Ordersyliusadminordershow = Schema.Schema.Type<typeof Ordersyliusadminordershow>;
export type OrdersyliusadminordershowEncoded = Schema.Codec.Encoded<
  typeof Ordersyliusadminordershow
>;

/* Paymentsyliusshopcartshowsyliusshopcartshowdetail */

export const Paymentsyliusshopcartshowsyliusshopcartshowdetail = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    method: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    price: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    code: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    image: Schema.optionalKey(
      Schema.Union([
        PaymentMethodImagesyliusshopcartshowsyliusshopcartshowdetail,
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Paymentsyliusshopcartshowsyliusshopcartshowdetail' });
export type Paymentsyliusshopcartshowsyliusshopcartshowdetail = Schema.Schema.Type<
  typeof Paymentsyliusshopcartshowsyliusshopcartshowdetail
>;
export type PaymentsyliusshopcartshowsyliusshopcartshowdetailEncoded = Schema.Codec.Encoded<
  typeof Paymentsyliusshopcartshowsyliusshopcartshowdetail
>;

/* Shipmentsyliusshopcartshowsyliusshopcartshowdetail */

export const Shipmentsyliusshopcartshowsyliusshopcartshowdetail = Schema.StructWithRest(
  Schema.Struct({
    placementId: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    state: Schema.String.annotate({ default: 'cart' }),
    method: Schema.String.annotate({ format: 'iri-reference' }),
    shippedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    absoluteTrackingUrl: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    image: Schema.optionalKey(
      Schema.Union([
        ShippingMethodImagesyliusshopcartshowsyliusshopcartshowdetail,
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    code: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    price: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Shipmentsyliusshopcartshowsyliusshopcartshowdetail' });
export type Shipmentsyliusshopcartshowsyliusshopcartshowdetail = Schema.Schema.Type<
  typeof Shipmentsyliusshopcartshowsyliusshopcartshowdetail
>;
export type ShipmentsyliusshopcartshowsyliusshopcartshowdetailEncoded = Schema.Codec.Encoded<
  typeof Shipmentsyliusshopcartshowsyliusshopcartshowdetail
>;

/* Productsyliusshopcartshowsyliusshopcartshowdetail */

export const Productsyliusshopcartshowsyliusshopcartshowdetail = Schema.StructWithRest(
  Schema.Struct({
    ageRestriction: Schema.Literals(['none', '18+']),
    brand: Schema.Union([Brandsyliusshopcartshowsyliusshopcartshowdetail, Schema.Null]),
    mainTaxon: Schema.Union([Taxonsyliusshopcartshowsyliusshopcartshowdetail, Schema.Null]),
    mainImage: Schema.optionalKey(
      Schema.Union([ProductImagesyliusshopcartshowsyliusshopcartshowdetail, Schema.Null]).annotate({
        readOnly: true,
      })
    ),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Productsyliusshopcartshowsyliusshopcartshowdetail' });
export type Productsyliusshopcartshowsyliusshopcartshowdetail = Schema.Schema.Type<
  typeof Productsyliusshopcartshowsyliusshopcartshowdetail
>;
export type ProductsyliusshopcartshowsyliusshopcartshowdetailEncoded = Schema.Codec.Encoded<
  typeof Productsyliusshopcartshowsyliusshopcartshowdetail
>;

/* Paymentsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const Paymentsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      id: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      method: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
      price: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({ readOnly: true })
      ),
      name: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
      code: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
      image: Schema.optionalKey(
        Schema.Union([
          PaymentMethodImagesyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
          Schema.Null,
        ]).annotate({ readOnly: true })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier: 'Paymentsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type Paymentsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof Paymentsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type PaymentsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof Paymentsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* Shipmentsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const Shipmentsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      placementId: Schema.Union([Schema.String, Schema.Null]),
      id: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      state: Schema.String.annotate({ default: 'cart' }),
      method: Schema.String.annotate({ format: 'iri-reference' }),
      shippedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
      absoluteTrackingUrl: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
      image: Schema.optionalKey(
        Schema.Union([
          ShippingMethodImagesyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
          Schema.Null,
        ]).annotate({ readOnly: true })
      ),
      name: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
      code: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
      price: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({ readOnly: true })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier: 'Shipmentsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type Shipmentsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof Shipmentsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type ShipmentsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof Shipmentsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* Productsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const Productsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      ageRestriction: Schema.Literals(['none', '18+']),
      brand: Schema.Union([
        Brandsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
        Schema.Null,
      ]),
      mainTaxon: Schema.Union([
        Taxonsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
        Schema.Null,
      ]),
      mainImage: Schema.optionalKey(
        Schema.Union([
          ProductImagesyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
          Schema.Null,
        ]).annotate({ readOnly: true })
      ),
      routerUrl: Schema.String.annotate({
        description: 'Frontend router URL for this resource.',
        readOnly: true,
      }),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier: 'Productsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type Productsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof Productsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type ProductsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof Productsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* Ordersyliusshoporderaccountshow */

export const Ordersyliusshoporderaccountshow = Schema.StructWithRest(
  Schema.Struct({
    invoiceId: Schema.Union([Schema.String, Schema.Null]),
    shippingAddress: Schema.Union([Addresssyliusshoporderaccountshow, Schema.Null]),
    billingAddress: Schema.Union([Addresssyliusshoporderaccountshow, Schema.Null]),
    payments: Schema.Array(Paymentsyliusshoporderaccountshow),
    shipments: Schema.Array(Shipmentsyliusshoporderaccountshow),
    localeCode: Schema.String,
    promotionCoupon: Schema.Union([
      Schema.String.annotate({ format: 'iri-reference' }),
      Schema.Null,
    ]),
    checkoutState: Schema.String.annotate({ default: 'cart' }),
    tokenValue: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    number: Schema.Union([Schema.String, Schema.Null]),
    items: Schema.Array(OrderItemsyliusshoporderaccountshow),
    itemsTotal: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    total: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Items total + adjustments total.',
        default: 0,
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    totalWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    itemsTotalWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Sum of price of all items WITHOUT VAT tax and WITHOUT shipping and payment price',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    orderPromotionTotalWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Order promotional total without VAT (total for all shipments)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    shippingWithoutTaxTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Shipping price without VAT (total for all shipments)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    orderPromotionTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns amount of order discount. Does not include shipping discounts.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    shippingPromotionTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    itemsSubtotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    taxTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns sum of neutral and non neutral tax adjustments on order and total tax of order items.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    shippingTaxTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    taxIncludedTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    shippingTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns shipping fee together with taxes decreased by shipping discount.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    invoiceUrl: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        description: 'Temporary Invoice file download url',
        readOnly: true,
      })
    ),
    globalState: Schema.optionalKey(
      Schema.Union([
        Schema.Literals([
          'AcceptedForPayment',
          'Paid',
          'AcceptedForProcessing',
          'Processing',
          'Resolved',
          'ResolvedStore',
          'ResolvedWithoutEmail',
          'Cancelled',
          'TopolPickup',
          'PardubicePickup',
          'NotPaidEmail',
          'NotPaidCancelled',
          'NotPickedUp',
        ]),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Ordersyliusshoporderaccountshow' });
export type Ordersyliusshoporderaccountshow = Schema.Schema.Type<
  typeof Ordersyliusshoporderaccountshow
>;
export type OrdersyliusshoporderaccountshowEncoded = Schema.Codec.Encoded<
  typeof Ordersyliusshoporderaccountshow
>;

/* Paymentsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const Paymentsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      id: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      method: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
      price: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({ readOnly: true })
      ),
      name: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
      code: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
      image: Schema.optionalKey(
        Schema.Union([
          PaymentMethodImagesyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
          Schema.Null,
        ]).annotate({ readOnly: true })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'Paymentsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type Paymentsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof Paymentsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type PaymentsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof Paymentsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* Shipmentsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const Shipmentsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      placementId: Schema.Union([Schema.String, Schema.Null]),
      id: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      state: Schema.String.annotate({ default: 'cart' }),
      method: Schema.String.annotate({ format: 'iri-reference' }),
      tracking: Schema.Union([Schema.String, Schema.Null]),
      shippedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
      absoluteTrackingUrl: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
      image: Schema.optionalKey(
        Schema.Union([
          ShippingMethodImagesyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
          Schema.Null,
        ]).annotate({ readOnly: true })
      ),
      name: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
      code: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
      price: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({ readOnly: true })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'Shipmentsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type Shipmentsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof Shipmentsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type ShipmentsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof Shipmentsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* Productsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const Productsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      ageRestriction: Schema.Literals(['none', '18+']),
      brand: Schema.Union([
        Brandsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
        Schema.Null,
      ]),
      mainTaxon: Schema.Union([
        Taxonsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
        Schema.Null,
      ]),
      mainImage: Schema.optionalKey(
        Schema.Union([
          ProductImagesyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
          Schema.Null,
        ]).annotate({ readOnly: true })
      ),
      routerUrl: Schema.String.annotate({
        description: 'Frontend router URL for this resource.',
        readOnly: true,
      }),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'Productsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type Productsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof Productsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type ProductsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof Productsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* Productsyliusshoporderindex */

export const Productsyliusshoporderindex = Schema.StructWithRest(
  Schema.Struct({
    ageRestriction: Schema.Literals(['none', '18+']),
    mainImage: Schema.optionalKey(
      Schema.Union([ProductImagesyliusshoporderindex, Schema.Null]).annotate({ readOnly: true })
    ),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Productsyliusshoporderindex' });
export type Productsyliusshoporderindex = Schema.Schema.Type<typeof Productsyliusshoporderindex>;
export type ProductsyliusshoporderindexEncoded = Schema.Codec.Encoded<
  typeof Productsyliusshoporderindex
>;

/* OrderItemsyliusshoporderitemshow */

export const OrderItemsyliusshoporderitemshow = Schema.StructWithRest(
  Schema.Struct({
    variant: Schema.String.annotate({ format: 'iri-reference' }),
    productName: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    order: Ordersyliusshoporderitemshow,
    quantity: Schema.Number.annotate({ default: 0, readOnly: true })
      .check(Schema.isInt().annotate({ expected: 'an integer' }))
      .check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
    unitPrice: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    originalUnitPrice: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({ default: 0 }),
    total: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    units: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    adjustments: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    adjustmentsTotal: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    product: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        readOnly: true,
        format: 'iri-reference',
      })
    ),
    frontUnitPriceWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    frontItemsPriceWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    frontUnitPriceDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Nominal value of sum of all discounts applied on unit\nDiscount technically contains VAT part (is applied for source price including VAT)\nValue is nominal for both nominal and percentage discounts\nValue is average for all units (if special discounts are per unit, this filed must be calculated custom for each every unit)\nNumber is positive.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontItemsPriceDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Nominal value of sum of all discounts applied on items (all units)\nDiscount technically contains VAT part (is applied for source price including VAT)\nValue is nominal for both nominal and percentage discounts\nNumber is positive.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontUnitPriceWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Unit price with VAT and after all product discounts (including order level discounts on products)\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontUnitPriceWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Unit price without VAT and after all product discounts (including order level discounts on products)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontUnitPricePaid: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    frontItemsPriceWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Sum of items (all units) with VAT and after all product discounts (including order level discounts on products)\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontItemsPriceWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Sum of items (all units) without VAT and after all product discounts (including order level discounts on products)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontUnitTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Tax as nominal value applied on unit price AFTER discount\nNULL if customer is verified to NOT pay VAT for Order (basically zero tax)',
        readOnly: true,
      })
    ),
    frontItemsTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Tax as nominal value applied on items (all units) price AFTER discount\nNULL if customer is verified to NOT pay VAT for Order (basically zero tax)',
        readOnly: true,
      })
    ),
    frontItemsPricePaid: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    discountedUnitPrice: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns single unit price lowered by order unit promotions (each unit must have the same unit promotion discount)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    adjustmentsRecursively: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    adjustmentsTotalRecursively: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    subtotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'OrderItemsyliusshoporderitemshow' });
export type OrderItemsyliusshoporderitemshow = Schema.Schema.Type<
  typeof OrderItemsyliusshoporderitemshow
>;
export type OrderItemsyliusshoporderitemshowEncoded = Schema.Codec.Encoded<
  typeof OrderItemsyliusshoporderitemshow
>;

/* Orderjsonldsyliusadminorderindex */

export const Orderjsonldsyliusadminorderindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    customer: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    channel: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    shippingAddress: Schema.Union([Addressjsonldsyliusadminorderindex, Schema.Null]),
    billingAddress: Schema.Union([Addressjsonldsyliusadminorderindex, Schema.Null]),
    payments: Schema.Array(Paymentjsonldsyliusadminorderindex),
    shipments: Schema.Array(Shipmentjsonldsyliusadminorderindex),
    currencyCode: Schema.String,
    localeCode: Schema.String,
    checkoutState: Schema.String.annotate({ default: 'cart' }),
    paymentState: Schema.String.annotate({ default: 'cart' }),
    shippingState: Schema.String.annotate({ default: 'cart' }),
    tokenValue: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    number: Schema.Union([Schema.String, Schema.Null]),
    notes: Schema.Union([Schema.String, Schema.Null]),
    items: Schema.Array(OrderItemjsonldsyliusadminorderindex),
    itemsTotal: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    total: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Items total + adjustments total.',
        default: 0,
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    state: Schema.String.annotate({ default: 'cart' }),
    totalWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    itemsTotalWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Sum of price of all items WITHOUT VAT tax and WITHOUT shipping and payment price',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    shippingWithoutTaxTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Shipping price without VAT (total for all shipments)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    orderPromotionTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns amount of order discount. Does not include shipping discounts.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    shippingPromotionTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    itemsSubtotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    taxTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns sum of neutral and non neutral tax adjustments on order and total tax of order items.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    shippingTaxTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    taxIncludedTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    shippingTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns shipping fee together with taxes decreased by shipping discount.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Orderjsonldsyliusadminorderindex' });
export type Orderjsonldsyliusadminorderindex = Schema.Schema.Type<
  typeof Orderjsonldsyliusadminorderindex
>;
export type OrderjsonldsyliusadminorderindexEncoded = Schema.Codec.Encoded<
  typeof Orderjsonldsyliusadminorderindex
>;

/* Orderjsonldsyliusadminordershow */

export const Orderjsonldsyliusadminordershow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    customer: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    channel: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    shippingAddress: Schema.Union([Addressjsonldsyliusadminordershow, Schema.Null]),
    billingAddress: Schema.Union([Addressjsonldsyliusadminordershow, Schema.Null]),
    payments: Schema.Array(Paymentjsonldsyliusadminordershow),
    shipments: Schema.Array(Shipmentjsonldsyliusadminordershow),
    currencyCode: Schema.String,
    localeCode: Schema.String,
    checkoutState: Schema.String.annotate({ default: 'cart' }),
    paymentState: Schema.String.annotate({ default: 'cart' }),
    shippingState: Schema.String.annotate({ default: 'cart' }),
    tokenValue: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    customerIp: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    number: Schema.Union([Schema.String, Schema.Null]),
    notes: Schema.Union([Schema.String, Schema.Null]),
    items: Schema.Array(OrderItemjsonldsyliusadminordershow),
    itemsTotal: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    total: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Items total + adjustments total.',
        default: 0,
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    state: Schema.String.annotate({ default: 'cart' }),
    totalWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    itemsTotalWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Sum of price of all items WITHOUT VAT tax and WITHOUT shipping and payment price',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    shippingWithoutTaxTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Shipping price without VAT (total for all shipments)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    orderPromotionTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns amount of order discount. Does not include shipping discounts.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    shippingPromotionTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    itemsSubtotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    taxTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns sum of neutral and non neutral tax adjustments on order and total tax of order items.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    shippingTaxTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    taxIncludedTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    shippingTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns shipping fee together with taxes decreased by shipping discount.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Orderjsonldsyliusadminordershow' });
export type Orderjsonldsyliusadminordershow = Schema.Schema.Type<
  typeof Orderjsonldsyliusadminordershow
>;
export type OrderjsonldsyliusadminordershowEncoded = Schema.Codec.Encoded<
  typeof Orderjsonldsyliusadminordershow
>;

/* Paymentjsonldsyliusshopcartshowsyliusshopcartshowdetail */

export const Paymentjsonldsyliusshopcartshowsyliusshopcartshowdetail = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    method: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    price: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    code: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    image: Schema.optionalKey(
      Schema.Union([
        PaymentMethodImagejsonldsyliusshopcartshowsyliusshopcartshowdetail,
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Paymentjsonldsyliusshopcartshowsyliusshopcartshowdetail' });
export type Paymentjsonldsyliusshopcartshowsyliusshopcartshowdetail = Schema.Schema.Type<
  typeof Paymentjsonldsyliusshopcartshowsyliusshopcartshowdetail
>;
export type PaymentjsonldsyliusshopcartshowsyliusshopcartshowdetailEncoded = Schema.Codec.Encoded<
  typeof Paymentjsonldsyliusshopcartshowsyliusshopcartshowdetail
>;

/* Shipmentjsonldsyliusshopcartshowsyliusshopcartshowdetail */

export const Shipmentjsonldsyliusshopcartshowsyliusshopcartshowdetail = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    placementId: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    state: Schema.String.annotate({ default: 'cart' }),
    method: Schema.String.annotate({ format: 'iri-reference' }),
    shippedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    absoluteTrackingUrl: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    image: Schema.optionalKey(
      Schema.Union([
        ShippingMethodImagejsonldsyliusshopcartshowsyliusshopcartshowdetail,
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    code: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    price: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Shipmentjsonldsyliusshopcartshowsyliusshopcartshowdetail' });
export type Shipmentjsonldsyliusshopcartshowsyliusshopcartshowdetail = Schema.Schema.Type<
  typeof Shipmentjsonldsyliusshopcartshowsyliusshopcartshowdetail
>;
export type ShipmentjsonldsyliusshopcartshowsyliusshopcartshowdetailEncoded = Schema.Codec.Encoded<
  typeof Shipmentjsonldsyliusshopcartshowsyliusshopcartshowdetail
>;

/* Productjsonldsyliusshopcartshowsyliusshopcartshowdetail */

export const Productjsonldsyliusshopcartshowsyliusshopcartshowdetail = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    ageRestriction: Schema.Literals(['none', '18+']),
    brand: Schema.Union([Brandjsonldsyliusshopcartshowsyliusshopcartshowdetail, Schema.Null]),
    mainTaxon: Schema.Union([Taxonjsonldsyliusshopcartshowsyliusshopcartshowdetail, Schema.Null]),
    mainImage: Schema.optionalKey(
      Schema.Union([
        ProductImagejsonldsyliusshopcartshowsyliusshopcartshowdetail,
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Productjsonldsyliusshopcartshowsyliusshopcartshowdetail' });
export type Productjsonldsyliusshopcartshowsyliusshopcartshowdetail = Schema.Schema.Type<
  typeof Productjsonldsyliusshopcartshowsyliusshopcartshowdetail
>;
export type ProductjsonldsyliusshopcartshowsyliusshopcartshowdetailEncoded = Schema.Codec.Encoded<
  typeof Productjsonldsyliusshopcartshowsyliusshopcartshowdetail
>;

/* Paymentjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const Paymentjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      id: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      method: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
      price: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({ readOnly: true })
      ),
      name: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
      code: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
      image: Schema.optionalKey(
        Schema.Union([
          PaymentMethodImagejsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
          Schema.Null,
        ]).annotate({ readOnly: true })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier: 'Paymentjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type Paymentjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof Paymentjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type PaymentjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof Paymentjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* Shipmentjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const Shipmentjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      placementId: Schema.Union([Schema.String, Schema.Null]),
      id: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      state: Schema.String.annotate({ default: 'cart' }),
      method: Schema.String.annotate({ format: 'iri-reference' }),
      shippedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
      absoluteTrackingUrl: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
      image: Schema.optionalKey(
        Schema.Union([
          ShippingMethodImagejsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
          Schema.Null,
        ]).annotate({ readOnly: true })
      ),
      name: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
      code: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
      price: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({ readOnly: true })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier: 'Shipmentjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type Shipmentjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof Shipmentjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type ShipmentjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof Shipmentjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* Productjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const Productjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      ageRestriction: Schema.Literals(['none', '18+']),
      brand: Schema.Union([
        Brandjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
        Schema.Null,
      ]),
      mainTaxon: Schema.Union([
        Taxonjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
        Schema.Null,
      ]),
      mainImage: Schema.optionalKey(
        Schema.Union([
          ProductImagejsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
          Schema.Null,
        ]).annotate({ readOnly: true })
      ),
      routerUrl: Schema.String.annotate({
        description: 'Frontend router URL for this resource.',
        readOnly: true,
      }),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier: 'Productjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type Productjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof Productjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type ProductjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof Productjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* Orderjsonldsyliusshoporderaccountshow */

export const Orderjsonldsyliusshoporderaccountshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    invoiceId: Schema.Union([Schema.String, Schema.Null]),
    shippingAddress: Schema.Union([Addressjsonldsyliusshoporderaccountshow, Schema.Null]),
    billingAddress: Schema.Union([Addressjsonldsyliusshoporderaccountshow, Schema.Null]),
    payments: Schema.Array(Paymentjsonldsyliusshoporderaccountshow),
    shipments: Schema.Array(Shipmentjsonldsyliusshoporderaccountshow),
    localeCode: Schema.String,
    promotionCoupon: Schema.Union([
      Schema.String.annotate({ format: 'iri-reference' }),
      Schema.Null,
    ]),
    checkoutState: Schema.String.annotate({ default: 'cart' }),
    tokenValue: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    number: Schema.Union([Schema.String, Schema.Null]),
    items: Schema.Array(OrderItemjsonldsyliusshoporderaccountshow),
    itemsTotal: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    total: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Items total + adjustments total.',
        default: 0,
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    totalWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    itemsTotalWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Sum of price of all items WITHOUT VAT tax and WITHOUT shipping and payment price',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    orderPromotionTotalWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Order promotional total without VAT (total for all shipments)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    shippingWithoutTaxTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Shipping price without VAT (total for all shipments)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    orderPromotionTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns amount of order discount. Does not include shipping discounts.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    shippingPromotionTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    itemsSubtotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    taxTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns sum of neutral and non neutral tax adjustments on order and total tax of order items.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    shippingTaxTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    taxIncludedTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    shippingTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns shipping fee together with taxes decreased by shipping discount.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    invoiceUrl: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        description: 'Temporary Invoice file download url',
        readOnly: true,
      })
    ),
    globalState: Schema.optionalKey(
      Schema.Union([
        Schema.Literals([
          'AcceptedForPayment',
          'Paid',
          'AcceptedForProcessing',
          'Processing',
          'Resolved',
          'ResolvedStore',
          'ResolvedWithoutEmail',
          'Cancelled',
          'TopolPickup',
          'PardubicePickup',
          'NotPaidEmail',
          'NotPaidCancelled',
          'NotPickedUp',
        ]),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Orderjsonldsyliusshoporderaccountshow' });
export type Orderjsonldsyliusshoporderaccountshow = Schema.Schema.Type<
  typeof Orderjsonldsyliusshoporderaccountshow
>;
export type OrderjsonldsyliusshoporderaccountshowEncoded = Schema.Codec.Encoded<
  typeof Orderjsonldsyliusshoporderaccountshow
>;

/* Paymentjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const Paymentjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      id: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      method: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
      price: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({ readOnly: true })
      ),
      name: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
      code: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
      image: Schema.optionalKey(
        Schema.Union([
          PaymentMethodImagejsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
          Schema.Null,
        ]).annotate({ readOnly: true })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'Paymentjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type Paymentjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof Paymentjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type PaymentjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof Paymentjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* Shipmentjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const Shipmentjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      placementId: Schema.Union([Schema.String, Schema.Null]),
      id: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      state: Schema.String.annotate({ default: 'cart' }),
      method: Schema.String.annotate({ format: 'iri-reference' }),
      tracking: Schema.Union([Schema.String, Schema.Null]),
      shippedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
      absoluteTrackingUrl: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
      image: Schema.optionalKey(
        Schema.Union([
          ShippingMethodImagejsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
          Schema.Null,
        ]).annotate({ readOnly: true })
      ),
      name: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
      code: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
      price: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({ readOnly: true })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'Shipmentjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type Shipmentjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof Shipmentjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type ShipmentjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof Shipmentjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* Productjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const Productjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      ageRestriction: Schema.Literals(['none', '18+']),
      brand: Schema.Union([
        Brandjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
        Schema.Null,
      ]),
      mainTaxon: Schema.Union([
        Taxonjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
        Schema.Null,
      ]),
      mainImage: Schema.optionalKey(
        Schema.Union([
          ProductImagejsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
          Schema.Null,
        ]).annotate({ readOnly: true })
      ),
      routerUrl: Schema.String.annotate({
        description: 'Frontend router URL for this resource.',
        readOnly: true,
      }),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'Productjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type Productjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof Productjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type ProductjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof Productjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* Productjsonldsyliusshoporderindex */

export const Productjsonldsyliusshoporderindex = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    ageRestriction: Schema.Literals(['none', '18+']),
    mainImage: Schema.optionalKey(
      Schema.Union([ProductImagejsonldsyliusshoporderindex, Schema.Null]).annotate({
        readOnly: true,
      })
    ),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Productjsonldsyliusshoporderindex' });
export type Productjsonldsyliusshoporderindex = Schema.Schema.Type<
  typeof Productjsonldsyliusshoporderindex
>;
export type ProductjsonldsyliusshoporderindexEncoded = Schema.Codec.Encoded<
  typeof Productjsonldsyliusshoporderindex
>;

/* OrderItemjsonldsyliusshoporderitemshow */

export const OrderItemjsonldsyliusshoporderitemshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    variant: Schema.String.annotate({ format: 'iri-reference' }),
    productName: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    order: Orderjsonldsyliusshoporderitemshow,
    quantity: Schema.Number.annotate({ default: 0, readOnly: true })
      .check(Schema.isInt().annotate({ expected: 'an integer' }))
      .check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
    unitPrice: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    originalUnitPrice: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({ default: 0 }),
    total: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    units: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    adjustments: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    adjustmentsTotal: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    product: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        readOnly: true,
        format: 'iri-reference',
      })
    ),
    frontUnitPriceWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    frontItemsPriceWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    frontUnitPriceDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Nominal value of sum of all discounts applied on unit\nDiscount technically contains VAT part (is applied for source price including VAT)\nValue is nominal for both nominal and percentage discounts\nValue is average for all units (if special discounts are per unit, this filed must be calculated custom for each every unit)\nNumber is positive.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontItemsPriceDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Nominal value of sum of all discounts applied on items (all units)\nDiscount technically contains VAT part (is applied for source price including VAT)\nValue is nominal for both nominal and percentage discounts\nNumber is positive.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontUnitPriceWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Unit price with VAT and after all product discounts (including order level discounts on products)\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontUnitPriceWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Unit price without VAT and after all product discounts (including order level discounts on products)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontUnitPricePaid: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    frontItemsPriceWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Sum of items (all units) with VAT and after all product discounts (including order level discounts on products)\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontItemsPriceWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Sum of items (all units) without VAT and after all product discounts (including order level discounts on products)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontUnitTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Tax as nominal value applied on unit price AFTER discount\nNULL if customer is verified to NOT pay VAT for Order (basically zero tax)',
        readOnly: true,
      })
    ),
    frontItemsTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Tax as nominal value applied on items (all units) price AFTER discount\nNULL if customer is verified to NOT pay VAT for Order (basically zero tax)',
        readOnly: true,
      })
    ),
    frontItemsPricePaid: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    discountedUnitPrice: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns single unit price lowered by order unit promotions (each unit must have the same unit promotion discount)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    adjustmentsRecursively: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    adjustmentsTotalRecursively: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    subtotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'OrderItemjsonldsyliusshoporderitemshow' });
export type OrderItemjsonldsyliusshoporderitemshow = Schema.Schema.Type<
  typeof OrderItemjsonldsyliusshoporderitemshow
>;
export type OrderItemjsonldsyliusshoporderitemshowEncoded = Schema.Codec.Encoded<
  typeof OrderItemjsonldsyliusshoporderitemshow
>;

/* ImageCollectionElementDTOsyliusshoppageshow */

export const ImageCollectionElementDTOsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    images: Schema.Array(ImageItemDTOsyliusshoppageshow),
    type: Schema.Literal('image_collection').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ImageCollectionElementDTOsyliusshoppageshow' });
export type ImageCollectionElementDTOsyliusshoppageshow = Schema.Schema.Type<
  typeof ImageCollectionElementDTOsyliusshoppageshow
>;
export type ImageCollectionElementDTOsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof ImageCollectionElementDTOsyliusshoppageshow
>;

/* ImagePairElementDTOsyliusshoppageshow */

export const ImagePairElementDTOsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    first: Schema.Union([ImageItemDTOsyliusshoppageshow, Schema.Null]),
    second: Schema.Union([ImageItemDTOsyliusshoppageshow, Schema.Null]),
    type: Schema.Literal('image_pair').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ImagePairElementDTOsyliusshoppageshow' });
export type ImagePairElementDTOsyliusshoppageshow = Schema.Schema.Type<
  typeof ImagePairElementDTOsyliusshoppageshow
>;
export type ImagePairElementDTOsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof ImagePairElementDTOsyliusshoppageshow
>;

/* MarkdownTextWithImageElementDTOsyliusshoppageshow */

export const MarkdownTextWithImageElementDTOsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    text: Schema.String,
    image: ImageItemDTOsyliusshoppageshow,
    direction: Schema.Literals(['textImage', 'imageText']),
    type: Schema.Literal('markdown_text_with_image').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'MarkdownTextWithImageElementDTOsyliusshoppageshow' });
export type MarkdownTextWithImageElementDTOsyliusshoppageshow = Schema.Schema.Type<
  typeof MarkdownTextWithImageElementDTOsyliusshoppageshow
>;
export type MarkdownTextWithImageElementDTOsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof MarkdownTextWithImageElementDTOsyliusshoppageshow
>;

/* Productsyliusshoppageshow */

export const Productsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    ageRestriction: Schema.Literals(['none', '18+']),
    averageRating: Schema.Number.annotate({ default: 0 }).check(
      Schema.isFinite().annotate({ expected: 'a finite number' })
    ),
    code: Schema.String,
    createdAt: Schema.optionalKey(DateTimeSerializableFromString),
    updatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    mainImage: Schema.optionalKey(
      Schema.Union([ProductImagesyliusshoppageshow, Schema.Null]).annotate({ readOnly: true })
    ),
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    shortDescription: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    subtitle: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Productsyliusshoppageshow' });
export type Productsyliusshoppageshow = Schema.Schema.Type<typeof Productsyliusshoppageshow>;
export type ProductsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof Productsyliusshoppageshow
>;

/* TeamMemberItemDTOsyliusshoppageshow */

export const TeamMemberItemDTOsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    name: Schema.String,
    position: Schema.Union([Schema.String, Schema.Null]),
    phone: Schema.Union([Schema.String, Schema.Null]),
    email: Schema.Union([Schema.String, Schema.Null]),
    avatar: Schema.Union([ImageClearItemDTOsyliusshoppageshow, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TeamMemberItemDTOsyliusshoppageshow' });
export type TeamMemberItemDTOsyliusshoppageshow = Schema.Schema.Type<
  typeof TeamMemberItemDTOsyliusshoppageshow
>;
export type TeamMemberItemDTOsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof TeamMemberItemDTOsyliusshoppageshow
>;

/* ButtonGridItemDTOsyliusshoppageshow */

export const ButtonGridItemDTOsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    link: Schema.String,
    text: Schema.String,
    image: Schema.Union([ImageClearItemDTOsyliusshoppageshow, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ButtonGridItemDTOsyliusshoppageshow' });
export type ButtonGridItemDTOsyliusshoppageshow = Schema.Schema.Type<
  typeof ButtonGridItemDTOsyliusshoppageshow
>;
export type ButtonGridItemDTOsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof ButtonGridItemDTOsyliusshoppageshow
>;

/* TableRowItemDTOsyliusshoppageshow */

export const TableRowItemDTOsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({ cells: Schema.Array(TableCellItemDTOsyliusshoppageshow) }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TableRowItemDTOsyliusshoppageshow' });
export type TableRowItemDTOsyliusshoppageshow = Schema.Schema.Type<
  typeof TableRowItemDTOsyliusshoppageshow
>;
export type TableRowItemDTOsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof TableRowItemDTOsyliusshoppageshow
>;

/* ImageCollectionElementDTOjsonldsyliusshoppageshow */

export const ImageCollectionElementDTOjsonldsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    images: Schema.Array(ImageItemDTOjsonldsyliusshoppageshow),
    type: Schema.Literal('image_collection').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ImageCollectionElementDTOjsonldsyliusshoppageshow' });
export type ImageCollectionElementDTOjsonldsyliusshoppageshow = Schema.Schema.Type<
  typeof ImageCollectionElementDTOjsonldsyliusshoppageshow
>;
export type ImageCollectionElementDTOjsonldsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof ImageCollectionElementDTOjsonldsyliusshoppageshow
>;

/* ImagePairElementDTOjsonldsyliusshoppageshow */

export const ImagePairElementDTOjsonldsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    first: Schema.Union([ImageItemDTOjsonldsyliusshoppageshow, Schema.Null]),
    second: Schema.Union([ImageItemDTOjsonldsyliusshoppageshow, Schema.Null]),
    type: Schema.Literal('image_pair').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ImagePairElementDTOjsonldsyliusshoppageshow' });
export type ImagePairElementDTOjsonldsyliusshoppageshow = Schema.Schema.Type<
  typeof ImagePairElementDTOjsonldsyliusshoppageshow
>;
export type ImagePairElementDTOjsonldsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof ImagePairElementDTOjsonldsyliusshoppageshow
>;

/* MarkdownTextWithImageElementDTOjsonldsyliusshoppageshow */

export const MarkdownTextWithImageElementDTOjsonldsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    text: Schema.String,
    image: ImageItemDTOjsonldsyliusshoppageshow,
    direction: Schema.Literals(['textImage', 'imageText']),
    type: Schema.Literal('markdown_text_with_image').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'MarkdownTextWithImageElementDTOjsonldsyliusshoppageshow' });
export type MarkdownTextWithImageElementDTOjsonldsyliusshoppageshow = Schema.Schema.Type<
  typeof MarkdownTextWithImageElementDTOjsonldsyliusshoppageshow
>;
export type MarkdownTextWithImageElementDTOjsonldsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof MarkdownTextWithImageElementDTOjsonldsyliusshoppageshow
>;

/* Productjsonldsyliusshoppageshow */

export const Productjsonldsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    ageRestriction: Schema.Literals(['none', '18+']),
    averageRating: Schema.Number.annotate({ default: 0 }).check(
      Schema.isFinite().annotate({ expected: 'a finite number' })
    ),
    code: Schema.String,
    createdAt: Schema.optionalKey(DateTimeSerializableFromString),
    updatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    mainImage: Schema.optionalKey(
      Schema.Union([ProductImagejsonldsyliusshoppageshow, Schema.Null]).annotate({ readOnly: true })
    ),
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    shortDescription: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    subtitle: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Productjsonldsyliusshoppageshow' });
export type Productjsonldsyliusshoppageshow = Schema.Schema.Type<
  typeof Productjsonldsyliusshoppageshow
>;
export type ProductjsonldsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof Productjsonldsyliusshoppageshow
>;

/* TeamMemberItemDTOjsonldsyliusshoppageshow */

export const TeamMemberItemDTOjsonldsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    name: Schema.String,
    position: Schema.Union([Schema.String, Schema.Null]),
    phone: Schema.Union([Schema.String, Schema.Null]),
    email: Schema.Union([Schema.String, Schema.Null]),
    avatar: Schema.Union([ImageClearItemDTOjsonldsyliusshoppageshow, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TeamMemberItemDTOjsonldsyliusshoppageshow' });
export type TeamMemberItemDTOjsonldsyliusshoppageshow = Schema.Schema.Type<
  typeof TeamMemberItemDTOjsonldsyliusshoppageshow
>;
export type TeamMemberItemDTOjsonldsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof TeamMemberItemDTOjsonldsyliusshoppageshow
>;

/* ButtonGridItemDTOjsonldsyliusshoppageshow */

export const ButtonGridItemDTOjsonldsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    link: Schema.String,
    text: Schema.String,
    image: Schema.Union([ImageClearItemDTOjsonldsyliusshoppageshow, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ButtonGridItemDTOjsonldsyliusshoppageshow' });
export type ButtonGridItemDTOjsonldsyliusshoppageshow = Schema.Schema.Type<
  typeof ButtonGridItemDTOjsonldsyliusshoppageshow
>;
export type ButtonGridItemDTOjsonldsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof ButtonGridItemDTOjsonldsyliusshoppageshow
>;

/* TableRowItemDTOjsonldsyliusshoppageshow */

export const TableRowItemDTOjsonldsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    cells: Schema.Array(TableCellItemDTOjsonldsyliusshoppageshow),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TableRowItemDTOjsonldsyliusshoppageshow' });
export type TableRowItemDTOjsonldsyliusshoppageshow = Schema.Schema.Type<
  typeof TableRowItemDTOjsonldsyliusshoppageshow
>;
export type TableRowItemDTOjsonldsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof TableRowItemDTOjsonldsyliusshoppageshow
>;

/* Paymentsyliusadminpaymentindex */

export const Paymentsyliusadminpaymentindex = Schema.StructWithRest(
  Schema.Struct({
    order: Schema.String.annotate({ format: 'iri-reference' }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    method: Schema.optionalKey(
      Schema.Union([PaymentMethodsyliusadminpaymentindex, Schema.Null]).annotate({ readOnly: true })
    ),
    currencyCode: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    amount: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    state: Schema.optionalKey(Schema.String.annotate({ default: 'cart', readOnly: true })),
    details: Schema.optionalKey(
      Schema.Array(Schema.Union([Schema.String, Schema.Null])).annotate({ readOnly: true })
    ),
    createdAt: Schema.optionalKey(DateTimeSerializableFromString),
    updatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    price: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Paymentsyliusadminpaymentindex' });
export type Paymentsyliusadminpaymentindex = Schema.Schema.Type<
  typeof Paymentsyliusadminpaymentindex
>;
export type PaymentsyliusadminpaymentindexEncoded = Schema.Codec.Encoded<
  typeof Paymentsyliusadminpaymentindex
>;

/* Paymentsyliusadminpaymentshow */

export const Paymentsyliusadminpaymentshow = Schema.StructWithRest(
  Schema.Struct({
    order: Schema.String.annotate({ format: 'iri-reference' }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    method: Schema.optionalKey(
      Schema.Union([PaymentMethodsyliusadminpaymentshow, Schema.Null]).annotate({ readOnly: true })
    ),
    currencyCode: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    amount: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    state: Schema.optionalKey(Schema.String.annotate({ default: 'cart', readOnly: true })),
    details: Schema.optionalKey(
      Schema.Array(Schema.Union([Schema.String, Schema.Null])).annotate({ readOnly: true })
    ),
    createdAt: Schema.optionalKey(DateTimeSerializableFromString),
    updatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    price: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Paymentsyliusadminpaymentshow' });
export type Paymentsyliusadminpaymentshow = Schema.Schema.Type<
  typeof Paymentsyliusadminpaymentshow
>;
export type PaymentsyliusadminpaymentshowEncoded = Schema.Codec.Encoded<
  typeof Paymentsyliusadminpaymentshow
>;

/* Paymentsyliusshoppaymentshow */

export const Paymentsyliusshoppaymentshow = Schema.StructWithRest(
  Schema.Struct({
    order: Schema.String.annotate({ format: 'iri-reference' }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    method: Schema.optionalKey(
      Schema.Union([PaymentMethodsyliusshoppaymentshow, Schema.Null]).annotate({ readOnly: true })
    ),
    currencyCode: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    amount: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    state: Schema.optionalKey(Schema.String.annotate({ default: 'cart', readOnly: true })),
    details: Schema.optionalKey(
      Schema.Array(Schema.Union([Schema.String, Schema.Null])).annotate({ readOnly: true })
    ),
    createdAt: Schema.optionalKey(DateTimeSerializableFromString),
    updatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    price: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Paymentsyliusshoppaymentshow' });
export type Paymentsyliusshoppaymentshow = Schema.Schema.Type<typeof Paymentsyliusshoppaymentshow>;
export type PaymentsyliusshoppaymentshowEncoded = Schema.Codec.Encoded<
  typeof Paymentsyliusshoppaymentshow
>;

/* Paymentjsonldsyliusadminpaymentindex */

export const Paymentjsonldsyliusadminpaymentindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    order: Schema.String.annotate({ format: 'iri-reference' }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    method: Schema.optionalKey(
      Schema.Union([PaymentMethodjsonldsyliusadminpaymentindex, Schema.Null]).annotate({
        readOnly: true,
      })
    ),
    currencyCode: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    amount: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    state: Schema.optionalKey(Schema.String.annotate({ default: 'cart', readOnly: true })),
    details: Schema.optionalKey(
      Schema.Array(Schema.Union([Schema.String, Schema.Null])).annotate({ readOnly: true })
    ),
    createdAt: Schema.optionalKey(DateTimeSerializableFromString),
    updatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    price: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Paymentjsonldsyliusadminpaymentindex' });
export type Paymentjsonldsyliusadminpaymentindex = Schema.Schema.Type<
  typeof Paymentjsonldsyliusadminpaymentindex
>;
export type PaymentjsonldsyliusadminpaymentindexEncoded = Schema.Codec.Encoded<
  typeof Paymentjsonldsyliusadminpaymentindex
>;

/* Paymentjsonldsyliusadminpaymentshow */

export const Paymentjsonldsyliusadminpaymentshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    order: Schema.String.annotate({ format: 'iri-reference' }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    method: Schema.optionalKey(
      Schema.Union([PaymentMethodjsonldsyliusadminpaymentshow, Schema.Null]).annotate({
        readOnly: true,
      })
    ),
    currencyCode: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    amount: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    state: Schema.optionalKey(Schema.String.annotate({ default: 'cart', readOnly: true })),
    details: Schema.optionalKey(
      Schema.Array(Schema.Union([Schema.String, Schema.Null])).annotate({ readOnly: true })
    ),
    createdAt: Schema.optionalKey(DateTimeSerializableFromString),
    updatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    price: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Paymentjsonldsyliusadminpaymentshow' });
export type Paymentjsonldsyliusadminpaymentshow = Schema.Schema.Type<
  typeof Paymentjsonldsyliusadminpaymentshow
>;
export type PaymentjsonldsyliusadminpaymentshowEncoded = Schema.Codec.Encoded<
  typeof Paymentjsonldsyliusadminpaymentshow
>;

/* Paymentjsonldsyliusshoppaymentshow */

export const Paymentjsonldsyliusshoppaymentshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    order: Schema.String.annotate({ format: 'iri-reference' }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    method: Schema.optionalKey(
      Schema.Union([PaymentMethodjsonldsyliusshoppaymentshow, Schema.Null]).annotate({
        readOnly: true,
      })
    ),
    currencyCode: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    amount: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    state: Schema.optionalKey(Schema.String.annotate({ default: 'cart', readOnly: true })),
    details: Schema.optionalKey(
      Schema.Array(Schema.Union([Schema.String, Schema.Null])).annotate({ readOnly: true })
    ),
    createdAt: Schema.optionalKey(DateTimeSerializableFromString),
    updatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    price: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Paymentjsonldsyliusshoppaymentshow' });
export type Paymentjsonldsyliusshoppaymentshow = Schema.Schema.Type<
  typeof Paymentjsonldsyliusshoppaymentshow
>;
export type PaymentjsonldsyliusshoppaymentshowEncoded = Schema.Codec.Encoded<
  typeof Paymentjsonldsyliusshoppaymentshow
>;

/* Productsyliusadminproductcreate */

export const Productsyliusadminproductcreate = Schema.StructWithRest(
  Schema.Struct({
    brand: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'iri-reference' }),
    warrantyMonths: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({
      description: 'Warranty length in months (unsigned smallint, null = unspecified)',
    }),
    ean: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'EAN/GTIN barcode, max 20 chars',
    }),
    variantSelectionMethod: Schema.String.annotate({ default: 'choice' }),
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    mainTaxon: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    images: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    code: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ).check(
      Schema.isPattern(new RegExp('^([\\w/()-]*)$')).annotate({
        expected: 'a string matching the RegExp ^([\\w/()-]*)$',
      })
    ),
    attributes: Schema.Array(ProductAttributeValuesyliusadminproductcreate),
    options: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Productsyliusadminproductcreate' });
export type Productsyliusadminproductcreate = Schema.Schema.Type<
  typeof Productsyliusadminproductcreate
>;
export type ProductsyliusadminproductcreateEncoded = Schema.Codec.Encoded<
  typeof Productsyliusadminproductcreate
>;

/* Productsyliusadminproductindex */

export const Productsyliusadminproductindex = Schema.StructWithRest(
  Schema.Struct({
    brand: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'iri-reference' }),
    warrantyMonths: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({
      description: 'Warranty length in months (unsigned smallint, null = unspecified)',
    }),
    ean: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'EAN/GTIN barcode, max 20 chars',
    }),
    variantSelectionMethod: Schema.String.annotate({ default: 'choice' }),
    productTaxons: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    mainTaxon: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    reviews: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    averageRating: Schema.Number.annotate({ default: 0 }).check(
      Schema.isFinite().annotate({ expected: 'a finite number' })
    ),
    images: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    attributes: Schema.Array(ProductAttributeValuesyliusadminproductindex),
    variants: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    options: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    associations: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    createdAt: Schema.optionalKey(DateTimeSerializableFromString),
    updatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Productsyliusadminproductindex' });
export type Productsyliusadminproductindex = Schema.Schema.Type<
  typeof Productsyliusadminproductindex
>;
export type ProductsyliusadminproductindexEncoded = Schema.Codec.Encoded<
  typeof Productsyliusadminproductindex
>;

/* Productsyliusadminproductshow */

export const Productsyliusadminproductshow = Schema.StructWithRest(
  Schema.Struct({
    brand: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'iri-reference' }),
    warrantyMonths: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({
      description: 'Warranty length in months (unsigned smallint, null = unspecified)',
    }),
    ean: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'EAN/GTIN barcode, max 20 chars',
    }),
    variantSelectionMethod: Schema.String.annotate({ default: 'choice' }),
    productTaxons: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    mainTaxon: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    reviews: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    averageRating: Schema.Number.annotate({ default: 0 }).check(
      Schema.isFinite().annotate({ expected: 'a finite number' })
    ),
    images: Schema.optionalKey(
      Schema.Array(ProductImagesyliusadminproductshow).annotate({ readOnly: true })
    ),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ).check(
      Schema.isPattern(new RegExp('^([\\w/()-]*)$')).annotate({
        expected: 'a string matching the RegExp ^([\\w/()-]*)$',
      })
    ),
    attributes: Schema.Array(ProductAttributeValuesyliusadminproductshow),
    variants: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    options: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    associations: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    createdAt: Schema.optionalKey(DateTimeSerializableFromString),
    updatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Productsyliusadminproductshow' });
export type Productsyliusadminproductshow = Schema.Schema.Type<
  typeof Productsyliusadminproductshow
>;
export type ProductsyliusadminproductshowEncoded = Schema.Codec.Encoded<
  typeof Productsyliusadminproductshow
>;

/* Productsyliusadminproductupdate */

export const Productsyliusadminproductupdate = Schema.StructWithRest(
  Schema.Struct({
    brand: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'iri-reference' }),
    warrantyMonths: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({
      description: 'Warranty length in months (unsigned smallint, null = unspecified)',
    }),
    ean: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'EAN/GTIN barcode, max 20 chars',
    }),
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    mainTaxon: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    images: Schema.optionalKey(
      Schema.Array(ProductImagesyliusadminproductupdate).annotate({ readOnly: true })
    ),
    attributes: Schema.Array(ProductAttributeValuesyliusadminproductupdate),
    options: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Productsyliusadminproductupdate' });
export type Productsyliusadminproductupdate = Schema.Schema.Type<
  typeof Productsyliusadminproductupdate
>;
export type ProductsyliusadminproductupdateEncoded = Schema.Codec.Encoded<
  typeof Productsyliusadminproductupdate
>;

/* Productsyliusshopproductindexbase */

export const Productsyliusshopproductindexbase = Schema.StructWithRest(
  Schema.Struct({
    ageRestriction: Schema.Literals(['none', '18+']),
    averageRating: Schema.Number.annotate({ default: 0 }).check(
      Schema.isFinite().annotate({ expected: 'a finite number' })
    ),
    code: Schema.String,
    createdAt: Schema.optionalKey(DateTimeSerializableFromString),
    updatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    mainImage: Schema.optionalKey(
      Schema.Union([ProductImagesyliusshopproductindexbase, Schema.Null]).annotate({
        readOnly: true,
      })
    ),
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    shortDescription: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    subtitle: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Productsyliusshopproductindexbase' });
export type Productsyliusshopproductindexbase = Schema.Schema.Type<
  typeof Productsyliusshopproductindexbase
>;
export type ProductsyliusshopproductindexbaseEncoded = Schema.Codec.Encoded<
  typeof Productsyliusshopproductindexbase
>;

/* Productsyliusshopproductshow */

export const Productsyliusshopproductshow = Schema.StructWithRest(
  Schema.Struct({
    ageRestriction: Schema.Literals(['none', '18+']),
    videos: Schema.Array(ProductVideosyliusshopproductshow),
    warrantyMonths: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({
      description: 'Warranty length in months (unsigned smallint, null = unspecified)',
    }),
    ean: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'EAN/GTIN barcode, max 20 chars',
    }),
    averageRating: Schema.Number.annotate({ default: 0 }).check(
      Schema.isFinite().annotate({ expected: 'a finite number' })
    ),
    images: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    createdAt: Schema.optionalKey(DateTimeSerializableFromString),
    updatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    name: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    shortDescription: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    metaDescription: Schema.Union([Schema.String, Schema.Null]),
    metaKeywords: Schema.Union([Schema.String, Schema.Null]),
    subtitle: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Productsyliusshopproductshow' });
export type Productsyliusshopproductshow = Schema.Schema.Type<typeof Productsyliusshopproductshow>;
export type ProductsyliusshopproductshowEncoded = Schema.Codec.Encoded<
  typeof Productsyliusshopproductshow
>;

/* Productjsonldsyliusadminproductcreate */

export const Productjsonldsyliusadminproductcreate = Schema.StructWithRest(
  Schema.Struct({
    brand: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'iri-reference' }),
    warrantyMonths: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({
      description: 'Warranty length in months (unsigned smallint, null = unspecified)',
    }),
    ean: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'EAN/GTIN barcode, max 20 chars',
    }),
    variantSelectionMethod: Schema.String.annotate({ default: 'choice' }),
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    mainTaxon: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    images: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    code: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ).check(
      Schema.isPattern(new RegExp('^([\\w/()-]*)$')).annotate({
        expected: 'a string matching the RegExp ^([\\w/()-]*)$',
      })
    ),
    attributes: Schema.Array(ProductAttributeValuejsonldsyliusadminproductcreate),
    options: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Productjsonldsyliusadminproductcreate' });
export type Productjsonldsyliusadminproductcreate = Schema.Schema.Type<
  typeof Productjsonldsyliusadminproductcreate
>;
export type ProductjsonldsyliusadminproductcreateEncoded = Schema.Codec.Encoded<
  typeof Productjsonldsyliusadminproductcreate
>;

/* Productjsonldsyliusadminproductindex */

export const Productjsonldsyliusadminproductindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    brand: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'iri-reference' }),
    warrantyMonths: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({
      description: 'Warranty length in months (unsigned smallint, null = unspecified)',
    }),
    ean: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'EAN/GTIN barcode, max 20 chars',
    }),
    variantSelectionMethod: Schema.String.annotate({ default: 'choice' }),
    productTaxons: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    mainTaxon: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    reviews: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    averageRating: Schema.Number.annotate({ default: 0 }).check(
      Schema.isFinite().annotate({ expected: 'a finite number' })
    ),
    images: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    attributes: Schema.Array(ProductAttributeValuejsonldsyliusadminproductindex),
    variants: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    options: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    associations: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    createdAt: Schema.optionalKey(DateTimeSerializableFromString),
    updatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Productjsonldsyliusadminproductindex' });
export type Productjsonldsyliusadminproductindex = Schema.Schema.Type<
  typeof Productjsonldsyliusadminproductindex
>;
export type ProductjsonldsyliusadminproductindexEncoded = Schema.Codec.Encoded<
  typeof Productjsonldsyliusadminproductindex
>;

/* Productjsonldsyliusadminproductshow */

export const Productjsonldsyliusadminproductshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    brand: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'iri-reference' }),
    warrantyMonths: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({
      description: 'Warranty length in months (unsigned smallint, null = unspecified)',
    }),
    ean: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'EAN/GTIN barcode, max 20 chars',
    }),
    variantSelectionMethod: Schema.String.annotate({ default: 'choice' }),
    productTaxons: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    mainTaxon: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    reviews: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    averageRating: Schema.Number.annotate({ default: 0 }).check(
      Schema.isFinite().annotate({ expected: 'a finite number' })
    ),
    images: Schema.optionalKey(
      Schema.Array(ProductImagejsonldsyliusadminproductshow).annotate({ readOnly: true })
    ),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ).check(
      Schema.isPattern(new RegExp('^([\\w/()-]*)$')).annotate({
        expected: 'a string matching the RegExp ^([\\w/()-]*)$',
      })
    ),
    attributes: Schema.Array(ProductAttributeValuejsonldsyliusadminproductshow),
    variants: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    options: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    associations: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    createdAt: Schema.optionalKey(DateTimeSerializableFromString),
    updatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Productjsonldsyliusadminproductshow' });
export type Productjsonldsyliusadminproductshow = Schema.Schema.Type<
  typeof Productjsonldsyliusadminproductshow
>;
export type ProductjsonldsyliusadminproductshowEncoded = Schema.Codec.Encoded<
  typeof Productjsonldsyliusadminproductshow
>;

/* Productjsonldsyliusadminproductupdate */

export const Productjsonldsyliusadminproductupdate = Schema.StructWithRest(
  Schema.Struct({
    brand: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'iri-reference' }),
    warrantyMonths: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({
      description: 'Warranty length in months (unsigned smallint, null = unspecified)',
    }),
    ean: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'EAN/GTIN barcode, max 20 chars',
    }),
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    mainTaxon: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    images: Schema.optionalKey(
      Schema.Array(ProductImagejsonldsyliusadminproductupdate).annotate({ readOnly: true })
    ),
    attributes: Schema.Array(ProductAttributeValuejsonldsyliusadminproductupdate),
    options: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Productjsonldsyliusadminproductupdate' });
export type Productjsonldsyliusadminproductupdate = Schema.Schema.Type<
  typeof Productjsonldsyliusadminproductupdate
>;
export type ProductjsonldsyliusadminproductupdateEncoded = Schema.Codec.Encoded<
  typeof Productjsonldsyliusadminproductupdate
>;

/* Productjsonldsyliusshopproductindexbase */

export const Productjsonldsyliusshopproductindexbase = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    ageRestriction: Schema.Literals(['none', '18+']),
    averageRating: Schema.Number.annotate({ default: 0 }).check(
      Schema.isFinite().annotate({ expected: 'a finite number' })
    ),
    code: Schema.String,
    createdAt: Schema.optionalKey(DateTimeSerializableFromString),
    updatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    mainImage: Schema.optionalKey(
      Schema.Union([ProductImagejsonldsyliusshopproductindexbase, Schema.Null]).annotate({
        readOnly: true,
      })
    ),
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    shortDescription: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    subtitle: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Productjsonldsyliusshopproductindexbase' });
export type Productjsonldsyliusshopproductindexbase = Schema.Schema.Type<
  typeof Productjsonldsyliusshopproductindexbase
>;
export type ProductjsonldsyliusshopproductindexbaseEncoded = Schema.Codec.Encoded<
  typeof Productjsonldsyliusshopproductindexbase
>;

/* Productjsonldsyliusshopproductshow */

export const Productjsonldsyliusshopproductshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    ageRestriction: Schema.Literals(['none', '18+']),
    videos: Schema.Array(ProductVideojsonldsyliusshopproductshow),
    warrantyMonths: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({
      description: 'Warranty length in months (unsigned smallint, null = unspecified)',
    }),
    ean: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'EAN/GTIN barcode, max 20 chars',
    }),
    averageRating: Schema.Number.annotate({ default: 0 }).check(
      Schema.isFinite().annotate({ expected: 'a finite number' })
    ),
    images: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    createdAt: Schema.optionalKey(DateTimeSerializableFromString),
    updatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    name: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    shortDescription: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    metaDescription: Schema.Union([Schema.String, Schema.Null]),
    metaKeywords: Schema.Union([Schema.String, Schema.Null]),
    subtitle: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Productjsonldsyliusshopproductshow' });
export type Productjsonldsyliusshopproductshow = Schema.Schema.Type<
  typeof Productjsonldsyliusshopproductshow
>;
export type ProductjsonldsyliusshopproductshowEncoded = Schema.Codec.Encoded<
  typeof Productjsonldsyliusshopproductshow
>;

/* Productmultipart */

export const Productmultipart = Schema.StructWithRest(
  Schema.Struct({
    ageRestriction: Schema.Literals(['none', '18+']),
    feedTop: Schema.Boolean.annotate({ default: false }),
    articles: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    productDocuments: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    brand: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'iri-reference' }),
    videos: Schema.Array(ProductVideomultipart),
    sellingPriceSynchronized: Schema.Boolean.annotate({
      description:
        "Whether warehouse selling prices may overwrite the channel pricing's selling price.",
      default: true,
    }),
    stockSynchronized: Schema.Boolean.annotate({
      description: "Whether warehouse quantities may overwrite the variant's available quantity.",
      default: true,
    }),
    warrantyMonths: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({
      description: 'Warranty length in months (unsigned smallint, null = unspecified)',
    }),
    ean: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'EAN/GTIN barcode, max 20 chars',
    }),
    variantSelectionMethod: Schema.String.annotate({ default: 'choice' }),
    productTaxons: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    mainTaxon: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    reviews: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    averageRating: Schema.Number.annotate({ default: 0 }).check(
      Schema.isFinite().annotate({ expected: 'a finite number' })
    ),
    images: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ).check(
      Schema.isPattern(new RegExp('^([\\w/()-]*)$')).annotate({
        expected: 'a string matching the RegExp ^([\\w/()-]*)$',
      })
    ),
    attributes: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    variants: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    options: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    associations: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    createdAt: Schema.optionalKey(DateTimeSerializableFromString),
    updatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    currentLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    fallbackLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    mainImage: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        readOnly: true,
        format: 'iri-reference',
      })
    ),
    documents: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    publicDocuments: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    restrictedDocuments: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    notifyDocuments: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    synchronizationGap: Schema.optionalKey(
      Schema.Union([Schema.Literals(['price', 'stock', 'both']), Schema.Null]).annotate({
        description:
          'Which halves of the warehouse synchronization are switched off, `null` when neither is.',
        readOnly: true,
      })
    ),
    productTaxonsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    taxonsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    channelsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    reviewsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    acceptedReviewsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    imagesTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    imagesWithoutMainImage: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    translationTyped: Schema.optionalKey(
      Schema.String.annotate({ readOnly: true, format: 'iri-reference' })
    ),
    variantsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    enabledVariantsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    optionsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    associatedByTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    associationsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    name: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    shortDescription: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    metaDescription: Schema.Union([Schema.String, Schema.Null]),
    metaKeywords: Schema.Union([Schema.String, Schema.Null]),
    subtitle: Schema.Union([Schema.String, Schema.Null]),
    variantSelectionMethodChoice: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    variantSelectionMethodLabel: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    taxons: Collectionmultipart,
    acceptedReviews: Collectionmultipart,
    variantSelectionMethodLabels: Schema.optionalKey(
      Schema.Record(Schema.String, Schema.String).annotate({ readOnly: true })
    ),
    translation: Schema.String.annotate({ format: 'iri-reference' }),
    descriptor: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    enabledVariants: Collectionmultipart,
    simple: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    configurable: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Productmultipart' });
export type Productmultipart = Schema.Schema.Type<typeof Productmultipart>;
export type ProductmultipartEncoded = Schema.Codec.Encoded<typeof Productmultipart>;

/* ProductOptionsyliusadminproductoptioncreate */

export const ProductOptionsyliusadminproductoptioncreate = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ).check(
      Schema.isPattern(new RegExp('^([\\w-]*)$')).annotate({
        expected: 'a string matching the RegExp ^([\\w-]*)$',
      })
    ),
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    values: Schema.Array(ProductOptionValuesyliusadminproductoptioncreate),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductOptionsyliusadminproductoptioncreate' });
export type ProductOptionsyliusadminproductoptioncreate = Schema.Schema.Type<
  typeof ProductOptionsyliusadminproductoptioncreate
>;
export type ProductOptionsyliusadminproductoptioncreateEncoded = Schema.Codec.Encoded<
  typeof ProductOptionsyliusadminproductoptioncreate
>;

/* ProductOptionsyliusadminproductoptionupdate */

export const ProductOptionsyliusadminproductoptionupdate = Schema.StructWithRest(
  Schema.Struct({
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    values: Schema.Array(ProductOptionValuesyliusadminproductoptionupdate),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductOptionsyliusadminproductoptionupdate' });
export type ProductOptionsyliusadminproductoptionupdate = Schema.Schema.Type<
  typeof ProductOptionsyliusadminproductoptionupdate
>;
export type ProductOptionsyliusadminproductoptionupdateEncoded = Schema.Codec.Encoded<
  typeof ProductOptionsyliusadminproductoptionupdate
>;

/* ProductOptionjsonldsyliusadminproductoptioncreate */

export const ProductOptionjsonldsyliusadminproductoptioncreate = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ).check(
      Schema.isPattern(new RegExp('^([\\w-]*)$')).annotate({
        expected: 'a string matching the RegExp ^([\\w-]*)$',
      })
    ),
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    values: Schema.Array(ProductOptionValuejsonldsyliusadminproductoptioncreate),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductOptionjsonldsyliusadminproductoptioncreate' });
export type ProductOptionjsonldsyliusadminproductoptioncreate = Schema.Schema.Type<
  typeof ProductOptionjsonldsyliusadminproductoptioncreate
>;
export type ProductOptionjsonldsyliusadminproductoptioncreateEncoded = Schema.Codec.Encoded<
  typeof ProductOptionjsonldsyliusadminproductoptioncreate
>;

/* ProductOptionjsonldsyliusadminproductoptionupdate */

export const ProductOptionjsonldsyliusadminproductoptionupdate = Schema.StructWithRest(
  Schema.Struct({
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    values: Schema.Array(ProductOptionValuejsonldsyliusadminproductoptionupdate),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductOptionjsonldsyliusadminproductoptionupdate' });
export type ProductOptionjsonldsyliusadminproductoptionupdate = Schema.Schema.Type<
  typeof ProductOptionjsonldsyliusadminproductoptionupdate
>;
export type ProductOptionjsonldsyliusadminproductoptionupdateEncoded = Schema.Codec.Encoded<
  typeof ProductOptionjsonldsyliusadminproductoptionupdate
>;

/* Promotionsyliusadminpromotioncreate */

export const Promotionsyliusadminpromotioncreate = Schema.StructWithRest(
  Schema.Struct({
    couponBased: Schema.Boolean.annotate({ default: true }),
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    code: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ).check(
      Schema.isPattern(new RegExp('^([\\w-]*)$')).annotate({
        expected: 'a string matching the RegExp ^([\\w-]*)$',
      })
    ),
    name: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    description: Schema.Union([
      Schema.String.check(
        Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
      ).check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    priority: Schema.Number.annotate({
      description: 'When exclusive, promotion with top priority will be applied',
      default: 0,
    }).check(Schema.isInt().annotate({ expected: 'an integer' })),
    exclusive: Schema.Boolean.annotate({
      description: 'Cannot be applied together with other promotions',
      default: false,
    }),
    usageLimit: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    startsAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    endsAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    rules: Schema.Array(PromotionRulesyliusadminpromotioncreate),
    actions: Schema.Array(PromotionActionsyliusadminpromotioncreate),
    appliesToDiscounted: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Promotionsyliusadminpromotioncreate' });
export type Promotionsyliusadminpromotioncreate = Schema.Schema.Type<
  typeof Promotionsyliusadminpromotioncreate
>;
export type PromotionsyliusadminpromotioncreateEncoded = Schema.Codec.Encoded<
  typeof Promotionsyliusadminpromotioncreate
>;

/* Promotionsyliusadminpromotionindex */

export const Promotionsyliusadminpromotionindex = Schema.StructWithRest(
  Schema.Struct({
    couponBased: Schema.Boolean.annotate({ default: true }),
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.String,
    description: Schema.Union([Schema.String, Schema.Null]),
    priority: Schema.Number.annotate({
      description: 'When exclusive, promotion with top priority will be applied',
      default: 0,
    }).check(Schema.isInt().annotate({ expected: 'an integer' })),
    exclusive: Schema.Boolean.annotate({
      description: 'Cannot be applied together with other promotions',
      default: false,
    }),
    usageLimit: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    used: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    startsAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    endsAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    coupons: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    rules: Schema.Array(PromotionRulesyliusadminpromotionindex),
    actions: Schema.Array(PromotionActionsyliusadminpromotionindex),
    appliesToDiscounted: Schema.Boolean.annotate({ default: true }),
    archivedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Promotionsyliusadminpromotionindex' });
export type Promotionsyliusadminpromotionindex = Schema.Schema.Type<
  typeof Promotionsyliusadminpromotionindex
>;
export type PromotionsyliusadminpromotionindexEncoded = Schema.Codec.Encoded<
  typeof Promotionsyliusadminpromotionindex
>;

/* Promotionsyliusadminpromotionshow */

export const Promotionsyliusadminpromotionshow = Schema.StructWithRest(
  Schema.Struct({
    couponBased: Schema.Boolean.annotate({ default: true }),
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.String,
    description: Schema.Union([Schema.String, Schema.Null]),
    priority: Schema.Number.annotate({
      description: 'When exclusive, promotion with top priority will be applied',
      default: 0,
    }).check(Schema.isInt().annotate({ expected: 'an integer' })),
    exclusive: Schema.Boolean.annotate({
      description: 'Cannot be applied together with other promotions',
      default: false,
    }),
    usageLimit: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    used: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    startsAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    endsAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    coupons: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    rules: Schema.Array(PromotionRulesyliusadminpromotionshow),
    actions: Schema.Array(PromotionActionsyliusadminpromotionshow),
    appliesToDiscounted: Schema.Boolean.annotate({ default: true }),
    archivedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Promotionsyliusadminpromotionshow' });
export type Promotionsyliusadminpromotionshow = Schema.Schema.Type<
  typeof Promotionsyliusadminpromotionshow
>;
export type PromotionsyliusadminpromotionshowEncoded = Schema.Codec.Encoded<
  typeof Promotionsyliusadminpromotionshow
>;

/* Promotionsyliusadminpromotionupdate */

export const Promotionsyliusadminpromotionupdate = Schema.StructWithRest(
  Schema.Struct({
    couponBased: Schema.Boolean.annotate({ default: true }),
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    name: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    description: Schema.Union([
      Schema.String.check(
        Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
      ).check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    priority: Schema.Number.annotate({
      description: 'When exclusive, promotion with top priority will be applied',
      default: 0,
    }).check(Schema.isInt().annotate({ expected: 'an integer' })),
    exclusive: Schema.Boolean.annotate({
      description: 'Cannot be applied together with other promotions',
      default: false,
    }),
    usageLimit: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    startsAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    endsAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    rules: Schema.Array(PromotionRulesyliusadminpromotionupdate),
    actions: Schema.Array(PromotionActionsyliusadminpromotionupdate),
    appliesToDiscounted: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Promotionsyliusadminpromotionupdate' });
export type Promotionsyliusadminpromotionupdate = Schema.Schema.Type<
  typeof Promotionsyliusadminpromotionupdate
>;
export type PromotionsyliusadminpromotionupdateEncoded = Schema.Codec.Encoded<
  typeof Promotionsyliusadminpromotionupdate
>;

/* Promotionjsonldsyliusadminpromotioncreate */

export const Promotionjsonldsyliusadminpromotioncreate = Schema.StructWithRest(
  Schema.Struct({
    couponBased: Schema.Boolean.annotate({ default: true }),
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    code: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ).check(
      Schema.isPattern(new RegExp('^([\\w-]*)$')).annotate({
        expected: 'a string matching the RegExp ^([\\w-]*)$',
      })
    ),
    name: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    description: Schema.Union([
      Schema.String.check(
        Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
      ).check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    priority: Schema.Number.annotate({
      description: 'When exclusive, promotion with top priority will be applied',
      default: 0,
    }).check(Schema.isInt().annotate({ expected: 'an integer' })),
    exclusive: Schema.Boolean.annotate({
      description: 'Cannot be applied together with other promotions',
      default: false,
    }),
    usageLimit: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    startsAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    endsAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    rules: Schema.Array(PromotionRulejsonldsyliusadminpromotioncreate),
    actions: Schema.Array(PromotionActionjsonldsyliusadminpromotioncreate),
    appliesToDiscounted: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Promotionjsonldsyliusadminpromotioncreate' });
export type Promotionjsonldsyliusadminpromotioncreate = Schema.Schema.Type<
  typeof Promotionjsonldsyliusadminpromotioncreate
>;
export type PromotionjsonldsyliusadminpromotioncreateEncoded = Schema.Codec.Encoded<
  typeof Promotionjsonldsyliusadminpromotioncreate
>;

/* Promotionjsonldsyliusadminpromotionindex */

export const Promotionjsonldsyliusadminpromotionindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    couponBased: Schema.Boolean.annotate({ default: true }),
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.String,
    description: Schema.Union([Schema.String, Schema.Null]),
    priority: Schema.Number.annotate({
      description: 'When exclusive, promotion with top priority will be applied',
      default: 0,
    }).check(Schema.isInt().annotate({ expected: 'an integer' })),
    exclusive: Schema.Boolean.annotate({
      description: 'Cannot be applied together with other promotions',
      default: false,
    }),
    usageLimit: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    used: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    startsAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    endsAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    coupons: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    rules: Schema.Array(PromotionRulejsonldsyliusadminpromotionindex),
    actions: Schema.Array(PromotionActionjsonldsyliusadminpromotionindex),
    appliesToDiscounted: Schema.Boolean.annotate({ default: true }),
    archivedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Promotionjsonldsyliusadminpromotionindex' });
export type Promotionjsonldsyliusadminpromotionindex = Schema.Schema.Type<
  typeof Promotionjsonldsyliusadminpromotionindex
>;
export type PromotionjsonldsyliusadminpromotionindexEncoded = Schema.Codec.Encoded<
  typeof Promotionjsonldsyliusadminpromotionindex
>;

/* Promotionjsonldsyliusadminpromotionshow */

export const Promotionjsonldsyliusadminpromotionshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    couponBased: Schema.Boolean.annotate({ default: true }),
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.String,
    description: Schema.Union([Schema.String, Schema.Null]),
    priority: Schema.Number.annotate({
      description: 'When exclusive, promotion with top priority will be applied',
      default: 0,
    }).check(Schema.isInt().annotate({ expected: 'an integer' })),
    exclusive: Schema.Boolean.annotate({
      description: 'Cannot be applied together with other promotions',
      default: false,
    }),
    usageLimit: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    used: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    startsAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    endsAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    coupons: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    rules: Schema.Array(PromotionRulejsonldsyliusadminpromotionshow),
    actions: Schema.Array(PromotionActionjsonldsyliusadminpromotionshow),
    appliesToDiscounted: Schema.Boolean.annotate({ default: true }),
    archivedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Promotionjsonldsyliusadminpromotionshow' });
export type Promotionjsonldsyliusadminpromotionshow = Schema.Schema.Type<
  typeof Promotionjsonldsyliusadminpromotionshow
>;
export type PromotionjsonldsyliusadminpromotionshowEncoded = Schema.Codec.Encoded<
  typeof Promotionjsonldsyliusadminpromotionshow
>;

/* Promotionjsonldsyliusadminpromotionupdate */

export const Promotionjsonldsyliusadminpromotionupdate = Schema.StructWithRest(
  Schema.Struct({
    couponBased: Schema.Boolean.annotate({ default: true }),
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    name: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    description: Schema.Union([
      Schema.String.check(
        Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
      ).check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    priority: Schema.Number.annotate({
      description: 'When exclusive, promotion with top priority will be applied',
      default: 0,
    }).check(Schema.isInt().annotate({ expected: 'an integer' })),
    exclusive: Schema.Boolean.annotate({
      description: 'Cannot be applied together with other promotions',
      default: false,
    }),
    usageLimit: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    startsAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    endsAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    rules: Schema.Array(PromotionRulejsonldsyliusadminpromotionupdate),
    actions: Schema.Array(PromotionActionjsonldsyliusadminpromotionupdate),
    appliesToDiscounted: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Promotionjsonldsyliusadminpromotionupdate' });
export type Promotionjsonldsyliusadminpromotionupdate = Schema.Schema.Type<
  typeof Promotionjsonldsyliusadminpromotionupdate
>;
export type PromotionjsonldsyliusadminpromotionupdateEncoded = Schema.Codec.Encoded<
  typeof Promotionjsonldsyliusadminpromotionupdate
>;

/* SearchAttributeFacet */

export const SearchAttributeFacet = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.annotate({
      description: 'Attribute code — the `<code>` of the `attribute_<code>` filter.',
    }),
    name: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'Attribute name in the request locale.',
    }),
    type: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'Sylius attribute type: select, text, integer, float, checkbox, …',
    }),
    unit: Schema.Union([Schema.String, Schema.Null]).annotate({
      description:
        'Unit symbol shown next to the values ("mm", "kg"); null when the attribute has none.',
    }),
    values: Schema.Array(SearchAttributeFacetValue),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'SearchAttributeFacet' });
export type SearchAttributeFacet = Schema.Schema.Type<typeof SearchAttributeFacet>;
export type SearchAttributeFacetEncoded = Schema.Codec.Encoded<typeof SearchAttributeFacet>;

/* ShippingMethodshopshippingAndPaymentOptionsindex */

export const ShippingMethodshopshippingAndPaymentOptionsindex = Schema.StructWithRest(
  Schema.Struct({
    deliveryDays: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })).check(
      Schema.isGreaterThanOrEqualTo(0).annotate({ expected: 'a value greater than or equal to 0' })
    ),
    image: Schema.Union([ShippingMethodImageshopshippingAndPaymentOptionsindex, Schema.Null]),
    code: Schema.String,
    predefinedPlacementId: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    name: Schema.Union([Schema.String, Schema.Null]),
    placement: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingMethodshopshippingAndPaymentOptionsindex' });
export type ShippingMethodshopshippingAndPaymentOptionsindex = Schema.Schema.Type<
  typeof ShippingMethodshopshippingAndPaymentOptionsindex
>;
export type ShippingMethodshopshippingAndPaymentOptionsindexEncoded = Schema.Codec.Encoded<
  typeof ShippingMethodshopshippingAndPaymentOptionsindex
>;

/* ShippingMethodsyliusadminshippingmethodcreate */

export const ShippingMethodsyliusadminshippingmethodcreate = Schema.StructWithRest(
  Schema.Struct({
    zone: Schema.String.annotate({ format: 'iri-reference' }),
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    code: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    shippingChargesCalculator: Schema.String,
    shippingChargesCalculatorConfiguration: Schema.Array(
      Schema.Union([Schema.String, Schema.Null])
    ),
    rules: Schema.Array(ShippingMethodRulesyliusadminshippingmethodcreate),
    minDeliveryTimeDays: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    maxDeliveryTimeDays: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingMethodsyliusadminshippingmethodcreate' });
export type ShippingMethodsyliusadminshippingmethodcreate = Schema.Schema.Type<
  typeof ShippingMethodsyliusadminshippingmethodcreate
>;
export type ShippingMethodsyliusadminshippingmethodcreateEncoded = Schema.Codec.Encoded<
  typeof ShippingMethodsyliusadminshippingmethodcreate
>;

/* ShippingMethodsyliusadminshippingmethodindex */

export const ShippingMethodsyliusadminshippingmethodindex = Schema.StructWithRest(
  Schema.Struct({
    zone: Schema.String.annotate({ format: 'iri-reference' }),
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    shippingChargesCalculator: Schema.String,
    shippingChargesCalculatorConfiguration: Schema.Array(
      Schema.Union([Schema.String, Schema.Null])
    ),
    rules: Schema.Array(ShippingMethodRulesyliusadminshippingmethodindex),
    minDeliveryTimeDays: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    maxDeliveryTimeDays: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    archivedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingMethodsyliusadminshippingmethodindex' });
export type ShippingMethodsyliusadminshippingmethodindex = Schema.Schema.Type<
  typeof ShippingMethodsyliusadminshippingmethodindex
>;
export type ShippingMethodsyliusadminshippingmethodindexEncoded = Schema.Codec.Encoded<
  typeof ShippingMethodsyliusadminshippingmethodindex
>;

/* ShippingMethodsyliusadminshippingmethodshow */

export const ShippingMethodsyliusadminshippingmethodshow = Schema.StructWithRest(
  Schema.Struct({
    zone: Schema.String.annotate({ format: 'iri-reference' }),
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    shippingChargesCalculator: Schema.String,
    shippingChargesCalculatorConfiguration: Schema.Array(
      Schema.Union([Schema.String, Schema.Null])
    ),
    rules: Schema.Array(ShippingMethodRulesyliusadminshippingmethodshow),
    minDeliveryTimeDays: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    maxDeliveryTimeDays: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    archivedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingMethodsyliusadminshippingmethodshow' });
export type ShippingMethodsyliusadminshippingmethodshow = Schema.Schema.Type<
  typeof ShippingMethodsyliusadminshippingmethodshow
>;
export type ShippingMethodsyliusadminshippingmethodshowEncoded = Schema.Codec.Encoded<
  typeof ShippingMethodsyliusadminshippingmethodshow
>;

/* ShippingMethodsyliusadminshippingmethodupdate */

export const ShippingMethodsyliusadminshippingmethodupdate = Schema.StructWithRest(
  Schema.Struct({
    zone: Schema.String.annotate({ format: 'iri-reference' }),
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    shippingChargesCalculator: Schema.String,
    shippingChargesCalculatorConfiguration: Schema.Array(
      Schema.Union([Schema.String, Schema.Null])
    ),
    rules: Schema.Array(ShippingMethodRulesyliusadminshippingmethodupdate),
    minDeliveryTimeDays: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    maxDeliveryTimeDays: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingMethodsyliusadminshippingmethodupdate' });
export type ShippingMethodsyliusadminshippingmethodupdate = Schema.Schema.Type<
  typeof ShippingMethodsyliusadminshippingmethodupdate
>;
export type ShippingMethodsyliusadminshippingmethodupdateEncoded = Schema.Codec.Encoded<
  typeof ShippingMethodsyliusadminshippingmethodupdate
>;

/* ShippingMethodjsonldshopshippingAndPaymentOptionsindex */

export const ShippingMethodjsonldshopshippingAndPaymentOptionsindex = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    deliveryDays: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })).check(
      Schema.isGreaterThanOrEqualTo(0).annotate({ expected: 'a value greater than or equal to 0' })
    ),
    image: Schema.Union([ShippingMethodImagejsonldshopshippingAndPaymentOptionsindex, Schema.Null]),
    code: Schema.String,
    predefinedPlacementId: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    name: Schema.Union([Schema.String, Schema.Null]),
    placement: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingMethodjsonldshopshippingAndPaymentOptionsindex' });
export type ShippingMethodjsonldshopshippingAndPaymentOptionsindex = Schema.Schema.Type<
  typeof ShippingMethodjsonldshopshippingAndPaymentOptionsindex
>;
export type ShippingMethodjsonldshopshippingAndPaymentOptionsindexEncoded = Schema.Codec.Encoded<
  typeof ShippingMethodjsonldshopshippingAndPaymentOptionsindex
>;

/* ShippingMethodjsonldsyliusadminshippingmethodcreate */

export const ShippingMethodjsonldsyliusadminshippingmethodcreate = Schema.StructWithRest(
  Schema.Struct({
    zone: Schema.String.annotate({ format: 'iri-reference' }),
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    code: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    shippingChargesCalculator: Schema.String,
    shippingChargesCalculatorConfiguration: Schema.Array(
      Schema.Union([Schema.String, Schema.Null])
    ),
    rules: Schema.Array(ShippingMethodRulejsonldsyliusadminshippingmethodcreate),
    minDeliveryTimeDays: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    maxDeliveryTimeDays: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingMethodjsonldsyliusadminshippingmethodcreate' });
export type ShippingMethodjsonldsyliusadminshippingmethodcreate = Schema.Schema.Type<
  typeof ShippingMethodjsonldsyliusadminshippingmethodcreate
>;
export type ShippingMethodjsonldsyliusadminshippingmethodcreateEncoded = Schema.Codec.Encoded<
  typeof ShippingMethodjsonldsyliusadminshippingmethodcreate
>;

/* ShippingMethodjsonldsyliusadminshippingmethodindex */

export const ShippingMethodjsonldsyliusadminshippingmethodindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    zone: Schema.String.annotate({ format: 'iri-reference' }),
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    shippingChargesCalculator: Schema.String,
    shippingChargesCalculatorConfiguration: Schema.Array(
      Schema.Union([Schema.String, Schema.Null])
    ),
    rules: Schema.Array(ShippingMethodRulejsonldsyliusadminshippingmethodindex),
    minDeliveryTimeDays: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    maxDeliveryTimeDays: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    archivedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingMethodjsonldsyliusadminshippingmethodindex' });
export type ShippingMethodjsonldsyliusadminshippingmethodindex = Schema.Schema.Type<
  typeof ShippingMethodjsonldsyliusadminshippingmethodindex
>;
export type ShippingMethodjsonldsyliusadminshippingmethodindexEncoded = Schema.Codec.Encoded<
  typeof ShippingMethodjsonldsyliusadminshippingmethodindex
>;

/* ShippingMethodjsonldsyliusadminshippingmethodshow */

export const ShippingMethodjsonldsyliusadminshippingmethodshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    zone: Schema.String.annotate({ format: 'iri-reference' }),
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    shippingChargesCalculator: Schema.String,
    shippingChargesCalculatorConfiguration: Schema.Array(
      Schema.Union([Schema.String, Schema.Null])
    ),
    rules: Schema.Array(ShippingMethodRulejsonldsyliusadminshippingmethodshow),
    minDeliveryTimeDays: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    maxDeliveryTimeDays: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    archivedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingMethodjsonldsyliusadminshippingmethodshow' });
export type ShippingMethodjsonldsyliusadminshippingmethodshow = Schema.Schema.Type<
  typeof ShippingMethodjsonldsyliusadminshippingmethodshow
>;
export type ShippingMethodjsonldsyliusadminshippingmethodshowEncoded = Schema.Codec.Encoded<
  typeof ShippingMethodjsonldsyliusadminshippingmethodshow
>;

/* ShippingMethodjsonldsyliusadminshippingmethodupdate */

export const ShippingMethodjsonldsyliusadminshippingmethodupdate = Schema.StructWithRest(
  Schema.Struct({
    zone: Schema.String.annotate({ format: 'iri-reference' }),
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    shippingChargesCalculator: Schema.String,
    shippingChargesCalculatorConfiguration: Schema.Array(
      Schema.Union([Schema.String, Schema.Null])
    ),
    rules: Schema.Array(ShippingMethodRulejsonldsyliusadminshippingmethodupdate),
    minDeliveryTimeDays: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    maxDeliveryTimeDays: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingMethodjsonldsyliusadminshippingmethodupdate' });
export type ShippingMethodjsonldsyliusadminshippingmethodupdate = Schema.Schema.Type<
  typeof ShippingMethodjsonldsyliusadminshippingmethodupdate
>;
export type ShippingMethodjsonldsyliusadminshippingmethodupdateEncoded = Schema.Codec.Encoded<
  typeof ShippingMethodjsonldsyliusadminshippingmethodupdate
>;

/* PaymentOptionsyliusshopshippingandpaymentoptionsindex */

export const PaymentOptionsyliusshopshippingandpaymentoptionsindex = Schema.Struct({
  paymentMethod: Schema.optionalKey(PaymentMethodsyliusshopshippingandpaymentoptionsindex),
  priceExVat: Schema.optionalKey(
    Schema.Number.annotate({ format: 'int64' }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    )
  ),
  priceIncVat: Schema.optionalKey(
    Schema.Number.annotate({ format: 'int64' }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    )
  ),
  priceVat: Schema.optionalKey(
    Schema.Number.annotate({ format: 'int64' }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    )
  ),
  currency: Schema.optionalKey(Currencysyliusshopshippingandpaymentoptionsindex),
}).annotate({ identifier: 'PaymentOptionsyliusshopshippingandpaymentoptionsindex' });
export type PaymentOptionsyliusshopshippingandpaymentoptionsindex = Schema.Schema.Type<
  typeof PaymentOptionsyliusshopshippingandpaymentoptionsindex
>;
export type PaymentOptionsyliusshopshippingandpaymentoptionsindexEncoded = Schema.Codec.Encoded<
  typeof PaymentOptionsyliusshopshippingandpaymentoptionsindex
>;

/* SuggestResult */

export const SuggestResult = Schema.StructWithRest(
  Schema.Struct({
    products: Schema.Array(SuggestHit),
    brands: Schema.Array(SuggestHit),
    taxons: Schema.Array(SuggestHit),
    articles: Schema.Array(SuggestHit),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({
  description:
    'Multi-entity suggest payload. Each group holds the top hits for one entity type.\n\nThe properties are typed `list<SuggestHit>` so API-Platform introspects them and\nGENERATES the `SuggestHit` component schema + typed arrays in OpenAPI — no manual\nschema decorator. A group stays empty when its query matches nothing or fails.',
  identifier: 'SuggestResult',
});
export type SuggestResult = Schema.Schema.Type<typeof SuggestResult>;
export type SuggestResultEncoded = Schema.Codec.Encoded<typeof SuggestResult>;

/* SuggestResultjsonld */

export const SuggestResultjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    products: Schema.Array(SuggestHitjsonld),
    brands: Schema.Array(SuggestHitjsonld),
    taxons: Schema.Array(SuggestHitjsonld),
    articles: Schema.Array(SuggestHitjsonld),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({
  description:
    'Multi-entity suggest payload. Each group holds the top hits for one entity type.\n\nThe properties are typed `list<SuggestHit>` so API-Platform introspects them and\nGENERATES the `SuggestHit` component schema + typed arrays in OpenAPI — no manual\nschema decorator. A group stays empty when its query matches nothing or fails.',
  identifier: 'SuggestResultjsonld',
});
export type SuggestResultjsonld = Schema.Schema.Type<typeof SuggestResultjsonld>;
export type SuggestResultjsonldEncoded = Schema.Codec.Encoded<typeof SuggestResultjsonld>;

/* Zonesyliusadminzonecreate */

export const Zonesyliusadminzonecreate = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ).check(
      Schema.isPattern(new RegExp('^([\\w-]*)$')).annotate({
        expected: 'a string matching the RegExp ^([\\w-]*)$',
      })
    ),
    name: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    type: Schema.String,
    scope: Schema.String.annotate({ default: 'all' }),
    members: Schema.Array(ZoneMembersyliusadminzonecreatenoid),
    priority: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Zonesyliusadminzonecreate' });
export type Zonesyliusadminzonecreate = Schema.Schema.Type<typeof Zonesyliusadminzonecreate>;
export type ZonesyliusadminzonecreateEncoded = Schema.Codec.Encoded<
  typeof Zonesyliusadminzonecreate
>;

/* Zonesyliusadminzoneindex */

export const Zonesyliusadminzoneindex = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.String,
    type: Schema.String,
    scope: Schema.String.annotate({ default: 'all' }),
    members: Schema.Array(ZoneMembersyliusadminzoneindexnoid),
    priority: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Zonesyliusadminzoneindex' });
export type Zonesyliusadminzoneindex = Schema.Schema.Type<typeof Zonesyliusadminzoneindex>;
export type ZonesyliusadminzoneindexEncoded = Schema.Codec.Encoded<typeof Zonesyliusadminzoneindex>;

/* Zonesyliusadminzoneshow */

export const Zonesyliusadminzoneshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.String,
    type: Schema.String,
    scope: Schema.String.annotate({ default: 'all' }),
    members: Schema.Array(ZoneMembersyliusadminzoneshownoid),
    priority: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Zonesyliusadminzoneshow' });
export type Zonesyliusadminzoneshow = Schema.Schema.Type<typeof Zonesyliusadminzoneshow>;
export type ZonesyliusadminzoneshowEncoded = Schema.Codec.Encoded<typeof Zonesyliusadminzoneshow>;

/* Zonesyliusadminzoneupdate */

export const Zonesyliusadminzoneupdate = Schema.StructWithRest(
  Schema.Struct({
    name: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    members: Schema.Array(ZoneMembersyliusadminzoneupdatenoid),
    priority: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Zonesyliusadminzoneupdate' });
export type Zonesyliusadminzoneupdate = Schema.Schema.Type<typeof Zonesyliusadminzoneupdate>;
export type ZonesyliusadminzoneupdateEncoded = Schema.Codec.Encoded<
  typeof Zonesyliusadminzoneupdate
>;

/* Zonejsonldsyliusadminzonecreate */

export const Zonejsonldsyliusadminzonecreate = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ).check(
      Schema.isPattern(new RegExp('^([\\w-]*)$')).annotate({
        expected: 'a string matching the RegExp ^([\\w-]*)$',
      })
    ),
    name: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    type: Schema.String,
    scope: Schema.String.annotate({ default: 'all' }),
    members: Schema.Array(ZoneMemberjsonldsyliusadminzonecreatenoid),
    priority: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Zonejsonldsyliusadminzonecreate' });
export type Zonejsonldsyliusadminzonecreate = Schema.Schema.Type<
  typeof Zonejsonldsyliusadminzonecreate
>;
export type ZonejsonldsyliusadminzonecreateEncoded = Schema.Codec.Encoded<
  typeof Zonejsonldsyliusadminzonecreate
>;

/* Zonejsonldsyliusadminzoneindex */

export const Zonejsonldsyliusadminzoneindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.String,
    type: Schema.String,
    scope: Schema.String.annotate({ default: 'all' }),
    members: Schema.Array(ZoneMemberjsonldsyliusadminzoneindexnoid),
    priority: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Zonejsonldsyliusadminzoneindex' });
export type Zonejsonldsyliusadminzoneindex = Schema.Schema.Type<
  typeof Zonejsonldsyliusadminzoneindex
>;
export type ZonejsonldsyliusadminzoneindexEncoded = Schema.Codec.Encoded<
  typeof Zonejsonldsyliusadminzoneindex
>;

/* Zonejsonldsyliusadminzoneshow */

export const Zonejsonldsyliusadminzoneshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.String,
    type: Schema.String,
    scope: Schema.String.annotate({ default: 'all' }),
    members: Schema.Array(ZoneMemberjsonldsyliusadminzoneshownoid),
    priority: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Zonejsonldsyliusadminzoneshow' });
export type Zonejsonldsyliusadminzoneshow = Schema.Schema.Type<
  typeof Zonejsonldsyliusadminzoneshow
>;
export type ZonejsonldsyliusadminzoneshowEncoded = Schema.Codec.Encoded<
  typeof Zonejsonldsyliusadminzoneshow
>;

/* Zonejsonldsyliusadminzoneupdate */

export const Zonejsonldsyliusadminzoneupdate = Schema.StructWithRest(
  Schema.Struct({
    name: Schema.String.check(
      Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
    ).check(Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })),
    members: Schema.Array(ZoneMemberjsonldsyliusadminzoneupdatenoid),
    priority: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Zonejsonldsyliusadminzoneupdate' });
export type Zonejsonldsyliusadminzoneupdate = Schema.Schema.Type<
  typeof Zonejsonldsyliusadminzoneupdate
>;
export type ZonejsonldsyliusadminzoneupdateEncoded = Schema.Codec.Encoded<
  typeof Zonejsonldsyliusadminzoneupdate
>;

/* ExchangeRate */

export const ExchangeRate = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    ratio: Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
    sourceCurrency: Currency,
    targetCurrency: Currency,
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ExchangeRate' });
export type ExchangeRate = Schema.Schema.Type<typeof ExchangeRate>;
export type ExchangeRateEncoded = Schema.Codec.Encoded<typeof ExchangeRate>;

/* ExchangeRatejsonld */

export const ExchangeRatejsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    ratio: Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
    sourceCurrency: Currencyjsonld,
    targetCurrency: Currencyjsonld,
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ExchangeRatejsonld' });
export type ExchangeRatejsonld = Schema.Schema.Type<typeof ExchangeRatejsonld>;
export type ExchangeRatejsonldEncoded = Schema.Codec.Encoded<typeof ExchangeRatejsonld>;

/* ProductVariantsyliusshopproductindex */

export const ProductVariantsyliusshopproductindex = Schema.StructWithRest(
  Schema.Struct({
    couponCodes: Schema.Array(ApplicablePromotionCodesyliusshopproductindex),
    labels: Schema.Array(Labelsyliusshopproductindex),
    code: Schema.String,
    enabled: Schema.Boolean.annotate({ default: true }),
    available: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    maxOrderable: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    inStock: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    dispatchDate: Schema.optionalKey(Schema.Union([DateSerializableFromString, Schema.Null])),
    stockStatus: Schema.optionalKey(
      Schema.Literals(['inStock', 'soldOut', 'preorder', 'supplierStock']).annotate({
        readOnly: true,
      })
    ),
    localWarehouse: Schema.optionalKey(
      Schema.Array(
        Schema.StructWithRest(
          Schema.Struct({
            type: Schema.Union([Schema.Literals(['CRU', 'PCE']), Schema.Null]).annotate({
              description: 'Kód pobočky/skladu (store code), např. PCE, CRU.',
            }),
            quantity: Schema.Union([
              Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
              Schema.Null,
            ]).annotate({
              description: 'Dostupné množství položky ve skladu, null pro neomezený počet.',
            }),
            dispatchDate: Schema.optionalKey(
              Schema.Union([DateSerializableFromString, Schema.Null])
            ),
          }),
          [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
        )
      ).annotate({ readOnly: true })
    ),
    isFavourite: Schema.optionalKey(
      Schema.Boolean.annotate({
        description:
          'True if ShopUser is logged in and has ProductVariant in at least one favourite list.',
        readOnly: true,
      })
    ),
    price: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    priceWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    originalPrice: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    lowestPriceBeforeDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ default: null, readOnly: true })
    ),
    productQuantity: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductVariantsyliusshopproductindex' });
export type ProductVariantsyliusshopproductindex = Schema.Schema.Type<
  typeof ProductVariantsyliusshopproductindex
>;
export type ProductVariantsyliusshopproductindexEncoded = Schema.Codec.Encoded<
  typeof ProductVariantsyliusshopproductindex
>;

/* ProductVariantsyliusshopproductvariantindex */

export const ProductVariantsyliusshopproductvariantindex = Schema.StructWithRest(
  Schema.Struct({
    couponCodes: Schema.Array(ApplicablePromotionCodesyliusshopproductvariantindex),
    labels: Schema.Array(Labelsyliusshopproductvariantindex),
    tracked: Schema.Boolean.annotate({ default: false }),
    code: Schema.String,
    product: Schema.String.annotate({ format: 'iri-reference' }),
    optionValues: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    enabled: Schema.Boolean.annotate({ default: true }),
    available: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    maxOrderable: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    inStock: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    name: Schema.Union([Schema.String, Schema.Null]),
    dispatchDate: Schema.optionalKey(Schema.Union([DateSerializableFromString, Schema.Null])),
    stockStatus: Schema.optionalKey(
      Schema.Literals(['inStock', 'soldOut', 'preorder', 'supplierStock']).annotate({
        readOnly: true,
      })
    ),
    localWarehouse: Schema.optionalKey(
      Schema.Array(
        Schema.StructWithRest(
          Schema.Struct({
            type: Schema.Union([Schema.Literals(['CRU', 'PCE']), Schema.Null]).annotate({
              description: 'Kód pobočky/skladu (store code), např. PCE, CRU.',
            }),
            quantity: Schema.Union([
              Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
              Schema.Null,
            ]).annotate({
              description: 'Dostupné množství položky ve skladu, null pro neomezený počet.',
            }),
            dispatchDate: Schema.optionalKey(
              Schema.Union([DateSerializableFromString, Schema.Null])
            ),
          }),
          [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
        )
      ).annotate({ readOnly: true })
    ),
    isFavourite: Schema.optionalKey(
      Schema.Boolean.annotate({
        description:
          'True if ShopUser is logged in and has ProductVariant in at least one favourite list.',
        readOnly: true,
      })
    ),
    price: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    originalPrice: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    lowestPriceBeforeDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ default: null, readOnly: true })
    ),
    appliedPromotions: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    priceWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    productQuantity: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductVariantsyliusshopproductvariantindex' });
export type ProductVariantsyliusshopproductvariantindex = Schema.Schema.Type<
  typeof ProductVariantsyliusshopproductvariantindex
>;
export type ProductVariantsyliusshopproductvariantindexEncoded = Schema.Codec.Encoded<
  typeof ProductVariantsyliusshopproductvariantindex
>;

/* ProductVariantsyliusshopproductvariantshow */

export const ProductVariantsyliusshopproductvariantshow = Schema.StructWithRest(
  Schema.Struct({
    couponCodes: Schema.Array(ApplicablePromotionCodesyliusshopproductvariantshow),
    labels: Schema.Array(Labelsyliusshopproductvariantshow),
    code: Schema.String,
    product: Schema.String.annotate({ format: 'iri-reference' }),
    optionValues: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    available: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    maxOrderable: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    name: Schema.Union([Schema.String, Schema.Null]),
    dispatchDate: Schema.optionalKey(Schema.Union([DateSerializableFromString, Schema.Null])),
    stockStatus: Schema.optionalKey(
      Schema.Literals(['inStock', 'soldOut', 'preorder', 'supplierStock']).annotate({
        readOnly: true,
      })
    ),
    localWarehouse: Schema.optionalKey(
      Schema.Array(
        Schema.StructWithRest(
          Schema.Struct({
            type: Schema.Union([Schema.Literals(['CRU', 'PCE']), Schema.Null]).annotate({
              description: 'Kód pobočky/skladu (store code), např. PCE, CRU.',
            }),
            quantity: Schema.Union([
              Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
              Schema.Null,
            ]).annotate({
              description: 'Dostupné množství položky ve skladu, null pro neomezený počet.',
            }),
            dispatchDate: Schema.optionalKey(
              Schema.Union([DateSerializableFromString, Schema.Null])
            ),
          }),
          [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
        )
      ).annotate({ readOnly: true })
    ),
    isFavourite: Schema.optionalKey(
      Schema.Boolean.annotate({
        description:
          'True if ShopUser is logged in and has ProductVariant in at least one favourite list.',
        readOnly: true,
      })
    ),
    inStock: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    price: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    originalPrice: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    lowestPriceBeforeDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ default: null, readOnly: true })
    ),
    appliedPromotions: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    priceWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    productQuantity: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductVariantsyliusshopproductvariantshow' });
export type ProductVariantsyliusshopproductvariantshow = Schema.Schema.Type<
  typeof ProductVariantsyliusshopproductvariantshow
>;
export type ProductVariantsyliusshopproductvariantshowEncoded = Schema.Codec.Encoded<
  typeof ProductVariantsyliusshopproductvariantshow
>;

/* ProductVariantsyliusshopproductvariantshowdetail */

export const ProductVariantsyliusshopproductvariantshowdetail = Schema.StructWithRest(
  Schema.Struct({
    couponCodes: Schema.Array(ApplicablePromotionCodesyliusshopproductvariantshowdetail),
    labels: Schema.Array(Labelsyliusshopproductvariantshowdetail),
    tracked: Schema.Boolean.annotate({ default: false }),
    code: Schema.String,
    enabled: Schema.Boolean.annotate({ default: true }),
    available: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    maxOrderable: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    inStock: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    dispatchDate: Schema.optionalKey(Schema.Union([DateSerializableFromString, Schema.Null])),
    stockStatus: Schema.optionalKey(
      Schema.Literals(['inStock', 'soldOut', 'preorder', 'supplierStock']).annotate({
        readOnly: true,
      })
    ),
    localWarehouse: Schema.optionalKey(
      Schema.Array(
        Schema.StructWithRest(
          Schema.Struct({
            type: Schema.Union([Schema.Literals(['CRU', 'PCE']), Schema.Null]).annotate({
              description: 'Kód pobočky/skladu (store code), např. PCE, CRU.',
            }),
            quantity: Schema.Union([
              Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
              Schema.Null,
            ]).annotate({
              description: 'Dostupné množství položky ve skladu, null pro neomezený počet.',
            }),
            dispatchDate: Schema.optionalKey(
              Schema.Union([DateSerializableFromString, Schema.Null])
            ),
          }),
          [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
        )
      ).annotate({ readOnly: true })
    ),
    isFavourite: Schema.optionalKey(
      Schema.Boolean.annotate({
        description:
          'True if ShopUser is logged in and has ProductVariant in at least one favourite list.',
        readOnly: true,
      })
    ),
    price: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    priceWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    originalPrice: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    lowestPriceBeforeDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ default: null, readOnly: true })
    ),
    productQuantity: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductVariantsyliusshopproductvariantshowdetail' });
export type ProductVariantsyliusshopproductvariantshowdetail = Schema.Schema.Type<
  typeof ProductVariantsyliusshopproductvariantshowdetail
>;
export type ProductVariantsyliusshopproductvariantshowdetailEncoded = Schema.Codec.Encoded<
  typeof ProductVariantsyliusshopproductvariantshowdetail
>;

/* ProductVariantjsonldsyliusshopproductindex */

export const ProductVariantjsonldsyliusshopproductindex = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    couponCodes: Schema.Array(ApplicablePromotionCodejsonldsyliusshopproductindex),
    labels: Schema.Array(Labeljsonldsyliusshopproductindex),
    code: Schema.String,
    enabled: Schema.Boolean.annotate({ default: true }),
    available: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    maxOrderable: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    inStock: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    dispatchDate: Schema.optionalKey(Schema.Union([DateSerializableFromString, Schema.Null])),
    stockStatus: Schema.optionalKey(
      Schema.Literals(['inStock', 'soldOut', 'preorder', 'supplierStock']).annotate({
        readOnly: true,
      })
    ),
    localWarehouse: Schema.optionalKey(
      Schema.Array(
        Schema.StructWithRest(
          Schema.Struct({
            type: Schema.Union([Schema.Literals(['CRU', 'PCE']), Schema.Null]).annotate({
              description: 'Kód pobočky/skladu (store code), např. PCE, CRU.',
            }),
            quantity: Schema.Union([
              Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
              Schema.Null,
            ]).annotate({
              description: 'Dostupné množství položky ve skladu, null pro neomezený počet.',
            }),
            dispatchDate: Schema.optionalKey(
              Schema.Union([DateSerializableFromString, Schema.Null])
            ),
          }),
          [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
        )
      ).annotate({ readOnly: true })
    ),
    isFavourite: Schema.optionalKey(
      Schema.Boolean.annotate({
        description:
          'True if ShopUser is logged in and has ProductVariant in at least one favourite list.',
        readOnly: true,
      })
    ),
    price: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    priceWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    originalPrice: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    lowestPriceBeforeDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ default: null, readOnly: true })
    ),
    productQuantity: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductVariantjsonldsyliusshopproductindex' });
export type ProductVariantjsonldsyliusshopproductindex = Schema.Schema.Type<
  typeof ProductVariantjsonldsyliusshopproductindex
>;
export type ProductVariantjsonldsyliusshopproductindexEncoded = Schema.Codec.Encoded<
  typeof ProductVariantjsonldsyliusshopproductindex
>;

/* ProductVariantjsonldsyliusshopproductvariantindex */

export const ProductVariantjsonldsyliusshopproductvariantindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    couponCodes: Schema.Array(ApplicablePromotionCodejsonldsyliusshopproductvariantindex),
    labels: Schema.Array(Labeljsonldsyliusshopproductvariantindex),
    tracked: Schema.Boolean.annotate({ default: false }),
    code: Schema.String,
    product: Schema.String.annotate({ format: 'iri-reference' }),
    optionValues: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    enabled: Schema.Boolean.annotate({ default: true }),
    available: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    maxOrderable: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    inStock: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    name: Schema.Union([Schema.String, Schema.Null]),
    dispatchDate: Schema.optionalKey(Schema.Union([DateSerializableFromString, Schema.Null])),
    stockStatus: Schema.optionalKey(
      Schema.Literals(['inStock', 'soldOut', 'preorder', 'supplierStock']).annotate({
        readOnly: true,
      })
    ),
    localWarehouse: Schema.optionalKey(
      Schema.Array(
        Schema.StructWithRest(
          Schema.Struct({
            type: Schema.Union([Schema.Literals(['CRU', 'PCE']), Schema.Null]).annotate({
              description: 'Kód pobočky/skladu (store code), např. PCE, CRU.',
            }),
            quantity: Schema.Union([
              Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
              Schema.Null,
            ]).annotate({
              description: 'Dostupné množství položky ve skladu, null pro neomezený počet.',
            }),
            dispatchDate: Schema.optionalKey(
              Schema.Union([DateSerializableFromString, Schema.Null])
            ),
          }),
          [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
        )
      ).annotate({ readOnly: true })
    ),
    isFavourite: Schema.optionalKey(
      Schema.Boolean.annotate({
        description:
          'True if ShopUser is logged in and has ProductVariant in at least one favourite list.',
        readOnly: true,
      })
    ),
    price: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    originalPrice: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    lowestPriceBeforeDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ default: null, readOnly: true })
    ),
    appliedPromotions: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    priceWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    productQuantity: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductVariantjsonldsyliusshopproductvariantindex' });
export type ProductVariantjsonldsyliusshopproductvariantindex = Schema.Schema.Type<
  typeof ProductVariantjsonldsyliusshopproductvariantindex
>;
export type ProductVariantjsonldsyliusshopproductvariantindexEncoded = Schema.Codec.Encoded<
  typeof ProductVariantjsonldsyliusshopproductvariantindex
>;

/* ProductVariantjsonldsyliusshopproductvariantshow */

export const ProductVariantjsonldsyliusshopproductvariantshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    couponCodes: Schema.Array(ApplicablePromotionCodejsonldsyliusshopproductvariantshow),
    labels: Schema.Array(Labeljsonldsyliusshopproductvariantshow),
    code: Schema.String,
    product: Schema.String.annotate({ format: 'iri-reference' }),
    optionValues: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    available: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    maxOrderable: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    name: Schema.Union([Schema.String, Schema.Null]),
    dispatchDate: Schema.optionalKey(Schema.Union([DateSerializableFromString, Schema.Null])),
    stockStatus: Schema.optionalKey(
      Schema.Literals(['inStock', 'soldOut', 'preorder', 'supplierStock']).annotate({
        readOnly: true,
      })
    ),
    localWarehouse: Schema.optionalKey(
      Schema.Array(
        Schema.StructWithRest(
          Schema.Struct({
            type: Schema.Union([Schema.Literals(['CRU', 'PCE']), Schema.Null]).annotate({
              description: 'Kód pobočky/skladu (store code), např. PCE, CRU.',
            }),
            quantity: Schema.Union([
              Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
              Schema.Null,
            ]).annotate({
              description: 'Dostupné množství položky ve skladu, null pro neomezený počet.',
            }),
            dispatchDate: Schema.optionalKey(
              Schema.Union([DateSerializableFromString, Schema.Null])
            ),
          }),
          [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
        )
      ).annotate({ readOnly: true })
    ),
    isFavourite: Schema.optionalKey(
      Schema.Boolean.annotate({
        description:
          'True if ShopUser is logged in and has ProductVariant in at least one favourite list.',
        readOnly: true,
      })
    ),
    inStock: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    price: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    originalPrice: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    lowestPriceBeforeDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ default: null, readOnly: true })
    ),
    appliedPromotions: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    priceWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    productQuantity: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductVariantjsonldsyliusshopproductvariantshow' });
export type ProductVariantjsonldsyliusshopproductvariantshow = Schema.Schema.Type<
  typeof ProductVariantjsonldsyliusshopproductvariantshow
>;
export type ProductVariantjsonldsyliusshopproductvariantshowEncoded = Schema.Codec.Encoded<
  typeof ProductVariantjsonldsyliusshopproductvariantshow
>;

/* ProductVariantjsonldsyliusshopproductvariantshowdetail */

export const ProductVariantjsonldsyliusshopproductvariantshowdetail = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    couponCodes: Schema.Array(ApplicablePromotionCodejsonldsyliusshopproductvariantshowdetail),
    labels: Schema.Array(Labeljsonldsyliusshopproductvariantshowdetail),
    tracked: Schema.Boolean.annotate({ default: false }),
    code: Schema.String,
    enabled: Schema.Boolean.annotate({ default: true }),
    available: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    maxOrderable: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    inStock: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    dispatchDate: Schema.optionalKey(Schema.Union([DateSerializableFromString, Schema.Null])),
    stockStatus: Schema.optionalKey(
      Schema.Literals(['inStock', 'soldOut', 'preorder', 'supplierStock']).annotate({
        readOnly: true,
      })
    ),
    localWarehouse: Schema.optionalKey(
      Schema.Array(
        Schema.StructWithRest(
          Schema.Struct({
            type: Schema.Union([Schema.Literals(['CRU', 'PCE']), Schema.Null]).annotate({
              description: 'Kód pobočky/skladu (store code), např. PCE, CRU.',
            }),
            quantity: Schema.Union([
              Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
              Schema.Null,
            ]).annotate({
              description: 'Dostupné množství položky ve skladu, null pro neomezený počet.',
            }),
            dispatchDate: Schema.optionalKey(
              Schema.Union([DateSerializableFromString, Schema.Null])
            ),
          }),
          [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
        )
      ).annotate({ readOnly: true })
    ),
    isFavourite: Schema.optionalKey(
      Schema.Boolean.annotate({
        description:
          'True if ShopUser is logged in and has ProductVariant in at least one favourite list.',
        readOnly: true,
      })
    ),
    price: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    priceWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    originalPrice: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    lowestPriceBeforeDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ default: null, readOnly: true })
    ),
    productQuantity: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductVariantjsonldsyliusshopproductvariantshowdetail' });
export type ProductVariantjsonldsyliusshopproductvariantshowdetail = Schema.Schema.Type<
  typeof ProductVariantjsonldsyliusshopproductvariantshowdetail
>;
export type ProductVariantjsonldsyliusshopproductvariantshowdetailEncoded = Schema.Codec.Encoded<
  typeof ProductVariantjsonldsyliusshopproductvariantshowdetail
>;

/* Money */

export const Money = Schema.StructWithRest(
  Schema.Struct({
    amount: BigDecimal,
    currency: MoneyCurrency,
    context: Context,
    minorAmount: BigDecimal,
    unscaledAmount: BigInteger,
    monies: Schema.optionalKey(
      Schema.Array(Schema.Union([Schema.String, Schema.Null])).annotate({
        description: 'Required by interface Monetary. Not intended for direct use.',
        readOnly: true,
      })
    ),
    sign: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns the sign of this money.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    zero: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Returns whether this money has zero value.',
        readOnly: true,
      })
    ),
    negative: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Returns whether this money has a negative value.',
        readOnly: true,
      })
    ),
    negativeOrZero: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Returns whether this money has a negative or zero value.',
        readOnly: true,
      })
    ),
    positive: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Returns whether this money has a positive value.',
        readOnly: true,
      })
    ),
    positiveOrZero: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Returns whether this money has a positive or zero value.',
        readOnly: true,
      })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Money' });
export type Money = Schema.Schema.Type<typeof Money>;
export type MoneyEncoded = Schema.Codec.Encoded<typeof Money>;

/* ZonedDateTime */

export const ZonedDateTime = Schema.StructWithRest(
  Schema.Struct({
    timeZoneOffset: TimeZoneOffset,
    timeZone: TimeZone,
    instant: Instant,
    dateTime: LocalDateTime,
    date: Schema.suspend((): Schema.Codec<LocalDate> => LocalDate),
    time: LocalTime,
    year: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    month: Schema.optionalKey(
      Schema.Literals([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]).annotate({
        description: 'Returns the month-of-year as a Month enum.',
        readOnly: true,
      })
    ),
    monthValue: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns the month-of-year value from 1 to 12.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    dayOfMonth: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    dayOfWeek: Schema.optionalKey(
      Schema.Literals([1, 2, 3, 4, 5, 6, 7]).annotate({ readOnly: true })
    ),
    dayOfYear: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    hour: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    minute: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    second: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    epochSecond: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    nano: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    future: Schema.optionalKey(
      Schema.Boolean.annotate({
        description:
          'Returns whether this ZonedDateTime is in the future, according to the given clock.',
        readOnly: true,
      })
    ),
    past: Schema.optionalKey(
      Schema.Boolean.annotate({
        description:
          'Returns whether this ZonedDateTime is in the past, according to the given clock.',
        readOnly: true,
      })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ZonedDateTime' });
export type ZonedDateTime = Schema.Schema.Type<typeof ZonedDateTime>;
export type ZonedDateTimeEncoded = Schema.Codec.Encoded<typeof ZonedDateTime>;

/* Brandjsonldsyliusshopbrandshowdetail */

export const Brandjsonldsyliusshopbrandshowdetail = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.String.annotate({ format: 'uuid' }),
    code: Schema.String,
    priority: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    page: Schema.Literals(['yes', 'hidden', 'no']),
    image: Schema.Union([BrandImagejsonldsyliusshopbrandshowdetail, Schema.Null]),
    name: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    metaDescription: Schema.Union([Schema.String, Schema.Null]),
    attributes: Schema.optionalKey(
      Schema.Array(ProductAttributejsonldsyliusshoptaxonshowdetail).annotate({ readOnly: true })
    ),
    priceRange: Schema.optionalKey(
      Schema.StructWithRest(
        Schema.Struct({
          min: Schema.optionalKey(
            Schema.Number.annotate({
              description: 'Minimum price in minor units (e.g., cents).',
            }).check(Schema.isInt().annotate({ expected: 'an integer' }))
          ),
          max: Schema.optionalKey(
            Schema.Number.annotate({
              description: 'Maximum price in minor units (e.g., cents).',
            }).check(Schema.isInt().annotate({ expected: 'an integer' }))
          ),
        }),
        [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
      ).annotate({ readOnly: true })
    ),
    articles: Schema.optionalKey(
      Schema.Array(Articlejsonldsyliusshoparticleindexfavourite).annotate({ readOnly: true })
    ),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Brandjsonldsyliusshopbrandshowdetail' });
export type Brandjsonldsyliusshopbrandshowdetail = Schema.Schema.Type<
  typeof Brandjsonldsyliusshopbrandshowdetail
>;
export type BrandjsonldsyliusshopbrandshowdetailEncoded = Schema.Codec.Encoded<
  typeof Brandjsonldsyliusshopbrandshowdetail
>;

/* Brandsyliusshopbrandshowdetail */

export const Brandsyliusshopbrandshowdetail = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.String.annotate({ format: 'uuid' }),
    code: Schema.String,
    priority: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    page: Schema.Literals(['yes', 'hidden', 'no']),
    image: Schema.Union([BrandImagesyliusshopbrandshowdetail, Schema.Null]),
    name: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    metaDescription: Schema.Union([Schema.String, Schema.Null]),
    attributes: Schema.optionalKey(
      Schema.Array(ProductAttributesyliusshoptaxonshowdetail).annotate({ readOnly: true })
    ),
    priceRange: Schema.optionalKey(
      Schema.StructWithRest(
        Schema.Struct({
          min: Schema.optionalKey(
            Schema.Number.annotate({
              description: 'Minimum price in minor units (e.g., cents).',
            }).check(Schema.isInt().annotate({ expected: 'an integer' }))
          ),
          max: Schema.optionalKey(
            Schema.Number.annotate({
              description: 'Maximum price in minor units (e.g., cents).',
            }).check(Schema.isInt().annotate({ expected: 'an integer' }))
          ),
        }),
        [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
      ).annotate({ readOnly: true })
    ),
    articles: Schema.optionalKey(
      Schema.Array(Articlesyliusshoparticleindexfavourite).annotate({ readOnly: true })
    ),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Brandsyliusshopbrandshowdetail' });
export type Brandsyliusshopbrandshowdetail = Schema.Schema.Type<
  typeof Brandsyliusshopbrandshowdetail
>;
export type BrandsyliusshopbrandshowdetailEncoded = Schema.Codec.Encoded<
  typeof Brandsyliusshopbrandshowdetail
>;

/* Moneyjsonld */

export const Moneyjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    amount: BigDecimaljsonld,
    currency: MoneyCurrencyjsonld,
    context: Contextjsonld,
    minorAmount: BigDecimaljsonld,
    unscaledAmount: BigIntegerjsonld,
    monies: Schema.optionalKey(
      Schema.Array(Schema.Union([Schema.String, Schema.Null])).annotate({
        description: 'Required by interface Monetary. Not intended for direct use.',
        readOnly: true,
      })
    ),
    sign: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns the sign of this money.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    zero: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Returns whether this money has zero value.',
        readOnly: true,
      })
    ),
    negative: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Returns whether this money has a negative value.',
        readOnly: true,
      })
    ),
    negativeOrZero: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Returns whether this money has a negative or zero value.',
        readOnly: true,
      })
    ),
    positive: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Returns whether this money has a positive value.',
        readOnly: true,
      })
    ),
    positiveOrZero: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Returns whether this money has a positive or zero value.',
        readOnly: true,
      })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Moneyjsonld' });
export type Moneyjsonld = Schema.Schema.Type<typeof Moneyjsonld>;
export type MoneyjsonldEncoded = Schema.Codec.Encoded<typeof Moneyjsonld>;

/* ZonedDateTimejsonld */

export const ZonedDateTimejsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    timeZoneOffset: TimeZoneOffsetjsonld,
    timeZone: TimeZonejsonld,
    instant: Instantjsonld,
    dateTime: LocalDateTimejsonld,
    date: Schema.suspend((): Schema.Codec<LocalDatejsonld> => LocalDatejsonld),
    time: LocalTimejsonld,
    year: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    month: Schema.optionalKey(
      Schema.Literals([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]).annotate({
        description: 'Returns the month-of-year as a Month enum.',
        readOnly: true,
      })
    ),
    monthValue: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns the month-of-year value from 1 to 12.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    dayOfMonth: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    dayOfWeek: Schema.optionalKey(
      Schema.Literals([1, 2, 3, 4, 5, 6, 7]).annotate({ readOnly: true })
    ),
    dayOfYear: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    hour: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    minute: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    second: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    epochSecond: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    nano: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    future: Schema.optionalKey(
      Schema.Boolean.annotate({
        description:
          'Returns whether this ZonedDateTime is in the future, according to the given clock.',
        readOnly: true,
      })
    ),
    past: Schema.optionalKey(
      Schema.Boolean.annotate({
        description:
          'Returns whether this ZonedDateTime is in the past, according to the given clock.',
        readOnly: true,
      })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ZonedDateTimejsonld' });
export type ZonedDateTimejsonld = Schema.Schema.Type<typeof ZonedDateTimejsonld>;
export type ZonedDateTimejsonldEncoded = Schema.Codec.Encoded<typeof ZonedDateTimejsonld>;

/* Articlesyliusshoparticleindex */

export const Articlesyliusshoparticleindex = Schema.StructWithRest(
  Schema.Struct({
    section: Sectionsyliusshoparticleindex,
    categories: Schema.Array(Categorysyliusshoparticleindex),
    tags: Schema.Array(Tagsyliusshoparticleindex),
    publishedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    authors: Schema.Array(Authorsyliusshoparticleindex),
    thumbnailImageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    title: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Articlesyliusshoparticleindex' });
export type Articlesyliusshoparticleindex = Schema.Schema.Type<
  typeof Articlesyliusshoparticleindex
>;
export type ArticlesyliusshoparticleindexEncoded = Schema.Codec.Encoded<
  typeof Articlesyliusshoparticleindex
>;

/* ProductElementDTOsyliusshoparticleshow */

export const ProductElementDTOsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    productCode: Schema.String,
    product: Schema.Union([Productsyliusshoparticleshow, Schema.Null]),
    type: Schema.Literal('product').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductElementDTOsyliusshoparticleshow' });
export type ProductElementDTOsyliusshoparticleshow = Schema.Schema.Type<
  typeof ProductElementDTOsyliusshoparticleshow
>;
export type ProductElementDTOsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof ProductElementDTOsyliusshoparticleshow
>;

/* AddToCartButtonElementDTOsyliusshoparticleshow */

export const AddToCartButtonElementDTOsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    productCode: Schema.String,
    text: Schema.String,
    product: Schema.Union([Productsyliusshoparticleshow, Schema.Null]),
    type: Schema.Literal('button_add_to_cart').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'AddToCartButtonElementDTOsyliusshoparticleshow' });
export type AddToCartButtonElementDTOsyliusshoparticleshow = Schema.Schema.Type<
  typeof AddToCartButtonElementDTOsyliusshoparticleshow
>;
export type AddToCartButtonElementDTOsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof AddToCartButtonElementDTOsyliusshoparticleshow
>;

/* TeamElementDTOsyliusshoparticleshow */

export const TeamElementDTOsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    teamMember: Schema.Array(TeamMemberItemDTOsyliusshoparticleshow),
    type: Schema.Literal('team').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TeamElementDTOsyliusshoparticleshow' });
export type TeamElementDTOsyliusshoparticleshow = Schema.Schema.Type<
  typeof TeamElementDTOsyliusshoparticleshow
>;
export type TeamElementDTOsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof TeamElementDTOsyliusshoparticleshow
>;

/* ButtonGridElementDTOsyliusshoparticleshow */

export const ButtonGridElementDTOsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    buttons: Schema.Array(ButtonGridItemDTOsyliusshoparticleshow),
    type: Schema.Literal('button_grid').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ButtonGridElementDTOsyliusshoparticleshow' });
export type ButtonGridElementDTOsyliusshoparticleshow = Schema.Schema.Type<
  typeof ButtonGridElementDTOsyliusshoparticleshow
>;
export type ButtonGridElementDTOsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof ButtonGridElementDTOsyliusshoparticleshow
>;

/* TableElementDTOsyliusshoparticleshow */

export const TableElementDTOsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    style: Schema.Literals(['full_width', 'fit_content']),
    rows: Schema.Array(TableRowItemDTOsyliusshoparticleshow),
    type: Schema.Literal('table').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TableElementDTOsyliusshoparticleshow' });
export type TableElementDTOsyliusshoparticleshow = Schema.Schema.Type<
  typeof TableElementDTOsyliusshoparticleshow
>;
export type TableElementDTOsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof TableElementDTOsyliusshoparticleshow
>;

/* Articlejsonldsyliusshoparticleindex */

export const Articlejsonldsyliusshoparticleindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    section: Sectionjsonldsyliusshoparticleindex,
    categories: Schema.Array(Categoryjsonldsyliusshoparticleindex),
    tags: Schema.Array(Tagjsonldsyliusshoparticleindex),
    publishedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    authors: Schema.Array(Authorjsonldsyliusshoparticleindex),
    thumbnailImageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    title: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Articlejsonldsyliusshoparticleindex' });
export type Articlejsonldsyliusshoparticleindex = Schema.Schema.Type<
  typeof Articlejsonldsyliusshoparticleindex
>;
export type ArticlejsonldsyliusshoparticleindexEncoded = Schema.Codec.Encoded<
  typeof Articlejsonldsyliusshoparticleindex
>;

/* ProductElementDTOjsonldsyliusshoparticleshow */

export const ProductElementDTOjsonldsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    productCode: Schema.String,
    product: Schema.Union([Productjsonldsyliusshoparticleshow, Schema.Null]),
    type: Schema.Literal('product').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductElementDTOjsonldsyliusshoparticleshow' });
export type ProductElementDTOjsonldsyliusshoparticleshow = Schema.Schema.Type<
  typeof ProductElementDTOjsonldsyliusshoparticleshow
>;
export type ProductElementDTOjsonldsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof ProductElementDTOjsonldsyliusshoparticleshow
>;

/* AddToCartButtonElementDTOjsonldsyliusshoparticleshow */

export const AddToCartButtonElementDTOjsonldsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    productCode: Schema.String,
    text: Schema.String,
    product: Schema.Union([Productjsonldsyliusshoparticleshow, Schema.Null]),
    type: Schema.Literal('button_add_to_cart').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'AddToCartButtonElementDTOjsonldsyliusshoparticleshow' });
export type AddToCartButtonElementDTOjsonldsyliusshoparticleshow = Schema.Schema.Type<
  typeof AddToCartButtonElementDTOjsonldsyliusshoparticleshow
>;
export type AddToCartButtonElementDTOjsonldsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof AddToCartButtonElementDTOjsonldsyliusshoparticleshow
>;

/* TeamElementDTOjsonldsyliusshoparticleshow */

export const TeamElementDTOjsonldsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    teamMember: Schema.Array(TeamMemberItemDTOjsonldsyliusshoparticleshow),
    type: Schema.Literal('team').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TeamElementDTOjsonldsyliusshoparticleshow' });
export type TeamElementDTOjsonldsyliusshoparticleshow = Schema.Schema.Type<
  typeof TeamElementDTOjsonldsyliusshoparticleshow
>;
export type TeamElementDTOjsonldsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof TeamElementDTOjsonldsyliusshoparticleshow
>;

/* ButtonGridElementDTOjsonldsyliusshoparticleshow */

export const ButtonGridElementDTOjsonldsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    buttons: Schema.Array(ButtonGridItemDTOjsonldsyliusshoparticleshow),
    type: Schema.Literal('button_grid').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ButtonGridElementDTOjsonldsyliusshoparticleshow' });
export type ButtonGridElementDTOjsonldsyliusshoparticleshow = Schema.Schema.Type<
  typeof ButtonGridElementDTOjsonldsyliusshoparticleshow
>;
export type ButtonGridElementDTOjsonldsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof ButtonGridElementDTOjsonldsyliusshoparticleshow
>;

/* TableElementDTOjsonldsyliusshoparticleshow */

export const TableElementDTOjsonldsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    style: Schema.Literals(['full_width', 'fit_content']),
    rows: Schema.Array(TableRowItemDTOjsonldsyliusshoparticleshow),
    type: Schema.Literal('table').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TableElementDTOjsonldsyliusshoparticleshow' });
export type TableElementDTOjsonldsyliusshoparticleshow = Schema.Schema.Type<
  typeof TableElementDTOjsonldsyliusshoparticleshow
>;
export type TableElementDTOjsonldsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof TableElementDTOjsonldsyliusshoparticleshow
>;

/* HomepageDTOsyliusshophomepageshow */

export const HomepageDTOsyliusshophomepageshow = Schema.StructWithRest(
  Schema.Struct({
    brands: Schema.Array(Brandsyliusshophomepageshow),
    banners: Schema.Array(Bannersyliusshophomepageshow),
    articles: Schema.Array(Articlesyliusshophomepageshow),
    taxons: Schema.Array(Taxonsyliusshophomepageshow),
    heurekaReviews: Schema.Array(HeurekaReviewsyliusshophomepageshow),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'HomepageDTOsyliusshophomepageshow' });
export type HomepageDTOsyliusshophomepageshow = Schema.Schema.Type<
  typeof HomepageDTOsyliusshophomepageshow
>;
export type HomepageDTOsyliusshophomepageshowEncoded = Schema.Codec.Encoded<
  typeof HomepageDTOsyliusshophomepageshow
>;

/* HomepageDTOjsonldsyliusshophomepageshow */

export const HomepageDTOjsonldsyliusshophomepageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    brands: Schema.Array(Brandjsonldsyliusshophomepageshow),
    banners: Schema.Array(Bannerjsonldsyliusshophomepageshow),
    articles: Schema.Array(Articlejsonldsyliusshophomepageshow),
    taxons: Schema.Array(Taxonjsonldsyliusshophomepageshow),
    heurekaReviews: Schema.Array(HeurekaReviewjsonldsyliusshophomepageshow),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'HomepageDTOjsonldsyliusshophomepageshow' });
export type HomepageDTOjsonldsyliusshophomepageshow = Schema.Schema.Type<
  typeof HomepageDTOjsonldsyliusshophomepageshow
>;
export type HomepageDTOjsonldsyliusshophomepageshowEncoded = Schema.Codec.Encoded<
  typeof HomepageDTOjsonldsyliusshophomepageshow
>;

/* Ordersyliusshopcartshow */

export const Ordersyliusshopcartshow = Schema.StructWithRest(
  Schema.Struct({
    promotionRuleHints: Schema.Array(CartPromotionRuleHintssyliusshopcartshow),
    customer: Schema.Union([Customersyliusshopcartshow, Schema.Null]),
    channel: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    shippingAddress: Schema.Union([Addresssyliusshopcartshow, Schema.Null]),
    billingAddress: Schema.Union([Addresssyliusshopcartshow, Schema.Null]),
    payments: Schema.Array(Paymentsyliusshopcartshow),
    shipments: Schema.Array(Shipmentsyliusshopcartshow),
    currencyCode: Schema.String,
    localeCode: Schema.String,
    promotionCoupon: Schema.Union([PromotionCouponsyliusshopcartshow, Schema.Null]),
    checkoutState: Schema.String.annotate({ default: 'cart' }),
    paymentState: Schema.String.annotate({ default: 'cart' }),
    shippingState: Schema.String.annotate({ default: 'cart' }),
    tokenValue: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    number: Schema.Union([Schema.String, Schema.Null]),
    itemsTotal: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    total: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Items total + adjustments total.',
        default: 0,
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    state: Schema.String.annotate({ default: 'cart' }),
    vatFree: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'This is TRUE if Order price does NOT contain any VAT tax.',
        readOnly: true,
      })
    ),
    frontAllItemsPriceWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Sum of price of all items (without shipment and payment) after all discounts with VAT\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontAllItemsPriceWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Sum of price of all items (without shipment and payment) after all discounts without VAT',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontAllItemsDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Nominal value of sum of all discounts applied on (all) items\nValue is nominal for both nominal and percentage discounts\nNote: Because discount includes VAT, this sum also technically always includes discount from base+VAT price event\nif customer is verified to NOT pay VAT for Order!\nNumber is positive.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontAllItemsTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns nominal value of VAT from price AFTER discounts for all items\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontTotalWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns price including all items, shipment, payment and applied discounts\nAlways with VAT or NULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontTotalWithoutVat: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns price including all items, shipment, payment and applied discounts\nAlways without VAT even if customer pays VAT.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontFinalRounding: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns final rounding on entire Order. This correction is applied after everything even after TAX/VAT.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontTotalTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns nominal value of VAT from price AFTER discounts for all items\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontTotalPaid: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns FINAL price to be paid by customer including all items, shipment, payment, applied discounts\nand applied taxes if any. This number is number which should be sent to payment gate or displayed as number\nrepresenting how much will customer pay.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontShipmentTotalPaid: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns FINAL price to be paid by customer for shipment (after discount and including taxes if applied)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontPaymentTotalPaid: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns FINAL price to be paid by customer for payment (after discount and including taxes if applied)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontDeliveryTotalPaid: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns FINAL price to be paid by customer for delivery: shipment+payment (after discount and including taxes if applied)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontShipmentWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns shipment price before discount with VAT\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontShipmentDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns discount in nominal value of shipment (for both percentage and nominal discount)\nPositive number.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontShipmentWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns shipment price with VAT after applied discounts\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontShipmentWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns shipment price without VAT after applied discounts',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontShipmentTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns nominal value of VAT from price AFTER discounts for shipment\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontPaymentWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns payment price before discount with VAT\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontPaymentDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns discount in nominal value of payment (for both percentage and nominal discount)\nPositive number.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontPaymentWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns payment price with VAT after applied discounts\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontPaymentWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns payment price without VAT after applied discounts',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontPaymentTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns nominal value of VAT from price AFTER discounts for payment\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontDeliveryWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns delivery: shipment+payment price before discount with VAT\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontDeliveryDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns discount in nominal value of delivery: shipment+payment (for both percentage and nominal discount)\nPositive number.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontDeliveryWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns delivery: shipment+payment price with VAT after applied discounts\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontDeliveryWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns delivery: shipment+payment price without VAT after applied discounts',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontDeliveryTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns nominal value of VAT from price AFTER discounts for delivery: shipment+payment\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontShipmentDiscountPercentage: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns overall percentage discount on shipments calculated from base price with tax and applied nominal discounts.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontPaymentDiscountPercentage: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns overall percentage discount on payments calculated from base price with tax and applied nominal discounts.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontDeliveryDiscountPercentage: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    totalWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    itemsTotalWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Sum of price of all items WITHOUT VAT tax and WITHOUT shipping and payment price',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    orderPromotionTotalWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Order promotional total without VAT (total for all shipments)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    shippingWithoutTaxTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Shipping price without VAT (total for all shipments)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    paymentTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns payment fee price after promotion with applied taxes (for VIES valid non-CZ subjects price is without taxes!)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    paymentPromotionTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    paymentTax: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns only tax of payment method',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    paymentWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns only tax of payment method\nTODO: works only if tax is included in price (this is ok for now)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    orderPromotionTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns amount of order discount. Does not include shipping discounts.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    shippingPromotionTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    itemsSubtotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    taxTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns sum of neutral and non neutral tax adjustments on order and total tax of order items.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    shippingTaxTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    taxIncludedTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    shippingTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns shipping fee together with taxes decreased by shipping discount.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Ordersyliusshopcartshow' });
export type Ordersyliusshopcartshow = Schema.Schema.Type<typeof Ordersyliusshopcartshow>;
export type OrdersyliusshopcartshowEncoded = Schema.Codec.Encoded<typeof Ordersyliusshopcartshow>;

/* Orderjsonldsyliusshopcartshow */

export const Orderjsonldsyliusshopcartshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    promotionRuleHints: Schema.Array(CartPromotionRuleHintsjsonldsyliusshopcartshow),
    customer: Schema.Union([Customerjsonldsyliusshopcartshow, Schema.Null]),
    channel: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    shippingAddress: Schema.Union([Addressjsonldsyliusshopcartshow, Schema.Null]),
    billingAddress: Schema.Union([Addressjsonldsyliusshopcartshow, Schema.Null]),
    payments: Schema.Array(Paymentjsonldsyliusshopcartshow),
    shipments: Schema.Array(Shipmentjsonldsyliusshopcartshow),
    currencyCode: Schema.String,
    localeCode: Schema.String,
    promotionCoupon: Schema.Union([PromotionCouponjsonldsyliusshopcartshow, Schema.Null]),
    checkoutState: Schema.String.annotate({ default: 'cart' }),
    paymentState: Schema.String.annotate({ default: 'cart' }),
    shippingState: Schema.String.annotate({ default: 'cart' }),
    tokenValue: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    number: Schema.Union([Schema.String, Schema.Null]),
    itemsTotal: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    total: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Items total + adjustments total.',
        default: 0,
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    state: Schema.String.annotate({ default: 'cart' }),
    vatFree: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'This is TRUE if Order price does NOT contain any VAT tax.',
        readOnly: true,
      })
    ),
    frontAllItemsPriceWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Sum of price of all items (without shipment and payment) after all discounts with VAT\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontAllItemsPriceWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Sum of price of all items (without shipment and payment) after all discounts without VAT',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontAllItemsDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Nominal value of sum of all discounts applied on (all) items\nValue is nominal for both nominal and percentage discounts\nNote: Because discount includes VAT, this sum also technically always includes discount from base+VAT price event\nif customer is verified to NOT pay VAT for Order!\nNumber is positive.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontAllItemsTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns nominal value of VAT from price AFTER discounts for all items\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontTotalWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns price including all items, shipment, payment and applied discounts\nAlways with VAT or NULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontTotalWithoutVat: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns price including all items, shipment, payment and applied discounts\nAlways without VAT even if customer pays VAT.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontFinalRounding: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns final rounding on entire Order. This correction is applied after everything even after TAX/VAT.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontTotalTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns nominal value of VAT from price AFTER discounts for all items\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontTotalPaid: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns FINAL price to be paid by customer including all items, shipment, payment, applied discounts\nand applied taxes if any. This number is number which should be sent to payment gate or displayed as number\nrepresenting how much will customer pay.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontShipmentTotalPaid: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns FINAL price to be paid by customer for shipment (after discount and including taxes if applied)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontPaymentTotalPaid: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns FINAL price to be paid by customer for payment (after discount and including taxes if applied)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontDeliveryTotalPaid: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns FINAL price to be paid by customer for delivery: shipment+payment (after discount and including taxes if applied)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontShipmentWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns shipment price before discount with VAT\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontShipmentDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns discount in nominal value of shipment (for both percentage and nominal discount)\nPositive number.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontShipmentWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns shipment price with VAT after applied discounts\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontShipmentWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns shipment price without VAT after applied discounts',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontShipmentTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns nominal value of VAT from price AFTER discounts for shipment\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontPaymentWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns payment price before discount with VAT\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontPaymentDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns discount in nominal value of payment (for both percentage and nominal discount)\nPositive number.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontPaymentWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns payment price with VAT after applied discounts\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontPaymentWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns payment price without VAT after applied discounts',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontPaymentTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns nominal value of VAT from price AFTER discounts for payment\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontDeliveryWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns delivery: shipment+payment price before discount with VAT\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontDeliveryDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns discount in nominal value of delivery: shipment+payment (for both percentage and nominal discount)\nPositive number.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontDeliveryWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns delivery: shipment+payment price with VAT after applied discounts\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontDeliveryWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns delivery: shipment+payment price without VAT after applied discounts',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontDeliveryTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns nominal value of VAT from price AFTER discounts for delivery: shipment+payment\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontShipmentDiscountPercentage: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns overall percentage discount on shipments calculated from base price with tax and applied nominal discounts.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontPaymentDiscountPercentage: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns overall percentage discount on payments calculated from base price with tax and applied nominal discounts.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontDeliveryDiscountPercentage: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    totalWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    itemsTotalWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Sum of price of all items WITHOUT VAT tax and WITHOUT shipping and payment price',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    orderPromotionTotalWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Order promotional total without VAT (total for all shipments)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    shippingWithoutTaxTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Shipping price without VAT (total for all shipments)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    paymentTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns payment fee price after promotion with applied taxes (for VIES valid non-CZ subjects price is without taxes!)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    paymentPromotionTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    paymentTax: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns only tax of payment method',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    paymentWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns only tax of payment method\nTODO: works only if tax is included in price (this is ok for now)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    orderPromotionTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns amount of order discount. Does not include shipping discounts.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    shippingPromotionTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    itemsSubtotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    taxTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns sum of neutral and non neutral tax adjustments on order and total tax of order items.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    shippingTaxTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    taxIncludedTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    shippingTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns shipping fee together with taxes decreased by shipping discount.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Orderjsonldsyliusshopcartshow' });
export type Orderjsonldsyliusshopcartshow = Schema.Schema.Type<
  typeof Orderjsonldsyliusshopcartshow
>;
export type OrderjsonldsyliusshopcartshowEncoded = Schema.Codec.Encoded<
  typeof Orderjsonldsyliusshopcartshow
>;

/* ChannelPricing */

export const ChannelPricing = Schema.StructWithRest(
  Schema.Struct({
    marginPercent: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        description:
          'DB-generated column (STORED): ((price - minimum_price) * -100.0 / price), NULL when\nprice/minimum_price is NULL or 0. Stored negated; getMarginPercent() flips the sign.',
        readOnly: true,
      })
    ),
    recycleFee: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({ description: 'Recycling contribution fee in minor units (null = no fee).' }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    channelCode: Schema.String,
    productVariant: Schema.suspend((): Schema.Codec<ProductVariant> => ProductVariant),
    price: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    originalPrice: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    minimumPrice: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    lowestPriceBeforeDiscount: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    appliedPromotions: Schema.Array(CatalogPromotion),
    appliedPromotionsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    priceReduced: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    exclusiveCatalogPromotionApplied: Schema.optionalKey(
      Schema.Boolean.annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ChannelPricing' });
export type ChannelPricing = Schema.Schema.Type<typeof ChannelPricing>;
export type ChannelPricingEncoded = Schema.Codec.Encoded<typeof ChannelPricing>;

/* ChannelPricingjsonld */

export const ChannelPricingjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    marginPercent: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        description:
          'DB-generated column (STORED): ((price - minimum_price) * -100.0 / price), NULL when\nprice/minimum_price is NULL or 0. Stored negated; getMarginPercent() flips the sign.',
        readOnly: true,
      })
    ),
    recycleFee: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({ description: 'Recycling contribution fee in minor units (null = no fee).' }),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    channelCode: Schema.String,
    productVariant: Schema.suspend((): Schema.Codec<ProductVariantjsonld> => ProductVariantjsonld),
    price: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    originalPrice: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    minimumPrice: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    lowestPriceBeforeDiscount: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    appliedPromotions: Schema.Array(CatalogPromotionjsonld),
    appliedPromotionsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    priceReduced: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    exclusiveCatalogPromotionApplied: Schema.optionalKey(
      Schema.Boolean.annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ChannelPricingjsonld' });
export type ChannelPricingjsonld = Schema.Schema.Type<typeof ChannelPricingjsonld>;
export type ChannelPricingjsonldEncoded = Schema.Codec.Encoded<typeof ChannelPricingjsonld>;

/* Channelsyliusadminchannelcreate */

export const Channelsyliusadminchannelcreate = Schema.StructWithRest(
  Schema.Struct({
    baseCurrency: Schema.String.annotate({ format: 'iri-reference' }),
    defaultLocale: Schema.String.annotate({ format: 'iri-reference' }),
    defaultTaxZone: Schema.Union([
      Schema.String.annotate({ format: 'iri-reference' }),
      Schema.Null,
    ]),
    taxCalculationStrategy: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ),
    currencies: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    locales: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    countries: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    themeName: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    contactEmail: Schema.Union([
      Schema.String.check(
        Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
      ).check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]).annotate({ format: 'email' }),
    contactPhoneNumber: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    skippingShippingStepAllowed: Schema.Boolean.annotate({ default: false }),
    skippingPaymentStepAllowed: Schema.Boolean.annotate({ default: false }),
    accountVerificationRequired: Schema.Boolean.annotate({ default: true }),
    shippingAddressInCheckoutRequired: Schema.Boolean.annotate({ default: false }),
    shopBillingData: Schema.Union([ShopBillingDatasyliusadminchannelcreatenoid, Schema.Null]),
    menuTaxon: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    channelPriceHistoryConfig: Schema.Union([
      ChannelPriceHistoryConfigsyliusadminchannelcreatenoid,
      Schema.Null,
    ]),
    code: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ).check(
      Schema.isPattern(new RegExp('^([\\w-]*)$')).annotate({
        expected: 'a string matching the RegExp ^([\\w-]*)$',
      })
    ),
    name: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ),
    description: Schema.Union([Schema.String, Schema.Null]),
    hostname: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    color: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    enabled: Schema.Boolean.annotate({ default: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Channelsyliusadminchannelcreate' });
export type Channelsyliusadminchannelcreate = Schema.Schema.Type<
  typeof Channelsyliusadminchannelcreate
>;
export type ChannelsyliusadminchannelcreateEncoded = Schema.Codec.Encoded<
  typeof Channelsyliusadminchannelcreate
>;

/* Channelsyliusadminchannelindex */

export const Channelsyliusadminchannelindex = Schema.StructWithRest(
  Schema.Struct({
    baseCurrency: Schema.String.annotate({ format: 'iri-reference' }),
    defaultLocale: Schema.String.annotate({ format: 'iri-reference' }),
    defaultTaxZone: Schema.Union([
      Schema.String.annotate({ format: 'iri-reference' }),
      Schema.Null,
    ]),
    taxCalculationStrategy: Schema.String,
    currencies: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    locales: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    countries: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    themeName: Schema.Union([Schema.String, Schema.Null]),
    contactEmail: Schema.Union([Schema.String, Schema.Null]),
    contactPhoneNumber: Schema.Union([Schema.String, Schema.Null]),
    skippingShippingStepAllowed: Schema.Boolean.annotate({ default: false }),
    skippingPaymentStepAllowed: Schema.Boolean.annotate({ default: false }),
    accountVerificationRequired: Schema.Boolean.annotate({ default: true }),
    shippingAddressInCheckoutRequired: Schema.Boolean.annotate({ default: false }),
    shopBillingData: Schema.Union([ShopBillingDatasyliusadminchannelindexnoid, Schema.Null]),
    menuTaxon: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    channelPriceHistoryConfig: Schema.Union([
      ChannelPriceHistoryConfigsyliusadminchannelindexnoid,
      Schema.Null,
    ]),
    code: Schema.String,
    name: Schema.String,
    description: Schema.Union([Schema.String, Schema.Null]),
    hostname: Schema.Union([Schema.String, Schema.Null]),
    color: Schema.Union([Schema.String, Schema.Null]),
    enabled: Schema.Boolean.annotate({ default: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Channelsyliusadminchannelindex' });
export type Channelsyliusadminchannelindex = Schema.Schema.Type<
  typeof Channelsyliusadminchannelindex
>;
export type ChannelsyliusadminchannelindexEncoded = Schema.Codec.Encoded<
  typeof Channelsyliusadminchannelindex
>;

/* Channelsyliusadminchannelshow */

export const Channelsyliusadminchannelshow = Schema.StructWithRest(
  Schema.Struct({
    baseCurrency: Schema.String.annotate({ format: 'iri-reference' }),
    defaultLocale: Schema.String.annotate({ format: 'iri-reference' }),
    defaultTaxZone: Schema.Union([
      Schema.String.annotate({ format: 'iri-reference' }),
      Schema.Null,
    ]),
    taxCalculationStrategy: Schema.String,
    currencies: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    locales: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    countries: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    themeName: Schema.Union([Schema.String, Schema.Null]),
    contactEmail: Schema.Union([Schema.String, Schema.Null]),
    contactPhoneNumber: Schema.Union([Schema.String, Schema.Null]),
    skippingShippingStepAllowed: Schema.Boolean.annotate({ default: false }),
    skippingPaymentStepAllowed: Schema.Boolean.annotate({ default: false }),
    accountVerificationRequired: Schema.Boolean.annotate({ default: true }),
    shippingAddressInCheckoutRequired: Schema.Boolean.annotate({ default: false }),
    shopBillingData: Schema.Union([ShopBillingDatasyliusadminchannelshownoid, Schema.Null]),
    menuTaxon: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    channelPriceHistoryConfig: Schema.Union([
      ChannelPriceHistoryConfigsyliusadminchannelshownoid,
      Schema.Null,
    ]),
    code: Schema.String,
    name: Schema.String,
    description: Schema.Union([Schema.String, Schema.Null]),
    hostname: Schema.Union([Schema.String, Schema.Null]),
    color: Schema.Union([Schema.String, Schema.Null]),
    enabled: Schema.Boolean.annotate({ default: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Channelsyliusadminchannelshow' });
export type Channelsyliusadminchannelshow = Schema.Schema.Type<
  typeof Channelsyliusadminchannelshow
>;
export type ChannelsyliusadminchannelshowEncoded = Schema.Codec.Encoded<
  typeof Channelsyliusadminchannelshow
>;

/* Channelsyliusadminchannelupdate */

export const Channelsyliusadminchannelupdate = Schema.StructWithRest(
  Schema.Struct({
    defaultLocale: Schema.String.annotate({ format: 'iri-reference' }),
    defaultTaxZone: Schema.Union([
      Schema.String.annotate({ format: 'iri-reference' }),
      Schema.Null,
    ]),
    taxCalculationStrategy: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ),
    currencies: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    locales: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    countries: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    themeName: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    contactEmail: Schema.Union([
      Schema.String.check(
        Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
      ).check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]).annotate({ format: 'email' }),
    contactPhoneNumber: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    skippingShippingStepAllowed: Schema.Boolean.annotate({ default: false }),
    skippingPaymentStepAllowed: Schema.Boolean.annotate({ default: false }),
    accountVerificationRequired: Schema.Boolean.annotate({ default: true }),
    shippingAddressInCheckoutRequired: Schema.Boolean.annotate({ default: false }),
    shopBillingData: Schema.Union([ShopBillingDatasyliusadminchannelupdatenoid, Schema.Null]),
    menuTaxon: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    channelPriceHistoryConfig: Schema.Union([
      ChannelPriceHistoryConfigsyliusadminchannelupdatenoid,
      Schema.Null,
    ]),
    name: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ),
    description: Schema.Union([Schema.String, Schema.Null]),
    hostname: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    color: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    enabled: Schema.Boolean.annotate({ default: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Channelsyliusadminchannelupdate' });
export type Channelsyliusadminchannelupdate = Schema.Schema.Type<
  typeof Channelsyliusadminchannelupdate
>;
export type ChannelsyliusadminchannelupdateEncoded = Schema.Codec.Encoded<
  typeof Channelsyliusadminchannelupdate
>;

/* Channeljsonldsyliusadminchannelcreate */

export const Channeljsonldsyliusadminchannelcreate = Schema.StructWithRest(
  Schema.Struct({
    baseCurrency: Schema.String.annotate({ format: 'iri-reference' }),
    defaultLocale: Schema.String.annotate({ format: 'iri-reference' }),
    defaultTaxZone: Schema.Union([
      Schema.String.annotate({ format: 'iri-reference' }),
      Schema.Null,
    ]),
    taxCalculationStrategy: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ),
    currencies: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    locales: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    countries: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    themeName: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    contactEmail: Schema.Union([
      Schema.String.check(
        Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
      ).check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]).annotate({ format: 'email' }),
    contactPhoneNumber: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    skippingShippingStepAllowed: Schema.Boolean.annotate({ default: false }),
    skippingPaymentStepAllowed: Schema.Boolean.annotate({ default: false }),
    accountVerificationRequired: Schema.Boolean.annotate({ default: true }),
    shippingAddressInCheckoutRequired: Schema.Boolean.annotate({ default: false }),
    shopBillingData: Schema.Union([ShopBillingDatajsonldsyliusadminchannelcreatenoid, Schema.Null]),
    menuTaxon: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    channelPriceHistoryConfig: Schema.Union([
      ChannelPriceHistoryConfigjsonldsyliusadminchannelcreatenoid,
      Schema.Null,
    ]),
    code: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ).check(
      Schema.isPattern(new RegExp('^([\\w-]*)$')).annotate({
        expected: 'a string matching the RegExp ^([\\w-]*)$',
      })
    ),
    name: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ),
    description: Schema.Union([Schema.String, Schema.Null]),
    hostname: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    color: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    enabled: Schema.Boolean.annotate({ default: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Channeljsonldsyliusadminchannelcreate' });
export type Channeljsonldsyliusadminchannelcreate = Schema.Schema.Type<
  typeof Channeljsonldsyliusadminchannelcreate
>;
export type ChanneljsonldsyliusadminchannelcreateEncoded = Schema.Codec.Encoded<
  typeof Channeljsonldsyliusadminchannelcreate
>;

/* Channeljsonldsyliusadminchannelindex */

export const Channeljsonldsyliusadminchannelindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    baseCurrency: Schema.String.annotate({ format: 'iri-reference' }),
    defaultLocale: Schema.String.annotate({ format: 'iri-reference' }),
    defaultTaxZone: Schema.Union([
      Schema.String.annotate({ format: 'iri-reference' }),
      Schema.Null,
    ]),
    taxCalculationStrategy: Schema.String,
    currencies: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    locales: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    countries: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    themeName: Schema.Union([Schema.String, Schema.Null]),
    contactEmail: Schema.Union([Schema.String, Schema.Null]),
    contactPhoneNumber: Schema.Union([Schema.String, Schema.Null]),
    skippingShippingStepAllowed: Schema.Boolean.annotate({ default: false }),
    skippingPaymentStepAllowed: Schema.Boolean.annotate({ default: false }),
    accountVerificationRequired: Schema.Boolean.annotate({ default: true }),
    shippingAddressInCheckoutRequired: Schema.Boolean.annotate({ default: false }),
    shopBillingData: Schema.Union([ShopBillingDatajsonldsyliusadminchannelindexnoid, Schema.Null]),
    menuTaxon: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    channelPriceHistoryConfig: Schema.Union([
      ChannelPriceHistoryConfigjsonldsyliusadminchannelindexnoid,
      Schema.Null,
    ]),
    code: Schema.String,
    name: Schema.String,
    description: Schema.Union([Schema.String, Schema.Null]),
    hostname: Schema.Union([Schema.String, Schema.Null]),
    color: Schema.Union([Schema.String, Schema.Null]),
    enabled: Schema.Boolean.annotate({ default: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Channeljsonldsyliusadminchannelindex' });
export type Channeljsonldsyliusadminchannelindex = Schema.Schema.Type<
  typeof Channeljsonldsyliusadminchannelindex
>;
export type ChanneljsonldsyliusadminchannelindexEncoded = Schema.Codec.Encoded<
  typeof Channeljsonldsyliusadminchannelindex
>;

/* Channeljsonldsyliusadminchannelshow */

export const Channeljsonldsyliusadminchannelshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    baseCurrency: Schema.String.annotate({ format: 'iri-reference' }),
    defaultLocale: Schema.String.annotate({ format: 'iri-reference' }),
    defaultTaxZone: Schema.Union([
      Schema.String.annotate({ format: 'iri-reference' }),
      Schema.Null,
    ]),
    taxCalculationStrategy: Schema.String,
    currencies: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    locales: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    countries: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    themeName: Schema.Union([Schema.String, Schema.Null]),
    contactEmail: Schema.Union([Schema.String, Schema.Null]),
    contactPhoneNumber: Schema.Union([Schema.String, Schema.Null]),
    skippingShippingStepAllowed: Schema.Boolean.annotate({ default: false }),
    skippingPaymentStepAllowed: Schema.Boolean.annotate({ default: false }),
    accountVerificationRequired: Schema.Boolean.annotate({ default: true }),
    shippingAddressInCheckoutRequired: Schema.Boolean.annotate({ default: false }),
    shopBillingData: Schema.Union([ShopBillingDatajsonldsyliusadminchannelshownoid, Schema.Null]),
    menuTaxon: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    channelPriceHistoryConfig: Schema.Union([
      ChannelPriceHistoryConfigjsonldsyliusadminchannelshownoid,
      Schema.Null,
    ]),
    code: Schema.String,
    name: Schema.String,
    description: Schema.Union([Schema.String, Schema.Null]),
    hostname: Schema.Union([Schema.String, Schema.Null]),
    color: Schema.Union([Schema.String, Schema.Null]),
    enabled: Schema.Boolean.annotate({ default: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Channeljsonldsyliusadminchannelshow' });
export type Channeljsonldsyliusadminchannelshow = Schema.Schema.Type<
  typeof Channeljsonldsyliusadminchannelshow
>;
export type ChanneljsonldsyliusadminchannelshowEncoded = Schema.Codec.Encoded<
  typeof Channeljsonldsyliusadminchannelshow
>;

/* Channeljsonldsyliusadminchannelupdate */

export const Channeljsonldsyliusadminchannelupdate = Schema.StructWithRest(
  Schema.Struct({
    defaultLocale: Schema.String.annotate({ format: 'iri-reference' }),
    defaultTaxZone: Schema.Union([
      Schema.String.annotate({ format: 'iri-reference' }),
      Schema.Null,
    ]),
    taxCalculationStrategy: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ),
    currencies: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    locales: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    countries: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    themeName: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    contactEmail: Schema.Union([
      Schema.String.check(
        Schema.isMinLength(2).annotate({ expected: 'a value with a length of at least 2' })
      ).check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]).annotate({ format: 'email' }),
    contactPhoneNumber: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    skippingShippingStepAllowed: Schema.Boolean.annotate({ default: false }),
    skippingPaymentStepAllowed: Schema.Boolean.annotate({ default: false }),
    accountVerificationRequired: Schema.Boolean.annotate({ default: true }),
    shippingAddressInCheckoutRequired: Schema.Boolean.annotate({ default: false }),
    shopBillingData: Schema.Union([ShopBillingDatajsonldsyliusadminchannelupdatenoid, Schema.Null]),
    menuTaxon: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    channelPriceHistoryConfig: Schema.Union([
      ChannelPriceHistoryConfigjsonldsyliusadminchannelupdatenoid,
      Schema.Null,
    ]),
    name: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ),
    description: Schema.Union([Schema.String, Schema.Null]),
    hostname: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    color: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    enabled: Schema.Boolean.annotate({ default: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Channeljsonldsyliusadminchannelupdate' });
export type Channeljsonldsyliusadminchannelupdate = Schema.Schema.Type<
  typeof Channeljsonldsyliusadminchannelupdate
>;
export type ChanneljsonldsyliusadminchannelupdateEncoded = Schema.Codec.Encoded<
  typeof Channeljsonldsyliusadminchannelupdate
>;

/* TeamElementDTOsyliusshopglossaryshow */

export const TeamElementDTOsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    teamMember: Schema.Array(TeamMemberItemDTOsyliusshopglossaryshow),
    type: Schema.Literal('team').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TeamElementDTOsyliusshopglossaryshow' });
export type TeamElementDTOsyliusshopglossaryshow = Schema.Schema.Type<
  typeof TeamElementDTOsyliusshopglossaryshow
>;
export type TeamElementDTOsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof TeamElementDTOsyliusshopglossaryshow
>;

/* ButtonGridElementDTOsyliusshopglossaryshow */

export const ButtonGridElementDTOsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    buttons: Schema.Array(ButtonGridItemDTOsyliusshopglossaryshow),
    type: Schema.Literal('button_grid').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ButtonGridElementDTOsyliusshopglossaryshow' });
export type ButtonGridElementDTOsyliusshopglossaryshow = Schema.Schema.Type<
  typeof ButtonGridElementDTOsyliusshopglossaryshow
>;
export type ButtonGridElementDTOsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof ButtonGridElementDTOsyliusshopglossaryshow
>;

/* TableElementDTOsyliusshopglossaryshow */

export const TableElementDTOsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    style: Schema.Literals(['full_width', 'fit_content']),
    rows: Schema.Array(TableRowItemDTOsyliusshopglossaryshow),
    type: Schema.Literal('table').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TableElementDTOsyliusshopglossaryshow' });
export type TableElementDTOsyliusshopglossaryshow = Schema.Schema.Type<
  typeof TableElementDTOsyliusshopglossaryshow
>;
export type TableElementDTOsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof TableElementDTOsyliusshopglossaryshow
>;

/* TeamElementDTOjsonldsyliusshopglossaryshow */

export const TeamElementDTOjsonldsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    teamMember: Schema.Array(TeamMemberItemDTOjsonldsyliusshopglossaryshow),
    type: Schema.Literal('team').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TeamElementDTOjsonldsyliusshopglossaryshow' });
export type TeamElementDTOjsonldsyliusshopglossaryshow = Schema.Schema.Type<
  typeof TeamElementDTOjsonldsyliusshopglossaryshow
>;
export type TeamElementDTOjsonldsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof TeamElementDTOjsonldsyliusshopglossaryshow
>;

/* ButtonGridElementDTOjsonldsyliusshopglossaryshow */

export const ButtonGridElementDTOjsonldsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    buttons: Schema.Array(ButtonGridItemDTOjsonldsyliusshopglossaryshow),
    type: Schema.Literal('button_grid').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ButtonGridElementDTOjsonldsyliusshopglossaryshow' });
export type ButtonGridElementDTOjsonldsyliusshopglossaryshow = Schema.Schema.Type<
  typeof ButtonGridElementDTOjsonldsyliusshopglossaryshow
>;
export type ButtonGridElementDTOjsonldsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof ButtonGridElementDTOjsonldsyliusshopglossaryshow
>;

/* TableElementDTOjsonldsyliusshopglossaryshow */

export const TableElementDTOjsonldsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    style: Schema.Literals(['full_width', 'fit_content']),
    rows: Schema.Array(TableRowItemDTOjsonldsyliusshopglossaryshow),
    type: Schema.Literal('table').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TableElementDTOjsonldsyliusshopglossaryshow' });
export type TableElementDTOjsonldsyliusshopglossaryshow = Schema.Schema.Type<
  typeof TableElementDTOjsonldsyliusshopglossaryshow
>;
export type TableElementDTOjsonldsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof TableElementDTOjsonldsyliusshopglossaryshow
>;

/* ProductVariantsyliusshopcartshowsyliusshopcartshowdetail */

export const ProductVariantsyliusshopcartshowsyliusshopcartshowdetail = Schema.StructWithRest(
  Schema.Struct({
    tracked: Schema.Boolean.annotate({ default: false }),
    code: Schema.String,
    product: Productsyliusshopcartshowsyliusshopcartshowdetail,
    available: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    maxOrderable: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    inStock: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    price: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    priceWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    originalPrice: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    lowestPriceBeforeDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ default: null, readOnly: true })
    ),
    productQuantity: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductVariantsyliusshopcartshowsyliusshopcartshowdetail' });
export type ProductVariantsyliusshopcartshowsyliusshopcartshowdetail = Schema.Schema.Type<
  typeof ProductVariantsyliusshopcartshowsyliusshopcartshowdetail
>;
export type ProductVariantsyliusshopcartshowsyliusshopcartshowdetailEncoded = Schema.Codec.Encoded<
  typeof ProductVariantsyliusshopcartshowsyliusshopcartshowdetail
>;

/* ProductVariantsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const ProductVariantsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      tracked: Schema.Boolean.annotate({ default: false }),
      code: Schema.String,
      product: Productsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
      available: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
      maxOrderable: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({ readOnly: true })
      ),
      inStock: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
      price: Schema.optionalKey(
        Schema.Number.annotate({ default: 0, readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      priceWithoutTax: Schema.optionalKey(
        Schema.Number.annotate({ default: 0, readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      originalPrice: Schema.optionalKey(
        Schema.Number.annotate({ default: 0, readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      lowestPriceBeforeDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({ default: null, readOnly: true })
      ),
      productQuantity: Schema.optionalKey(
        Schema.Number.annotate({ default: 0, readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier: 'ProductVariantsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type ProductVariantsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof ProductVariantsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type ProductVariantsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof ProductVariantsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* ProductVariantsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const ProductVariantsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      tracked: Schema.Boolean.annotate({ default: false }),
      code: Schema.String,
      product:
        Productsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
      available: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
      maxOrderable: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({ readOnly: true })
      ),
      inStock: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
      price: Schema.optionalKey(
        Schema.Number.annotate({ default: 0, readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      priceWithoutTax: Schema.optionalKey(
        Schema.Number.annotate({ default: 0, readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      originalPrice: Schema.optionalKey(
        Schema.Number.annotate({ default: 0, readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      lowestPriceBeforeDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({ default: null, readOnly: true })
      ),
      productQuantity: Schema.optionalKey(
        Schema.Number.annotate({ default: 0, readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'ProductVariantsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type ProductVariantsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof ProductVariantsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type ProductVariantsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof ProductVariantsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* ProductVariantsyliusshoporderindex */

export const ProductVariantsyliusshoporderindex = Schema.StructWithRest(
  Schema.Struct({ code: Schema.String, product: Productsyliusshoporderindex }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductVariantsyliusshoporderindex' });
export type ProductVariantsyliusshoporderindex = Schema.Schema.Type<
  typeof ProductVariantsyliusshoporderindex
>;
export type ProductVariantsyliusshoporderindexEncoded = Schema.Codec.Encoded<
  typeof ProductVariantsyliusshoporderindex
>;

/* ProductVariantjsonldsyliusshopcartshowsyliusshopcartshowdetail */

export const ProductVariantjsonldsyliusshopcartshowsyliusshopcartshowdetail = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    tracked: Schema.Boolean.annotate({ default: false }),
    code: Schema.String,
    product: Productjsonldsyliusshopcartshowsyliusshopcartshowdetail,
    available: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    maxOrderable: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    inStock: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    price: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    priceWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    originalPrice: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    lowestPriceBeforeDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ default: null, readOnly: true })
    ),
    productQuantity: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductVariantjsonldsyliusshopcartshowsyliusshopcartshowdetail' });
export type ProductVariantjsonldsyliusshopcartshowsyliusshopcartshowdetail = Schema.Schema.Type<
  typeof ProductVariantjsonldsyliusshopcartshowsyliusshopcartshowdetail
>;
export type ProductVariantjsonldsyliusshopcartshowsyliusshopcartshowdetailEncoded =
  Schema.Codec.Encoded<typeof ProductVariantjsonldsyliusshopcartshowsyliusshopcartshowdetail>;

/* ProductVariantjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const ProductVariantjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      tracked: Schema.Boolean.annotate({ default: false }),
      code: Schema.String,
      product: Productjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
      available: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
      maxOrderable: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({ readOnly: true })
      ),
      inStock: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
      price: Schema.optionalKey(
        Schema.Number.annotate({ default: 0, readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      priceWithoutTax: Schema.optionalKey(
        Schema.Number.annotate({ default: 0, readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      originalPrice: Schema.optionalKey(
        Schema.Number.annotate({ default: 0, readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      lowestPriceBeforeDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({ default: null, readOnly: true })
      ),
      productQuantity: Schema.optionalKey(
        Schema.Number.annotate({ default: 0, readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'ProductVariantjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type ProductVariantjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof ProductVariantjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type ProductVariantjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof ProductVariantjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* ProductVariantjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const ProductVariantjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      tracked: Schema.Boolean.annotate({ default: false }),
      code: Schema.String,
      product:
        Productjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
      available: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
      maxOrderable: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({ readOnly: true })
      ),
      inStock: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
      price: Schema.optionalKey(
        Schema.Number.annotate({ default: 0, readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      priceWithoutTax: Schema.optionalKey(
        Schema.Number.annotate({ default: 0, readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      originalPrice: Schema.optionalKey(
        Schema.Number.annotate({ default: 0, readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      lowestPriceBeforeDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({ default: null, readOnly: true })
      ),
      productQuantity: Schema.optionalKey(
        Schema.Number.annotate({ default: 0, readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'ProductVariantjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type ProductVariantjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof ProductVariantjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type ProductVariantjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof ProductVariantjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* ProductVariantjsonldsyliusshoporderindex */

export const ProductVariantjsonldsyliusshoporderindex = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String,
    product: Productjsonldsyliusshoporderindex,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductVariantjsonldsyliusshoporderindex' });
export type ProductVariantjsonldsyliusshoporderindex = Schema.Schema.Type<
  typeof ProductVariantjsonldsyliusshoporderindex
>;
export type ProductVariantjsonldsyliusshoporderindexEncoded = Schema.Codec.Encoded<
  typeof ProductVariantjsonldsyliusshoporderindex
>;

/* ProductElementDTOsyliusshoppageshow */

export const ProductElementDTOsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    productCode: Schema.String,
    product: Schema.Union([Productsyliusshoppageshow, Schema.Null]),
    type: Schema.Literal('product').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductElementDTOsyliusshoppageshow' });
export type ProductElementDTOsyliusshoppageshow = Schema.Schema.Type<
  typeof ProductElementDTOsyliusshoppageshow
>;
export type ProductElementDTOsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof ProductElementDTOsyliusshoppageshow
>;

/* AddToCartButtonElementDTOsyliusshoppageshow */

export const AddToCartButtonElementDTOsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    productCode: Schema.String,
    text: Schema.String,
    product: Schema.Union([Productsyliusshoppageshow, Schema.Null]),
    type: Schema.Literal('button_add_to_cart').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'AddToCartButtonElementDTOsyliusshoppageshow' });
export type AddToCartButtonElementDTOsyliusshoppageshow = Schema.Schema.Type<
  typeof AddToCartButtonElementDTOsyliusshoppageshow
>;
export type AddToCartButtonElementDTOsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof AddToCartButtonElementDTOsyliusshoppageshow
>;

/* TeamElementDTOsyliusshoppageshow */

export const TeamElementDTOsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    teamMember: Schema.Array(TeamMemberItemDTOsyliusshoppageshow),
    type: Schema.Literal('team').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TeamElementDTOsyliusshoppageshow' });
export type TeamElementDTOsyliusshoppageshow = Schema.Schema.Type<
  typeof TeamElementDTOsyliusshoppageshow
>;
export type TeamElementDTOsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof TeamElementDTOsyliusshoppageshow
>;

/* ButtonGridElementDTOsyliusshoppageshow */

export const ButtonGridElementDTOsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    buttons: Schema.Array(ButtonGridItemDTOsyliusshoppageshow),
    type: Schema.Literal('button_grid').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ButtonGridElementDTOsyliusshoppageshow' });
export type ButtonGridElementDTOsyliusshoppageshow = Schema.Schema.Type<
  typeof ButtonGridElementDTOsyliusshoppageshow
>;
export type ButtonGridElementDTOsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof ButtonGridElementDTOsyliusshoppageshow
>;

/* TableElementDTOsyliusshoppageshow */

export const TableElementDTOsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    style: Schema.Literals(['full_width', 'fit_content']),
    rows: Schema.Array(TableRowItemDTOsyliusshoppageshow),
    type: Schema.Literal('table').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TableElementDTOsyliusshoppageshow' });
export type TableElementDTOsyliusshoppageshow = Schema.Schema.Type<
  typeof TableElementDTOsyliusshoppageshow
>;
export type TableElementDTOsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof TableElementDTOsyliusshoppageshow
>;

/* ProductElementDTOjsonldsyliusshoppageshow */

export const ProductElementDTOjsonldsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    productCode: Schema.String,
    product: Schema.Union([Productjsonldsyliusshoppageshow, Schema.Null]),
    type: Schema.Literal('product').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductElementDTOjsonldsyliusshoppageshow' });
export type ProductElementDTOjsonldsyliusshoppageshow = Schema.Schema.Type<
  typeof ProductElementDTOjsonldsyliusshoppageshow
>;
export type ProductElementDTOjsonldsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof ProductElementDTOjsonldsyliusshoppageshow
>;

/* AddToCartButtonElementDTOjsonldsyliusshoppageshow */

export const AddToCartButtonElementDTOjsonldsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    productCode: Schema.String,
    text: Schema.String,
    product: Schema.Union([Productjsonldsyliusshoppageshow, Schema.Null]),
    type: Schema.Literal('button_add_to_cart').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'AddToCartButtonElementDTOjsonldsyliusshoppageshow' });
export type AddToCartButtonElementDTOjsonldsyliusshoppageshow = Schema.Schema.Type<
  typeof AddToCartButtonElementDTOjsonldsyliusshoppageshow
>;
export type AddToCartButtonElementDTOjsonldsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof AddToCartButtonElementDTOjsonldsyliusshoppageshow
>;

/* TeamElementDTOjsonldsyliusshoppageshow */

export const TeamElementDTOjsonldsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    teamMember: Schema.Array(TeamMemberItemDTOjsonldsyliusshoppageshow),
    type: Schema.Literal('team').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TeamElementDTOjsonldsyliusshoppageshow' });
export type TeamElementDTOjsonldsyliusshoppageshow = Schema.Schema.Type<
  typeof TeamElementDTOjsonldsyliusshoppageshow
>;
export type TeamElementDTOjsonldsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof TeamElementDTOjsonldsyliusshoppageshow
>;

/* ButtonGridElementDTOjsonldsyliusshoppageshow */

export const ButtonGridElementDTOjsonldsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    buttons: Schema.Array(ButtonGridItemDTOjsonldsyliusshoppageshow),
    type: Schema.Literal('button_grid').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ButtonGridElementDTOjsonldsyliusshoppageshow' });
export type ButtonGridElementDTOjsonldsyliusshoppageshow = Schema.Schema.Type<
  typeof ButtonGridElementDTOjsonldsyliusshoppageshow
>;
export type ButtonGridElementDTOjsonldsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof ButtonGridElementDTOjsonldsyliusshoppageshow
>;

/* TableElementDTOjsonldsyliusshoppageshow */

export const TableElementDTOjsonldsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    style: Schema.Literals(['full_width', 'fit_content']),
    rows: Schema.Array(TableRowItemDTOjsonldsyliusshoppageshow),
    type: Schema.Literal('table').annotate({ readOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TableElementDTOjsonldsyliusshoppageshow' });
export type TableElementDTOjsonldsyliusshoppageshow = Schema.Schema.Type<
  typeof TableElementDTOjsonldsyliusshoppageshow
>;
export type TableElementDTOjsonldsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof TableElementDTOjsonldsyliusshoppageshow
>;

/* AutomaticAccessoryItem */

export const AutomaticAccessoryItem = Schema.StructWithRest(
  Schema.Struct({
    label: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    quantity: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    product: Schema.optionalKey(Productsyliusshopproductindexbase),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'AutomaticAccessoryItem' });
export type AutomaticAccessoryItem = Schema.Schema.Type<typeof AutomaticAccessoryItem>;
export type AutomaticAccessoryItemEncoded = Schema.Codec.Encoded<typeof AutomaticAccessoryItem>;

/* AutomaticAccessoryItemjsonld */

export const AutomaticAccessoryItemjsonld = Schema.StructWithRest(
  Schema.Struct({
    label: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    quantity: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    product: Schema.optionalKey(Productjsonldsyliusshopproductindexbase),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'AutomaticAccessoryItemjsonld' });
export type AutomaticAccessoryItemjsonld = Schema.Schema.Type<typeof AutomaticAccessoryItemjsonld>;
export type AutomaticAccessoryItemjsonldEncoded = Schema.Codec.Encoded<
  typeof AutomaticAccessoryItemjsonld
>;

/* SearchFacets */

export const SearchFacets = Schema.StructWithRest(
  Schema.Struct({
    totalItems: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    brands: Schema.Array(SearchFacetBrandBucket).annotate({ description: 'Brand buckets.' }),
    taxons: Schema.Array(SearchFacetTaxonBucket).annotate({
      description: 'Category buckets (leaf taxons).',
    }),
    price: Schema.Union([
      Schema.Record(
        Schema.String,
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      Schema.Null,
    ]).annotate({ description: 'channel-scoped price range; null when no `channel=` was given' }),
    inStockCount: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    attributes: Schema.Array(SearchAttributeFacet).annotate({
      description:
        "Attribute facets. With disjunctive faceting, the values of an attribute the customer filtered on reflect the result set without that attribute's own filter.",
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'SearchFacets' });
export type SearchFacets = Schema.Schema.Type<typeof SearchFacets>;
export type SearchFacetsEncoded = Schema.Codec.Encoded<typeof SearchFacets>;

/* SearchFacetsjsonld */

export const SearchFacetsjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    totalItems: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    brands: Schema.Array(SearchFacetBrandBucket).annotate({ description: 'Brand buckets.' }),
    taxons: Schema.Array(SearchFacetTaxonBucket).annotate({
      description: 'Category buckets (leaf taxons).',
    }),
    price: Schema.Union([
      Schema.Record(
        Schema.String,
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      Schema.Null,
    ]).annotate({ description: 'channel-scoped price range; null when no `channel=` was given' }),
    inStockCount: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    attributes: Schema.Array(SearchAttributeFacet).annotate({
      description:
        "Attribute facets. With disjunctive faceting, the values of an attribute the customer filtered on reflect the result set without that attribute's own filter.",
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'SearchFacetsjsonld' });
export type SearchFacetsjsonld = Schema.Schema.Type<typeof SearchFacetsjsonld>;
export type SearchFacetsjsonldEncoded = Schema.Codec.Encoded<typeof SearchFacetsjsonld>;

/* ShippingOptionsshopshippingAndPaymentOptionsindex */

export const ShippingOptionsshopshippingAndPaymentOptionsindex = Schema.StructWithRest(
  Schema.Struct({
    shippingMethod: ShippingMethodshopshippingAndPaymentOptionsindex,
    priceExVat: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    priceIncVat: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    priceVat: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    currency: CurrencyshopshippingAndPaymentOptionsindex,
    payments: Schema.Array(PaymentOptionsyliusshopshippingandpaymentoptionsindex),
    countryCodes: Schema.Array(Schema.String),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingOptionsshopshippingAndPaymentOptionsindex' });
export type ShippingOptionsshopshippingAndPaymentOptionsindex = Schema.Schema.Type<
  typeof ShippingOptionsshopshippingAndPaymentOptionsindex
>;
export type ShippingOptionsshopshippingAndPaymentOptionsindexEncoded = Schema.Codec.Encoded<
  typeof ShippingOptionsshopshippingAndPaymentOptionsindex
>;

/* ShippingOptionsjsonldshopshippingAndPaymentOptionsindex */

export const ShippingOptionsjsonldshopshippingAndPaymentOptionsindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    shippingMethod: ShippingMethodjsonldshopshippingAndPaymentOptionsindex,
    priceExVat: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    priceIncVat: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    priceVat: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    currency: CurrencyjsonldshopshippingAndPaymentOptionsindex,
    payments: Schema.Array(PaymentOptionsyliusshopshippingandpaymentoptionsindex),
    countryCodes: Schema.Array(Schema.String),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingOptionsjsonldshopshippingAndPaymentOptionsindex' });
export type ShippingOptionsjsonldshopshippingAndPaymentOptionsindex = Schema.Schema.Type<
  typeof ShippingOptionsjsonldshopshippingAndPaymentOptionsindex
>;
export type ShippingOptionsjsonldshopshippingAndPaymentOptionsindexEncoded = Schema.Codec.Encoded<
  typeof ShippingOptionsjsonldshopshippingAndPaymentOptionsindex
>;

/* Productsyliusshopproductindex */

export const Productsyliusshopproductindex = Schema.StructWithRest(
  Schema.Struct({
    ageRestriction: Schema.Literals(['none', '18+']),
    averageRating: Schema.Number.annotate({ default: 0 }).check(
      Schema.isFinite().annotate({ expected: 'a finite number' })
    ),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    variants: Schema.Array(ProductVariantsyliusshopproductindex),
    createdAt: Schema.optionalKey(DateTimeSerializableFromString),
    updatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    mainImage: Schema.optionalKey(
      Schema.Union([ProductImagesyliusshopproductindex, Schema.Null]).annotate({ readOnly: true })
    ),
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    shortDescription: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    subtitle: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Productsyliusshopproductindex' });
export type Productsyliusshopproductindex = Schema.Schema.Type<
  typeof Productsyliusshopproductindex
>;
export type ProductsyliusshopproductindexEncoded = Schema.Codec.Encoded<
  typeof Productsyliusshopproductindex
>;

/* Productjsonldsyliusshopproductindex */

export const Productjsonldsyliusshopproductindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    ageRestriction: Schema.Literals(['none', '18+']),
    averageRating: Schema.Number.annotate({ default: 0 }).check(
      Schema.isFinite().annotate({ expected: 'a finite number' })
    ),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    variants: Schema.Array(ProductVariantjsonldsyliusshopproductindex),
    createdAt: Schema.optionalKey(DateTimeSerializableFromString),
    updatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    mainImage: Schema.optionalKey(
      Schema.Union([ProductImagejsonldsyliusshopproductindex, Schema.Null]).annotate({
        readOnly: true,
      })
    ),
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    shortDescription: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    subtitle: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Productjsonldsyliusshopproductindex' });
export type Productjsonldsyliusshopproductindex = Schema.Schema.Type<
  typeof Productjsonldsyliusshopproductindex
>;
export type ProductjsonldsyliusshopproductindexEncoded = Schema.Codec.Encoded<
  typeof Productjsonldsyliusshopproductindex
>;

/* Articlesyliusshoparticleshow */

export const Articlesyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    section: Sectionsyliusshoparticleshow,
    categories: Schema.Array(Categorysyliusshoparticleshow),
    image: Schema.Union([Schema.String, Schema.Null]),
    tags: Schema.Array(Tagsyliusshoparticleshow),
    publishedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    authors: Schema.Array(Authorsyliusshoparticleshow),
    imageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    thumbnailImageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    metaImageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    title: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    metaDescription: Schema.Union([Schema.String, Schema.Null]),
    metaKeywords: Schema.Union([Schema.String, Schema.Null]),
    metaImage: Schema.Union([Schema.String, Schema.Null]),
    content: Schema.Array(
      Schema.Union(
        [
          TitleElementDTOsyliusshoparticleshow,
          MarkdownTextElementDTOsyliusshoparticleshow,
          MarkdownPerexElementDTOsyliusshoparticleshow,
          QuoteElementDTOsyliusshoparticleshow,
          ImageElementDTOsyliusshoparticleshow,
          ImageCollectionElementDTOsyliusshoparticleshow,
          ProductElementDTOsyliusshoparticleshow,
          YoutubeElementDTOsyliusshoparticleshow,
          ImagePairElementDTOsyliusshoparticleshow,
          MarkdownTwoColumnsElementDTOsyliusshoparticleshow,
          MarkdownThreeColumnsElementDTOsyliusshoparticleshow,
          MarkdownTextWithImageElementDTOsyliusshoparticleshow,
          RetinoWidgetElementDTOsyliusshoparticleshow,
          AdvantagesElementDTOsyliusshoparticleshow,
          WhiteBoxElementDTOsyliusshoparticleshow,
          TeamElementDTOsyliusshoparticleshow,
          BaseButtonElementDTOsyliusshoparticleshow,
          AddToCartButtonElementDTOsyliusshoparticleshow,
          ButtonGridElementDTOsyliusshoparticleshow,
          ProductListElementDTOsyliusshoparticleshow,
          TableElementDTOsyliusshoparticleshow,
        ],
        { mode: 'oneOf' }
      )
    ),
    articles: Schema.optionalKey(
      Schema.Array(Articlesyliusshoparticleindexfavourite).annotate({ readOnly: true })
    ),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Articlesyliusshoparticleshow' });
export type Articlesyliusshoparticleshow = Schema.Schema.Type<typeof Articlesyliusshoparticleshow>;
export type ArticlesyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof Articlesyliusshoparticleshow
>;

/* Articlejsonldsyliusshoparticleshow */

export const Articlejsonldsyliusshoparticleshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    section: Sectionjsonldsyliusshoparticleshow,
    categories: Schema.Array(Categoryjsonldsyliusshoparticleshow),
    image: Schema.Union([Schema.String, Schema.Null]),
    tags: Schema.Array(Tagjsonldsyliusshoparticleshow),
    publishedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    authors: Schema.Array(Authorjsonldsyliusshoparticleshow),
    imageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    thumbnailImageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    metaImageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    title: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    metaDescription: Schema.Union([Schema.String, Schema.Null]),
    metaKeywords: Schema.Union([Schema.String, Schema.Null]),
    metaImage: Schema.Union([Schema.String, Schema.Null]),
    content: Schema.Array(
      Schema.Union(
        [
          TitleElementDTOjsonldsyliusshoparticleshow,
          MarkdownTextElementDTOjsonldsyliusshoparticleshow,
          MarkdownPerexElementDTOjsonldsyliusshoparticleshow,
          QuoteElementDTOjsonldsyliusshoparticleshow,
          ImageElementDTOjsonldsyliusshoparticleshow,
          ImageCollectionElementDTOjsonldsyliusshoparticleshow,
          ProductElementDTOjsonldsyliusshoparticleshow,
          YoutubeElementDTOjsonldsyliusshoparticleshow,
          ImagePairElementDTOjsonldsyliusshoparticleshow,
          MarkdownTwoColumnsElementDTOjsonldsyliusshoparticleshow,
          MarkdownThreeColumnsElementDTOjsonldsyliusshoparticleshow,
          MarkdownTextWithImageElementDTOjsonldsyliusshoparticleshow,
          RetinoWidgetElementDTOjsonldsyliusshoparticleshow,
          AdvantagesElementDTOjsonldsyliusshoparticleshow,
          WhiteBoxElementDTOjsonldsyliusshoparticleshow,
          TeamElementDTOjsonldsyliusshoparticleshow,
          BaseButtonElementDTOjsonldsyliusshoparticleshow,
          AddToCartButtonElementDTOjsonldsyliusshoparticleshow,
          ButtonGridElementDTOjsonldsyliusshoparticleshow,
          ProductListElementDTOjsonldsyliusshoparticleshow,
          TableElementDTOjsonldsyliusshoparticleshow,
        ],
        { mode: 'oneOf' }
      )
    ),
    articles: Schema.optionalKey(
      Schema.Array(Articlejsonldsyliusshoparticleindexfavourite).annotate({ readOnly: true })
    ),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Articlejsonldsyliusshoparticleshow' });
export type Articlejsonldsyliusshoparticleshow = Schema.Schema.Type<
  typeof Articlejsonldsyliusshoparticleshow
>;
export type ArticlejsonldsyliusshoparticleshowEncoded = Schema.Codec.Encoded<
  typeof Articlejsonldsyliusshoparticleshow
>;

/* ChannelPricingLogEntry */

export const ChannelPricingLogEntry = Schema.StructWithRest(
  Schema.Struct({
    channelPricing: ChannelPricing,
    loggedAt: DateTimeSerializableFromString,
    price: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    originalPrice: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ChannelPricingLogEntry' });
export type ChannelPricingLogEntry = Schema.Schema.Type<typeof ChannelPricingLogEntry>;
export type ChannelPricingLogEntryEncoded = Schema.Codec.Encoded<typeof ChannelPricingLogEntry>;

/* ChannelPricingLogEntryjsonld */

export const ChannelPricingLogEntryjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    channelPricing: ChannelPricingjsonld,
    loggedAt: DateTimeSerializableFromString,
    price: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    originalPrice: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ChannelPricingLogEntryjsonld' });
export type ChannelPricingLogEntryjsonld = Schema.Schema.Type<typeof ChannelPricingLogEntryjsonld>;
export type ChannelPricingLogEntryjsonldEncoded = Schema.Codec.Encoded<
  typeof ChannelPricingLogEntryjsonld
>;

/* GlossaryTermsyliusshopglossaryshow */

export const GlossaryTermsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(Schema.String.annotate({ readOnly: true, format: 'uuid' })),
    code: Schema.String.annotate({ default: '' }),
    enabled: Schema.Boolean.annotate({ default: true }),
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    favorite: Schema.Boolean.annotate({ default: false }),
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    content: Schema.Array(
      Schema.Union(
        [
          TitleElementDTOsyliusshopglossaryshow,
          MarkdownTextElementDTOsyliusshopglossaryshow,
          QuoteElementDTOsyliusshopglossaryshow,
          ImageElementDTOsyliusshopglossaryshow,
          ImageCollectionElementDTOsyliusshopglossaryshow,
          YoutubeElementDTOsyliusshopglossaryshow,
          ImagePairElementDTOsyliusshopglossaryshow,
          MarkdownTwoColumnsElementDTOsyliusshopglossaryshow,
          MarkdownThreeColumnsElementDTOsyliusshopglossaryshow,
          MarkdownTextWithImageElementDTOsyliusshopglossaryshow,
          RetinoWidgetElementDTOsyliusshopglossaryshow,
          AdvantagesElementDTOsyliusshopglossaryshow,
          WhiteBoxElementDTOsyliusshopglossaryshow,
          TeamElementDTOsyliusshopglossaryshow,
          BaseButtonElementDTOsyliusshopglossaryshow,
          ButtonGridElementDTOsyliusshopglossaryshow,
          ProductListElementDTOsyliusshopglossaryshow,
          TableElementDTOsyliusshopglossaryshow,
        ],
        { mode: 'oneOf' }
      )
    ),
    tooltip: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    metaTitle: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    metaDescription: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    metaImage: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    metaImageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        description:
          'Media-cache URL of the meta image; the filter placeholder is resolved by the consumer.',
        readOnly: true,
      })
    ),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'GlossaryTermsyliusshopglossaryshow' });
export type GlossaryTermsyliusshopglossaryshow = Schema.Schema.Type<
  typeof GlossaryTermsyliusshopglossaryshow
>;
export type GlossaryTermsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof GlossaryTermsyliusshopglossaryshow
>;

/* GlossaryTermjsonldsyliusshopglossaryshow */

export const GlossaryTermjsonldsyliusshopglossaryshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(Schema.String.annotate({ readOnly: true, format: 'uuid' })),
    code: Schema.String.annotate({ default: '' }),
    enabled: Schema.Boolean.annotate({ default: true }),
    channels: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    favorite: Schema.Boolean.annotate({ default: false }),
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    content: Schema.Array(
      Schema.Union(
        [
          TitleElementDTOjsonldsyliusshopglossaryshow,
          MarkdownTextElementDTOjsonldsyliusshopglossaryshow,
          QuoteElementDTOjsonldsyliusshopglossaryshow,
          ImageElementDTOjsonldsyliusshopglossaryshow,
          ImageCollectionElementDTOjsonldsyliusshopglossaryshow,
          YoutubeElementDTOjsonldsyliusshopglossaryshow,
          ImagePairElementDTOjsonldsyliusshopglossaryshow,
          MarkdownTwoColumnsElementDTOjsonldsyliusshopglossaryshow,
          MarkdownThreeColumnsElementDTOjsonldsyliusshopglossaryshow,
          MarkdownTextWithImageElementDTOjsonldsyliusshopglossaryshow,
          RetinoWidgetElementDTOjsonldsyliusshopglossaryshow,
          AdvantagesElementDTOjsonldsyliusshopglossaryshow,
          WhiteBoxElementDTOjsonldsyliusshopglossaryshow,
          TeamElementDTOjsonldsyliusshopglossaryshow,
          BaseButtonElementDTOjsonldsyliusshopglossaryshow,
          ButtonGridElementDTOjsonldsyliusshopglossaryshow,
          ProductListElementDTOjsonldsyliusshopglossaryshow,
          TableElementDTOjsonldsyliusshopglossaryshow,
        ],
        { mode: 'oneOf' }
      )
    ),
    tooltip: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    metaTitle: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    metaDescription: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    metaImage: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    metaImageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        description:
          'Media-cache URL of the meta image; the filter placeholder is resolved by the consumer.',
        readOnly: true,
      })
    ),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'GlossaryTermjsonldsyliusshopglossaryshow' });
export type GlossaryTermjsonldsyliusshopglossaryshow = Schema.Schema.Type<
  typeof GlossaryTermjsonldsyliusshopglossaryshow
>;
export type GlossaryTermjsonldsyliusshopglossaryshowEncoded = Schema.Codec.Encoded<
  typeof GlossaryTermjsonldsyliusshopglossaryshow
>;

/* OrderItemsyliusshopcartshowsyliusshopcartshowdetail */

export const OrderItemsyliusshopcartshowsyliusshopcartshowdetail = Schema.StructWithRest(
  Schema.Struct({
    variant: ProductVariantsyliusshopcartshowsyliusshopcartshowdetail,
    productName: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    quantity: Schema.Number.annotate({ default: 0, readOnly: true })
      .check(Schema.isInt().annotate({ expected: 'an integer' }))
      .check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
    unitPrice: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    originalUnitPrice: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({ default: 0 }),
    total: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    frontUnitPriceWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    frontItemsPriceWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    frontUnitPriceDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Nominal value of sum of all discounts applied on unit\nDiscount technically contains VAT part (is applied for source price including VAT)\nValue is nominal for both nominal and percentage discounts\nValue is average for all units (if special discounts are per unit, this filed must be calculated custom for each every unit)\nNumber is positive.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontItemsPriceDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Nominal value of sum of all discounts applied on items (all units)\nDiscount technically contains VAT part (is applied for source price including VAT)\nValue is nominal for both nominal and percentage discounts\nNumber is positive.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontUnitPriceWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Unit price with VAT and after all product discounts (including order level discounts on products)\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontUnitPriceWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Unit price without VAT and after all product discounts (including order level discounts on products)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontUnitPricePaid: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    frontItemsPriceWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Sum of items (all units) with VAT and after all product discounts (including order level discounts on products)\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontItemsPriceWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Sum of items (all units) without VAT and after all product discounts (including order level discounts on products)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontUnitTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Tax as nominal value applied on unit price AFTER discount\nNULL if customer is verified to NOT pay VAT for Order (basically zero tax)',
        readOnly: true,
      })
    ),
    frontItemsTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Tax as nominal value applied on items (all units) price AFTER discount\nNULL if customer is verified to NOT pay VAT for Order (basically zero tax)',
        readOnly: true,
      })
    ),
    frontItemsPricePaid: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    discountedUnitPrice: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns single unit price lowered by order unit promotions (each unit must have the same unit promotion discount)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    subtotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'OrderItemsyliusshopcartshowsyliusshopcartshowdetail' });
export type OrderItemsyliusshopcartshowsyliusshopcartshowdetail = Schema.Schema.Type<
  typeof OrderItemsyliusshopcartshowsyliusshopcartshowdetail
>;
export type OrderItemsyliusshopcartshowsyliusshopcartshowdetailEncoded = Schema.Codec.Encoded<
  typeof OrderItemsyliusshopcartshowsyliusshopcartshowdetail
>;

/* OrderItemsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const OrderItemsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      variant: ProductVariantsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
      productName: Schema.Union([Schema.String, Schema.Null]),
      id: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      quantity: Schema.Number.annotate({ default: 0, readOnly: true })
        .check(Schema.isInt().annotate({ expected: 'an integer' }))
        .check(
          Schema.isGreaterThanOrEqualTo(0).annotate({
            expected: 'a value greater than or equal to 0',
          })
        ),
      unitPrice: Schema.Number.annotate({ default: 0 }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      ),
      originalUnitPrice: Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ default: 0 }),
      total: Schema.optionalKey(
        Schema.Number.annotate({ default: 0, readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      frontUnitPriceWithVat: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({ readOnly: true })
      ),
      frontItemsPriceWithVat: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({ readOnly: true })
      ),
      frontUnitPriceDiscountAsNominalValue: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Nominal value of sum of all discounts applied on unit\nDiscount technically contains VAT part (is applied for source price including VAT)\nValue is nominal for both nominal and percentage discounts\nValue is average for all units (if special discounts are per unit, this filed must be calculated custom for each every unit)\nNumber is positive.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontItemsPriceDiscountAsNominalValue: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Nominal value of sum of all discounts applied on items (all units)\nDiscount technically contains VAT part (is applied for source price including VAT)\nValue is nominal for both nominal and percentage discounts\nNumber is positive.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontUnitPriceWithVatAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Unit price with VAT and after all product discounts (including order level discounts on products)\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontUnitPriceWithoutVatAfterDiscount: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Unit price without VAT and after all product discounts (including order level discounts on products)',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontUnitPricePaid: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      frontItemsPriceWithVatAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Sum of items (all units) with VAT and after all product discounts (including order level discounts on products)\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontItemsPriceWithoutVatAfterDiscount: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Sum of items (all units) without VAT and after all product discounts (including order level discounts on products)',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontUnitTaxAppliedAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Tax as nominal value applied on unit price AFTER discount\nNULL if customer is verified to NOT pay VAT for Order (basically zero tax)',
          readOnly: true,
        })
      ),
      frontItemsTaxAppliedAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Tax as nominal value applied on items (all units) price AFTER discount\nNULL if customer is verified to NOT pay VAT for Order (basically zero tax)',
          readOnly: true,
        })
      ),
      frontItemsPricePaid: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      discountedUnitPrice: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns single unit price lowered by order unit promotions (each unit must have the same unit promotion discount)',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      subtotal: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier: 'OrderItemsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type OrderItemsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof OrderItemsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type OrderItemsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof OrderItemsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* OrderItemsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const OrderItemsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      variant:
        ProductVariantsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
      productName: Schema.Union([Schema.String, Schema.Null]),
      id: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      quantity: Schema.Number.annotate({ default: 0, readOnly: true })
        .check(Schema.isInt().annotate({ expected: 'an integer' }))
        .check(
          Schema.isGreaterThanOrEqualTo(0).annotate({
            expected: 'a value greater than or equal to 0',
          })
        ),
      unitPrice: Schema.Number.annotate({ default: 0 }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      ),
      originalUnitPrice: Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ default: 0 }),
      total: Schema.optionalKey(
        Schema.Number.annotate({ default: 0, readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      frontUnitPriceWithVat: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({ readOnly: true })
      ),
      frontItemsPriceWithVat: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({ readOnly: true })
      ),
      frontUnitPriceDiscountAsNominalValue: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Nominal value of sum of all discounts applied on unit\nDiscount technically contains VAT part (is applied for source price including VAT)\nValue is nominal for both nominal and percentage discounts\nValue is average for all units (if special discounts are per unit, this filed must be calculated custom for each every unit)\nNumber is positive.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontItemsPriceDiscountAsNominalValue: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Nominal value of sum of all discounts applied on items (all units)\nDiscount technically contains VAT part (is applied for source price including VAT)\nValue is nominal for both nominal and percentage discounts\nNumber is positive.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontUnitPriceWithVatAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Unit price with VAT and after all product discounts (including order level discounts on products)\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontUnitPriceWithoutVatAfterDiscount: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Unit price without VAT and after all product discounts (including order level discounts on products)',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontUnitPricePaid: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      frontItemsPriceWithVatAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Sum of items (all units) with VAT and after all product discounts (including order level discounts on products)\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontItemsPriceWithoutVatAfterDiscount: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Sum of items (all units) without VAT and after all product discounts (including order level discounts on products)',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontUnitTaxAppliedAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Tax as nominal value applied on unit price AFTER discount\nNULL if customer is verified to NOT pay VAT for Order (basically zero tax)',
          readOnly: true,
        })
      ),
      frontItemsTaxAppliedAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Tax as nominal value applied on items (all units) price AFTER discount\nNULL if customer is verified to NOT pay VAT for Order (basically zero tax)',
          readOnly: true,
        })
      ),
      frontItemsPricePaid: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      discountedUnitPrice: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns single unit price lowered by order unit promotions (each unit must have the same unit promotion discount)',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      subtotal: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'OrderItemsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type OrderItemsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof OrderItemsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type OrderItemsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof OrderItemsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* OrderItemsyliusshoporderindex */

export const OrderItemsyliusshoporderindex = Schema.StructWithRest(
  Schema.Struct({
    variant: ProductVariantsyliusshoporderindex,
    productName: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'OrderItemsyliusshoporderindex' });
export type OrderItemsyliusshoporderindex = Schema.Schema.Type<
  typeof OrderItemsyliusshoporderindex
>;
export type OrderItemsyliusshoporderindexEncoded = Schema.Codec.Encoded<
  typeof OrderItemsyliusshoporderindex
>;

/* OrderItemjsonldsyliusshopcartshowsyliusshopcartshowdetail */

export const OrderItemjsonldsyliusshopcartshowsyliusshopcartshowdetail = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    variant: ProductVariantjsonldsyliusshopcartshowsyliusshopcartshowdetail,
    productName: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    quantity: Schema.Number.annotate({ default: 0, readOnly: true })
      .check(Schema.isInt().annotate({ expected: 'an integer' }))
      .check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
    unitPrice: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    originalUnitPrice: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({ default: 0 }),
    total: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    frontUnitPriceWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    frontItemsPriceWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    frontUnitPriceDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Nominal value of sum of all discounts applied on unit\nDiscount technically contains VAT part (is applied for source price including VAT)\nValue is nominal for both nominal and percentage discounts\nValue is average for all units (if special discounts are per unit, this filed must be calculated custom for each every unit)\nNumber is positive.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontItemsPriceDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Nominal value of sum of all discounts applied on items (all units)\nDiscount technically contains VAT part (is applied for source price including VAT)\nValue is nominal for both nominal and percentage discounts\nNumber is positive.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontUnitPriceWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Unit price with VAT and after all product discounts (including order level discounts on products)\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontUnitPriceWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Unit price without VAT and after all product discounts (including order level discounts on products)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontUnitPricePaid: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    frontItemsPriceWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Sum of items (all units) with VAT and after all product discounts (including order level discounts on products)\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontItemsPriceWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Sum of items (all units) without VAT and after all product discounts (including order level discounts on products)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontUnitTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Tax as nominal value applied on unit price AFTER discount\nNULL if customer is verified to NOT pay VAT for Order (basically zero tax)',
        readOnly: true,
      })
    ),
    frontItemsTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Tax as nominal value applied on items (all units) price AFTER discount\nNULL if customer is verified to NOT pay VAT for Order (basically zero tax)',
        readOnly: true,
      })
    ),
    frontItemsPricePaid: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    discountedUnitPrice: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns single unit price lowered by order unit promotions (each unit must have the same unit promotion discount)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    subtotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'OrderItemjsonldsyliusshopcartshowsyliusshopcartshowdetail' });
export type OrderItemjsonldsyliusshopcartshowsyliusshopcartshowdetail = Schema.Schema.Type<
  typeof OrderItemjsonldsyliusshopcartshowsyliusshopcartshowdetail
>;
export type OrderItemjsonldsyliusshopcartshowsyliusshopcartshowdetailEncoded = Schema.Codec.Encoded<
  typeof OrderItemjsonldsyliusshopcartshowsyliusshopcartshowdetail
>;

/* OrderItemjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const OrderItemjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      variant: ProductVariantjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
      productName: Schema.Union([Schema.String, Schema.Null]),
      id: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      quantity: Schema.Number.annotate({ default: 0, readOnly: true })
        .check(Schema.isInt().annotate({ expected: 'an integer' }))
        .check(
          Schema.isGreaterThanOrEqualTo(0).annotate({
            expected: 'a value greater than or equal to 0',
          })
        ),
      unitPrice: Schema.Number.annotate({ default: 0 }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      ),
      originalUnitPrice: Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ default: 0 }),
      total: Schema.optionalKey(
        Schema.Number.annotate({ default: 0, readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      frontUnitPriceWithVat: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({ readOnly: true })
      ),
      frontItemsPriceWithVat: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({ readOnly: true })
      ),
      frontUnitPriceDiscountAsNominalValue: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Nominal value of sum of all discounts applied on unit\nDiscount technically contains VAT part (is applied for source price including VAT)\nValue is nominal for both nominal and percentage discounts\nValue is average for all units (if special discounts are per unit, this filed must be calculated custom for each every unit)\nNumber is positive.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontItemsPriceDiscountAsNominalValue: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Nominal value of sum of all discounts applied on items (all units)\nDiscount technically contains VAT part (is applied for source price including VAT)\nValue is nominal for both nominal and percentage discounts\nNumber is positive.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontUnitPriceWithVatAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Unit price with VAT and after all product discounts (including order level discounts on products)\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontUnitPriceWithoutVatAfterDiscount: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Unit price without VAT and after all product discounts (including order level discounts on products)',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontUnitPricePaid: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      frontItemsPriceWithVatAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Sum of items (all units) with VAT and after all product discounts (including order level discounts on products)\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontItemsPriceWithoutVatAfterDiscount: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Sum of items (all units) without VAT and after all product discounts (including order level discounts on products)',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontUnitTaxAppliedAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Tax as nominal value applied on unit price AFTER discount\nNULL if customer is verified to NOT pay VAT for Order (basically zero tax)',
          readOnly: true,
        })
      ),
      frontItemsTaxAppliedAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Tax as nominal value applied on items (all units) price AFTER discount\nNULL if customer is verified to NOT pay VAT for Order (basically zero tax)',
          readOnly: true,
        })
      ),
      frontItemsPricePaid: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      discountedUnitPrice: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns single unit price lowered by order unit promotions (each unit must have the same unit promotion discount)',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      subtotal: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier: 'OrderItemjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type OrderItemjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof OrderItemjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type OrderItemjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof OrderItemjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* OrderItemjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const OrderItemjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      variant:
        ProductVariantjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
      productName: Schema.Union([Schema.String, Schema.Null]),
      id: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      quantity: Schema.Number.annotate({ default: 0, readOnly: true })
        .check(Schema.isInt().annotate({ expected: 'an integer' }))
        .check(
          Schema.isGreaterThanOrEqualTo(0).annotate({
            expected: 'a value greater than or equal to 0',
          })
        ),
      unitPrice: Schema.Number.annotate({ default: 0 }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      ),
      originalUnitPrice: Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ default: 0 }),
      total: Schema.optionalKey(
        Schema.Number.annotate({ default: 0, readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      frontUnitPriceWithVat: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({ readOnly: true })
      ),
      frontItemsPriceWithVat: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({ readOnly: true })
      ),
      frontUnitPriceDiscountAsNominalValue: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Nominal value of sum of all discounts applied on unit\nDiscount technically contains VAT part (is applied for source price including VAT)\nValue is nominal for both nominal and percentage discounts\nValue is average for all units (if special discounts are per unit, this filed must be calculated custom for each every unit)\nNumber is positive.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontItemsPriceDiscountAsNominalValue: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Nominal value of sum of all discounts applied on items (all units)\nDiscount technically contains VAT part (is applied for source price including VAT)\nValue is nominal for both nominal and percentage discounts\nNumber is positive.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontUnitPriceWithVatAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Unit price with VAT and after all product discounts (including order level discounts on products)\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontUnitPriceWithoutVatAfterDiscount: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Unit price without VAT and after all product discounts (including order level discounts on products)',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontUnitPricePaid: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      frontItemsPriceWithVatAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Sum of items (all units) with VAT and after all product discounts (including order level discounts on products)\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontItemsPriceWithoutVatAfterDiscount: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Sum of items (all units) without VAT and after all product discounts (including order level discounts on products)',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontUnitTaxAppliedAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Tax as nominal value applied on unit price AFTER discount\nNULL if customer is verified to NOT pay VAT for Order (basically zero tax)',
          readOnly: true,
        })
      ),
      frontItemsTaxAppliedAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Tax as nominal value applied on items (all units) price AFTER discount\nNULL if customer is verified to NOT pay VAT for Order (basically zero tax)',
          readOnly: true,
        })
      ),
      frontItemsPricePaid: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      discountedUnitPrice: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns single unit price lowered by order unit promotions (each unit must have the same unit promotion discount)',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      subtotal: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'OrderItemjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type OrderItemjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof OrderItemjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type OrderItemjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof OrderItemjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* OrderItemjsonldsyliusshoporderindex */

export const OrderItemjsonldsyliusshoporderindex = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    variant: ProductVariantjsonldsyliusshoporderindex,
    productName: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'OrderItemjsonldsyliusshoporderindex' });
export type OrderItemjsonldsyliusshoporderindex = Schema.Schema.Type<
  typeof OrderItemjsonldsyliusshoporderindex
>;
export type OrderItemjsonldsyliusshoporderindexEncoded = Schema.Codec.Encoded<
  typeof OrderItemjsonldsyliusshoporderindex
>;

/* Pagesyliusshoppageshow */

export const Pagesyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    metaImageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    title: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    metaKeywords: Schema.Union([Schema.String, Schema.Null]),
    metaDescription: Schema.Union([Schema.String, Schema.Null]),
    metaImage: Schema.Union([Schema.String, Schema.Null]),
    content: Schema.Array(
      Schema.Union(
        [
          TitleElementDTOsyliusshoppageshow,
          MarkdownTextElementDTOsyliusshoppageshow,
          QuoteElementDTOsyliusshoppageshow,
          ImageElementDTOsyliusshoppageshow,
          ImageCollectionElementDTOsyliusshoppageshow,
          ProductElementDTOsyliusshoppageshow,
          YoutubeElementDTOsyliusshoppageshow,
          ImagePairElementDTOsyliusshoppageshow,
          MarkdownTwoColumnsElementDTOsyliusshoppageshow,
          MarkdownThreeColumnsElementDTOsyliusshoppageshow,
          MarkdownTextWithImageElementDTOsyliusshoppageshow,
          RetinoWidgetElementDTOsyliusshoppageshow,
          AdvantagesElementDTOsyliusshoppageshow,
          WhiteBoxElementDTOsyliusshoppageshow,
          TeamElementDTOsyliusshoppageshow,
          GoogleMapsElementDTOsyliusshoppageshow,
          BaseButtonElementDTOsyliusshoppageshow,
          AddToCartButtonElementDTOsyliusshoppageshow,
          ButtonGridElementDTOsyliusshoppageshow,
          ProductListElementDTOsyliusshoppageshow,
          TableElementDTOsyliusshoppageshow,
        ],
        { mode: 'oneOf' }
      )
    ),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Pagesyliusshoppageshow' });
export type Pagesyliusshoppageshow = Schema.Schema.Type<typeof Pagesyliusshoppageshow>;
export type PagesyliusshoppageshowEncoded = Schema.Codec.Encoded<typeof Pagesyliusshoppageshow>;

/* Pagejsonldsyliusshoppageshow */

export const Pagejsonldsyliusshoppageshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    metaImageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    title: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    metaKeywords: Schema.Union([Schema.String, Schema.Null]),
    metaDescription: Schema.Union([Schema.String, Schema.Null]),
    metaImage: Schema.Union([Schema.String, Schema.Null]),
    content: Schema.Array(
      Schema.Union(
        [
          TitleElementDTOjsonldsyliusshoppageshow,
          MarkdownTextElementDTOjsonldsyliusshoppageshow,
          QuoteElementDTOjsonldsyliusshoppageshow,
          ImageElementDTOjsonldsyliusshoppageshow,
          ImageCollectionElementDTOjsonldsyliusshoppageshow,
          ProductElementDTOjsonldsyliusshoppageshow,
          YoutubeElementDTOjsonldsyliusshoppageshow,
          ImagePairElementDTOjsonldsyliusshoppageshow,
          MarkdownTwoColumnsElementDTOjsonldsyliusshoppageshow,
          MarkdownThreeColumnsElementDTOjsonldsyliusshoppageshow,
          MarkdownTextWithImageElementDTOjsonldsyliusshoppageshow,
          RetinoWidgetElementDTOjsonldsyliusshoppageshow,
          AdvantagesElementDTOjsonldsyliusshoppageshow,
          WhiteBoxElementDTOjsonldsyliusshoppageshow,
          TeamElementDTOjsonldsyliusshoppageshow,
          GoogleMapsElementDTOjsonldsyliusshoppageshow,
          BaseButtonElementDTOjsonldsyliusshoppageshow,
          AddToCartButtonElementDTOjsonldsyliusshoppageshow,
          ButtonGridElementDTOjsonldsyliusshoppageshow,
          ProductListElementDTOjsonldsyliusshoppageshow,
          TableElementDTOjsonldsyliusshoppageshow,
        ],
        { mode: 'oneOf' }
      )
    ),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Pagejsonldsyliusshoppageshow' });
export type Pagejsonldsyliusshoppageshow = Schema.Schema.Type<typeof Pagejsonldsyliusshoppageshow>;
export type PagejsonldsyliusshoppageshowEncoded = Schema.Codec.Encoded<
  typeof Pagejsonldsyliusshoppageshow
>;

/* Productsyliusshopproductshowsyliusshopproductshowdetail */

export const Productsyliusshopproductshowsyliusshopproductshowdetail = Schema.StructWithRest(
  Schema.Struct({
    ageRestriction: Schema.Literals(['none', '18+']),
    brand: Schema.Union([Brandsyliusshopproductshowsyliusshopproductshowdetail, Schema.Null]),
    videos: Schema.Array(ProductVideosyliusshopproductshowsyliusshopproductshowdetail),
    warrantyMonths: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({
      description: 'Warranty length in months (unsigned smallint, null = unspecified)',
    }),
    ean: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'EAN/GTIN barcode, max 20 chars',
    }),
    mainTaxon: Schema.Union([Taxonsyliusshopproductshowsyliusshopproductshowdetail, Schema.Null]),
    averageRating: Schema.Number.annotate({ default: 0 }).check(
      Schema.isFinite().annotate({ expected: 'a finite number' })
    ),
    images: Schema.optionalKey(
      Schema.Array(ProductImagesyliusshopproductshowsyliusshopproductshowdetail).annotate({
        readOnly: true,
      })
    ),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    attributes: Schema.Array(ProductAttributeValuesyliusshopproductshowsyliusshopproductshowdetail),
    createdAt: Schema.optionalKey(DateTimeSerializableFromString),
    updatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    publicDocuments: Schema.optionalKey(
      Schema.Array(ProductDocumentsyliusshopproductshowsyliusshopproductshowdetail).annotate({
        readOnly: true,
      })
    ),
    name: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    shortDescription: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    metaDescription: Schema.Union([Schema.String, Schema.Null]),
    metaKeywords: Schema.Union([Schema.String, Schema.Null]),
    subtitle: Schema.Union([Schema.String, Schema.Null]),
    banners: Schema.optionalKey(
      Schema.Array(Bannersyliusshopbannerindex).annotate({ readOnly: true })
    ),
    breadcrumbs: Schema.optionalKey(
      Schema.Array(Taxonsyliusshoptaxonindex).annotate({ readOnly: true })
    ),
    articles: Schema.optionalKey(
      Schema.Array(Articlesyliusshoparticleindexfavourite).annotate({ readOnly: true })
    ),
    productAssociations: Schema.optionalKey(
      Schema.StructWithRest(
        Schema.Struct({
          variants: Schema.optionalKey(
            Schema.Array(Productsyliusshopproductindexbase).annotate({ readOnly: true })
          ),
          colors: Schema.optionalKey(
            Schema.Array(Productsyliusshopproductindexbase).annotate({ readOnly: true })
          ),
          taxons: Schema.optionalKey(
            Schema.Array(Taxonsyliusshoptaxonindexshort).annotate({ readOnly: true })
          ),
        }),
        [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
      ).annotate({ readOnly: true })
    ),
    suggestions: Schema.optionalKey(
      Schema.Array(AutomaticAccessoryItem).annotate({ readOnly: true })
    ),
    sets: Schema.optionalKey(
      Schema.Array(Schema.Array(AutomaticAccessoryItem)).annotate({ readOnly: true })
    ),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Productsyliusshopproductshowsyliusshopproductshowdetail' });
export type Productsyliusshopproductshowsyliusshopproductshowdetail = Schema.Schema.Type<
  typeof Productsyliusshopproductshowsyliusshopproductshowdetail
>;
export type ProductsyliusshopproductshowsyliusshopproductshowdetailEncoded = Schema.Codec.Encoded<
  typeof Productsyliusshopproductshowsyliusshopproductshowdetail
>;

/* Productjsonldsyliusshopproductshowsyliusshopproductshowdetail */

export const Productjsonldsyliusshopproductshowsyliusshopproductshowdetail = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    ageRestriction: Schema.Literals(['none', '18+']),
    brand: Schema.Union([Brandjsonldsyliusshopproductshowsyliusshopproductshowdetail, Schema.Null]),
    videos: Schema.Array(ProductVideojsonldsyliusshopproductshowsyliusshopproductshowdetail),
    warrantyMonths: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({
      description: 'Warranty length in months (unsigned smallint, null = unspecified)',
    }),
    ean: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'EAN/GTIN barcode, max 20 chars',
    }),
    mainTaxon: Schema.Union([
      Taxonjsonldsyliusshopproductshowsyliusshopproductshowdetail,
      Schema.Null,
    ]),
    averageRating: Schema.Number.annotate({ default: 0 }).check(
      Schema.isFinite().annotate({ expected: 'a finite number' })
    ),
    images: Schema.optionalKey(
      Schema.Array(ProductImagejsonldsyliusshopproductshowsyliusshopproductshowdetail).annotate({
        readOnly: true,
      })
    ),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    attributes: Schema.Array(
      ProductAttributeValuejsonldsyliusshopproductshowsyliusshopproductshowdetail
    ),
    createdAt: Schema.optionalKey(DateTimeSerializableFromString),
    updatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    publicDocuments: Schema.optionalKey(
      Schema.Array(ProductDocumentjsonldsyliusshopproductshowsyliusshopproductshowdetail).annotate({
        readOnly: true,
      })
    ),
    name: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    shortDescription: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    metaDescription: Schema.Union([Schema.String, Schema.Null]),
    metaKeywords: Schema.Union([Schema.String, Schema.Null]),
    subtitle: Schema.Union([Schema.String, Schema.Null]),
    banners: Schema.optionalKey(
      Schema.Array(Bannerjsonldsyliusshopbannerindex).annotate({ readOnly: true })
    ),
    breadcrumbs: Schema.optionalKey(
      Schema.Array(Taxonjsonldsyliusshoptaxonindex).annotate({ readOnly: true })
    ),
    articles: Schema.optionalKey(
      Schema.Array(Articlejsonldsyliusshoparticleindexfavourite).annotate({ readOnly: true })
    ),
    productAssociations: Schema.optionalKey(
      Schema.StructWithRest(
        Schema.Struct({
          variants: Schema.optionalKey(
            Schema.Array(Productjsonldsyliusshopproductindexbase).annotate({ readOnly: true })
          ),
          colors: Schema.optionalKey(
            Schema.Array(Productjsonldsyliusshopproductindexbase).annotate({ readOnly: true })
          ),
          taxons: Schema.optionalKey(
            Schema.Array(Taxonjsonldsyliusshoptaxonindexshort).annotate({ readOnly: true })
          ),
        }),
        [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
      ).annotate({ readOnly: true })
    ),
    suggestions: Schema.optionalKey(
      Schema.Array(AutomaticAccessoryItemjsonld).annotate({ readOnly: true })
    ),
    sets: Schema.optionalKey(
      Schema.Array(AutomaticAccessoryItemjsonld).annotate({ readOnly: true })
    ),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Productjsonldsyliusshopproductshowsyliusshopproductshowdetail' });
export type Productjsonldsyliusshopproductshowsyliusshopproductshowdetail = Schema.Schema.Type<
  typeof Productjsonldsyliusshopproductshowsyliusshopproductshowdetail
>;
export type ProductjsonldsyliusshopproductshowsyliusshopproductshowdetailEncoded =
  Schema.Codec.Encoded<typeof Productjsonldsyliusshopproductshowsyliusshopproductshowdetail>;

/* Ordersyliusshopcartshowsyliusshopcartshowdetail */

export const Ordersyliusshopcartshowsyliusshopcartshowdetail = Schema.StructWithRest(
  Schema.Struct({
    promotionRuleHints: Schema.Array(
      CartPromotionRuleHintssyliusshopcartshowsyliusshopcartshowdetail
    ),
    customer: Schema.Union([Customersyliusshopcartshowsyliusshopcartshowdetail, Schema.Null]),
    channel: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    shippingAddress: Schema.Union([Addresssyliusshopcartshowsyliusshopcartshowdetail, Schema.Null]),
    billingAddress: Schema.Union([Addresssyliusshopcartshowsyliusshopcartshowdetail, Schema.Null]),
    payments: Schema.Array(Paymentsyliusshopcartshowsyliusshopcartshowdetail),
    shipments: Schema.Array(Shipmentsyliusshopcartshowsyliusshopcartshowdetail),
    currencyCode: Schema.String,
    localeCode: Schema.String,
    promotionCoupon: Schema.Union([
      PromotionCouponsyliusshopcartshowsyliusshopcartshowdetail,
      Schema.Null,
    ]),
    checkoutState: Schema.String.annotate({ default: 'cart' }),
    paymentState: Schema.String.annotate({ default: 'cart' }),
    shippingState: Schema.String.annotate({ default: 'cart' }),
    tokenValue: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    checkoutCompletedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    number: Schema.Union([Schema.String, Schema.Null]),
    notes: Schema.Union([Schema.String, Schema.Null]),
    items: Schema.Array(OrderItemsyliusshopcartshowsyliusshopcartshowdetail),
    itemsTotal: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    total: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Items total + adjustments total.',
        default: 0,
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    state: Schema.String.annotate({ default: 'cart' }),
    vatFree: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'This is TRUE if Order price does NOT contain any VAT tax.',
        readOnly: true,
      })
    ),
    frontAllItemsPriceWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Sum of price of all items (without shipment and payment) after all discounts with VAT\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontAllItemsPriceWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Sum of price of all items (without shipment and payment) after all discounts without VAT',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontAllItemsDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Nominal value of sum of all discounts applied on (all) items\nValue is nominal for both nominal and percentage discounts\nNote: Because discount includes VAT, this sum also technically always includes discount from base+VAT price event\nif customer is verified to NOT pay VAT for Order!\nNumber is positive.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontAllItemsTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns nominal value of VAT from price AFTER discounts for all items\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontTotalWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns price including all items, shipment, payment and applied discounts\nAlways with VAT or NULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontTotalWithoutVat: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns price including all items, shipment, payment and applied discounts\nAlways without VAT even if customer pays VAT.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontFinalRounding: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns final rounding on entire Order. This correction is applied after everything even after TAX/VAT.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontTotalTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns nominal value of VAT from price AFTER discounts for all items\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontTotalPaid: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns FINAL price to be paid by customer including all items, shipment, payment, applied discounts\nand applied taxes if any. This number is number which should be sent to payment gate or displayed as number\nrepresenting how much will customer pay.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontShipmentTotalPaid: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns FINAL price to be paid by customer for shipment (after discount and including taxes if applied)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontPaymentTotalPaid: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns FINAL price to be paid by customer for payment (after discount and including taxes if applied)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontDeliveryTotalPaid: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns FINAL price to be paid by customer for delivery: shipment+payment (after discount and including taxes if applied)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontShipmentWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns shipment price before discount with VAT\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontShipmentDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns discount in nominal value of shipment (for both percentage and nominal discount)\nPositive number.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontShipmentWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns shipment price with VAT after applied discounts\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontShipmentWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns shipment price without VAT after applied discounts',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontShipmentTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns nominal value of VAT from price AFTER discounts for shipment\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontPaymentWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns payment price before discount with VAT\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontPaymentDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns discount in nominal value of payment (for both percentage and nominal discount)\nPositive number.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontPaymentWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns payment price with VAT after applied discounts\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontPaymentWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns payment price without VAT after applied discounts',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontPaymentTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns nominal value of VAT from price AFTER discounts for payment\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontDeliveryWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns delivery: shipment+payment price before discount with VAT\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontDeliveryDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns discount in nominal value of delivery: shipment+payment (for both percentage and nominal discount)\nPositive number.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontDeliveryWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns delivery: shipment+payment price with VAT after applied discounts\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontDeliveryWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns delivery: shipment+payment price without VAT after applied discounts',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontDeliveryTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns nominal value of VAT from price AFTER discounts for delivery: shipment+payment\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontShipmentDiscountPercentage: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns overall percentage discount on shipments calculated from base price with tax and applied nominal discounts.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontPaymentDiscountPercentage: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns overall percentage discount on payments calculated from base price with tax and applied nominal discounts.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontDeliveryDiscountPercentage: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    totalWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    itemsTotalWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Sum of price of all items WITHOUT VAT tax and WITHOUT shipping and payment price',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    orderPromotionTotalWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Order promotional total without VAT (total for all shipments)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    shippingWithoutTaxTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Shipping price without VAT (total for all shipments)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    paymentTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns payment fee price after promotion with applied taxes (for VIES valid non-CZ subjects price is without taxes!)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    paymentPromotionTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    paymentTax: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns only tax of payment method',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    paymentWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns only tax of payment method\nTODO: works only if tax is included in price (this is ok for now)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    orderPromotionTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns amount of order discount. Does not include shipping discounts.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    shippingPromotionTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    itemsSubtotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    taxTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns sum of neutral and non neutral tax adjustments on order and total tax of order items.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    shippingTaxTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    taxIncludedTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    shippingTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns shipping fee together with taxes decreased by shipping discount.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Ordersyliusshopcartshowsyliusshopcartshowdetail' });
export type Ordersyliusshopcartshowsyliusshopcartshowdetail = Schema.Schema.Type<
  typeof Ordersyliusshopcartshowsyliusshopcartshowdetail
>;
export type OrdersyliusshopcartshowsyliusshopcartshowdetailEncoded = Schema.Codec.Encoded<
  typeof Ordersyliusshopcartshowsyliusshopcartshowdetail
>;

/* Ordersyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const Ordersyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      promotionRuleHints: Schema.Array(
        CartPromotionRuleHintssyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
      ),
      customer: Schema.Union([
        Customersyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
        Schema.Null,
      ]),
      channel: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
      shippingAddress: Schema.Union([
        Addresssyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
        Schema.Null,
      ]),
      billingAddress: Schema.Union([
        Addresssyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
        Schema.Null,
      ]),
      payments: Schema.Array(
        Paymentsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
      ),
      shipments: Schema.Array(
        Shipmentsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
      ),
      currencyCode: Schema.String,
      localeCode: Schema.String,
      promotionCoupon: Schema.Union([
        PromotionCouponsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
        Schema.Null,
      ]),
      checkoutState: Schema.String.annotate({ default: 'cart' }),
      paymentState: Schema.String.annotate({ default: 'cart' }),
      shippingState: Schema.String.annotate({ default: 'cart' }),
      tokenValue: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
      checkoutCompletedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
      number: Schema.Union([Schema.String, Schema.Null]),
      notes: Schema.Union([Schema.String, Schema.Null]),
      items: Schema.Array(
        OrderItemsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
      ),
      itemsTotal: Schema.optionalKey(
        Schema.Number.annotate({ default: 0, readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      total: Schema.optionalKey(
        Schema.Number.annotate({
          description: 'Items total + adjustments total.',
          default: 0,
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      state: Schema.String.annotate({ default: 'cart' }),
      documents: Schema.optionalKey(
        Schema.Array(
          ProductDocumentsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
        ).annotate({ readOnly: true })
      ),
      vatFree: Schema.optionalKey(
        Schema.Boolean.annotate({
          description: 'This is TRUE if Order price does NOT contain any VAT tax.',
          readOnly: true,
        })
      ),
      frontAllItemsPriceWithVatAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Sum of price of all items (without shipment and payment) after all discounts with VAT\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontAllItemsPriceWithoutVatAfterDiscount: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Sum of price of all items (without shipment and payment) after all discounts without VAT',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontAllItemsDiscountAsNominalValue: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Nominal value of sum of all discounts applied on (all) items\nValue is nominal for both nominal and percentage discounts\nNote: Because discount includes VAT, this sum also technically always includes discount from base+VAT price event\nif customer is verified to NOT pay VAT for Order!\nNumber is positive.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontAllItemsTaxAppliedAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns nominal value of VAT from price AFTER discounts for all items\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontTotalWithVat: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns price including all items, shipment, payment and applied discounts\nAlways with VAT or NULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontTotalWithoutVat: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns price including all items, shipment, payment and applied discounts\nAlways without VAT even if customer pays VAT.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontFinalRounding: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns final rounding on entire Order. This correction is applied after everything even after TAX/VAT.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontTotalTaxAppliedAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns nominal value of VAT from price AFTER discounts for all items\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontTotalPaid: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns FINAL price to be paid by customer including all items, shipment, payment, applied discounts\nand applied taxes if any. This number is number which should be sent to payment gate or displayed as number\nrepresenting how much will customer pay.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontShipmentTotalPaid: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns FINAL price to be paid by customer for shipment (after discount and including taxes if applied)',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontPaymentTotalPaid: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns FINAL price to be paid by customer for payment (after discount and including taxes if applied)',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontDeliveryTotalPaid: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns FINAL price to be paid by customer for delivery: shipment+payment (after discount and including taxes if applied)',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontShipmentWithVat: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns shipment price before discount with VAT\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontShipmentDiscountAsNominalValue: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns discount in nominal value of shipment (for both percentage and nominal discount)\nPositive number.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontShipmentWithVatAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns shipment price with VAT after applied discounts\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontShipmentWithoutVatAfterDiscount: Schema.optionalKey(
        Schema.Number.annotate({
          description: 'Returns shipment price without VAT after applied discounts',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontShipmentTaxAppliedAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns nominal value of VAT from price AFTER discounts for shipment\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontPaymentWithVat: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns payment price before discount with VAT\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontPaymentDiscountAsNominalValue: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns discount in nominal value of payment (for both percentage and nominal discount)\nPositive number.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontPaymentWithVatAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns payment price with VAT after applied discounts\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontPaymentWithoutVatAfterDiscount: Schema.optionalKey(
        Schema.Number.annotate({
          description: 'Returns payment price without VAT after applied discounts',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontPaymentTaxAppliedAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns nominal value of VAT from price AFTER discounts for payment\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontDeliveryWithVat: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns delivery: shipment+payment price before discount with VAT\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontDeliveryDiscountAsNominalValue: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns discount in nominal value of delivery: shipment+payment (for both percentage and nominal discount)\nPositive number.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontDeliveryWithVatAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns delivery: shipment+payment price with VAT after applied discounts\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontDeliveryWithoutVatAfterDiscount: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns delivery: shipment+payment price without VAT after applied discounts',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontDeliveryTaxAppliedAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns nominal value of VAT from price AFTER discounts for delivery: shipment+payment\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontShipmentDiscountPercentage: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns overall percentage discount on shipments calculated from base price with tax and applied nominal discounts.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontPaymentDiscountPercentage: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns overall percentage discount on payments calculated from base price with tax and applied nominal discounts.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontDeliveryDiscountPercentage: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      totalWithoutTax: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      itemsTotalWithoutTax: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Sum of price of all items WITHOUT VAT tax and WITHOUT shipping and payment price',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      orderPromotionTotalWithoutTax: Schema.optionalKey(
        Schema.Number.annotate({
          description: 'Order promotional total without VAT (total for all shipments)',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      shippingWithoutTaxTotal: Schema.optionalKey(
        Schema.Number.annotate({
          description: 'Shipping price without VAT (total for all shipments)',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      paymentTotal: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns payment fee price after promotion with applied taxes (for VIES valid non-CZ subjects price is without taxes!)',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      paymentPromotionTotal: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      paymentTax: Schema.optionalKey(
        Schema.Number.annotate({
          description: 'Returns only tax of payment method',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      paymentWithoutTax: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns only tax of payment method\nTODO: works only if tax is included in price (this is ok for now)',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      orderPromotionTotal: Schema.optionalKey(
        Schema.Number.annotate({
          description: 'Returns amount of order discount. Does not include shipping discounts.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      shippingPromotionTotal: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      itemsSubtotal: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      taxTotal: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns sum of neutral and non neutral tax adjustments on order and total tax of order items.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      shippingTaxTotal: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      taxIncludedTotal: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      shippingTotal: Schema.optionalKey(
        Schema.Number.annotate({
          description: 'Returns shipping fee together with taxes decreased by shipping discount.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier: 'Ordersyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type Ordersyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<typeof Ordersyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid>;
export type OrdersyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof Ordersyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* Ordersyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const Ordersyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      promotionRuleHints: Schema.Array(
        CartPromotionRuleHintssyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
      ),
      invoiceId: Schema.Union([Schema.String, Schema.Null]),
      customer: Schema.Union([
        Customersyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
        Schema.Null,
      ]),
      channel: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
      shippingAddress: Schema.Union([
        Addresssyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
        Schema.Null,
      ]),
      billingAddress: Schema.Union([
        Addresssyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
        Schema.Null,
      ]),
      payments: Schema.Array(
        Paymentsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
      ),
      shipments: Schema.Array(
        Shipmentsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
      ),
      currencyCode: Schema.String,
      localeCode: Schema.String,
      promotionCoupon: Schema.Union([
        PromotionCouponsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
        Schema.Null,
      ]),
      checkoutState: Schema.String.annotate({ default: 'cart' }),
      paymentState: Schema.String.annotate({ default: 'cart' }),
      shippingState: Schema.String.annotate({ default: 'cart' }),
      tokenValue: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
      checkoutCompletedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
      number: Schema.Union([Schema.String, Schema.Null]),
      notes: Schema.Union([Schema.String, Schema.Null]),
      items: Schema.Array(
        OrderItemsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
      ),
      itemsTotal: Schema.optionalKey(
        Schema.Number.annotate({ default: 0, readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      total: Schema.optionalKey(
        Schema.Number.annotate({
          description: 'Items total + adjustments total.',
          default: 0,
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      state: Schema.String.annotate({ default: 'cart' }),
      documents: Schema.optionalKey(
        Schema.Array(
          ProductDocumentsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
        ).annotate({ readOnly: true })
      ),
      vatFree: Schema.optionalKey(
        Schema.Boolean.annotate({
          description: 'This is TRUE if Order price does NOT contain any VAT tax.',
          readOnly: true,
        })
      ),
      frontAllItemsPriceWithVatAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Sum of price of all items (without shipment and payment) after all discounts with VAT\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontAllItemsPriceWithoutVatAfterDiscount: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Sum of price of all items (without shipment and payment) after all discounts without VAT',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontAllItemsDiscountAsNominalValue: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Nominal value of sum of all discounts applied on (all) items\nValue is nominal for both nominal and percentage discounts\nNote: Because discount includes VAT, this sum also technically always includes discount from base+VAT price event\nif customer is verified to NOT pay VAT for Order!\nNumber is positive.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontAllItemsTaxAppliedAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns nominal value of VAT from price AFTER discounts for all items\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontTotalWithVat: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns price including all items, shipment, payment and applied discounts\nAlways with VAT or NULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontTotalWithoutVat: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns price including all items, shipment, payment and applied discounts\nAlways without VAT even if customer pays VAT.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontFinalRounding: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns final rounding on entire Order. This correction is applied after everything even after TAX/VAT.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontTotalTaxAppliedAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns nominal value of VAT from price AFTER discounts for all items\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontTotalPaid: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns FINAL price to be paid by customer including all items, shipment, payment, applied discounts\nand applied taxes if any. This number is number which should be sent to payment gate or displayed as number\nrepresenting how much will customer pay.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontShipmentTotalPaid: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns FINAL price to be paid by customer for shipment (after discount and including taxes if applied)',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontPaymentTotalPaid: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns FINAL price to be paid by customer for payment (after discount and including taxes if applied)',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontDeliveryTotalPaid: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns FINAL price to be paid by customer for delivery: shipment+payment (after discount and including taxes if applied)',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontShipmentWithVat: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns shipment price before discount with VAT\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontShipmentDiscountAsNominalValue: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns discount in nominal value of shipment (for both percentage and nominal discount)\nPositive number.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontShipmentWithVatAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns shipment price with VAT after applied discounts\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontShipmentWithoutVatAfterDiscount: Schema.optionalKey(
        Schema.Number.annotate({
          description: 'Returns shipment price without VAT after applied discounts',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontShipmentTaxAppliedAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns nominal value of VAT from price AFTER discounts for shipment\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontPaymentWithVat: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns payment price before discount with VAT\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontPaymentDiscountAsNominalValue: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns discount in nominal value of payment (for both percentage and nominal discount)\nPositive number.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontPaymentWithVatAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns payment price with VAT after applied discounts\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontPaymentWithoutVatAfterDiscount: Schema.optionalKey(
        Schema.Number.annotate({
          description: 'Returns payment price without VAT after applied discounts',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontPaymentTaxAppliedAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns nominal value of VAT from price AFTER discounts for payment\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontDeliveryWithVat: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns delivery: shipment+payment price before discount with VAT\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontDeliveryDiscountAsNominalValue: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns discount in nominal value of delivery: shipment+payment (for both percentage and nominal discount)\nPositive number.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontDeliveryWithVatAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns delivery: shipment+payment price with VAT after applied discounts\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontDeliveryWithoutVatAfterDiscount: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns delivery: shipment+payment price without VAT after applied discounts',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontDeliveryTaxAppliedAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns nominal value of VAT from price AFTER discounts for delivery: shipment+payment\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontShipmentDiscountPercentage: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns overall percentage discount on shipments calculated from base price with tax and applied nominal discounts.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontPaymentDiscountPercentage: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns overall percentage discount on payments calculated from base price with tax and applied nominal discounts.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontDeliveryDiscountPercentage: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      totalWithoutTax: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      itemsTotalWithoutTax: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Sum of price of all items WITHOUT VAT tax and WITHOUT shipping and payment price',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      orderPromotionTotalWithoutTax: Schema.optionalKey(
        Schema.Number.annotate({
          description: 'Order promotional total without VAT (total for all shipments)',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      shippingWithoutTaxTotal: Schema.optionalKey(
        Schema.Number.annotate({
          description: 'Shipping price without VAT (total for all shipments)',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      paymentTotal: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns payment fee price after promotion with applied taxes (for VIES valid non-CZ subjects price is without taxes!)',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      paymentPromotionTotal: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      paymentTax: Schema.optionalKey(
        Schema.Number.annotate({
          description: 'Returns only tax of payment method',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      paymentWithoutTax: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns only tax of payment method\nTODO: works only if tax is included in price (this is ok for now)',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      orderPromotionTotal: Schema.optionalKey(
        Schema.Number.annotate({
          description: 'Returns amount of order discount. Does not include shipping discounts.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      shippingPromotionTotal: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      itemsSubtotal: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      taxTotal: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns sum of neutral and non neutral tax adjustments on order and total tax of order items.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      shippingTaxTotal: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      taxIncludedTotal: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      shippingTotal: Schema.optionalKey(
        Schema.Number.annotate({
          description: 'Returns shipping fee together with taxes decreased by shipping discount.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      invoiceUrl: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({
          description: 'Temporary Invoice file download url',
          readOnly: true,
        })
      ),
      globalState: Schema.optionalKey(
        Schema.Union([
          Schema.Literals([
            'AcceptedForPayment',
            'Paid',
            'AcceptedForProcessing',
            'Processing',
            'Resolved',
            'ResolvedStore',
            'ResolvedWithoutEmail',
            'Cancelled',
            'TopolPickup',
            'PardubicePickup',
            'NotPaidEmail',
            'NotPaidCancelled',
            'NotPickedUp',
          ]),
          Schema.Null,
        ]).annotate({ readOnly: true })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'Ordersyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type Ordersyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof Ordersyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type OrdersyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof Ordersyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* Ordersyliusshoporderindex */

export const Ordersyliusshoporderindex = Schema.StructWithRest(
  Schema.Struct({
    invoiceId: Schema.Union([Schema.String, Schema.Null]),
    identifier: Schema.String.annotate({
      description:
        'Public order identifier (UUIDv4) used wherever the sequential id / number must not be\nexposed or guessable — payment QR links, gateway return URLs, document access.',
      format: 'uuid',
    }),
    channel: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    shipments: Schema.Array(Shipmentsyliusshoporderindex),
    checkoutState: Schema.String.annotate({ default: 'cart' }),
    paymentState: Schema.String.annotate({ default: 'cart' }),
    shippingState: Schema.String.annotate({ default: 'cart' }),
    tokenValue: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    checkoutCompletedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    number: Schema.Union([Schema.String, Schema.Null]),
    items: Schema.Array(OrderItemsyliusshoporderindex),
    itemsTotal: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    total: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Items total + adjustments total.',
        default: 0,
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    state: Schema.String.annotate({ default: 'cart' }),
    vatFree: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'This is TRUE if Order price does NOT contain any VAT tax.',
        readOnly: true,
      })
    ),
    totalWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    itemsTotalWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Sum of price of all items WITHOUT VAT tax and WITHOUT shipping and payment price',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    shippingWithoutTaxTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Shipping price without VAT (total for all shipments)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    itemsSubtotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    taxTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns sum of neutral and non neutral tax adjustments on order and total tax of order items.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    shippingTaxTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    taxIncludedTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    invoiceUrl: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        description: 'Temporary Invoice file download url',
        readOnly: true,
      })
    ),
    globalState: Schema.optionalKey(
      Schema.Union([
        Schema.Literals([
          'AcceptedForPayment',
          'Paid',
          'AcceptedForProcessing',
          'Processing',
          'Resolved',
          'ResolvedStore',
          'ResolvedWithoutEmail',
          'Cancelled',
          'TopolPickup',
          'PardubicePickup',
          'NotPaidEmail',
          'NotPaidCancelled',
          'NotPickedUp',
        ]),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Ordersyliusshoporderindex' });
export type Ordersyliusshoporderindex = Schema.Schema.Type<typeof Ordersyliusshoporderindex>;
export type OrdersyliusshoporderindexEncoded = Schema.Codec.Encoded<
  typeof Ordersyliusshoporderindex
>;

/* Orderjsonldsyliusshopcartshowsyliusshopcartshowdetail */

export const Orderjsonldsyliusshopcartshowsyliusshopcartshowdetail = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    promotionRuleHints: Schema.Array(
      CartPromotionRuleHintsjsonldsyliusshopcartshowsyliusshopcartshowdetail
    ),
    customer: Schema.Union([Customerjsonldsyliusshopcartshowsyliusshopcartshowdetail, Schema.Null]),
    channel: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    shippingAddress: Schema.Union([
      Addressjsonldsyliusshopcartshowsyliusshopcartshowdetail,
      Schema.Null,
    ]),
    billingAddress: Schema.Union([
      Addressjsonldsyliusshopcartshowsyliusshopcartshowdetail,
      Schema.Null,
    ]),
    payments: Schema.Array(Paymentjsonldsyliusshopcartshowsyliusshopcartshowdetail),
    shipments: Schema.Array(Shipmentjsonldsyliusshopcartshowsyliusshopcartshowdetail),
    currencyCode: Schema.String,
    localeCode: Schema.String,
    promotionCoupon: Schema.Union([
      PromotionCouponjsonldsyliusshopcartshowsyliusshopcartshowdetail,
      Schema.Null,
    ]),
    checkoutState: Schema.String.annotate({ default: 'cart' }),
    paymentState: Schema.String.annotate({ default: 'cart' }),
    shippingState: Schema.String.annotate({ default: 'cart' }),
    tokenValue: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    checkoutCompletedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    number: Schema.Union([Schema.String, Schema.Null]),
    notes: Schema.Union([Schema.String, Schema.Null]),
    items: Schema.Array(OrderItemjsonldsyliusshopcartshowsyliusshopcartshowdetail),
    itemsTotal: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    total: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Items total + adjustments total.',
        default: 0,
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    state: Schema.String.annotate({ default: 'cart' }),
    vatFree: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'This is TRUE if Order price does NOT contain any VAT tax.',
        readOnly: true,
      })
    ),
    frontAllItemsPriceWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Sum of price of all items (without shipment and payment) after all discounts with VAT\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontAllItemsPriceWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Sum of price of all items (without shipment and payment) after all discounts without VAT',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontAllItemsDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Nominal value of sum of all discounts applied on (all) items\nValue is nominal for both nominal and percentage discounts\nNote: Because discount includes VAT, this sum also technically always includes discount from base+VAT price event\nif customer is verified to NOT pay VAT for Order!\nNumber is positive.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontAllItemsTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns nominal value of VAT from price AFTER discounts for all items\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontTotalWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns price including all items, shipment, payment and applied discounts\nAlways with VAT or NULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontTotalWithoutVat: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns price including all items, shipment, payment and applied discounts\nAlways without VAT even if customer pays VAT.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontFinalRounding: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns final rounding on entire Order. This correction is applied after everything even after TAX/VAT.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontTotalTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns nominal value of VAT from price AFTER discounts for all items\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontTotalPaid: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns FINAL price to be paid by customer including all items, shipment, payment, applied discounts\nand applied taxes if any. This number is number which should be sent to payment gate or displayed as number\nrepresenting how much will customer pay.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontShipmentTotalPaid: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns FINAL price to be paid by customer for shipment (after discount and including taxes if applied)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontPaymentTotalPaid: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns FINAL price to be paid by customer for payment (after discount and including taxes if applied)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontDeliveryTotalPaid: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns FINAL price to be paid by customer for delivery: shipment+payment (after discount and including taxes if applied)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontShipmentWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns shipment price before discount with VAT\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontShipmentDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns discount in nominal value of shipment (for both percentage and nominal discount)\nPositive number.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontShipmentWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns shipment price with VAT after applied discounts\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontShipmentWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns shipment price without VAT after applied discounts',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontShipmentTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns nominal value of VAT from price AFTER discounts for shipment\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontPaymentWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns payment price before discount with VAT\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontPaymentDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns discount in nominal value of payment (for both percentage and nominal discount)\nPositive number.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontPaymentWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns payment price with VAT after applied discounts\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontPaymentWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns payment price without VAT after applied discounts',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontPaymentTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns nominal value of VAT from price AFTER discounts for payment\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontDeliveryWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns delivery: shipment+payment price before discount with VAT\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontDeliveryDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns discount in nominal value of delivery: shipment+payment (for both percentage and nominal discount)\nPositive number.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontDeliveryWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns delivery: shipment+payment price with VAT after applied discounts\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontDeliveryWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns delivery: shipment+payment price without VAT after applied discounts',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontDeliveryTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns nominal value of VAT from price AFTER discounts for delivery: shipment+payment\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontShipmentDiscountPercentage: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns overall percentage discount on shipments calculated from base price with tax and applied nominal discounts.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontPaymentDiscountPercentage: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns overall percentage discount on payments calculated from base price with tax and applied nominal discounts.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontDeliveryDiscountPercentage: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    totalWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    itemsTotalWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Sum of price of all items WITHOUT VAT tax and WITHOUT shipping and payment price',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    orderPromotionTotalWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Order promotional total without VAT (total for all shipments)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    shippingWithoutTaxTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Shipping price without VAT (total for all shipments)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    paymentTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns payment fee price after promotion with applied taxes (for VIES valid non-CZ subjects price is without taxes!)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    paymentPromotionTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    paymentTax: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns only tax of payment method',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    paymentWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns only tax of payment method\nTODO: works only if tax is included in price (this is ok for now)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    orderPromotionTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns amount of order discount. Does not include shipping discounts.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    shippingPromotionTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    itemsSubtotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    taxTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns sum of neutral and non neutral tax adjustments on order and total tax of order items.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    shippingTaxTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    taxIncludedTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    shippingTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns shipping fee together with taxes decreased by shipping discount.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    globalState: Schema.optionalKey(
      Schema.Union([
        Schema.Literals([
          'AcceptedForPayment',
          'Paid',
          'AcceptedForProcessing',
          'Processing',
          'Resolved',
          'ResolvedStore',
          'ResolvedWithoutEmail',
          'Cancelled',
          'TopolPickup',
          'PardubicePickup',
          'NotPaidEmail',
          'NotPaidCancelled',
          'NotPickedUp',
        ]),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Orderjsonldsyliusshopcartshowsyliusshopcartshowdetail' });
export type Orderjsonldsyliusshopcartshowsyliusshopcartshowdetail = Schema.Schema.Type<
  typeof Orderjsonldsyliusshopcartshowsyliusshopcartshowdetail
>;
export type OrderjsonldsyliusshopcartshowsyliusshopcartshowdetailEncoded = Schema.Codec.Encoded<
  typeof Orderjsonldsyliusshopcartshowsyliusshopcartshowdetail
>;

/* Orderjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const Orderjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      promotionRuleHints: Schema.Array(
        CartPromotionRuleHintsjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
      ),
      customer: Schema.Union([
        Customerjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
        Schema.Null,
      ]),
      channel: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
      shippingAddress: Schema.Union([
        Addressjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
        Schema.Null,
      ]),
      billingAddress: Schema.Union([
        Addressjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
        Schema.Null,
      ]),
      payments: Schema.Array(
        Paymentjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
      ),
      shipments: Schema.Array(
        Shipmentjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
      ),
      currencyCode: Schema.String,
      localeCode: Schema.String,
      promotionCoupon: Schema.Union([
        PromotionCouponjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
        Schema.Null,
      ]),
      checkoutState: Schema.String.annotate({ default: 'cart' }),
      paymentState: Schema.String.annotate({ default: 'cart' }),
      shippingState: Schema.String.annotate({ default: 'cart' }),
      tokenValue: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
      checkoutCompletedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
      number: Schema.Union([Schema.String, Schema.Null]),
      notes: Schema.Union([Schema.String, Schema.Null]),
      items: Schema.Array(
        OrderItemjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
      ),
      itemsTotal: Schema.optionalKey(
        Schema.Number.annotate({ default: 0, readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      total: Schema.optionalKey(
        Schema.Number.annotate({
          description: 'Items total + adjustments total.',
          default: 0,
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      state: Schema.String.annotate({ default: 'cart' }),
      documents: Schema.optionalKey(
        Schema.Array(
          ProductDocumentjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
        ).annotate({ readOnly: true })
      ),
      vatFree: Schema.optionalKey(
        Schema.Boolean.annotate({
          description: 'This is TRUE if Order price does NOT contain any VAT tax.',
          readOnly: true,
        })
      ),
      frontAllItemsPriceWithVatAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Sum of price of all items (without shipment and payment) after all discounts with VAT\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontAllItemsPriceWithoutVatAfterDiscount: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Sum of price of all items (without shipment and payment) after all discounts without VAT',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontAllItemsDiscountAsNominalValue: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Nominal value of sum of all discounts applied on (all) items\nValue is nominal for both nominal and percentage discounts\nNote: Because discount includes VAT, this sum also technically always includes discount from base+VAT price event\nif customer is verified to NOT pay VAT for Order!\nNumber is positive.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontAllItemsTaxAppliedAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns nominal value of VAT from price AFTER discounts for all items\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontTotalWithVat: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns price including all items, shipment, payment and applied discounts\nAlways with VAT or NULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontTotalWithoutVat: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns price including all items, shipment, payment and applied discounts\nAlways without VAT even if customer pays VAT.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontFinalRounding: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns final rounding on entire Order. This correction is applied after everything even after TAX/VAT.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontTotalTaxAppliedAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns nominal value of VAT from price AFTER discounts for all items\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontTotalPaid: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns FINAL price to be paid by customer including all items, shipment, payment, applied discounts\nand applied taxes if any. This number is number which should be sent to payment gate or displayed as number\nrepresenting how much will customer pay.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontShipmentTotalPaid: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns FINAL price to be paid by customer for shipment (after discount and including taxes if applied)',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontPaymentTotalPaid: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns FINAL price to be paid by customer for payment (after discount and including taxes if applied)',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontDeliveryTotalPaid: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns FINAL price to be paid by customer for delivery: shipment+payment (after discount and including taxes if applied)',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontShipmentWithVat: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns shipment price before discount with VAT\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontShipmentDiscountAsNominalValue: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns discount in nominal value of shipment (for both percentage and nominal discount)\nPositive number.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontShipmentWithVatAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns shipment price with VAT after applied discounts\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontShipmentWithoutVatAfterDiscount: Schema.optionalKey(
        Schema.Number.annotate({
          description: 'Returns shipment price without VAT after applied discounts',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontShipmentTaxAppliedAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns nominal value of VAT from price AFTER discounts for shipment\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontPaymentWithVat: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns payment price before discount with VAT\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontPaymentDiscountAsNominalValue: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns discount in nominal value of payment (for both percentage and nominal discount)\nPositive number.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontPaymentWithVatAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns payment price with VAT after applied discounts\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontPaymentWithoutVatAfterDiscount: Schema.optionalKey(
        Schema.Number.annotate({
          description: 'Returns payment price without VAT after applied discounts',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontPaymentTaxAppliedAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns nominal value of VAT from price AFTER discounts for payment\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontDeliveryWithVat: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns delivery: shipment+payment price before discount with VAT\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontDeliveryDiscountAsNominalValue: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns discount in nominal value of delivery: shipment+payment (for both percentage and nominal discount)\nPositive number.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontDeliveryWithVatAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns delivery: shipment+payment price with VAT after applied discounts\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontDeliveryWithoutVatAfterDiscount: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns delivery: shipment+payment price without VAT after applied discounts',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontDeliveryTaxAppliedAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns nominal value of VAT from price AFTER discounts for delivery: shipment+payment\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontShipmentDiscountPercentage: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns overall percentage discount on shipments calculated from base price with tax and applied nominal discounts.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontPaymentDiscountPercentage: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns overall percentage discount on payments calculated from base price with tax and applied nominal discounts.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontDeliveryDiscountPercentage: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      totalWithoutTax: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      itemsTotalWithoutTax: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Sum of price of all items WITHOUT VAT tax and WITHOUT shipping and payment price',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      orderPromotionTotalWithoutTax: Schema.optionalKey(
        Schema.Number.annotate({
          description: 'Order promotional total without VAT (total for all shipments)',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      shippingWithoutTaxTotal: Schema.optionalKey(
        Schema.Number.annotate({
          description: 'Shipping price without VAT (total for all shipments)',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      paymentTotal: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns payment fee price after promotion with applied taxes (for VIES valid non-CZ subjects price is without taxes!)',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      paymentPromotionTotal: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      paymentTax: Schema.optionalKey(
        Schema.Number.annotate({
          description: 'Returns only tax of payment method',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      paymentWithoutTax: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns only tax of payment method\nTODO: works only if tax is included in price (this is ok for now)',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      orderPromotionTotal: Schema.optionalKey(
        Schema.Number.annotate({
          description: 'Returns amount of order discount. Does not include shipping discounts.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      shippingPromotionTotal: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      itemsSubtotal: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      taxTotal: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns sum of neutral and non neutral tax adjustments on order and total tax of order items.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      shippingTaxTotal: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      taxIncludedTotal: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      shippingTotal: Schema.optionalKey(
        Schema.Number.annotate({
          description: 'Returns shipping fee together with taxes decreased by shipping discount.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier: 'Orderjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type Orderjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof Orderjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type OrderjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof Orderjsonldsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* Orderjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid */

export const Orderjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.StructWithRest(
    Schema.Struct({
      '@context': Schema.optionalKey(
        Schema.Union(
          [
            Schema.String,
            Schema.StructWithRest(
              Schema.Struct({
                '@vocab': Schema.String,
                hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
              }),
              [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
            ),
          ],
          { mode: 'oneOf' }
        ).annotate({ readOnly: true })
      ),
      '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
      promotionRuleHints: Schema.Array(
        CartPromotionRuleHintsjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
      ),
      invoiceId: Schema.Union([Schema.String, Schema.Null]),
      customer: Schema.Union([
        Customerjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
        Schema.Null,
      ]),
      channel: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
      shippingAddress: Schema.Union([
        Addressjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
        Schema.Null,
      ]),
      billingAddress: Schema.Union([
        Addressjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
        Schema.Null,
      ]),
      payments: Schema.Array(
        Paymentjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
      ),
      shipments: Schema.Array(
        Shipmentjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
      ),
      currencyCode: Schema.String,
      localeCode: Schema.String,
      promotionCoupon: Schema.Union([
        PromotionCouponjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid,
        Schema.Null,
      ]),
      checkoutState: Schema.String.annotate({ default: 'cart' }),
      paymentState: Schema.String.annotate({ default: 'cart' }),
      shippingState: Schema.String.annotate({ default: 'cart' }),
      tokenValue: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
      ),
      checkoutCompletedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
      number: Schema.Union([Schema.String, Schema.Null]),
      notes: Schema.Union([Schema.String, Schema.Null]),
      items: Schema.Array(
        OrderItemjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
      ),
      itemsTotal: Schema.optionalKey(
        Schema.Number.annotate({ default: 0, readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      total: Schema.optionalKey(
        Schema.Number.annotate({
          description: 'Items total + adjustments total.',
          default: 0,
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      state: Schema.String.annotate({ default: 'cart' }),
      documents: Schema.optionalKey(
        Schema.Array(
          ProductDocumentjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
        ).annotate({ readOnly: true })
      ),
      vatFree: Schema.optionalKey(
        Schema.Boolean.annotate({
          description: 'This is TRUE if Order price does NOT contain any VAT tax.',
          readOnly: true,
        })
      ),
      frontAllItemsPriceWithVatAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Sum of price of all items (without shipment and payment) after all discounts with VAT\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontAllItemsPriceWithoutVatAfterDiscount: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Sum of price of all items (without shipment and payment) after all discounts without VAT',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontAllItemsDiscountAsNominalValue: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Nominal value of sum of all discounts applied on (all) items\nValue is nominal for both nominal and percentage discounts\nNote: Because discount includes VAT, this sum also technically always includes discount from base+VAT price event\nif customer is verified to NOT pay VAT for Order!\nNumber is positive.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontAllItemsTaxAppliedAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns nominal value of VAT from price AFTER discounts for all items\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontTotalWithVat: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns price including all items, shipment, payment and applied discounts\nAlways with VAT or NULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontTotalWithoutVat: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns price including all items, shipment, payment and applied discounts\nAlways without VAT even if customer pays VAT.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontFinalRounding: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns final rounding on entire Order. This correction is applied after everything even after TAX/VAT.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontTotalTaxAppliedAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns nominal value of VAT from price AFTER discounts for all items\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontTotalPaid: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns FINAL price to be paid by customer including all items, shipment, payment, applied discounts\nand applied taxes if any. This number is number which should be sent to payment gate or displayed as number\nrepresenting how much will customer pay.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontShipmentTotalPaid: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns FINAL price to be paid by customer for shipment (after discount and including taxes if applied)',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontPaymentTotalPaid: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns FINAL price to be paid by customer for payment (after discount and including taxes if applied)',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontDeliveryTotalPaid: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns FINAL price to be paid by customer for delivery: shipment+payment (after discount and including taxes if applied)',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontShipmentWithVat: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns shipment price before discount with VAT\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontShipmentDiscountAsNominalValue: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns discount in nominal value of shipment (for both percentage and nominal discount)\nPositive number.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontShipmentWithVatAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns shipment price with VAT after applied discounts\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontShipmentWithoutVatAfterDiscount: Schema.optionalKey(
        Schema.Number.annotate({
          description: 'Returns shipment price without VAT after applied discounts',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontShipmentTaxAppliedAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns nominal value of VAT from price AFTER discounts for shipment\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontPaymentWithVat: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns payment price before discount with VAT\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontPaymentDiscountAsNominalValue: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns discount in nominal value of payment (for both percentage and nominal discount)\nPositive number.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontPaymentWithVatAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns payment price with VAT after applied discounts\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontPaymentWithoutVatAfterDiscount: Schema.optionalKey(
        Schema.Number.annotate({
          description: 'Returns payment price without VAT after applied discounts',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontPaymentTaxAppliedAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns nominal value of VAT from price AFTER discounts for payment\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontDeliveryWithVat: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns delivery: shipment+payment price before discount with VAT\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontDeliveryDiscountAsNominalValue: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns discount in nominal value of delivery: shipment+payment (for both percentage and nominal discount)\nPositive number.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontDeliveryWithVatAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns delivery: shipment+payment price with VAT after applied discounts\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontDeliveryWithoutVatAfterDiscount: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns delivery: shipment+payment price without VAT after applied discounts',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontDeliveryTaxAppliedAfterDiscount: Schema.optionalKey(
        Schema.Union([
          Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
          Schema.Null,
        ]).annotate({
          description:
            'Returns nominal value of VAT from price AFTER discounts for delivery: shipment+payment\nNULL if customer is verified to NOT pay VAT for Order',
          readOnly: true,
        })
      ),
      frontShipmentDiscountPercentage: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns overall percentage discount on shipments calculated from base price with tax and applied nominal discounts.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontPaymentDiscountPercentage: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns overall percentage discount on payments calculated from base price with tax and applied nominal discounts.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      frontDeliveryDiscountPercentage: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      totalWithoutTax: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      itemsTotalWithoutTax: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Sum of price of all items WITHOUT VAT tax and WITHOUT shipping and payment price',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      orderPromotionTotalWithoutTax: Schema.optionalKey(
        Schema.Number.annotate({
          description: 'Order promotional total without VAT (total for all shipments)',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      shippingWithoutTaxTotal: Schema.optionalKey(
        Schema.Number.annotate({
          description: 'Shipping price without VAT (total for all shipments)',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      paymentTotal: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns payment fee price after promotion with applied taxes (for VIES valid non-CZ subjects price is without taxes!)',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      paymentPromotionTotal: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      paymentTax: Schema.optionalKey(
        Schema.Number.annotate({
          description: 'Returns only tax of payment method',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      paymentWithoutTax: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns only tax of payment method\nTODO: works only if tax is included in price (this is ok for now)',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      orderPromotionTotal: Schema.optionalKey(
        Schema.Number.annotate({
          description: 'Returns amount of order discount. Does not include shipping discounts.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      shippingPromotionTotal: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      itemsSubtotal: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      taxTotal: Schema.optionalKey(
        Schema.Number.annotate({
          description:
            'Returns sum of neutral and non neutral tax adjustments on order and total tax of order items.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      shippingTaxTotal: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      taxIncludedTotal: Schema.optionalKey(
        Schema.Number.annotate({ readOnly: true }).check(
          Schema.isInt().annotate({ expected: 'an integer' })
        )
      ),
      shippingTotal: Schema.optionalKey(
        Schema.Number.annotate({
          description: 'Returns shipping fee together with taxes decreased by shipping discount.',
          readOnly: true,
        }).check(Schema.isInt().annotate({ expected: 'an integer' }))
      ),
      invoiceUrl: Schema.optionalKey(
        Schema.Union([Schema.String, Schema.Null]).annotate({
          description: 'Temporary Invoice file download url',
          readOnly: true,
        })
      ),
      globalState: Schema.optionalKey(
        Schema.Union([
          Schema.Literals([
            'AcceptedForPayment',
            'Paid',
            'AcceptedForProcessing',
            'Processing',
            'Resolved',
            'ResolvedStore',
            'ResolvedWithoutEmail',
            'Cancelled',
            'TopolPickup',
            'PardubicePickup',
            'NotPaidEmail',
            'NotPaidCancelled',
            'NotPickedUp',
          ]),
          Schema.Null,
        ]).annotate({ readOnly: true })
      ),
    }),
    [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
  ).annotate({
    identifier:
      'Orderjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid',
  });
export type Orderjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid =
  Schema.Schema.Type<
    typeof Orderjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;
export type OrderjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaidEncoded =
  Schema.Codec.Encoded<
    typeof Orderjsonldsyliusshoporderaccountshowsyliusshopcartshowsyliusshopcartshowdetailsyliusshopcartshowpaid
  >;

/* Orderjsonldsyliusshoporderindex */

export const Orderjsonldsyliusshoporderindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    invoiceId: Schema.Union([Schema.String, Schema.Null]),
    identifier: Schema.String.annotate({
      description:
        'Public order identifier (UUIDv4) used wherever the sequential id / number must not be\nexposed or guessable — payment QR links, gateway return URLs, document access.',
      format: 'uuid',
    }),
    channel: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    shipments: Schema.Array(Shipmentjsonldsyliusshoporderindex),
    checkoutState: Schema.String.annotate({ default: 'cart' }),
    paymentState: Schema.String.annotate({ default: 'cart' }),
    shippingState: Schema.String.annotate({ default: 'cart' }),
    tokenValue: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    checkoutCompletedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    number: Schema.Union([Schema.String, Schema.Null]),
    items: Schema.Array(OrderItemjsonldsyliusshoporderindex),
    itemsTotal: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    total: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Items total + adjustments total.',
        default: 0,
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    state: Schema.String.annotate({ default: 'cart' }),
    vatFree: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'This is TRUE if Order price does NOT contain any VAT tax.',
        readOnly: true,
      })
    ),
    totalWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    itemsTotalWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Sum of price of all items WITHOUT VAT tax and WITHOUT shipping and payment price',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    shippingWithoutTaxTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Shipping price without VAT (total for all shipments)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    itemsSubtotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    taxTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns sum of neutral and non neutral tax adjustments on order and total tax of order items.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    shippingTaxTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    taxIncludedTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    invoiceUrl: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        description: 'Temporary Invoice file download url',
        readOnly: true,
      })
    ),
    globalState: Schema.optionalKey(
      Schema.Union([
        Schema.Literals([
          'AcceptedForPayment',
          'Paid',
          'AcceptedForProcessing',
          'Processing',
          'Resolved',
          'ResolvedStore',
          'ResolvedWithoutEmail',
          'Cancelled',
          'TopolPickup',
          'PardubicePickup',
          'NotPaidEmail',
          'NotPaidCancelled',
          'NotPickedUp',
        ]),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Orderjsonldsyliusshoporderindex' });
export type Orderjsonldsyliusshoporderindex = Schema.Schema.Type<
  typeof Orderjsonldsyliusshoporderindex
>;
export type OrderjsonldsyliusshoporderindexEncoded = Schema.Codec.Encoded<
  typeof Orderjsonldsyliusshoporderindex
>;

/* UrlMatchroutershow */

export const UrlMatchroutershow = Schema.StructWithRest(
  Schema.Struct({
    view: Schema.Union([
      Schema.Literals([
        'notFound',
        'product',
        'category',
        'brands',
        'articles',
        'pages',
        'articles_category',
        'articles_author',
        'faq_topics',
        'faq_questions',
        'glossary_terms',
      ]),
      Schema.Null,
    ]),
    data: Schema.optionalKey(
      Schema.Array(
        Schema.Union([
          Productjsonldsyliusshopproductshowsyliusshopproductshowdetail,
          Productsyliusshopproductshowsyliusshopproductshowdetail,
          Brandjsonldsyliusshopbrandshowdetail,
          Brandsyliusshopbrandshowdetail,
          Schema.suspend(
            (): Schema.Codec<Taxonjsonldsyliusshoptaxonshowdetail> =>
              Taxonjsonldsyliusshoptaxonshowdetail
          ),
          Schema.suspend(
            (): Schema.Codec<Taxonsyliusshoptaxonshowdetail> => Taxonsyliusshoptaxonshowdetail
          ),
          Articlejsonldsyliusshoparticleshow,
          Articlesyliusshoparticleshow,
          Pagejsonldsyliusshoppageshow,
          Pagesyliusshoppageshow,
          Authorjsonldsyliusshopauthorindex,
          Authorsyliusshopauthorindex,
          Categoryjsonldsyliusshopcategoryindex,
          Categorysyliusshopcategoryindex,
          FaqTopicjsonldsyliusshopfaqtopicindex,
          FaqTopicsyliusshopfaqtopicindex,
          FaqQuestionjsonldsyliusshopfaqquestionindex,
          FaqQuestionsyliusshopfaqquestionindex,
          Schema.suspend(
            (): Schema.Codec<FaqQuestionjsonldsyliusshopfaqquestionshow> =>
              FaqQuestionjsonldsyliusshopfaqquestionshow
          ),
          Schema.suspend(
            (): Schema.Codec<FaqQuestionsyliusshopfaqquestionshow> =>
              FaqQuestionsyliusshopfaqquestionshow
          ),
          GlossaryTermjsonldsyliusshopglossaryshow,
          GlossaryTermsyliusshopglossaryshow,
        ])
      )
    ),
    status: Schema.Literals([
      'found',
      'notFound',
      'permanentRedirect',
      'invalidUrl',
      'unknownDomain',
      'redirectFailed',
    ]),
    channel: Schema.Union([Channelroutershow, Schema.Null]),
    url: Schema.Union([UrlConstructroutershow, Schema.Null]),
    dbParams: Schema.Union(
      [
        Schema.Record(Schema.String, Schema.Never),
        Schema.Struct({
          id: Schema.optionalKey(
            Schema.Union(
              [
                Schema.Number.annotate({ format: 'int64' }).check(
                  Schema.isInt().annotate({ expected: 'an integer' })
                ),
                Schema.String.annotate({ format: 'uuid' }),
              ],
              { mode: 'oneOf' }
            )
          ),
        }),
        Schema.Struct({ code: Schema.optionalKey(Schema.String) }),
        Schema.Struct({
          id: Schema.optionalKey(
            Schema.Union(
              [
                Schema.Number.annotate({ format: 'int64' }).check(
                  Schema.isInt().annotate({ expected: 'an integer' })
                ),
                Schema.String.annotate({ format: 'uuid' }),
              ],
              { mode: 'oneOf' }
            )
          ),
          code: Schema.optionalKey(Schema.String),
        }),
      ],
      { mode: 'oneOf' }
    ),
    queryParams: Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({
  description:
    'Resolves a frontend URL to the matched internal view, its routing parameters and (optionally)\nthe routed entity itself.',
  identifier: 'UrlMatchroutershow',
});
export type UrlMatchroutershow = Schema.Schema.Type<typeof UrlMatchroutershow>;
export type UrlMatchroutershowEncoded = Schema.Codec.Encoded<typeof UrlMatchroutershow>;

/* UrlMatchjsonldroutershow */

export const UrlMatchjsonldroutershow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    view: Schema.Union([
      Schema.Literals([
        'notFound',
        'product',
        'category',
        'brands',
        'articles',
        'pages',
        'articles_category',
        'articles_author',
        'faq_topics',
        'faq_questions',
        'glossary_terms',
      ]),
      Schema.Null,
    ]),
    data: Schema.optionalKey(
      Schema.Array(
        Schema.Union([
          Productjsonldsyliusshopproductshowsyliusshopproductshowdetail,
          Productsyliusshopproductshowsyliusshopproductshowdetail,
          Brandjsonldsyliusshopbrandshowdetail,
          Brandsyliusshopbrandshowdetail,
          Schema.suspend(
            (): Schema.Codec<Taxonjsonldsyliusshoptaxonshowdetail> =>
              Taxonjsonldsyliusshoptaxonshowdetail
          ),
          Schema.suspend(
            (): Schema.Codec<Taxonsyliusshoptaxonshowdetail> => Taxonsyliusshoptaxonshowdetail
          ),
          Articlejsonldsyliusshoparticleshow,
          Articlesyliusshoparticleshow,
          Pagejsonldsyliusshoppageshow,
          Pagesyliusshoppageshow,
          Authorjsonldsyliusshopauthorindex,
          Authorsyliusshopauthorindex,
          Categoryjsonldsyliusshopcategoryindex,
          Categorysyliusshopcategoryindex,
          FaqTopicjsonldsyliusshopfaqtopicindex,
          FaqTopicsyliusshopfaqtopicindex,
          FaqQuestionjsonldsyliusshopfaqquestionindex,
          FaqQuestionsyliusshopfaqquestionindex,
          Schema.suspend(
            (): Schema.Codec<FaqQuestionjsonldsyliusshopfaqquestionshow> =>
              FaqQuestionjsonldsyliusshopfaqquestionshow
          ),
          Schema.suspend(
            (): Schema.Codec<FaqQuestionsyliusshopfaqquestionshow> =>
              FaqQuestionsyliusshopfaqquestionshow
          ),
          GlossaryTermjsonldsyliusshopglossaryshow,
          GlossaryTermsyliusshopglossaryshow,
        ])
      )
    ),
    status: Schema.Literals([
      'found',
      'notFound',
      'permanentRedirect',
      'invalidUrl',
      'unknownDomain',
      'redirectFailed',
    ]),
    channel: Schema.Union([Channeljsonldroutershow, Schema.Null]),
    url: Schema.Union([UrlConstructjsonldroutershow, Schema.Null]),
    dbParams: Schema.Union(
      [
        Schema.Record(Schema.String, Schema.Never),
        Schema.Struct({
          id: Schema.optionalKey(
            Schema.Union(
              [
                Schema.Number.annotate({ format: 'int64' }).check(
                  Schema.isInt().annotate({ expected: 'an integer' })
                ),
                Schema.String.annotate({ format: 'uuid' }),
              ],
              { mode: 'oneOf' }
            )
          ),
        }),
        Schema.Struct({ code: Schema.optionalKey(Schema.String) }),
        Schema.Struct({
          id: Schema.optionalKey(
            Schema.Union(
              [
                Schema.Number.annotate({ format: 'int64' }).check(
                  Schema.isInt().annotate({ expected: 'an integer' })
                ),
                Schema.String.annotate({ format: 'uuid' }),
              ],
              { mode: 'oneOf' }
            )
          ),
          code: Schema.optionalKey(Schema.String),
        }),
      ],
      { mode: 'oneOf' }
    ),
    queryParams: Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({
  description:
    'Resolves a frontend URL to the matched internal view, its routing parameters and (optionally)\nthe routed entity itself.',
  identifier: 'UrlMatchjsonldroutershow',
});
export type UrlMatchjsonldroutershow = Schema.Schema.Type<typeof UrlMatchjsonldroutershow>;
export type UrlMatchjsonldroutershowEncoded = Schema.Codec.Encoded<typeof UrlMatchjsonldroutershow>;

/* Transaction */

export const Transaction = Schema.StructWithRest(
  Schema.Struct({
    pohodaRefId: Schema.Union([Schema.String, Schema.Null]).annotate({
      description:
        'Id of the bank book movement created in Pohoda for this transaction. Null until exported.',
    }),
    id: Schema.optionalKey(Schema.String.annotate({ readOnly: true, format: 'uuid' })),
    bankAccount: Schema.suspend((): Schema.Codec<BankAccount> => BankAccount),
    order: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'iri-reference' }),
    identifier: Schema.String,
    amount: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    currency: Schema.String.annotate({ format: 'iri-reference' }),
    transactionDate: DateTimeSerializableFromString,
    statementDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    description: Schema.Union([Schema.String, Schema.Null]),
    counterpartyName: Schema.Union([Schema.String, Schema.Null]),
    counterpartyAccount: Schema.Union([Schema.String, Schema.Null]),
    variableSymbol: Schema.Union([Schema.String, Schema.Null]),
    constantSymbol: Schema.Union([Schema.String, Schema.Null]),
    specificSymbol: Schema.Union([Schema.String, Schema.Null]),
    meta: Schema.Union([
      Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
      Schema.Null,
    ]),
    checked: Schema.Boolean.annotate({ default: false }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Transaction' });
export type Transaction = Schema.Schema.Type<typeof Transaction>;
export type TransactionEncoded = Schema.Codec.Encoded<typeof Transaction>;

/* BankAccount */

export const BankAccount = Schema.StructWithRest(
  Schema.Struct({
    pohodaRefIds: Schema.Union([Schema.String, Schema.Null]).annotate({
      description:
        "Reference (IDS / code) of the corresponding bank account in Pohoda. When set, the account's\ntransactions are exported as bank book movements under this Pohoda account.",
    }),
    id: Schema.optionalKey(Schema.String.annotate({ readOnly: true, format: 'uuid' })),
    code: Schema.String,
    iban: Schema.Union([Schema.String, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    defaultChannel: Schema.Union([Schema.String, Schema.Null]).annotate({
      format: 'iri-reference',
    }),
    type: Schema.Literals(['fio', 'comgate', 'other']),
    config: Schema.Union([
      Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
      Schema.Null,
    ]),
    autoCheckUnmatched: Schema.Boolean.annotate({ default: false }),
    transactions: Schema.Array(Schema.suspend((): Schema.Codec<Transaction> => Transaction)),
    bankAccountCZ: Schema.optionalKey(
      Schema.Union([BankAccountCZ, Schema.Null]).annotate({ readOnly: true })
    ),
    bankAccountAsIban: Schema.optionalKey(
      Schema.Union([Iban, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'BankAccount' });
export type BankAccount = Schema.Schema.Type<typeof BankAccount>;
export type BankAccountEncoded = Schema.Codec.Encoded<typeof BankAccount>;

/* ZoneMember */

export const ZoneMember = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    belongsTo: Schema.Union([Schema.suspend((): Schema.Codec<Zone> => Zone), Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ZoneMember' });
export type ZoneMember = Schema.Schema.Type<typeof ZoneMember>;
export type ZoneMemberEncoded = Schema.Codec.Encoded<typeof ZoneMember>;

/* Zone */

export const Zone = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.String,
    type: Schema.String,
    scope: Schema.String.annotate({ default: 'all' }),
    members: Schema.Array(Schema.suspend((): Schema.Codec<ZoneMember> => ZoneMember)),
    priority: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    membersTyped: Schema.optionalKey(
      Schema.Array(Schema.suspend((): Schema.Codec<ZoneMember> => ZoneMember)).annotate({
        readOnly: true,
      })
    ),
    types: Schema.optionalKey(Schema.Json.annotate({ expected: 'JSON value', readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Zone' });
export type Zone = Schema.Schema.Type<typeof Zone>;
export type ZoneEncoded = Schema.Codec.Encoded<typeof Zone>;

/* Province */

export const Province = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.String,
    abbreviation: Schema.Union([Schema.String, Schema.Null]),
    country: Schema.suspend((): Schema.Codec<Country> => Country),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Province' });
export type Province = Schema.Schema.Type<typeof Province>;
export type ProvinceEncoded = Schema.Codec.Encoded<typeof Province>;

/* Country */

export const Country = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String.annotate({ description: 'Country code ISO 3166-1 alpha-2.' }),
    provinces: Schema.Array(Schema.suspend((): Schema.Codec<Province> => Province)),
    enabled: Schema.Boolean.annotate({ default: true }),
    provincesTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Country' });
export type Country = Schema.Schema.Type<typeof Country>;
export type CountryEncoded = Schema.Codec.Encoded<typeof Country>;

/* TranslatableInterface */

export const TranslatableInterface = Schema.StructWithRest(
  Schema.Struct({
    translations: Schema.Union([
      Schema.suspend((): Schema.Codec<TranslationInterface> => TranslationInterface),
      Schema.Array(Schema.suspend((): Schema.Codec<TranslationInterface> => TranslationInterface)),
    ]),
    translation: Schema.Array(
      Schema.suspend((): Schema.Codec<TranslationInterface> => TranslationInterface)
    ),
    currentLocale: Schema.String.annotate({ writeOnly: true }),
    fallbackLocale: Schema.String.annotate({ writeOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TranslatableInterface' });
export type TranslatableInterface = Schema.Schema.Type<typeof TranslatableInterface>;
export type TranslatableInterfaceEncoded = Schema.Codec.Encoded<typeof TranslatableInterface>;

/* TranslationInterface */

export const TranslationInterface = Schema.StructWithRest(
  Schema.Struct({
    translatable: Schema.Union([
      Schema.suspend((): Schema.Codec<TranslatableInterface> => TranslatableInterface),
      Schema.Null,
    ]),
    locale: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TranslationInterface' });
export type TranslationInterface = Schema.Schema.Type<typeof TranslationInterface>;
export type TranslationInterfaceEncoded = Schema.Codec.Encoded<typeof TranslationInterface>;

/* DocumentType */

export const DocumentType = Schema.StructWithRest(
  Schema.Struct({
    mode: Schema.Union([
      Schema.Literals(['public', 'publicAndNotify', 'hiddenAndNotify']),
      Schema.Null,
    ]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    position: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    productDocuments: Schema.Array(
      Schema.suspend((): Schema.Codec<ProductDocument> => ProductDocument)
    ),
    documentType: Schema.Union([
      Schema.suspend((): Schema.Codec<DocumentType> => DocumentType),
      Schema.Null,
    ]),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
    currentLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    fallbackLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    translation: Schema.Array(
      Schema.suspend((): Schema.Codec<TranslationInterface> => TranslationInterface)
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'DocumentType' });
export type DocumentType = Schema.Schema.Type<typeof DocumentType>;
export type DocumentTypeEncoded = Schema.Codec.Encoded<typeof DocumentType>;

/* ProductDocument */

export const ProductDocument = Schema.StructWithRest(
  Schema.Struct({
    originalPath: Schema.Union([Schema.String, Schema.Null]),
    lastSync: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    product: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'iri-reference' }),
    createdAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    documentType: Schema.suspend((): Schema.Codec<DocumentType> => DocumentType),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    name: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    file: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'binary' }),
    path: Schema.String,
    publicPath: Schema.Union([Schema.String, Schema.Null]),
    hasPath: Schema.optionalKey(Schema.Json.annotate({ expected: 'JSON value', readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductDocument' });
export type ProductDocument = Schema.Schema.Type<typeof ProductDocument>;
export type ProductDocumentEncoded = Schema.Codec.Encoded<typeof ProductDocument>;

/* Taxon */

export const Taxon = Schema.StructWithRest(
  Schema.Struct({
    searchWeight: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Null,
    ]),
    articleCategories: Schema.optionalKey(
      Schema.Array(Schema.suspend((): Schema.Codec<Category> => Category)).annotate({
        readOnly: true,
      })
    ),
    feedCategories: Schema.Array(FeedCategory),
    productTaxons: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    listing: Schema.Literals(['ajax', 'inline']),
    visibility: Schema.Literals(['hideInMenu', 'hideCompletely', 'visible']),
    showOnHomepage: Schema.Boolean.annotate({ default: false }),
    children: Schema.optionalKey(
      Schema.Array(
        Schema.Union([
          Schema.suspend(
            (): Schema.Codec<Taxonjsonldsyliusshoptaxonshowdetail> =>
              Taxonjsonldsyliusshoptaxonshowdetail
          ),
          Schema.suspend(
            (): Schema.Codec<Taxonsyliusshoptaxonshowdetail> => Taxonsyliusshoptaxonshowdetail
          ),
          Schema.String.annotate({
            description: 'IRI na Taxon při překročení MaxDepth',
            format: 'uri',
          }),
        ])
      ).annotate({
        description: 'První úroveň = objekt Taxon, hlubší úrovně = IRI.',
        readOnly: true,
      })
    ),
    images: Schema.optionalKey(Schema.Array(TaxonImage).annotate({ readOnly: true })),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    root: Schema.optionalKey(
      Schema.Union([Schema.suspend((): Schema.Codec<Taxon> => Taxon), Schema.Null]).annotate({
        readOnly: true,
      })
    ),
    parent: Schema.Union([Schema.suspend((): Schema.Codec<Taxon> => Taxon), Schema.Null]),
    left: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    right: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    level: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    currentLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    fallbackLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    enabled: Schema.Boolean.annotate({ default: true }),
    imagesTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
    nameInTaxonList: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    metaDescription: Schema.Union([Schema.String, Schema.Null]),
    translationClass: Schema.optionalKey(
      Schema.Json.annotate({ expected: 'JSON value', readOnly: true })
    ),
    ancestors: Schema.optionalKey(
      Schema.Array(Schema.suspend((): Schema.Codec<Taxon> => Taxon)).annotate({ readOnly: true })
    ),
    enabledChildren: Collection,
    fullname: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    translation: TaxonTranslation,
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxon' });
export type Taxon = Schema.Schema.Type<typeof Taxon>;
export type TaxonEncoded = Schema.Codec.Encoded<typeof Taxon>;

/* Taxonsyliusshoptaxonshowdetail */

export const Taxonsyliusshoptaxonshowdetail = Schema.StructWithRest(
  Schema.Struct({
    listing: Schema.Literals(['ajax', 'inline']),
    visibility: Schema.Literals(['hideInMenu', 'hideCompletely', 'visible']),
    images: Schema.optionalKey(
      Schema.Array(TaxonImagesyliusshoptaxonshowdetail).annotate({ readOnly: true })
    ),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    children: Schema.optionalKey(
      Schema.Array(
        Schema.Union(
          [
            Schema.suspend(
              (): Schema.Codec<Taxonsyliusshoptaxonshowdetail> => Taxonsyliusshoptaxonshowdetail
            ),
            Schema.String.annotate({
              description: 'IRI na Taxon při překročení MaxDepth',
              format: 'uri',
            }),
          ],
          { mode: 'oneOf' }
        )
      ).annotate({
        description: 'První úroveň = objekt Taxon, hlubší úrovně = IRI.',
        readOnly: true,
      })
    ),
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
    nameInTaxonList: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    metaDescription: Schema.Union([Schema.String, Schema.Null]),
    attributes: Schema.optionalKey(
      Schema.Array(ProductAttributesyliusshoptaxonshowdetail).annotate({ readOnly: true })
    ),
    banners: Schema.optionalKey(
      Schema.Array(Bannersyliusshopbannerindex).annotate({ readOnly: true })
    ),
    breadcrumbs: Schema.optionalKey(
      Schema.Array(Taxonsyliusshoptaxonindex).annotate({ readOnly: true })
    ),
    priceRange: Schema.optionalKey(
      Schema.StructWithRest(
        Schema.Struct({
          min: Schema.optionalKey(
            Schema.Number.annotate({
              description: 'Minimum price in minor units (e.g., cents).',
            }).check(Schema.isInt().annotate({ expected: 'an integer' }))
          ),
          max: Schema.optionalKey(
            Schema.Number.annotate({
              description: 'Maximum price in minor units (e.g., cents).',
            }).check(Schema.isInt().annotate({ expected: 'an integer' }))
          ),
        }),
        [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
      ).annotate({ readOnly: true })
    ),
    articles: Schema.optionalKey(
      Schema.Array(Articlesyliusshoparticleindexfavourite).annotate({ readOnly: true })
    ),
    brands: Schema.optionalKey(
      Schema.Array(Brandsyliusshopbrandindexdetail).annotate({ readOnly: true })
    ),
    totalProducts: Schema.optionalKey(
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonsyliusshoptaxonshowdetail' });
export type Taxonsyliusshoptaxonshowdetail = Schema.Schema.Type<
  typeof Taxonsyliusshoptaxonshowdetail
>;
export type TaxonsyliusshoptaxonshowdetailEncoded = Schema.Codec.Encoded<
  typeof Taxonsyliusshoptaxonshowdetail
>;

/* Taxonjsonldsyliusshoptaxonshowdetail */

export const Taxonjsonldsyliusshoptaxonshowdetail = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    listing: Schema.Literals(['ajax', 'inline']),
    visibility: Schema.Literals(['hideInMenu', 'hideCompletely', 'visible']),
    images: Schema.optionalKey(
      Schema.Array(TaxonImagejsonldsyliusshoptaxonshowdetail).annotate({ readOnly: true })
    ),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    children: Schema.optionalKey(
      Schema.Array(
        Schema.Union(
          [
            Schema.suspend(
              (): Schema.Codec<Taxonjsonldsyliusshoptaxonshowdetail> =>
                Taxonjsonldsyliusshoptaxonshowdetail
            ),
            Schema.String.annotate({
              description: 'IRI na Taxon při překročení MaxDepth',
              format: 'uri',
            }),
          ],
          { mode: 'oneOf' }
        )
      ).annotate({
        description: 'První úroveň = objekt Taxon, hlubší úrovně = IRI.',
        readOnly: true,
      })
    ),
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
    nameInTaxonList: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    metaDescription: Schema.Union([Schema.String, Schema.Null]),
    attributes: Schema.optionalKey(
      Schema.Array(ProductAttributejsonldsyliusshoptaxonshowdetail).annotate({ readOnly: true })
    ),
    banners: Schema.optionalKey(
      Schema.Array(Bannerjsonldsyliusshopbannerindex).annotate({ readOnly: true })
    ),
    breadcrumbs: Schema.optionalKey(
      Schema.Array(Taxonjsonldsyliusshoptaxonindex).annotate({ readOnly: true })
    ),
    priceRange: Schema.optionalKey(
      Schema.StructWithRest(
        Schema.Struct({
          min: Schema.optionalKey(
            Schema.Number.annotate({
              description: 'Minimum price in minor units (e.g., cents).',
            }).check(Schema.isInt().annotate({ expected: 'an integer' }))
          ),
          max: Schema.optionalKey(
            Schema.Number.annotate({
              description: 'Maximum price in minor units (e.g., cents).',
            }).check(Schema.isInt().annotate({ expected: 'an integer' }))
          ),
        }),
        [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
      ).annotate({ readOnly: true })
    ),
    articles: Schema.optionalKey(
      Schema.Array(Articlejsonldsyliusshoparticleindexfavourite).annotate({ readOnly: true })
    ),
    brands: Schema.optionalKey(
      Schema.Array(Brandjsonldsyliusshopbrandindexdetail).annotate({ readOnly: true })
    ),
    totalProducts: Schema.optionalKey(
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonjsonldsyliusshoptaxonshowdetail' });
export type Taxonjsonldsyliusshoptaxonshowdetail = Schema.Schema.Type<
  typeof Taxonjsonldsyliusshoptaxonshowdetail
>;
export type TaxonjsonldsyliusshoptaxonshowdetailEncoded = Schema.Codec.Encoded<
  typeof Taxonjsonldsyliusshoptaxonshowdetail
>;

/* Category */

export const Category = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.String.annotate({ format: 'uuid' }),
    code: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    enabled: Schema.Boolean,
    image: Schema.Union([CategoryImage, Schema.Null]),
    articles: Schema.Array(Schema.suspend((): Schema.Codec<Article> => Article)),
    taxons: Schema.Array(Schema.suspend((): Schema.Codec<Taxon> => Taxon)),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
    currentLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    fallbackLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    metaDescription: Schema.Union([Schema.String, Schema.Null]),
    translation: Schema.Array(
      Schema.suspend((): Schema.Codec<TranslationInterface> => TranslationInterface)
    ),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Category' });
export type Category = Schema.Schema.Type<typeof Category>;
export type CategoryEncoded = Schema.Codec.Encoded<typeof Category>;

/* Article */

export const Article = Schema.StructWithRest(
  Schema.Struct({
    section: Schema.String.annotate({ format: 'iri-reference' }),
    favourite: Schema.Boolean.annotate({ default: false }),
    products: Schema.Array(Schema.suspend((): Schema.Codec<Product> => Product)),
    categories: Schema.Array(Schema.suspend((): Schema.Codec<Category> => Category)),
    image: Schema.Union([Schema.String, Schema.Null]),
    video: Schema.Union([Schema.String, Schema.Null]),
    thumbnailImage: Schema.Union([Schema.String, Schema.Null]),
    enabled: Schema.Boolean.annotate({ default: true }),
    channels: Schema.Array(Schema.suspend((): Schema.Codec<Channel> => Channel)),
    tags: Schema.Array(Tag),
    publishedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    authors: Schema.Array(Author),
    type: Schema.String.annotate({ default: 'blog' }),
    state: Schema.String.annotate({ default: 'draft' }),
    createdAt: DateTimeSerializableFromString,
    updatedAt: DateTimeSerializableFromString,
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
    currentLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    fallbackLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    imageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    thumbnailImageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    metaImageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    title: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    metaDescription: Schema.Union([Schema.String, Schema.Null]),
    metaKeywords: Schema.Union([Schema.String, Schema.Null]),
    metaImage: Schema.Union([Schema.String, Schema.Null]),
    content: Schema.String,
    translation: Schema.Array(
      Schema.suspend((): Schema.Codec<TranslationInterface> => TranslationInterface)
    ),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Article' });
export type Article = Schema.Schema.Type<typeof Article>;
export type ArticleEncoded = Schema.Codec.Encoded<typeof Article>;

/* Channel */

export const Channel = Schema.StructWithRest(
  Schema.Struct({
    pohodaCentre: Schema.Union([Schema.String, Schema.Null]),
    pohodaPriceLevel: Schema.Union([Schema.String, Schema.Null]),
    pohodaRounding: Schema.Union([
      Schema.Literals([
        'none',
        'math2one',
        'math2half',
        'math2tenth',
        'math5cent',
        'up2one',
        'up2half',
        'up2tenth',
        'down2one',
        'down2half',
        'down2tenth',
      ]),
      Schema.Null,
    ]),
    bankAccount: Schema.Union([
      Schema.suspend((): Schema.Codec<BankAccount> => BankAccount),
      Schema.Null,
    ]),
    ecomailListId: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    heurekaApiKey: Schema.Union([Schema.String, Schema.Null]),
    zboziApiKey: Schema.Union([Schema.String, Schema.Null]),
    baseCurrency: Currency,
    defaultLocale: Locale,
    defaultTaxZone: Schema.Union([Schema.suspend((): Schema.Codec<Zone> => Zone), Schema.Null]),
    taxCalculationStrategy: Schema.String,
    currencies: Schema.Array(Currency),
    locales: Schema.Array(Locale),
    countries: Schema.Array(Schema.suspend((): Schema.Codec<Country> => Country)),
    themeName: Schema.Union([Schema.String, Schema.Null]),
    contactEmail: Schema.Union([Schema.String, Schema.Null]),
    contactPhoneNumber: Schema.Union([Schema.String, Schema.Null]),
    skippingShippingStepAllowed: Schema.Boolean.annotate({ default: false }),
    skippingPaymentStepAllowed: Schema.Boolean.annotate({ default: false }),
    accountVerificationRequired: Schema.Boolean.annotate({ default: true }),
    shippingAddressInCheckoutRequired: Schema.Boolean.annotate({ default: false }),
    shopBillingData: Schema.Union([ShopBillingData, Schema.Null]),
    menuTaxon: Schema.Union([Schema.suspend((): Schema.Codec<Taxon> => Taxon), Schema.Null]),
    channelPriceHistoryConfig: Schema.Union([
      Schema.suspend((): Schema.Codec<ChannelPriceHistoryConfig> => ChannelPriceHistoryConfig),
      Schema.Null,
    ]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.String,
    description: Schema.Union([Schema.String, Schema.Null]),
    hostname: Schema.Union([Schema.String, Schema.Null]),
    color: Schema.Union([Schema.String, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    enabled: Schema.Boolean.annotate({ default: true }),
    currenciesTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    localesTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    countriesTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    enabledCountries: Collection,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Channel' });
export type Channel = Schema.Schema.Type<typeof Channel>;
export type ChannelEncoded = Schema.Codec.Encoded<typeof Channel>;

/* ChannelPriceHistoryConfig */

export const ChannelPriceHistoryConfig = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    lowestPriceForDiscountedProductsCheckingPeriod: Schema.Number.annotate({ default: 30 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    lowestPriceForDiscountedProductsVisible: Schema.Boolean.annotate({ default: true }),
    taxonsExcludedFromShowingLowestPrice: Schema.optionalKey(
      Schema.Array(Schema.suspend((): Schema.Codec<Taxon> => Taxon)).annotate({ readOnly: true })
    ),
    taxonsExcludedFromShowingLowestPriceTyped: Schema.optionalKey(
      Schema.Array(Schema.suspend((): Schema.Codec<Taxon> => Taxon)).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ChannelPriceHistoryConfig' });
export type ChannelPriceHistoryConfig = Schema.Schema.Type<typeof ChannelPriceHistoryConfig>;
export type ChannelPriceHistoryConfigEncoded = Schema.Codec.Encoded<
  typeof ChannelPriceHistoryConfig
>;

/* Product */

export const Product = Schema.StructWithRest(
  Schema.Struct({
    ageRestriction: Schema.Literals(['none', '18+']),
    feedTop: Schema.Boolean.annotate({ default: false }),
    articles: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    productDocuments: Schema.Array(
      Schema.suspend((): Schema.Codec<ProductDocument> => ProductDocument)
    ),
    brand: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'iri-reference' }),
    videos: Schema.Array(ProductVideo),
    sellingPriceSynchronized: Schema.Boolean.annotate({
      description:
        "Whether warehouse selling prices may overwrite the channel pricing's selling price.",
      default: true,
    }),
    stockSynchronized: Schema.Boolean.annotate({
      description: "Whether warehouse quantities may overwrite the variant's available quantity.",
      default: true,
    }),
    warrantyMonths: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({
      description: 'Warranty length in months (unsigned smallint, null = unspecified)',
    }),
    ean: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'EAN/GTIN barcode, max 20 chars',
    }),
    variantSelectionMethod: Schema.String.annotate({ default: 'choice' }),
    productTaxons: Schema.Array(Schema.suspend((): Schema.Codec<ProductTaxon> => ProductTaxon)),
    channels: Schema.Array(Schema.suspend((): Schema.Codec<Channel> => Channel)),
    mainTaxon: Schema.Union([Schema.suspend((): Schema.Codec<Taxon> => Taxon), Schema.Null]),
    reviews: Schema.Array(Schema.suspend((): Schema.Codec<ProductReview> => ProductReview)),
    averageRating: Schema.Number.annotate({ default: 0 }).check(
      Schema.isFinite().annotate({ expected: 'a finite number' })
    ),
    images: Schema.optionalKey(
      Schema.Array(Schema.suspend((): Schema.Codec<ProductImage> => ProductImage)).annotate({
        readOnly: true,
      })
    ),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    attributes: Schema.Array(
      Schema.suspend((): Schema.Codec<ProductAttributeValue> => ProductAttributeValue)
    ),
    variants: Schema.Array(Schema.suspend((): Schema.Codec<ProductVariant> => ProductVariant)),
    options: Schema.Array(Schema.suspend((): Schema.Codec<ProductOption> => ProductOption)),
    associations: Schema.Array(
      Schema.suspend((): Schema.Codec<ProductAssociation> => ProductAssociation)
    ),
    createdAt: Schema.optionalKey(DateTimeSerializableFromString),
    updatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    currentLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    fallbackLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    mainImage: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        readOnly: true,
        format: 'iri-reference',
      })
    ),
    documents: Schema.optionalKey(
      Schema.Array(Schema.suspend((): Schema.Codec<ProductDocument> => ProductDocument)).annotate({
        readOnly: true,
      })
    ),
    publicDocuments: Schema.optionalKey(
      Schema.Array(Schema.suspend((): Schema.Codec<ProductDocument> => ProductDocument)).annotate({
        readOnly: true,
      })
    ),
    restrictedDocuments: Schema.optionalKey(
      Schema.Array(Schema.suspend((): Schema.Codec<ProductDocument> => ProductDocument)).annotate({
        readOnly: true,
      })
    ),
    notifyDocuments: Schema.optionalKey(
      Schema.Array(Schema.suspend((): Schema.Codec<ProductDocument> => ProductDocument)).annotate({
        readOnly: true,
      })
    ),
    synchronizationGap: Schema.optionalKey(
      Schema.Union([Schema.Literals(['price', 'stock', 'both']), Schema.Null]).annotate({
        description:
          'Which halves of the warehouse synchronization are switched off, `null` when neither is.',
        readOnly: true,
      })
    ),
    productTaxonsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    taxonsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    channelsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    reviewsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    acceptedReviewsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    imagesTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    imagesWithoutMainImage: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    translationTyped: Schema.optionalKey(
      Schema.String.annotate({ readOnly: true, format: 'iri-reference' })
    ),
    variantsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    enabledVariantsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    optionsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    associatedByTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    associationsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    name: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    shortDescription: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    metaDescription: Schema.Union([Schema.String, Schema.Null]),
    metaKeywords: Schema.Union([Schema.String, Schema.Null]),
    subtitle: Schema.Union([Schema.String, Schema.Null]),
    variantSelectionMethodChoice: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    variantSelectionMethodLabel: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    taxons: Collection,
    acceptedReviews: Collection,
    variantSelectionMethodLabels: Schema.optionalKey(
      Schema.Record(Schema.String, Schema.String).annotate({ readOnly: true })
    ),
    translation: ProductTranslation,
    descriptor: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    enabledVariants: Collection,
    simple: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    configurable: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Product' });
export type Product = Schema.Schema.Type<typeof Product>;
export type ProductEncoded = Schema.Codec.Encoded<typeof Product>;

/* ProductAssociation */

export const ProductAssociation = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: ProductAssociationType,
    owner: Schema.suspend((): Schema.Codec<Product> => Product),
    associatedProducts: Schema.Array(Schema.suspend((): Schema.Codec<Product> => Product)),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    associatedProductsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAssociation' });
export type ProductAssociation = Schema.Schema.Type<typeof ProductAssociation>;
export type ProductAssociationEncoded = Schema.Codec.Encoded<typeof ProductAssociation>;

/* ProductOption */

export const ProductOption = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    values: Schema.Array(
      Schema.suspend((): Schema.Codec<ProductOptionValue> => ProductOptionValue)
    ),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
    currentLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    fallbackLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    name: Schema.Union([Schema.String, Schema.Null]),
    valuesTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    translation: Schema.Array(
      Schema.suspend((): Schema.Codec<TranslationInterface> => TranslationInterface)
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductOption' });
export type ProductOption = Schema.Schema.Type<typeof ProductOption>;
export type ProductOptionEncoded = Schema.Codec.Encoded<typeof ProductOption>;

/* ProductOptionValue */

export const ProductOptionValue = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    option: Schema.suspend((): Schema.Codec<ProductOption> => ProductOption),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
    currentLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    fallbackLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    value: Schema.Union([Schema.String, Schema.Null]),
    translation: Schema.Array(
      Schema.suspend((): Schema.Codec<TranslationInterface> => TranslationInterface)
    ),
    optionCode: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductOptionValue' });
export type ProductOptionValue = Schema.Schema.Type<typeof ProductOptionValue>;
export type ProductOptionValueEncoded = Schema.Codec.Encoded<typeof ProductOptionValue>;

/* ProductVariant */

export const ProductVariant = Schema.StructWithRest(
  Schema.Struct({
    warehouseStocks: Schema.Array(
      Schema.suspend((): Schema.Codec<WarehouseStock> => WarehouseStock)
    ),
    couponCodes: Schema.Array(ApplicablePromotionCode),
    eligiblePromotions: Schema.Array(EligiblePromotion),
    labels: Schema.Array(Schema.suspend((): Schema.Codec<Label> => Label)),
    highestPriorityWarehouse: Schema.Union([
      Schema.suspend((): Schema.Codec<Warehouse> => Warehouse),
      Schema.Null,
    ]),
    version: Schema.Number.annotate({ default: 1 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    onHold: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    onHand: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    tracked: Schema.Boolean.annotate({ default: false }),
    weight: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Null,
    ]),
    width: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Null,
    ]),
    height: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Null,
    ]),
    depth: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Null,
    ]),
    taxCategory: Schema.Union([
      Schema.suspend((): Schema.Codec<TaxCategory> => TaxCategory),
      Schema.Null,
    ]),
    shippingCategory: Schema.Union([ShippingCategory, Schema.Null]),
    channelPricings: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    shippingRequired: Schema.Boolean.annotate({ default: true }),
    images: Schema.Array(Schema.suspend((): Schema.Codec<ProductImage> => ProductImage)),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    product: Schema.suspend((): Schema.Codec<Product> => Product),
    optionValues: Schema.Array(
      Schema.suspend((): Schema.Codec<ProductOptionValue> => ProductOptionValue)
    ),
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    currentLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    fallbackLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    channelPricingsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    imagesTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    optionValuesTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    translation: Schema.Array(
      Schema.suspend((): Schema.Codec<TranslationInterface> => TranslationInterface)
    ),
    preorder: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    productQuantity: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    availableOnLocalWarehouse: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    available: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    maxOrderable: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    inStock: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    name: Schema.Union([Schema.String, Schema.Null]),
    inventoryName: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    shippingWeight: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    shippingWidth: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    shippingHeight: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    shippingDepth: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    shippingVolume: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    descriptor: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductVariant' });
export type ProductVariant = Schema.Schema.Type<typeof ProductVariant>;
export type ProductVariantEncoded = Schema.Codec.Encoded<typeof ProductVariant>;

/* ProductImage */

export const ProductImage = Schema.StructWithRest(
  Schema.Struct({
    originalPath: Schema.Union([Schema.String, Schema.Null]),
    lastSync: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    cropX: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    cropY: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    cropWidth: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    cropHeight: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    productVariants: Schema.Array(
      Schema.suspend((): Schema.Codec<ProductVariant> => ProductVariant)
    ),
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.Union([Schema.String, Schema.Null]),
    file: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'binary' }),
    path: Schema.String,
    owner: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    productVariantsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    crop: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductImage' });
export type ProductImage = Schema.Schema.Type<typeof ProductImage>;
export type ProductImageEncoded = Schema.Codec.Encoded<typeof ProductImage>;

/* TaxCategory */

export const TaxCategory = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.String,
    description: Schema.Union([Schema.String, Schema.Null]),
    rates: Schema.Array(Schema.suspend((): Schema.Codec<TaxRate> => TaxRate)),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    ratesTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TaxCategory' });
export type TaxCategory = Schema.Schema.Type<typeof TaxCategory>;
export type TaxCategoryEncoded = Schema.Codec.Encoded<typeof TaxCategory>;

/* TaxRate */

export const TaxRate = Schema.StructWithRest(
  Schema.Struct({
    zone: Schema.suspend((): Schema.Codec<Zone> => Zone),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    category: Schema.suspend((): Schema.Codec<TaxCategory> => TaxCategory),
    name: Schema.String,
    amount: Schema.Number.annotate({ default: 0 }).check(
      Schema.isFinite().annotate({ expected: 'a finite number' })
    ),
    includedInPrice: Schema.Boolean.annotate({ default: false }),
    calculator: Schema.String,
    startDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    endDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    amountAsPercentage: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isFinite().annotate({ expected: 'a finite number' })
      )
    ),
    label: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TaxRate' });
export type TaxRate = Schema.Schema.Type<typeof TaxRate>;
export type TaxRateEncoded = Schema.Codec.Encoded<typeof TaxRate>;

/* LocalDate */

export const LocalDate = Schema.StructWithRest(
  Schema.Struct({
    year: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Private constructor. Use of() to obtain an instance.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    month: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Private constructor. Use of() to obtain an instance.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    monthValue: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns the month-of-year value from 1 to 12.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    dayOfMonth: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    yearMonth: Schema.suspend((): Schema.Codec<YearMonth> => YearMonth),
    dayOfWeek: Schema.optionalKey(
      Schema.Literals([1, 2, 3, 4, 5, 6, 7]).annotate({ readOnly: true })
    ),
    dayOfYear: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns the day-of-year, from 1 to 365, or 366 in a leap year.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    yearWeek: Schema.suspend((): Schema.Codec<YearWeek> => YearWeek),
    quarter: Schema.optionalKey(
      Schema.Literals([1, 2, 3, 4]).annotate({
        description: 'Returns the quarter-of-year as a Quarter enum.',
        readOnly: true,
      })
    ),
    quarterValue: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns the quarter-of-year value from 1 to 4.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    leapYear: Schema.optionalKey(
      Schema.Boolean.annotate({
        description:
          'Checks if the year is a leap year, according to the ISO proleptic calendar system rules.',
        readOnly: true,
      })
    ),
    lengthOfYear: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns the length of the year represented by this date, in days.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    lengthOfMonth: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns the length of the month represented by this date, in days.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'LocalDate' });
export type LocalDate = Schema.Schema.Type<typeof LocalDate>;
export type LocalDateEncoded = Schema.Codec.Encoded<typeof LocalDate>;

/* YearWeek */

export const YearWeek = Schema.StructWithRest(
  Schema.Struct({
    year: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'The year, validated from MIN_YEAR to MAX_YEAR.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    week: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'The week number, validated in the range 1 to 53, and valid for the year.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    firstDay: Schema.suspend((): Schema.Codec<LocalDate> => LocalDate),
    lastDay: Schema.suspend((): Schema.Codec<LocalDate> => LocalDate),
    '53WeekYear': Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Returns whether this year has 53 weeks.',
        readOnly: true,
      })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'YearWeek' });
export type YearWeek = Schema.Schema.Type<typeof YearWeek>;
export type YearWeekEncoded = Schema.Codec.Encoded<typeof YearWeek>;

/* YearMonth */

export const YearMonth = Schema.StructWithRest(
  Schema.Struct({
    year: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'The year, validated from MIN_YEAR to MAX_YEAR.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    month: Schema.optionalKey(
      Schema.Number.annotate({ description: 'The month.', readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    monthValue: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns the month-of-year value from 1 to 12.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    leapYear: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Returns whether the year is a leap year.',
        readOnly: true,
      })
    ),
    lengthOfMonth: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns the length of the month in days, taking account of the year.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    lengthOfYear: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns the length of the year in days, either 365 or 366.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    firstDay: Schema.suspend((): Schema.Codec<LocalDate> => LocalDate),
    lastDay: Schema.suspend((): Schema.Codec<LocalDate> => LocalDate),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'YearMonth' });
export type YearMonth = Schema.Schema.Type<typeof YearMonth>;
export type YearMonthEncoded = Schema.Codec.Encoded<typeof YearMonth>;

/* WarehouseStock */

export const WarehouseStock = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.Union([Schema.String.annotate({ format: 'uuid' }), Schema.String]),
    productVariant: Schema.String.annotate({ format: 'iri-reference' }),
    warehouse: Schema.suspend((): Schema.Codec<Warehouse> => Warehouse),
    quantity: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })).check(
      Schema.isGreaterThanOrEqualTo(0).annotate({ expected: 'a value greater than or equal to 0' })
    ),
    warehouseMoneyCollection: Schema.optionalKey(
      Schema.Array(Schema.suspend((): Schema.Codec<WarehouseMoney> => WarehouseMoney)).annotate({
        readOnly: true,
      })
    ),
    syncId: Schema.Union([Schema.String, Schema.Null]),
    lastChanged: ZonedDateTime,
    preOrder: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    purchasePrices: Schema.Array(
      Schema.suspend((): Schema.Codec<WarehouseMoney> => WarehouseMoney)
    ),
    sellingPrices: Schema.Array(Schema.suspend((): Schema.Codec<WarehouseMoney> => WarehouseMoney)),
    preOrderAsLocal: Schema.optionalKey(
      Schema.Union([
        Schema.suspend((): Schema.Codec<LocalDate> => LocalDate),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'WarehouseStock' });
export type WarehouseStock = Schema.Schema.Type<typeof WarehouseStock>;
export type WarehouseStockEncoded = Schema.Codec.Encoded<typeof WarehouseStock>;

/* WarehouseMoney */

export const WarehouseMoney = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.Union([Schema.String.annotate({ format: 'uuid' }), Schema.String]),
    warehouseStock: Schema.suspend((): Schema.Codec<WarehouseStock> => WarehouseStock),
    type: Schema.Literals(['purchase', 'selling', 'recycling_fee']),
    amount: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    currency: Schema.String.annotate({ format: 'iri-reference' }),
    purchasePrice: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    sellingPrice: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    amountAsMoney: Money,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'WarehouseMoney' });
export type WarehouseMoney = Schema.Schema.Type<typeof WarehouseMoney>;
export type WarehouseMoneyEncoded = Schema.Codec.Encoded<typeof WarehouseMoney>;

/* Warehouse */

export const Warehouse = Schema.StructWithRest(
  Schema.Struct({
    pohodaSyncId: Schema.Union([Schema.String, Schema.Null]),
    deliveryTimes: Schema.Array(
      Schema.suspend((): Schema.Codec<WarehouseDeliveryTime> => WarehouseDeliveryTime)
    ),
    deliveryDelayOffsets: Schema.Array(
      Schema.suspend((): Schema.Codec<WarehouseDeliveryDelayOffset> => WarehouseDeliveryDelayOffset)
    ),
    id: Schema.optionalKey(
      Schema.Union([Schema.String.annotate({ format: 'uuid' }), Schema.String]).annotate({
        readOnly: true,
      })
    ),
    name: Schema.String.annotate({ default: '' }),
    supplierType: Schema.Union([Schema.String, Schema.Null]),
    priority: Schema.Number.annotate({ default: 0 })
      .check(Schema.isInt().annotate({ expected: 'an integer' }))
      .check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
    minimumMarkup: Schema.Number.annotate({ default: 0 })
      .check(Schema.isInt().annotate({ expected: 'an integer' }))
      .check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      )
      .check(
        Schema.isLessThanOrEqualTo(100).annotate({ expected: 'a value less than or equal to 100' })
      ),
    percentPriceChange: Schema.Number.annotate({ default: 100 })
      .check(Schema.isInt().annotate({ expected: 'an integer' }))
      .check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
    stockType: Schema.Literals(['local', 'external_supplier']),
    warehouseStocks: Schema.Array(
      Schema.suspend((): Schema.Codec<WarehouseStock> => WarehouseStock)
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Warehouse' });
export type Warehouse = Schema.Schema.Type<typeof Warehouse>;
export type WarehouseEncoded = Schema.Codec.Encoded<typeof Warehouse>;

/* WarehouseDeliveryDelayOffset */

export const WarehouseDeliveryDelayOffset = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    offset: Schema.suspend((): Schema.Codec<LocalDate> => LocalDate),
    warehouse: Schema.suspend((): Schema.Codec<Warehouse> => Warehouse),
    channel: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'iri-reference' }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'WarehouseDeliveryDelayOffset' });
export type WarehouseDeliveryDelayOffset = Schema.Schema.Type<typeof WarehouseDeliveryDelayOffset>;
export type WarehouseDeliveryDelayOffsetEncoded = Schema.Codec.Encoded<
  typeof WarehouseDeliveryDelayOffset
>;

/* WarehouseDeliveryTime */

export const WarehouseDeliveryTime = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.Literals(['Store', 'Channel']),
    warehouse: Schema.suspend((): Schema.Codec<Warehouse> => Warehouse),
    time: Schema.Number.annotate({ default: 0 })
      .check(Schema.isInt().annotate({ expected: 'an integer' }))
      .check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      )
      .check(
        Schema.isLessThanOrEqualTo(24).annotate({ expected: 'a value less than or equal to 24' })
      )
      .check(Schema.isLessThan(24).annotate({ expected: 'a value less than 24' })),
    deliveryDays: Schema.Number.annotate({ default: 0 })
      .check(Schema.isInt().annotate({ expected: 'an integer' }))
      .check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
    channel: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'iri-reference' }),
    store: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'iri-reference' }),
    targetLabel: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'WarehouseDeliveryTime' });
export type WarehouseDeliveryTime = Schema.Schema.Type<typeof WarehouseDeliveryTime>;
export type WarehouseDeliveryTimeEncoded = Schema.Codec.Encoded<typeof WarehouseDeliveryTime>;

/* Label */

export const Label = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(Schema.String.annotate({ readOnly: true, format: 'uuid' })),
    code: Schema.String.annotate({ default: '' }),
    color: Schema.String.annotate({ default: '' }),
    textColor: Schema.String.annotate({ default: '' }),
    icon: Schema.Union([Schema.String, Schema.Null]),
    enabled: Schema.Boolean.annotate({ default: true }),
    priority: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    channels: Schema.Array(Schema.suspend((): Schema.Codec<Channel> => Channel)),
    rules: Schema.Array(Schema.suspend((): Schema.Codec<LabelRule> => LabelRule)),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
    currentLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    fallbackLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    name: Schema.Union([Schema.String, Schema.Null]),
    translation: Schema.Array(
      Schema.suspend((): Schema.Codec<TranslationInterface> => TranslationInterface)
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Label' });
export type Label = Schema.Schema.Type<typeof Label>;
export type LabelEncoded = Schema.Codec.Encoded<typeof Label>;

/* LabelRule */

export const LabelRule = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(Schema.String.annotate({ readOnly: true, format: 'uuid' })),
    label: Schema.suspend((): Schema.Codec<Label> => Label),
    type: Schema.String.annotate({ default: '' }),
    configuration: Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'LabelRule' });
export type LabelRule = Schema.Schema.Type<typeof LabelRule>;
export type LabelRuleEncoded = Schema.Codec.Encoded<typeof LabelRule>;

/* ProductAttributeValue */

export const ProductAttributeValue = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    subject: Schema.suspend((): Schema.Codec<Product> => Product),
    attribute: Schema.String.annotate({ writeOnly: true, format: 'iri-reference' }),
    localeCode: Schema.Union([Schema.String, Schema.Null]),
    attributeGroupId: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true, format: 'uuid' })
    ),
    unit: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    position: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    value: Schema.Union([
      Schema.String,
      Schema.Boolean,
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Array(Schema.String),
      Schema.Null,
    ]),
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    type: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    code: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    product: Schema.Union([Schema.suspend((): Schema.Codec<Product> => Product), Schema.Null]),
    text: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    boolean: Schema.Union([Schema.Boolean, Schema.Null]).annotate({ writeOnly: true }),
    integer: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({ writeOnly: true }),
    float: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Null,
    ]).annotate({ writeOnly: true }),
    datetime: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    date: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    json: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Null,
    ]).annotate({ writeOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAttributeValue' });
export type ProductAttributeValue = Schema.Schema.Type<typeof ProductAttributeValue>;
export type ProductAttributeValueEncoded = Schema.Codec.Encoded<typeof ProductAttributeValue>;

/* ProductReview */

export const ProductReview = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    title: Schema.Union([Schema.String, Schema.Null]),
    rating: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    comment: Schema.Union([Schema.String, Schema.Null]),
    author: Schema.suspend((): Schema.Codec<Customer> => Customer),
    status: Schema.String.annotate({ default: 'new' }),
    reviewSubject: Schema.suspend((): Schema.Codec<Product> => Product),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductReview' });
export type ProductReview = Schema.Schema.Type<typeof ProductReview>;
export type ProductReviewEncoded = Schema.Codec.Encoded<typeof ProductReview>;

/* ShopUser */

export const ShopUser = Schema.StructWithRest(
  Schema.Struct({
    favouriteList: Schema.optionalKey(Schema.Array(FavouriteList).annotate({ readOnly: true })),
    customer: Schema.suspend((): Schema.Codec<Customer> => Customer),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    username: Schema.Union([Schema.String, Schema.Null]),
    usernameCanonical: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'Normalized representation of a username.',
    }),
    password: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'Encrypted password. Must be persisted.',
    }),
    plainPassword: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'Password before encryption. Used for model validation. Must not be persisted.',
    }),
    lastLogin: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    emailVerificationToken: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'Random string sent to the user email address in order to verify it',
    }),
    passwordResetToken: Schema.Union([Schema.String, Schema.Null]).annotate({
      description:
        'Random string sent to the user email address in order to verify the password resetting request',
    }),
    passwordRequestedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    verified: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    roles: Schema.Array(Schema.Union([Schema.String, Schema.Null])).annotate({
      description: 'We need at least one role to be able to authenticate',
      default: ['ROLE_USER'],
    }),
    oauthAccounts: Schema.Array(Schema.suspend((): Schema.Codec<UserOAuth> => UserOAuth)),
    email: Schema.Union([Schema.String, Schema.Null]),
    emailCanonical: Schema.Union([Schema.String, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    enabled: Schema.Boolean.annotate({ default: true }),
    oAuthAccounts: Schema.Array(Schema.suspend((): Schema.Codec<UserOAuth> => UserOAuth)),
    userIdentifier: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShopUser' });
export type ShopUser = Schema.Schema.Type<typeof ShopUser>;
export type ShopUserEncoded = Schema.Codec.Encoded<typeof ShopUser>;

/* UserOAuth */

export const UserOAuth = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    provider: Schema.String,
    identifier: Schema.String,
    accessToken: Schema.Union([Schema.String, Schema.Null]),
    refreshToken: Schema.Union([Schema.String, Schema.Null]),
    user: Schema.Union([Schema.suspend((): Schema.Codec<ShopUser> => ShopUser), Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'UserOAuth' });
export type UserOAuth = Schema.Schema.Type<typeof UserOAuth>;
export type UserOAuthEncoded = Schema.Codec.Encoded<typeof UserOAuth>;

/* Customer */

export const Customer = Schema.StructWithRest(
  Schema.Struct({
    orders: Schema.optionalKey(
      Schema.Array(Schema.suspend((): Schema.Codec<Order> => Order)).annotate({ readOnly: true })
    ),
    defaultAddress: Schema.Union([
      Schema.suspend((): Schema.Codec<Address> => Address),
      Schema.Null,
    ]),
    addresses: Schema.Array(Schema.suspend((): Schema.Codec<Address> => Address)),
    user: Schema.Union([Schema.suspend((): Schema.Codec<ShopUser> => ShopUser), Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    email: Schema.String,
    emailCanonical: Schema.String,
    firstName: Schema.Union([Schema.String, Schema.Null]),
    lastName: Schema.Union([Schema.String, Schema.Null]),
    birthday: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    gender: Schema.String.annotate({ default: 'u' }),
    group: Schema.Union([CustomerGroup, Schema.Null]),
    phoneNumber: Schema.Union([Schema.String, Schema.Null]),
    subscribedToNewsletter: Schema.Boolean.annotate({ default: false }),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    ordersTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    addressesTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    fullName: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    male: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    female: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Customer' });
export type Customer = Schema.Schema.Type<typeof Customer>;
export type CustomerEncoded = Schema.Codec.Encoded<typeof Customer>;

/* Address */

export const Address = Schema.StructWithRest(
  Schema.Struct({
    vatNumber: Schema.Union([Schema.String, Schema.Null]),
    vatValid: Schema.Boolean.annotate({ default: false }),
    vatVerified: Schema.Boolean.annotate({ default: true }),
    vatValidatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    businessId: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'IČO or similar ID for other countries',
    }),
    customer: Schema.Union([Schema.suspend((): Schema.Codec<Customer> => Customer), Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    firstName: Schema.String,
    lastName: Schema.String,
    phoneNumber: Schema.Union([Schema.String, Schema.Null]),
    company: Schema.Union([Schema.String, Schema.Null]),
    countryCode: Schema.String,
    provinceCode: Schema.Union([Schema.String, Schema.Null]),
    provinceName: Schema.Union([Schema.String, Schema.Null]),
    street: Schema.String,
    city: Schema.String,
    postcode: Schema.String,
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    complexStreet: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    fullAddress: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    vatManualReviewRequired: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    validVatNumber: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    fullName: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Address' });
export type Address = Schema.Schema.Type<typeof Address>;
export type AddressEncoded = Schema.Codec.Encoded<typeof Address>;

/* Order */

export const Order = Schema.StructWithRest(
  Schema.Struct({
    promotionRuleHints: Schema.Array(CartPromotionRuleHints),
    pohodaId: Schema.Union([Schema.String, Schema.Null]),
    cancelledReason: Schema.Union([
      Schema.Literals(['customer', 'unpaid', 'returned', 'unpicked']),
      Schema.Null,
    ]),
    invoiceId: Schema.Union([Schema.String, Schema.Null]),
    identifier: Schema.String.annotate({
      description:
        'Public order identifier (UUIDv4) used wherever the sequential id / number must not be\nexposed or guessable — payment QR links, gateway return URLs, document access.',
      format: 'uuid',
    }),
    surveyOptIn: Schema.Boolean.annotate({ default: false }),
    customer: Schema.Union([Schema.suspend((): Schema.Codec<Customer> => Customer), Schema.Null]),
    channel: Schema.Union([Schema.suspend((): Schema.Codec<Channel> => Channel), Schema.Null]),
    shippingAddress: Schema.Union([
      Schema.suspend((): Schema.Codec<Address> => Address),
      Schema.Null,
    ]),
    billingAddress: Schema.Union([
      Schema.suspend((): Schema.Codec<Address> => Address),
      Schema.Null,
    ]),
    payments: Schema.Array(Schema.suspend((): Schema.Codec<Payment> => Payment)),
    shipments: Schema.Array(Schema.suspend((): Schema.Codec<Shipment> => Shipment)),
    currencyCode: Schema.String,
    localeCode: Schema.String,
    promotionCoupon: Schema.Union([PromotionCoupon, Schema.Null]),
    checkoutState: Schema.String.annotate({ default: 'cart' }),
    paymentState: Schema.String.annotate({ default: 'cart' }),
    shippingState: Schema.String.annotate({ default: 'cart' }),
    promotions: Schema.Array(Schema.suspend((): Schema.Codec<Promotion> => Promotion)),
    tokenValue: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    customerIp: Schema.Union([Schema.String, Schema.Null]),
    createdByGuest: Schema.optionalKey(Schema.Boolean.annotate({ default: true, readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    checkoutCompletedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    number: Schema.Union([Schema.String, Schema.Null]),
    notes: Schema.Union([Schema.String, Schema.Null]),
    items: Schema.Array(Schema.suspend((): Schema.Codec<OrderItem> => OrderItem)),
    itemsTotal: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    adjustments: Schema.Array(Schema.suspend((): Schema.Codec<Adjustment> => Adjustment)),
    adjustmentsTotal: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    total: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Items total + adjustments total.',
        default: 0,
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    state: Schema.String.annotate({ default: 'cart' }),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    primaryShipment: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        description: "The order's shipment — currently a single shipping method per order is used.",
        readOnly: true,
        format: 'iri-reference',
      })
    ),
    totalAsMoney: Money,
    totalDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'TODO: works only if tax is included in price (this is ok for now)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    documents: Schema.optionalKey(
      Schema.Array(Schema.suspend((): Schema.Codec<ProductDocument> => ProductDocument)).annotate({
        readOnly: true,
      })
    ),
    documentsForNotification: Schema.optionalKey(
      Schema.Array(Schema.suspend((): Schema.Codec<ProductDocument> => ProductDocument)).annotate({
        readOnly: true,
      })
    ),
    fullySynchronized: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    synchronizationGap: Schema.optionalKey(
      Schema.Union([Schema.Literals(['price', 'stock', 'both']), Schema.Null]).annotate({
        description:
          "The union of what this order's products stopped synchronizing — `null` when every product\nstill follows the warehouse in both price and stock.",
        readOnly: true,
      })
    ),
    itemsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    primaryShipmentStrict: Schema.optionalKey(
      Schema.String.annotate({
        description: "The order's shipment — currently a single shipping method per order is used.",
        readOnly: true,
        format: 'iri-reference',
      })
    ),
    user: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        readOnly: true,
        format: 'iri-reference',
      })
    ),
    specificLastPayment: Schema.optionalKey(
      Schema.Union([Schema.suspend((): Schema.Codec<Payment> => Payment), Schema.Null]).annotate({
        readOnly: true,
      })
    ),
    lastPayment: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        readOnly: true,
        format: 'iri-reference',
      })
    ),
    itemUnitsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    paymentsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    shipmentsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    promotionsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    business: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    vatNumber: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    vatValid: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    mossCountry: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        description:
          "OSS/MOSS taxation country of the order: the billing country for B2C orders taxed\noutside the shop's residency country, null otherwise.",
        readOnly: true,
      })
    ),
    taxAddress: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        description: 'Returns address which is used for determining MOSS country',
        readOnly: true,
        format: 'iri-reference',
      })
    ),
    vatFree: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'This is TRUE if Order price does NOT contain any VAT tax.',
        readOnly: true,
      })
    ),
    taxedByCountry: Schema.optionalKey(
      Schema.String.annotate({
        description:
          'Returns the country code whose tax rates were applied to the Order INCLUDING Orders without applied tax!',
        readOnly: true,
      })
    ),
    physicallyTaxedByCountry: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        description:
          'Returns the country code whose tax rates were applied to the Order\nif customer had valid VAT number so no tax has been applied, returns NULL.',
        readOnly: true,
      })
    ),
    vatFreeRequested: Schema.optionalKey(
      Schema.Boolean.annotate({
        description:
          'Returns TRUE if customer is eligible for free VAT\nThis does NOT say if VAT is applied or not. Use isVatFree to determine that!',
        readOnly: true,
      })
    ),
    vatFreeManualReviewRequired: Schema.optionalKey(
      Schema.Boolean.annotate({
        description:
          'Returns TRUE if customer is business (vat number in billing address) and that number has NOT been validated by VIES API\nThis also means that tax is currently applied. Which tax is applied is determined by MOSS mode, and we can get\ncountry code by calling $this->getTaxedByCountry();',
        readOnly: true,
      })
    ),
    adjustment: Schema.Array(Schema.suspend((): Schema.Codec<Adjustment> => Adjustment)),
    frontAllItemsPriceWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Sum of price of all items (without shipment and payment) after all discounts with VAT\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontAllItemsPriceWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Sum of price of all items (without shipment and payment) after all discounts without VAT',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontAllItemsDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Nominal value of sum of all discounts applied on (all) items\nValue is nominal for both nominal and percentage discounts\nNote: Because discount includes VAT, this sum also technically always includes discount from base+VAT price event\nif customer is verified to NOT pay VAT for Order!\nNumber is positive.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontAllItemsTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns nominal value of VAT from price AFTER discounts for all items\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontTotalWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns price including all items, shipment, payment and applied discounts\nAlways with VAT or NULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontTotalWithoutVat: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns price including all items, shipment, payment and applied discounts\nAlways without VAT even if customer pays VAT.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontFinalRounding: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns final rounding on entire Order. This correction is applied after everything even after TAX/VAT.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontTotalTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns nominal value of VAT from price AFTER discounts for all items\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontTotalPaid: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns FINAL price to be paid by customer including all items, shipment, payment, applied discounts\nand applied taxes if any. This number is number which should be sent to payment gate or displayed as number\nrepresenting how much will customer pay.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontShipmentTotalPaid: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns FINAL price to be paid by customer for shipment (after discount and including taxes if applied)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontPaymentTotalPaid: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns FINAL price to be paid by customer for payment (after discount and including taxes if applied)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontDeliveryTotalPaid: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns FINAL price to be paid by customer for delivery: shipment+payment (after discount and including taxes if applied)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontShipmentWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns shipment price before discount with VAT\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontShipmentDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns discount in nominal value of shipment (for both percentage and nominal discount)\nPositive number.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontShipmentWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns shipment price with VAT after applied discounts\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontShipmentWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns shipment price without VAT after applied discounts',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontShipmentTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns nominal value of VAT from price AFTER discounts for shipment\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontPaymentWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns payment price before discount with VAT\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontPaymentDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns discount in nominal value of payment (for both percentage and nominal discount)\nPositive number.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontPaymentWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns payment price with VAT after applied discounts\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontPaymentWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns payment price without VAT after applied discounts',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontPaymentTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns nominal value of VAT from price AFTER discounts for payment\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontDeliveryWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns delivery: shipment+payment price before discount with VAT\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontDeliveryDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns discount in nominal value of delivery: shipment+payment (for both percentage and nominal discount)\nPositive number.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontDeliveryWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns delivery: shipment+payment price with VAT after applied discounts\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontDeliveryWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns delivery: shipment+payment price without VAT after applied discounts',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontDeliveryTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns nominal value of VAT from price AFTER discounts for delivery: shipment+payment\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontShipmentDiscountPercentage: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns overall percentage discount on shipments calculated from base price with tax and applied nominal discounts.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontPaymentDiscountPercentage: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns overall percentage discount on payments calculated from base price with tax and applied nominal discounts.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontDeliveryDiscountPercentage: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    latestDispatchDate: Schema.optionalKey(
      Schema.Union([
        Schema.suspend((): Schema.Codec<LocalDate> => LocalDate),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    totalWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    itemsTotalWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Sum of price of all items WITHOUT VAT tax and WITHOUT shipping and payment price',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    orderPromotionTotalWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Order promotional total without VAT (total for all shipments)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    shippingWithoutTaxTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Shipping price without VAT (total for all shipments)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    paymentTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns payment fee price after promotion with applied taxes (for VIES valid non-CZ subjects price is without taxes!)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    paymentPromotionTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    paymentTax: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns only tax of payment method',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    paymentWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns only tax of payment method\nTODO: works only if tax is included in price (this is ok for now)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    originalShipmentPricing: Schema.optionalKey(
      Schema.Union([OriginalPricing, Schema.Null]).annotate({ readOnly: true })
    ),
    originalPaymentPricing: Schema.optionalKey(
      Schema.Union([OriginalPricing, Schema.Null]).annotate({ readOnly: true })
    ),
    orderPromotionTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns amount of order discount. Does not include shipping discounts.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    shippingPromotionTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    itemsSubtotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    taxTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns sum of neutral and non neutral tax adjustments on order and total tax of order items.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    shippingTaxTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    taxIncludedTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    shippingTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns shipping fee together with taxes decreased by shipping discount.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    customerWithAuthorization: Schema.Union([
      Schema.suspend((): Schema.Codec<Customer> => Customer),
      Schema.Null,
    ]),
    itemUnits: Collection,
    shippingRequired: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    promotionSubjectTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    promotionSubjectCount: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    taxExcludedTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    nonDiscountedItemsTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    checkoutCompleted: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    totalQuantity: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    empty: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    adjustmentsRecursively: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    adjustmentsTotalRecursively: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    beProcessed: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Order' });
export type Order = Schema.Schema.Type<typeof Order>;
export type OrderEncoded = Schema.Codec.Encoded<typeof Order>;

/* Adjustment */

export const Adjustment = Schema.StructWithRest(
  Schema.Struct({
    shippingPricing: Schema.Union([ShippingPricing, Schema.Null]),
    shipment: Schema.optionalKey(
      Schema.Union([Schema.suspend((): Schema.Codec<Shipment> => Shipment), Schema.Null]).annotate({
        readOnly: true,
      })
    ),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    order: Schema.optionalKey(
      Schema.Union([Schema.suspend((): Schema.Codec<Order> => Order), Schema.Null]).annotate({
        readOnly: true,
      })
    ),
    orderItem: Schema.optionalKey(
      Schema.Union([
        Schema.suspend((): Schema.Codec<OrderItem> => OrderItem),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    orderItemUnit: Schema.optionalKey(
      Schema.Union([
        Schema.suspend((): Schema.Codec<OrderItemUnit> => OrderItemUnit),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    type: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    label: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    amount: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    neutral: Schema.optionalKey(Schema.Boolean.annotate({ default: false, readOnly: true })),
    locked: Schema.optionalKey(Schema.Boolean.annotate({ default: false, readOnly: true })),
    originCode: Schema.Union([Schema.String, Schema.Null]),
    details: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    taxRateAmount: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returned as [0,1] range e.g. for 21% taxRate this method returns float value: 0.21',
        readOnly: true,
      }).check(Schema.isFinite().annotate({ expected: 'a finite number' }))
    ),
    adjustmentTypeChoices: Schema.optionalKey(
      Schema.Json.annotate({ expected: 'JSON value', readOnly: true })
    ),
    adjustable: Schema.Union([
      Schema.suspend((): Schema.Codec<AdjustableInterface> => AdjustableInterface),
      Schema.Null,
    ]),
    charge: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    credit: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Adjustment' });
export type Adjustment = Schema.Schema.Type<typeof Adjustment>;
export type AdjustmentEncoded = Schema.Codec.Encoded<typeof Adjustment>;

/* AdjustableInterface */

export const AdjustableInterface = Schema.StructWithRest(
  Schema.Struct({
    adjustments: Schema.Array(Schema.suspend((): Schema.Codec<Adjustment> => Adjustment)),
    adjustmentsTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'AdjustableInterface' });
export type AdjustableInterface = Schema.Schema.Type<typeof AdjustableInterface>;
export type AdjustableInterfaceEncoded = Schema.Codec.Encoded<typeof AdjustableInterface>;

/* OrderItemUnit */

export const OrderItemUnit = Schema.StructWithRest(
  Schema.Struct({
    dispatchDate: Schema.Union([
      Schema.suspend((): Schema.Codec<LocalDate> => LocalDate),
      Schema.Null,
    ]),
    shipment: Schema.Union([Schema.suspend((): Schema.Codec<Shipment> => Shipment), Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    adjustments: Schema.Array(Schema.suspend((): Schema.Codec<Adjustment> => Adjustment)),
    adjustmentsTotal: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    orderItem: Schema.suspend((): Schema.Codec<OrderItem> => OrderItem),
    stockable: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        readOnly: true,
        format: 'iri-reference',
      })
    ),
    shippable: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        readOnly: true,
        format: 'iri-reference',
      })
    ),
    adjustmentsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    taxTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    total: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'OrderItemUnit' });
export type OrderItemUnit = Schema.Schema.Type<typeof OrderItemUnit>;
export type OrderItemUnitEncoded = Schema.Codec.Encoded<typeof OrderItemUnit>;

/* OrderItem */

export const OrderItem = Schema.StructWithRest(
  Schema.Struct({
    version: Schema.Number.annotate({ default: 1 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    variant: Schema.suspend((): Schema.Codec<ProductVariant> => ProductVariant),
    productName: Schema.Union([Schema.String, Schema.Null]),
    variantName: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    order: Schema.suspend((): Schema.Codec<Order> => Order),
    quantity: Schema.Number.annotate({ default: 0, readOnly: true })
      .check(Schema.isInt().annotate({ expected: 'an integer' }))
      .check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
    unitPrice: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    originalUnitPrice: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({ default: 0 }),
    total: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    immutable: Schema.Boolean.annotate({ default: false }),
    units: Schema.Array(Schema.suspend((): Schema.Codec<OrderItemUnit> => OrderItemUnit)),
    adjustments: Schema.Array(Schema.suspend((): Schema.Codec<Adjustment> => Adjustment)),
    adjustmentsTotal: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    product: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        readOnly: true,
        format: 'iri-reference',
      })
    ),
    orderStrict: Schema.optionalKey(
      Schema.String.annotate({ readOnly: true, format: 'iri-reference' })
    ),
    preorder: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    unitsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    adjustmentsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    adjustmentsRecursivelyTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    adjustment: Schema.Array(Schema.suspend((): Schema.Codec<Adjustment> => Adjustment)),
    frontUnitPriceWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    frontItemsPriceWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    frontUnitPriceDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Nominal value of sum of all discounts applied on unit\nDiscount technically contains VAT part (is applied for source price including VAT)\nValue is nominal for both nominal and percentage discounts\nValue is average for all units (if special discounts are per unit, this filed must be calculated custom for each every unit)\nNumber is positive.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontItemsPriceDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Nominal value of sum of all discounts applied on items (all units)\nDiscount technically contains VAT part (is applied for source price including VAT)\nValue is nominal for both nominal and percentage discounts\nNumber is positive.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontUnitPriceWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Unit price with VAT and after all product discounts (including order level discounts on products)\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontUnitPriceWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Unit price without VAT and after all product discounts (including order level discounts on products)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontUnitPricePaid: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    frontItemsPriceWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Sum of items (all units) with VAT and after all product discounts (including order level discounts on products)\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontItemsPriceWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Sum of items (all units) without VAT and after all product discounts (including order level discounts on products)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontUnitTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Tax as nominal value applied on unit price AFTER discount\nNULL if customer is verified to NOT pay VAT for Order (basically zero tax)',
        readOnly: true,
      })
    ),
    frontItemsTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Tax as nominal value applied on items (all units) price AFTER discount\nNULL if customer is verified to NOT pay VAT for Order (basically zero tax)',
        readOnly: true,
      })
    ),
    frontItemsPricePaid: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    originalPricing: Schema.optionalKey(
      Schema.Union([OriginalPricing, Schema.Null]).annotate({ readOnly: true })
    ),
    latestDispatchDate: Schema.optionalKey(
      Schema.Union([
        Schema.suspend((): Schema.Codec<LocalDate> => LocalDate),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    discountedUnitPrice: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns single unit price lowered by order unit promotions (each unit must have the same unit promotion discount)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    adjustmentsRecursively: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    adjustmentsTotalRecursively: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    subtotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    fullDiscountedUnitPrice: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    taxTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns sum of neutral and non neutral tax adjustments on order item and total tax of units.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'OrderItem' });
export type OrderItem = Schema.Schema.Type<typeof OrderItem>;
export type OrderItemEncoded = Schema.Codec.Encoded<typeof OrderItem>;

/* Shipment */

export const Shipment = Schema.StructWithRest(
  Schema.Struct({
    placementId: Schema.Union([Schema.String, Schema.Null]),
    order: Schema.suspend((): Schema.Codec<Order> => Order),
    adjustments: Schema.Array(Schema.suspend((): Schema.Codec<Adjustment> => Adjustment)),
    adjustmentsTotal: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    state: Schema.String.annotate({ default: 'cart' }),
    method: Schema.suspend((): Schema.Codec<ShippingMethod> => ShippingMethod),
    units: Schema.Array(Schema.suspend((): Schema.Codec<OrderItemUnit> => OrderItemUnit)),
    tracking: Schema.Union([Schema.String, Schema.Null]),
    shippedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    priceAsMoney: Schema.optionalKey(
      Schema.Union([Money, Schema.Null]).annotate({ readOnly: true })
    ),
    adjustmentsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    unitsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    shippablesTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    adjustment: Schema.Array(Schema.suspend((): Schema.Codec<Adjustment> => Adjustment)),
    adjustmentStrict: Schema.optionalKey(
      Schema.String.annotate({ readOnly: true, format: 'iri-reference' })
    ),
    absoluteTrackingUrl: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    image: Schema.optionalKey(
      Schema.Union([ShippingMethodImage, Schema.Null]).annotate({ readOnly: true })
    ),
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    code: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    price: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    shippingUnitTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    tracked: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    shippables: Collection,
    shippingWeight: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isFinite().annotate({ expected: 'a finite number' })
      )
    ),
    shippingVolume: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isFinite().annotate({ expected: 'a finite number' })
      )
    ),
    shippingUnitCount: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Shipment' });
export type Shipment = Schema.Schema.Type<typeof Shipment>;
export type ShipmentEncoded = Schema.Codec.Encoded<typeof Shipment>;

/* ShippingMethod */

export const ShippingMethod = Schema.StructWithRest(
  Schema.Struct({
    deliveryDays: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })).check(
      Schema.isGreaterThanOrEqualTo(0).annotate({ expected: 'a value greater than or equal to 0' })
    ),
    pohodaSyncId: Schema.String,
    feedShippingMethods: Schema.Array(FeedShippingMethod),
    store: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'iri-reference' }),
    placement: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    trackingUrl: Schema.Union([Schema.String, Schema.Null]),
    image: Schema.Union([ShippingMethodImage, Schema.Null]),
    zone: Schema.suspend((): Schema.Codec<Zone> => Zone),
    taxCategory: Schema.Union([
      Schema.suspend((): Schema.Codec<TaxCategory> => TaxCategory),
      Schema.Null,
    ]),
    channels: Schema.Array(Schema.suspend((): Schema.Codec<Channel> => Channel)),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    category: Schema.Union([ShippingCategory, Schema.Null]),
    categoryRequirement: Schema.Number.annotate({ default: 1 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    shippingChargesCalculator: Schema.String,
    shippingChargesCalculatorConfiguration: Schema.Array(
      Schema.Union([Schema.String, Schema.Null])
    ),
    rules: Schema.Array(Schema.suspend((): Schema.Codec<ShippingMethodRule> => ShippingMethodRule)),
    minDeliveryTimeDays: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    maxDeliveryTimeDays: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    archivedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
    currentLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    fallbackLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    predefinedPlacementId: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    name: Schema.Union([Schema.String, Schema.Null]),
    channelsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    rulesTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    translation: Schema.Array(
      Schema.suspend((): Schema.Codec<TranslationInterface> => TranslationInterface)
    ),
    formattedTrackingUrl: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    translationClass: Schema.optionalKey(
      Schema.Json.annotate({ expected: 'JSON value', readOnly: true })
    ),
    description: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingMethod' });
export type ShippingMethod = Schema.Schema.Type<typeof ShippingMethod>;
export type ShippingMethodEncoded = Schema.Codec.Encoded<typeof ShippingMethod>;

/* ShippingMethodRule */

export const ShippingMethodRule = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.String,
    configuration: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    shippingMethod: Schema.Union([
      Schema.suspend((): Schema.Codec<ShippingMethod> => ShippingMethod),
      Schema.Null,
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingMethodRule' });
export type ShippingMethodRule = Schema.Schema.Type<typeof ShippingMethodRule>;
export type ShippingMethodRuleEncoded = Schema.Codec.Encoded<typeof ShippingMethodRule>;

/* Payment */

export const Payment = Schema.StructWithRest(
  Schema.Struct({
    order: Schema.suspend((): Schema.Codec<Order> => Order),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    method: Schema.optionalKey(
      Schema.Union([PaymentMethod, Schema.Null]).annotate({ readOnly: true })
    ),
    currencyCode: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    amount: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    state: Schema.optionalKey(Schema.String.annotate({ default: 'cart', readOnly: true })),
    details: Schema.optionalKey(
      Schema.Array(Schema.Union([Schema.String, Schema.Null])).annotate({ readOnly: true })
    ),
    paymentRequests: Schema.optionalKey(
      Schema.Array(Schema.suspend((): Schema.Codec<PaymentRequest> => PaymentRequest)).annotate({
        readOnly: true,
      })
    ),
    createdAt: Schema.optionalKey(DateTimeSerializableFromString),
    updatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    priceAsMoney: Schema.optionalKey(
      Schema.Union([Money, Schema.Null]).annotate({ readOnly: true })
    ),
    paymentRequestsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    price: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    code: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    image: Schema.optionalKey(
      Schema.Union([PaymentMethodImage, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Payment' });
export type Payment = Schema.Schema.Type<typeof Payment>;
export type PaymentEncoded = Schema.Codec.Encoded<typeof Payment>;

/* PaymentRequest */

export const PaymentRequest = Schema.StructWithRest(
  Schema.Struct({
    hash: Schema.optionalKey(Schema.String.annotate({ readOnly: true, format: 'uuid' })),
    state: Schema.String.annotate({ default: 'new' }),
    action: Schema.String.annotate({ default: 'capture' }),
    payload: Schema.Json.annotate({ expected: 'JSON value' }),
    responseData: Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
    payment: Schema.suspend((): Schema.Codec<Payment> => Payment),
    method: PaymentMethod,
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    orderToken: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PaymentRequest' });
export type PaymentRequest = Schema.Schema.Type<typeof PaymentRequest>;
export type PaymentRequestEncoded = Schema.Codec.Encoded<typeof PaymentRequest>;

/* Promotion */

export const Promotion = Schema.StructWithRest(
  Schema.Struct({
    couponBased: Schema.Boolean.annotate({ default: true }),
    showCartHints: Schema.Boolean.annotate({
      description:
        "When enabled, the shop cart shows hints on how to earn this promotion's discount.",
      default: false,
    }),
    channels: Schema.Array(Schema.suspend((): Schema.Codec<Channel> => Channel)),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.String,
    description: Schema.Union([Schema.String, Schema.Null]),
    priority: Schema.Number.annotate({
      description: 'When exclusive, promotion with top priority will be applied',
      default: 0,
    }).check(Schema.isInt().annotate({ expected: 'an integer' })),
    exclusive: Schema.Boolean.annotate({
      description: 'Cannot be applied together with other promotions',
      default: false,
    }),
    usageLimit: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    used: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    startsAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    endsAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    coupons: Schema.Array(PromotionCoupon),
    rules: Schema.Array(Schema.suspend((): Schema.Codec<PromotionRule> => PromotionRule)),
    actions: Schema.Array(Schema.suspend((): Schema.Codec<PromotionAction> => PromotionAction)),
    appliesToDiscounted: Schema.Boolean.annotate({ default: true }),
    archivedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
    currentLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    fallbackLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    channelsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    couponsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    rulesTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    actionsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    translation: Schema.Array(
      Schema.suspend((): Schema.Codec<TranslationInterface> => TranslationInterface)
    ),
    label: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Promotion' });
export type Promotion = Schema.Schema.Type<typeof Promotion>;
export type PromotionEncoded = Schema.Codec.Encoded<typeof Promotion>;

/* PromotionAction */

export const PromotionAction = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.String,
    configuration: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    promotion: Schema.Union([
      Schema.suspend((): Schema.Codec<Promotion> => Promotion),
      Schema.Null,
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PromotionAction' });
export type PromotionAction = Schema.Schema.Type<typeof PromotionAction>;
export type PromotionActionEncoded = Schema.Codec.Encoded<typeof PromotionAction>;

/* PromotionRule */

export const PromotionRule = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.String,
    configuration: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    promotion: Schema.Union([
      Schema.suspend((): Schema.Codec<Promotion> => Promotion),
      Schema.Null,
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PromotionRule' });
export type PromotionRule = Schema.Schema.Type<typeof PromotionRule>;
export type PromotionRuleEncoded = Schema.Codec.Encoded<typeof PromotionRule>;

/* ProductTaxon */

export const ProductTaxon = Schema.StructWithRest(
  Schema.Struct({
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    product: Schema.suspend((): Schema.Codec<Product> => Product),
    taxon: Schema.suspend((): Schema.Codec<Taxon> => Taxon),
    position: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductTaxon' });
export type ProductTaxon = Schema.Schema.Type<typeof ProductTaxon>;
export type ProductTaxonEncoded = Schema.Codec.Encoded<typeof ProductTaxon>;

/* Transactionjsonld */

export const Transactionjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    pohodaRefId: Schema.Union([Schema.String, Schema.Null]).annotate({
      description:
        'Id of the bank book movement created in Pohoda for this transaction. Null until exported.',
    }),
    id: Schema.optionalKey(Schema.String.annotate({ readOnly: true, format: 'uuid' })),
    bankAccount: Schema.suspend((): Schema.Codec<BankAccountjsonld> => BankAccountjsonld),
    order: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'iri-reference' }),
    identifier: Schema.String,
    amount: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    currency: Schema.String.annotate({ format: 'iri-reference' }),
    transactionDate: DateTimeSerializableFromString,
    statementDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    description: Schema.Union([Schema.String, Schema.Null]),
    counterpartyName: Schema.Union([Schema.String, Schema.Null]),
    counterpartyAccount: Schema.Union([Schema.String, Schema.Null]),
    variableSymbol: Schema.Union([Schema.String, Schema.Null]),
    constantSymbol: Schema.Union([Schema.String, Schema.Null]),
    specificSymbol: Schema.Union([Schema.String, Schema.Null]),
    meta: Schema.Union([
      Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
      Schema.Null,
    ]),
    checked: Schema.Boolean.annotate({ default: false }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Transactionjsonld' });
export type Transactionjsonld = Schema.Schema.Type<typeof Transactionjsonld>;
export type TransactionjsonldEncoded = Schema.Codec.Encoded<typeof Transactionjsonld>;

/* BankAccountjsonld */

export const BankAccountjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    pohodaRefIds: Schema.Union([Schema.String, Schema.Null]).annotate({
      description:
        "Reference (IDS / code) of the corresponding bank account in Pohoda. When set, the account's\ntransactions are exported as bank book movements under this Pohoda account.",
    }),
    id: Schema.optionalKey(Schema.String.annotate({ readOnly: true, format: 'uuid' })),
    code: Schema.String,
    iban: Schema.Union([Schema.String, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    defaultChannel: Schema.Union([Schema.String, Schema.Null]).annotate({
      format: 'iri-reference',
    }),
    type: Schema.Literals(['fio', 'comgate', 'other']),
    config: Schema.Union([
      Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
      Schema.Null,
    ]),
    autoCheckUnmatched: Schema.Boolean.annotate({ default: false }),
    transactions: Schema.Array(
      Schema.suspend((): Schema.Codec<Transactionjsonld> => Transactionjsonld)
    ),
    bankAccountCZ: Schema.optionalKey(
      Schema.Union([BankAccountCZjsonld, Schema.Null]).annotate({ readOnly: true })
    ),
    bankAccountAsIban: Schema.optionalKey(
      Schema.Union([Ibanjsonld, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'BankAccountjsonld' });
export type BankAccountjsonld = Schema.Schema.Type<typeof BankAccountjsonld>;
export type BankAccountjsonldEncoded = Schema.Codec.Encoded<typeof BankAccountjsonld>;

/* ZoneMemberjsonld */

export const ZoneMemberjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    belongsTo: Schema.Union([
      Schema.suspend((): Schema.Codec<Zonejsonld> => Zonejsonld),
      Schema.Null,
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ZoneMemberjsonld' });
export type ZoneMemberjsonld = Schema.Schema.Type<typeof ZoneMemberjsonld>;
export type ZoneMemberjsonldEncoded = Schema.Codec.Encoded<typeof ZoneMemberjsonld>;

/* Zonejsonld */

export const Zonejsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.String,
    type: Schema.String,
    scope: Schema.String.annotate({ default: 'all' }),
    members: Schema.Array(Schema.suspend((): Schema.Codec<ZoneMemberjsonld> => ZoneMemberjsonld)),
    priority: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    membersTyped: Schema.optionalKey(
      Schema.Array(Schema.suspend((): Schema.Codec<ZoneMemberjsonld> => ZoneMemberjsonld)).annotate(
        { readOnly: true }
      )
    ),
    types: Schema.optionalKey(Schema.Json.annotate({ expected: 'JSON value', readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Zonejsonld' });
export type Zonejsonld = Schema.Schema.Type<typeof Zonejsonld>;
export type ZonejsonldEncoded = Schema.Codec.Encoded<typeof Zonejsonld>;

/* Provincejsonld */

export const Provincejsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.String,
    abbreviation: Schema.Union([Schema.String, Schema.Null]),
    country: Schema.suspend((): Schema.Codec<Countryjsonld> => Countryjsonld),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Provincejsonld' });
export type Provincejsonld = Schema.Schema.Type<typeof Provincejsonld>;
export type ProvincejsonldEncoded = Schema.Codec.Encoded<typeof Provincejsonld>;

/* Countryjsonld */

export const Countryjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String.annotate({ description: 'Country code ISO 3166-1 alpha-2.' }),
    provinces: Schema.Array(Schema.suspend((): Schema.Codec<Provincejsonld> => Provincejsonld)),
    enabled: Schema.Boolean.annotate({ default: true }),
    provincesTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Countryjsonld' });
export type Countryjsonld = Schema.Schema.Type<typeof Countryjsonld>;
export type CountryjsonldEncoded = Schema.Codec.Encoded<typeof Countryjsonld>;

/* TranslatableInterfacejsonld */

export const TranslatableInterfacejsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    translations: Schema.Union([
      Schema.suspend((): Schema.Codec<TranslationInterface> => TranslationInterface),
      Schema.Array(Schema.suspend((): Schema.Codec<TranslationInterface> => TranslationInterface)),
    ]),
    translation: Schema.Array(
      Schema.suspend((): Schema.Codec<TranslationInterfacejsonld> => TranslationInterfacejsonld)
    ),
    currentLocale: Schema.String.annotate({ writeOnly: true }),
    fallbackLocale: Schema.String.annotate({ writeOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TranslatableInterfacejsonld' });
export type TranslatableInterfacejsonld = Schema.Schema.Type<typeof TranslatableInterfacejsonld>;
export type TranslatableInterfacejsonldEncoded = Schema.Codec.Encoded<
  typeof TranslatableInterfacejsonld
>;

/* TranslationInterfacejsonld */

export const TranslationInterfacejsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    translatable: Schema.Union([
      Schema.suspend((): Schema.Codec<TranslatableInterfacejsonld> => TranslatableInterfacejsonld),
      Schema.Null,
    ]),
    locale: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TranslationInterfacejsonld' });
export type TranslationInterfacejsonld = Schema.Schema.Type<typeof TranslationInterfacejsonld>;
export type TranslationInterfacejsonldEncoded = Schema.Codec.Encoded<
  typeof TranslationInterfacejsonld
>;

/* DocumentTypejsonld */

export const DocumentTypejsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    mode: Schema.Union([
      Schema.Literals(['public', 'publicAndNotify', 'hiddenAndNotify']),
      Schema.Null,
    ]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    position: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    productDocuments: Schema.Array(
      Schema.suspend((): Schema.Codec<ProductDocumentjsonld> => ProductDocumentjsonld)
    ),
    documentType: Schema.Union([
      Schema.suspend((): Schema.Codec<DocumentTypejsonld> => DocumentTypejsonld),
      Schema.Null,
    ]),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
    currentLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    fallbackLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    translation: Schema.Array(
      Schema.suspend((): Schema.Codec<TranslationInterfacejsonld> => TranslationInterfacejsonld)
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'DocumentTypejsonld' });
export type DocumentTypejsonld = Schema.Schema.Type<typeof DocumentTypejsonld>;
export type DocumentTypejsonldEncoded = Schema.Codec.Encoded<typeof DocumentTypejsonld>;

/* ProductDocumentjsonld */

export const ProductDocumentjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    originalPath: Schema.Union([Schema.String, Schema.Null]),
    lastSync: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    product: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'iri-reference' }),
    createdAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    documentType: Schema.suspend((): Schema.Codec<DocumentTypejsonld> => DocumentTypejsonld),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    name: Schema.Union([
      Schema.String.check(
        Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
      ),
      Schema.Null,
    ]),
    file: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'binary' }),
    path: Schema.String,
    publicPath: Schema.Union([Schema.String, Schema.Null]),
    hasPath: Schema.optionalKey(Schema.Json.annotate({ expected: 'JSON value', readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductDocumentjsonld' });
export type ProductDocumentjsonld = Schema.Schema.Type<typeof ProductDocumentjsonld>;
export type ProductDocumentjsonldEncoded = Schema.Codec.Encoded<typeof ProductDocumentjsonld>;

/* Taxonjsonld */

export const Taxonjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    searchWeight: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Null,
    ]),
    articleCategories: Schema.optionalKey(
      Schema.Array(Schema.suspend((): Schema.Codec<Categoryjsonld> => Categoryjsonld)).annotate({
        readOnly: true,
      })
    ),
    feedCategories: Schema.Array(FeedCategoryjsonld),
    productTaxons: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    listing: Schema.Literals(['ajax', 'inline']),
    visibility: Schema.Literals(['hideInMenu', 'hideCompletely', 'visible']),
    showOnHomepage: Schema.Boolean.annotate({ default: false }),
    children: Schema.optionalKey(
      Schema.Array(
        Schema.Union([
          Schema.suspend(
            (): Schema.Codec<Taxonjsonldsyliusshoptaxonshowdetail> =>
              Taxonjsonldsyliusshoptaxonshowdetail
          ),
          Schema.suspend(
            (): Schema.Codec<Taxonsyliusshoptaxonshowdetail> => Taxonsyliusshoptaxonshowdetail
          ),
          Schema.String.annotate({
            description: 'IRI na Taxon při překročení MaxDepth',
            format: 'uri',
          }),
        ])
      ).annotate({
        description: 'První úroveň = objekt Taxon, hlubší úrovně = IRI.',
        readOnly: true,
      })
    ),
    images: Schema.optionalKey(Schema.Array(TaxonImagejsonld).annotate({ readOnly: true })),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    root: Schema.optionalKey(
      Schema.Union([
        Schema.suspend((): Schema.Codec<Taxonjsonld> => Taxonjsonld),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    parent: Schema.Union([
      Schema.suspend((): Schema.Codec<Taxonjsonld> => Taxonjsonld),
      Schema.Null,
    ]),
    left: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    right: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    level: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    currentLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    fallbackLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    enabled: Schema.Boolean.annotate({ default: true }),
    imagesTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
    nameInTaxonList: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    metaDescription: Schema.Union([Schema.String, Schema.Null]),
    translationClass: Schema.optionalKey(
      Schema.Json.annotate({ expected: 'JSON value', readOnly: true })
    ),
    ancestors: Schema.optionalKey(
      Schema.Array(Schema.suspend((): Schema.Codec<Taxonjsonld> => Taxonjsonld)).annotate({
        readOnly: true,
      })
    ),
    enabledChildren: Collectionjsonld,
    fullname: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    translation: TaxonTranslationjsonld,
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonjsonld' });
export type Taxonjsonld = Schema.Schema.Type<typeof Taxonjsonld>;
export type TaxonjsonldEncoded = Schema.Codec.Encoded<typeof Taxonjsonld>;

/* Categoryjsonld */

export const Categoryjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.String.annotate({ format: 'uuid' }),
    code: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    enabled: Schema.Boolean,
    image: Schema.Union([CategoryImagejsonld, Schema.Null]),
    articles: Schema.Array(Schema.suspend((): Schema.Codec<Articlejsonld> => Articlejsonld)),
    taxons: Schema.Array(Schema.suspend((): Schema.Codec<Taxonjsonld> => Taxonjsonld)),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
    currentLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    fallbackLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    metaDescription: Schema.Union([Schema.String, Schema.Null]),
    translation: Schema.Array(
      Schema.suspend((): Schema.Codec<TranslationInterfacejsonld> => TranslationInterfacejsonld)
    ),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Categoryjsonld' });
export type Categoryjsonld = Schema.Schema.Type<typeof Categoryjsonld>;
export type CategoryjsonldEncoded = Schema.Codec.Encoded<typeof Categoryjsonld>;

/* Articlejsonld */

export const Articlejsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    section: Schema.String.annotate({ format: 'iri-reference' }),
    favourite: Schema.Boolean.annotate({ default: false }),
    products: Schema.Array(Schema.suspend((): Schema.Codec<Productjsonld> => Productjsonld)),
    categories: Schema.Array(Schema.suspend((): Schema.Codec<Categoryjsonld> => Categoryjsonld)),
    image: Schema.Union([Schema.String, Schema.Null]),
    video: Schema.Union([Schema.String, Schema.Null]),
    thumbnailImage: Schema.Union([Schema.String, Schema.Null]),
    enabled: Schema.Boolean.annotate({ default: true }),
    channels: Schema.Array(Schema.suspend((): Schema.Codec<Channeljsonld> => Channeljsonld)),
    tags: Schema.Array(Tagjsonld),
    publishedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    authors: Schema.Array(Authorjsonld),
    type: Schema.String.annotate({ default: 'blog' }),
    state: Schema.String.annotate({ default: 'draft' }),
    createdAt: DateTimeSerializableFromString,
    updatedAt: DateTimeSerializableFromString,
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
    currentLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    fallbackLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    imageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    thumbnailImageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    metaImageAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    title: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    metaDescription: Schema.Union([Schema.String, Schema.Null]),
    metaKeywords: Schema.Union([Schema.String, Schema.Null]),
    metaImage: Schema.Union([Schema.String, Schema.Null]),
    content: Schema.String,
    translation: Schema.Array(
      Schema.suspend((): Schema.Codec<TranslationInterfacejsonld> => TranslationInterfacejsonld)
    ),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Articlejsonld' });
export type Articlejsonld = Schema.Schema.Type<typeof Articlejsonld>;
export type ArticlejsonldEncoded = Schema.Codec.Encoded<typeof Articlejsonld>;

/* Channeljsonld */

export const Channeljsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    pohodaCentre: Schema.Union([Schema.String, Schema.Null]),
    pohodaPriceLevel: Schema.Union([Schema.String, Schema.Null]),
    pohodaRounding: Schema.Union([
      Schema.Literals([
        'none',
        'math2one',
        'math2half',
        'math2tenth',
        'math5cent',
        'up2one',
        'up2half',
        'up2tenth',
        'down2one',
        'down2half',
        'down2tenth',
      ]),
      Schema.Null,
    ]),
    bankAccount: Schema.Union([
      Schema.suspend((): Schema.Codec<BankAccountjsonld> => BankAccountjsonld),
      Schema.Null,
    ]),
    ecomailListId: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    heurekaApiKey: Schema.Union([Schema.String, Schema.Null]),
    zboziApiKey: Schema.Union([Schema.String, Schema.Null]),
    baseCurrency: Currencyjsonld,
    defaultLocale: Localejsonld,
    defaultTaxZone: Schema.Union([
      Schema.suspend((): Schema.Codec<Zonejsonld> => Zonejsonld),
      Schema.Null,
    ]),
    taxCalculationStrategy: Schema.String,
    currencies: Schema.Array(Currencyjsonld),
    locales: Schema.Array(Localejsonld),
    countries: Schema.Array(Schema.suspend((): Schema.Codec<Countryjsonld> => Countryjsonld)),
    themeName: Schema.Union([Schema.String, Schema.Null]),
    contactEmail: Schema.Union([Schema.String, Schema.Null]),
    contactPhoneNumber: Schema.Union([Schema.String, Schema.Null]),
    skippingShippingStepAllowed: Schema.Boolean.annotate({ default: false }),
    skippingPaymentStepAllowed: Schema.Boolean.annotate({ default: false }),
    accountVerificationRequired: Schema.Boolean.annotate({ default: true }),
    shippingAddressInCheckoutRequired: Schema.Boolean.annotate({ default: false }),
    shopBillingData: Schema.Union([ShopBillingDatajsonld, Schema.Null]),
    menuTaxon: Schema.Union([
      Schema.suspend((): Schema.Codec<Taxonjsonld> => Taxonjsonld),
      Schema.Null,
    ]),
    channelPriceHistoryConfig: Schema.Union([
      Schema.suspend(
        (): Schema.Codec<ChannelPriceHistoryConfigjsonld> => ChannelPriceHistoryConfigjsonld
      ),
      Schema.Null,
    ]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.String,
    description: Schema.Union([Schema.String, Schema.Null]),
    hostname: Schema.Union([Schema.String, Schema.Null]),
    color: Schema.Union([Schema.String, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    enabled: Schema.Boolean.annotate({ default: true }),
    currenciesTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    localesTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    countriesTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    enabledCountries: Collectionjsonld,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Channeljsonld' });
export type Channeljsonld = Schema.Schema.Type<typeof Channeljsonld>;
export type ChanneljsonldEncoded = Schema.Codec.Encoded<typeof Channeljsonld>;

/* ChannelPriceHistoryConfigjsonld */

export const ChannelPriceHistoryConfigjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    lowestPriceForDiscountedProductsCheckingPeriod: Schema.Number.annotate({ default: 30 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    lowestPriceForDiscountedProductsVisible: Schema.Boolean.annotate({ default: true }),
    taxonsExcludedFromShowingLowestPrice: Schema.optionalKey(
      Schema.Array(Schema.suspend((): Schema.Codec<Taxonjsonld> => Taxonjsonld)).annotate({
        readOnly: true,
      })
    ),
    taxonsExcludedFromShowingLowestPriceTyped: Schema.optionalKey(
      Schema.Array(Schema.suspend((): Schema.Codec<Taxonjsonld> => Taxonjsonld)).annotate({
        readOnly: true,
      })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ChannelPriceHistoryConfigjsonld' });
export type ChannelPriceHistoryConfigjsonld = Schema.Schema.Type<
  typeof ChannelPriceHistoryConfigjsonld
>;
export type ChannelPriceHistoryConfigjsonldEncoded = Schema.Codec.Encoded<
  typeof ChannelPriceHistoryConfigjsonld
>;

/* Productjsonld */

export const Productjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    ageRestriction: Schema.Literals(['none', '18+']),
    feedTop: Schema.Boolean.annotate({ default: false }),
    articles: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    productDocuments: Schema.Array(
      Schema.suspend((): Schema.Codec<ProductDocumentjsonld> => ProductDocumentjsonld)
    ),
    brand: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'iri-reference' }),
    videos: Schema.Array(ProductVideojsonld),
    sellingPriceSynchronized: Schema.Boolean.annotate({
      description:
        "Whether warehouse selling prices may overwrite the channel pricing's selling price.",
      default: true,
    }),
    stockSynchronized: Schema.Boolean.annotate({
      description: "Whether warehouse quantities may overwrite the variant's available quantity.",
      default: true,
    }),
    warrantyMonths: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({
      description: 'Warranty length in months (unsigned smallint, null = unspecified)',
    }),
    ean: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'EAN/GTIN barcode, max 20 chars',
    }),
    variantSelectionMethod: Schema.String.annotate({ default: 'choice' }),
    productTaxons: Schema.Array(
      Schema.suspend((): Schema.Codec<ProductTaxonjsonld> => ProductTaxonjsonld)
    ),
    channels: Schema.Array(Schema.suspend((): Schema.Codec<Channeljsonld> => Channeljsonld)),
    mainTaxon: Schema.Union([
      Schema.suspend((): Schema.Codec<Taxonjsonld> => Taxonjsonld),
      Schema.Null,
    ]),
    reviews: Schema.Array(
      Schema.suspend((): Schema.Codec<ProductReviewjsonld> => ProductReviewjsonld)
    ),
    averageRating: Schema.Number.annotate({ default: 0 }).check(
      Schema.isFinite().annotate({ expected: 'a finite number' })
    ),
    images: Schema.optionalKey(
      Schema.Array(
        Schema.suspend((): Schema.Codec<ProductImagejsonld> => ProductImagejsonld)
      ).annotate({ readOnly: true })
    ),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    attributes: Schema.Array(
      Schema.suspend((): Schema.Codec<ProductAttributeValuejsonld> => ProductAttributeValuejsonld)
    ),
    variants: Schema.Array(
      Schema.suspend((): Schema.Codec<ProductVariantjsonld> => ProductVariantjsonld)
    ),
    options: Schema.Array(
      Schema.suspend((): Schema.Codec<ProductOptionjsonld> => ProductOptionjsonld)
    ),
    associations: Schema.Array(
      Schema.suspend((): Schema.Codec<ProductAssociationjsonld> => ProductAssociationjsonld)
    ),
    createdAt: Schema.optionalKey(DateTimeSerializableFromString),
    updatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    currentLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    fallbackLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    mainImage: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        readOnly: true,
        format: 'iri-reference',
      })
    ),
    documents: Schema.optionalKey(
      Schema.Array(
        Schema.suspend((): Schema.Codec<ProductDocumentjsonld> => ProductDocumentjsonld)
      ).annotate({ readOnly: true })
    ),
    publicDocuments: Schema.optionalKey(
      Schema.Array(
        Schema.suspend((): Schema.Codec<ProductDocumentjsonld> => ProductDocumentjsonld)
      ).annotate({ readOnly: true })
    ),
    restrictedDocuments: Schema.optionalKey(
      Schema.Array(
        Schema.suspend((): Schema.Codec<ProductDocumentjsonld> => ProductDocumentjsonld)
      ).annotate({ readOnly: true })
    ),
    notifyDocuments: Schema.optionalKey(
      Schema.Array(
        Schema.suspend((): Schema.Codec<ProductDocumentjsonld> => ProductDocumentjsonld)
      ).annotate({ readOnly: true })
    ),
    synchronizationGap: Schema.optionalKey(
      Schema.Union([Schema.Literals(['price', 'stock', 'both']), Schema.Null]).annotate({
        description:
          'Which halves of the warehouse synchronization are switched off, `null` when neither is.',
        readOnly: true,
      })
    ),
    productTaxonsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    taxonsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    channelsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    reviewsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    acceptedReviewsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    imagesTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    imagesWithoutMainImage: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    translationTyped: Schema.optionalKey(
      Schema.String.annotate({ readOnly: true, format: 'iri-reference' })
    ),
    variantsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    enabledVariantsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    optionsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    associatedByTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    associationsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    name: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    shortDescription: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    metaDescription: Schema.Union([Schema.String, Schema.Null]),
    metaKeywords: Schema.Union([Schema.String, Schema.Null]),
    subtitle: Schema.Union([Schema.String, Schema.Null]),
    variantSelectionMethodChoice: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    variantSelectionMethodLabel: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    taxons: Collectionjsonld,
    acceptedReviews: Collectionjsonld,
    variantSelectionMethodLabels: Schema.optionalKey(
      Schema.Record(Schema.String, Schema.String).annotate({ readOnly: true })
    ),
    translation: ProductTranslationjsonld,
    descriptor: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    enabledVariants: Collectionjsonld,
    simple: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    configurable: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Productjsonld' });
export type Productjsonld = Schema.Schema.Type<typeof Productjsonld>;
export type ProductjsonldEncoded = Schema.Codec.Encoded<typeof Productjsonld>;

/* ProductAssociationjsonld */

export const ProductAssociationjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: ProductAssociationTypejsonld,
    owner: Schema.suspend((): Schema.Codec<Productjsonld> => Productjsonld),
    associatedProducts: Schema.Array(
      Schema.suspend((): Schema.Codec<Productjsonld> => Productjsonld)
    ),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    associatedProductsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAssociationjsonld' });
export type ProductAssociationjsonld = Schema.Schema.Type<typeof ProductAssociationjsonld>;
export type ProductAssociationjsonldEncoded = Schema.Codec.Encoded<typeof ProductAssociationjsonld>;

/* ProductOptionjsonld */

export const ProductOptionjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    values: Schema.Array(
      Schema.suspend((): Schema.Codec<ProductOptionValuejsonld> => ProductOptionValuejsonld)
    ),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
    currentLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    fallbackLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    name: Schema.Union([Schema.String, Schema.Null]),
    valuesTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    translation: Schema.Array(
      Schema.suspend((): Schema.Codec<TranslationInterfacejsonld> => TranslationInterfacejsonld)
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductOptionjsonld' });
export type ProductOptionjsonld = Schema.Schema.Type<typeof ProductOptionjsonld>;
export type ProductOptionjsonldEncoded = Schema.Codec.Encoded<typeof ProductOptionjsonld>;

/* ProductOptionValuejsonld */

export const ProductOptionValuejsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    option: Schema.suspend((): Schema.Codec<ProductOptionjsonld> => ProductOptionjsonld),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
    currentLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    fallbackLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    value: Schema.Union([Schema.String, Schema.Null]),
    translation: Schema.Array(
      Schema.suspend((): Schema.Codec<TranslationInterfacejsonld> => TranslationInterfacejsonld)
    ),
    optionCode: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductOptionValuejsonld' });
export type ProductOptionValuejsonld = Schema.Schema.Type<typeof ProductOptionValuejsonld>;
export type ProductOptionValuejsonldEncoded = Schema.Codec.Encoded<typeof ProductOptionValuejsonld>;

/* ProductVariantjsonld */

export const ProductVariantjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    warehouseStocks: Schema.Array(
      Schema.suspend((): Schema.Codec<WarehouseStockjsonld> => WarehouseStockjsonld)
    ),
    couponCodes: Schema.Array(ApplicablePromotionCodejsonld),
    eligiblePromotions: Schema.Array(EligiblePromotionjsonld),
    labels: Schema.Array(Schema.suspend((): Schema.Codec<Labeljsonld> => Labeljsonld)),
    highestPriorityWarehouse: Schema.Union([
      Schema.suspend((): Schema.Codec<Warehousejsonld> => Warehousejsonld),
      Schema.Null,
    ]),
    version: Schema.Number.annotate({ default: 1 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    onHold: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    onHand: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    tracked: Schema.Boolean.annotate({ default: false }),
    weight: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Null,
    ]),
    width: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Null,
    ]),
    height: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Null,
    ]),
    depth: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Null,
    ]),
    taxCategory: Schema.Union([
      Schema.suspend((): Schema.Codec<TaxCategoryjsonld> => TaxCategoryjsonld),
      Schema.Null,
    ]),
    shippingCategory: Schema.Union([ShippingCategoryjsonld, Schema.Null]),
    channelPricings: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    shippingRequired: Schema.Boolean.annotate({ default: true }),
    images: Schema.Array(
      Schema.suspend((): Schema.Codec<ProductImagejsonld> => ProductImagejsonld)
    ),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    product: Schema.suspend((): Schema.Codec<Productjsonld> => Productjsonld),
    optionValues: Schema.Array(
      Schema.suspend((): Schema.Codec<ProductOptionValuejsonld> => ProductOptionValuejsonld)
    ),
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    currentLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    fallbackLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    channelPricingsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    imagesTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    optionValuesTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    translation: Schema.Array(
      Schema.suspend((): Schema.Codec<TranslationInterfacejsonld> => TranslationInterfacejsonld)
    ),
    preorder: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    productQuantity: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    availableOnLocalWarehouse: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    available: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    maxOrderable: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    inStock: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    name: Schema.Union([Schema.String, Schema.Null]),
    inventoryName: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    shippingWeight: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    shippingWidth: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    shippingHeight: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    shippingDepth: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    shippingVolume: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    descriptor: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductVariantjsonld' });
export type ProductVariantjsonld = Schema.Schema.Type<typeof ProductVariantjsonld>;
export type ProductVariantjsonldEncoded = Schema.Codec.Encoded<typeof ProductVariantjsonld>;

/* ProductImagejsonld */

export const ProductImagejsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    originalPath: Schema.Union([Schema.String, Schema.Null]),
    lastSync: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    cropX: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    cropY: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    cropWidth: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    cropHeight: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    productVariants: Schema.Array(
      Schema.suspend((): Schema.Codec<ProductVariantjsonld> => ProductVariantjsonld)
    ),
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.Union([Schema.String, Schema.Null]),
    file: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'binary' }),
    path: Schema.String,
    owner: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    productVariantsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    pathAbstract: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    crop: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductImagejsonld' });
export type ProductImagejsonld = Schema.Schema.Type<typeof ProductImagejsonld>;
export type ProductImagejsonldEncoded = Schema.Codec.Encoded<typeof ProductImagejsonld>;

/* TaxCategoryjsonld */

export const TaxCategoryjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.String,
    description: Schema.Union([Schema.String, Schema.Null]),
    rates: Schema.Array(Schema.suspend((): Schema.Codec<TaxRatejsonld> => TaxRatejsonld)),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    ratesTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TaxCategoryjsonld' });
export type TaxCategoryjsonld = Schema.Schema.Type<typeof TaxCategoryjsonld>;
export type TaxCategoryjsonldEncoded = Schema.Codec.Encoded<typeof TaxCategoryjsonld>;

/* TaxRatejsonld */

export const TaxRatejsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    zone: Schema.suspend((): Schema.Codec<Zonejsonld> => Zonejsonld),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    category: Schema.suspend((): Schema.Codec<TaxCategoryjsonld> => TaxCategoryjsonld),
    name: Schema.String,
    amount: Schema.Number.annotate({ default: 0 }).check(
      Schema.isFinite().annotate({ expected: 'a finite number' })
    ),
    includedInPrice: Schema.Boolean.annotate({ default: false }),
    calculator: Schema.String,
    startDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    endDate: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    amountAsPercentage: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isFinite().annotate({ expected: 'a finite number' })
      )
    ),
    label: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'TaxRatejsonld' });
export type TaxRatejsonld = Schema.Schema.Type<typeof TaxRatejsonld>;
export type TaxRatejsonldEncoded = Schema.Codec.Encoded<typeof TaxRatejsonld>;

/* LocalDatejsonld */

export const LocalDatejsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    year: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Private constructor. Use of() to obtain an instance.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    month: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Private constructor. Use of() to obtain an instance.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    monthValue: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns the month-of-year value from 1 to 12.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    dayOfMonth: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    yearMonth: Schema.suspend((): Schema.Codec<YearMonthjsonld> => YearMonthjsonld),
    dayOfWeek: Schema.optionalKey(
      Schema.Literals([1, 2, 3, 4, 5, 6, 7]).annotate({ readOnly: true })
    ),
    dayOfYear: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns the day-of-year, from 1 to 365, or 366 in a leap year.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    yearWeek: Schema.suspend((): Schema.Codec<YearWeekjsonld> => YearWeekjsonld),
    quarter: Schema.optionalKey(
      Schema.Literals([1, 2, 3, 4]).annotate({
        description: 'Returns the quarter-of-year as a Quarter enum.',
        readOnly: true,
      })
    ),
    quarterValue: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns the quarter-of-year value from 1 to 4.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    leapYear: Schema.optionalKey(
      Schema.Boolean.annotate({
        description:
          'Checks if the year is a leap year, according to the ISO proleptic calendar system rules.',
        readOnly: true,
      })
    ),
    lengthOfYear: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns the length of the year represented by this date, in days.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    lengthOfMonth: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns the length of the month represented by this date, in days.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'LocalDatejsonld' });
export type LocalDatejsonld = Schema.Schema.Type<typeof LocalDatejsonld>;
export type LocalDatejsonldEncoded = Schema.Codec.Encoded<typeof LocalDatejsonld>;

/* YearWeekjsonld */

export const YearWeekjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    year: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'The year, validated from MIN_YEAR to MAX_YEAR.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    week: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'The week number, validated in the range 1 to 53, and valid for the year.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    firstDay: Schema.suspend((): Schema.Codec<LocalDatejsonld> => LocalDatejsonld),
    lastDay: Schema.suspend((): Schema.Codec<LocalDatejsonld> => LocalDatejsonld),
    '53WeekYear': Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Returns whether this year has 53 weeks.',
        readOnly: true,
      })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'YearWeekjsonld' });
export type YearWeekjsonld = Schema.Schema.Type<typeof YearWeekjsonld>;
export type YearWeekjsonldEncoded = Schema.Codec.Encoded<typeof YearWeekjsonld>;

/* YearMonthjsonld */

export const YearMonthjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    year: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'The year, validated from MIN_YEAR to MAX_YEAR.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    month: Schema.optionalKey(
      Schema.Number.annotate({ description: 'The month.', readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    monthValue: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns the month-of-year value from 1 to 12.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    leapYear: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'Returns whether the year is a leap year.',
        readOnly: true,
      })
    ),
    lengthOfMonth: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns the length of the month in days, taking account of the year.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    lengthOfYear: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns the length of the year in days, either 365 or 366.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    firstDay: Schema.suspend((): Schema.Codec<LocalDatejsonld> => LocalDatejsonld),
    lastDay: Schema.suspend((): Schema.Codec<LocalDatejsonld> => LocalDatejsonld),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'YearMonthjsonld' });
export type YearMonthjsonld = Schema.Schema.Type<typeof YearMonthjsonld>;
export type YearMonthjsonldEncoded = Schema.Codec.Encoded<typeof YearMonthjsonld>;

/* WarehouseStockjsonld */

export const WarehouseStockjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.Union([Schema.String.annotate({ format: 'uuid' }), Schema.String]),
    productVariant: Schema.String.annotate({ format: 'iri-reference' }),
    warehouse: Schema.suspend((): Schema.Codec<Warehousejsonld> => Warehousejsonld),
    quantity: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })).check(
      Schema.isGreaterThanOrEqualTo(0).annotate({ expected: 'a value greater than or equal to 0' })
    ),
    warehouseMoneyCollection: Schema.optionalKey(
      Schema.Array(
        Schema.suspend((): Schema.Codec<WarehouseMoneyjsonld> => WarehouseMoneyjsonld)
      ).annotate({ readOnly: true })
    ),
    syncId: Schema.Union([Schema.String, Schema.Null]),
    lastChanged: ZonedDateTimejsonld,
    preOrder: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    purchasePrices: Schema.Array(
      Schema.suspend((): Schema.Codec<WarehouseMoneyjsonld> => WarehouseMoneyjsonld)
    ),
    sellingPrices: Schema.Array(
      Schema.suspend((): Schema.Codec<WarehouseMoneyjsonld> => WarehouseMoneyjsonld)
    ),
    preOrderAsLocal: Schema.optionalKey(
      Schema.Union([
        Schema.suspend((): Schema.Codec<LocalDatejsonld> => LocalDatejsonld),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'WarehouseStockjsonld' });
export type WarehouseStockjsonld = Schema.Schema.Type<typeof WarehouseStockjsonld>;
export type WarehouseStockjsonldEncoded = Schema.Codec.Encoded<typeof WarehouseStockjsonld>;

/* WarehouseMoneyjsonld */

export const WarehouseMoneyjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.Union([Schema.String.annotate({ format: 'uuid' }), Schema.String]),
    warehouseStock: Schema.suspend((): Schema.Codec<WarehouseStockjsonld> => WarehouseStockjsonld),
    type: Schema.Literals(['purchase', 'selling', 'recycling_fee']),
    amount: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    currency: Schema.String.annotate({ format: 'iri-reference' }),
    purchasePrice: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    sellingPrice: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    amountAsMoney: Moneyjsonld,
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'WarehouseMoneyjsonld' });
export type WarehouseMoneyjsonld = Schema.Schema.Type<typeof WarehouseMoneyjsonld>;
export type WarehouseMoneyjsonldEncoded = Schema.Codec.Encoded<typeof WarehouseMoneyjsonld>;

/* Warehousejsonld */

export const Warehousejsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    pohodaSyncId: Schema.Union([Schema.String, Schema.Null]),
    deliveryTimes: Schema.Array(
      Schema.suspend((): Schema.Codec<WarehouseDeliveryTimejsonld> => WarehouseDeliveryTimejsonld)
    ),
    deliveryDelayOffsets: Schema.Array(
      Schema.suspend(
        (): Schema.Codec<WarehouseDeliveryDelayOffsetjsonld> => WarehouseDeliveryDelayOffsetjsonld
      )
    ),
    id: Schema.optionalKey(
      Schema.Union([Schema.String.annotate({ format: 'uuid' }), Schema.String]).annotate({
        readOnly: true,
      })
    ),
    name: Schema.String.annotate({ default: '' }),
    supplierType: Schema.Union([Schema.String, Schema.Null]),
    priority: Schema.Number.annotate({ default: 0 })
      .check(Schema.isInt().annotate({ expected: 'an integer' }))
      .check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
    minimumMarkup: Schema.Number.annotate({ default: 0 })
      .check(Schema.isInt().annotate({ expected: 'an integer' }))
      .check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      )
      .check(
        Schema.isLessThanOrEqualTo(100).annotate({ expected: 'a value less than or equal to 100' })
      ),
    percentPriceChange: Schema.Number.annotate({ default: 100 })
      .check(Schema.isInt().annotate({ expected: 'an integer' }))
      .check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
    stockType: Schema.Literals(['local', 'external_supplier']),
    warehouseStocks: Schema.Array(
      Schema.suspend((): Schema.Codec<WarehouseStockjsonld> => WarehouseStockjsonld)
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Warehousejsonld' });
export type Warehousejsonld = Schema.Schema.Type<typeof Warehousejsonld>;
export type WarehousejsonldEncoded = Schema.Codec.Encoded<typeof Warehousejsonld>;

/* WarehouseDeliveryDelayOffsetjsonld */

export const WarehouseDeliveryDelayOffsetjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    offset: Schema.suspend((): Schema.Codec<LocalDatejsonld> => LocalDatejsonld),
    warehouse: Schema.suspend((): Schema.Codec<Warehousejsonld> => Warehousejsonld),
    channel: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'iri-reference' }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'WarehouseDeliveryDelayOffsetjsonld' });
export type WarehouseDeliveryDelayOffsetjsonld = Schema.Schema.Type<
  typeof WarehouseDeliveryDelayOffsetjsonld
>;
export type WarehouseDeliveryDelayOffsetjsonldEncoded = Schema.Codec.Encoded<
  typeof WarehouseDeliveryDelayOffsetjsonld
>;

/* WarehouseDeliveryTimejsonld */

export const WarehouseDeliveryTimejsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.Literals(['Store', 'Channel']),
    warehouse: Schema.suspend((): Schema.Codec<Warehousejsonld> => Warehousejsonld),
    time: Schema.Number.annotate({ default: 0 })
      .check(Schema.isInt().annotate({ expected: 'an integer' }))
      .check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      )
      .check(
        Schema.isLessThanOrEqualTo(24).annotate({ expected: 'a value less than or equal to 24' })
      )
      .check(Schema.isLessThan(24).annotate({ expected: 'a value less than 24' })),
    deliveryDays: Schema.Number.annotate({ default: 0 })
      .check(Schema.isInt().annotate({ expected: 'an integer' }))
      .check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
    channel: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'iri-reference' }),
    store: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'iri-reference' }),
    targetLabel: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'WarehouseDeliveryTimejsonld' });
export type WarehouseDeliveryTimejsonld = Schema.Schema.Type<typeof WarehouseDeliveryTimejsonld>;
export type WarehouseDeliveryTimejsonldEncoded = Schema.Codec.Encoded<
  typeof WarehouseDeliveryTimejsonld
>;

/* Labeljsonld */

export const Labeljsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(Schema.String.annotate({ readOnly: true, format: 'uuid' })),
    code: Schema.String.annotate({ default: '' }),
    color: Schema.String.annotate({ default: '' }),
    textColor: Schema.String.annotate({ default: '' }),
    icon: Schema.Union([Schema.String, Schema.Null]),
    enabled: Schema.Boolean.annotate({ default: true }),
    priority: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    channels: Schema.Array(Schema.suspend((): Schema.Codec<Channeljsonld> => Channeljsonld)),
    rules: Schema.Array(Schema.suspend((): Schema.Codec<LabelRulejsonld> => LabelRulejsonld)),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
    currentLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    fallbackLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    name: Schema.Union([Schema.String, Schema.Null]),
    translation: Schema.Array(
      Schema.suspend((): Schema.Codec<TranslationInterfacejsonld> => TranslationInterfacejsonld)
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Labeljsonld' });
export type Labeljsonld = Schema.Schema.Type<typeof Labeljsonld>;
export type LabeljsonldEncoded = Schema.Codec.Encoded<typeof Labeljsonld>;

/* LabelRulejsonld */

export const LabelRulejsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(Schema.String.annotate({ readOnly: true, format: 'uuid' })),
    label: Schema.suspend((): Schema.Codec<Labeljsonld> => Labeljsonld),
    type: Schema.String.annotate({ default: '' }),
    configuration: Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'LabelRulejsonld' });
export type LabelRulejsonld = Schema.Schema.Type<typeof LabelRulejsonld>;
export type LabelRulejsonldEncoded = Schema.Codec.Encoded<typeof LabelRulejsonld>;

/* ProductAttributeValuejsonld */

export const ProductAttributeValuejsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    subject: Schema.suspend((): Schema.Codec<Productjsonld> => Productjsonld),
    attribute: Schema.String.annotate({ writeOnly: true, format: 'iri-reference' }),
    localeCode: Schema.Union([Schema.String, Schema.Null]),
    attributeGroupId: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true, format: 'uuid' })
    ),
    unit: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    position: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    value: Schema.Union([
      Schema.String,
      Schema.Boolean,
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Array(Schema.String),
      Schema.Null,
    ]),
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    type: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    code: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    product: Schema.Union([
      Schema.suspend((): Schema.Codec<Productjsonld> => Productjsonld),
      Schema.Null,
    ]),
    text: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    boolean: Schema.Union([Schema.Boolean, Schema.Null]).annotate({ writeOnly: true }),
    integer: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({ writeOnly: true }),
    float: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Null,
    ]).annotate({ writeOnly: true }),
    datetime: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    date: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    json: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Null,
    ]).annotate({ writeOnly: true }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductAttributeValuejsonld' });
export type ProductAttributeValuejsonld = Schema.Schema.Type<typeof ProductAttributeValuejsonld>;
export type ProductAttributeValuejsonldEncoded = Schema.Codec.Encoded<
  typeof ProductAttributeValuejsonld
>;

/* ProductReviewjsonld */

export const ProductReviewjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    title: Schema.Union([Schema.String, Schema.Null]),
    rating: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    comment: Schema.Union([Schema.String, Schema.Null]),
    author: Schema.suspend((): Schema.Codec<Customerjsonld> => Customerjsonld),
    status: Schema.String.annotate({ default: 'new' }),
    reviewSubject: Schema.suspend((): Schema.Codec<Productjsonld> => Productjsonld),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductReviewjsonld' });
export type ProductReviewjsonld = Schema.Schema.Type<typeof ProductReviewjsonld>;
export type ProductReviewjsonldEncoded = Schema.Codec.Encoded<typeof ProductReviewjsonld>;

/* ShopUserjsonld */

export const ShopUserjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    favouriteList: Schema.optionalKey(
      Schema.Array(FavouriteListjsonld).annotate({ readOnly: true })
    ),
    customer: Schema.suspend((): Schema.Codec<Customerjsonld> => Customerjsonld),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    username: Schema.Union([Schema.String, Schema.Null]),
    usernameCanonical: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'Normalized representation of a username.',
    }),
    password: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'Encrypted password. Must be persisted.',
    }),
    plainPassword: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'Password before encryption. Used for model validation. Must not be persisted.',
    }),
    lastLogin: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    emailVerificationToken: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'Random string sent to the user email address in order to verify it',
    }),
    passwordResetToken: Schema.Union([Schema.String, Schema.Null]).annotate({
      description:
        'Random string sent to the user email address in order to verify the password resetting request',
    }),
    passwordRequestedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    verified: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    roles: Schema.Array(Schema.Union([Schema.String, Schema.Null])).annotate({
      description: 'We need at least one role to be able to authenticate',
      default: ['ROLE_USER'],
    }),
    oauthAccounts: Schema.Array(
      Schema.suspend((): Schema.Codec<UserOAuthjsonld> => UserOAuthjsonld)
    ),
    email: Schema.Union([Schema.String, Schema.Null]),
    emailCanonical: Schema.Union([Schema.String, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    enabled: Schema.Boolean.annotate({ default: true }),
    oAuthAccounts: Schema.Array(
      Schema.suspend((): Schema.Codec<UserOAuthjsonld> => UserOAuthjsonld)
    ),
    userIdentifier: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShopUserjsonld' });
export type ShopUserjsonld = Schema.Schema.Type<typeof ShopUserjsonld>;
export type ShopUserjsonldEncoded = Schema.Codec.Encoded<typeof ShopUserjsonld>;

/* UserOAuthjsonld */

export const UserOAuthjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    provider: Schema.String,
    identifier: Schema.String,
    accessToken: Schema.Union([Schema.String, Schema.Null]),
    refreshToken: Schema.Union([Schema.String, Schema.Null]),
    user: Schema.Union([
      Schema.suspend((): Schema.Codec<ShopUserjsonld> => ShopUserjsonld),
      Schema.Null,
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'UserOAuthjsonld' });
export type UserOAuthjsonld = Schema.Schema.Type<typeof UserOAuthjsonld>;
export type UserOAuthjsonldEncoded = Schema.Codec.Encoded<typeof UserOAuthjsonld>;

/* Customerjsonld */

export const Customerjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    orders: Schema.optionalKey(
      Schema.Array(Schema.suspend((): Schema.Codec<Orderjsonld> => Orderjsonld)).annotate({
        readOnly: true,
      })
    ),
    defaultAddress: Schema.Union([
      Schema.suspend((): Schema.Codec<Addressjsonld> => Addressjsonld),
      Schema.Null,
    ]),
    addresses: Schema.Array(Schema.suspend((): Schema.Codec<Addressjsonld> => Addressjsonld)),
    user: Schema.Union([
      Schema.suspend((): Schema.Codec<ShopUserjsonld> => ShopUserjsonld),
      Schema.Null,
    ]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    email: Schema.String,
    emailCanonical: Schema.String,
    firstName: Schema.Union([Schema.String, Schema.Null]),
    lastName: Schema.Union([Schema.String, Schema.Null]),
    birthday: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    gender: Schema.String.annotate({ default: 'u' }),
    group: Schema.Union([CustomerGroupjsonld, Schema.Null]),
    phoneNumber: Schema.Union([Schema.String, Schema.Null]),
    subscribedToNewsletter: Schema.Boolean.annotate({ default: false }),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    ordersTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    addressesTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    fullName: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    male: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    female: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Customerjsonld' });
export type Customerjsonld = Schema.Schema.Type<typeof Customerjsonld>;
export type CustomerjsonldEncoded = Schema.Codec.Encoded<typeof Customerjsonld>;

/* Addressjsonld */

export const Addressjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    vatNumber: Schema.Union([Schema.String, Schema.Null]),
    vatValid: Schema.Boolean.annotate({ default: false }),
    vatVerified: Schema.Boolean.annotate({ default: true }),
    vatValidatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    businessId: Schema.Union([Schema.String, Schema.Null]).annotate({
      description: 'IČO or similar ID for other countries',
    }),
    customer: Schema.Union([
      Schema.suspend((): Schema.Codec<Customerjsonld> => Customerjsonld),
      Schema.Null,
    ]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    firstName: Schema.String,
    lastName: Schema.String,
    phoneNumber: Schema.Union([Schema.String, Schema.Null]),
    company: Schema.Union([Schema.String, Schema.Null]),
    countryCode: Schema.String,
    provinceCode: Schema.Union([Schema.String, Schema.Null]),
    provinceName: Schema.Union([Schema.String, Schema.Null]),
    street: Schema.String,
    city: Schema.String,
    postcode: Schema.String,
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    complexStreet: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    fullAddress: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    vatManualReviewRequired: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    validVatNumber: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    fullName: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Addressjsonld' });
export type Addressjsonld = Schema.Schema.Type<typeof Addressjsonld>;
export type AddressjsonldEncoded = Schema.Codec.Encoded<typeof Addressjsonld>;

/* Orderjsonld */

export const Orderjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    promotionRuleHints: Schema.Array(CartPromotionRuleHintsjsonld),
    pohodaId: Schema.Union([Schema.String, Schema.Null]),
    cancelledReason: Schema.Union([
      Schema.Literals(['customer', 'unpaid', 'returned', 'unpicked']),
      Schema.Null,
    ]),
    invoiceId: Schema.Union([Schema.String, Schema.Null]),
    identifier: Schema.String.annotate({
      description:
        'Public order identifier (UUIDv4) used wherever the sequential id / number must not be\nexposed or guessable — payment QR links, gateway return URLs, document access.',
      format: 'uuid',
    }),
    surveyOptIn: Schema.Boolean.annotate({ default: false }),
    customer: Schema.Union([
      Schema.suspend((): Schema.Codec<Customerjsonld> => Customerjsonld),
      Schema.Null,
    ]),
    channel: Schema.Union([
      Schema.suspend((): Schema.Codec<Channeljsonld> => Channeljsonld),
      Schema.Null,
    ]),
    shippingAddress: Schema.Union([
      Schema.suspend((): Schema.Codec<Addressjsonld> => Addressjsonld),
      Schema.Null,
    ]),
    billingAddress: Schema.Union([
      Schema.suspend((): Schema.Codec<Addressjsonld> => Addressjsonld),
      Schema.Null,
    ]),
    payments: Schema.Array(Schema.suspend((): Schema.Codec<Paymentjsonld> => Paymentjsonld)),
    shipments: Schema.Array(Schema.suspend((): Schema.Codec<Shipmentjsonld> => Shipmentjsonld)),
    currencyCode: Schema.String,
    localeCode: Schema.String,
    promotionCoupon: Schema.Union([PromotionCouponjsonld, Schema.Null]),
    checkoutState: Schema.String.annotate({ default: 'cart' }),
    paymentState: Schema.String.annotate({ default: 'cart' }),
    shippingState: Schema.String.annotate({ default: 'cart' }),
    promotions: Schema.Array(Schema.suspend((): Schema.Codec<Promotionjsonld> => Promotionjsonld)),
    tokenValue: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    customerIp: Schema.Union([Schema.String, Schema.Null]),
    createdByGuest: Schema.optionalKey(Schema.Boolean.annotate({ default: true, readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    checkoutCompletedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    number: Schema.Union([Schema.String, Schema.Null]),
    notes: Schema.Union([Schema.String, Schema.Null]),
    items: Schema.Array(Schema.suspend((): Schema.Codec<OrderItemjsonld> => OrderItemjsonld)),
    itemsTotal: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    adjustments: Schema.Array(
      Schema.suspend((): Schema.Codec<Adjustmentjsonld> => Adjustmentjsonld)
    ),
    adjustmentsTotal: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    total: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Items total + adjustments total.',
        default: 0,
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    state: Schema.String.annotate({ default: 'cart' }),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    primaryShipment: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        description: "The order's shipment — currently a single shipping method per order is used.",
        readOnly: true,
        format: 'iri-reference',
      })
    ),
    totalAsMoney: Moneyjsonld,
    totalDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'TODO: works only if tax is included in price (this is ok for now)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    documents: Schema.optionalKey(
      Schema.Array(
        Schema.suspend((): Schema.Codec<ProductDocumentjsonld> => ProductDocumentjsonld)
      ).annotate({ readOnly: true })
    ),
    documentsForNotification: Schema.optionalKey(
      Schema.Array(
        Schema.suspend((): Schema.Codec<ProductDocumentjsonld> => ProductDocumentjsonld)
      ).annotate({ readOnly: true })
    ),
    fullySynchronized: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    synchronizationGap: Schema.optionalKey(
      Schema.Union([Schema.Literals(['price', 'stock', 'both']), Schema.Null]).annotate({
        description:
          "The union of what this order's products stopped synchronizing — `null` when every product\nstill follows the warehouse in both price and stock.",
        readOnly: true,
      })
    ),
    itemsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    primaryShipmentStrict: Schema.optionalKey(
      Schema.String.annotate({
        description: "The order's shipment — currently a single shipping method per order is used.",
        readOnly: true,
        format: 'iri-reference',
      })
    ),
    user: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        readOnly: true,
        format: 'iri-reference',
      })
    ),
    specificLastPayment: Schema.optionalKey(
      Schema.Union([
        Schema.suspend((): Schema.Codec<Paymentjsonld> => Paymentjsonld),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    lastPayment: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        readOnly: true,
        format: 'iri-reference',
      })
    ),
    itemUnitsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    paymentsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    shipmentsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    promotionsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    business: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    vatNumber: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    vatValid: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    mossCountry: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        description:
          "OSS/MOSS taxation country of the order: the billing country for B2C orders taxed\noutside the shop's residency country, null otherwise.",
        readOnly: true,
      })
    ),
    taxAddress: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        description: 'Returns address which is used for determining MOSS country',
        readOnly: true,
        format: 'iri-reference',
      })
    ),
    vatFree: Schema.optionalKey(
      Schema.Boolean.annotate({
        description: 'This is TRUE if Order price does NOT contain any VAT tax.',
        readOnly: true,
      })
    ),
    taxedByCountry: Schema.optionalKey(
      Schema.String.annotate({
        description:
          'Returns the country code whose tax rates were applied to the Order INCLUDING Orders without applied tax!',
        readOnly: true,
      })
    ),
    physicallyTaxedByCountry: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        description:
          'Returns the country code whose tax rates were applied to the Order\nif customer had valid VAT number so no tax has been applied, returns NULL.',
        readOnly: true,
      })
    ),
    vatFreeRequested: Schema.optionalKey(
      Schema.Boolean.annotate({
        description:
          'Returns TRUE if customer is eligible for free VAT\nThis does NOT say if VAT is applied or not. Use isVatFree to determine that!',
        readOnly: true,
      })
    ),
    vatFreeManualReviewRequired: Schema.optionalKey(
      Schema.Boolean.annotate({
        description:
          'Returns TRUE if customer is business (vat number in billing address) and that number has NOT been validated by VIES API\nThis also means that tax is currently applied. Which tax is applied is determined by MOSS mode, and we can get\ncountry code by calling $this->getTaxedByCountry();',
        readOnly: true,
      })
    ),
    adjustment: Schema.Array(
      Schema.suspend((): Schema.Codec<Adjustmentjsonld> => Adjustmentjsonld)
    ),
    frontAllItemsPriceWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Sum of price of all items (without shipment and payment) after all discounts with VAT\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontAllItemsPriceWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Sum of price of all items (without shipment and payment) after all discounts without VAT',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontAllItemsDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Nominal value of sum of all discounts applied on (all) items\nValue is nominal for both nominal and percentage discounts\nNote: Because discount includes VAT, this sum also technically always includes discount from base+VAT price event\nif customer is verified to NOT pay VAT for Order!\nNumber is positive.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontAllItemsTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns nominal value of VAT from price AFTER discounts for all items\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontTotalWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns price including all items, shipment, payment and applied discounts\nAlways with VAT or NULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontTotalWithoutVat: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns price including all items, shipment, payment and applied discounts\nAlways without VAT even if customer pays VAT.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontFinalRounding: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns final rounding on entire Order. This correction is applied after everything even after TAX/VAT.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontTotalTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns nominal value of VAT from price AFTER discounts for all items\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontTotalPaid: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns FINAL price to be paid by customer including all items, shipment, payment, applied discounts\nand applied taxes if any. This number is number which should be sent to payment gate or displayed as number\nrepresenting how much will customer pay.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontShipmentTotalPaid: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns FINAL price to be paid by customer for shipment (after discount and including taxes if applied)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontPaymentTotalPaid: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns FINAL price to be paid by customer for payment (after discount and including taxes if applied)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontDeliveryTotalPaid: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns FINAL price to be paid by customer for delivery: shipment+payment (after discount and including taxes if applied)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontShipmentWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns shipment price before discount with VAT\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontShipmentDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns discount in nominal value of shipment (for both percentage and nominal discount)\nPositive number.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontShipmentWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns shipment price with VAT after applied discounts\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontShipmentWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns shipment price without VAT after applied discounts',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontShipmentTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns nominal value of VAT from price AFTER discounts for shipment\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontPaymentWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns payment price before discount with VAT\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontPaymentDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns discount in nominal value of payment (for both percentage and nominal discount)\nPositive number.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontPaymentWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns payment price with VAT after applied discounts\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontPaymentWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns payment price without VAT after applied discounts',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontPaymentTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns nominal value of VAT from price AFTER discounts for payment\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontDeliveryWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns delivery: shipment+payment price before discount with VAT\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontDeliveryDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns discount in nominal value of delivery: shipment+payment (for both percentage and nominal discount)\nPositive number.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontDeliveryWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns delivery: shipment+payment price with VAT after applied discounts\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontDeliveryWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns delivery: shipment+payment price without VAT after applied discounts',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontDeliveryTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Returns nominal value of VAT from price AFTER discounts for delivery: shipment+payment\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontShipmentDiscountPercentage: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns overall percentage discount on shipments calculated from base price with tax and applied nominal discounts.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontPaymentDiscountPercentage: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns overall percentage discount on payments calculated from base price with tax and applied nominal discounts.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontDeliveryDiscountPercentage: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    latestDispatchDate: Schema.optionalKey(
      Schema.Union([
        Schema.suspend((): Schema.Codec<LocalDatejsonld> => LocalDatejsonld),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    totalWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    itemsTotalWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Sum of price of all items WITHOUT VAT tax and WITHOUT shipping and payment price',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    orderPromotionTotalWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Order promotional total without VAT (total for all shipments)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    shippingWithoutTaxTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Shipping price without VAT (total for all shipments)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    paymentTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns payment fee price after promotion with applied taxes (for VIES valid non-CZ subjects price is without taxes!)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    paymentPromotionTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    paymentTax: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns only tax of payment method',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    paymentWithoutTax: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns only tax of payment method\nTODO: works only if tax is included in price (this is ok for now)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    originalShipmentPricing: Schema.optionalKey(
      Schema.Union([OriginalPricingjsonld, Schema.Null]).annotate({ readOnly: true })
    ),
    originalPaymentPricing: Schema.optionalKey(
      Schema.Union([OriginalPricingjsonld, Schema.Null]).annotate({ readOnly: true })
    ),
    orderPromotionTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns amount of order discount. Does not include shipping discounts.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    shippingPromotionTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    itemsSubtotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    taxTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns sum of neutral and non neutral tax adjustments on order and total tax of order items.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    shippingTaxTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    taxIncludedTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    shippingTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description: 'Returns shipping fee together with taxes decreased by shipping discount.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    customerWithAuthorization: Schema.Union([
      Schema.suspend((): Schema.Codec<Customerjsonld> => Customerjsonld),
      Schema.Null,
    ]),
    itemUnits: Collectionjsonld,
    shippingRequired: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    promotionSubjectTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    promotionSubjectCount: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    taxExcludedTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    nonDiscountedItemsTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    checkoutCompleted: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    totalQuantity: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    empty: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    adjustmentsRecursively: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    adjustmentsTotalRecursively: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    beProcessed: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Orderjsonld' });
export type Orderjsonld = Schema.Schema.Type<typeof Orderjsonld>;
export type OrderjsonldEncoded = Schema.Codec.Encoded<typeof Orderjsonld>;

/* Adjustmentjsonld */

export const Adjustmentjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    shippingPricing: Schema.Union([ShippingPricingjsonld, Schema.Null]),
    shipment: Schema.optionalKey(
      Schema.Union([
        Schema.suspend((): Schema.Codec<Shipmentjsonld> => Shipmentjsonld),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    order: Schema.optionalKey(
      Schema.Union([
        Schema.suspend((): Schema.Codec<Orderjsonld> => Orderjsonld),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    orderItem: Schema.optionalKey(
      Schema.Union([
        Schema.suspend((): Schema.Codec<OrderItemjsonld> => OrderItemjsonld),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    orderItemUnit: Schema.optionalKey(
      Schema.Union([
        Schema.suspend((): Schema.Codec<OrderItemUnitjsonld> => OrderItemUnitjsonld),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    type: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    label: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    amount: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    neutral: Schema.optionalKey(Schema.Boolean.annotate({ default: false, readOnly: true })),
    locked: Schema.optionalKey(Schema.Boolean.annotate({ default: false, readOnly: true })),
    originCode: Schema.Union([Schema.String, Schema.Null]),
    details: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    taxRateAmount: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returned as [0,1] range e.g. for 21% taxRate this method returns float value: 0.21',
        readOnly: true,
      }).check(Schema.isFinite().annotate({ expected: 'a finite number' }))
    ),
    adjustmentTypeChoices: Schema.optionalKey(
      Schema.Json.annotate({ expected: 'JSON value', readOnly: true })
    ),
    adjustable: Schema.Union([
      Schema.suspend((): Schema.Codec<AdjustableInterfacejsonld> => AdjustableInterfacejsonld),
      Schema.Null,
    ]),
    charge: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    credit: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Adjustmentjsonld' });
export type Adjustmentjsonld = Schema.Schema.Type<typeof Adjustmentjsonld>;
export type AdjustmentjsonldEncoded = Schema.Codec.Encoded<typeof Adjustmentjsonld>;

/* AdjustableInterfacejsonld */

export const AdjustableInterfacejsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    adjustments: Schema.Array(
      Schema.suspend((): Schema.Codec<Adjustmentjsonld> => Adjustmentjsonld)
    ),
    adjustmentsTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'AdjustableInterfacejsonld' });
export type AdjustableInterfacejsonld = Schema.Schema.Type<typeof AdjustableInterfacejsonld>;
export type AdjustableInterfacejsonldEncoded = Schema.Codec.Encoded<
  typeof AdjustableInterfacejsonld
>;

/* OrderItemUnitjsonld */

export const OrderItemUnitjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    dispatchDate: Schema.Union([
      Schema.suspend((): Schema.Codec<LocalDatejsonld> => LocalDatejsonld),
      Schema.Null,
    ]),
    shipment: Schema.Union([
      Schema.suspend((): Schema.Codec<Shipmentjsonld> => Shipmentjsonld),
      Schema.Null,
    ]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    adjustments: Schema.Array(
      Schema.suspend((): Schema.Codec<Adjustmentjsonld> => Adjustmentjsonld)
    ),
    adjustmentsTotal: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    orderItem: Schema.suspend((): Schema.Codec<OrderItemjsonld> => OrderItemjsonld),
    stockable: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        readOnly: true,
        format: 'iri-reference',
      })
    ),
    shippable: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        readOnly: true,
        format: 'iri-reference',
      })
    ),
    adjustmentsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    taxTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    total: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'OrderItemUnitjsonld' });
export type OrderItemUnitjsonld = Schema.Schema.Type<typeof OrderItemUnitjsonld>;
export type OrderItemUnitjsonldEncoded = Schema.Codec.Encoded<typeof OrderItemUnitjsonld>;

/* OrderItemjsonld */

export const OrderItemjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    version: Schema.Number.annotate({ default: 1 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    variant: Schema.suspend((): Schema.Codec<ProductVariantjsonld> => ProductVariantjsonld),
    productName: Schema.Union([Schema.String, Schema.Null]),
    variantName: Schema.Union([Schema.String, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    order: Schema.suspend((): Schema.Codec<Orderjsonld> => Orderjsonld),
    quantity: Schema.Number.annotate({ default: 0, readOnly: true })
      .check(Schema.isInt().annotate({ expected: 'an integer' }))
      .check(
        Schema.isGreaterThanOrEqualTo(0).annotate({
          expected: 'a value greater than or equal to 0',
        })
      ),
    unitPrice: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    originalUnitPrice: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]).annotate({ default: 0 }),
    total: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    immutable: Schema.Boolean.annotate({ default: false }),
    units: Schema.Array(
      Schema.suspend((): Schema.Codec<OrderItemUnitjsonld> => OrderItemUnitjsonld)
    ),
    adjustments: Schema.Array(
      Schema.suspend((): Schema.Codec<Adjustmentjsonld> => Adjustmentjsonld)
    ),
    adjustmentsTotal: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    product: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({
        readOnly: true,
        format: 'iri-reference',
      })
    ),
    orderStrict: Schema.optionalKey(
      Schema.String.annotate({ readOnly: true, format: 'iri-reference' })
    ),
    preorder: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    unitsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    adjustmentsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    adjustmentsRecursivelyTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    adjustment: Schema.Array(
      Schema.suspend((): Schema.Codec<Adjustmentjsonld> => Adjustmentjsonld)
    ),
    frontUnitPriceWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    frontItemsPriceWithVat: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    frontUnitPriceDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Nominal value of sum of all discounts applied on unit\nDiscount technically contains VAT part (is applied for source price including VAT)\nValue is nominal for both nominal and percentage discounts\nValue is average for all units (if special discounts are per unit, this filed must be calculated custom for each every unit)\nNumber is positive.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontItemsPriceDiscountAsNominalValue: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Nominal value of sum of all discounts applied on items (all units)\nDiscount technically contains VAT part (is applied for source price including VAT)\nValue is nominal for both nominal and percentage discounts\nNumber is positive.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontUnitPriceWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Unit price with VAT and after all product discounts (including order level discounts on products)\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontUnitPriceWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Unit price without VAT and after all product discounts (including order level discounts on products)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontUnitPricePaid: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    frontItemsPriceWithVatAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Sum of items (all units) with VAT and after all product discounts (including order level discounts on products)\nNULL if customer is verified to NOT pay VAT for Order',
        readOnly: true,
      })
    ),
    frontItemsPriceWithoutVatAfterDiscount: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Sum of items (all units) without VAT and after all product discounts (including order level discounts on products)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    frontUnitTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Tax as nominal value applied on unit price AFTER discount\nNULL if customer is verified to NOT pay VAT for Order (basically zero tax)',
        readOnly: true,
      })
    ),
    frontItemsTaxAppliedAfterDiscount: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({
        description:
          'Tax as nominal value applied on items (all units) price AFTER discount\nNULL if customer is verified to NOT pay VAT for Order (basically zero tax)',
        readOnly: true,
      })
    ),
    frontItemsPricePaid: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    originalPricing: Schema.optionalKey(
      Schema.Union([OriginalPricingjsonld, Schema.Null]).annotate({ readOnly: true })
    ),
    latestDispatchDate: Schema.optionalKey(
      Schema.Union([
        Schema.suspend((): Schema.Codec<LocalDatejsonld> => LocalDatejsonld),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    discountedUnitPrice: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns single unit price lowered by order unit promotions (each unit must have the same unit promotion discount)',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
    adjustmentsRecursively: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    adjustmentsTotalRecursively: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    subtotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    fullDiscountedUnitPrice: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    taxTotal: Schema.optionalKey(
      Schema.Number.annotate({
        description:
          'Returns sum of neutral and non neutral tax adjustments on order item and total tax of units.',
        readOnly: true,
      }).check(Schema.isInt().annotate({ expected: 'an integer' }))
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'OrderItemjsonld' });
export type OrderItemjsonld = Schema.Schema.Type<typeof OrderItemjsonld>;
export type OrderItemjsonldEncoded = Schema.Codec.Encoded<typeof OrderItemjsonld>;

/* Shipmentjsonld */

export const Shipmentjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    placementId: Schema.Union([Schema.String, Schema.Null]),
    order: Schema.suspend((): Schema.Codec<Orderjsonld> => Orderjsonld),
    adjustments: Schema.Array(
      Schema.suspend((): Schema.Codec<Adjustmentjsonld> => Adjustmentjsonld)
    ),
    adjustmentsTotal: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    state: Schema.String.annotate({ default: 'cart' }),
    method: Schema.suspend((): Schema.Codec<ShippingMethodjsonld> => ShippingMethodjsonld),
    units: Schema.Array(
      Schema.suspend((): Schema.Codec<OrderItemUnitjsonld> => OrderItemUnitjsonld)
    ),
    tracking: Schema.Union([Schema.String, Schema.Null]),
    shippedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    priceAsMoney: Schema.optionalKey(
      Schema.Union([Moneyjsonld, Schema.Null]).annotate({ readOnly: true })
    ),
    adjustmentsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    unitsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    shippablesTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    adjustment: Schema.Array(
      Schema.suspend((): Schema.Codec<Adjustmentjsonld> => Adjustmentjsonld)
    ),
    adjustmentStrict: Schema.optionalKey(
      Schema.String.annotate({ readOnly: true, format: 'iri-reference' })
    ),
    absoluteTrackingUrl: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    image: Schema.optionalKey(
      Schema.Union([ShippingMethodImagejsonld, Schema.Null]).annotate({ readOnly: true })
    ),
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    code: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    price: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    shippingUnitTotal: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    tracked: Schema.optionalKey(Schema.Boolean.annotate({ readOnly: true })),
    shippables: Collectionjsonld,
    shippingWeight: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isFinite().annotate({ expected: 'a finite number' })
      )
    ),
    shippingVolume: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isFinite().annotate({ expected: 'a finite number' })
      )
    ),
    shippingUnitCount: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Shipmentjsonld' });
export type Shipmentjsonld = Schema.Schema.Type<typeof Shipmentjsonld>;
export type ShipmentjsonldEncoded = Schema.Codec.Encoded<typeof Shipmentjsonld>;

/* ShippingMethodjsonld */

export const ShippingMethodjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    deliveryDays: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })).check(
      Schema.isGreaterThanOrEqualTo(0).annotate({ expected: 'a value greater than or equal to 0' })
    ),
    pohodaSyncId: Schema.String,
    feedShippingMethods: Schema.Array(FeedShippingMethodjsonld),
    store: Schema.Union([Schema.String, Schema.Null]).annotate({ format: 'iri-reference' }),
    placement: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    trackingUrl: Schema.Union([Schema.String, Schema.Null]),
    image: Schema.Union([ShippingMethodImagejsonld, Schema.Null]),
    zone: Schema.suspend((): Schema.Codec<Zonejsonld> => Zonejsonld),
    taxCategory: Schema.Union([
      Schema.suspend((): Schema.Codec<TaxCategoryjsonld> => TaxCategoryjsonld),
      Schema.Null,
    ]),
    channels: Schema.Array(Schema.suspend((): Schema.Codec<Channeljsonld> => Channeljsonld)),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    category: Schema.Union([ShippingCategoryjsonld, Schema.Null]),
    categoryRequirement: Schema.Number.annotate({ default: 1 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    shippingChargesCalculator: Schema.String,
    shippingChargesCalculatorConfiguration: Schema.Array(
      Schema.Union([Schema.String, Schema.Null])
    ),
    rules: Schema.Array(
      Schema.suspend((): Schema.Codec<ShippingMethodRulejsonld> => ShippingMethodRulejsonld)
    ),
    minDeliveryTimeDays: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    maxDeliveryTimeDays: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    archivedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    enabled: Schema.Boolean.annotate({ default: true }),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
    currentLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    fallbackLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    predefinedPlacementId: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    name: Schema.Union([Schema.String, Schema.Null]),
    channelsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    rulesTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    translation: Schema.Array(
      Schema.suspend((): Schema.Codec<TranslationInterfacejsonld> => TranslationInterfacejsonld)
    ),
    formattedTrackingUrl: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    translationClass: Schema.optionalKey(
      Schema.Json.annotate({ expected: 'JSON value', readOnly: true })
    ),
    description: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingMethodjsonld' });
export type ShippingMethodjsonld = Schema.Schema.Type<typeof ShippingMethodjsonld>;
export type ShippingMethodjsonldEncoded = Schema.Codec.Encoded<typeof ShippingMethodjsonld>;

/* ShippingMethodRulejsonld */

export const ShippingMethodRulejsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.String,
    configuration: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    shippingMethod: Schema.Union([
      Schema.suspend((): Schema.Codec<ShippingMethodjsonld> => ShippingMethodjsonld),
      Schema.Null,
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ShippingMethodRulejsonld' });
export type ShippingMethodRulejsonld = Schema.Schema.Type<typeof ShippingMethodRulejsonld>;
export type ShippingMethodRulejsonldEncoded = Schema.Codec.Encoded<typeof ShippingMethodRulejsonld>;

/* Paymentjsonld */

export const Paymentjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    order: Schema.suspend((): Schema.Codec<Orderjsonld> => Orderjsonld),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    method: Schema.optionalKey(
      Schema.Union([PaymentMethodjsonld, Schema.Null]).annotate({ readOnly: true })
    ),
    currencyCode: Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    amount: Schema.optionalKey(
      Schema.Number.annotate({ default: 0, readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    state: Schema.optionalKey(Schema.String.annotate({ default: 'cart', readOnly: true })),
    details: Schema.optionalKey(
      Schema.Array(Schema.Union([Schema.String, Schema.Null])).annotate({ readOnly: true })
    ),
    paymentRequests: Schema.optionalKey(
      Schema.Array(
        Schema.suspend((): Schema.Codec<PaymentRequestjsonld> => PaymentRequestjsonld)
      ).annotate({ readOnly: true })
    ),
    createdAt: Schema.optionalKey(DateTimeSerializableFromString),
    updatedAt: Schema.optionalKey(Schema.Union([DateTimeSerializableFromString, Schema.Null])),
    priceAsMoney: Schema.optionalKey(
      Schema.Union([Moneyjsonld, Schema.Null]).annotate({ readOnly: true })
    ),
    paymentRequestsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    price: Schema.optionalKey(
      Schema.Union([
        Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
        Schema.Null,
      ]).annotate({ readOnly: true })
    ),
    name: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    code: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    image: Schema.optionalKey(
      Schema.Union([PaymentMethodImagejsonld, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Paymentjsonld' });
export type Paymentjsonld = Schema.Schema.Type<typeof Paymentjsonld>;
export type PaymentjsonldEncoded = Schema.Codec.Encoded<typeof Paymentjsonld>;

/* PaymentRequestjsonld */

export const PaymentRequestjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    hash: Schema.optionalKey(Schema.String.annotate({ readOnly: true, format: 'uuid' })),
    state: Schema.String.annotate({ default: 'new' }),
    action: Schema.String.annotate({ default: 'capture' }),
    payload: Schema.Json.annotate({ expected: 'JSON value' }),
    responseData: Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Null])),
    payment: Schema.suspend((): Schema.Codec<Paymentjsonld> => Paymentjsonld),
    method: PaymentMethodjsonld,
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    orderToken: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PaymentRequestjsonld' });
export type PaymentRequestjsonld = Schema.Schema.Type<typeof PaymentRequestjsonld>;
export type PaymentRequestjsonldEncoded = Schema.Codec.Encoded<typeof PaymentRequestjsonld>;

/* Promotionjsonld */

export const Promotionjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    couponBased: Schema.Boolean.annotate({ default: true }),
    showCartHints: Schema.Boolean.annotate({
      description:
        "When enabled, the shop cart shows hints on how to earn this promotion's discount.",
      default: false,
    }),
    channels: Schema.Array(Schema.suspend((): Schema.Codec<Channeljsonld> => Channeljsonld)),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    name: Schema.String,
    description: Schema.Union([Schema.String, Schema.Null]),
    priority: Schema.Number.annotate({
      description: 'When exclusive, promotion with top priority will be applied',
      default: 0,
    }).check(Schema.isInt().annotate({ expected: 'an integer' })),
    exclusive: Schema.Boolean.annotate({
      description: 'Cannot be applied together with other promotions',
      default: false,
    }),
    usageLimit: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
    used: Schema.Number.annotate({ default: 0 }).check(
      Schema.isInt().annotate({ expected: 'an integer' })
    ),
    startsAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    endsAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    coupons: Schema.Array(PromotionCouponjsonld),
    rules: Schema.Array(
      Schema.suspend((): Schema.Codec<PromotionRulejsonld> => PromotionRulejsonld)
    ),
    actions: Schema.Array(
      Schema.suspend((): Schema.Codec<PromotionActionjsonld> => PromotionActionjsonld)
    ),
    appliesToDiscounted: Schema.Boolean.annotate({ default: true }),
    archivedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    translations: Schema.Union([
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
      Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    ]),
    currentLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    fallbackLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    channelsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    couponsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    rulesTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    actionsTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    translation: Schema.Array(
      Schema.suspend((): Schema.Codec<TranslationInterfacejsonld> => TranslationInterfacejsonld)
    ),
    label: Schema.Union([Schema.String, Schema.Null]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Promotionjsonld' });
export type Promotionjsonld = Schema.Schema.Type<typeof Promotionjsonld>;
export type PromotionjsonldEncoded = Schema.Codec.Encoded<typeof Promotionjsonld>;

/* PromotionActionjsonld */

export const PromotionActionjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.String,
    configuration: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    promotion: Schema.Union([
      Schema.suspend((): Schema.Codec<Promotionjsonld> => Promotionjsonld),
      Schema.Null,
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PromotionActionjsonld' });
export type PromotionActionjsonld = Schema.Schema.Type<typeof PromotionActionjsonld>;
export type PromotionActionjsonldEncoded = Schema.Codec.Encoded<typeof PromotionActionjsonld>;

/* PromotionRulejsonld */

export const PromotionRulejsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    type: Schema.String,
    configuration: Schema.Array(Schema.Union([Schema.String, Schema.Null])),
    promotion: Schema.Union([
      Schema.suspend((): Schema.Codec<Promotionjsonld> => Promotionjsonld),
      Schema.Null,
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'PromotionRulejsonld' });
export type PromotionRulejsonld = Schema.Schema.Type<typeof PromotionRulejsonld>;
export type PromotionRulejsonldEncoded = Schema.Codec.Encoded<typeof PromotionRulejsonld>;

/* ProductTaxonjsonld */

export const ProductTaxonjsonld = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    product: Schema.suspend((): Schema.Codec<Productjsonld> => Productjsonld),
    taxon: Schema.suspend((): Schema.Codec<Taxonjsonld> => Taxonjsonld),
    position: Schema.Union([
      Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
      Schema.Null,
    ]),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'ProductTaxonjsonld' });
export type ProductTaxonjsonld = Schema.Schema.Type<typeof ProductTaxonjsonld>;
export type ProductTaxonjsonldEncoded = Schema.Codec.Encoded<typeof ProductTaxonjsonld>;

/* FaqQuestionsyliusshopfaqquestionshow */

export const FaqQuestionsyliusshopfaqquestionshow = Schema.StructWithRest(
  Schema.Struct({
    code: Schema.String.annotate({ default: '' }),
    topic: FaqTopicsyliusshopfaqquestionshow,
    favourite: Schema.Boolean.annotate({
      description:
        'Hand-picked for prominent placement (a homepage, a "top questions" box) — the shop decides where.',
      default: false,
    }),
    question: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    answer: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    slug: Schema.Union([Schema.String, Schema.Null]),
    relatedQuestions: Schema.optionalKey(
      Schema.Array(
        Schema.Union([
          Schema.suspend(
            (): Schema.Codec<FaqQuestionjsonldsyliusshopfaqquestionshow> =>
              FaqQuestionjsonldsyliusshopfaqquestionshow
          ),
          Schema.suspend(
            (): Schema.Codec<FaqQuestionsyliusshopfaqquestionshow> =>
              FaqQuestionsyliusshopfaqquestionshow
          ),
          Schema.String.annotate({
            description: 'IRI on FaqQuestion when MaxDepth is exceeded',
            format: 'uri',
          }),
        ])
      ).annotate({
        description:
          'First level = FaqQuestion object, deeper levels = IRI. Limited to 6 questions.',
        readOnly: true,
      })
    ),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'FaqQuestionsyliusshopfaqquestionshow' });
export type FaqQuestionsyliusshopfaqquestionshow = Schema.Schema.Type<
  typeof FaqQuestionsyliusshopfaqquestionshow
>;
export type FaqQuestionsyliusshopfaqquestionshowEncoded = Schema.Codec.Encoded<
  typeof FaqQuestionsyliusshopfaqquestionshow
>;

/* FaqQuestionjsonldsyliusshopfaqquestionshow */

export const FaqQuestionjsonldsyliusshopfaqquestionshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    code: Schema.String.annotate({ default: '' }),
    topic: FaqTopicjsonldsyliusshopfaqquestionshow,
    favourite: Schema.Boolean.annotate({
      description:
        'Hand-picked for prominent placement (a homepage, a "top questions" box) — the shop decides where.',
      default: false,
    }),
    question: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    answer: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    slug: Schema.Union([Schema.String, Schema.Null]),
    relatedQuestions: Schema.optionalKey(
      Schema.Array(
        Schema.Union([
          Schema.suspend(
            (): Schema.Codec<FaqQuestionjsonldsyliusshopfaqquestionshow> =>
              FaqQuestionjsonldsyliusshopfaqquestionshow
          ),
          Schema.suspend(
            (): Schema.Codec<FaqQuestionsyliusshopfaqquestionshow> =>
              FaqQuestionsyliusshopfaqquestionshow
          ),
          Schema.String.annotate({
            description: 'IRI on FaqQuestion when MaxDepth is exceeded',
            format: 'uri',
          }),
        ])
      ).annotate({
        description:
          'First level = FaqQuestion object, deeper levels = IRI. Limited to 6 questions.',
        readOnly: true,
      })
    ),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'FaqQuestionjsonldsyliusshopfaqquestionshow' });
export type FaqQuestionjsonldsyliusshopfaqquestionshow = Schema.Schema.Type<
  typeof FaqQuestionjsonldsyliusshopfaqquestionshow
>;
export type FaqQuestionjsonldsyliusshopfaqquestionshowEncoded = Schema.Codec.Encoded<
  typeof FaqQuestionjsonldsyliusshopfaqquestionshow
>;

/* Taxonsyliusadmintaxoncreate */

export const Taxonsyliusadmintaxoncreate = Schema.StructWithRest(
  Schema.Struct({
    listing: Schema.Literals(['ajax', 'inline']),
    visibility: Schema.Literals(['hideInMenu', 'hideCompletely', 'visible']),
    code: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ).check(
      Schema.isPattern(new RegExp('^([\\w-]*)$')).annotate({
        expected: 'a string matching the RegExp ^([\\w-]*)$',
      })
    ),
    parent: Schema.Union([
      Schema.suspend((): Schema.Codec<Taxonsyliusadmintaxoncreate> => Taxonsyliusadmintaxoncreate),
      Schema.Null,
    ]),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    enabled: Schema.Boolean.annotate({ default: true }),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonsyliusadmintaxoncreate' });
export type Taxonsyliusadmintaxoncreate = Schema.Schema.Type<typeof Taxonsyliusadmintaxoncreate>;
export type TaxonsyliusadmintaxoncreateEncoded = Schema.Codec.Encoded<
  typeof Taxonsyliusadmintaxoncreate
>;

/* Taxonsyliusadmintaxonindex */

export const Taxonsyliusadmintaxonindex = Schema.StructWithRest(
  Schema.Struct({
    listing: Schema.Literals(['ajax', 'inline']),
    visibility: Schema.Literals(['hideInMenu', 'hideCompletely', 'visible']),
    images: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    parent: Schema.Union([
      Schema.suspend((): Schema.Codec<Taxonsyliusadmintaxonindex> => Taxonsyliusadmintaxonindex),
      Schema.Null,
    ]),
    children: Schema.Array(
      Schema.suspend((): Schema.Codec<Taxonsyliusadmintaxonindex> => Taxonsyliusadmintaxonindex)
    ),
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    enabled: Schema.Boolean.annotate({ default: true }),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonsyliusadmintaxonindex' });
export type Taxonsyliusadmintaxonindex = Schema.Schema.Type<typeof Taxonsyliusadmintaxonindex>;
export type TaxonsyliusadmintaxonindexEncoded = Schema.Codec.Encoded<
  typeof Taxonsyliusadmintaxonindex
>;

/* Taxonsyliusadmintaxonshow */

export const Taxonsyliusadmintaxonshow = Schema.StructWithRest(
  Schema.Struct({
    listing: Schema.Literals(['ajax', 'inline']),
    visibility: Schema.Literals(['hideInMenu', 'hideCompletely', 'visible']),
    images: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ).check(
      Schema.isPattern(new RegExp('^([\\w-]*)$')).annotate({
        expected: 'a string matching the RegExp ^([\\w-]*)$',
      })
    ),
    parent: Schema.Union([
      Schema.suspend((): Schema.Codec<Taxonsyliusadmintaxonshow> => Taxonsyliusadmintaxonshow),
      Schema.Null,
    ]),
    children: Schema.Array(
      Schema.suspend((): Schema.Codec<Taxonsyliusadmintaxonshow> => Taxonsyliusadmintaxonshow)
    ),
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    enabled: Schema.Boolean.annotate({ default: true }),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonsyliusadmintaxonshow' });
export type Taxonsyliusadmintaxonshow = Schema.Schema.Type<typeof Taxonsyliusadmintaxonshow>;
export type TaxonsyliusadmintaxonshowEncoded = Schema.Codec.Encoded<
  typeof Taxonsyliusadmintaxonshow
>;

/* Taxonsyliusadmintaxonupdate */

export const Taxonsyliusadmintaxonupdate = Schema.StructWithRest(
  Schema.Struct({
    listing: Schema.Literals(['ajax', 'inline']),
    visibility: Schema.Literals(['hideInMenu', 'hideCompletely', 'visible']),
    parent: Schema.Union([
      Schema.suspend((): Schema.Codec<Taxonsyliusadmintaxonupdate> => Taxonsyliusadmintaxonupdate),
      Schema.Null,
    ]),
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    enabled: Schema.Boolean.annotate({ default: true }),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonsyliusadmintaxonupdate' });
export type Taxonsyliusadmintaxonupdate = Schema.Schema.Type<typeof Taxonsyliusadmintaxonupdate>;
export type TaxonsyliusadmintaxonupdateEncoded = Schema.Codec.Encoded<
  typeof Taxonsyliusadmintaxonupdate
>;

/* Taxonsyliusshoptaxonmenu */

export const Taxonsyliusshoptaxonmenu = Schema.StructWithRest(
  Schema.Struct({
    children: Schema.optionalKey(
      Schema.Array(
        Schema.suspend((): Schema.Codec<Taxonsyliusshoptaxonmenu> => Taxonsyliusshoptaxonmenu)
      )
    ),
    images: Schema.optionalKey(
      Schema.Array(TaxonImagesyliusshoptaxonmenu).annotate({ readOnly: true })
    ),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    nameInTaxonList: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    articles: Schema.optionalKey(
      Schema.Array(Articlesyliusshoparticleindexfavourite).annotate({ readOnly: true })
    ),
    brands: Schema.optionalKey(
      Schema.Array(Brandsyliusshopbrandindex).annotate({ readOnly: true })
    ),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonsyliusshoptaxonmenu' });
export type Taxonsyliusshoptaxonmenu = Schema.Schema.Type<typeof Taxonsyliusshoptaxonmenu>;
export type TaxonsyliusshoptaxonmenuEncoded = Schema.Codec.Encoded<typeof Taxonsyliusshoptaxonmenu>;

/* Taxonsyliusshoptaxonshow */

export const Taxonsyliusshoptaxonshow = Schema.StructWithRest(
  Schema.Struct({
    listing: Schema.Literals(['ajax', 'inline']),
    visibility: Schema.Literals(['hideInMenu', 'hideCompletely', 'visible']),
    images: Schema.optionalKey(
      Schema.Array(TaxonImagesyliusshoptaxonshow).annotate({ readOnly: true })
    ),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    children: Schema.Array(
      Schema.suspend((): Schema.Codec<Taxonsyliusshoptaxonshow> => Taxonsyliusshoptaxonshow)
    ),
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
    nameInTaxonList: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    metaDescription: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonsyliusshoptaxonshow' });
export type Taxonsyliusshoptaxonshow = Schema.Schema.Type<typeof Taxonsyliusshoptaxonshow>;
export type TaxonsyliusshoptaxonshowEncoded = Schema.Codec.Encoded<typeof Taxonsyliusshoptaxonshow>;

/* Taxonsyliusshoptaxontree */

export const Taxonsyliusshoptaxontree = Schema.StructWithRest(
  Schema.Struct({
    children: Schema.Array(
      Schema.suspend((): Schema.Codec<Taxonsyliusshoptaxontree> => Taxonsyliusshoptaxontree)
    ),
    images: Schema.optionalKey(
      Schema.Array(TaxonImagesyliusshoptaxontree).annotate({ readOnly: true })
    ),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    nameInTaxonList: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonsyliusshoptaxontree' });
export type Taxonsyliusshoptaxontree = Schema.Schema.Type<typeof Taxonsyliusshoptaxontree>;
export type TaxonsyliusshoptaxontreeEncoded = Schema.Codec.Encoded<typeof Taxonsyliusshoptaxontree>;

/* Taxonjsonldsyliusadmintaxoncreate */

export const Taxonjsonldsyliusadmintaxoncreate = Schema.StructWithRest(
  Schema.Struct({
    listing: Schema.Literals(['ajax', 'inline']),
    visibility: Schema.Literals(['hideInMenu', 'hideCompletely', 'visible']),
    code: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ).check(
      Schema.isPattern(new RegExp('^([\\w-]*)$')).annotate({
        expected: 'a string matching the RegExp ^([\\w-]*)$',
      })
    ),
    parent: Schema.Union([
      Schema.suspend(
        (): Schema.Codec<Taxonjsonldsyliusadmintaxoncreate> => Taxonjsonldsyliusadmintaxoncreate
      ),
      Schema.Null,
    ]),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    enabled: Schema.Boolean.annotate({ default: true }),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonjsonldsyliusadmintaxoncreate' });
export type Taxonjsonldsyliusadmintaxoncreate = Schema.Schema.Type<
  typeof Taxonjsonldsyliusadmintaxoncreate
>;
export type TaxonjsonldsyliusadmintaxoncreateEncoded = Schema.Codec.Encoded<
  typeof Taxonjsonldsyliusadmintaxoncreate
>;

/* Taxonjsonldsyliusadmintaxonindex */

export const Taxonjsonldsyliusadmintaxonindex = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    listing: Schema.Literals(['ajax', 'inline']),
    visibility: Schema.Literals(['hideInMenu', 'hideCompletely', 'visible']),
    images: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    parent: Schema.Union([
      Schema.suspend(
        (): Schema.Codec<Taxonjsonldsyliusadmintaxonindex> => Taxonjsonldsyliusadmintaxonindex
      ),
      Schema.Null,
    ]),
    children: Schema.Array(
      Schema.suspend(
        (): Schema.Codec<Taxonjsonldsyliusadmintaxonindex> => Taxonjsonldsyliusadmintaxonindex
      )
    ),
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    enabled: Schema.Boolean.annotate({ default: true }),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonjsonldsyliusadmintaxonindex' });
export type Taxonjsonldsyliusadmintaxonindex = Schema.Schema.Type<
  typeof Taxonjsonldsyliusadmintaxonindex
>;
export type TaxonjsonldsyliusadmintaxonindexEncoded = Schema.Codec.Encoded<
  typeof Taxonjsonldsyliusadmintaxonindex
>;

/* Taxonjsonldsyliusadmintaxonshow */

export const Taxonjsonldsyliusadmintaxonshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    listing: Schema.Literals(['ajax', 'inline']),
    visibility: Schema.Literals(['hideInMenu', 'hideCompletely', 'visible']),
    images: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ).check(
      Schema.isPattern(new RegExp('^([\\w-]*)$')).annotate({
        expected: 'a string matching the RegExp ^([\\w-]*)$',
      })
    ),
    parent: Schema.Union([
      Schema.suspend(
        (): Schema.Codec<Taxonjsonldsyliusadmintaxonshow> => Taxonjsonldsyliusadmintaxonshow
      ),
      Schema.Null,
    ]),
    children: Schema.Array(
      Schema.suspend(
        (): Schema.Codec<Taxonjsonldsyliusadmintaxonshow> => Taxonjsonldsyliusadmintaxonshow
      )
    ),
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    enabled: Schema.Boolean.annotate({ default: true }),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonjsonldsyliusadmintaxonshow' });
export type Taxonjsonldsyliusadmintaxonshow = Schema.Schema.Type<
  typeof Taxonjsonldsyliusadmintaxonshow
>;
export type TaxonjsonldsyliusadmintaxonshowEncoded = Schema.Codec.Encoded<
  typeof Taxonjsonldsyliusadmintaxonshow
>;

/* Taxonjsonldsyliusadmintaxonupdate */

export const Taxonjsonldsyliusadmintaxonupdate = Schema.StructWithRest(
  Schema.Struct({
    listing: Schema.Literals(['ajax', 'inline']),
    visibility: Schema.Literals(['hideInMenu', 'hideCompletely', 'visible']),
    parent: Schema.Union([
      Schema.suspend(
        (): Schema.Codec<Taxonjsonldsyliusadmintaxonupdate> => Taxonjsonldsyliusadmintaxonupdate
      ),
      Schema.Null,
    ]),
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    enabled: Schema.Boolean.annotate({ default: true }),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonjsonldsyliusadmintaxonupdate' });
export type Taxonjsonldsyliusadmintaxonupdate = Schema.Schema.Type<
  typeof Taxonjsonldsyliusadmintaxonupdate
>;
export type TaxonjsonldsyliusadmintaxonupdateEncoded = Schema.Codec.Encoded<
  typeof Taxonjsonldsyliusadmintaxonupdate
>;

/* Taxonjsonldsyliusshoptaxonmenu */

export const Taxonjsonldsyliusshoptaxonmenu = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    children: Schema.optionalKey(
      Schema.Array(
        Schema.suspend(
          (): Schema.Codec<Taxonjsonldsyliusshoptaxonmenu> => Taxonjsonldsyliusshoptaxonmenu
        )
      )
    ),
    images: Schema.optionalKey(
      Schema.Array(TaxonImagejsonldsyliusshoptaxonmenu).annotate({ readOnly: true })
    ),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    nameInTaxonList: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    articles: Schema.optionalKey(
      Schema.Array(Articlejsonldsyliusshoparticleindexfavourite).annotate({ readOnly: true })
    ),
    brands: Schema.optionalKey(
      Schema.Array(Brandjsonldsyliusshopbrandindex).annotate({ readOnly: true })
    ),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonjsonldsyliusshoptaxonmenu' });
export type Taxonjsonldsyliusshoptaxonmenu = Schema.Schema.Type<
  typeof Taxonjsonldsyliusshoptaxonmenu
>;
export type TaxonjsonldsyliusshoptaxonmenuEncoded = Schema.Codec.Encoded<
  typeof Taxonjsonldsyliusshoptaxonmenu
>;

/* Taxonjsonldsyliusshoptaxonshow */

export const Taxonjsonldsyliusshoptaxonshow = Schema.StructWithRest(
  Schema.Struct({
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    listing: Schema.Literals(['ajax', 'inline']),
    visibility: Schema.Literals(['hideInMenu', 'hideCompletely', 'visible']),
    images: Schema.optionalKey(
      Schema.Array(TaxonImagejsonldsyliusshoptaxonshow).annotate({ readOnly: true })
    ),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    children: Schema.Array(
      Schema.suspend(
        (): Schema.Codec<Taxonjsonldsyliusshoptaxonshow> => Taxonjsonldsyliusshoptaxonshow
      )
    ),
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
    nameInTaxonList: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    metaDescription: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonjsonldsyliusshoptaxonshow' });
export type Taxonjsonldsyliusshoptaxonshow = Schema.Schema.Type<
  typeof Taxonjsonldsyliusshoptaxonshow
>;
export type TaxonjsonldsyliusshoptaxonshowEncoded = Schema.Codec.Encoded<
  typeof Taxonjsonldsyliusshoptaxonshow
>;

/* Taxonjsonldsyliusshoptaxontree */

export const Taxonjsonldsyliusshoptaxontree = Schema.StructWithRest(
  Schema.Struct({
    '@id': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@type': Schema.optionalKey(Schema.String.annotate({ readOnly: true })),
    '@context': Schema.optionalKey(
      Schema.Union(
        [
          Schema.String,
          Schema.StructWithRest(
            Schema.Struct({
              '@vocab': Schema.String,
              hydra: Schema.Literal('http://www.w3.org/ns/hydra/core#'),
            }),
            [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
          ),
        ],
        { mode: 'oneOf' }
      ).annotate({ readOnly: true })
    ),
    children: Schema.Array(
      Schema.suspend(
        (): Schema.Codec<Taxonjsonldsyliusshoptaxontree> => Taxonjsonldsyliusshoptaxontree
      )
    ),
    images: Schema.optionalKey(
      Schema.Array(TaxonImagejsonldsyliusshoptaxontree).annotate({ readOnly: true })
    ),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String,
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    nameInTaxonList: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonjsonldsyliusshoptaxontree' });
export type Taxonjsonldsyliusshoptaxontree = Schema.Schema.Type<
  typeof Taxonjsonldsyliusshoptaxontree
>;
export type TaxonjsonldsyliusshoptaxontreeEncoded = Schema.Codec.Encoded<
  typeof Taxonjsonldsyliusshoptaxontree
>;

/* Taxonmultipart */

export const Taxonmultipart = Schema.StructWithRest(
  Schema.Struct({
    searchWeight: Schema.Union([
      Schema.Number.check(Schema.isFinite().annotate({ expected: 'a finite number' })),
      Schema.Null,
    ]),
    articleCategories: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    feedCategories: Schema.Array(FeedCategorymultipart),
    productTaxons: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    listing: Schema.Literals(['ajax', 'inline']),
    visibility: Schema.Literals(['hideInMenu', 'hideCompletely', 'visible']),
    showOnHomepage: Schema.Boolean.annotate({ default: false }),
    children: Schema.Array(
      Schema.Union([
        Schema.suspend(
          (): Schema.Codec<Taxonjsonldsyliusshoptaxonshowdetail> =>
            Taxonjsonldsyliusshoptaxonshowdetail
        ),
        Schema.suspend(
          (): Schema.Codec<Taxonsyliusshoptaxonshowdetail> => Taxonsyliusshoptaxonshowdetail
        ),
        Schema.String.annotate({
          description: 'IRI na Taxon při překročení MaxDepth',
          format: 'uri',
        }),
      ])
    ).annotate({ description: 'První úroveň = objekt Taxon, hlubší úrovně = IRI.' }),
    images: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    createdAt: DateTimeSerializableFromString,
    updatedAt: Schema.Union([DateTimeSerializableFromString, Schema.Null]),
    id: Schema.optionalKey(
      Schema.Number.annotate({ readOnly: true }).check(
        Schema.isInt().annotate({ expected: 'an integer' })
      )
    ),
    code: Schema.String.check(
      Schema.isMaxLength(255).annotate({ expected: 'a value with a length of at most 255' })
    ).check(
      Schema.isPattern(new RegExp('^([\\w-]*)$')).annotate({
        expected: 'a string matching the RegExp ^([\\w-]*)$',
      })
    ),
    root: Schema.Union([Schema.String.annotate({ format: 'iri-reference' }), Schema.Null]),
    parent: Schema.Union([
      Schema.suspend((): Schema.Codec<Taxonmultipart> => Taxonmultipart),
      Schema.Null,
    ]),
    left: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    right: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    level: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    position: Schema.Number.check(Schema.isInt().annotate({ expected: 'an integer' })),
    translations: Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' })),
    currentLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    fallbackLocale: Schema.Union([Schema.String, Schema.Null]).annotate({ writeOnly: true }),
    enabled: Schema.Boolean.annotate({ default: true }),
    imagesTyped: Schema.optionalKey(
      Schema.Array(Schema.String.annotate({ format: 'iri-reference' })).annotate({ readOnly: true })
    ),
    name: Schema.Union([Schema.String, Schema.Null]),
    slug: Schema.Union([Schema.String, Schema.Null]),
    description: Schema.Union([Schema.String, Schema.Null]),
    nameInTaxonList: Schema.Union([Schema.String, Schema.Null]),
    metaTitle: Schema.Union([Schema.String, Schema.Null]),
    metaDescription: Schema.Union([Schema.String, Schema.Null]),
    translationClass: Schema.optionalKey(
      Schema.Json.annotate({ expected: 'JSON value', readOnly: true })
    ),
    ancestors: Schema.Array(Schema.String.annotate({ format: 'iri-reference' })),
    enabledChildren: Collectionmultipart,
    fullname: Schema.optionalKey(
      Schema.Union([Schema.String, Schema.Null]).annotate({ readOnly: true })
    ),
    translation: Schema.String.annotate({ format: 'iri-reference' }),
    routerUrl: Schema.String.annotate({
      description: 'Frontend router URL for this resource.',
      readOnly: true,
    }),
  }),
  [Schema.Record(Schema.String, Schema.Json.annotate({ expected: 'JSON value' }))]
).annotate({ identifier: 'Taxonmultipart' });
export type Taxonmultipart = Schema.Schema.Type<typeof Taxonmultipart>;
export type TaxonmultipartEncoded = Schema.Codec.Encoded<typeof Taxonmultipart>;
